var kj = Object.defineProperty;
var PA = (f) => {
  throw TypeError(f);
};
var xj = (f, s, n) => s in f ? kj(f, s, { enumerable: !0, configurable: !0, writable: !0, value: n }) : f[s] = n;
var Z = (f, s, n) => xj(f, typeof s != "symbol" ? s + "" : s, n), pR = (f, s, n) => s.has(f) || PA("Cannot " + n);
var d = (f, s, n) => (pR(f, s, "read from private field"), n ? n.call(f) : s.get(f)), R = (f, s, n) => s.has(f) ? PA("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(f) : s.set(f, n), L = (f, s, n, o) => (pR(f, s, "write to private field"), o ? o.call(f, n) : s.set(f, n), n), S = (f, s, n) => (pR(f, s, "access private method"), n);
import { jsx as lt, Fragment as Rj, jsxs as hy } from "react/jsx-runtime";
import * as ue from "react";
import DP from "react";
import { g as Dj, a as Mj, i as _A, h as Lj, b as $j, c as Oj, d as Aj, e as Pj, f as _j } from "./vidstack-google-cast-BL3V-630.js";
const wo = Symbol(0);
let YC = !1, RR = !1, Cl = null, uv = null, Ns = null, rs = 0, av = [], RM = {};
const Nj = () => {
}, wy = 0, MP = 1, GC = 2, x0 = 3;
function Uj() {
  YC = !0, queueMicrotask(LP);
}
function LP() {
  if (!av.length) {
    YC = !1;
    return;
  }
  RR = !0;
  for (let f = 0; f < av.length; f++)
    av[f].$st !== wy && zj(av[f]);
  av = [], YC = !1, RR = !1;
}
function zj(f) {
  let s = [f];
  for (; f = f[wo]; )
    f.$e && f.$st !== wy && s.push(f);
  for (let n = s.length - 1; n >= 0; n--)
    _M(s[n]);
}
function Fj(f) {
  const s = WC();
  return lw(s, f.length ? f.bind(null, my.bind(s)) : f, null);
}
function ye(f) {
  return lw(Cl, f, null);
}
function py(f) {
  return lw(null, f, null);
}
function Xu() {
  RR || LP();
}
function DM() {
  return Cl;
}
function bl(f, s) {
  try {
    return lw(s, f, null);
  } catch (n) {
    LM(s, n);
    return;
  }
}
function MM(f, s = Cl) {
  return s == null ? void 0 : s.$cx[f];
}
function Vj(f, s, n = Cl) {
  n && (n.$cx = { ...n.$cx, [f]: s });
}
function Wt(f) {
  if (!f || !Cl)
    return f || Nj;
  const s = Cl;
  return s.$d ? Array.isArray(s.$d) ? s.$d.push(f) : s.$d = [s.$d, f] : s.$d = f, function() {
    s.$st !== x0 && (f.call(null), R0(s.$d) ? s.$d = null : Array.isArray(s.$d) && s.$d.splice(s.$d.indexOf(f), 1));
  };
}
function my(f = !0) {
  if (this.$st !== x0) {
    if (this.$h)
      if (Array.isArray(this.$h))
        for (let s = this.$h.length - 1; s >= 0; s--)
          my.call(this.$h[s]);
      else
        my.call(this.$h);
    if (f) {
      const s = this[wo];
      s && (Array.isArray(s.$h) ? s.$h.splice(s.$h.indexOf(this), 1) : s.$h = null), Hj(this);
    }
  }
}
function Hj(f) {
  f.$st = x0, f.$d && $P(f), f.$s && DR(f, 0), f[wo] = null, f.$s = null, f.$o = null, f.$h = null, f.$cx = RM, f.$eh = null;
}
function $P(f) {
  try {
    if (Array.isArray(f.$d))
      for (let s = f.$d.length - 1; s >= 0; s--) {
        const n = f.$d[s];
        n.call(n);
      }
    else
      f.$d.call(f.$d);
    f.$d = null;
  } catch (s) {
    LM(f, s);
  }
}
function lw(f, s, n) {
  const o = Cl, h = uv;
  Cl = f, uv = n;
  try {
    return s.call(f);
  } finally {
    Cl = o, uv = h;
  }
}
function LM(f, s) {
  if (!f || !f.$eh)
    throw s;
  let n = 0, o = f.$eh.length, h = s;
  for (n = 0; n < o; n++)
    try {
      f.$eh[n](h);
      break;
    } catch (v) {
      h = v;
    }
  if (n === o)
    throw h;
}
function $M() {
  return this.$st === x0 ? this.$v : (uv && !this.$e && (!Ns && uv.$s && uv.$s[rs] == this ? rs++ : Ns ? Ns.push(this) : Ns = [this]), this.$c && _M(this), this.$v);
}
function OP(f) {
  const s = R0(f) ? f(this.$v) : f;
  if (this.$ch(this.$v, s) && (this.$v = s, this.$o))
    for (let n = 0; n < this.$o.length; n++)
      _P(this.$o[n], GC);
  return this.$v;
}
const OM = function() {
  this[wo] = null, this.$h = null, Cl && Cl.append(this);
}, rp = OM.prototype;
rp.$cx = RM;
rp.$eh = null;
rp.$c = null;
rp.$d = null;
rp.append = function(f) {
  f[wo] = this, this.$h ? Array.isArray(this.$h) ? this.$h.push(f) : this.$h = [this.$h, f] : this.$h = f, f.$cx = f.$cx === RM ? this.$cx : { ...this.$cx, ...f.$cx }, this.$eh && (f.$eh = f.$eh ? [...f.$eh, ...this.$eh] : this.$eh);
};
rp.dispose = function() {
  my.call(this);
};
function WC() {
  return new OM();
}
const AP = function(s, n, o) {
  OM.call(this), this.$st = n ? GC : wy, this.$i = !1, this.$e = !1, this.$s = null, this.$o = null, this.$v = s, n && (this.$c = n), o && o.dirty && (this.$ch = o.dirty);
}, AM = AP.prototype;
Object.setPrototypeOf(AM, rp);
AM.$ch = Ij;
AM.call = $M;
function PM(f, s, n) {
  return new AP(f, s, n);
}
function Ij(f, s) {
  return f !== s;
}
function R0(f) {
  return typeof f == "function";
}
function _M(f) {
  if (f.$st === MP)
    for (let s = 0; s < f.$s.length && (_M(f.$s[s]), f.$st !== GC); s++)
      ;
  f.$st === GC ? PP(f) : f.$st = wy;
}
function qj(f) {
  f.$h && my.call(f, !1), f.$d && $P(f), f.$eh = f[wo] ? f[wo].$eh : null;
}
function PP(f) {
  let s = Ns, n = rs;
  Ns = null, rs = 0;
  try {
    qj(f);
    const o = lw(f, f.$c, f);
    NA(f), !f.$e && f.$i ? OP.call(f, o) : (f.$v = o, f.$i = !0);
  } catch (o) {
    NA(f), LM(f, o);
  } finally {
    Ns = s, rs = n, f.$st = wy;
  }
}
function NA(f) {
  if (Ns) {
    if (f.$s && DR(f, rs), f.$s && rs > 0) {
      f.$s.length = rs + Ns.length;
      for (let n = 0; n < Ns.length; n++)
        f.$s[rs + n] = Ns[n];
    } else
      f.$s = Ns;
    let s;
    for (let n = rs; n < f.$s.length; n++)
      s = f.$s[n], s.$o ? s.$o.push(f) : s.$o = [f];
  } else f.$s && rs < f.$s.length && (DR(f, rs), f.$s.length = rs);
}
function _P(f, s) {
  if (!(f.$st >= s) && (f.$e && f.$st === wy && (av.push(f), YC || Uj()), f.$st = s, f.$o))
    for (let n = 0; n < f.$o.length; n++)
      _P(f.$o[n], MP);
}
function DR(f, s) {
  let n, o;
  for (let h = s; h < f.$s.length; h++)
    n = f.$s[h], n.$o && (o = n.$o.indexOf(f), n.$o[o] = n.$o[n.$o.length - 1], n.$o.pop());
}
function KC(...f) {
}
function Zu(f) {
  return f === null;
}
function mi(f) {
  return typeof f > "u";
}
function jj(f) {
  return Zu(f) || mi(f);
}
function Bj(f) {
  return (f == null ? void 0 : f.constructor) === Object;
}
function ss(f) {
  return typeof f == "number" && !Number.isNaN(f);
}
function Ze(f) {
  return typeof f == "string";
}
function EQ(f) {
  return typeof f == "boolean";
}
function ls(f) {
  return typeof f == "function";
}
function Vr(f) {
  return Array.isArray(f);
}
const Qj = Event, NP = Symbol("DOM_EVENT");
var gP, SP;
class yt extends (SP = Qj, gP = NP, SP) {
  constructor(n, ...o) {
    var v, y;
    super(n, o[0]);
    Z(this, gP, !0);
    /**
     * The event detail.
     */
    Z(this, "detail");
    /**
     * The event trigger chain.
     */
    Z(this, "triggers", new Yj());
    this.detail = (v = o[0]) == null ? void 0 : v.detail;
    const h = (y = o[0]) == null ? void 0 : y.trigger;
    h && this.triggers.add(h);
  }
  /**
   * The preceding event that was responsible for this event being fired.
   */
  get trigger() {
    return this.triggers.source;
  }
  /**
   * The origin event that lead to this event being fired.
   */
  get originEvent() {
    return this.triggers.origin;
  }
  /**
   * Whether the origin event was triggered by the user.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted}
   */
  get isOriginTrusted() {
    var n;
    return ((n = this.triggers.origin) == null ? void 0 : n.isTrusted) ?? !1;
  }
}
class Yj {
  constructor() {
    Z(this, "chain", []);
  }
  get source() {
    return this.chain[0];
  }
  get origin() {
    return this.chain[this.chain.length - 1];
  }
  /**
   * Appends the event to the end of the chain.
   */
  add(s) {
    this.chain.push(s), Gj(s) && this.chain.push(...s.triggers);
  }
  /**
   * Removes the event from the chain and returns it (if found).
   */
  remove(s) {
    return this.chain.splice(this.chain.indexOf(s), 1)[0];
  }
  /**
   * Returns whether the chain contains the given `event`.
   */
  has(s) {
    return this.chain.some((n) => n === s);
  }
  /**
   * Returns whether the chain contains the given event type.
   */
  hasType(s) {
    return !!this.findType(s);
  }
  /**
   * Returns the first event with the given `type` found in the chain.
   */
  findType(s) {
    return this.chain.find((n) => n.type === s);
  }
  /**
   * Walks an event chain on a given `event`, and invokes the given `callback` for each trigger event.
   */
  walk(s) {
    for (const n of this.chain) {
      const o = s(n);
      if (o) return [n, o];
    }
  }
  [Symbol.iterator]() {
    return this.chain.values();
  }
}
function Gj(f) {
  return !!(f != null && f[NP]);
}
class UP extends EventTarget {
  constructor() {
    super(...arguments);
    /** @internal type only */
    Z(this, "$ts__events");
  }
  addEventListener(n, o, h) {
    return super.addEventListener(n, o, h);
  }
  removeEventListener(n, o, h) {
    return super.removeEventListener(n, o, h);
  }
}
function En(f, s, n, o) {
  return f.addEventListener(s, n, o), Wt(() => f.removeEventListener(s, n, o));
}
var cv, dv;
class gn {
  constructor(s) {
    R(this, cv);
    R(this, dv);
    L(this, cv, s), L(this, dv, new AbortController()), Wt(this.abort.bind(this));
  }
  get signal() {
    return d(this, dv).signal;
  }
  add(s, n, o) {
    if (this.signal.aborted) throw Error("aborted");
    return d(this, cv).addEventListener(s, n, {
      ...o,
      signal: o != null && o.signal ? Wj(this.signal, o.signal) : this.signal
    }), this;
  }
  remove(s, n) {
    return d(this, cv).removeEventListener(s, n), this;
  }
  abort(s) {
    d(this, dv).abort(s);
  }
}
cv = new WeakMap(), dv = new WeakMap();
function Wj(...f) {
  const s = new AbortController(), n = { signal: s.signal };
  function o(h) {
    s.abort(h.target.reason);
  }
  for (const h of f) {
    if (h.aborted) {
      s.abort(h.reason);
      break;
    }
    h.addEventListener("abort", o, n);
  }
  return s.signal;
}
function Kj(f) {
  return !!(f != null && f.type.startsWith("touch"));
}
function D0(f) {
  return !!(f != null && f.type.startsWith("key"));
}
function Xj(f) {
  return D0(f) && f.key === "Enter";
}
function zP(f) {
  return D0(f) && (f.key === "Enter" || f.key === " ");
}
function Zj(f) {
  return f instanceof Node;
}
function ht(f, s, n) {
  if (f) if (!n && n !== "" && n !== 0)
    f.removeAttribute(s);
  else {
    const o = n === !0 ? "" : n + "";
    f.getAttribute(s) !== o && f.setAttribute(s, o);
  }
  else return;
}
function Nd(f, s, n) {
  if (f) !n && n !== 0 ? f.style.removeProperty(s) : f.style.setProperty(s, n + "");
  else return;
}
function M0(f) {
  return f.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Jj(f) {
  return eB(f).replace(/\s/g, "");
}
function eB(f) {
  return FP(f.replace(/-./g, (s) => " " + s[1].toUpperCase()));
}
function FP(f) {
  return f.charAt(0).toUpperCase() + f.slice(1);
}
function XC(f) {
  return f ? "true" : "false";
}
function bQ(f) {
  return Object.keys(f);
}
function MR() {
  let f, s;
  return { promise: new Promise((o, h) => {
    f = o, s = h;
  }), resolve: f, reject: s };
}
function tB(f) {
  return new Promise((s) => setTimeout(s, f));
}
function Ey(f) {
  let s = -1, n;
  function o(...h) {
    n = h, !(s >= 0) && (s = window.requestAnimationFrame(() => {
      f.apply(this, n), s = -1, n = void 0;
    }));
  }
  return o;
}
const nB = typeof window < "u" ? "requestIdleCallback" in window ? window.requestIdleCallback : (f) => window.setTimeout(f, 1) : KC;
function iB(f, s) {
  return new Promise((n) => {
    nB((o) => {
      f == null || f(o), n();
    }, s);
  });
}
function LR(f) {
  return !Ze(f) && "width" in f && "height" in f && ss(f.width) && ss(f.height);
}
var Ja = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
}, UA = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
], zA = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
], FA = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
], Pa = typeof window < "u" && typeof window.document < "u" ? window.document : {}, Os = "fullscreenEnabled" in Pa && Object.keys(Ja) || UA[0] in Pa && UA || zA[0] in Pa && zA || FA[0] in Pa && FA || [], Jh = {
  requestFullscreen: function(f) {
    return f[Os[Ja.requestFullscreen]]();
  },
  requestFullscreenFunction: function(f) {
    return f[Os[Ja.requestFullscreen]];
  },
  get exitFullscreen() {
    return Pa[Os[Ja.exitFullscreen]].bind(Pa);
  },
  get fullscreenPseudoClass() {
    return ":" + Os[Ja.fullscreen];
  },
  addEventListener: function(f, s, n) {
    return Pa.addEventListener(Os[Ja[f]], s, n);
  },
  removeEventListener: function(f, s, n) {
    return Pa.removeEventListener(Os[Ja[f]], s, n);
  },
  get fullscreenEnabled() {
    return !!Pa[Os[Ja.fullscreenEnabled]];
  },
  set fullscreenEnabled(f) {
  },
  get fullscreenElement() {
    return Pa[Os[Ja.fullscreenElement]];
  },
  set fullscreenElement(f) {
  },
  get onfullscreenchange() {
    return Pa[("on" + Os[Ja.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(f) {
    return Pa[("on" + Os[Ja.fullscreenchange]).toLowerCase()] = f;
  },
  get onfullscreenerror() {
    return Pa[("on" + Os[Ja.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(f) {
    return Pa[("on" + Os[Ja.fullscreenerror]).toLowerCase()] = f;
  }
};
function st(f, s) {
  const n = PM(f, null, s), o = $M.bind(n);
  return o[wo] = !0, o.set = OP.bind(n), o;
}
function rB(f) {
  return R0(f) && wo in f;
}
function ow(f, s) {
  const n = PM(
    s == null ? void 0 : s.initial,
    f,
    s
  ), o = $M.bind(n);
  return o[wo] = !0, o;
}
function VP(f, s) {
  const n = PM(
    null,
    function() {
      let h = f();
      return R0(h) && Wt(h), null;
    },
    void 0
  );
  return n.$e = !0, PP(n), my.bind(n, !0);
}
function aB(f) {
  return rB(f) && "set" in f;
}
const J = VP;
function by(f) {
  return { id: Symbol(), provide: f };
}
function Ju(f, s, n = DM()) {
  var h;
  const o = !mi(s);
  Vj(f.id, o ? s : (h = f.provide) == null ? void 0 : h.call(f), n);
}
function Us(f) {
  return MM(f.id);
}
function ep(f) {
  return !mi(MM(f.id));
}
const mR = /* @__PURE__ */ Symbol(0), vR = /* @__PURE__ */ Symbol(0), L0 = /* @__PURE__ */ Symbol(0), yR = {};
var TP, fv, hv, vh, pv, Eo, HP, IP, qP, jP;
TP = L0;
class sB {
  constructor(s, n, o) {
    R(this, Eo);
    /** @internal type only */
    Z(this, "$ts__events");
    /** @internal type only */
    Z(this, "$ts__vars");
    /* @internal */
    Z(this, TP, null);
    Z(this, "$el", st(null));
    Z(this, "el", null);
    Z(this, "scope", null);
    Z(this, "attachScope", null);
    Z(this, "connectScope", null);
    Z(this, "component", null);
    Z(this, "destroyed", !1);
    Z(this, "props", yR);
    Z(this, "attrs", null);
    Z(this, "styles", null);
    Z(this, "state");
    Z(this, "$state");
    R(this, fv, []);
    R(this, hv, []);
    R(this, vh, []);
    R(this, pv, []);
    var y;
    this.scope = n, o != null && o.scope && o.scope.append(n);
    let h = s.state, v = s.props;
    if (h && (this.$state = h.create(), this.state = new Proxy(this.$state, {
      get: (C, D) => this.$state[D]()
    }), Ju(h, this.$state)), v && (this.props = lB(v), o != null && o.props))
      for (const C of Object.keys(o.props))
        (y = this.props[C]) == null || y.set(o.props[C]);
    Wt(this.destroy.bind(this));
  }
  setup() {
    bl(() => {
      for (const s of d(this, fv)) s();
    }, this.scope);
  }
  attach(s) {
    this.el || (this.el = s, this.$el.set(s), bl(() => {
      this.attachScope = WC(), bl(() => {
        for (const n of d(this, hv)) n(this.el);
        S(this, Eo, HP).call(this), S(this, Eo, IP).call(this);
      }, this.attachScope);
    }, this.scope), s.dispatchEvent(new Event("attached")));
  }
  detach() {
    var s;
    (s = this.attachScope) == null || s.dispose(), this.attachScope = null, this.connectScope = null, this.el = null, this.$el.set(null);
  }
  connect() {
    !this.el || !this.attachScope || !d(this, vh).length || bl(() => {
      this.connectScope = WC(), bl(() => {
        for (const s of d(this, vh)) s(this.el);
      }, this.connectScope);
    }, this.attachScope);
  }
  disconnect() {
    var s;
    (s = this.connectScope) == null || s.dispose(), this.connectScope = null;
  }
  destroy() {
    if (this.destroyed) return;
    this.destroyed = !0, bl(() => {
      for (const n of d(this, pv)) n(this.el);
    }, this.scope);
    const s = this.el;
    this.detach(), this.scope.dispose(), d(this, fv).length = 0, d(this, hv).length = 0, d(this, vh).length = 0, d(this, pv).length = 0, this.component = null, this.attrs = null, this.styles = null, this.props = yR, this.scope = null, this.state = yR, this.$state = null, s && delete s.$;
  }
  addHooks(s) {
    s.onSetup && d(this, fv).push(s.onSetup.bind(s)), s.onAttach && d(this, hv).push(s.onAttach.bind(s)), s.onConnect && d(this, vh).push(s.onConnect.bind(s)), s.onDestroy && d(this, pv).push(s.onDestroy.bind(s));
  }
}
fv = new WeakMap(), hv = new WeakMap(), vh = new WeakMap(), pv = new WeakMap(), Eo = new WeakSet(), HP = function() {
  if (this.attrs)
    for (const s of Object.keys(this.attrs))
      ls(this.attrs[s]) ? J(S(this, Eo, qP).bind(this, s)) : ht(this.el, s, this.attrs[s]);
}, IP = function() {
  if (this.styles)
    for (const s of Object.keys(this.styles))
      ls(this.styles[s]) ? J(S(this, Eo, jP).bind(this, s)) : Nd(this.el, s, this.styles[s]);
}, qP = function(s) {
  ht(this.el, s, this.attrs[s].call(this.component));
}, jP = function(s) {
  Nd(this.el, s, this.styles[s].call(this.component));
};
function lB(f) {
  const s = {};
  for (const n of Object.keys(f)) {
    const o = f[n];
    s[n] = st(o, o);
  }
  return s;
}
let aT = { $$: null };
function oB(f, s) {
  return Fj(() => {
    aT.$$ = new sB(f, DM(), s);
    const n = new f();
    return aT.$$.component = n, aT.$$ = null, n;
  });
}
class Hs extends EventTarget {
  constructor() {
    super();
    /** @internal */
    Z(this, "$$");
    aT.$$ && this.attach(aT);
  }
  get el() {
    return this.$$.el;
  }
  get $el() {
    return this.$$.$el();
  }
  get scope() {
    return this.$$.scope;
  }
  get attachScope() {
    return this.$$.attachScope;
  }
  get connectScope() {
    return this.$$.connectScope;
  }
  /** @internal */
  get $props() {
    return this.$$.props;
  }
  /** @internal */
  get $state() {
    return this.$$.$state;
  }
  get state() {
    return this.$$.state;
  }
  attach({ $$: n }) {
    return this.$$ = n, n.addHooks(this), this;
  }
  addEventListener(n, o, h) {
    this.listen(n, o, h);
  }
  removeEventListener(n, o, h) {
    var v;
    (v = this.el) == null || v.removeEventListener(n, o, h);
  }
  /**
   * The given callback is invoked when the component is ready to be set up.
   *
   * - This hook will run once.
   * - This hook is called both client-side and server-side.
   * - It's safe to use context inside this hook.
   * - The host element has not attached yet - wait for `onAttach`.
   */
  /**
   * This method can be used to specify attributes that should be set on the host element. Any
   * attributes that are assigned to a function will be considered a signal and updated accordingly.
   */
  setAttributes(n) {
    this.$$.attrs || (this.$$.attrs = {}), Object.assign(this.$$.attrs, n);
  }
  /**
   * This method can be used to specify styles that should set be set on the host element. Any
   * styles that are assigned to a function will be considered a signal and updated accordingly.
   */
  setStyles(n) {
    this.$$.styles || (this.$$.styles = {}), Object.assign(this.$$.styles, n);
  }
  /**
   * This method is used to satisfy the CSS variables contract specified on the current
   * component. Other CSS variables can be set via the `setStyles` method.
   */
  setCSSVars(n) {
    this.setStyles(n);
  }
  /**
   * Type-safe utility for creating component DOM events.
   */
  createEvent(n, ...o) {
    return new yt(n, o[0]);
  }
  /**
   * Creates a `DOMEvent` and dispatches it from the host element. This method is typed to
   * match all component events.
   */
  dispatch(n, ...o) {
    if (!this.el) return !1;
    const h = n instanceof Event ? n : new yt(n, o[0]);
    return Object.defineProperty(h, "target", {
      get: () => this.$$.component
    }), py(() => {
      var v, y;
      return (y = (v = this.$$)[L0]) == null || y.call(v, h), this.el.dispatchEvent(h);
    });
  }
  dispatchEvent(n) {
    return this.dispatch(n);
  }
  /**
   * Adds an event listener for the given `type` and returns a function which can be invoked to
   * remove the event listener.
   *
   * - The listener is removed if the current scope is disposed.
   * - This method is safe to use on the server (noop).
   */
  listen(n, o, h) {
    return this.el ? En(this.el, n, o, h) : KC;
  }
}
class bi extends Hs {
  subscribe(s) {
    return bl(() => J(() => s(this.state)), this.$$.scope);
  }
  destroy() {
    this.$$.destroy();
  }
}
function rn(f, s, n) {
  f[mR] || (f[mR] = /* @__PURE__ */ new Set()), f[mR].add(s);
}
function Zi(f, s, n) {
  f[vR] || (f[vR] = /* @__PURE__ */ new Set()), f[vR].add(s);
}
var mv;
class Cy {
  constructor(s) {
    Z(this, "id", Symbol(0));
    Z(this, "record");
    R(this, mv);
    this.record = s, L(this, mv, Object.getOwnPropertyDescriptors(s));
  }
  create() {
    const s = {}, n = new Proxy(s, { get: (o, h) => s[h]() });
    for (const o of Object.keys(this.record)) {
      const h = d(this, mv)[o].get;
      s[o] = h ? ow(h.bind(n)) : st(this.record[o]);
    }
    return s;
  }
  reset(s, n) {
    for (const o of Object.keys(s))
      !d(this, mv)[o].get && (!n || n(o)) && s[o].set(this.record[o]);
  }
}
mv = new WeakMap();
function uw(f) {
  return Us(f);
}
const uB = (navigator == null ? void 0 : navigator.userAgent.toLowerCase()) || "", $0 = /iphone|ipad|ipod|ios|crios|fxios/i.test(uB), BP = /(iphone|ipod)/gi.test((navigator == null ? void 0 : navigator.platform) || ""), O0 = !!window.chrome, ZC = !!window.safari || $0;
function QP() {
  return cB() && ls(screen.orientation.unlock);
}
function cB() {
  return !mi(window.screen.orientation) && !mi(window.screen.orientation.lock);
}
function YP(f, s) {
  return f || (f = document.createElement("audio")), f.canPlayType(s).length > 0;
}
function GP(f, s) {
  return f || (f = document.createElement("video")), f.canPlayType(s).length > 0;
}
function dB(f) {
  return f || (f = document.createElement("video")), f.canPlayType("application/vnd.apple.mpegurl").length > 0;
}
function fB(f) {
  return !!document.pictureInPictureEnabled && !(f != null && f.disablePictureInPicture);
}
function hB(f) {
  return ls(f == null ? void 0 : f.webkitSupportsPresentationMode) && ls(f == null ? void 0 : f.webkitSetPresentationMode);
}
async function pB() {
  const f = document.createElement("video");
  return f.volume = 0.5, await tB(0), f.volume === 0.5;
}
function mB() {
  return (window == null ? void 0 : window.ManagedMediaSource) ?? (window == null ? void 0 : window.MediaSource) ?? (window == null ? void 0 : window.WebKitMediaSource);
}
function vB() {
  return (window == null ? void 0 : window.SourceBuffer) ?? (window == null ? void 0 : window.WebKitSourceBuffer);
}
function NM() {
  const f = mB();
  if (mi(f)) return !1;
  const s = f && ls(f.isTypeSupported) && f.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), n = vB(), o = mi(n) || !mi(n.prototype) && ls(n.prototype.appendBuffer) && ls(n.prototype.remove);
  return !!s && !!o;
}
function yB() {
  return NM();
}
var Du;
class bC {
  constructor(s, n) {
    R(this, Du);
    Vr(s) ? L(this, Du, s) : !mi(s) && !mi(n) ? L(this, Du, [[s, n]]) : L(this, Du, []);
  }
  get length() {
    return d(this, Du).length;
  }
  start(s) {
    return d(this, Du)[s][0] ?? 1 / 0;
  }
  end(s) {
    return d(this, Du)[s][1] ?? 1 / 0;
  }
}
Du = new WeakMap();
function VA(f) {
  if (!f.length) return null;
  let s = f.start(0);
  for (let n = 1; n < f.length; n++) {
    const o = f.start(n);
    o < s && (s = o);
  }
  return s;
}
function mh(f) {
  if (!f.length) return null;
  let s = f.end(0);
  for (let n = 1; n < f.length; n++) {
    const o = f.end(n);
    o > s && (s = o);
  }
  return s;
}
function gB(f) {
  if (f.length <= 1)
    return f;
  f.sort((o, h) => o[0] - h[0]);
  let s = [], n = f[0];
  for (let o = 1; o < f.length; o++) {
    const h = f[o];
    n[1] >= h[0] - 1 ? n = [n[0], Math.max(n[1], h[1])] : (s.push(n), n = h);
  }
  return s.push(n), s;
}
function SB(f, s, n) {
  let o = s[0], h = s[1];
  return n < o ? [n, -1] : n === o ? s : o === -1 ? (s[0] = n, s) : (n > o && (s[1] = n, h === -1 && f.push(s)), gB(f), s);
}
const TB = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx|flac)($|\?)/i, wB = /* @__PURE__ */ new Set([
  "audio/aac",
  "audio/mpeg",
  "audio/ogg",
  "audio/3gp",
  "audio/mp3",
  "audio/webm",
  "audio/flac",
  "audio/m4a",
  "audio/m4b",
  "audio/mp4a",
  "audio/mp4"
]), EB = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, bB = /* @__PURE__ */ new Set([
  "video/mp4",
  "video/webm",
  "video/3gp",
  "video/ogg",
  "video/avi",
  "video/mpeg"
]), CB = /\.(m3u8)($|\?)/i, kB = /\.(mpd)($|\?)/i, xB = /* @__PURE__ */ new Set([
  // Apple sanctioned
  "application/vnd.apple.mpegurl",
  // Apple sanctioned for backwards compatibility
  "audio/mpegurl",
  // Very common
  "audio/x-mpegurl",
  // Very common
  "application/x-mpegurl",
  // Included for completeness
  "video/x-mpegurl",
  "video/mpegurl",
  "application/mpegurl"
]), RB = /* @__PURE__ */ new Set(["application/dash+xml"]);
function WP({ src: f, type: s }) {
  return Ze(f) ? TB.test(f) || wB.has(s) || f.startsWith("blob:") && s === "audio/object" : s === "audio/object";
}
function KP(f) {
  return Ze(f.src) ? EB.test(f.src) || bB.has(f.type) || f.src.startsWith("blob:") && f.type === "video/object" || ky(f) && dB() : f.type === "video/object";
}
function ky({ src: f, type: s }) {
  return Ze(f) && CB.test(f) || xB.has(s);
}
function UM({ src: f, type: s }) {
  return Ze(f) && kB.test(f) || RB.has(s);
}
function XP(f) {
  return Ze(f.src) && (WP(f) || KP(f) || ky(f));
}
function CQ(f) {
  return typeof window.MediaStream < "u" && f instanceof window.MediaStream;
}
function DB(f, s) {
  const n = new URL(f);
  for (const o of Object.keys(s)) {
    const h = s[o];
    mi(h) || n.searchParams.set(o, s[o] + "");
  }
  return n.toString();
}
function A0(f, s = "preconnect") {
  const n = document.querySelector(`link[href="${f}"]`);
  if (!Zu(n)) return !0;
  const o = document.createElement("link");
  return o.rel = s, o.href = f, o.crossOrigin = "true", document.head.append(o), !0;
}
const XS = {};
function zM(f) {
  if (XS[f]) return XS[f].promise;
  const s = MR(), n = document.querySelector(`script[src="${f}"]`);
  if (!Zu(n))
    return s.resolve(), s.promise;
  XS[f] = s;
  const o = document.createElement("script");
  return o.src = f, o.onload = () => {
    s.resolve(), delete XS[f];
  }, o.onerror = () => {
    s.reject(), delete XS[f];
  }, setTimeout(() => document.head.append(o), 0), s.promise;
}
function sT(f) {
  return f === "use-credentials" ? "include" : Ze(f) ? "same-origin" : void 0;
}
const MB = Symbol(0), LB = Symbol(0), $B = Symbol(0), OB = Symbol(0), AB = Symbol(0), PB = Symbol(0), _B = Symbol(0), tt = {
  crossOrigin: MB,
  readyState: LB,
  updateActiveCues: $B,
  canLoad: OB,
  onModeChange: AB,
  native: PB,
  nativeHLS: _B
};
function HA(f, s) {
  return s >= f.startTime && s < f.endTime;
}
function ZP(f, s, n) {
  let o = null, h = DM();
  function v() {
    const y = Ze(s) ? [s] : s, C = f.toArray().find((D) => y.includes(D.kind) && D.mode === "showing");
    if (C !== o) {
      if (!C) {
        n(null), o = null;
        return;
      }
      C.readyState == 2 ? n(C) : (n(null), bl(() => {
        const D = En(
          C,
          "load",
          () => {
            n(C), D();
          },
          { once: !0 }
        );
      }, h)), o = C;
    }
  }
  return v(), En(f, "mode-change", v);
}
var wP, EP, bP, CP, cT, Mu, vv, dT, yh, vr, nd, Ei, JP, $R, JS, OR, AR, e_;
class Ud extends UP {
  constructor(n) {
    super();
    R(this, Ei);
    Z(this, "src");
    Z(this, "content");
    Z(this, "type");
    Z(this, "encoding");
    Z(this, "id", "");
    Z(this, "label", "");
    Z(this, "language", "");
    Z(this, "kind");
    Z(this, "default", !1);
    Z(this, "sourceType");
    R(this, cT, !1);
    R(this, Mu, 0);
    R(this, vv, "disabled");
    R(this, dT, {});
    R(this, yh, []);
    R(this, vr, []);
    R(this, nd, []);
    /** @internal */
    Z(this, CP, 0);
    /** @internal */
    Z(this, bP);
    /** @internal */
    Z(this, EP, null);
    /** @internal */
    Z(this, wP, null);
    for (const o of Object.keys(n)) this[o] = n[o];
    this.type || (this.type = "vtt"), n.content ? S(this, Ei, JP).call(this, n) : n.src || (this[tt.readyState] = 2);
  }
  static createId(n) {
    return `vds-${n.type}-${n.kind}-${n.src ?? n.label ?? "?"}`;
  }
  get metadata() {
    return d(this, dT);
  }
  get regions() {
    return d(this, yh);
  }
  get cues() {
    return d(this, vr);
  }
  get activeCues() {
    return d(this, nd);
  }
  /**
   * - 0: Not Loading
   * - 1: Loading
   * - 2: Ready
   * - 3: Error
   */
  get readyState() {
    return this[tt.readyState];
  }
  get mode() {
    return d(this, vv);
  }
  set mode(n) {
    this.setMode(n);
  }
  addCue(n, o) {
    var y;
    let h = 0, v = d(this, vr).length;
    for (h = 0; h < v && !(n.endTime <= d(this, vr)[h].startTime); h++) ;
    h === v ? d(this, vr).push(n) : d(this, vr).splice(h, 0, n), n instanceof TextTrackCue || (y = this[tt.native]) == null || y.track.addCue(n), this.dispatchEvent(new yt("add-cue", { detail: n, trigger: o })), HA(n, d(this, Mu)) && this[tt.updateActiveCues](d(this, Mu), o);
  }
  removeCue(n, o) {
    var v;
    const h = d(this, vr).indexOf(n);
    if (h >= 0) {
      const y = d(this, nd).includes(n);
      d(this, vr).splice(h, 1), (v = this[tt.native]) == null || v.track.removeCue(n), this.dispatchEvent(new yt("remove-cue", { detail: n, trigger: o })), y && this[tt.updateActiveCues](d(this, Mu), o);
    }
  }
  setMode(n, o) {
    var h;
    d(this, vv) !== n && (L(this, vv, n), this.readyState === 2 ? this[tt.updateActiveCues](d(this, Mu), o) : S(this, Ei, $R).call(this), this.dispatchEvent(new yt("mode-change", { detail: this, trigger: o })), (h = this[tt.onModeChange]) == null || h.call(this));
  }
  /** @internal */
  [(CP = tt.readyState, bP = tt.crossOrigin, EP = tt.onModeChange, wP = tt.native, tt.updateActiveCues)](n, o) {
    if (L(this, Mu, n), !d(this, vr).length) return;
    const h = [];
    for (let y = 0, C = d(this, vr).length; y < C; y++) {
      const D = d(this, vr)[y];
      HA(D, n) && h.push(D);
    }
    let v = h.length !== d(this, nd).length;
    if (!v) {
      for (let y = 0; y < h.length; y++)
        if (!d(this, nd).includes(h[y])) {
          v = !0;
          break;
        }
    }
    L(this, nd, h), v && S(this, Ei, e_).call(this, o);
  }
  /** @internal */
  [tt.canLoad]() {
    L(this, cT, !0), S(this, Ei, $R).call(this);
  }
}
cT = new WeakMap(), Mu = new WeakMap(), vv = new WeakMap(), dT = new WeakMap(), yh = new WeakMap(), vr = new WeakMap(), nd = new WeakMap(), Ei = new WeakSet(), JP = function(n) {
  import("./dev-D3SS6qhA.js").then((o) => o.d).then(({ parseText: o, VTTCue: h, VTTRegion: v }) => {
    !Ze(n.content) || n.type === "json" ? (S(this, Ei, AR).call(this, n.content, h, v), this.readyState !== 3 && S(this, Ei, JS).call(this)) : o(n.content, { type: n.type }).then(({ cues: y, regions: C }) => {
      L(this, vr, y), L(this, yh, C), S(this, Ei, JS).call(this);
    });
  });
}, $R = async function() {
  var n, o;
  if (!(!d(this, cT) || this[tt.readyState] > 0)) {
    if (this[tt.readyState] = 1, this.dispatchEvent(new yt("load-start")), !this.src) {
      S(this, Ei, JS).call(this);
      return;
    }
    try {
      const { parseResponse: h, VTTCue: v, VTTRegion: y } = await import("./dev-D3SS6qhA.js").then(($) => $.d), C = (n = this[tt.crossOrigin]) == null ? void 0 : n.call(this), D = fetch(this.src, {
        headers: this.type === "json" ? { "Content-Type": "application/json" } : void 0,
        credentials: sT(C)
      });
      if (this.type === "json")
        S(this, Ei, AR).call(this, await (await D).text(), v, y);
      else {
        const { errors: $, metadata: _, regions: A, cues: B } = await h(D, {
          type: this.type,
          encoding: this.encoding
        });
        if (((o = $[0]) == null ? void 0 : o.code) === 0)
          throw $[0];
        L(this, dT, _), L(this, yh, A), L(this, vr, B);
      }
      S(this, Ei, JS).call(this);
    } catch (h) {
      S(this, Ei, OR).call(this, h);
    }
  }
}, JS = function() {
  if (this[tt.readyState] = 2, !this.src || this.type !== "vtt") {
    const o = this[tt.native];
    if (o && !o.managed)
      for (const h of d(this, vr)) o.track.addCue(h);
  }
  const n = new yt("load");
  this[tt.updateActiveCues](d(this, Mu), n), this.dispatchEvent(n);
}, OR = function(n) {
  this[tt.readyState] = 3, this.dispatchEvent(new yt("error", { detail: n }));
}, AR = function(n, o, h) {
  try {
    const { regions: v, cues: y } = UB(n, o, h);
    L(this, yh, v), L(this, vr, y);
  } catch (v) {
    S(this, Ei, OR).call(this, v);
  }
}, e_ = function(n) {
  this.dispatchEvent(new yt("cue-change", { trigger: n }));
};
const NB = /captions|subtitles/;
function _a(f) {
  return NB.test(f.kind);
}
function UB(f, s, n) {
  const o = Ze(f) ? JSON.parse(f) : f;
  let h = [], v = [];
  return o.regions && n && (h = o.regions.map((y) => Object.assign(new n(), y))), (o.cues || Vr(o)) && (v = (Vr(o) ? o : o.cues).filter((y) => ss(y.startTime) && ss(y.endTime)).map((y) => Object.assign(new s(0, 0, ""), y))), { regions: h, cues: v };
}
const xy = new Cy({
  artist: "",
  artwork: null,
  audioTrack: null,
  audioTracks: [],
  autoPlay: !1,
  autoPlayError: null,
  audioGain: null,
  buffered: new bC(),
  canLoad: !1,
  canLoadPoster: !1,
  canFullscreen: !1,
  canOrientScreen: QP(),
  canPictureInPicture: !1,
  canPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  get iOSControls() {
    return BP && this.mediaType === "video" && (!this.playsInline || !Jh.fullscreenEnabled && this.fullscreen);
  },
  get nativeControls() {
    return this.controls || this.iOSControls;
  },
  controlsVisible: !1,
  get controlsHidden() {
    return !this.controlsVisible;
  },
  crossOrigin: null,
  ended: !1,
  error: null,
  fullscreen: !1,
  get loop() {
    return this.providedLoop || this.userPrefersLoop;
  },
  logLevel: "silent",
  mediaType: "unknown",
  muted: !1,
  paused: !0,
  played: new bC(),
  playing: !1,
  playsInline: !1,
  pictureInPicture: !1,
  preload: "metadata",
  playbackRate: 1,
  qualities: [],
  quality: null,
  autoQuality: !1,
  canSetQuality: !0,
  canSetPlaybackRate: !0,
  canSetVolume: !1,
  canSetAudioGain: !1,
  seekable: new bC(),
  seeking: !1,
  source: { src: "", type: "" },
  sources: [],
  started: !1,
  textTracks: [],
  textTrack: null,
  get hasCaptions() {
    return this.textTracks.filter(_a).length > 0;
  },
  volume: 1,
  waiting: !1,
  realCurrentTime: 0,
  get currentTime() {
    return this.ended ? this.duration : this.clipStartTime > 0 ? Math.max(0, Math.min(this.realCurrentTime - this.clipStartTime, this.duration)) : this.realCurrentTime;
  },
  providedDuration: -1,
  intrinsicDuration: 0,
  get duration() {
    return this.seekableWindow;
  },
  get title() {
    return this.providedTitle || this.inferredTitle;
  },
  get poster() {
    return this.providedPoster || this.inferredPoster;
  },
  get viewType() {
    return this.providedViewType !== "unknown" ? this.providedViewType : this.inferredViewType;
  },
  get streamType() {
    return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
  },
  get currentSrc() {
    return this.source;
  },
  get bufferedStart() {
    const f = VA(this.buffered) ?? 0;
    return Math.max(f, this.clipStartTime);
  },
  get bufferedEnd() {
    const f = mh(this.buffered) ?? 0;
    return Math.min(this.seekableEnd, Math.max(0, f - this.clipStartTime));
  },
  get bufferedWindow() {
    return Math.max(0, this.bufferedEnd - this.bufferedStart);
  },
  get seekableStart() {
    if (this.isLiveDVR && this.liveDVRWindow > 0)
      return Math.max(0, this.seekableEnd - this.liveDVRWindow);
    const f = VA(this.seekable) ?? 0;
    return Math.max(f, this.clipStartTime);
  },
  get seekableEnd() {
    if (this.providedDuration > 0) return this.providedDuration;
    const f = this.liveSyncPosition > 0 ? this.liveSyncPosition : this.canPlay ? mh(this.seekable) ?? 1 / 0 : 0;
    return this.clipEndTime > 0 ? Math.min(this.clipEndTime, f) : f;
  },
  get seekableWindow() {
    const f = this.seekableEnd - this.seekableStart;
    return isNaN(f) ? 1 / 0 : Math.max(0, f);
  },
  // ~~ remote playback ~~
  canAirPlay: !1,
  canGoogleCast: !1,
  remotePlaybackState: "disconnected",
  remotePlaybackType: "none",
  remotePlaybackLoader: null,
  remotePlaybackInfo: null,
  get isAirPlayConnected() {
    return this.remotePlaybackType === "airplay" && this.remotePlaybackState === "connected";
  },
  get isGoogleCastConnected() {
    return this.remotePlaybackType === "google-cast" && this.remotePlaybackState === "connected";
  },
  // ~~ responsive design ~~
  pointer: "fine",
  orientation: "landscape",
  width: 0,
  height: 0,
  mediaWidth: 0,
  mediaHeight: 0,
  lastKeyboardAction: null,
  // ~~ user props ~~
  userBehindLiveEdge: !1,
  // ~~ live props ~~
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  get canSeek() {
    return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.duration) && (!this.isLiveDVR || this.duration >= this.liveDVRWindow);
  },
  get live() {
    return this.streamType.includes("live") || !Number.isFinite(this.duration);
  },
  get liveEdgeStart() {
    return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, this.seekableEnd - this.liveEdgeTolerance) : 0;
  },
  get liveEdge() {
    return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
  },
  get liveEdgeWindow() {
    return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
  },
  get isLiveDVR() {
    return /:dvr/.test(this.streamType);
  },
  get liveDVRWindow() {
    return Math.max(this.inferredLiveDVRWindow, this.minLiveDVRWindow);
  },
  // ~~ internal props ~~
  autoPlaying: !1,
  providedTitle: "",
  inferredTitle: "",
  providedLoop: !1,
  userPrefersLoop: !1,
  providedPoster: "",
  inferredPoster: "",
  inferredViewType: "unknown",
  providedViewType: "unknown",
  providedStreamType: "unknown",
  inferredStreamType: "unknown",
  liveSyncPosition: null,
  inferredLiveDVRWindow: 0,
  savedState: null
}), t_ = /* @__PURE__ */ new Set([
  "autoPlayError",
  "autoPlaying",
  "buffered",
  "canPlay",
  "error",
  "paused",
  "played",
  "playing",
  "seekable",
  "seeking",
  "waiting"
]), zB = /* @__PURE__ */ new Set([
  ...t_,
  "ended",
  "inferredPoster",
  "inferredStreamType",
  "inferredTitle",
  "intrinsicDuration",
  "inferredLiveDVRWindow",
  "liveSyncPosition",
  "realCurrentTime",
  "savedState",
  "started",
  "userBehindLiveEdge"
]);
function IA(f, s = !1) {
  const n = s ? t_ : zB;
  xy.reset(f, (o) => n.has(o)), Xu();
}
function n_(f, s) {
  const n = f + s.clipStartTime(), o = Math.floor(f) === Math.floor(s.seekableStart()), h = Math.floor(n) === Math.floor(s.seekableEnd());
  return o ? s.seekableStart() : h ? s.seekableEnd() : s.isLiveDVR() && s.liveDVRWindow() > 0 && n < s.seekableEnd() - s.liveDVRWindow() ? s.bufferedStart() : Math.min(Math.max(s.seekableStart() + 0.1, n), s.seekableEnd() - 0.1);
}
const FM = by();
function Ua() {
  return Us(FM);
}
var gh, ts, yv, s0, Bt, nn, FB;
class i_ {
  constructor(s = void 0) {
    R(this, Bt);
    R(this, gh, null);
    R(this, ts, null);
    R(this, yv, -1);
    R(this, s0);
    L(this, s0, s);
  }
  /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the player element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */
  setTarget(s) {
    L(this, gh, s);
  }
  /**
   * Returns the current player element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */
  getPlayer(s) {
    var n;
    return d(this, ts) ? d(this, ts) : ((n = s ?? d(this, gh)) == null || n.dispatchEvent(
      new yt("find-media-player", {
        detail: (o) => void L(this, ts, o),
        bubbles: !0,
        composed: !0
      })
    ), d(this, ts));
  }
  /**
   * Set the current player element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */
  setPlayer(s) {
    L(this, ts, s);
  }
  /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(s) {
    S(this, Bt, nn).call(this, "media-start-loading", s);
  }
  /**
   * Dispatch a request to start the poster loading process. This will only work if the media
   * player has been initialized with a custom poster loading strategy `posterLoad="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(s) {
    S(this, Bt, nn).call(this, "media-poster-start-loading", s);
  }
  /**
   * Dispatch a request to connect to AirPlay.
   *
   * @see {@link https://www.apple.com/au/airplay}
   */
  requestAirPlay(s) {
    S(this, Bt, nn).call(this, "media-airplay-request", s);
  }
  /**
   * Dispatch a request to connect to Google Cast.
   *
   * @see {@link https://developers.google.com/cast/docs/overview}
   */
  requestGoogleCast(s) {
    S(this, Bt, nn).call(this, "media-google-cast-request", s);
  }
  /**
   * Dispatch a request to begin/resume media playback.
   */
  play(s) {
    S(this, Bt, nn).call(this, "media-play-request", s);
  }
  /**
   * Dispatch a request to pause media playback.
   */
  pause(s) {
    S(this, Bt, nn).call(this, "media-pause-request", s);
  }
  /**
   * Dispatch a request to set the media volume to mute (0).
   */
  mute(s) {
    S(this, Bt, nn).call(this, "media-mute-request", s);
  }
  /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */
  unmute(s) {
    S(this, Bt, nn).call(this, "media-unmute-request", s);
  }
  /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  enterFullscreen(s, n) {
    S(this, Bt, nn).call(this, "media-enter-fullscreen-request", n, s);
  }
  /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  exitFullscreen(s, n) {
    S(this, Bt, nn).call(this, "media-exit-fullscreen-request", n, s);
  }
  /**
   * Dispatch a request to lock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/screen-orientation#remote-control}
   */
  lockScreenOrientation(s, n) {
    S(this, Bt, nn).call(this, "media-orientation-lock-request", n, s);
  }
  /**
   * Dispatch a request to unlock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/screen-orientation#remote-control}
   */
  unlockScreenOrientation(s) {
    S(this, Bt, nn).call(this, "media-orientation-unlock-request", s);
  }
  /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  enterPictureInPicture(s) {
    S(this, Bt, nn).call(this, "media-enter-pip-request", s);
  }
  /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  exitPictureInPicture(s) {
    S(this, Bt, nn).call(this, "media-exit-pip-request", s);
  }
  /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */
  seeking(s, n) {
    S(this, Bt, nn).call(this, "media-seeking-request", n, s);
  }
  /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */
  seek(s, n) {
    S(this, Bt, nn).call(this, "media-seek-request", n, s);
  }
  seekToLiveEdge(s) {
    S(this, Bt, nn).call(this, "media-live-edge-request", s);
  }
  /**
   * Dispatch a request to update the length of the media in seconds.
   *
   * @example
   * ```ts
   * remote.changeDuration(100); // 100 seconds
   * ```
   */
  changeDuration(s, n) {
    S(this, Bt, nn).call(this, "media-duration-change-request", n, s);
  }
  /**
   * Dispatch a request to update the clip start time. This is the time at which media playback
   * should start at.
   *
   * @example
   * ```ts
   * remote.changeClipStart(100); // start at 100 seconds
   * ```
   */
  changeClipStart(s, n) {
    S(this, Bt, nn).call(this, "media-clip-start-change-request", n, s);
  }
  /**
   * Dispatch a request to update the clip end time. This is the time at which media playback
   * should end at.
   *
   * @example
   * ```ts
   * remote.changeClipEnd(100); // end at 100 seconds
   * ```
   */
  changeClipEnd(s, n) {
    S(this, Bt, nn).call(this, "media-clip-end-change-request", n, s);
  }
  /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/audio-gain#remote-control}
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */
  changeVolume(s, n) {
    S(this, Bt, nn).call(this, "media-volume-change-request", n, Math.max(0, Math.min(1, s)));
  }
  /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */
  changeAudioTrack(s, n) {
    S(this, Bt, nn).call(this, "media-audio-track-change-request", n, s);
  }
  /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */
  changeQuality(s, n) {
    S(this, Bt, nn).call(this, "media-quality-change-request", n, s);
  }
  /**
   * Request auto quality selection.
   */
  requestAutoQuality(s) {
    this.changeQuality(-1, s);
  }
  /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */
  changeTextTrackMode(s, n, o) {
    S(this, Bt, nn).call(this, "media-text-track-change-request", o, {
      index: s,
      mode: n
    });
  }
  /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */
  changePlaybackRate(s, n) {
    S(this, Bt, nn).call(this, "media-rate-change-request", n, s);
  }
  /**
   * Dispatch a request to change the media audio gain.
   *
   * @example
   * ```ts
   * remote.changeAudioGain(1); // Disable audio gain
   * remote.changeAudioGain(1.5); // 50% louder
   * remote.changeAudioGain(2); // 100% louder
   * ```
   */
  changeAudioGain(s, n) {
    S(this, Bt, nn).call(this, "media-audio-gain-change-request", n, s);
  }
  /**
   * Dispatch a request to resume idle tracking on controls.
   */
  resumeControls(s) {
    S(this, Bt, nn).call(this, "media-resume-controls-request", s);
  }
  /**
   * Dispatch a request to pause controls idle tracking. Pausing tracking will result in the
   * controls being visible until `remote.resumeControls()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * disappearing.
   *
   * @example
   * ```ts
   * // Prevent controls hiding while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseControls();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeControls();
   * }
   * ```
   */
  pauseControls(s) {
    S(this, Bt, nn).call(this, "media-pause-controls-request", s);
  }
  /**
   * Dispatch a request to toggle the media playback state.
   */
  togglePaused(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.paused ? this.play(s) : this.pause(s));
  }
  /**
   * Dispatch a request to toggle the controls visibility.
   */
  toggleControls(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.controls.showing ? n.controls.hide(0, s) : n.controls.show(0, s));
  }
  /**
   * Dispatch a request to toggle the media muted state.
   */
  toggleMuted(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.muted ? this.unmute(s) : this.mute(s));
  }
  /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  toggleFullscreen(s, n) {
    const o = this.getPlayer(n == null ? void 0 : n.target);
    o && (o.state.fullscreen ? this.exitFullscreen(s, n) : this.enterFullscreen(s, n));
  }
  /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  togglePictureInPicture(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.pictureInPicture ? this.exitPictureInPicture(s) : this.enterPictureInPicture(s));
  }
  /**
   * Show captions.
   */
  showCaptions(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    if (!n)
      return;
    let o = n.state.textTracks, h = d(this, yv);
    (!o[h] || !_a(o[h])) && (h = -1), h === -1 && (h = o.findIndex((v) => _a(v) && v.default)), h === -1 && (h = o.findIndex((v) => _a(v))), h >= 0 && this.changeTextTrackMode(h, "showing", s), L(this, yv, -1);
  }
  /**
   * Turn captions off.
   */
  disableCaptions(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    if (!n)
      return;
    const o = n.state.textTracks, h = n.state.textTrack;
    if (h) {
      const v = o.indexOf(h);
      this.changeTextTrackMode(v, "disabled", s), L(this, yv, v);
    }
  }
  /**
   * Dispatch a request to toggle the current captions mode.
   */
  toggleCaptions(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.textTrack ? this.disableCaptions() : this.showCaptions());
  }
  userPrefersLoopChange(s, n) {
    S(this, Bt, nn).call(this, "media-user-loop-change-request", n, s);
  }
}
gh = new WeakMap(), ts = new WeakMap(), yv = new WeakMap(), s0 = new WeakMap(), Bt = new WeakSet(), nn = function(s, n, o) {
  var C, D;
  const h = new yt(s, {
    bubbles: !0,
    composed: !0,
    cancelable: !0,
    detail: o,
    trigger: n
  });
  let v = (n == null ? void 0 : n.target) || null;
  v && v instanceof bi && (v = v.el), v = !v || v === document || v === window || v === document.body || ((C = d(this, ts)) == null ? void 0 : C.el) && v instanceof Node && !d(this, ts).el.contains(v) ? d(this, gh) ?? ((D = this.getPlayer()) == null ? void 0 : D.el) : v ?? d(this, gh), d(this, ts) ? s === "media-play-request" && !d(this, ts).state.canLoad ? v == null || v.dispatchEvent(h) : d(this, ts).canPlayQueue.enqueue(s, () => v == null ? void 0 : v.dispatchEvent(h)) : v == null || v.dispatchEvent(h);
}, FB = function(s) {
};
var cw = VB;
function VB(f, s, n) {
  var o = null, h = null, v = n && n.leading, y = n && n.trailing;
  v == null && (v = !0), y == null && (y = !v), v == !0 && (y = !1);
  var C = function() {
    o && (clearTimeout(o), o = null);
  }, D = function() {
    var _ = h;
    C(), _ && _();
  }, $ = function() {
    var _ = v && !o, A = this, B = arguments;
    if (h = function() {
      return f.apply(A, B);
    }, o || (o = setTimeout(function() {
      if (o = null, y)
        return h();
    }, s)), _)
      return _ = !1, h();
  };
  return $.cancel = C, $.flush = D, $;
}
var ri;
class HB {
  constructor() {
    Z(this, "playerId", "vds-player");
    Z(this, "mediaId", null);
    R(this, ri, {
      volume: null,
      muted: null,
      audioGain: null,
      time: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null
    });
    Z(this, "saveTimeThrottled", cw(this.saveTime.bind(this), 1e3));
  }
  async getVolume() {
    return d(this, ri).volume;
  }
  async setVolume(s) {
    d(this, ri).volume = s, this.save();
  }
  async getMuted() {
    return d(this, ri).muted;
  }
  async setMuted(s) {
    d(this, ri).muted = s, this.save();
  }
  async getTime() {
    return d(this, ri).time;
  }
  async setTime(s, n) {
    const o = s < 0;
    d(this, ri).time = o ? null : s, o || n ? this.saveTime() : this.saveTimeThrottled();
  }
  async getLang() {
    return d(this, ri).lang;
  }
  async setLang(s) {
    d(this, ri).lang = s, this.save();
  }
  async getCaptions() {
    return d(this, ri).captions;
  }
  async setCaptions(s) {
    d(this, ri).captions = s, this.save();
  }
  async getPlaybackRate() {
    return d(this, ri).rate;
  }
  async setPlaybackRate(s) {
    d(this, ri).rate = s, this.save();
  }
  async getAudioGain() {
    return d(this, ri).audioGain;
  }
  async setAudioGain(s) {
    d(this, ri).audioGain = s, this.save();
  }
  async getVideoQuality() {
    return d(this, ri).quality;
  }
  async setVideoQuality(s) {
    d(this, ri).quality = s, this.save();
  }
  onChange(s, n, o = "vds-player") {
    const h = o ? localStorage.getItem(o) : null, v = n ? localStorage.getItem(n) : null;
    this.playerId = o, this.mediaId = n, L(this, ri, {
      volume: null,
      muted: null,
      audioGain: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null,
      ...h ? JSON.parse(h) : {},
      time: v ? +v : null
    });
  }
  save() {
    if (!this.playerId) return;
    const s = JSON.stringify({ ...d(this, ri), time: void 0 });
    localStorage.setItem(this.playerId, s);
  }
  saveTime() {
    if (!this.mediaId) return;
    const s = (d(this, ri).time ?? 0).toString();
    localStorage.setItem(this.mediaId, s);
  }
}
ri = new WeakMap();
const IB = Symbol(0), qB = Symbol(0), jB = Symbol(0), BB = Symbol(0), QB = Symbol(0), YB = Symbol(0), GB = Symbol(0), WB = Symbol(0), KB = Symbol(0), at = {
  add: IB,
  remove: qB,
  reset: jB,
  select: BB,
  readonly: QB,
  setReadonly: YB,
  onReset: GB,
  onRemove: WB,
  onUserSelect: KB
};
var kP;
class r_ extends UP {
  constructor() {
    super(...arguments);
    Z(this, "items", []);
    /** @internal */
    Z(this, kP, !1);
  }
  get length() {
    return this.items.length;
  }
  get readonly() {
    return this[at.readonly];
  }
  /**
   * Returns the index of the first occurrence of the given item, or -1 if it is not present.
   */
  indexOf(n) {
    return this.items.indexOf(n);
  }
  /**
   * Returns an item matching the given `id`, or `null` if not present.
   */
  getById(n) {
    return n === "" ? null : this.items.find((o) => o.id === n) ?? null;
  }
  /**
   * Transform list to an array.
   */
  toArray() {
    return [...this.items];
  }
  [(kP = at.readonly, Symbol.iterator)]() {
    return this.items.values();
  }
  /** @internal */
  [at.add](n, o) {
    const h = this.items.length;
    "" + h in this || Object.defineProperty(this, h, {
      get() {
        return this.items[h];
      }
    }), !this.items.includes(n) && (this.items.push(n), this.dispatchEvent(new yt("add", { detail: n, trigger: o })));
  }
  /** @internal */
  [at.remove](n, o) {
    var v;
    const h = this.items.indexOf(n);
    h >= 0 && ((v = this[at.onRemove]) == null || v.call(this, n, o), this.items.splice(h, 1), this.dispatchEvent(new yt("remove", { detail: n, trigger: o })));
  }
  /** @internal */
  [at.reset](n) {
    var o;
    for (const h of [...this.items]) this[at.remove](h, n);
    this.items = [], this[at.setReadonly](!1, n), (o = this[at.onReset]) == null || o.call(this);
  }
  /** @internal */
  [at.setReadonly](n, o) {
    this[at.readonly] !== n && (this[at.readonly] = n, this.dispatchEvent(new yt("readonly-change", { detail: n, trigger: o })));
  }
}
const ZS = Symbol(0);
class a_ extends r_ {
  get selected() {
    return this.items.find((s) => s.selected) ?? null;
  }
  get selectedIndex() {
    return this.items.findIndex((s) => s.selected);
  }
  /** @internal */
  [at.onRemove](s, n) {
    this[at.select](s, !1, n);
  }
  /** @internal */
  [at.add](s, n) {
    s[ZS] = !1, Object.defineProperty(s, "selected", {
      get() {
        return this[ZS];
      },
      set: (o) => {
        var h;
        this.readonly || ((h = this[at.onUserSelect]) == null || h.call(this), this[at.select](s, o));
      }
    }), super[at.add](s, n);
  }
  /** @internal */
  [at.select](s, n, o) {
    if (n === (s == null ? void 0 : s[ZS])) return;
    const h = this.selected;
    s && (s[ZS] = n), (n ? h !== s : h === s) && (h && (h[ZS] = !1), this.dispatchEvent(
      new yt("change", {
        detail: {
          prev: h,
          current: this.selected
        },
        trigger: o
      })
    ));
  }
}
class XB extends a_ {
}
function Na(f, s = 2) {
  return Number(f.toFixed(s));
}
function PR(f) {
  var s;
  return ((s = String(f).split(".")[1]) == null ? void 0 : s.length) ?? 0;
}
function VM(f, s, n) {
  return Math.max(f, Math.min(n, s));
}
function qA(f, s) {
  const n = s.composedPath()[0];
  return Zj(n) && f.contains(n);
}
const _R = /* @__PURE__ */ new Set();
{
  let f = function() {
    for (const s of _R)
      try {
        s();
      } catch {
      }
    window.requestAnimationFrame(f);
  };
  f();
}
function ZB(f) {
  return _R.add(f), () => _R.delete(f);
}
function Wi(f, s, n) {
  f.hasAttribute(s) || f.setAttribute(s, n);
}
function JB(f, s) {
  if (f.hasAttribute("aria-label") || f.hasAttribute("data-no-label")) return;
  if (!ls(s)) {
    ht(f, "aria-label", s);
    return;
  }
  function n() {
    ht(f, "aria-label", s());
  }
  J(n);
}
function s_(f) {
  const s = getComputedStyle(f);
  return s.display !== "none" && parseInt(s.opacity) > 0;
}
function e5(f) {
  return !!f && ("checkVisibility" in f ? f.checkVisibility({ checkOpacity: !0, checkVisibilityCSS: !0 }) : s_(f));
}
function l_(f, s) {
  return ZB(() => s(e5(f)));
}
function o_(f, s, n) {
  for (; s; ) {
    if (s === f)
      return !0;
    if (n != null && n(s))
      break;
    s = s.parentElement;
  }
  return !1;
}
function vy(f, s) {
  return new gn(f).add("pointerup", (n) => {
    n.button === 0 && !n.defaultPrevented && s(n);
  }).add("keydown", (n) => {
    zP(n) && s(n);
  });
}
function u_(f) {
  return Kj(f) && (f.touches.length > 1 || f.changedTouches.length > 1);
}
function t5(f) {
  return getComputedStyle(f).animationName !== "none";
}
function JC(f) {
  return f instanceof HTMLElement;
}
var fT, Lu, hT, id, zs, c_, d_, NR, UR;
class n5 {
  constructor() {
    R(this, zs);
    Z(this, "priority", 0);
    R(this, fT, !0);
    R(this, Lu, null);
    R(this, hT, null);
    R(this, id, /* @__PURE__ */ new Set());
  }
  canRender(s, n) {
    return !!n;
  }
  attach(s) {
    L(this, Lu, s), s && (s.textTracks.onchange = S(this, zs, UR).bind(this));
  }
  addTrack(s) {
    d(this, id).add(s), S(this, zs, c_).call(this, s);
  }
  removeTrack(s) {
    var n, o;
    (o = (n = s[tt.native]) == null ? void 0 : n.remove) == null || o.call(n), s[tt.native] = null, d(this, id).delete(s);
  }
  changeTrack(s) {
    const n = s == null ? void 0 : s[tt.native];
    n && n.track.mode !== "showing" && (n.track.mode = "showing"), L(this, hT, s);
  }
  setDisplay(s) {
    L(this, fT, s), S(this, zs, UR).call(this);
  }
  detach() {
    d(this, Lu) && (d(this, Lu).textTracks.onchange = null);
    for (const s of d(this, id)) this.removeTrack(s);
    d(this, id).clear(), L(this, Lu, null), L(this, hT, null);
  }
}
fT = new WeakMap(), Lu = new WeakMap(), hT = new WeakMap(), id = new WeakMap(), zs = new WeakSet(), c_ = function(s) {
  var o;
  if (!d(this, Lu)) return;
  const n = s[o = tt.native] ?? (s[o] = S(this, zs, d_).call(this, s));
  JC(n) && (d(this, Lu).append(n), n.track.mode = n.default ? "showing" : "disabled");
}, d_ = function(s) {
  const n = document.createElement("track"), o = s.default || s.mode === "showing", h = s.src && s.type === "vtt";
  return n.id = s.id, n.src = h ? s.src : "", n.label = s.label, n.kind = s.kind, n.default = o, s.language && (n.srclang = s.language), o && !h && S(this, zs, NR).call(this, s, n.track), n;
}, NR = function(s, n) {
  var o;
  if (!(s.src && s.type === "vtt" || (o = n.cues) != null && o.length))
    for (const h of s.cues) n.addCue(h);
}, UR = function(s) {
  for (const n of d(this, id)) {
    const o = n[tt.native];
    if (!o) continue;
    if (!d(this, fT)) {
      o.track.mode = o.managed ? "hidden" : "disabled";
      continue;
    }
    const h = o.track.mode === "showing";
    h && S(this, zs, NR).call(this, n, o.track), n.setMode(h ? "showing" : "disabled", s);
  }
};
var Sh, gv, Th, pT, mT, ns, so, pi, f_, zR, h_, p_, m_, sv, v_;
class i5 {
  constructor(s) {
    R(this, pi);
    R(this, Sh, null);
    R(this, gv);
    R(this, Th, []);
    R(this, pT);
    R(this, mT, !1);
    R(this, ns, null);
    R(this, so, null);
    L(this, pT, s);
    const n = s.textTracks;
    L(this, gv, n), J(S(this, pi, f_).bind(this)), Wt(S(this, pi, v_).bind(this)), new gn(n).add("add", S(this, pi, p_).bind(this)).add("remove", S(this, pi, m_).bind(this)).add("mode-change", S(this, pi, sv).bind(this));
  }
  add(s) {
    d(this, Th).push(s), py(S(this, pi, sv).bind(this));
  }
  remove(s) {
    s.detach(), d(this, Th).splice(d(this, Th).indexOf(s), 1), py(S(this, pi, sv).bind(this));
  }
  /** @internal */
  attachVideo(s) {
    requestAnimationFrame(() => {
      if (L(this, Sh, s), s) {
        L(this, ns, new n5()), d(this, ns).attach(s);
        for (const n of d(this, gv)) S(this, pi, zR).call(this, n);
      }
      S(this, pi, sv).call(this);
    });
  }
}
Sh = new WeakMap(), gv = new WeakMap(), Th = new WeakMap(), pT = new WeakMap(), mT = new WeakMap(), ns = new WeakMap(), so = new WeakMap(), pi = new WeakSet(), f_ = function() {
  const { nativeControls: s } = d(this, pT).$state;
  L(this, mT, s()), S(this, pi, sv).call(this);
}, zR = function(s) {
  var n;
  _a(s) && ((n = d(this, ns)) == null || n.addTrack(s));
}, h_ = function(s) {
  var n;
  _a(s) && ((n = d(this, ns)) == null || n.removeTrack(s));
}, p_ = function(s) {
  S(this, pi, zR).call(this, s.detail);
}, m_ = function(s) {
  S(this, pi, h_).call(this, s.detail);
}, sv = function() {
  var o, h, v, y, C, D, $;
  const s = d(this, gv).selected;
  if (d(this, Sh) && (d(this, mT) || s != null && s[tt.nativeHLS])) {
    (o = d(this, so)) == null || o.changeTrack(null), (h = d(this, ns)) == null || h.setDisplay(!0), (v = d(this, ns)) == null || v.changeTrack(s);
    return;
  }
  if ((y = d(this, ns)) == null || y.setDisplay(!1), (C = d(this, ns)) == null || C.changeTrack(null), !s) {
    (D = d(this, so)) == null || D.changeTrack(null);
    return;
  }
  const n = d(this, Th).sort((_, A) => _.priority - A.priority).find((_) => _.canRender(s, d(this, Sh)));
  d(this, so) !== n && (($ = d(this, so)) == null || $.detach(), n == null || n.attach(d(this, Sh)), L(this, so, n ?? null)), n == null || n.changeTrack(s);
}, v_ = function() {
  var s, n;
  (s = d(this, ns)) == null || s.detach(), L(this, ns, null), (n = d(this, so)) == null || n.detach(), L(this, so, null);
};
var HM = r5;
function r5(f, s, n) {
  var o = null, h = null, v = function() {
    o && (clearTimeout(o), h = null, o = null);
  }, y = function() {
    var D = h;
    v(), D && D();
  }, C = function() {
    if (!s)
      return f.apply(this, arguments);
    var D = this, $ = arguments, _ = n && !o;
    if (v(), h = function() {
      f.apply(D, $);
    }, o = setTimeout(function() {
      if (o = null, !_) {
        var A = h;
        return h = null, A();
      }
    }, s), _)
      return h();
  };
  return C.cancel = v, C.flush = y, C;
}
var xP, wh, lo, oo, uo, vT, Sv, yT, bo, y_, FR, VR;
class a5 extends r_ {
  constructor() {
    super();
    R(this, bo);
    R(this, wh, !1);
    R(this, lo, {});
    R(this, oo, null);
    R(this, uo, null);
    /** @internal */
    Z(this, xP);
    R(this, vT, HM(async () => {
      var h;
      if (!d(this, wh)) return;
      !d(this, uo) && d(this, oo) && L(this, uo, await d(this, oo).getLang());
      const n = await ((h = d(this, oo)) == null ? void 0 : h.getCaptions()), o = [
        ["captions", "subtitles"],
        "chapters",
        "descriptions",
        "metadata"
      ];
      for (const v of o) {
        const y = this.getByKind(v);
        if (y.find((A) => A.mode === "showing")) continue;
        const C = d(this, uo) ? y.find((A) => A.language === d(this, uo)) : null, D = Vr(v) ? d(this, lo)[v.find((A) => d(this, lo)[A]) || ""] : d(this, lo)[v], $ = C ?? D, _ = $ && _a($);
        $ && (!_ || n !== !1) && ($.mode = "showing", _ && S(this, bo, FR).call(this, $));
      }
    }, 300));
    R(this, Sv, null);
    R(this, yT, S(this, bo, y_).bind(this));
  }
  get selected() {
    return this.items.find((o) => o.mode === "showing" && _a(o)) ?? null;
  }
  get selectedIndex() {
    const n = this.selected;
    return n ? this.indexOf(n) : -1;
  }
  get preferredLang() {
    return d(this, uo);
  }
  set preferredLang(n) {
    L(this, uo, n), S(this, bo, VR).call(this, n);
  }
  add(n, o) {
    const h = n instanceof Ud, v = h ? n : new Ud(n), y = n.kind === "captions" || n.kind === "subtitles" ? "captions" : n.kind;
    return d(this, lo)[y] && n.default && delete n.default, v.addEventListener("mode-change", d(this, yT)), this[at.add](v, o), v[tt.crossOrigin] = this[tt.crossOrigin], d(this, wh) && v[tt.canLoad](), n.default && (d(this, lo)[y] = v), d(this, vT).call(this), this;
  }
  remove(n, o) {
    if (L(this, Sv, n), !!this.items.includes(n))
      return n === d(this, lo)[n.kind] && delete d(this, lo)[n.kind], n.mode = "disabled", n[tt.onModeChange] = null, n.removeEventListener("mode-change", d(this, yT)), this[at.remove](n, o), L(this, Sv, null), this;
  }
  clear(n) {
    for (const o of [...this.items])
      this.remove(o, n);
    return this;
  }
  getByKind(n) {
    const o = Array.isArray(n) ? n : [n];
    return this.items.filter((h) => o.includes(h.kind));
  }
  /** @internal */
  [(xP = tt.crossOrigin, tt.canLoad)]() {
    if (!d(this, wh)) {
      for (const n of this.items) n[tt.canLoad]();
      L(this, wh, !0), d(this, vT).call(this);
    }
  }
  setStorage(n) {
    L(this, oo, n);
  }
}
wh = new WeakMap(), lo = new WeakMap(), oo = new WeakMap(), uo = new WeakMap(), vT = new WeakMap(), Sv = new WeakMap(), yT = new WeakMap(), bo = new WeakSet(), y_ = function(n) {
  const o = n.detail;
  if (d(this, oo) && _a(o) && o !== d(this, Sv) && S(this, bo, FR).call(this, o), o.mode === "showing") {
    const h = _a(o) ? ["captions", "subtitles"] : [o.kind];
    for (const v of this.items)
      v.mode === "showing" && v != o && h.includes(v.kind) && (v.mode = "disabled");
  }
  this.dispatchEvent(
    new yt("mode-change", {
      detail: n.detail,
      trigger: n
    })
  );
}, FR = function(n) {
  var o, h;
  n.mode !== "disabled" && S(this, bo, VR).call(this, n.language), (h = (o = d(this, oo)) == null ? void 0 : o.setCaptions) == null || h.call(
    o,
    this.items.some((v) => _a(v) && v.mode === "showing")
  );
}, VR = function(n) {
  var o, h;
  (h = (o = d(this, oo)) == null ? void 0 : o.setLang) == null || h.call(o, L(this, uo, n));
};
const s5 = Symbol(0), l5 = Symbol(0), la = {
  setAuto: s5,
  enableAuto: l5
};
var RP, Eh;
class o5 extends a_ {
  constructor() {
    super(...arguments);
    R(this, Eh, !1);
    /**
     * Configures quality switching:
     *
     * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
     * request if any, flush the whole buffer, and fetch fragment matching with current position
     * and requested quality level.
     *
     * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
     * already buffered next fragment.
     *
     * - `load`: Set quality level for next loaded fragment.
     *
     * @see {@link https://www.vidstack.io/docs/player/api/video-quality#switch}
     * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
     */
    Z(this, "switch", "current");
    /** @internal */
    Z(this, RP);
  }
  /**
   * Whether automatic quality selection is enabled.
   */
  get auto() {
    return d(this, Eh) || this.readonly;
  }
  /** @internal */
  [(RP = la.enableAuto, at.onUserSelect)]() {
    this[la.setAuto](!1);
  }
  /** @internal */
  [at.onReset](n) {
    this[la.enableAuto] = void 0, this[la.setAuto](!1, n);
  }
  /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */
  autoSelect(n) {
    var o;
    this.readonly || d(this, Eh) || !this[la.enableAuto] || ((o = this[la.enableAuto]) == null || o.call(this, n), this[la.setAuto](!0, n));
  }
  getBySrc(n) {
    return this.items.find((o) => o.src === n);
  }
  /** @internal */
  [la.setAuto](n, o) {
    d(this, Eh) !== n && (L(this, Eh, n), this.dispatchEvent(
      new yt("auto-change", {
        detail: n,
        trigger: o
      })
    ));
  }
}
Eh = new WeakMap();
function u5(f, s) {
  return [...f].sort(s ? d5 : c5);
}
function c5(f, s) {
  return f.height === s.height ? (f.bitrate ?? 0) - (s.bitrate ?? 0) : f.height - s.height;
}
function d5(f, s) {
  return s.height === f.height ? (s.bitrate ?? 0) - (f.bitrate ?? 0) : s.height - f.height;
}
function kQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "AUDIO";
}
function xQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "VIDEO";
}
function RQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "DASH";
}
function DQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "YOUTUBE";
}
function MQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "VIMEO";
}
function f5(f) {
  return f instanceof HTMLAudioElement;
}
function h5(f) {
  return f instanceof HTMLVideoElement;
}
function p5(f) {
  return f5(f) || h5(f);
}
class ap extends Hs {
}
const m5 = {
  togglePaused: "k Space",
  toggleMuted: "m",
  toggleFullscreen: "f",
  togglePictureInPicture: "i",
  toggleCaptions: "c",
  seekBackward: "j J ArrowLeft",
  seekForward: "l L ArrowRight",
  volumeUp: "ArrowUp",
  volumeDown: "ArrowDown",
  speedUp: ">",
  slowDown: "<"
}, eT = /* @__PURE__ */ new Set(["Shift", "Alt", "Meta", "Ctrl"]), v5 = 'button, [role="button"]', jA = 'input, textarea, select, [contenteditable], [role^="menuitem"], [role="timer"]';
var Yi, vi, g_, S_, T_, w_, CC, bh, E_, $u, HR, b_;
class y5 extends ap {
  constructor(n) {
    super();
    R(this, vi);
    R(this, Yi);
    R(this, bh);
    R(this, $u, null);
    L(this, Yi, n);
  }
  onConnect() {
    J(S(this, vi, g_).bind(this));
  }
}
Yi = new WeakMap(), vi = new WeakSet(), g_ = function() {
  const { keyDisabled: n, keyTarget: o } = this.$props;
  if (n()) return;
  const h = o() === "player" ? this.el : document, v = st(!1);
  h === this.el ? new gn(this.el).add("focusin", () => v.set(!0)).add("focusout", (y) => {
    this.el.contains(y.target) || v.set(!1);
  }) : (ye(v) || v.set(document.querySelector("[data-media-player]") === this.el), En(document, "focusin", (y) => {
    const C = y.composedPath().find((D) => D instanceof Element && D.localName === "media-player");
    C !== void 0 && v.set(this.el === C);
  })), J(() => {
    v() && new gn(h).add("keyup", S(this, vi, S_).bind(this)).add("keydown", S(this, vi, T_).bind(this)).add("keydown", S(this, vi, w_).bind(this), { capture: !0 });
  });
}, S_ = function(n) {
  var y, C;
  const o = document.activeElement;
  if (!n.key || !this.$state.canSeek() || o != null && o.matches(jA))
    return;
  let { method: h, value: v } = S(this, vi, CC).call(this, n);
  if (!Ze(v) && !Vr(v)) {
    (y = v == null ? void 0 : v.onKeyUp) == null || y.call(v, {
      event: n,
      player: d(this, Yi).player,
      remote: d(this, Yi).remote
    }), (C = v == null ? void 0 : v.callback) == null || C.call(v, n, d(this, Yi).remote);
    return;
  }
  if (h != null && h.startsWith("seek") && (n.preventDefault(), n.stopPropagation(), d(this, $u) ? (S(this, vi, HR).call(this, n, h === "seekForward"), L(this, $u, null)) : (d(this, Yi).remote.seek(d(this, bh), n), L(this, bh, void 0))), h != null && h.startsWith("volume")) {
    const D = this.el.querySelector("[data-media-volume-slider]");
    D == null || D.dispatchEvent(
      new KeyboardEvent("keyup", {
        key: h === "volumeUp" ? "Up" : "Down",
        shiftKey: n.shiftKey,
        trigger: n
      })
    );
  }
}, T_ = function(n) {
  var C, D, $, _;
  if (!n.key || eT.has(n.key)) return;
  const o = document.activeElement;
  if (o != null && o.matches(jA) || zP(n) && (o != null && o.matches(v5)))
    return;
  let { method: h, value: v } = S(this, vi, CC).call(this, n), y = !n.metaKey && /^[0-9]$/.test(n.key);
  if (!Ze(v) && !Vr(v) && !y) {
    (C = v == null ? void 0 : v.onKeyDown) == null || C.call(v, {
      event: n,
      player: d(this, Yi).player,
      remote: d(this, Yi).remote
    }), (D = v == null ? void 0 : v.callback) == null || D.call(v, n, d(this, Yi).remote);
    return;
  }
  if (!h && y && !T5(n)) {
    n.preventDefault(), n.stopPropagation(), d(this, Yi).remote.seek(this.$state.duration() / 10 * Number(n.key), n);
    return;
  }
  if (h) {
    switch (n.preventDefault(), n.stopPropagation(), h) {
      case "seekForward":
      case "seekBackward":
        S(this, vi, b_).call(this, n, h, h === "seekForward");
        break;
      case "volumeUp":
      case "volumeDown":
        const A = this.el.querySelector("[data-media-volume-slider]");
        if (A)
          A.dispatchEvent(
            new KeyboardEvent("keydown", {
              key: h === "volumeUp" ? "Up" : "Down",
              shiftKey: n.shiftKey,
              trigger: n
            })
          );
        else {
          const W = n.shiftKey ? 0.1 : 0.05;
          d(this, Yi).remote.changeVolume(
            this.$state.volume() + (h === "volumeUp" ? +W : -W),
            n
          );
        }
        break;
      case "toggleFullscreen":
        d(this, Yi).remote.toggleFullscreen("prefer-media", n);
        break;
      case "speedUp":
      case "slowDown":
        const B = this.$state.playbackRate();
        d(this, Yi).remote.changePlaybackRate(
          Math.max(0.25, Math.min(2, B + (h === "speedUp" ? 0.25 : -0.25))),
          n
        );
        break;
      default:
        (_ = ($ = d(this, Yi).remote)[h]) == null || _.call($, n);
    }
    this.$state.lastKeyboardAction.set({
      action: h,
      event: n
    });
  }
}, w_ = function(n) {
  p5(n.target) && S(this, vi, CC).call(this, n).method && n.preventDefault();
}, CC = function(n) {
  const o = {
    ...this.$props.keyShortcuts(),
    ...d(this, Yi).ariaKeys
  }, h = Object.keys(o).find((v) => {
    var $;
    const y = o[v], C = Vr(y) ? y.join(" ") : Ze(y) ? y : y == null ? void 0 : y.keys, D = ($ = Vr(C) ? C : C == null ? void 0 : C.split(" ")) == null ? void 0 : $.map(
      (_) => S5(_).replace(/Control/g, "Ctrl").split("+")
    );
    return D == null ? void 0 : D.some((_) => {
      const A = new Set(_.filter((B) => eT.has(B)));
      for (const B of eT) {
        const W = B.toLowerCase() + "Key";
        if (!A.has(B) && n[W])
          return !1;
      }
      return _.every((B) => eT.has(B) ? n[B.toLowerCase() + "Key"] : n.key === B.replace("Space", " "));
    });
  });
  return {
    method: h,
    value: h ? o[h] : null
  };
}, bh = new WeakMap(), E_ = function(n, o) {
  const h = n.shiftKey ? 10 : 5;
  return L(this, bh, Math.max(
    0,
    Math.min(
      (d(this, bh) ?? this.$state.currentTime()) + (o === "seekForward" ? +h : -h),
      this.$state.duration()
    )
  ));
}, $u = new WeakMap(), HR = function(n, o) {
  var h;
  (h = d(this, $u)) == null || h.dispatchEvent(
    new KeyboardEvent(n.type, {
      key: o ? "Right" : "Left",
      shiftKey: n.shiftKey,
      trigger: n
    })
  );
}, b_ = function(n, o, h) {
  this.$state.canSeek() && (d(this, $u) || L(this, $u, this.el.querySelector("[data-media-time-slider]")), d(this, $u) ? S(this, vi, HR).call(this, n, h) : d(this, Yi).remote.seeking(S(this, vi, E_).call(this, n, o), n));
};
const g5 = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];
function S5(f) {
  return f.replace(/Shift\+(\d)/g, (s, n) => g5[n - 1]);
}
function T5(f) {
  for (const s of eT)
    if (f[s.toLowerCase() + "Key"])
      return !0;
  return !1;
}
var Ch;
class w5 extends Hs {
  constructor(n) {
    super();
    R(this, Ch);
    L(this, Ch, n);
  }
  onAttach(n) {
    const { $props: o, ariaKeys: h } = Ua(), v = n.getAttribute("aria-keyshortcuts");
    if (v) {
      h[d(this, Ch)] = v, Wt(() => {
        delete h[d(this, Ch)];
      });
      return;
    }
    const y = o.keyShortcuts()[d(this, Ch)];
    if (y) {
      const C = Vr(y) ? y.join(" ") : Ze(y) ? y : y == null ? void 0 : y.keys;
      n.setAttribute("aria-keyshortcuts", Vr(C) ? C.join(" ") : C);
    }
  }
}
Ch = new WeakMap();
var Tv, Ou, gT, wv, rd, Ev, Qt, C_, k_, x_, R_, D_, M_, L_, $_, kC, IR, tT, qR;
class E5 extends ap {
  constructor() {
    super(...arguments);
    R(this, Qt);
    R(this, Tv, -2);
    R(this, Ou, !1);
    R(this, gT, st(!1));
    R(this, wv, st(!1));
    R(this, rd, null);
    R(this, Ev, st(!0));
    /**
     * The default amount of delay in milliseconds while media playback is progressing without user
     * activity to indicate an idle state (i.e., hide controls).
     *
     * @defaultValue 2000
     */
    Z(this, "defaultDelay", 2e3);
  }
  /**
   * Whether controls can hide after a delay in user interaction. If this is false, controls will
   * not hide and be user controlled.
   */
  get canIdle() {
    return d(this, Ev).call(this);
  }
  set canIdle(n) {
    d(this, Ev).set(n);
  }
  /**
   * Whether controls visibility should be toggled when the mouse enters and leaves the player
   * container.
   *
   * @defaultValue false
   */
  get hideOnMouseLeave() {
    const { hideControlsOnMouseLeave: n } = this.$props;
    return d(this, gT).call(this) || n();
  }
  set hideOnMouseLeave(n) {
    d(this, gT).set(n);
  }
  /**
   * Whether media controls are currently visible.
   */
  get showing() {
    return this.$state.controlsVisible();
  }
  /**
   * Show controls.
   */
  show(n = 0, o) {
    S(this, Qt, kC).call(this), d(this, Ou) || S(this, Qt, tT).call(this, !0, n, o);
  }
  /**
   * Hide controls.
   */
  hide(n = this.defaultDelay, o) {
    S(this, Qt, kC).call(this), d(this, Ou) || S(this, Qt, tT).call(this, !1, n, o);
  }
  /**
   * Whether all idle tracking on controls should be paused until resumed again.
   */
  pause(n) {
    L(this, Ou, !0), S(this, Qt, kC).call(this), S(this, Qt, tT).call(this, !0, 0, n);
  }
  resume(n) {
    L(this, Ou, !1), !this.$state.paused() && S(this, Qt, tT).call(this, !1, this.defaultDelay, n);
  }
  onConnect() {
    J(S(this, Qt, C_).bind(this));
  }
}
Tv = new WeakMap(), Ou = new WeakMap(), gT = new WeakMap(), wv = new WeakMap(), rd = new WeakMap(), Ev = new WeakMap(), Qt = new WeakSet(), C_ = function() {
  const { viewType: n } = this.$state;
  if (!this.el || !d(this, Ev).call(this)) return;
  if (n() === "audio") {
    this.show();
    return;
  }
  J(S(this, Qt, k_).bind(this)), J(S(this, Qt, x_).bind(this));
  const o = S(this, Qt, R_).bind(this), h = S(this, Qt, D_).bind(this), v = S(this, Qt, M_).bind(this);
  new gn(this.el).add("can-play", (y) => this.show(0, y)).add("play", o).add("pause", h).add("end", v).add("auto-play-fail", h);
}, k_ = function() {
  if (!this.el) return;
  const { started: n, pointer: o, paused: h } = this.$state;
  if (!n() || o() !== "fine") return;
  const v = new gn(this.el), y = this.hideOnMouseLeave;
  (!y || !d(this, wv).call(this)) && J(() => {
    h() || v.add("pointermove", S(this, Qt, IR).bind(this));
  }), y && v.add("mouseenter", S(this, Qt, L_).bind(this)).add("mouseleave", S(this, Qt, $_).bind(this));
}, x_ = function() {
  const { paused: n, started: o, autoPlayError: h } = this.$state;
  if (n() || h() && !o()) return;
  const v = S(this, Qt, IR).bind(this);
  J(() => {
    if (!this.el) return;
    const y = this.$state.pointer(), C = y === "coarse", D = new gn(this.el), $ = [C ? "touchend" : "pointerup", "keydown"];
    for (const _ of $)
      D.add(_, v, { passive: !1 });
  });
}, R_ = function(n) {
  n.triggers.hasType("ended") || (this.show(0, n), this.hide(void 0, n));
}, D_ = function(n) {
  this.show(0, n);
}, M_ = function(n) {
  const { loop: o } = this.$state;
  o() && this.hide(0, n);
}, L_ = function(n) {
  d(this, wv).set(!1), this.show(0, n), this.hide(void 0, n);
}, $_ = function(n) {
  d(this, wv).set(!0), this.hide(0, n);
}, kC = function() {
  window.clearTimeout(d(this, Tv)), L(this, Tv, -1);
}, IR = function(n) {
  var o;
  // @ts-expect-error
  n.MEDIA_GESTURE || d(this, Ou) || u_(n) || (D0(n) && (n.key === "Escape" ? ((o = this.el) == null || o.focus(), L(this, rd, null)) : d(this, rd) && (n.preventDefault(), requestAnimationFrame(() => {
    var h;
    (h = d(this, rd)) == null || h.focus(), L(this, rd, null);
  }))), this.show(0, n), this.hide(this.defaultDelay, n));
}, tT = function(n, o, h) {
  if (o === 0) {
    S(this, Qt, qR).call(this, n, h);
    return;
  }
  L(this, Tv, window.setTimeout(() => {
    this.scope && S(this, Qt, qR).call(this, n && !d(this, Ou), h);
  }, o));
}, qR = function(n, o) {
  var h;
  this.$state.controlsVisible() !== n && (this.$state.controlsVisible.set(n), !n && document.activeElement && ((h = this.el) != null && h.contains(document.activeElement)) && L(this, rd, document.activeElement), this.dispatch("controls-change", {
    detail: n,
    trigger: o
  }));
};
const jR = Jh.fullscreenEnabled;
var ad, bv, zd, O_, A_, P_;
class b5 extends Hs {
  constructor() {
    super(...arguments);
    R(this, zd);
    /**
     * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
     * listened to globally on the document so we need to know if they relate to the current host
     * element or not.
     */
    R(this, ad, !1);
    R(this, bv, !1);
  }
  get active() {
    return d(this, bv);
  }
  get supported() {
    return jR;
  }
  onConnect() {
    new gn(Jh).add("fullscreenchange", S(this, zd, A_).bind(this)).add("fullscreenerror", S(this, zd, P_).bind(this)), Wt(S(this, zd, O_).bind(this));
  }
  async enter() {
    try {
      return L(this, ad, !0), !this.el || gR(this.el) ? void 0 : (BA(), Jh.requestFullscreen(this.el));
    } catch (n) {
      throw L(this, ad, !1), n;
    }
  }
  async exit() {
    if (!(!this.el || !gR(this.el)))
      return BA(), Jh.exitFullscreen();
  }
}
ad = new WeakMap(), bv = new WeakMap(), zd = new WeakSet(), O_ = async function() {
  jR && await this.exit();
}, A_ = function(n) {
  const o = gR(this.el);
  o !== d(this, bv) && (o || L(this, ad, !1), L(this, bv, o), this.dispatch("fullscreen-change", { detail: o, trigger: n }));
}, P_ = function(n) {
  d(this, ad) && (this.dispatch("fullscreen-error", { detail: null, trigger: n }), L(this, ad, !1));
};
function gR(f) {
  if (Jh.fullscreenElement === f) return !0;
  try {
    return f.matches(
      // @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
      Jh.fullscreenPseudoClass
    );
  } catch {
    return !1;
  }
}
function BA() {
  if (!jR)
    throw Error(
      "[vidstack] no fullscreen API"
    );
}
var sd, Au, kh, os, __, BR, QR, YR;
const l0 = class l0 extends Hs {
  constructor() {
    super(...arguments);
    R(this, os);
    R(this, sd, st(S(this, os, YR).call(this)));
    R(this, Au, st(!1));
    R(this, kh);
  }
  /**
   * The current screen orientation type.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get type() {
    return d(this, sd).call(this);
  }
  /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get locked() {
    return d(this, Au).call(this);
  }
  /**
   * Whether the viewport is in a portrait orientation.
   *
   * @signal
   */
  get portrait() {
    return d(this, sd).call(this).startsWith("portrait");
  }
  /**
   * Whether the viewport is in a landscape orientation.
   *
   * @signal
   */
  get landscape() {
    return d(this, sd).call(this).startsWith("landscape");
  }
  /**
   * Whether the native Screen Orientation API is available.
   */
  get supported() {
    return l0.supported;
  }
  onConnect() {
    if (this.supported)
      En(screen.orientation, "change", S(this, os, BR).bind(this));
    else {
      const n = window.matchMedia("(orientation: landscape)");
      n.onchange = S(this, os, BR).bind(this), Wt(() => n.onchange = null);
    }
    Wt(S(this, os, __).bind(this));
  }
  /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async lock(n) {
    ye(d(this, Au)) || d(this, kh) === n || (S(this, os, QR).call(this), await screen.orientation.lock(n), d(this, Au).set(!0), L(this, kh, n));
  }
  /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async unlock() {
    ye(d(this, Au)) && (S(this, os, QR).call(this), L(this, kh, void 0), await screen.orientation.unlock(), d(this, Au).set(!1));
  }
};
sd = new WeakMap(), Au = new WeakMap(), kh = new WeakMap(), os = new WeakSet(), __ = async function() {
  this.supported && d(this, Au).call(this) && await this.unlock();
}, BR = function(n) {
  d(this, sd).set(S(this, os, YR).call(this)), this.dispatch("orientation-change", {
    detail: {
      orientation: ye(d(this, sd)),
      lock: d(this, kh)
    },
    trigger: n
  });
}, QR = function() {
  if (!this.supported)
    throw Error(
      "[vidstack] no orientation API"
    );
}, YR = function() {
  return this.supported ? window.screen.orientation.type : window.innerWidth >= window.innerHeight ? "landscape-primary" : "portrait-primary";
}, /**
 * Whether the native Screen Orientation API is available.
 */
Z(l0, "supported", QP());
let e0 = l0;
class C5 {
  constructor() {
    Z(this, "name", "audio");
    Z(this, "target");
  }
  canPlay(s) {
    return WP(s) ? !Ze(s.src) || s.type === "?" || YP(this.target, s.type) : !1;
  }
  mediaType() {
    return "audio";
  }
  async load(s) {
    return new (await import("./vidstack-audio-B1ai7_n3.js")).AudioProvider(this.target, s);
  }
}
class IM {
  constructor() {
    Z(this, "name", "video");
    Z(this, "target");
  }
  canPlay(s) {
    return KP(s) ? !Ze(s.src) || s.type === "?" || GP(this.target, s.type) : !1;
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    return new (await import("./vidstack-video-D76qkNcW.js")).VideoProvider(this.target, s);
  }
}
const o0 = class o0 extends IM {
  constructor() {
    super(...arguments);
    Z(this, "name", "hls");
  }
  canPlay(n) {
    return o0.supported && ky(n);
  }
  async load(n) {
    return new (await import("./vidstack-hls-CrUcpjme.js")).HLSProvider(this.target, n);
  }
};
Z(o0, "supported", NM());
let GR = o0, xC = null, t0 = [], n0 = [];
function qM() {
  return xC ?? (xC = new AudioContext());
}
function k5() {
  const f = qM(), s = f.createGain();
  return s.connect(f.destination), t0.push(s), s;
}
function x5(f, s) {
  const n = qM(), o = n.createMediaElementSource(f);
  return s && o.connect(s), n0.push(o), o;
}
function R5(f) {
  const s = t0.indexOf(f);
  s !== -1 && (t0.splice(s, 1), f.disconnect(), N_());
}
function D5(f) {
  const s = n0.indexOf(f);
  s !== -1 && (n0.splice(s, 1), f.disconnect(), N_());
}
function N_() {
  xC && t0.length === 0 && n0.length === 0 && xC.close().then(() => {
    xC = null;
  });
}
var ST, Cv, is, As, ip, U_, WR;
class LQ {
  constructor(s, n) {
    R(this, ip);
    R(this, ST);
    R(this, Cv);
    R(this, is, null);
    R(this, As, null);
    L(this, ST, s), L(this, Cv, n);
  }
  get currentGain() {
    var s, n;
    return ((n = (s = d(this, is)) == null ? void 0 : s.gain) == null ? void 0 : n.value) ?? null;
  }
  get supported() {
    return !0;
  }
  setGain(s) {
    const n = this.currentGain;
    if (s !== this.currentGain) {
      if (s === 1 && n !== 1) {
        this.removeGain();
        return;
      }
      d(this, is) || (L(this, is, k5()), d(this, As) && d(this, As).connect(d(this, is))), d(this, As) || L(this, As, x5(d(this, ST), d(this, is))), d(this, is).gain.value = s, d(this, Cv).call(this, s);
    }
  }
  removeGain() {
    d(this, is) && (d(this, As) && d(this, As).connect(qM().destination), S(this, ip, WR).call(this), d(this, Cv).call(this, null));
  }
  destroy() {
    S(this, ip, U_).call(this), S(this, ip, WR).call(this);
  }
}
ST = new WeakMap(), Cv = new WeakMap(), is = new WeakMap(), As = new WeakMap(), ip = new WeakSet(), U_ = function() {
  if (d(this, As))
    try {
      D5(d(this, As));
    } catch {
    } finally {
      L(this, As, null);
    }
}, WR = function() {
  if (d(this, is))
    try {
      R5(d(this, is));
    } catch {
    } finally {
      L(this, is, null);
    }
};
const M5 = ["focus", "blur", "visibilitychange", "pageshow", "pagehide"];
var xh, kv, TT, u0, z_;
class L5 {
  constructor() {
    R(this, u0);
    R(this, xh, st(QA()));
    R(this, kv, st(document.visibilityState));
    R(this, TT);
  }
  connect() {
    const s = new gn(window), n = S(this, u0, z_).bind(this);
    for (const o of M5)
      s.add(o, n);
    ZC && s.add("beforeunload", (o) => {
      L(this, TT, setTimeout(() => {
        o.defaultPrevented || o.returnValue.length > 0 || (d(this, xh).set("hidden"), d(this, kv).set("hidden"));
      }, 0));
    });
  }
  /**
   * The current page state. Important to note we only account for a subset of page states, as
   * the rest aren't valuable to the player at the moment.
   *
   * - **active:** A page is in the active state if it is visible and has input focus.
   * - **passive:** A page is in the passive state if it is visible and does not have input focus.
   * - **hidden:** A page is in the hidden state if it is not visible.
   *
   * @see https://developers.google.com/web/updates/2018/07/page-lifecycle-api#states
   */
  get pageState() {
    return d(this, xh).call(this);
  }
  /**
   * The current document visibility state.
   *
   * - **visible:** The page content may be at least partially visible. In practice, this means that
   * the page is the foreground tab of a non-minimized window.
   * - **hidden:** The page content is not visible to the user. In practice this means that the
   * document is either a background tab or part of a minimized window, or the OS screen lock is
   * active.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
   */
  get visibility() {
    return d(this, kv).call(this);
  }
}
xh = new WeakMap(), kv = new WeakMap(), TT = new WeakMap(), u0 = new WeakSet(), z_ = function(s) {
  ZC && window.clearTimeout(d(this, TT)), (s.type !== "blur" || d(this, xh).call(this) === "active") && (d(this, xh).set(QA(s)), d(this, kv).set(document.visibilityState == "hidden" ? "hidden" : "visible"));
};
function QA(f) {
  return (f == null ? void 0 : f.type) === "blur" || document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
var Pu, wT, ET, KR;
class jM {
  constructor(s) {
    R(this, ET);
    R(this, Pu);
    R(this, wT);
    L(this, wT, s);
  }
  start() {
    mi(d(this, Pu)) && S(this, ET, KR).call(this);
  }
  stop() {
    ss(d(this, Pu)) && window.cancelAnimationFrame(d(this, Pu)), L(this, Pu, void 0);
  }
}
Pu = new WeakMap(), wT = new WeakMap(), ET = new WeakSet(), KR = function() {
  L(this, Pu, window.requestAnimationFrame(() => {
    mi(d(this, Pu)) || (d(this, wT).call(this), S(this, ET, KR).call(this));
  }));
};
var bT, Rt, ld, xv, Rv, Rh, CT, Dv, K, jt, F_, Mv, Lv, V_, H_, I_, q_, c0, kM, ii, $5, ch, j_, XR, B_, Q_, Y_, RC, G_, W_, K_, X_, Z_, J_, eN, tN, nN, iN, rN, aN, sN, lN, oN, uN, cN, dN;
class $Q {
  constructor(s, n) {
    R(this, K);
    R(this, bT);
    R(this, Rt);
    R(this, ld, !1);
    R(this, xv, !1);
    R(this, Rv, !1);
    R(this, Rh, new jM(S(this, K, V_).bind(this)));
    R(this, CT, new L5());
    R(this, Dv);
    /**
     * The `timeupdate` event fires surprisingly infrequently during playback, meaning your progress
     * bar (or whatever else is synced to the currentTime) moves in a choppy fashion. This helps
     * resolve that by retrieving time updates in a request animation frame loop.
     */
    R(this, Mv, 0);
    R(this, Lv, -1);
    R(this, c0);
    R(this, kM);
    L(this, bT, s), L(this, Rt, n), L(this, Dv, new gn(s.media)), S(this, K, H_).call(this), d(this, CT).connect(), J(S(this, K, nN).bind(this)), Wt(S(this, K, F_).bind(this));
  }
}
bT = new WeakMap(), Rt = new WeakMap(), ld = new WeakMap(), xv = new WeakMap(), Rv = new WeakMap(), Rh = new WeakMap(), CT = new WeakMap(), Dv = new WeakMap(), K = new WeakSet(), jt = function() {
  return d(this, bT).media;
}, F_ = function() {
  var s;
  L(this, xv, !1), L(this, Rv, !1), d(this, Rh).stop(), d(this, Dv).abort(), (s = d(this, c0)) == null || s.clear();
}, Mv = new WeakMap(), Lv = new WeakMap(), V_ = function() {
  const s = d(this, K, jt).currentTime;
  !(ZC && s - d(this, Lv) < 0.35) && d(this, Mv) !== s && (S(this, K, ch).call(this, s), L(this, Mv, s));
}, H_ = function() {
  S(this, K, ii).call(this, "loadstart", S(this, K, j_)), S(this, K, ii).call(this, "abort", S(this, K, XR)), S(this, K, ii).call(this, "emptied", S(this, K, B_)), S(this, K, ii).call(this, "error", S(this, K, dN)), S(this, K, ii).call(this, "volumechange", S(this, K, aN));
}, I_ = function() {
  d(this, xv) || (S(this, K, ii).call(this, "loadeddata", S(this, K, Q_)), S(this, K, ii).call(this, "loadedmetadata", S(this, K, Y_)), S(this, K, ii).call(this, "canplay", S(this, K, K_)), S(this, K, ii).call(this, "canplaythrough", S(this, K, X_)), S(this, K, ii).call(this, "durationchange", S(this, K, rN)), S(this, K, ii).call(this, "play", S(this, K, G_)), S(this, K, ii).call(this, "progress", S(this, K, oN)), S(this, K, ii).call(this, "stalled", S(this, K, J_)), S(this, K, ii).call(this, "suspend", S(this, K, uN)), S(this, K, ii).call(this, "ratechange", S(this, K, cN)), L(this, xv, !0));
}, q_ = function() {
  d(this, Rv) || (S(this, K, ii).call(this, "pause", S(this, K, W_)), S(this, K, ii).call(this, "playing", S(this, K, Z_)), S(this, K, ii).call(this, "seeked", S(this, K, sN)), S(this, K, ii).call(this, "seeking", S(this, K, lN)), S(this, K, ii).call(this, "ended", S(this, K, tN)), S(this, K, ii).call(this, "waiting", S(this, K, eN)), L(this, Rv, !0));
}, c0 = new WeakMap(), kM = new WeakMap(), ii = function(s, n) {
  d(this, Dv).add(s, n.bind(this));
}, $5 = function(s) {
}, ch = function(s, n) {
  const o = Math.min(s, d(this, Rt).$state.seekableEnd());
  d(this, Rt).notify("time-change", o, n);
}, j_ = function(s) {
  if (d(this, K, jt).networkState === 3) {
    S(this, K, XR).call(this, s);
    return;
  }
  S(this, K, I_).call(this), d(this, Rt).notify("load-start", void 0, s);
}, XR = function(s) {
  d(this, Rt).notify("abort", void 0, s);
}, B_ = function() {
  d(this, Rt).notify("emptied", void 0, event);
}, Q_ = function(s) {
  d(this, Rt).notify("loaded-data", void 0, s);
}, Y_ = function(s) {
  L(this, Mv, 0), L(this, Lv, -1), S(this, K, q_).call(this), d(this, Rt).notify("loaded-metadata", void 0, s), ($0 || ZC && ky(d(this, Rt).$state.source())) && d(this, Rt).delegate.ready(S(this, K, RC).call(this), s);
}, RC = function() {
  return {
    provider: ye(d(this, Rt).$provider),
    duration: d(this, K, jt).duration,
    buffered: d(this, K, jt).buffered,
    seekable: d(this, K, jt).seekable
  };
}, G_ = function(s) {
  d(this, Rt).$state.canPlay && d(this, Rt).notify("play", void 0, s);
}, W_ = function(s) {
  d(this, K, jt).readyState === 1 && !d(this, ld) || (L(this, ld, !1), d(this, Rh).stop(), d(this, Rt).notify("pause", void 0, s));
}, K_ = function(s) {
  d(this, Rt).delegate.ready(S(this, K, RC).call(this), s);
}, X_ = function(s) {
  d(this, Rt).$state.started() || d(this, Rt).notify("can-play-through", S(this, K, RC).call(this), s);
}, Z_ = function(s) {
  d(this, K, jt).paused || (L(this, ld, !1), d(this, Rt).notify("playing", void 0, s), d(this, Rh).start());
}, J_ = function(s) {
  d(this, Rt).notify("stalled", void 0, s), d(this, K, jt).readyState < 3 && (L(this, ld, !0), d(this, Rt).notify("waiting", void 0, s));
}, eN = function(s) {
  d(this, K, jt).readyState < 3 && (L(this, ld, !0), d(this, Rt).notify("waiting", void 0, s));
}, tN = function(s) {
  d(this, Rh).stop(), S(this, K, ch).call(this, d(this, K, jt).duration, s), d(this, Rt).notify("end", void 0, s), d(this, Rt).$state.loop() && jj(d(this, K, jt).controls) && (d(this, K, jt).controls = !1);
}, nN = function() {
  const s = d(this, Rt).$state.paused(), n = d(this, CT).visibility === "hidden";
  (s || n) && En(d(this, K, jt), "timeupdate", S(this, K, iN).bind(this));
}, iN = function(s) {
  S(this, K, ch).call(this, d(this, K, jt).currentTime, s);
}, rN = function(s) {
  d(this, Rt).$state.ended() && S(this, K, ch).call(this, d(this, K, jt).duration, s), d(this, Rt).notify("duration-change", d(this, K, jt).duration, s);
}, aN = function(s) {
  const n = {
    volume: d(this, K, jt).volume,
    muted: d(this, K, jt).muted
  };
  d(this, Rt).notify("volume-change", n, s);
}, sN = function(s) {
  L(this, Lv, d(this, K, jt).currentTime), S(this, K, ch).call(this, d(this, K, jt).currentTime, s), d(this, Rt).notify("seeked", d(this, K, jt).currentTime, s), Math.trunc(d(this, K, jt).currentTime) === Math.trunc(d(this, K, jt).duration) && PR(d(this, K, jt).duration) > PR(d(this, K, jt).currentTime) && (S(this, K, ch).call(this, d(this, K, jt).duration, s), d(this, K, jt).ended || d(this, Rt).player.dispatch(
    new yt("media-play-request", {
      trigger: s
    })
  ));
}, lN = function(s) {
  d(this, Rt).notify("seeking", d(this, K, jt).currentTime, s);
}, oN = function(s) {
  const n = {
    buffered: d(this, K, jt).buffered,
    seekable: d(this, K, jt).seekable
  };
  d(this, Rt).notify("progress", n, s);
}, uN = function(s) {
  d(this, Rt).notify("suspend", void 0, s);
}, cN = function(s) {
  d(this, Rt).notify("rate-change", d(this, K, jt).playbackRate, s);
}, dN = function(s) {
  const n = d(this, K, jt).error;
  if (!n) return;
  const o = {
    message: n.message,
    code: n.code,
    mediaError: n
  };
  d(this, Rt).notify("error", o, s);
};
var kT, pl, Hi, lv, fN, hN, pN, ZR, mN;
class OQ {
  constructor(s, n) {
    R(this, Hi);
    R(this, kT);
    R(this, pl);
    L(this, kT, s), L(this, pl, n), d(this, Hi, lv).onaddtrack = S(this, Hi, fN).bind(this), d(this, Hi, lv).onremovetrack = S(this, Hi, hN).bind(this), d(this, Hi, lv).onchange = S(this, Hi, pN).bind(this), En(d(this, pl).audioTracks, "change", S(this, Hi, mN).bind(this));
  }
}
kT = new WeakMap(), pl = new WeakMap(), Hi = new WeakSet(), lv = function() {
  return d(this, kT).media.audioTracks;
}, fN = function(s) {
  const n = s.track;
  if (n.label === "") return;
  const o = n.id.toString() || `native-audio-${d(this, pl).audioTracks.length}`, h = {
    id: o,
    label: n.label,
    language: n.language,
    kind: n.kind,
    selected: !1
  };
  d(this, pl).audioTracks[at.add](h, s), n.enabled && (h.selected = !0);
}, hN = function(s) {
  const n = d(this, pl).audioTracks.getById(s.track.id);
  n && d(this, pl).audioTracks[at.remove](n, s);
}, pN = function(s) {
  let n = S(this, Hi, ZR).call(this);
  if (!n) return;
  const o = d(this, pl).audioTracks.getById(n.id);
  o && d(this, pl).audioTracks[at.select](o, !0, s);
}, ZR = function() {
  return Array.from(d(this, Hi, lv)).find((s) => s.enabled);
}, mN = function(s) {
  const { current: n } = s.detail;
  if (!n) return;
  const o = d(this, Hi, lv).getTrackById(n.id);
  if (o) {
    const h = S(this, Hi, ZR).call(this);
    h && (h.enabled = !1), o.enabled = !0;
  }
};
var Ps, xT, RT, Dh, Fd, vN, yN, gN;
class O5 {
  constructor(s, n) {
    R(this, Fd);
    R(this, Ps);
    R(this, xT);
    R(this, RT);
    R(this, Dh, st(!1));
    L(this, Ps, s), L(this, xT, n), S(this, Fd, vN).call(this);
  }
  get supported() {
    return d(this, Dh).call(this);
  }
  async prompt() {
    if (!this.supported) throw Error("Not supported on this platform.");
    return this.type === "airplay" && d(this, Ps).webkitShowPlaybackTargetPicker ? d(this, Ps).webkitShowPlaybackTargetPicker() : d(this, Ps).remote.prompt();
  }
}
Ps = new WeakMap(), xT = new WeakMap(), RT = new WeakMap(), Dh = new WeakMap(), Fd = new WeakSet(), vN = function() {
  var s;
  !((s = d(this, Ps)) != null && s.remote) || !this.canPrompt || (d(this, Ps).remote.watchAvailability((n) => {
    d(this, Dh).set(n);
  }).catch(() => {
    d(this, Dh).set(!1);
  }), J(S(this, Fd, yN).bind(this)));
}, yN = function() {
  if (!d(this, Dh).call(this)) return;
  const s = ["connecting", "connect", "disconnect"], n = S(this, Fd, gN).bind(this);
  n(), En(d(this, Ps), "playing", n);
  const o = new gn(d(this, Ps).remote);
  for (const h of s)
    o.add(h, n);
}, gN = function(s) {
  const n = d(this, Ps).remote.state;
  if (n === d(this, RT)) return;
  const o = { type: this.type, state: n };
  d(this, xT).notify("remote-playback-change", o, s), L(this, RT, n);
};
class AQ extends O5 {
  constructor() {
    super(...arguments);
    Z(this, "type", "airplay");
  }
  get canPrompt() {
    return "WebKitPlaybackTargetAvailabilityEvent" in window;
  }
}
var $v, Ov, yy, SN, TN;
class PQ {
  constructor(s, n) {
    R(this, yy);
    R(this, $v);
    R(this, Ov);
    L(this, $v, s), L(this, Ov, n), s.textTracks.onaddtrack = S(this, yy, SN).bind(this), Wt(S(this, yy, TN).bind(this));
  }
}
$v = new WeakMap(), Ov = new WeakMap(), yy = new WeakSet(), SN = function(s) {
  const n = s.track;
  if (!n || A5(d(this, $v), n)) return;
  const o = new Ud({
    id: n.id,
    kind: n.kind,
    label: n.label ?? "",
    language: n.language,
    type: "vtt"
  });
  o[tt.native] = { track: n }, o[tt.readyState] = 2, o[tt.nativeHLS] = !0;
  let h = 0;
  const v = (y) => {
    if (n.cues)
      for (let C = h; C < n.cues.length; C++)
        o.addCue(n.cues[C], y), h++;
  };
  v(s), n.oncuechange = v, d(this, Ov).textTracks.add(o, s), o.setMode(n.mode, s);
}, TN = function() {
  var s;
  d(this, $v).textTracks.onaddtrack = null;
  for (const n of d(this, Ov).textTracks) {
    const o = (s = n[tt.native]) == null ? void 0 : s.track;
    o != null && o.oncuechange && (o.oncuechange = null);
  }
};
function A5(f, s) {
  return Array.from(f.children).find((n) => n.track === s);
}
var Mh, DT, gy, wN, EN, MT;
class _Q {
  constructor(s, n) {
    R(this, gy);
    R(this, Mh);
    R(this, DT);
    R(this, MT, (s, n) => {
      d(this, DT).notify("picture-in-picture-change", s, n);
    });
    L(this, Mh, s), L(this, DT, n), new gn(s).add("enterpictureinpicture", S(this, gy, wN).bind(this)).add("leavepictureinpicture", S(this, gy, EN).bind(this));
  }
  get active() {
    return document.pictureInPictureElement === d(this, Mh);
  }
  get supported() {
    return fB(d(this, Mh));
  }
  async enter() {
    return d(this, Mh).requestPictureInPicture();
  }
  exit() {
    return document.exitPictureInPicture();
  }
}
Mh = new WeakMap(), DT = new WeakMap(), gy = new WeakSet(), wN = function(s) {
  d(this, MT).call(this, !0, s);
}, EN = function(s) {
  d(this, MT).call(this, !1, s);
}, MT = new WeakMap();
var Lh, Av, co, d0, bN;
class NQ {
  constructor(s, n) {
    R(this, d0);
    R(this, Lh);
    R(this, Av);
    R(this, co, "inline");
    L(this, Lh, s), L(this, Av, n), En(s, "webkitpresentationmodechanged", S(this, d0, bN).bind(this));
  }
  get mode() {
    return d(this, co);
  }
  get supported() {
    return hB(d(this, Lh));
  }
  async setPresentationMode(s) {
    d(this, co) !== s && d(this, Lh).webkitSetPresentationMode(s);
  }
}
Lh = new WeakMap(), Av = new WeakMap(), co = new WeakMap(), d0 = new WeakSet(), bN = function(s) {
  var o;
  const n = d(this, co);
  L(this, co, d(this, Lh).webkitPresentationMode), (o = d(this, Av).player) == null || o.dispatch(
    new yt("video-presentation-change", {
      detail: d(this, co),
      trigger: s
    })
  ), ["fullscreen", "picture-in-picture"].forEach((h) => {
    (d(this, co) === h || n === h) && d(this, Av).notify(`${h}-change`, d(this, co) === h, s);
  });
};
var od;
class UQ {
  constructor(s) {
    R(this, od);
    L(this, od, s);
  }
  get active() {
    return d(this, od).mode === "fullscreen";
  }
  get supported() {
    return d(this, od).supported;
  }
  async enter() {
    d(this, od).setPresentationMode("fullscreen");
  }
  async exit() {
    d(this, od).setPresentationMode("inline");
  }
}
od = new WeakMap();
var ud;
class zQ {
  constructor(s) {
    R(this, ud);
    L(this, ud, s);
  }
  get active() {
    return d(this, ud).mode === "picture-in-picture";
  }
  get supported() {
    return d(this, ud).supported;
  }
  async enter() {
    d(this, ud).setPresentationMode("picture-in-picture");
  }
  async exit() {
    d(this, ud).setPresentationMode("inline");
  }
}
ud = new WeakMap();
function YA(f) {
  try {
    return new Intl.DisplayNames(navigator.languages, { type: "language" }).of(f) ?? null;
  } catch {
    return null;
  }
}
const P5 = (f) => `dash-${M0(f)}`;
var cd, cn, vt, Pv, _v, Be, dh, CN, kN, xN, _u, Nv, RN, DN, MN, LN, $N, ON, AN, PN, dd, _N, DC, JR, NN, eD, UN, zN, tD;
class FQ {
  constructor(s, n) {
    R(this, Be);
    R(this, cd);
    R(this, cn);
    R(this, vt, null);
    R(this, Pv, /* @__PURE__ */ new Set());
    R(this, _v, null);
    Z(this, "config", {});
    R(this, _u, null);
    R(this, Nv, {});
    R(this, dd, -1);
    L(this, cd, s), L(this, cn, n);
  }
  get instance() {
    return d(this, vt);
  }
  setup(s) {
    L(this, vt, s().create());
    const n = S(this, Be, xN).bind(this);
    for (const o of Object.values(s.events)) d(this, vt).on(o, n);
    d(this, vt).on(s.events.ERROR, S(this, Be, ON).bind(this));
    for (const o of d(this, Pv)) o(d(this, vt));
    d(this, cn).player.dispatch("dash-instance", {
      detail: d(this, vt)
    }), d(this, vt).initialize(d(this, cd), void 0, !1), d(this, vt).updateSettings({
      streaming: {
        text: {
          // Disabling text rendering by dash.
          defaultEnabled: !1,
          dispatchForManualRendering: !0
        },
        buffer: {
          /// Enables buffer replacement when switching bitrates for faster switching.
          fastSwitchEnabled: !0
        }
      },
      ...this.config
    }), d(this, vt).on(s.events.FRAGMENT_LOADING_STARTED, S(this, Be, AN).bind(this)), d(this, vt).on(
      s.events.FRAGMENT_LOADING_COMPLETED,
      S(this, Be, PN).bind(this)
    ), d(this, vt).on(s.events.MANIFEST_LOADED, S(this, Be, $N).bind(this)), d(this, vt).on(s.events.QUALITY_CHANGE_RENDERED, S(this, Be, LN).bind(this)), d(this, vt).on(s.events.TEXT_TRACKS_ADDED, S(this, Be, DN).bind(this)), d(this, vt).on(s.events.TRACK_CHANGE_RENDERED, S(this, Be, MN).bind(this)), d(this, cn).qualities[la.enableAuto] = S(this, Be, NN).bind(this), En(d(this, cn).qualities, "change", S(this, Be, UN).bind(this)), En(d(this, cn).audioTracks, "change", S(this, Be, zN).bind(this)), L(this, _v, J(S(this, Be, CN).bind(this)));
  }
  onInstance(s) {
    return d(this, Pv).add(s), () => d(this, Pv).delete(s);
  }
  loadSource(s) {
    var n;
    S(this, Be, tD).call(this), Ze(s.src) && ((n = d(this, vt)) == null || n.attachSource(s.src));
  }
  destroy() {
    var s, n;
    S(this, Be, tD).call(this), (s = d(this, vt)) == null || s.destroy(), L(this, vt, null), (n = d(this, _v)) == null || n.call(this), L(this, _v, null);
  }
}
cd = new WeakMap(), cn = new WeakMap(), vt = new WeakMap(), Pv = new WeakMap(), _v = new WeakMap(), Be = new WeakSet(), dh = function(s) {
  return new yt(P5(s.type), { detail: s });
}, CN = function() {
  if (!d(this, cn).$state.live()) return;
  const s = new jM(S(this, Be, kN).bind(this));
  return s.start(), s.stop.bind(s);
}, kN = function() {
  if (!d(this, vt)) return;
  const s = d(this, vt).duration() - d(this, vt).time();
  d(this, cn).$state.liveSyncPosition.set(isNaN(s) ? 1 / 0 : s);
}, xN = function(s) {
  var n;
  (n = d(this, cn).player) == null || n.dispatch(S(this, Be, dh).call(this, s));
}, _u = new WeakMap(), Nv = new WeakMap(), RN = function(s) {
  var C;
  const n = (C = d(this, _u)) == null ? void 0 : C[tt.native], o = (n == null ? void 0 : n.track).cues;
  if (!n || !o) return;
  const h = d(this, _u).id, v = d(this, Nv)[h] ?? 0, y = S(this, Be, dh).call(this, s);
  for (let D = v; D < o.length; D++) {
    const $ = o[D];
    $.positionAlign || ($.positionAlign = "auto"), d(this, _u).addCue($, y);
  }
  d(this, Nv)[h] = o.length;
}, DN = function(s) {
  var v;
  if (!d(this, vt)) return;
  const n = s.tracks, o = [...d(this, cd).textTracks].filter((y) => "manualMode" in y), h = S(this, Be, dh).call(this, s);
  for (let y = 0; y < o.length; y++) {
    const C = n[y], D = o[y], $ = `dash-${C.kind}-${y}`, _ = new Ud({
      id: $,
      label: (C == null ? void 0 : C.label) ?? ((v = C.labels.find((A) => A.text)) == null ? void 0 : v.text) ?? ((C == null ? void 0 : C.lang) && YA(C.lang)) ?? (C == null ? void 0 : C.lang) ?? void 0,
      language: C.lang ?? void 0,
      kind: C.kind,
      default: C.defaultTrack
    });
    _[tt.native] = {
      managed: !0,
      track: D
    }, _[tt.readyState] = 2, _[tt.onModeChange] = () => {
      d(this, vt) && (_.mode === "showing" ? (d(this, vt).setTextTrack(y), L(this, _u, _)) : (d(this, vt).setTextTrack(-1), L(this, _u, null)));
    }, d(this, cn).textTracks.add(_, h);
  }
}, MN = function(s) {
  const { mediaType: n, newMediaInfo: o } = s;
  if (n === "audio") {
    const h = d(this, cn).audioTracks.getById(`dash-audio-${o.index}`);
    if (h) {
      const v = S(this, Be, dh).call(this, s);
      d(this, cn).audioTracks[at.select](h, !0, v);
    }
  }
}, LN = function(s) {
  if (s.mediaType !== "video") return;
  const n = d(this, cn).qualities[s.newQuality];
  if (n) {
    const o = S(this, Be, dh).call(this, s);
    d(this, cn).qualities[at.select](n, !0, o);
  }
}, $N = function(s) {
  if (d(this, cn).$state.canPlay() || !d(this, vt)) return;
  const { type: n, mediaPresentationDuration: o } = s.data, h = S(this, Be, dh).call(this, s);
  d(this, cn).notify("stream-type-change", n !== "static" ? "live" : "on-demand", h), d(this, cn).notify("duration-change", o, h), d(this, cn).qualities[la.setAuto](!0, h);
  const v = d(this, vt).getVideoElement(), y = d(this, vt).getTracksForTypeFromManifest(
    "video",
    s.data
  ), C = [...new Set(y.map((A) => A.mimeType))].find(
    (A) => A && GP(v, A)
  ), D = y.filter(
    (A) => C === A.mimeType
  )[0];
  let $ = d(this, vt).getTracksForTypeFromManifest(
    "audio",
    s.data
  );
  const _ = [...new Set($.map((A) => A.mimeType))].find(
    (A) => A && YP(v, A)
  );
  if ($ = $.filter((A) => _ === A.mimeType), D == null || D.bitrateList.forEach((A, B) => {
    var ne;
    const W = {
      id: ((ne = A.id) == null ? void 0 : ne.toString()) ?? `dash-bitrate-${B}`,
      width: A.width ?? 0,
      height: A.height ?? 0,
      bitrate: A.bandwidth ?? 0,
      codec: D.codec,
      index: B
    };
    d(this, cn).qualities[at.add](W, h);
  }), ss(D == null ? void 0 : D.index)) {
    const A = d(this, cn).qualities[D.index];
    A && d(this, cn).qualities[at.select](A, !0, h);
  }
  $.forEach((A, B) => {
    const ne = A.labels.find((Re) => navigator.languages.some((Lt) => Re.lang && Lt.toLowerCase().startsWith(Re.lang.toLowerCase()))) || A.labels[0], ce = {
      id: `dash-audio-${A == null ? void 0 : A.index}`,
      label: (ne == null ? void 0 : ne.text) ?? (A.lang && YA(A.lang)) ?? A.lang ?? "",
      language: A.lang ?? "",
      kind: "main",
      mimeType: A.mimeType,
      codec: A.codec,
      index: B
    };
    d(this, cn).audioTracks[at.add](ce, h);
  }), v.dispatchEvent(new yt("canplay", { trigger: h }));
}, ON = function(s) {
  const { type: n, error: o } = s;
  switch (o.code) {
    case 27:
      S(this, Be, _N).call(this, o);
      break;
    default:
      S(this, Be, JR).call(this, o);
      break;
  }
}, AN = function() {
  d(this, dd) >= 0 && S(this, Be, DC).call(this);
}, PN = function(s) {
  s.mediaType === "text" && requestAnimationFrame(S(this, Be, RN).bind(this, s));
}, dd = new WeakMap(), _N = function(s) {
  var n;
  S(this, Be, DC).call(this), (n = d(this, vt)) == null || n.play(), L(this, dd, window.setTimeout(() => {
    L(this, dd, -1), S(this, Be, JR).call(this, s);
  }, 5e3));
}, DC = function() {
  clearTimeout(d(this, dd)), L(this, dd, -1);
}, JR = function(s) {
  d(this, cn).notify("error", {
    message: s.message ?? "",
    code: 1,
    error: s
  });
}, NN = function() {
  var n;
  S(this, Be, eD).call(this, "video", !0);
  const { qualities: s } = d(this, cn);
  (n = d(this, vt)) == null || n.setQualityFor("video", s.selectedIndex, !0);
}, eD = function(s, n) {
  var o;
  (o = d(this, vt)) == null || o.updateSettings({
    streaming: { abr: { autoSwitchBitrate: { [s]: n } } }
  });
}, UN = function() {
  const { qualities: s } = d(this, cn);
  !d(this, vt) || s.auto || !s.selected || (S(this, Be, eD).call(this, "video", !1), d(this, vt).setQualityFor("video", s.selectedIndex, s.switch === "current"), O0 && (d(this, cd).currentTime = d(this, cd).currentTime));
}, zN = function() {
  if (!d(this, vt)) return;
  const { audioTracks: s } = d(this, cn), n = d(this, vt).getTracksFor("audio").find(
    (o) => s.selected && s.selected.id === `dash-audio-${o.index}`
  );
  n && d(this, vt).setCurrentTrack(n);
}, tD = function() {
  S(this, Be, DC).call(this), L(this, _u, null), L(this, Nv, {});
};
function lT(f) {
  return f instanceof Error ? f : Error(typeof f == "string" ? f : JSON.stringify(f));
}
function xu(f, s) {
  if (!f)
    throw Error("Assertion failed.");
}
var $h, fo, LT, Co, FN, VN, HN, IN;
class VQ {
  constructor(s, n, o) {
    R(this, Co);
    R(this, $h);
    R(this, fo);
    R(this, LT);
    L(this, $h, s), L(this, fo, n), L(this, LT, o), S(this, Co, FN).call(this);
  }
}
$h = new WeakMap(), fo = new WeakMap(), LT = new WeakMap(), Co = new WeakSet(), FN = async function() {
  const s = {
    onLoadStart: S(this, Co, VN).bind(this),
    onLoaded: S(this, Co, HN).bind(this),
    onLoadError: S(this, Co, IN).bind(this)
  };
  let n = await N5(d(this, $h), s);
  if (mi(n) && !Ze(d(this, $h)) && (n = await _5(d(this, $h), s)), !n) return null;
  if (!window.dashjs.supportsMediaSource()) {
    const o = "[vidstack] `dash.js` is not supported in this environment";
    return d(this, fo).player.dispatch(new yt("dash-unsupported")), d(this, fo).notify("error", { message: o, code: 4 }), null;
  }
  return n;
}, VN = function() {
  d(this, fo).player.dispatch(new yt("dash-lib-load-start"));
}, HN = function(s) {
  d(this, fo).player.dispatch(
    new yt("dash-lib-loaded", {
      detail: s
    })
  ), d(this, LT).call(this, s);
}, IN = function(s) {
  const n = lT(s);
  d(this, fo).player.dispatch(
    new yt("dash-lib-load-error", {
      detail: n
    })
  ), d(this, fo).notify("error", {
    message: n.message,
    code: 4,
    error: n
  });
};
async function _5(f, s = {}) {
  var n, o, h, v, y, C, D;
  if (!mi(f)) {
    if ((n = s.onLoadStart) == null || n.call(s), U5(f))
      return (o = s.onLoaded) == null || o.call(s, f), f;
    if (GA(f)) {
      const $ = f.MediaPlayer;
      return (h = s.onLoaded) == null || h.call(s, $), $;
    }
    try {
      const $ = (v = await f()) == null ? void 0 : v.default;
      if (GA($))
        return (y = s.onLoaded) == null || y.call(s, $.MediaPlayer), $.MediaPlayer;
      if ($)
        (C = s.onLoaded) == null || C.call(s, $);
      else
        throw Error(
          ""
        );
      return $;
    } catch ($) {
      (D = s.onLoadError) == null || D.call(s, $);
    }
  }
}
async function N5(f, s = {}) {
  var n, o, h;
  if (Ze(f)) {
    (n = s.onLoadStart) == null || n.call(s);
    try {
      if (await zM(f), !ls(window.dashjs.MediaPlayer))
        throw Error(
          ""
        );
      const v = window.dashjs.MediaPlayer;
      return (o = s.onLoaded) == null || o.call(s, v), v;
    } catch (v) {
      (h = s.onLoadError) == null || h.call(s, v);
    }
  }
}
function U5(f) {
  return f && f.prototype && f.prototype !== Function;
}
function GA(f) {
  return f && "MediaPlayer" in f;
}
const f0 = class f0 extends IM {
  constructor() {
    super(...arguments);
    Z(this, "name", "dash");
  }
  canPlay(n) {
    return f0.supported && UM(n);
  }
  async load(n) {
    return new (await import("./vidstack-dash-DpscB_tK.js")).DASHProvider(this.target, n);
  }
};
Z(f0, "supported", yB());
let nD = f0;
class z5 {
  constructor() {
    Z(this, "name", "vimeo");
    Z(this, "target");
  }
  preconnect() {
    const s = [
      "https://i.vimeocdn.com",
      "https://f.vimeocdn.com",
      "https://fresnel.vimeocdn.com"
    ];
    for (const n of s)
      A0(n);
  }
  canPlay(s) {
    return Ze(s.src) && s.type === "video/vimeo";
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    return new (await import("./vidstack-vimeo-CpP-MjQb.js").then((n) => n.p)).VimeoProvider(this.target, s);
  }
  async loadPoster(s, n, o) {
    const { resolveVimeoVideoId: h, getVimeoVideoInfo: v } = await import("./vidstack-vimeo-CpP-MjQb.js").then((D) => D.u);
    if (!Ze(s.src)) return null;
    const { videoId: y, hash: C } = h(s.src);
    return y ? v(y, o, C).then((D) => D ? D.poster : null) : null;
  }
}
class F5 {
  constructor() {
    Z(this, "name", "youtube");
    Z(this, "target");
  }
  preconnect() {
    const s = [
      // Botguard script.
      "https://www.google.com",
      // Posters.
      "https://i.ytimg.com",
      // Ads.
      "https://googleads.g.doubleclick.net",
      "https://static.doubleclick.net"
    ];
    for (const n of s)
      A0(n);
  }
  canPlay(s) {
    return Ze(s.src) && s.type === "video/youtube";
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    return new (await import("./vidstack-youtube-4AkWRL18.js").then((n) => n.p)).YouTubeProvider(this.target, s);
  }
  async loadPoster(s, n, o) {
    const { findYouTubePoster: h, resolveYouTubeVideoId: v } = await import("./vidstack-youtube-4AkWRL18.js").then((C) => C.u), y = Ze(s.src) && v(s.src);
    return y ? h(y, o) : null;
  }
}
function SR(f, s) {
  const n = String(f), o = n.length;
  if (o < s) {
    const v = s - o;
    return `${"0".repeat(v)}${f}`;
  }
  return n;
}
function qN(f) {
  const s = Math.trunc(f / 3600), n = Math.trunc(f % 3600 / 60), o = Math.trunc(f % 60), h = Number((f - Math.trunc(f)).toPrecision(3));
  return {
    hours: s,
    minutes: n,
    seconds: o,
    fraction: h
  };
}
function BM(f, { padHrs: s = null, padMins: n = null, showHrs: o = !1, showMs: h = !1 } = {}) {
  const { hours: v, minutes: y, seconds: C, fraction: D } = qN(f), $ = s ? SR(v, 2) : v, _ = n || Zu(n) && f >= 3600 ? SR(y, 2) : y, A = SR(C, 2), B = h && D > 0 ? `.${String(D).replace(/^0?\./, "")}` : "", W = `${_}:${A}${B}`;
  return v > 0 || o ? `${$}:${W}` : W;
}
function iD(f) {
  const s = [], { hours: n, minutes: o, seconds: h } = qN(f);
  return n > 0 && s.push(`${n} hour`), o > 0 && s.push(`${o} min`), (h > 0 || s.length === 0) && s.push(`${h} sec`), s.join(" ");
}
const TR = Symbol(0), V5 = [
  "autoPlay",
  "canAirPlay",
  "canFullscreen",
  "canGoogleCast",
  "canLoad",
  "canLoadPoster",
  "canPictureInPicture",
  "canPlay",
  "canSeek",
  "ended",
  "fullscreen",
  "isAirPlayConnected",
  "isGoogleCastConnected",
  "live",
  "liveEdge",
  "loop",
  "mediaType",
  "muted",
  "paused",
  "pictureInPicture",
  "playing",
  "playsInline",
  "remotePlaybackState",
  "remotePlaybackType",
  "seeking",
  "started",
  "streamType",
  "viewType",
  "waiting"
], H5 = {
  artist: "",
  artwork: null,
  autoplay: !1,
  autoPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  currentTime: 0,
  crossorigin: null,
  crossOrigin: null,
  duration: -1,
  fullscreenOrientation: "landscape",
  googleCast: {},
  load: "visible",
  posterLoad: "visible",
  logLevel: "silent",
  loop: !1,
  muted: !1,
  paused: !0,
  playsinline: !1,
  playsInline: !1,
  playbackRate: 1,
  poster: "",
  preload: "metadata",
  preferNativeHLS: !1,
  src: "",
  title: "",
  controlsDelay: 2e3,
  hideControlsOnMouseLeave: !1,
  viewType: "unknown",
  streamType: "unknown",
  volume: 1,
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  keyDisabled: !1,
  keyTarget: "player",
  keyShortcuts: m5,
  storage: null
};
var $T, Oh;
class WA extends ap {
  constructor(n, o) {
    super();
    R(this, $T);
    R(this, Oh);
    L(this, $T, n), L(this, Oh, o);
  }
  async onAttach(n) {
    const o = this.$props[d(this, $T)]();
    if (o === "eager")
      requestAnimationFrame(d(this, Oh));
    else if (o === "idle")
      iB(d(this, Oh));
    else if (o === "visible") {
      let h, v = new IntersectionObserver((y) => {
        this.scope && y[0].isIntersecting && (h == null || h(), h = void 0, d(this, Oh).call(this));
      });
      v.observe(n), h = Wt(() => v.disconnect());
    }
  }
}
$T = new WeakMap(), Oh = new WeakMap();
var OT, ml, h0, jN;
class I5 {
  constructor(s, n) {
    R(this, h0);
    R(this, OT);
    R(this, ml);
    L(this, OT, s), L(this, ml, n);
  }
  notify(s, ...n) {
    d(this, OT).call(this, new yt(s, {
      detail: n == null ? void 0 : n[0],
      trigger: n == null ? void 0 : n[1]
    }));
  }
  async ready(s, n) {
    return py(async () => {
      var Kt, Mt, Ae, Et, Sn, Je, ot;
      d(this, ml);
      const {
        autoPlay: o,
        canPlay: h,
        started: v,
        duration: y,
        seekable: C,
        buffered: D,
        remotePlaybackInfo: $,
        playsInline: _,
        savedState: A,
        source: B
      } = d(this, ml).$state;
      if (h()) return;
      const W = {
        duration: (s == null ? void 0 : s.duration) ?? y(),
        seekable: (s == null ? void 0 : s.seekable) ?? C(),
        buffered: (s == null ? void 0 : s.buffered) ?? D(),
        provider: d(this, ml).$provider()
      };
      this.notify("can-play", W, n), Xu();
      let ne = d(this, ml).$provider(), { storage: ce, qualities: Re } = d(this, ml), { muted: Lt, volume: $t, clipStartTime: Ve, playbackRate: ct } = d(this, ml).$props;
      await ((Kt = ce == null ? void 0 : ce.onLoad) == null ? void 0 : Kt.call(ce, B()));
      const Ye = (Mt = A()) == null ? void 0 : Mt.currentTime, wt = (Ae = A()) == null ? void 0 : Ae.paused, He = await (ce == null ? void 0 : ce.getTime()), de = Ye ?? He ?? Ve(), Ge = wt === !1 || wt !== !0 && !v() && o();
      if (ne) {
        ne.setVolume(await (ce == null ? void 0 : ce.getVolume()) ?? $t()), ne.setMuted(Lt() || !!await (ce == null ? void 0 : ce.getMuted()));
        const oe = await (ce == null ? void 0 : ce.getAudioGain()) ?? 1;
        oe > 1 && ((Sn = (Et = ne.audioGain) == null ? void 0 : Et.setGain) == null || Sn.call(Et, oe)), (Je = ne.setPlaybackRate) == null || Je.call(ne, await (ce == null ? void 0 : ce.getPlaybackRate()) ?? ct()), (ot = ne.setPlaysInline) == null || ot.call(ne, _()), de > 0 && ne.setCurrentTime(de);
      }
      const ft = await (ce == null ? void 0 : ce.getVideoQuality());
      if (ft && Re.length) {
        let oe = null, Le = 1 / 0;
        for (const he of Re) {
          const gt = Math.abs(ft.width - he.width) + Math.abs(ft.height - he.height) + (ft.bitrate ? Math.abs(ft.bitrate - (he.bitrate ?? 0)) : 0);
          gt < Le && (oe = he, Le = gt);
        }
        oe && (oe.selected = !0);
      }
      h() && Ge ? await S(this, h0, jN).call(this, n) : He && He > 0 && this.notify("started", void 0, n), $.set(null);
    });
  }
}
OT = new WeakMap(), ml = new WeakMap(), h0 = new WeakSet(), jN = async function(s) {
  const {
    player: n,
    $state: { autoPlaying: o, muted: h }
  } = d(this, ml);
  o.set(!0);
  const v = new yt("auto-play-attempt", { trigger: s });
  try {
    await n.play(v);
  } catch {
  }
};
var fd;
class q5 {
  constructor() {
    R(this, fd, /* @__PURE__ */ new Map());
  }
  /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */
  enqueue(s, n) {
    d(this, fd).set(s, n);
  }
  /**
   * Process item in queue for the given `key`.
   */
  serve(s) {
    const n = this.peek(s);
    return d(this, fd).delete(s), n;
  }
  /**
   * Peek at item in queue for the given `key`.
   */
  peek(s) {
    return d(this, fd).get(s);
  }
  /**
   * Removes queued item under the given `key`.
   */
  delete(s) {
    d(this, fd).delete(s);
  }
  /**
   * Clear all items in the queue.
   */
  clear() {
    d(this, fd).clear();
  }
}
fd = new WeakMap();
var hd, Uv, vl, Vd, rD, aD;
class BN {
  constructor() {
    R(this, Vd);
    R(this, hd, !1);
    R(this, Uv, MR());
    R(this, vl, /* @__PURE__ */ new Map());
  }
  /**
   * The number of callbacks that are currently in queue.
   */
  get size() {
    return d(this, vl).size;
  }
  /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */
  get isServing() {
    return d(this, hd);
  }
  /**
   * Waits for the queue to be flushed (ie: start serving).
   */
  async waitForFlush() {
    d(this, hd) || await d(this, Uv).promise;
  }
  /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */
  enqueue(s, n) {
    if (d(this, hd)) {
      n();
      return;
    }
    d(this, vl).delete(s), d(this, vl).set(s, n);
  }
  /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */
  serve(s) {
    var n;
    (n = d(this, vl).get(s)) == null || n(), d(this, vl).delete(s);
  }
  /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */
  start() {
    S(this, Vd, rD).call(this), L(this, hd, !0), d(this, vl).size > 0 && S(this, Vd, rD).call(this);
  }
  /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */
  stop() {
    L(this, hd, !1);
  }
  /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */
  reset() {
    this.stop(), d(this, vl).clear(), S(this, Vd, aD).call(this);
  }
}
hd = new WeakMap(), Uv = new WeakMap(), vl = new WeakMap(), Vd = new WeakSet(), rD = function() {
  for (const s of d(this, vl).keys()) this.serve(s);
  S(this, Vd, aD).call(this);
}, aD = function() {
  d(this, Uv).resolve(), L(this, Uv, MR());
};
function j5(f) {
  return f ? "true" : "false";
}
function sp(f) {
  return () => j5(f());
}
function B5() {
  return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
var Nu, rt, Uu, Ah, zu, xn, pd, Tt, QN, YN, GN, sD, zv, lD, oD, WN, KN, XN, ZN, JN, eU, Ph, tU, uD, cD, Y5;
class Q5 extends ap {
  constructor(n, o, h) {
    super();
    R(this, Tt);
    R(this, Nu);
    R(this, rt);
    R(this, Uu);
    Z(this, "controls");
    R(this, Ah);
    R(this, zu);
    R(this, xn);
    R(this, pd, new BN());
    R(this, zv, !1);
    R(this, Ph);
    L(this, Nu, n), L(this, rt, o), L(this, Uu, h), L(this, xn, h.$provider), this.controls = new E5(), L(this, Ah, new b5()), L(this, zu, new e0());
  }
  onAttach() {
    this.listen("fullscreen-change", S(this, Tt, tU).bind(this));
  }
  onConnect(n) {
    const o = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), h = new gn(n), v = S(this, Tt, GN).bind(this);
    for (const y of o)
      y.startsWith("media-") && h.add(y, v);
    S(this, Tt, QN).call(this), J(S(this, Tt, YN).bind(this)), J(S(this, Tt, WN).bind(this)), J(S(this, Tt, KN).bind(this)), J(S(this, Tt, XN).bind(this)), J(S(this, Tt, ZN).bind(this)), J(S(this, Tt, JN).bind(this)), J(S(this, Tt, eU).bind(this));
  }
  onDestroy() {
    try {
      const n = this.createEvent("destroy"), { pictureInPicture: o, fullscreen: h } = this.$state;
      h() && this.exitFullscreen("prefer-media", n), o() && this.exitPictureInPicture(n);
    } catch {
    }
    d(this, pd).reset();
  }
  async play(n) {
    const { canPlay: o, paused: h, autoPlaying: v } = this.$state;
    if (S(this, Tt, sD).call(this, n) || !ye(h)) return;
    n && d(this, rt).queue.enqueue("media-play-request", n);
    const y = ye(v);
    try {
      const C = ye(d(this, xn));
      return wR(C, ye(o)), G5(y), await C.play();
    } catch (C) {
      const D = this.createEvent("play-fail", {
        detail: lT(C),
        trigger: n
      });
      throw D.autoPlay = y, d(this, Nu).handle(D), C;
    }
  }
  async pause(n) {
    const { canPlay: o, paused: h } = this.$state;
    if (!ye(h)) {
      n && d(this, rt).queue.enqueue("media-pause-request", n);
      try {
        const v = ye(d(this, xn));
        return wR(v, ye(o)), await v.pause();
      } catch (v) {
        throw d(this, rt).queue.delete("media-pause-request"), v;
      }
    }
  }
  setAudioGain(n, o) {
    const { audioGain: h, canSetAudioGain: v } = this.$state;
    if (h() === n) return;
    const y = d(this, xn).call(this);
    if (!(y != null && y.audioGain) || !v())
      throw Error("[vidstack] audio gain api not available");
    o && d(this, rt).queue.enqueue("media-audio-gain-change-request", o), y.audioGain.setGain(n);
  }
  seekToLiveEdge(n) {
    const { canPlay: o, live: h, liveEdge: v, canSeek: y, liveSyncPosition: C, seekableEnd: D, userBehindLiveEdge: $ } = this.$state;
    if ($.set(!1), ye(() => !h() || v() || !y())) return;
    const _ = ye(d(this, xn));
    wR(_, ye(o)), n && d(this, rt).queue.enqueue("media-seek-request", n);
    const A = D() - 2;
    _.setCurrentTime(Math.min(A, C() ?? A));
  }
  async enterFullscreen(n = "prefer-media", o) {
    const h = S(this, Tt, lD).call(this, n);
    if (KA(n, h), !h.active)
      return ye(this.$state.pictureInPicture) && (L(this, zv, !0), await this.exitPictureInPicture(o)), o && d(this, rt).queue.enqueue("media-enter-fullscreen-request", o), h.enter();
  }
  async exitFullscreen(n = "prefer-media", o) {
    const h = S(this, Tt, lD).call(this, n);
    if (KA(n, h), !!h.active) {
      o && d(this, rt).queue.enqueue("media-exit-fullscreen-request", o);
      try {
        const v = await h.exit();
        return d(this, zv) && ye(this.$state.canPictureInPicture) && await this.enterPictureInPicture(), v;
      } finally {
        L(this, zv, !1);
      }
    }
  }
  async enterPictureInPicture(n) {
    if (S(this, Tt, oD).call(this), !this.$state.pictureInPicture())
      return n && d(this, rt).queue.enqueue("media-enter-pip-request", n), await d(this, xn).call(this).pictureInPicture.enter();
  }
  async exitPictureInPicture(n) {
    if (S(this, Tt, oD).call(this), !!this.$state.pictureInPicture())
      return n && d(this, rt).queue.enqueue("media-exit-pip-request", n), await d(this, xn).call(this).pictureInPicture.exit();
  }
  async "media-airplay-request"(n) {
    try {
      await this.requestAirPlay(n);
    } catch {
    }
  }
  async requestAirPlay(n) {
    var o;
    try {
      const h = (o = d(this, xn).call(this)) == null ? void 0 : o.airPlay;
      if (!(h != null && h.supported))
        throw Error("No AirPlay adapter.");
      return n && d(this, rt).queue.enqueue("media-airplay-request", n), await h.prompt();
    } catch (h) {
      throw d(this, rt).queue.delete("media-airplay-request"), h;
    }
  }
  async "media-google-cast-request"(n) {
    try {
      await this.requestGoogleCast(n);
    } catch {
    }
  }
  async requestGoogleCast(n) {
    try {
      const { canGoogleCast: o } = this.$state;
      if (!ye(o)) {
        const v = Error(
          "Cast not available."
        );
        throw v.code = "CAST_NOT_AVAILABLE", v;
      }
      if (A0("https://www.gstatic.com"), !d(this, Ph)) {
        const v = await Promise.resolve().then(() => pQ);
        L(this, Ph, new v.GoogleCastLoader());
      }
      await d(this, Ph).prompt(d(this, Uu)), n && d(this, rt).queue.enqueue("media-google-cast-request", n);
      const h = ye(this.$state.remotePlaybackState) !== "disconnected";
      h && this.$state.savedState.set({
        paused: ye(this.$state.paused),
        currentTime: ye(this.$state.currentTime)
      }), this.$state.remotePlaybackLoader.set(h ? d(this, Ph) : null);
    } catch (o) {
      throw d(this, rt).queue.delete("media-google-cast-request"), o;
    }
  }
  "media-clip-start-change-request"(n) {
    const { clipStartTime: o } = this.$state;
    o.set(n.detail);
  }
  "media-clip-end-change-request"(n) {
    const { clipEndTime: o } = this.$state;
    o.set(n.detail), this.dispatch("duration-change", {
      detail: n.detail,
      trigger: n
    });
  }
  "media-duration-change-request"(n) {
    const { providedDuration: o, clipEndTime: h } = this.$state;
    o.set(n.detail), h() <= 0 && this.dispatch("duration-change", {
      detail: n.detail,
      trigger: n
    });
  }
  "media-audio-track-change-request"(n) {
    const { logger: o, audioTracks: h } = d(this, Uu);
    if (h.readonly)
      return;
    const v = n.detail, y = h[v];
    if (y) {
      const C = n.type;
      d(this, rt).queue.enqueue(C, n), y.selected = !0;
    }
  }
  async "media-enter-fullscreen-request"(n) {
    try {
      await this.enterFullscreen(n.detail, n);
    } catch (o) {
      S(this, Tt, uD).call(this, o, n);
    }
  }
  async "media-exit-fullscreen-request"(n) {
    try {
      await this.exitFullscreen(n.detail, n);
    } catch (o) {
      S(this, Tt, uD).call(this, o, n);
    }
  }
  async "media-orientation-lock-request"(n) {
    const o = n.type;
    try {
      d(this, rt).queue.enqueue(o, n), await d(this, zu).lock(n.detail);
    } catch {
      d(this, rt).queue.delete(o);
    }
  }
  async "media-orientation-unlock-request"(n) {
    const o = n.type;
    try {
      d(this, rt).queue.enqueue(o, n), await d(this, zu).unlock();
    } catch {
      d(this, rt).queue.delete(o);
    }
  }
  async "media-enter-pip-request"(n) {
    try {
      await this.enterPictureInPicture(n);
    } catch (o) {
      S(this, Tt, cD).call(this, o, n);
    }
  }
  async "media-exit-pip-request"(n) {
    try {
      await this.exitPictureInPicture(n);
    } catch (o) {
      S(this, Tt, cD).call(this, o, n);
    }
  }
  "media-live-edge-request"(n) {
    const { live: o, liveEdge: h, canSeek: v } = this.$state;
    if (!(!o() || h() || !v())) {
      d(this, rt).queue.enqueue("media-seek-request", n);
      try {
        this.seekToLiveEdge();
      } catch {
        d(this, rt).queue.delete("media-seek-request");
      }
    }
  }
  async "media-loop-request"(n) {
    try {
      d(this, rt).looping = !0, d(this, rt).replaying = !0, await this.play(n);
    } catch {
      d(this, rt).looping = !1;
    }
  }
  "media-user-loop-change-request"(n) {
    this.$state.userPrefersLoop.set(n.detail);
  }
  async "media-pause-request"(n) {
    if (!this.$state.paused())
      try {
        await this.pause(n);
      } catch {
      }
  }
  async "media-play-request"(n) {
    if (this.$state.paused())
      try {
        await this.play(n);
      } catch {
      }
  }
  "media-rate-change-request"(n) {
    const { playbackRate: o, canSetPlaybackRate: h } = this.$state;
    if (o() === n.detail || !h()) return;
    const v = d(this, xn).call(this);
    v != null && v.setPlaybackRate && (d(this, rt).queue.enqueue("media-rate-change-request", n), v.setPlaybackRate(n.detail));
  }
  "media-audio-gain-change-request"(n) {
    try {
      this.setAudioGain(n.detail, n);
    } catch {
    }
  }
  "media-quality-change-request"(n) {
    var C, D;
    const { qualities: o, storage: h, logger: v } = d(this, Uu);
    if (o.readonly)
      return;
    d(this, rt).queue.enqueue("media-quality-change-request", n);
    const y = n.detail;
    if (y < 0)
      o.autoSelect(n), n.isOriginTrusted && ((C = h == null ? void 0 : h.setVideoQuality) == null || C.call(h, null));
    else {
      const $ = o[y];
      $ && ($.selected = !0, n.isOriginTrusted && ((D = h == null ? void 0 : h.setVideoQuality) == null || D.call(h, {
        id: $.id,
        width: $.width,
        height: $.height,
        bitrate: $.bitrate
      })));
    }
  }
  "media-pause-controls-request"(n) {
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), this.controls.pause(n);
  }
  "media-resume-controls-request"(n) {
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), this.controls.resume(n);
  }
  "media-seek-request"(n) {
    const { canSeek: o, ended: h, live: v, seekableEnd: y, userBehindLiveEdge: C } = this.$state, D = n.detail;
    h() && (d(this, rt).replaying = !0);
    const $ = n.type;
    d(this, rt).seeking = !1, d(this, rt).queue.delete($);
    const _ = n_(D, this.$state);
    !Number.isFinite(_) || !o() || (d(this, rt).queue.enqueue($, n), d(this, xn).call(this).setCurrentTime(_), v() && n.isOriginTrusted && Math.abs(y() - _) >= 2 && C.set(!0));
  }
  "media-seeking-request"(n) {
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), this.$state.seeking.set(!0), d(this, rt).seeking = !0;
  }
  "media-start-loading"(n) {
    if (this.$state.canLoad()) return;
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), d(this, Nu).handle(this.createEvent("can-load"));
  }
  "media-poster-start-loading"(n) {
    if (this.$state.canLoadPoster()) return;
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), d(this, Nu).handle(this.createEvent("can-load-poster"));
  }
  "media-text-track-change-request"(n) {
    const { index: o, mode: h } = n.detail, v = d(this, Uu).textTracks[o];
    if (v) {
      const y = n.type;
      d(this, rt).queue.enqueue(y, n), v.setMode(h, n);
    }
  }
  "media-mute-request"(n) {
    if (this.$state.muted()) return;
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), d(this, xn).call(this).setMuted(!0);
  }
  "media-unmute-request"(n) {
    const { muted: o, volume: h } = this.$state;
    if (!o()) return;
    const v = n.type;
    d(this, rt).queue.enqueue(v, n), d(this, Uu).$provider().setMuted(!1), h() === 0 && (d(this, rt).queue.enqueue(v, n), d(this, xn).call(this).setVolume(0.25));
  }
  "media-volume-change-request"(n) {
    const { muted: o, volume: h } = this.$state, v = n.detail;
    if (h() === v) return;
    const y = n.type;
    d(this, rt).queue.enqueue(y, n), d(this, xn).call(this).setVolume(v), v > 0 && o() && (d(this, rt).queue.enqueue(y, n), d(this, xn).call(this).setMuted(!1));
  }
}
Nu = new WeakMap(), rt = new WeakMap(), Uu = new WeakMap(), Ah = new WeakMap(), zu = new WeakMap(), xn = new WeakMap(), pd = new WeakMap(), Tt = new WeakSet(), QN = function() {
  const { load: n } = this.$props, { canLoad: o } = this.$state;
  if (n() !== "play" || o()) return;
  const h = this.listen("media-play-request", (v) => {
    S(this, Tt, sD).call(this, v), h();
  });
}, YN = function() {
  const n = d(this, xn).call(this), o = this.$state.canPlay();
  return n && o && d(this, pd).start(), () => {
    d(this, pd).stop();
  };
}, GN = function(n) {
  n.stopPropagation(), !n.defaultPrevented && this[n.type] && (ye(d(this, xn)) ? this[n.type](n) : d(this, pd).enqueue(n.type, () => {
    ye(d(this, xn)) && this[n.type](n);
  }));
}, sD = function(n) {
  const { load: o } = this.$props, { canLoad: h } = this.$state;
  if (o() === "play" && !h()) {
    const v = this.createEvent("media-start-loading", { trigger: n });
    return this.dispatchEvent(v), d(this, pd).enqueue("media-play-request", async () => {
      try {
        await this.play(v);
      } catch {
      }
    }), !0;
  }
  return !1;
}, zv = new WeakMap(), lD = function(n) {
  const o = ye(d(this, xn));
  return n === "prefer-media" && d(this, Ah).supported || n === "media" ? d(this, Ah) : o == null ? void 0 : o.fullscreen;
}, oD = function() {
  if (!this.$state.canPictureInPicture())
    throw Error(
      "[vidstack] no pip support"
    );
}, WN = function() {
  this.controls.defaultDelay = this.$props.controlsDelay();
}, KN = function() {
  var h, v;
  const { canSetAudioGain: n } = this.$state, o = !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.audioGain) != null && v.supported);
  n.set(o);
}, XN = function() {
  var h, v;
  const { canAirPlay: n } = this.$state, o = !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.airPlay) != null && v.supported);
  n.set(o);
}, ZN = function() {
  const { canGoogleCast: n, source: o } = this.$state, h = O0 && !$0 && XP(o());
  n.set(h);
}, JN = function() {
  var h, v;
  const { canFullscreen: n } = this.$state, o = d(this, Ah).supported || !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.fullscreen) != null && v.supported);
  n.set(o);
}, eU = function() {
  var h, v;
  const { canPictureInPicture: n } = this.$state, o = !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.pictureInPicture) != null && v.supported);
  n.set(o);
}, Ph = new WeakMap(), tU = async function(n) {
  const o = ye(this.$props.fullscreenOrientation), h = n.detail;
  if (!(mi(o) || o === "none" || !d(this, zu).supported))
    if (h) {
      if (d(this, zu).locked) return;
      this.dispatch("media-orientation-lock-request", {
        detail: o,
        trigger: n
      });
    } else d(this, zu).locked && this.dispatch("media-orientation-unlock-request", {
      trigger: n
    });
}, uD = function(n, o) {
  d(this, Nu).handle(
    this.createEvent("fullscreen-error", {
      detail: lT(n)
    })
  );
}, cD = function(n, o) {
  d(this, Nu).handle(
    this.createEvent("picture-in-picture-error", {
      detail: lT(n)
    })
  );
}, Y5 = function(n, o, h) {
};
function wR(f, s) {
  if (!(f && s))
    throw Error(
      "[vidstack] media not ready"
    );
}
function KA(f, s) {
  if (!(s != null && s.supported))
    throw Error(
      "[vidstack] no fullscreen support"
    );
}
function G5(f) {
  if (!(!B5() || !f))
    throw Error(
      "[vidstack] autoplay blocked"
    );
}
class W5 {
  constructor() {
    Z(this, "seeking", !1);
    Z(this, "looping", !1);
    Z(this, "replaying", !1);
    Z(this, "queue", new q5());
  }
}
const K5 = /* @__PURE__ */ new Set([
  "auto-play",
  "auto-play-fail",
  "can-load",
  "sources-change",
  "source-change",
  "load-start",
  "abort",
  "error",
  "loaded-metadata",
  "loaded-data",
  "can-play",
  "play",
  "play-fail",
  "pause",
  "playing",
  "seeking",
  "seeked",
  "waiting"
]);
var ia, It, dn, _h, Fv, Nh, Uh, Fu, md, se, nU, iU, Jc, jn, rU, aU, sU, MC, dD, fD, lU, hD, oU, uU, Vv, pD, LC, cU, dU, fU, mD, vD, yD, hU, gD, pU, Hv, mU, SD;
class X5 extends ap {
  constructor(n, o) {
    super();
    R(this, se);
    R(this, ia);
    R(this, It);
    R(this, dn, /* @__PURE__ */ new Map());
    R(this, _h, !1);
    R(this, Fv, []);
    R(this, Nh, [-1, -1]);
    R(this, Uh, !1);
    R(this, Fu);
    R(this, md, !1);
    R(this, Vv, null);
    Z(this, "seeking", cw(
      (n) => {
        const { seeking: o, realCurrentTime: h, paused: v } = this.$state;
        o.set(!0), h.set(n.detail), S(this, se, jn).call(this, "media-seeking-request", n), v() && (L(this, Fu, n), d(this, Hv).call(this)), L(this, Nh, [-1, -1]);
      },
      150,
      { leading: !0 }
    ));
    R(this, Hv, HM(() => {
      if (!d(this, Fu)) return;
      L(this, Uh, !0);
      const { waiting: n, playing: o } = this.$state;
      n.set(!0), o.set(!1);
      const h = this.createEvent("waiting", { trigger: d(this, Fu) });
      d(this, dn).set("waiting", h), this.dispatch(h), L(this, Fu, void 0), L(this, Uh, !1);
    }, 300));
    L(this, ia, n), L(this, It, o);
  }
  onAttach(n) {
    n.setAttribute("aria-busy", "true"), new gn(this).add("fullscreen-change", this["fullscreen-change"].bind(this)).add("fullscreen-error", this["fullscreen-error"].bind(this)).add("orientation-change", this["orientation-change"].bind(this));
  }
  onConnect(n) {
    J(S(this, se, dU).bind(this)), S(this, se, rU).call(this), S(this, se, aU).call(this), S(this, se, sU).call(this), S(this, se, nU).call(this), Wt(S(this, se, iU).bind(this));
  }
  onDestroy() {
    const { audioTracks: n, qualities: o, textTracks: h } = d(this, It);
    n[at.reset](), o[at.reset](), h[at.reset](), S(this, se, LC).call(this);
  }
  handle(n) {
    if (!this.scope) return;
    const o = n.type;
    py(() => {
      var h;
      return (h = this[n.type]) == null ? void 0 : h.call(this, n);
    }), K5.has(o) && d(this, dn).set(o, n), this.dispatch(n);
  }
  "provider-change"(n) {
    var v, y;
    const o = d(this, It).$provider(), h = n.detail;
    (o == null ? void 0 : o.type) !== (h == null ? void 0 : h.type) && ((v = o == null ? void 0 : o.destroy) == null || v.call(o), (y = o == null ? void 0 : o.scope) == null || y.dispose(), d(this, It).$provider.set(n.detail), o && n.detail === null && S(this, se, mD).call(this, n));
  }
  "provider-loader-change"(n) {
  }
  "auto-play"(n) {
    this.$state.autoPlayError.set(null);
  }
  "auto-play-fail"(n) {
    this.$state.autoPlayError.set(n.detail), S(this, se, Jc).call(this);
  }
  "can-load"(n) {
    this.$state.canLoad.set(!0), d(this, dn).set("can-load", n), d(this, It).textTracks[tt.canLoad](), S(this, se, jn).call(this, "media-start-loading", n);
  }
  "can-load-poster"(n) {
    this.$state.canLoadPoster.set(!0), d(this, dn).set("can-load-poster", n), S(this, se, jn).call(this, "media-poster-start-loading", n);
  }
  "media-type-change"(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
    const h = this.$state.viewType();
    this.$state.mediaType.set(n.detail);
    const v = this.$state.providedViewType(), y = v === "unknown" ? n.detail : v;
    h !== y && setTimeout(() => {
      requestAnimationFrame(() => {
        this.scope && (this.$state.inferredViewType.set(n.detail), this.dispatch("view-type-change", {
          detail: y,
          trigger: n
        }));
      });
    }, 0);
  }
  "stream-type-change"(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
    const { streamType: h, inferredStreamType: v } = this.$state;
    v.set(n.detail), n.detail = h();
  }
  "rate-change"(n) {
    var v;
    const { storage: o } = d(this, It), { canPlay: h } = this.$state;
    this.$state.playbackRate.set(n.detail), S(this, se, jn).call(this, "media-rate-change-request", n), h() && ((v = o == null ? void 0 : o.setPlaybackRate) == null || v.call(o, n.detail));
  }
  "remote-playback-change"(n) {
    const { remotePlaybackState: o, remotePlaybackType: h } = this.$state, { type: v, state: y } = n.detail, C = y === "connected";
    h.set(v), o.set(y);
    const D = v === "airplay" ? "media-airplay-request" : "media-google-cast-request";
    if (C)
      S(this, se, jn).call(this, D, n);
    else {
      const $ = d(this, ia).queue.peek(D);
      $ && (n.request = $, n.triggers.add($));
    }
  }
  "sources-change"(n) {
    const o = this.$state.sources(), h = n.detail;
    this.$state.sources.set(h), S(this, se, fU).call(this, o, h, n);
  }
  "source-change"(n) {
    var h, v;
    n.isQualityChange = ((h = n.originEvent) == null ? void 0 : h.type) === "quality-change";
    const o = n.detail;
    S(this, se, mD).call(this, n, n.isQualityChange), d(this, dn).set(n.type, n), this.$state.source.set(o), (v = this.el) == null || v.setAttribute("aria-busy", "true");
  }
  abort(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
    const h = d(this, dn).get("can-load");
    h && !n.triggers.hasType("can-load") && n.triggers.add(h);
  }
  "load-start"(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
  }
  error(n) {
    this.$state.error.set(n.detail);
    const o = d(this, dn).get("abort");
    o && n.triggers.add(o);
  }
  "loaded-metadata"(n) {
    const o = d(this, dn).get("load-start");
    o && n.triggers.add(o);
  }
  "loaded-data"(n) {
    const o = d(this, dn).get("load-start");
    o && n.triggers.add(o);
  }
  "can-play"(n) {
    var h;
    const o = d(this, dn).get("loaded-metadata");
    o && n.triggers.add(o), S(this, se, vD).call(this, n.detail), (h = this.el) == null || h.setAttribute("aria-busy", "false");
  }
  "can-play-through"(n) {
    S(this, se, vD).call(this, n.detail);
    const o = d(this, dn).get("can-play");
    o && n.triggers.add(o);
  }
  "duration-change"(n) {
    const { live: o, intrinsicDuration: h, providedDuration: v, clipEndTime: y, ended: C } = this.$state, D = n.detail;
    if (!o()) {
      const $ = Number.isNaN(D) ? 0 : D;
      h.set($), C() && S(this, se, gD).call(this, n);
    }
    (v() > 0 || y() > 0) && n.stopImmediatePropagation();
  }
  progress(n) {
    const { buffered: o, seekable: h } = this.$state, { buffered: v, seekable: y } = n.detail, C = mh(v), D = v.length !== o().length, $ = C !== mh(o()), _ = mh(y), A = y.length !== h().length, B = _ !== mh(h());
    (D || $) && o.set(v), (A || B) && h.set(y);
  }
  play(n) {
    const {
      paused: o,
      autoPlayError: h,
      ended: v,
      autoPlaying: y,
      playsInline: C,
      pointer: D,
      muted: $,
      viewType: _,
      live: A,
      userBehindLiveEdge: B
    } = this.$state;
    if (S(this, se, yD).call(this), !o()) {
      n.stopImmediatePropagation();
      return;
    }
    n.autoPlay = y();
    const W = d(this, dn).get("waiting");
    W && n.triggers.add(W), S(this, se, jn).call(this, "media-play-request", n), d(this, dn).set("play", n), o.set(!1), h.set(null), n.autoPlay && (this.handle(
      this.createEvent("auto-play", {
        detail: { muted: $() },
        trigger: n
      })
    ), y.set(!1)), (v() || d(this, ia).replaying) && (d(this, ia).replaying = !1, v.set(!1), this.handle(this.createEvent("replay", { trigger: n }))), !C() && _() === "video" && D() === "coarse" && d(this, It).remote.enterFullscreen("prefer-media", n), A() && !B() && d(this, It).remote.seekToLiveEdge(n);
  }
  "play-fail"(n) {
    const { muted: o, autoPlaying: h } = this.$state, v = d(this, dn).get("play");
    v && n.triggers.add(v), S(this, se, jn).call(this, "media-play-request", n);
    const { paused: y, playing: C } = this.$state;
    y.set(!0), C.set(!1), S(this, se, Jc).call(this), d(this, dn).set("play-fail", n), n.autoPlay && (this.handle(
      this.createEvent("auto-play-fail", {
        detail: {
          muted: o(),
          error: n.detail
        },
        trigger: n
      })
    ), h.set(!1));
  }
  playing(n) {
    const o = d(this, dn).get("play"), h = d(this, dn).get("seeked");
    o ? n.triggers.add(o) : h && n.triggers.add(h), setTimeout(() => S(this, se, Jc).call(this), 0);
    const {
      paused: v,
      playing: y,
      live: C,
      liveSyncPosition: D,
      seekableEnd: $,
      started: _,
      currentTime: A,
      seeking: B,
      ended: W
    } = this.$state;
    if (v.set(!1), y.set(!0), B.set(!1), W.set(!1), d(this, ia).looping) {
      d(this, ia).looping = !1;
      return;
    }
    if (C() && !_() && A() === 0) {
      const ne = D() ?? $() - 2;
      Number.isFinite(ne) && d(this, It).$provider().setCurrentTime(ne);
    }
    this.started(n);
  }
  started(n) {
    const { started: o } = this.$state;
    o() || (o.set(!0), this.handle(this.createEvent("started", { trigger: n })));
  }
  pause(n) {
    var y;
    (y = this.el) != null && y.isConnected || L(this, md, !0), S(this, se, jn).call(this, "media-pause-request", n);
    const o = d(this, dn).get("seeked");
    o && n.triggers.add(o);
    const { paused: h, playing: v } = this.$state;
    h.set(!0), v.set(!1), d(this, _h) && setTimeout(() => {
      this.handle(this.createEvent("end", { trigger: n })), L(this, _h, !1);
    }, 0), S(this, se, Jc).call(this);
  }
  "time-change"(n) {
    if (d(this, ia).looping) {
      n.stopImmediatePropagation();
      return;
    }
    let { waiting: o, played: h, clipEndTime: v, realCurrentTime: y, currentTime: C } = this.$state, D = n.detail, $ = v();
    y.set(D), S(this, se, hU).call(this), o.set(!1);
    for (const _ of d(this, It).textTracks)
      _[tt.updateActiveCues](D, n);
    $ > 0 && D >= $ && (L(this, _h, !0), this.dispatch("media-pause-request", { trigger: n })), S(this, se, pU).call(this), this.dispatch("time-update", {
      detail: { currentTime: C(), played: h() },
      trigger: n
    });
  }
  "audio-gain-change"(n) {
    var y;
    const { storage: o } = d(this, It), { canPlay: h, audioGain: v } = this.$state;
    v.set(n.detail), S(this, se, jn).call(this, "media-audio-gain-change-request", n), h() && ((y = o == null ? void 0 : o.setAudioGain) == null || y.call(o, v()));
  }
  "volume-change"(n) {
    var D, $;
    const { storage: o } = d(this, It), { volume: h, muted: v, canPlay: y } = this.$state, C = n.detail;
    h.set(C.volume), v.set(C.muted || C.volume === 0), S(this, se, jn).call(this, "media-volume-change-request", n), S(this, se, jn).call(this, C.muted ? "media-mute-request" : "media-unmute-request", n), y() && ((D = o == null ? void 0 : o.setVolume) == null || D.call(o, h()), ($ = o == null ? void 0 : o.setMuted) == null || $.call(o, v()));
  }
  seeked(n) {
    const { seeking: o, currentTime: h, realCurrentTime: v, paused: y, seekableEnd: C, ended: D, live: $ } = this.$state;
    if (d(this, ia).seeking)
      o.set(!0), n.stopImmediatePropagation();
    else if (o()) {
      const _ = d(this, dn).get("waiting");
      _ && n.triggers.add(_);
      const A = d(this, dn).get("seeking");
      A && !n.triggers.has(A) && n.triggers.add(A), y() && S(this, se, SD).call(this), o.set(!1), v.set(n.detail), S(this, se, jn).call(this, "media-seek-request", n);
      const B = n == null ? void 0 : n.originEvent;
      B != null && B.isTrusted && !(B instanceof MessageEvent) && !/seek/.test(B.type) && this.started(n);
    }
    $() || (Math.floor(v()) !== Math.floor(C()) ? D.set(!1) : this.end(n));
  }
  waiting(n) {
    d(this, Uh) || d(this, ia).seeking || (n.stopImmediatePropagation(), L(this, Fu, n), d(this, Hv).call(this));
  }
  end(n) {
    const { loop: o, ended: h } = this.$state;
    if (!(!o() && h())) {
      if (o()) {
        setTimeout(() => {
          requestAnimationFrame(() => {
            S(this, se, yD).call(this, n), this.dispatch("media-loop-request", { trigger: n });
          });
        }, 10);
        return;
      }
      setTimeout(() => S(this, se, mU).call(this, n), 0);
    }
  }
  "fullscreen-change"(n) {
    const o = n.detail;
    this.$state.fullscreen.set(o), S(this, se, jn).call(this, o ? "media-enter-fullscreen-request" : "media-exit-fullscreen-request", n);
  }
  "fullscreen-error"(n) {
    S(this, se, jn).call(this, "media-enter-fullscreen-request", n), S(this, se, jn).call(this, "media-exit-fullscreen-request", n);
  }
  "orientation-change"(n) {
    const o = n.detail.lock;
    S(this, se, jn).call(this, o ? "media-orientation-lock-request" : "media-orientation-unlock-request", n);
  }
  "picture-in-picture-change"(n) {
    const o = n.detail;
    this.$state.pictureInPicture.set(o), S(this, se, jn).call(this, o ? "media-enter-pip-request" : "media-exit-pip-request", n);
  }
  "picture-in-picture-error"(n) {
    S(this, se, jn).call(this, "media-enter-pip-request", n), S(this, se, jn).call(this, "media-exit-pip-request", n);
  }
  "title-change"(n) {
    n.trigger && (n.stopImmediatePropagation(), this.$state.inferredTitle.set(n.detail));
  }
  "poster-change"(n) {
    n.trigger && (n.stopImmediatePropagation(), this.$state.inferredPoster.set(n.detail));
  }
}
ia = new WeakMap(), It = new WeakMap(), dn = new WeakMap(), _h = new WeakMap(), Fv = new WeakMap(), Nh = new WeakMap(), Uh = new WeakMap(), Fu = new WeakMap(), md = new WeakMap(), se = new WeakSet(), nU = function() {
  d(this, md) && (requestAnimationFrame(() => {
    this.scope && d(this, It).remote.play(new yt("dom-connect"));
  }), L(this, md, !1));
}, iU = function() {
  var n;
  d(this, md) || (L(this, md, !this.$state.paused()), (n = d(this, It).$provider()) == null || n.pause());
}, Jc = function() {
  S(this, se, SD).call(this), L(this, _h, !1), d(this, ia).replaying = !1, d(this, ia).looping = !1, L(this, Uh, !1), L(this, Fu, void 0), d(this, dn).clear();
}, jn = function(n, o) {
  const h = d(this, ia).queue.serve(n);
  h && (o.request = h, o.triggers.add(h));
}, rU = function() {
  S(this, se, MC).call(this), S(this, se, dD).call(this);
  const n = d(this, It).textTracks;
  new gn(n).add("add", S(this, se, MC).bind(this)).add("remove", S(this, se, MC).bind(this)).add("mode-change", S(this, se, dD).bind(this));
}, aU = function() {
  const n = d(this, It).qualities;
  new gn(n).add("add", S(this, se, hD).bind(this)).add("remove", S(this, se, hD).bind(this)).add("change", S(this, se, oU).bind(this)).add("auto-change", S(this, se, uU).bind(this)).add("readonly-change", S(this, se, cU).bind(this));
}, sU = function() {
  const n = d(this, It).audioTracks;
  new gn(n).add("add", S(this, se, fD).bind(this)).add("remove", S(this, se, fD).bind(this)).add("change", S(this, se, lU).bind(this));
}, MC = function(n) {
  const { textTracks: o } = this.$state;
  o.set(d(this, It).textTracks.toArray()), this.dispatch("text-tracks-change", {
    detail: o(),
    trigger: n
  });
}, dD = function(n) {
  n && S(this, se, jn).call(this, "media-text-track-change-request", n);
  const o = d(this, It).textTracks.selected, { textTrack: h } = this.$state;
  h() !== o && (h.set(o), this.dispatch("text-track-change", {
    detail: o,
    trigger: n
  }));
}, fD = function(n) {
  const { audioTracks: o } = this.$state;
  o.set(d(this, It).audioTracks.toArray()), this.dispatch("audio-tracks-change", {
    detail: o(),
    trigger: n
  });
}, lU = function(n) {
  const { audioTrack: o } = this.$state;
  o.set(d(this, It).audioTracks.selected), n && S(this, se, jn).call(this, "media-audio-track-change-request", n), this.dispatch("audio-track-change", {
    detail: o(),
    trigger: n
  });
}, hD = function(n) {
  const { qualities: o } = this.$state;
  o.set(d(this, It).qualities.toArray()), this.dispatch("qualities-change", {
    detail: o(),
    trigger: n
  });
}, oU = function(n) {
  const { quality: o } = this.$state;
  o.set(d(this, It).qualities.selected), n && S(this, se, jn).call(this, "media-quality-change-request", n), this.dispatch("quality-change", {
    detail: o(),
    trigger: n
  });
}, uU = function() {
  const { qualities: n } = d(this, It), o = n.auto;
  this.$state.autoQuality.set(o), o || S(this, se, LC).call(this);
}, Vv = new WeakMap(), pD = function() {
  S(this, se, LC).call(this), L(this, Vv, J(() => {
    const { qualities: n } = d(this, It), { mediaWidth: o, mediaHeight: h } = this.$state, v = o(), y = h();
    if (v === 0 || y === 0) return;
    let C = null, D = 1 / 0;
    for (const $ of n) {
      const _ = Math.abs($.width - v) + Math.abs($.height - y);
      _ < D && (D = _, C = $);
    }
    C && n[at.select](
      C,
      !0,
      new yt("resize", { detail: { width: v, height: y } })
    );
  }));
}, LC = function() {
  var n;
  (n = d(this, Vv)) == null || n.call(this), L(this, Vv, null);
}, cU = function() {
  this.$state.canSetQuality.set(!d(this, It).qualities.readonly);
}, dU = function() {
  const { canSetVolume: n, isGoogleCastConnected: o } = this.$state;
  if (o()) {
    n.set(!1);
    return;
  }
  pB().then(n.set);
}, fU = function(n, o, h) {
  let { qualities: v } = d(this, It), y = !1, C = !1;
  for (const D of n) {
    if (!LR(D)) continue;
    if (!o.some((_) => _.src === D.src)) {
      const _ = v.getBySrc(D.src);
      _ && (v[at.remove](_, h), C = !0);
    }
  }
  C && !v.length && (this.$state.savedState.set(null), v[at.reset](h));
  for (const D of o) {
    if (!LR(D) || v.getBySrc(D.src)) continue;
    const $ = {
      id: D.id ?? D.height + "p",
      bitrate: null,
      codec: null,
      ...D,
      selected: !1
    };
    v[at.add]($, h), y = !0;
  }
  y && !v[la.enableAuto] && (S(this, se, pD).call(this), v[la.enableAuto] = S(this, se, pD).bind(this), v[la.setAuto](!0, h));
}, mD = function(n, o = !1) {
  const { audioTracks: h, qualities: v } = d(this, It);
  if (!o) {
    L(this, Fv, []), L(this, Nh, [-1, -1]), h[at.reset](n), v[at.reset](n), IA(this.$state, o), S(this, se, Jc).call(this);
    return;
  }
  IA(this.$state, o), S(this, se, Jc).call(this);
}, vD = function(n) {
  const { seekable: o, buffered: h, intrinsicDuration: v, canPlay: y } = this.$state;
  y.set(!0), h.set(n.buffered), o.set(n.seekable);
  const C = mh(n.seekable) ?? 1 / 0;
  v.set(C);
}, yD = function(n) {
  if (!ye(d(this, It).$provider)) return;
  const { ended: h, seekableStart: v, clipEndTime: y, currentTime: C, realCurrentTime: D, duration: $ } = this.$state, _ = h() || D() < v() || y() > 0 && D() >= y() || Math.abs(C() - $()) < 0.1;
  return _ && this.dispatch("media-seek-request", {
    detail: v(),
    trigger: n
  }), _;
}, hU = function() {
  const { currentTime: n, played: o, paused: h } = this.$state;
  h() || (L(this, Nh, SB(
    d(this, Fv),
    d(this, Nh),
    n()
  )), o.set(new bC(d(this, Fv))));
}, // Called to update time again incase duration precision has changed.
gD = function(n) {
  const { clipStartTime: o, clipEndTime: h, duration: v } = this.$state;
  o() > 0 || h() > 0 || this.handle(
    this.createEvent("time-change", {
      detail: v(),
      trigger: n
    })
  );
}, pU = function() {
  var v;
  const { storage: n } = d(this, It), { canPlay: o, realCurrentTime: h } = this.$state;
  o() && ((v = n == null ? void 0 : n.setTime) == null || v.call(n, h()));
}, Hv = new WeakMap(), mU = function(n) {
  var D;
  const { storage: o } = d(this, It), { paused: h, seeking: v, ended: y, duration: C } = this.$state;
  S(this, se, gD).call(this, n), h() || this.dispatch("pause", { trigger: n }), v() && this.dispatch("seeked", {
    detail: C(),
    trigger: n
  }), y.set(!0), S(this, se, Jc).call(this), (D = o == null ? void 0 : o.setTime) == null || D.call(o, C(), !0), this.dispatch("ended", {
    trigger: n
  });
}, SD = function() {
  d(this, Hv).cancel(), this.$state.waiting.set(!1);
};
var _t, vU, yU, J5, gU, SU, TU, wU, EU, bU, CU, kU, xU, RU, DU, MU, LU, $U;
class Z5 extends ap {
  constructor() {
    super(...arguments);
    R(this, _t);
  }
  onSetup() {
    S(this, _t, vU).call(this);
    const n = [
      S(this, _t, gU),
      S(this, _t, TU),
      S(this, _t, RU),
      S(this, _t, DU),
      S(this, _t, EU),
      S(this, _t, CU),
      S(this, _t, kU),
      S(this, _t, MU),
      S(this, _t, $U),
      S(this, _t, LU),
      S(this, _t, wU),
      S(this, _t, xU),
      S(this, _t, bU),
      S(this, _t, yU),
      S(this, _t, SU)
    ];
    for (const o of n)
      J(o.bind(this));
  }
}
_t = new WeakSet(), vU = function() {
  var h;
  const n = {
    duration: "providedDuration",
    loop: "providedLoop",
    poster: "providedPoster",
    streamType: "providedStreamType",
    title: "providedTitle",
    viewType: "providedViewType"
  }, o = /* @__PURE__ */ new Set([
    "currentTime",
    "paused",
    "playbackRate",
    "volume"
  ]);
  for (const v of Object.keys(this.$props))
    o.has(v) || (h = this.$state[n[v] ?? v]) == null || h.set(this.$props[v]());
  this.$state.muted.set(this.$props.muted() || this.$props.volume() === 0);
}, // Sync "provided" props with internal state. Provided props are used to differentiate from
// provider inferred values.
yU = function() {
  const { viewType: n, streamType: o, title: h, poster: v, loop: y } = this.$props, C = this.$state;
  C.providedPoster.set(v()), C.providedStreamType.set(o()), C.providedViewType.set(n()), C.providedTitle.set(h()), C.providedLoop.set(y());
}, J5 = function() {
}, gU = function() {
  const { artist: n, artwork: o } = this.$props;
  this.$state.artist.set(n()), this.$state.artwork.set(o());
}, SU = function() {
  const { title: n } = this.$state;
  this.dispatch("title-change", { detail: n() });
}, TU = function() {
  const n = this.$props.autoPlay() || this.$props.autoplay();
  this.$state.autoPlay.set(n), this.dispatch("auto-play-change", { detail: n });
}, wU = function() {
  const n = this.$state.loop();
  this.dispatch("loop-change", { detail: n });
}, EU = function() {
  const n = this.$props.controls();
  this.$state.controls.set(n);
}, bU = function() {
  const { poster: n } = this.$state;
  this.dispatch("poster-change", { detail: n() });
}, CU = function() {
  const n = this.$props.crossOrigin() ?? this.$props.crossorigin(), o = n === !0 ? "" : n;
  this.$state.crossOrigin.set(o);
}, kU = function() {
  const { duration: n } = this.$props;
  this.dispatch("media-duration-change-request", {
    detail: n()
  });
}, xU = function() {
  const n = this.$props.playsInline() || this.$props.playsinline();
  this.$state.playsInline.set(n), this.dispatch("plays-inline-change", { detail: n });
}, RU = function() {
  const { clipStartTime: n } = this.$props;
  this.dispatch("media-clip-start-change-request", {
    detail: n()
  });
}, DU = function() {
  const { clipEndTime: n } = this.$props;
  this.dispatch("media-clip-end-change-request", {
    detail: n()
  });
}, MU = function() {
  this.dispatch("live-change", { detail: this.$state.live() });
}, LU = function() {
  this.$state.liveEdgeTolerance.set(this.$props.liveEdgeTolerance()), this.$state.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
}, $U = function() {
  this.dispatch("live-edge-change", { detail: this.$state.liveEdge() });
};
const XA = ["play", "pause", "seekforward", "seekbackward", "seekto"];
var ko, OU, AU, PU, _U;
class e8 extends ap {
  constructor() {
    super(...arguments);
    R(this, ko);
  }
  onConnect() {
    J(S(this, ko, AU).bind(this)), J(S(this, ko, PU).bind(this));
    const n = S(this, ko, _U).bind(this);
    for (const o of XA)
      navigator.mediaSession.setActionHandler(o, n);
    Wt(S(this, ko, OU).bind(this));
  }
}
ko = new WeakSet(), OU = function() {
  for (const n of XA)
    navigator.mediaSession.setActionHandler(n, null);
}, AU = function() {
  const { title: n, artist: o, artwork: h, poster: v } = this.$state;
  navigator.mediaSession.metadata = new MediaMetadata({
    title: n(),
    artist: o(),
    artwork: h() ?? [{ src: v() }]
  });
}, PU = function() {
  const { canPlay: n, paused: o } = this.$state;
  navigator.mediaSession.playbackState = n() ? o() ? "paused" : "playing" : "none";
}, _U = function(n) {
  const o = new yt("media-session-action", { detail: n });
  switch (n.action) {
    case "play":
      this.dispatch("media-play-request", { trigger: o });
      break;
    case "pause":
      this.dispatch("media-pause-request", { trigger: o });
      break;
    case "seekto":
    case "seekforward":
    case "seekbackward":
      this.dispatch("media-seek-request", {
        detail: ss(n.seekTime) ? n.seekTime : this.$state.currentTime() + (n.seekOffset ?? (n.action === "seekforward" ? 10 : -10)),
        trigger: o
      });
      break;
  }
};
let TD = st(!1);
En(document, "pointerdown", () => {
  TD.set(!1);
}), En(document, "keydown", (f) => {
  f.metaKey || f.altKey || f.ctrlKey || TD.set(!0);
});
var vd, xo, NU, UU, zU, FU;
class dw extends Hs {
  constructor() {
    super(...arguments);
    R(this, xo);
    R(this, vd, st(!1));
  }
  onConnect(n) {
    J(() => {
      const o = new gn(n);
      if (!TD()) {
        d(this, vd).set(!1), mC(n, !1), o.add("pointerenter", S(this, xo, zU).bind(this)).add("pointerleave", S(this, xo, FU).bind(this));
        return;
      }
      const h = document.activeElement === n;
      d(this, vd).set(h), mC(n, h), o.add("focus", S(this, xo, NU).bind(this)).add("blur", S(this, xo, UU).bind(this));
    });
  }
  focused() {
    return d(this, vd).call(this);
  }
}
vd = new WeakMap(), xo = new WeakSet(), NU = function() {
  d(this, vd).set(!0), mC(this.el, !0);
}, UU = function() {
  d(this, vd).set(!1), mC(this.el, !1);
}, zU = function() {
  ZA(this.el, !0);
}, FU = function() {
  ZA(this.el, !1);
};
function mC(f, s) {
  ht(f, "data-focus", s), ht(f, "data-hocus", s);
}
function ZA(f, s) {
  ht(f, "data-hocus", s), ht(f, "data-hover", s);
}
var t8 = Object.defineProperty, n8 = Object.getOwnPropertyDescriptor, hn = (f, s, n, o) => {
  for (var h = o > 1 ? void 0 : o ? n8(s, n) : s, v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = (o ? y(s, n, h) : y(h)) || h);
  return o && h && t8(s, n, h), h;
}, To, yr, zh, gr, Ce, es, $C, Iv, VU, HU, IU, qU, jU, nT, wD, BU, ED, QU, bD, YU, CD, GU, kD, WU, xD, KU, XU, ZU, JU;
const on = (To = class extends bi {
  constructor() {
    super();
    R(this, Ce);
    R(this, yr);
    R(this, zh);
    R(this, gr);
    Z(this, "canPlayQueue", new BN());
    Z(this, "remoteControl");
    R(this, Iv, !1);
    Z(this, "orientation");
    new Z5();
    const n = {
      player: this,
      qualities: new o5(),
      audioTracks: new XB(),
      storage: null,
      $provider: st(null),
      $providerSetup: st(!1),
      $props: this.$props,
      $state: this.$state
    };
    n.remote = this.remoteControl = new i_(
      void 0
    ), n.remote.setPlayer(this), n.textTracks = new a5(), n.textTracks[tt.crossOrigin] = this.$state.crossOrigin, n.textRenderers = new i5(n), n.ariaKeys = {}, L(this, yr, n), Ju(FM, n), this.orientation = new e0(), new dw(), new y5(n);
    const o = new W5();
    L(this, zh, new X5(o, n)), L(this, gr, new Q5(d(this, zh), o, n)), n.delegate = new I5(d(this, zh).handle.bind(d(this, zh)), n), n.notify = n.delegate.notify.bind(n.delegate), typeof navigator < "u" && "mediaSession" in navigator && new e8(), new WA("load", this.startLoading.bind(this)), new WA("posterLoad", this.startLoadingPoster.bind(this));
  }
  onSetup() {
    S(this, Ce, qU).call(this), J(S(this, Ce, IU).bind(this)), J(S(this, Ce, QU).bind(this)), J(S(this, Ce, BU).bind(this)), J(S(this, Ce, GU).bind(this)), J(S(this, Ce, YU).bind(this)), J(S(this, Ce, KU).bind(this)), J(S(this, Ce, WU).bind(this));
  }
  onAttach(n) {
    n.setAttribute("data-media-player", ""), Wi(n, "tabindex", "0"), Wi(n, "role", "region"), J(S(this, Ce, ZU).bind(this)), J(S(this, Ce, VU).bind(this)), J(S(this, Ce, HU).bind(this)), En(n, "find-media-player", S(this, Ce, jU).bind(this));
  }
  onConnect(n) {
    BP && ht(n, "data-iphone", "");
    const o = window.matchMedia("(pointer: coarse)");
    S(this, Ce, wD).call(this, o), o.onchange = S(this, Ce, wD).bind(this);
    const h = new ResizeObserver(Ey(S(this, Ce, nT).bind(this)));
    h.observe(n), J(S(this, Ce, nT).bind(this)), this.dispatch("media-player-connect", {
      detail: this,
      bubbles: !0,
      composed: !0
    }), Wt(() => {
      h.disconnect(), o.onchange = null;
    });
  }
  onDestroy() {
    d(this, yr).player = null, this.canPlayQueue.reset();
  }
  get provider() {
    return d(this, Ce, es);
  }
  get controls() {
    return d(this, gr).controls;
  }
  set controls(n) {
    d(this, Ce, $C).controls.set(n);
  }
  get title() {
    return ye(this.$state.title);
  }
  set title(n) {
    if (d(this, Iv)) {
      L(this, Iv, !1);
      return;
    }
    d(this, Ce, $C).title.set(n);
  }
  get qualities() {
    return d(this, yr).qualities;
  }
  get audioTracks() {
    return d(this, yr).audioTracks;
  }
  get textTracks() {
    return d(this, yr).textTracks;
  }
  get textRenderers() {
    return d(this, yr).textRenderers;
  }
  get duration() {
    return this.$state.duration();
  }
  set duration(n) {
    d(this, Ce, $C).duration.set(n);
  }
  get paused() {
    return ye(this.$state.paused);
  }
  set paused(n) {
    S(this, Ce, ED).call(this, n);
  }
  get muted() {
    return ye(this.$state.muted);
  }
  set muted(n) {
    S(this, Ce, bD).call(this, n);
  }
  get currentTime() {
    return ye(this.$state.currentTime);
  }
  set currentTime(n) {
    S(this, Ce, CD).call(this, n);
  }
  get volume() {
    return ye(this.$state.volume);
  }
  set volume(n) {
    S(this, Ce, kD).call(this, n);
  }
  get playbackRate() {
    return ye(this.$state.playbackRate);
  }
  set playbackRate(n) {
    S(this, Ce, xD).call(this, n);
  }
  async play(n) {
    return d(this, gr).play(n);
  }
  async pause(n) {
    return d(this, gr).pause(n);
  }
  async enterFullscreen(n, o) {
    return d(this, gr).enterFullscreen(n, o);
  }
  async exitFullscreen(n, o) {
    return d(this, gr).exitFullscreen(n, o);
  }
  enterPictureInPicture(n) {
    return d(this, gr).enterPictureInPicture(n);
  }
  exitPictureInPicture(n) {
    return d(this, gr).exitPictureInPicture(n);
  }
  seekToLiveEdge(n) {
    d(this, gr).seekToLiveEdge(n);
  }
  startLoading(n) {
    d(this, yr).notify("can-load", void 0, n);
  }
  startLoadingPoster(n) {
    d(this, yr).notify("can-load-poster", void 0, n);
  }
  requestAirPlay(n) {
    return d(this, gr).requestAirPlay(n);
  }
  requestGoogleCast(n) {
    return d(this, gr).requestGoogleCast(n);
  }
  setAudioGain(n, o) {
    return d(this, gr).setAudioGain(n, o);
  }
  destroy() {
    super.destroy(), d(this, yr).remote.setPlayer(null), this.dispatch("destroy");
  }
}, yr = new WeakMap(), zh = new WeakMap(), gr = new WeakMap(), Ce = new WeakSet(), es = function() {
  return d(this, yr).$provider();
}, $C = function() {
  return this.$props;
}, Iv = new WeakMap(), VU = function() {
  const n = this.$el, { title: o, live: h, viewType: v, providedTitle: y } = this.$state, C = h(), D = FP(v()), $ = D !== "Unknown" ? `${C ? "Live " : ""}${D}` : C ? "Live" : "Media", _ = o();
  ht(
    this.el,
    "aria-label",
    `${$} Player` + (_ ? ` - ${_}` : "")
  ), n != null && n.hasAttribute("title") && (L(this, Iv, !0), n == null || n.removeAttribute("title"));
}, HU = function() {
  const n = this.orientation.landscape ? "landscape" : "portrait";
  this.$state.orientation.set(n), ht(this.el, "data-orientation", n), S(this, Ce, nT).call(this);
}, IU = function() {
  this.$state.canPlay() && d(this, Ce, es) ? this.canPlayQueue.start() : this.canPlayQueue.stop();
}, qU = function() {
  if (To[TR]) {
    this.setAttributes(To[TR]);
    return;
  }
  const n = {
    "data-load": function() {
      return this.$props.load();
    },
    "data-captions": function() {
      const h = this.$state.textTrack();
      return !!h && _a(h);
    },
    "data-ios-controls": function() {
      return this.$state.iOSControls();
    },
    "data-controls": function() {
      return this.controls.showing;
    },
    "data-buffering": function() {
      const { canLoad: h, canPlay: v, waiting: y } = this.$state;
      return h() && (!v() || y());
    },
    "data-error": function() {
      const { error: h } = this.$state;
      return !!h();
    },
    "data-autoplay-error": function() {
      const { autoPlayError: h } = this.$state;
      return !!h();
    }
  }, o = {
    autoPlay: "autoplay",
    canAirPlay: "can-airplay",
    canPictureInPicture: "can-pip",
    pictureInPicture: "pip",
    playsInline: "playsinline",
    remotePlaybackState: "remote-state",
    remotePlaybackType: "remote-type",
    isAirPlayConnected: "airplay",
    isGoogleCastConnected: "google-cast"
  };
  for (const h of V5) {
    const v = "data-" + (o[h] ?? M0(h));
    n[v] = function() {
      return this.$state[h]();
    };
  }
  delete n.title, To[TR] = n, this.setAttributes(n);
}, jU = function(n) {
  n.detail(this);
}, nT = function() {
  if (!this.el) return;
  const n = this.el.clientWidth, o = this.el.clientHeight;
  this.$state.width.set(n), this.$state.height.set(o), Nd(this.el, "--player-width", n + "px"), Nd(this.el, "--player-height", o + "px");
}, wD = function(n) {
  const o = n.matches ? "coarse" : "fine";
  ht(this.el, "data-pointer", o), this.$state.pointer.set(o), S(this, Ce, nT).call(this);
}, BU = function() {
  S(this, Ce, ED).call(this, this.$props.paused());
}, ED = function(n) {
  n ? this.canPlayQueue.enqueue("paused", () => d(this, gr).pause()) : this.canPlayQueue.enqueue("paused", () => d(this, gr).play());
}, QU = function() {
  S(this, Ce, bD).call(this, this.$props.muted());
}, bD = function(n) {
  this.canPlayQueue.enqueue("muted", () => {
    d(this, Ce, es) && d(this, Ce, es).setMuted(n);
  });
}, YU = function() {
  S(this, Ce, CD).call(this, this.$props.currentTime());
}, CD = function(n) {
  this.canPlayQueue.enqueue("currentTime", () => {
    const { currentTime: o } = this.$state;
    n !== ye(o) && ye(() => {
      if (!d(this, Ce, es)) return;
      const h = n_(n, this.$state);
      Number.isFinite(h) && d(this, Ce, es).setCurrentTime(h);
    });
  });
}, GU = function() {
  S(this, Ce, kD).call(this, this.$props.volume());
}, kD = function(n) {
  const o = VM(0, n, 1);
  this.canPlayQueue.enqueue("volume", () => {
    d(this, Ce, es) && d(this, Ce, es).setVolume(o);
  });
}, WU = function() {
  S(this, Ce, xD).call(this, this.$props.playbackRate());
}, xD = function(n) {
  this.canPlayQueue.enqueue("rate", () => {
    var o, h;
    d(this, Ce, es) && ((h = (o = d(this, Ce, es)).setPlaybackRate) == null || h.call(o, n));
  });
}, KU = function() {
  S(this, Ce, XU).call(this, this.$props.playsInline());
}, XU = function(n) {
  this.canPlayQueue.enqueue("playsinline", () => {
    var o, h;
    d(this, Ce, es) && ((h = (o = d(this, Ce, es)).setPlaysInline) == null || h.call(o, n));
  });
}, ZU = function() {
  var h;
  let n = this.$props.storage(), o = Ze(n) ? new HB() : n;
  if (o != null && o.onChange) {
    const { source: v } = this.$state, y = Ze(n) ? n : (h = this.el) == null ? void 0 : h.id, C = ow(S(this, Ce, JU).bind(this));
    J(() => o.onChange(v(), C(), y || void 0));
  }
  d(this, yr).storage = o, d(this, yr).textTracks.setStorage(o), Wt(() => {
    var v;
    (v = o == null ? void 0 : o.onDestroy) == null || v.call(o), d(this, yr).storage = null, d(this, yr).textTracks.setStorage(null);
  });
}, JU = function() {
  const { clipStartTime: n, clipEndTime: o } = this.$props, { source: h } = this.$state, v = h();
  return v.src ? `${v.src}:${n()}:${o()}` : null;
}, Z(To, "props", H5), Z(To, "state", xy), To);
hn([
  rn
], on.prototype, "canPlayQueue", 2);
hn([
  rn
], on.prototype, "remoteControl", 2);
hn([
  rn
], on.prototype, "provider", 1);
hn([
  rn
], on.prototype, "controls", 1);
hn([
  rn
], on.prototype, "orientation", 2);
hn([
  rn
], on.prototype, "title", 1);
hn([
  rn
], on.prototype, "qualities", 1);
hn([
  rn
], on.prototype, "audioTracks", 1);
hn([
  rn
], on.prototype, "textTracks", 1);
hn([
  rn
], on.prototype, "textRenderers", 1);
hn([
  rn
], on.prototype, "duration", 1);
hn([
  rn
], on.prototype, "paused", 1);
hn([
  rn
], on.prototype, "muted", 1);
hn([
  rn
], on.prototype, "currentTime", 1);
hn([
  rn
], on.prototype, "volume", 1);
hn([
  rn
], on.prototype, "playbackRate", 1);
hn([
  Zi
], on.prototype, "play", 1);
hn([
  Zi
], on.prototype, "pause", 1);
hn([
  Zi
], on.prototype, "enterFullscreen", 1);
hn([
  Zi
], on.prototype, "exitFullscreen", 1);
hn([
  Zi
], on.prototype, "enterPictureInPicture", 1);
hn([
  Zi
], on.prototype, "exitPictureInPicture", 1);
hn([
  Zi
], on.prototype, "seekToLiveEdge", 1);
hn([
  Zi
], on.prototype, "startLoading", 1);
hn([
  Zi
], on.prototype, "startLoadingPoster", 1);
hn([
  Zi
], on.prototype, "requestAirPlay", 1);
hn([
  Zi
], on.prototype, "requestGoogleCast", 1);
hn([
  Zi
], on.prototype, "setAudioGain", 1);
let i8 = on;
function r8(f, s) {
  return fetch(f, s).then((n) => n.text()).then((n) => /type="static"/.test(n) ? "on-demand" : "live");
}
function ez(f, s) {
  return fetch(f, s).then((n) => n.text()).then((n) => {
    const o = a8(n);
    if (o)
      return ez(
        /^https?:/.test(o) ? o : new URL(o, f).href,
        s
      );
    const h = /EXT-X-PLAYLIST-TYPE:\s*VOD/.test(n) ? "on-demand" : "live";
    return h === "live" && s8(n) >= 10 && (/#EXT-X-DVR-ENABLED:\s*true/.test(n) || n.includes("#EXT-X-DISCONTINUITY")) ? "live:dvr" : h;
  });
}
function a8(f) {
  const s = f.match(/#EXT-X-STREAM-INF:[^\n]+(\n[^\n]+)*/g);
  return s ? s[0].split(`
`)[1].trim() : null;
}
function s8(f) {
  const s = f.split(`
`);
  for (const n of s)
    if (n.startsWith("#EXT-X-TARGETDURATION")) {
      const o = parseFloat(n.split(":")[1]);
      if (!isNaN(o))
        return o;
    }
  return -1;
}
const RD = /* @__PURE__ */ new Map();
var qv, jv, AT, qt, Vu, yi, tz, nz, DD, MD, LD, iz, rz, az;
class l8 {
  constructor(s, n, o, h = []) {
    R(this, yi);
    R(this, qv, !1);
    R(this, jv);
    R(this, AT);
    R(this, qt);
    R(this, Vu);
    L(this, AT, s), L(this, qt, n), L(this, Vu, o);
    const v = new nD(), y = new GR(), C = new IM(), D = new C5(), $ = new F5(), _ = new z5(), A = [$, _];
    L(this, jv, ow(() => {
      const W = n.$state.remotePlaybackLoader(), ne = n.$props.preferNativeHLS() ? [C, D, v, y, ...A, ...h] : [y, C, D, v, ...A, ...h];
      return W ? [W, ...ne] : ne;
    }));
    const { $state: B } = n;
    B.sources.set(JA(n.$props.src()));
    for (const W of B.sources()) {
      const ne = d(this, jv).call(this).find((Re) => Re.canPlay(W));
      if (!ne) continue;
      const ce = ne.mediaType(W);
      n.$state.source.set(W), n.$state.mediaType.set(ce), n.$state.inferredViewType.set(ce), d(this, Vu).set(ne), L(this, qv, !0);
      break;
    }
  }
  connect() {
    const s = d(this, Vu).call(this);
    d(this, qv) && (S(this, yi, MD).call(this, d(this, qt).$state.source(), s), S(this, yi, LD).call(this, s), L(this, qv, !1)), J(S(this, yi, tz).bind(this)), J(S(this, yi, nz).bind(this)), J(S(this, yi, iz).bind(this)), J(S(this, yi, rz).bind(this)), J(S(this, yi, az).bind(this));
  }
}
qv = new WeakMap(), jv = new WeakMap(), AT = new WeakMap(), qt = new WeakMap(), Vu = new WeakMap(), yi = new WeakSet(), tz = function() {
  d(this, qt).notify("sources-change", [
    ...JA(d(this, qt).$props.src()),
    ...d(this, AT).call(this)
  ]);
}, nz = function() {
  var y;
  const { $state: s } = d(this, qt), n = s.sources(), o = ye(s.source), h = S(this, yi, DD).call(this, o, n);
  if (((y = n[0]) == null ? void 0 : y.src) && !h.src && !h.type) {
    const { crossOrigin: C } = s, D = sT(C()), $ = new AbortController();
    return Promise.all(
      n.map(
        (_) => Ze(_.src) && _.type === "?" ? fetch(_.src, {
          method: "HEAD",
          credentials: D,
          signal: $.signal
        }).then((A) => (_.type = A.headers.get("content-type") || "??", RD.set(_.src, _.type), _)).catch(() => _) : _
      )
    ).then((_) => {
      if ($.signal.aborted) return;
      const A = S(this, yi, DD).call(this, ye(s.source), _);
      Xu(), A.src || d(this, qt).notify("error", {
        message: "Failed to load resource.",
        code: 4
      });
    }), () => $.abort();
  }
  Xu();
}, DD = function(s, n) {
  let o = { src: "", type: "" }, h = null, v = new yt("sources-change", { detail: { sources: n } }), y = d(this, jv).call(this), { started: C, paused: D, currentTime: $, quality: _, savedState: A } = d(this, qt).$state;
  for (const B of n) {
    const W = y.find((ne) => ne.canPlay(B));
    if (W) {
      o = B, h = W;
      break;
    }
  }
  if (LR(o)) {
    const B = _(), W = n.find((ne) => ne.src === (B == null ? void 0 : B.src));
    ye(C) ? A.set({
      paused: ye(D),
      currentTime: ye($)
    }) : A.set(null), W && (o = W, v = new yt("quality-change", {
      detail: { quality: B }
    }));
  }
  return tP(s, o) || S(this, yi, MD).call(this, o, h, v), h !== ye(d(this, Vu)) && S(this, yi, LD).call(this, h, v), o;
}, MD = function(s, n, o) {
  d(this, qt).notify("source-change", s, o), d(this, qt).notify("media-type-change", (n == null ? void 0 : n.mediaType(s)) || "unknown", o);
}, LD = function(s, n) {
  d(this, qt).$providerSetup.set(!1), d(this, qt).notify("provider-change", null, n), s && ye(() => {
    var o;
    return (o = s.preconnect) == null ? void 0 : o.call(s, d(this, qt));
  }), d(this, Vu).set(s), d(this, qt).notify("provider-loader-change", s, n);
}, iz = function() {
  const s = d(this, qt).$provider();
  if (!(!s || ye(d(this, qt).$providerSetup))) {
    if (d(this, qt).$state.canLoad()) {
      bl(() => s.setup(), s.scope), d(this, qt).$providerSetup.set(!0);
      return;
    }
    ye(() => {
      var n;
      return (n = s.preconnect) == null ? void 0 : n.call(s);
    });
  }
}, rz = function() {
  if (!d(this, qt).$providerSetup()) return;
  const s = d(this, qt).$provider(), n = d(this, qt).$state.source(), o = ye(d(this, qt).$state.crossOrigin), h = ye(d(this, qt).$props.preferNativeHLS);
  if (!tP(s == null ? void 0 : s.currentSrc, n)) {
    if (d(this, qt).$state.canLoad()) {
      const v = new AbortController();
      return ky(n) ? (h || !NM()) && ez(n.src, {
        credentials: sT(o),
        signal: v.signal
      }).then((y) => {
        d(this, qt).notify("stream-type-change", y);
      }).catch(KC) : UM(n) ? r8(n.src, {
        credentials: sT(o),
        signal: v.signal
      }).then((y) => {
        d(this, qt).notify("stream-type-change", y);
      }).catch(KC) : d(this, qt).notify("stream-type-change", "on-demand"), ye(() => {
        const y = ye(d(this, qt).$state.preload);
        return s == null ? void 0 : s.loadSource(n, y).catch((C) => {
        });
      }), () => v.abort();
    }
    try {
      Ze(n.src) && A0(new URL(n.src).origin);
    } catch {
    }
  }
}, az = function() {
  const s = d(this, Vu).call(this), { providedPoster: n, source: o, canLoadPoster: h } = d(this, qt).$state;
  if (!s || !s.loadPoster || !o() || !h() || n()) return;
  const v = new AbortController(), y = new yt("source-change", { detail: o });
  return s.loadPoster(o(), d(this, qt), v).then((C) => {
    d(this, qt).notify("poster-change", C || "", y);
  }).catch(() => {
    d(this, qt).notify("poster-change", "", y);
  }), () => {
    v.abort();
  };
};
function JA(f) {
  return (Vr(f) ? f : [f]).map((s) => Ze(s) ? { src: s, type: eP(s) } : { ...s, type: eP(s.src, s.type) });
}
function eP(f, s) {
  return Ze(s) && s.length ? s : Ze(f) && RD.has(f) ? RD.get(f) : !s && ky({ src: f, type: "" }) ? "application/x-mpegurl" : !s && UM({ src: f, type: "" }) ? "application/dash+xml" : !Ze(f) || f.startsWith("blob:") ? "video/object" : f.includes("youtube") || f.includes("youtu.be") ? "video/youtube" : f.includes("vimeo") && !f.includes("progressive_redirect") && !f.includes(".m3u8") ? "video/vimeo" : "?";
}
function tP(f, s) {
  return (f == null ? void 0 : f.src) === (s == null ? void 0 : s.src) && (f == null ? void 0 : f.type) === (s == null ? void 0 : s.type);
}
var PT, yd, _T, p0, sz;
class o8 {
  constructor(s, n) {
    R(this, p0);
    R(this, PT);
    R(this, yd);
    R(this, _T, []);
    L(this, PT, s), L(this, yd, n), J(S(this, p0, sz).bind(this));
  }
}
PT = new WeakMap(), yd = new WeakMap(), _T = new WeakMap(), p0 = new WeakSet(), sz = function() {
  const s = d(this, PT).call(this);
  for (const n of d(this, _T))
    if (!s.some((o) => o.id === n.id)) {
      const o = n.id && d(this, yd).textTracks.getById(n.id);
      o && d(this, yd).textTracks.remove(o);
    }
  for (const n of s) {
    const o = n.id || Ud.createId(n);
    d(this, yd).textTracks.getById(o) || (n.id = o, d(this, yd).textTracks.add(n));
  }
  L(this, _T, s);
};
var u8 = Object.defineProperty, c8 = Object.getOwnPropertyDescriptor, d8 = (f, s, n, o) => {
  for (var h = c8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && u8(s, n, h), h;
}, wC, yl, NT, UT, zT, Bv, Qv, us, oz, $D, OD, AD;
let lz = (wC = class extends bi {
  constructor() {
    super(...arguments);
    R(this, us);
    R(this, yl);
    R(this, NT);
    R(this, UT, st([]));
    R(this, zT, st([]));
    R(this, Bv, null);
    R(this, Qv, -1);
  }
  onSetup() {
    L(this, yl, Ua()), L(this, NT, new l8(
      d(this, UT),
      d(this, yl),
      this.$state.loader,
      this.$props.loaders()
    ));
  }
  onAttach(n) {
    n.setAttribute("data-media-provider", "");
  }
  onConnect(n) {
    d(this, NT).connect(), new o8(d(this, zT), d(this, yl));
    const o = new ResizeObserver(Ey(S(this, us, OD).bind(this)));
    o.observe(n);
    const h = new MutationObserver(S(this, us, AD).bind(this));
    h.observe(n, { attributes: !0, childList: !0 }), S(this, us, OD).call(this), S(this, us, AD).call(this), Wt(() => {
      o.disconnect(), h.disconnect();
    });
  }
  load(n) {
    n == null || n.setAttribute("aria-hidden", "true"), window.cancelAnimationFrame(d(this, Qv)), L(this, Qv, requestAnimationFrame(() => S(this, us, oz).call(this, n))), Wt(() => {
      window.cancelAnimationFrame(d(this, Qv));
    });
  }
  onDestroy() {
    L(this, Bv, null), S(this, us, $D).call(this);
  }
}, yl = new WeakMap(), NT = new WeakMap(), UT = new WeakMap(), zT = new WeakMap(), Bv = new WeakMap(), Qv = new WeakMap(), us = new WeakSet(), oz = function(n) {
  if (!this.scope) return;
  const o = this.$state.loader(), { $provider: h } = d(this, yl);
  d(this, Bv) === o && (o == null ? void 0 : o.target) === n && ye(h) || (S(this, us, $D).call(this), L(this, Bv, o), o && (o.target = n || null), !(!o || !n) && o.load(d(this, yl)).then((v) => {
    this.scope && ye(this.$state.loader) === o && d(this, yl).notify("provider-change", v);
  }));
}, $D = function() {
  var n;
  (n = d(this, yl)) == null || n.notify("provider-change", null);
}, OD = function() {
  if (!this.el) return;
  const { player: n, $state: o } = d(this, yl), h = this.el.offsetWidth, v = this.el.offsetHeight;
  n && (o.mediaWidth.set(h), o.mediaHeight.set(v), n.el && (Nd(n.el, "--media-width", h + "px"), Nd(n.el, "--media-height", v + "px")));
}, AD = function() {
  const n = [], o = [], h = this.el.children;
  for (const v of h)
    if (!v.hasAttribute("data-vds")) {
      if (v instanceof HTMLSourceElement) {
        const y = {
          id: v.id,
          src: v.src,
          type: v.type
        };
        for (const C of ["id", "src", "width", "height", "bitrate", "codec"]) {
          const D = v.getAttribute(`data-${C}`);
          Ze(D) && (y[C] = /id|src|codec/.test(C) ? D : Number(D));
        }
        n.push(y);
      } else if (v instanceof HTMLTrackElement) {
        const y = {
          src: v.src,
          kind: v.track.kind,
          language: v.srclang,
          label: v.label,
          default: v.default,
          type: v.getAttribute("data-type")
        };
        o.push({
          id: v.id || Ud.createId(y),
          ...y
        });
      }
    }
  d(this, UT).set(n), d(this, zT).set(o), Xu();
}, Z(wC, "props", {
  loaders: []
}), Z(wC, "state", new Cy({
  loader: null
})), wC);
d8([
  Zi
], lz.prototype, "load");
var gl, _d, uz, Fh, Vh, ho, OC;
class f8 extends Hs {
  constructor(n) {
    super();
    R(this, _d);
    R(this, gl);
    R(this, Fh, -1);
    R(this, Vh, -1);
    R(this, ho, null);
    L(this, gl, n), J(S(this, _d, uz).bind(this));
  }
  onDestroy() {
    var n;
    (n = d(this, ho)) == null || n.call(this), L(this, ho, null);
  }
  show(n) {
    var o, h, v;
    S(this, _d, OC).call(this), window.cancelAnimationFrame(d(this, Vh)), L(this, Vh, -1), (o = d(this, ho)) == null || o.call(this), L(this, ho, null), L(this, Fh, window.setTimeout(() => {
      L(this, Fh, -1);
      const y = d(this, gl).content();
      y && y.style.removeProperty("display"), ye(() => d(this, gl).onChange(!0, n));
    }, ((v = (h = d(this, gl)).showDelay) == null ? void 0 : v.call(h)) ?? 0));
  }
  hide(n) {
    S(this, _d, OC).call(this), ye(() => d(this, gl).onChange(!1, n)), L(this, Vh, requestAnimationFrame(() => {
      var h;
      S(this, _d, OC).call(this), L(this, Vh, -1);
      const o = d(this, gl).content();
      if (o) {
        const v = () => {
          o.style.display = "none", L(this, ho, null);
        };
        if (t5(o)) {
          (h = d(this, ho)) == null || h.call(this);
          const C = En(o, "animationend", v, { once: !0 });
          L(this, ho, C);
        } else
          v();
      }
    }));
  }
}
gl = new WeakMap(), _d = new WeakSet(), uz = function() {
  const n = d(this, gl).trigger();
  if (!n) {
    this.hide();
    return;
  }
  const o = this.show.bind(this), h = this.hide.bind(this);
  d(this, gl).listen(n, o, h);
}, Fh = new WeakMap(), Vh = new WeakMap(), ho = new WeakMap(), OC = function() {
  window.clearTimeout(d(this, Fh)), L(this, Fh, -1);
};
var Hu, Ro, cz, dz, fz, hz;
class i0 extends Hs {
  constructor(n) {
    super();
    R(this, Ro);
    R(this, Hu);
    L(this, Hu, n), new dw(), n.keyShortcut && new w5(n.keyShortcut);
  }
  onSetup() {
    const { disabled: n } = this.$props;
    this.setAttributes({
      "data-pressed": d(this, Hu).isPresssed,
      "aria-pressed": S(this, Ro, cz).bind(this),
      "aria-disabled": () => n() ? "true" : null
    });
  }
  onAttach(n) {
    Wi(n, "tabindex", "0"), Wi(n, "role", "button"), Wi(n, "type", "button");
  }
  onConnect(n) {
    const o = vy(n, S(this, Ro, fz).bind(this));
    for (const h of ["click", "touchstart"])
      o.add(h, S(this, Ro, hz).bind(this), {
        passive: !0
      });
  }
}
Hu = new WeakMap(), Ro = new WeakSet(), cz = function() {
  return XC(d(this, Hu).isPresssed());
}, dz = function(n) {
  aB(d(this, Hu).isPresssed) && d(this, Hu).isPresssed.set((o) => !o);
}, fz = function(n) {
  if (this.$props.disabled() || this.el.hasAttribute("data-disabled")) {
    n.preventDefault(), n.stopImmediatePropagation();
    return;
  }
  n.preventDefault(), (d(this, Hu).onPress ?? S(this, Ro, dz)).call(this, n);
}, hz = function(n) {
  this.$props.disabled() && (n.preventDefault(), n.stopImmediatePropagation());
}, Z(i0, "props", {
  disabled: !1
});
var h8 = Object.defineProperty, p8 = Object.getOwnPropertyDescriptor, m8 = (f, s, n, o) => {
  for (var h = p8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && h8(s, n, h), h;
}, FT;
class pz extends bi {
  constructor() {
    super();
    R(this, FT, st(!1));
    new i0({
      isPresssed: d(this, FT)
    });
  }
  get pressed() {
    return d(this, FT).call(this);
  }
}
FT = new WeakMap(), Z(pz, "props", {
  disabled: !1,
  defaultPressed: !1
});
m8([
  rn
], pz.prototype, "pressed");
var xR, gd, ec, mz, PD, vz;
let v8 = (xR = class extends bi {
  constructor() {
    super();
    R(this, ec);
    R(this, gd);
    new i0({
      isPresssed: S(this, ec, PD).bind(this),
      keyShortcut: "toggleFullscreen",
      onPress: S(this, ec, mz).bind(this)
    });
  }
  onSetup() {
    L(this, gd, Ua());
    const { fullscreen: n } = d(this, gd).$state, o = S(this, ec, vz).bind(this);
    this.setAttributes({
      "data-active": n,
      "data-supported": o,
      "aria-hidden": sp(() => !o())
    });
  }
  onAttach(n) {
    n.setAttribute("data-media-tooltip", "fullscreen"), JB(n, "Fullscreen");
  }
}, gd = new WeakMap(), ec = new WeakSet(), mz = function(n) {
  const o = d(this, gd).remote, h = this.$props.target();
  S(this, ec, PD).call(this) ? o.exitFullscreen(h, n) : o.enterFullscreen(h, n);
}, PD = function() {
  const { fullscreen: n } = d(this, gd).$state;
  return n();
}, vz = function() {
  const { canFullscreen: n } = d(this, gd).$state;
  return n();
}, Z(xR, "props", {
  ...i0.props,
  target: "prefer-media"
}), xR);
const P0 = new Cy({
  min: 0,
  max: 100,
  value: 0,
  step: 1,
  pointerValue: 0,
  focused: !1,
  dragging: !1,
  pointing: !1,
  hidden: !1,
  get active() {
    return this.dragging || this.focused || this.pointing;
  },
  get fillRate() {
    return nP(this.min, this.max, this.value);
  },
  get fillPercent() {
    return this.fillRate * 100;
  },
  get pointerRate() {
    return nP(this.min, this.max, this.pointerValue);
  },
  get pointerPercent() {
    return this.pointerRate * 100;
  }
});
function nP(f, s, n) {
  const o = s - f, h = n - f;
  return o > 0 ? h / o : 0;
}
var Yv, Sd, m0, gz;
class yz extends Hs {
  constructor(n) {
    super();
    R(this, m0);
    R(this, Yv);
    R(this, Sd);
    L(this, Yv, n);
  }
  onConnect(n) {
    L(this, Sd, new IntersectionObserver((o) => {
      var h, v;
      (v = (h = d(this, Yv)).callback) == null || v.call(h, o, d(this, Sd));
    }, d(this, Yv))), d(this, Sd).observe(n), Wt(S(this, m0, gz).bind(this));
  }
}
Yv = new WeakMap(), Sd = new WeakMap(), m0 = new WeakSet(), /**
 * Disconnect any active intersection observers.
 */
gz = function() {
  var n;
  (n = d(this, Sd)) == null || n.disconnect(), L(this, Sd, void 0);
};
const QM = by(), oT = by();
function y8(f, s, n, o) {
  return VM(f, Na(n, PR(o)), s);
}
function g8(f, s, n, o) {
  const h = VM(0, n, 1), v = s - f, y = v * h, C = y / o, D = o * Math.round(C);
  return f + D;
}
const ER = {
  Left: -1,
  ArrowLeft: -1,
  Up: 1,
  ArrowUp: 1,
  Right: 1,
  ArrowRight: 1,
  Down: -1,
  ArrowDown: -1
};
var Sr, Td, Gv, $e, Sz, wd, Sl, Iu, Tz, wz, Ez, bz, Cz, AC, ed, iT, kz, xz, Rz, Dz, PC, _D, Wv, qu, Mz, Lz, ND, UD, $z, Oz, v0;
class S8 extends Hs {
  constructor(n, o) {
    super();
    R(this, $e);
    R(this, Sr);
    R(this, Td);
    R(this, Gv);
    R(this, wd, null);
    R(this, Sl, null);
    R(this, Iu, null);
    // -------------------------------------------------------------------------------------------
    // Keyboard Events
    // -------------------------------------------------------------------------------------------
    R(this, Wv);
    R(this, qu, !1);
    R(this, v0, cw(
      (n) => {
        S(this, $e, ed).call(this, S(this, $e, iT).call(this, n), n);
      },
      20,
      { leading: !0 }
    ));
    L(this, Sr, n), L(this, Td, o);
  }
  onSetup() {
    ep(oT) && L(this, Gv, Us(oT));
  }
  onConnect(n) {
    J(S(this, $e, Ez).bind(this, n)), J(S(this, $e, bz).bind(this, n)), d(this, Sr).swipeGesture && J(S(this, $e, Sz).bind(this));
  }
}
Sr = new WeakMap(), Td = new WeakMap(), Gv = new WeakMap(), $e = new WeakSet(), Sz = function() {
  var o;
  const { pointer: n } = d(this, Td).$state;
  if (n() !== "coarse" || !d(this, Sr).swipeGesture()) {
    L(this, wd, null);
    return;
  }
  L(this, wd, (o = d(this, Td).player.el) == null ? void 0 : o.querySelector(
    "media-provider,[data-media-provider]"
  )), d(this, wd) && new gn(d(this, wd)).add("touchstart", S(this, $e, Tz).bind(this), {
    passive: !0
  }).add("touchmove", S(this, $e, wz).bind(this), { passive: !1 });
}, wd = new WeakMap(), Sl = new WeakMap(), Iu = new WeakMap(), Tz = function(n) {
  L(this, Sl, n.touches[0]);
}, wz = function(n) {
  if (Zu(d(this, Sl)) || u_(n)) return;
  const o = n.touches[0], h = o.clientX - d(this, Sl).clientX, v = o.clientY - d(this, Sl).clientY, y = this.$state.dragging();
  !y && Math.abs(v) > 5 || y || (n.preventDefault(), Math.abs(h) > 20 && (L(this, Sl, o), L(this, Iu, this.$state.value()), S(this, $e, PC).call(this, d(this, Iu), n)));
}, Ez = function(n) {
  const { hidden: o } = this.$props;
  En(n, "focus", S(this, $e, Cz).bind(this)), !(o() || d(this, Sr).isDisabled()) && new gn(n).add("keyup", S(this, $e, Lz).bind(this)).add("keydown", S(this, $e, Mz).bind(this)).add("pointerenter", S(this, $e, kz).bind(this)).add("pointermove", S(this, $e, xz).bind(this)).add("pointerleave", S(this, $e, Rz).bind(this)).add("pointerdown", S(this, $e, Dz).bind(this));
}, bz = function(n) {
  d(this, Sr).isDisabled() || !this.$state.dragging() || new gn(document).add("pointerup", S(this, $e, $z).bind(this), { capture: !0 }).add("pointermove", d(this, v0).bind(this)).add("touchmove", S(this, $e, Oz).bind(this), {
    passive: !1
  });
}, Cz = function() {
  S(this, $e, ed).call(this, this.$state.value());
}, AC = function(n, o) {
  var _, A, B, W;
  const { value: h, min: v, max: y, dragging: C } = this.$state, D = Math.max(v(), Math.min(n, y()));
  h.set(D);
  const $ = this.createEvent("value-change", { detail: D, trigger: o });
  if (this.dispatch($), (A = (_ = d(this, Sr)).onValueChange) == null || A.call(_, $), C()) {
    const ne = this.createEvent("drag-value-change", { detail: D, trigger: o });
    this.dispatch(ne), (W = (B = d(this, Sr)).onDragValueChange) == null || W.call(B, ne);
  }
}, ed = function(n, o) {
  const { pointerValue: h, dragging: v } = this.$state;
  h.set(n), this.dispatch("pointer-value-change", { detail: n, trigger: o }), v() && S(this, $e, AC).call(this, n, o);
}, iT = function(n) {
  let o, h = this.el.getBoundingClientRect(), { min: v, max: y } = this.$state;
  if (this.$props.orientation() === "vertical") {
    const { bottom: C, height: D } = h;
    o = (C - n.clientY) / D;
  } else if (d(this, Sl) && ss(d(this, Iu))) {
    const { width: C } = d(this, wd).getBoundingClientRect(), D = (n.clientX - d(this, Sl).clientX) / C, $ = y() - v(), _ = $ * Math.abs(D);
    o = (D < 0 ? d(this, Iu) - _ : d(this, Iu) + _) / $;
  } else {
    const { left: C, width: D } = h;
    o = (n.clientX - C) / D;
  }
  return Math.max(
    v(),
    Math.min(
      y(),
      d(this, Sr).roundValue(
        g8(v(), y(), o, d(this, Sr).getStep())
      )
    )
  );
}, kz = function(n) {
  this.$state.pointing.set(!0);
}, xz = function(n) {
  const { dragging: o } = this.$state;
  o() || S(this, $e, ed).call(this, S(this, $e, iT).call(this, n), n);
}, Rz = function(n) {
  this.$state.pointing.set(!1);
}, Dz = function(n) {
  if (n.button !== 0) return;
  const o = S(this, $e, iT).call(this, n);
  S(this, $e, PC).call(this, o, n), S(this, $e, ed).call(this, o, n);
}, PC = function(n, o) {
  var y, C, D, $;
  const { dragging: h } = this.$state;
  if (h()) return;
  h.set(!0), d(this, Td).remote.pauseControls(o);
  const v = this.createEvent("drag-start", { detail: n, trigger: o });
  this.dispatch(v), (C = (y = d(this, Sr)).onDragStart) == null || C.call(y, v), ($ = (D = d(this, Gv)) == null ? void 0 : D.onDragStart) == null || $.call(D);
}, _D = function(n, o) {
  var y, C, D, $;
  const { dragging: h } = this.$state;
  if (!h()) return;
  h.set(!1), d(this, Td).remote.resumeControls(o);
  const v = this.createEvent("drag-end", { detail: n, trigger: o });
  this.dispatch(v), (C = (y = d(this, Sr)).onDragEnd) == null || C.call(y, v), L(this, Sl, null), L(this, Iu, null), ($ = (D = d(this, Gv)) == null ? void 0 : D.onDragEnd) == null || $.call(D);
}, Wv = new WeakMap(), qu = new WeakMap(), Mz = function(n) {
  if (!Object.keys(ER).includes(n.key)) return;
  const { key: h } = n, v = S(this, $e, ND).call(this, n);
  if (!Zu(v)) {
    S(this, $e, ed).call(this, v, n), S(this, $e, AC).call(this, v, n);
    return;
  }
  const y = S(this, $e, UD).call(this, n);
  d(this, qu) || (L(this, qu, h === d(this, Wv)), !this.$state.dragging() && d(this, qu) && S(this, $e, PC).call(this, y, n)), S(this, $e, ed).call(this, y, n), L(this, Wv, h);
}, Lz = function(n) {
  if (!Object.keys(ER).includes(n.key) || !Zu(S(this, $e, ND).call(this, n))) return;
  const h = d(this, qu) ? this.$state.pointerValue() : S(this, $e, UD).call(this, n);
  S(this, $e, AC).call(this, h, n), S(this, $e, _D).call(this, h, n), L(this, Wv, ""), L(this, qu, !1);
}, ND = function(n) {
  let o = n.key, { min: h, max: v } = this.$state;
  return o === "Home" || o === "PageUp" ? h() : o === "End" || o === "PageDown" ? v() : !n.metaKey && /^[0-9]$/.test(o) ? (v() - h()) / 10 * Number(o) : null;
}, UD = function(n) {
  var Lt, $t;
  const { key: o, shiftKey: h } = n;
  n.preventDefault(), n.stopPropagation();
  const { shiftKeyMultiplier: v } = this.$props, { min: y, max: C, value: D, pointerValue: $ } = this.$state, _ = d(this, Sr).getStep(), A = d(this, Sr).getKeyStep(), B = h ? A * v() : A, W = Number(ER[o]), ne = B * W, ce = d(this, qu) ? $() : (($t = (Lt = d(this, Sr)).getValue) == null ? void 0 : $t.call(Lt)) ?? D(), Re = (ce + ne) / _;
  return Math.max(y(), Math.min(C(), Number((_ * Re).toFixed(3))));
}, // -------------------------------------------------------------------------------------------
// Document (Pointer Events)
// -------------------------------------------------------------------------------------------
$z = function(n) {
  if (n.button !== 0) return;
  n.preventDefault(), n.stopImmediatePropagation();
  const o = S(this, $e, iT).call(this, n);
  S(this, $e, ed).call(this, o, n), S(this, $e, _D).call(this, o, n);
}, Oz = function(n) {
  n.preventDefault();
}, v0 = new WeakMap();
const uT = by(() => ({}));
var VT, La, HT, IT, Ki, Az, Pz, _z, Nz, Uz, zz, Fz, Vz, y0;
class tp extends Hs {
  constructor(n) {
    super();
    R(this, Ki);
    R(this, VT);
    R(this, La);
    R(this, HT, st(!0));
    R(this, IT, st(!0));
    R(this, y0, Ey((n, o) => {
      var h, v;
      (h = this.el) == null || h.style.setProperty("--slider-fill", n + "%"), (v = this.el) == null || v.style.setProperty("--slider-pointer", o + "%");
    }));
    L(this, La, n);
  }
  onSetup() {
    L(this, VT, Ua());
    const n = new dw();
    n.attach(this), this.$state.focused = n.focused.bind(n), ep(uT) || Ju(uT, {
      default: "value"
    }), Ju(QM, {
      orientation: this.$props.orientation,
      disabled: d(this, La).isDisabled,
      preview: st(null)
    }), J(S(this, Ki, _z).bind(this)), J(S(this, Ki, Nz).bind(this)), J(S(this, Ki, Uz).bind(this)), S(this, Ki, Fz).call(this), new S8(d(this, La), d(this, VT)).attach(this), new yz({
      callback: S(this, Ki, Az).bind(this)
    }).attach(this);
  }
  onAttach(n) {
    Wi(n, "role", "slider"), Wi(n, "tabindex", "0"), Wi(n, "autocomplete", "off"), J(S(this, Ki, Vz).bind(this));
  }
  onConnect(n) {
    Wt(l_(n, d(this, HT).set)), J(S(this, Ki, Pz).bind(this));
  }
}
VT = new WeakMap(), La = new WeakMap(), HT = new WeakMap(), IT = new WeakMap(), Ki = new WeakSet(), Az = function(n) {
  d(this, IT).set(n[0].isIntersecting);
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
Pz = function() {
  const { hidden: n } = this.$props;
  this.$state.hidden.set(n() || !d(this, HT).call(this) || !d(this, IT).bind(this));
}, _z = function() {
  const { dragging: n, value: o, min: h, max: v } = this.$state;
  ye(n) || o.set(y8(h(), v(), o(), d(this, La).getStep()));
}, Nz = function() {
  this.$state.step.set(d(this, La).getStep());
}, Uz = function() {
  if (!d(this, La).isDisabled()) return;
  const { dragging: n, pointing: o } = this.$state;
  n.set(!1), o.set(!1);
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
zz = function() {
  return XC(d(this, La).isDisabled());
}, // -------------------------------------------------------------------------------------------
// Attributes
// -------------------------------------------------------------------------------------------
Fz = function() {
  const { orientation: n } = this.$props, { dragging: o, active: h, pointing: v } = this.$state;
  this.setAttributes({
    "data-dragging": o,
    "data-pointing": v,
    "data-active": h,
    "aria-disabled": S(this, Ki, zz).bind(this),
    "aria-valuemin": d(this, La).aria.valueMin ?? this.$state.min,
    "aria-valuemax": d(this, La).aria.valueMax ?? this.$state.max,
    "aria-valuenow": d(this, La).aria.valueNow,
    "aria-valuetext": d(this, La).aria.valueText,
    "aria-orientation": n
  });
}, Vz = function() {
  const { fillPercent: n, pointerPercent: o } = this.$state;
  d(this, y0).call(this, Na(n(), 3), Na(o(), 3));
}, y0 = new WeakMap(), Z(tp, "props", {
  hidden: !1,
  disabled: !1,
  step: 1,
  keyStep: 1,
  orientation: "horizontal",
  shiftKeyMultiplier: 5
});
var Do, Hz, Iz, qz, jz;
class np extends bi {
  constructor() {
    super();
    R(this, Do);
    new tp({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: this.$props.disabled,
      aria: {
        valueNow: S(this, Do, Hz).bind(this),
        valueText: S(this, Do, Iz).bind(this)
      }
    });
  }
  onSetup() {
    J(S(this, Do, qz).bind(this)), J(S(this, Do, jz).bind(this));
  }
}
Do = new WeakSet(), // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
Hz = function() {
  const { value: n } = this.$state;
  return Math.round(n());
}, Iz = function() {
  const { value: n, max: o } = this.$state;
  return Na(n() / o() * 100, 2) + "%";
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
qz = function() {
  const { value: n } = this.$props;
  this.$state.value.set(n());
}, jz = function() {
  const { min: n, max: o } = this.$props;
  this.$state.min.set(n()), this.$state.max.set(o());
}, Z(np, "props", {
  ...tp.props,
  min: 0,
  max: 100,
  value: 0
}), Z(np, "state", P0);
const Ru = /* @__PURE__ */ new Map(), vC = /* @__PURE__ */ new Map();
var qT, Kv, jT, Pn, Bz, Qz, FD, VD, HD, ID, Yz, _C;
const ZM = class ZM {
  constructor(s, n, o) {
    R(this, Pn);
    R(this, qT);
    R(this, Kv);
    R(this, jT);
    Z(this, "$images", st([]));
    L(this, Kv, s), L(this, jT, n), L(this, qT, o), J(S(this, Pn, Bz).bind(this));
  }
  static create(s, n) {
    const o = Ua();
    return new ZM(s, n, o);
  }
};
qT = new WeakMap(), Kv = new WeakMap(), jT = new WeakMap(), Pn = new WeakSet(), Bz = function() {
  var o;
  const { canLoad: s } = d(this, qT).$state;
  if (!s()) return;
  const n = d(this, Kv).call(this);
  if (n) {
    if (Ze(n) && Ru.has(n)) {
      const h = Ru.get(n);
      if (Ru.delete(n), Ru.set(n, h), Ru.size > 99) {
        const v = Ru.keys().next().value;
        Ru.delete(v);
      }
      this.$images.set(Ru.get(n));
    } else if (Ze(n)) {
      const h = d(this, jT).call(this), v = n + "::" + h;
      if (!vC.has(v)) {
        const y = new Promise(async (C, D) => {
          try {
            const $ = await fetch(n, {
              credentials: sT(h)
            });
            if ($.headers.get("content-type") === "application/json") {
              const A = await $.json();
              if (Vr(A))
                if (A[0] && "text" in A[0])
                  C(S(this, Pn, VD).call(this, A));
                else {
                  for (let B = 0; B < A.length; B++) {
                    const W = A[B];
                    xu(Bj(W), !1), xu(
                      "url" in W && Ze(W.url),
                      !1
                    ), xu(
                      "startTime" in W && ss(W.startTime),
                      !1
                    );
                  }
                  C(A);
                }
              else
                C(S(this, Pn, FD).call(this, A));
              return;
            }
            import("./dev-D3SS6qhA.js").then((A) => A.d).then(async ({ parseResponse: A }) => {
              try {
                const { cues: B } = await A($);
                C(S(this, Pn, VD).call(this, B));
              } catch (B) {
                D(B);
              }
            });
          } catch ($) {
            D($);
          }
        }).then((C) => (Ru.set(v, C), C)).catch((C) => {
          S(this, Pn, _C).call(this, n, C);
        }).finally(() => {
          Ze(v) && vC.delete(v);
        });
        vC.set(v, y);
      }
      (o = vC.get(v)) == null || o.then((y) => {
        this.$images.set(y || []);
      });
    } else if (Vr(n))
      try {
        this.$images.set(S(this, Pn, Qz).call(this, n));
      } catch (h) {
        S(this, Pn, _C).call(this, n, h);
      }
    else
      try {
        this.$images.set(S(this, Pn, FD).call(this, n));
      } catch (h) {
        S(this, Pn, _C).call(this, n, h);
      }
    return () => {
      this.$images.set([]);
    };
  }
}, Qz = function(s) {
  const n = S(this, Pn, HD).call(this);
  return s.map((o, h) => (xu(
    o.url && Ze(o.url)
  ), xu(
    "startTime" in o && ss(o.startTime)
  ), {
    ...o,
    url: Ze(o.url) ? S(this, Pn, ID).call(this, o.url, n) : o.url
  }));
}, FD = function(s) {
  var y;
  xu(Ze(s.url)), xu(Vr(s.tiles) && ((y = s.tiles) == null ? void 0 : y.length));
  const n = new URL(s.url), o = [], h = "tile_width" in s ? s.tile_width : s.tileWidth, v = "tile_height" in s ? s.tile_height : s.tileHeight;
  for (const C of s.tiles)
    o.push({
      url: n,
      startTime: "start" in C ? C.start : C.startTime,
      width: h,
      height: v,
      coords: { x: C.x, y: C.y }
    });
  return o;
}, VD = function(s) {
  for (let h = 0; h < s.length; h++) {
    const v = s[h];
    xu(
      "startTime" in v && ss(v.startTime)
    ), xu(
      "text" in v && Ze(v.text)
    );
  }
  const n = [], o = S(this, Pn, HD).call(this);
  for (const h of s) {
    const [v, y] = h.text.split("#"), C = S(this, Pn, Yz).call(this, y);
    n.push({
      url: S(this, Pn, ID).call(this, v, o),
      startTime: h.startTime,
      endTime: h.endTime,
      width: C == null ? void 0 : C.w,
      height: C == null ? void 0 : C.h,
      coords: C && ss(C.x) && ss(C.y) ? { x: C.x, y: C.y } : void 0
    });
  }
  return n;
}, HD = function() {
  let s = ye(d(this, Kv));
  return !Ze(s) || !/^https?:/.test(s) ? location.href : s;
}, ID = function(s, n) {
  return /^https?:/.test(s) ? new URL(s) : new URL(s, n);
}, Yz = function(s) {
  if (!s) return {};
  const [n, o] = s.split("="), h = o == null ? void 0 : o.split(","), v = {};
  if (!n || !h)
    return null;
  for (let y = 0; y < n.length; y++) {
    const C = +h[y];
    isNaN(C) || (v[n[y]] = C);
  }
  return v;
}, _C = function(s, n) {
};
let zD = ZM;
var Xv, Zv, Pt, Gz, jD, Wz, Kz, Xz, Zz, BD, Jz, e2, QD, td, t2;
class qD extends bi {
  constructor() {
    super(...arguments);
    R(this, Pt);
    Z(this, "media");
    R(this, Xv);
    R(this, Zv, []);
  }
  onSetup() {
    this.media = Ua(), L(this, Xv, zD.create(this.$props.src, this.$state.crossOrigin)), S(this, Pt, jD).call(this), this.setAttributes({
      "data-loading": S(this, Pt, Zz).bind(this),
      "data-error": S(this, Pt, BD).bind(this),
      "data-hidden": this.$state.hidden,
      "aria-hidden": sp(this.$state.hidden)
    });
  }
  onConnect(n) {
    J(S(this, Pt, Gz).bind(this)), J(S(this, Pt, Jz).bind(this)), J(S(this, Pt, jD).bind(this)), J(S(this, Pt, Wz).bind(this)), J(S(this, Pt, e2).bind(this)), J(S(this, Pt, QD).bind(this));
  }
  getTime() {
    return this.$props.time();
  }
}
Xv = new WeakMap(), Zv = new WeakMap(), Pt = new WeakSet(), Gz = function() {
  const n = this.$state.img();
  n && new gn(n).add("load", S(this, Pt, Kz).bind(this)).add("error", S(this, Pt, Xz).bind(this));
}, jD = function() {
  const { crossOrigin: n } = this.$props, { crossOrigin: o } = this.$state, { crossOrigin: h } = this.media.$state, v = n() !== null ? n() : h();
  o.set(v === !0 ? "anonymous" : v);
}, Wz = function() {
  const { src: n, loading: o, error: h } = this.$state;
  return n() && (o.set(!0), h.set(null)), () => {
    S(this, Pt, t2).call(this), o.set(!1), h.set(null);
  };
}, Kz = function() {
  const { loading: n, error: o } = this.$state;
  S(this, Pt, QD).call(this), n.set(!1), o.set(null);
}, Xz = function(n) {
  const { loading: o, error: h } = this.$state;
  o.set(!1), h.set(n);
}, Zz = function() {
  const { loading: n, hidden: o } = this.$state;
  return !o() && n();
}, BD = function() {
  const { error: n } = this.$state;
  return !Zu(n());
}, Jz = function() {
  const { hidden: n } = this.$state, { duration: o } = this.media.$state, h = d(this, Xv).$images();
  n.set(S(this, Pt, BD).call(this) || !Number.isFinite(o()) || h.length === 0);
}, e2 = function() {
  let n = d(this, Xv).$images();
  if (!n.length) return;
  let o = this.getTime(), { src: h, activeThumbnail: v } = this.$state, y = -1, C = null;
  for (let D = n.length - 1; D >= 0; D--) {
    const $ = n[D];
    if (o >= $.startTime && (!$.endTime || o < $.endTime)) {
      y = D;
      break;
    }
  }
  n[y] && (C = n[y]), v.set(C), h.set((C == null ? void 0 : C.url.href) || "");
}, QD = function() {
  if (!this.scope || this.$state.hidden()) return;
  const n = this.el, o = this.$state.img(), h = this.$state.activeThumbnail();
  if (!o || !h || !n) return;
  let v = h.width ?? o.naturalWidth, y = (h == null ? void 0 : h.height) ?? o.naturalHeight, {
    maxWidth: C,
    maxHeight: D,
    minWidth: $,
    minHeight: _,
    width: A,
    height: B
  } = getComputedStyle(this.el);
  $ === "100%" && ($ = parseFloat(A) + ""), _ === "100%" && (_ = parseFloat(B) + "");
  let W = Math.max(parseInt($) / v, parseInt(_) / y), ne = Math.min(
    Math.max(parseInt($), parseInt(C)) / v,
    Math.max(parseInt(_), parseInt(D)) / y
  ), ce = !isNaN(ne) && ne < 1 ? ne : W > 1 ? W : 1;
  S(this, Pt, td).call(this, n, "--thumbnail-width", `${v * ce}px`), S(this, Pt, td).call(this, n, "--thumbnail-height", `${y * ce}px`), S(this, Pt, td).call(this, n, "--thumbnail-aspect-ratio", String(Na(v / y, 5))), S(this, Pt, td).call(this, o, "width", `${o.naturalWidth * ce}px`), S(this, Pt, td).call(this, o, "height", `${o.naturalHeight * ce}px`), S(this, Pt, td).call(this, o, "transform", h.coords ? `translate(-${h.coords.x * ce}px, -${h.coords.y * ce}px)` : ""), S(this, Pt, td).call(this, o, "max-width", "none");
}, td = function(n, o, h) {
  n.style.setProperty(o, h), d(this, Zv).push(() => n.style.removeProperty(o));
}, t2 = function() {
  for (const n of d(this, Zv)) n();
  L(this, Zv, []);
}, Z(qD, "props", {
  src: null,
  time: 0,
  crossOrigin: null
}), Z(qD, "state", new Cy({
  src: "",
  img: null,
  thumbnails: [],
  activeThumbnail: null,
  crossOrigin: null,
  loading: !1,
  error: null,
  hidden: !1
}));
var BT;
class T8 extends qD {
  constructor() {
    super(...arguments);
    R(this, BT);
  }
  onAttach(n) {
    L(this, BT, uw(np.state));
  }
  getTime() {
    const { duration: n, clipStartTime: o } = this.media.$state;
    return o() + d(this, BT).pointerRate() * n();
  }
}
BT = new WeakMap();
var w8 = Object.defineProperty, E8 = Object.getOwnPropertyDescriptor, b8 = (f, s, n, o) => {
  for (var h = E8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && w8(s, n, h), h;
}, Ed, QT, Mn, n2, i2, YD, r2, GD, a2, s2, WD, l2, o2;
class r0 extends bi {
  constructor() {
    super(...arguments);
    R(this, Mn);
    R(this, Ed);
    R(this, QT);
  }
  get video() {
    return this.$state.video();
  }
  onSetup() {
    L(this, Ed, Ua()), L(this, QT, uw(np.state)), S(this, Mn, YD).call(this), this.setAttributes({
      "data-loading": S(this, Mn, r2).bind(this),
      "data-hidden": this.$state.hidden,
      "data-error": S(this, Mn, GD).bind(this),
      "aria-hidden": sp(this.$state.hidden)
    });
  }
  onAttach(n) {
    J(S(this, Mn, n2).bind(this)), J(S(this, Mn, i2).bind(this)), J(S(this, Mn, YD).bind(this)), J(S(this, Mn, a2).bind(this)), J(S(this, Mn, s2).bind(this)), J(S(this, Mn, o2).bind(this));
  }
}
Ed = new WeakMap(), QT = new WeakMap(), Mn = new WeakSet(), n2 = function() {
  const n = this.$state.video();
  n && (n.readyState >= 2 && S(this, Mn, WD).call(this), new gn(n).add("canplay", S(this, Mn, WD).bind(this)).add("error", S(this, Mn, l2).bind(this)));
}, i2 = function() {
  const { src: n } = this.$state, { canLoad: o } = d(this, Ed).$state;
  n.set(o() ? this.$props.src() : null);
}, YD = function() {
  const { crossOrigin: n } = this.$props, { crossOrigin: o } = this.$state, { crossOrigin: h } = d(this, Ed).$state, v = n() !== null ? n() : h();
  o.set(v === !0 ? "anonymous" : v);
}, r2 = function() {
  const { canPlay: n, hidden: o } = this.$state;
  return !n() && !o();
}, GD = function() {
  const { error: n } = this.$state;
  return !Zu(n);
}, a2 = function() {
  const { src: n, hidden: o } = this.$state, { canLoad: h, duration: v } = d(this, Ed).$state;
  o.set(h() && (!n() || S(this, Mn, GD).call(this) || !Number.isFinite(v())));
}, s2 = function() {
  const { src: n, canPlay: o, error: h } = this.$state;
  n(), o.set(!1), h.set(null);
}, WD = function(n) {
  const { canPlay: o, error: h } = this.$state;
  o.set(!0), h.set(null), this.dispatch("can-play", { trigger: n });
}, l2 = function(n) {
  const { canPlay: o, error: h } = this.$state;
  o.set(!1), h.set(n), this.dispatch("error", { trigger: n });
}, o2 = function() {
  const { video: n, canPlay: o } = this.$state, { duration: h } = d(this, Ed).$state, { pointerRate: v } = d(this, QT), y = n();
  o() && y && Number.isFinite(h()) && Number.isFinite(v()) && (y.currentTime = v() * h());
}, Z(r0, "props", {
  src: null,
  crossOrigin: null
}), Z(r0, "state", new Cy({
  video: null,
  src: null,
  crossOrigin: null,
  canPlay: !1,
  error: null,
  hidden: !1
}));
b8([
  rn
], r0.prototype, "video");
var C8 = Object.defineProperty, k8 = Object.getOwnPropertyDescriptor, x8 = (f, s, n, o) => {
  for (var h = k8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && C8(s, n, h), h;
}, bd, g0, YT;
class YM extends bi {
  constructor() {
    super(...arguments);
    R(this, bd);
    R(this, g0);
    R(this, YT);
  }
  onSetup() {
    L(this, YT, uw(np.state)), L(this, bd, Us(uT)), L(this, g0, ow(this.getValueText.bind(this)));
  }
  getValueText() {
    var ce, Re;
    const {
      type: n,
      format: o,
      decimalPlaces: h,
      padHours: v,
      padMinutes: y,
      showHours: C,
      showMs: D
    } = this.$props, { value: $, pointerValue: _, min: A, max: B } = d(this, YT), W = (o == null ? void 0 : o()) ?? d(this, bd).default, ne = n() === "current" ? $() : _();
    if (W === "percent") {
      const Lt = B() - A(), $t = ne / Lt * 100;
      return (d(this, bd).percent ?? Na)($t, h()) + "%";
    } else return W === "time" ? (d(this, bd).time ?? BM)(ne, {
      padHrs: v(),
      padMins: y(),
      showHrs: C(),
      showMs: D()
    }) : (((Re = (ce = d(this, bd)).value) == null ? void 0 : Re.call(ce, ne)) ?? ne.toFixed(2)) + "";
  }
}
bd = new WeakMap(), g0 = new WeakMap(), YT = new WeakMap(), Z(YM, "props", {
  type: "pointer",
  format: null,
  showHours: !1,
  showMs: !1,
  padHours: null,
  padMinutes: null,
  decimalPlaces: 2
});
x8([
  Zi
], YM.prototype, "getValueText");
var Jv, GT;
class u2 extends bi {
  constructor() {
    super(...arguments);
    R(this, Jv);
    R(this, GT, Ey(() => {
      const { disabled: n, orientation: o } = d(this, Jv);
      if (n()) return;
      const h = this.el, { offset: v, noClamp: y } = this.$props;
      h && R8(h, {
        clamp: !y(),
        offset: v(),
        orientation: o()
      });
    }));
  }
  onSetup() {
    L(this, Jv, Us(QM));
    const { active: n } = uw(np.state);
    this.setAttributes({
      "data-visible": n
    });
  }
  onAttach(n) {
    Object.assign(n.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
  }
  onConnect(n) {
    const { preview: o } = d(this, Jv);
    o.set(n), Wt(() => o.set(null)), J(d(this, GT).bind(this));
    const h = new ResizeObserver(d(this, GT).bind(this));
    h.observe(n), Wt(() => h.disconnect());
  }
}
Jv = new WeakMap(), GT = new WeakMap(), Z(u2, "props", {
  offset: 0,
  noClamp: !1
});
function R8(f, {
  clamp: s,
  offset: n,
  orientation: o
}) {
  const h = getComputedStyle(f), v = parseFloat(h.width), y = parseFloat(h.height), C = {
    top: null,
    right: null,
    bottom: null,
    left: null
  };
  if (C[o === "horizontal" ? "bottom" : "left"] = `calc(100% + var(--media-slider-preview-offset, ${n}px))`, o === "horizontal") {
    const D = v / 2;
    if (!s)
      C.left = `calc(var(--slider-pointer) - ${D}px)`;
    else {
      const $ = `max(0px, calc(var(--slider-pointer) - ${D}px))`, _ = `calc(100% - ${v}px)`;
      C.left = `min(${$}, ${_})`;
    }
  } else {
    const D = y / 2;
    if (!s)
      C.bottom = `calc(var(--slider-pointer) - ${D}px)`;
    else {
      const $ = `max(${D}px, calc(var(--slider-pointer) - ${D}px))`, _ = `calc(100% - ${y}px)`;
      C.bottom = `min(${$}, ${_})`;
    }
  }
  Object.assign(f.style, C);
}
var _s, Xi, c2, d2, f2, h2, p2, WT, m2, v2, y2;
class KD extends bi {
  constructor() {
    super(...arguments);
    R(this, Xi);
    R(this, _s);
    R(this, WT, cw(S(this, Xi, m2).bind(this), 25));
  }
  onSetup() {
    L(this, _s, Ua());
    const { audioGain: n } = d(this, _s).$state;
    Ju(uT, {
      default: "percent",
      value(o) {
        return (o * (n() ?? 1)).toFixed(2);
      },
      percent(o) {
        return Math.round(o * (n() ?? 1));
      }
    }), new tp({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: S(this, Xi, h2).bind(this),
      aria: {
        valueMax: S(this, Xi, f2).bind(this),
        valueNow: S(this, Xi, c2).bind(this),
        valueText: S(this, Xi, d2).bind(this)
      },
      onDragValueChange: S(this, Xi, y2).bind(this),
      onValueChange: S(this, Xi, v2).bind(this)
    }).attach(this), J(S(this, Xi, p2).bind(this));
  }
  onAttach(n) {
    n.setAttribute("data-media-volume-slider", ""), Wi(n, "aria-label", "Volume");
    const { canSetVolume: o } = d(this, _s).$state;
    this.setAttributes({
      "data-supported": o,
      "aria-hidden": sp(() => !o())
    });
  }
}
_s = new WeakMap(), Xi = new WeakSet(), c2 = function() {
  const { value: n } = this.$state, { audioGain: o } = d(this, _s).$state;
  return Math.round(n() * (o() ?? 1));
}, d2 = function() {
  const { value: n, max: o } = this.$state, { audioGain: h } = d(this, _s).$state;
  return Na(n() / o() * (h() ?? 1) * 100, 2) + "%";
}, f2 = function() {
  const { audioGain: n } = d(this, _s).$state;
  return this.$state.max() * (n() ?? 1);
}, h2 = function() {
  const { disabled: n } = this.$props, { canSetVolume: o } = d(this, _s).$state;
  return n() || !o();
}, p2 = function() {
  const { muted: n, volume: o } = d(this, _s).$state, h = n() ? 0 : o() * 100;
  this.$state.value.set(h), this.dispatch("value-change", { detail: h });
}, WT = new WeakMap(), m2 = function(n) {
  if (!n.trigger) return;
  const o = Na(n.detail / 100, 3);
  d(this, _s).remote.changeVolume(o, n);
}, v2 = function(n) {
  d(this, WT).call(this, n);
}, y2 = function(n) {
  d(this, WT).call(this, n);
}, Z(KD, "props", {
  ...tp.props,
  keyStep: 5,
  shiftKeyMultiplier: 2
}), Z(KD, "state", P0);
var Rn, ey, KT, Ie, g2, S2, T2, w2, E2, XD, b2, ty, C2, k2, ZD, x2, JD, R2, D2, M2, L2, $2, O2, fh, A2, P2, _2;
class a0 extends bi {
  constructor() {
    super();
    R(this, Ie);
    R(this, Rn);
    R(this, ey);
    R(this, KT, st(null));
    R(this, ty, !1);
    const { noSwipeGesture: n } = this.$props;
    new tp({
      swipeGesture: () => !n(),
      getValue: S(this, Ie, JD).bind(this),
      getStep: S(this, Ie, R2).bind(this),
      getKeyStep: S(this, Ie, D2).bind(this),
      roundValue: S(this, Ie, M2),
      isDisabled: S(this, Ie, L2).bind(this),
      aria: {
        valueNow: S(this, Ie, $2).bind(this),
        valueText: S(this, Ie, O2).bind(this)
      },
      onDragStart: S(this, Ie, C2).bind(this),
      onDragValueChange: S(this, Ie, k2).bind(this),
      onDragEnd: S(this, Ie, ZD).bind(this),
      onValueChange: S(this, Ie, x2).bind(this)
    });
  }
  onSetup() {
    L(this, Rn, Ua()), Ju(uT, {
      default: "time",
      value: S(this, Ie, P2).bind(this),
      time: S(this, Ie, _2).bind(this)
    }), this.setAttributes({
      "data-chapters": S(this, Ie, S2).bind(this)
    }), this.setStyles({
      "--slider-progress": S(this, Ie, g2).bind(this)
    }), J(S(this, Ie, w2).bind(this)), J(S(this, Ie, T2).bind(this));
  }
  onAttach(n) {
    n.setAttribute("data-media-time-slider", ""), Wi(n, "aria-label", "Seek");
  }
  onConnect(n) {
    J(S(this, Ie, E2).bind(this)), ZP(d(this, Rn).textTracks, "chapters", d(this, KT).set);
  }
}
Rn = new WeakMap(), ey = new WeakMap(), KT = new WeakMap(), Ie = new WeakSet(), g2 = function() {
  const { bufferedEnd: n, duration: o } = d(this, Rn).$state;
  return Na(Math.min(n() / Math.max(o(), 1), 1) * 100, 3) + "%";
}, S2 = function() {
  var o;
  const { duration: n } = d(this, Rn).$state;
  return ((o = d(this, KT).call(this)) == null ? void 0 : o.cues.length) && Number.isFinite(n()) && n() > 0;
}, T2 = function() {
  L(this, ey, cw(
    S(this, Ie, XD).bind(this),
    this.$props.seekingRequestThrottle()
  ));
}, w2 = function() {
  if (this.$state.hidden()) return;
  const { value: n, dragging: o } = this.$state, h = S(this, Ie, JD).call(this);
  ye(o) || (n.set(h), this.dispatch("value-change", { detail: h }));
}, E2 = function() {
  const n = d(this, Rn).player.el, { preview: o } = Us(QM);
  n && o() && ht(n, "data-preview", this.$state.active());
}, XD = function(n, o) {
  d(this, Rn).remote.seeking(n, o);
}, b2 = function(n, o, h) {
  d(this, ey).cancel();
  const { live: v } = d(this, Rn).$state;
  if (v() && o >= 99) {
    d(this, Rn).remote.seekToLiveEdge(h);
    return;
  }
  d(this, Rn).remote.seek(n, h);
}, ty = new WeakMap(), C2 = function(n) {
  const { pauseWhileDragging: o } = this.$props;
  if (o()) {
    const { paused: h } = d(this, Rn).$state;
    L(this, ty, !h()), d(this, Rn).remote.pause(n);
  }
}, k2 = function(n) {
  d(this, ey).call(this, S(this, Ie, fh).call(this, n.detail), n);
}, ZD = function(n) {
  const { seeking: o } = d(this, Rn).$state;
  ye(o) || S(this, Ie, XD).call(this, S(this, Ie, fh).call(this, n.detail), n);
  const h = n.detail;
  S(this, Ie, b2).call(this, S(this, Ie, fh).call(this, h), h, n);
  const { pauseWhileDragging: v } = this.$props;
  v() && d(this, ty) && (d(this, Rn).remote.play(n), L(this, ty, !1));
}, x2 = function(n) {
  const { dragging: o } = this.$state;
  o() || !n.trigger || S(this, Ie, ZD).call(this, n);
}, // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
JD = function() {
  const { currentTime: n } = d(this, Rn).$state;
  return S(this, Ie, A2).call(this, n());
}, R2 = function() {
  const n = this.$props.step() / d(this, Rn).$state.duration() * 100;
  return Number.isFinite(n) ? n : 1;
}, D2 = function() {
  const n = this.$props.keyStep() / d(this, Rn).$state.duration() * 100;
  return Number.isFinite(n) ? n : 1;
}, M2 = function(n) {
  return Na(n, 3);
}, L2 = function() {
  const { disabled: n } = this.$props, { canSeek: o } = d(this, Rn).$state;
  return n() || !o();
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
$2 = function() {
  const { value: n } = this.$state;
  return Math.round(n());
}, O2 = function() {
  const n = S(this, Ie, fh).call(this, this.$state.value()), { duration: o } = d(this, Rn).$state;
  return Number.isFinite(n) ? `${iD(n)} out of ${iD(o())}` : "live";
}, // -------------------------------------------------------------------------------------------
// Format
// -------------------------------------------------------------------------------------------
fh = function(n) {
  const { duration: o } = d(this, Rn).$state;
  return Na(n / 100 * o(), 5);
}, A2 = function(n) {
  const { liveEdge: o, duration: h } = d(this, Rn).$state, v = Math.max(0, Math.min(1, o() ? 1 : Math.min(n, h()) / h()));
  return Number.isNaN(v) ? 0 : Number.isFinite(v) ? v * 100 : 100;
}, P2 = function(n) {
  const o = S(this, Ie, fh).call(this, n), { live: h, duration: v } = d(this, Rn).$state;
  return Number.isFinite(o) ? (h() ? o - v() : o).toFixed(0) : "LIVE";
}, _2 = function(n, o) {
  const h = S(this, Ie, fh).call(this, n), { live: v, duration: y } = d(this, Rn).$state, C = v() ? h - y() : h;
  return Number.isFinite(h) ? `${C < 0 ? "-" : ""}${BM(Math.abs(C), o)}` : "LIVE";
}, Z(a0, "props", {
  ...tp.props,
  step: 0.1,
  keyStep: 5,
  shiftKeyMultiplier: 2,
  pauseWhileDragging: !1,
  noSwipeGesture: !1,
  seekingRequestThrottle: 100
}), Z(a0, "state", P0);
var D8 = Object.defineProperty, M8 = Object.getOwnPropertyDescriptor, _0 = (f, s, n, o) => {
  for (var h = M8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && D8(s, n, h), h;
}, $a, Hh, ny, po, ra, Ih, aa, ju, qh, Cd, qe, eM, tM, N2, U2, z2, F2, V2, NC, nM, iM, H2, S0, T0, I2, UC, zC, q2, j2, B2, Q2, XT, Y2, G2, W2;
class Ry extends bi {
  constructor() {
    super(...arguments);
    R(this, qe);
    R(this, $a);
    R(this, Hh);
    R(this, ny);
    R(this, po, null);
    R(this, ra, []);
    R(this, Ih, st(null));
    R(this, aa, st([]));
    R(this, ju, st(-1));
    R(this, qh, st(-1));
    R(this, Cd, 0);
    R(this, S0, Ey((n) => {
      var D;
      let o, h = d(this, aa).call(this), { seekableStart: v } = d(this, $a).$state, y = v(), C = S(this, qe, UC).call(this, h);
      for (let $ = d(this, Cd); $ < d(this, ra).length; $++)
        if (o = S(this, qe, zC).call(this, h[$], n, y, C), (D = d(this, ra)[$]) == null || D.style.setProperty("--chapter-progress", o + "%"), o < 100) {
          L(this, Cd, $);
          break;
        }
    }));
    R(this, T0, ow(S(this, qe, I2).bind(this)));
    R(this, XT, HM(
      () => {
        const n = ye(d(this, Ih));
        !this.scope || !n || !n.cues.length || (d(this, aa).set(S(this, qe, q2).call(this, n.cues)), d(this, ju).set(0), L(this, Cd, 0));
      },
      150,
      !0
    ));
  }
  get cues() {
    return d(this, aa).call(this);
  }
  get activeCue() {
    return d(this, aa).call(this)[d(this, ju).call(this)] || null;
  }
  get activePointerCue() {
    return d(this, aa).call(this)[d(this, qh).call(this)] || null;
  }
  onSetup() {
    L(this, $a, Ua()), L(this, Hh, uw(a0.state));
  }
  onAttach(n) {
    ZP(d(this, $a).textTracks, "chapters", S(this, qe, eM).bind(this)), J(S(this, qe, j2).bind(this));
  }
  onConnect() {
    Wt(() => S(this, qe, tM).bind(this));
  }
  onDestroy() {
    S(this, qe, eM).call(this, null);
  }
  setRefs(n) {
    var o;
    if (L(this, ra, n), (o = d(this, ny)) == null || o.dispose(), d(this, ra).length === 1) {
      const h = d(this, ra)[0];
      h.style.width = "100%", h.style.setProperty("--chapter-fill", "var(--slider-fill)"), h.style.setProperty("--chapter-progress", "var(--slider-progress)");
    } else d(this, ra).length > 0 && bl(() => S(this, qe, N2).call(this), L(this, ny, WC()));
  }
}
$a = new WeakMap(), Hh = new WeakMap(), ny = new WeakMap(), po = new WeakMap(), ra = new WeakMap(), Ih = new WeakMap(), aa = new WeakMap(), ju = new WeakMap(), qh = new WeakMap(), Cd = new WeakMap(), qe = new WeakSet(), eM = function(n) {
  ye(d(this, Ih)) !== n && (S(this, qe, tM).call(this), d(this, Ih).set(n));
}, tM = function() {
  var n;
  L(this, ra, []), d(this, aa).set([]), d(this, ju).set(-1), d(this, qh).set(-1), L(this, Cd, 0), (n = d(this, ny)) == null || n.dispose();
}, N2 = function() {
  d(this, ra).length && J(S(this, qe, U2).bind(this));
}, U2 = function() {
  const { hidden: n } = d(this, Hh);
  n() || (J(S(this, qe, z2).bind(this)), J(S(this, qe, F2).bind(this)), J(S(this, qe, V2).bind(this)), J(S(this, qe, H2).bind(this)));
}, z2 = function() {
  const n = d(this, aa).call(this);
  if (!n.length) return;
  let o, { seekableStart: h, seekableEnd: v } = d(this, $a).$state, y = h(), C = v() || n[n.length - 1].endTime, D = C - y, $ = 100;
  for (let _ = 0; _ < n.length; _++)
    if (o = n[_], d(this, ra)[_]) {
      const A = _ === n.length - 1 ? $ : Na((o.endTime - Math.max(y, o.startTime)) / D * 100, 3);
      d(this, ra)[_].style.width = A + "%", $ -= A;
    }
}, F2 = function() {
  let { liveEdge: n, seekableStart: o, seekableEnd: h } = d(this, $a).$state, { fillPercent: v, value: y } = d(this, Hh), C = d(this, aa).call(this), D = n(), $ = ye(d(this, ju)), _ = C[$], A = D ? d(this, aa).length - 1 : S(this, qe, iM).call(this, _ && _.startTime / h() * 100 <= ye(y) ? $ : 0, v());
  D || !_ ? S(this, qe, NC).call(this, 0, C.length, 100) : A > $ ? S(this, qe, NC).call(this, $, A, 100) : A < $ && S(this, qe, NC).call(this, A + 1, $ + 1, 0);
  const B = D ? 100 : S(this, qe, zC).call(this, C[A], v(), o(), S(this, qe, UC).call(this, C));
  S(this, qe, nM).call(this, d(this, ra)[A], B), d(this, ju).set(A);
}, V2 = function() {
  let { hidden: n, pointerPercent: o } = d(this, Hh);
  if (n()) {
    d(this, qh).set(-1);
    return;
  }
  const h = S(this, qe, iM).call(this, 0, o());
  d(this, qh).set(h);
}, NC = function(n, o, h) {
  for (let v = n; v < o; v++) S(this, qe, nM).call(this, d(this, ra)[v], h);
}, nM = function(n, o) {
  n && (n.style.setProperty("--chapter-fill", o + "%"), ht(n, "data-active", o > 0 && o < 100), ht(n, "data-ended", o === 100));
}, iM = function(n, o) {
  let h = 0, v = d(this, aa).call(this);
  if (o === 0) return 0;
  if (o === 100) return v.length - 1;
  let { seekableStart: y } = d(this, $a).$state, C = y(), D = S(this, qe, UC).call(this, v);
  for (let $ = n; $ < v.length; $++)
    if (h = S(this, qe, zC).call(this, v[$], o, C, D), h >= 0 && h < 100) return $;
  return 0;
}, H2 = function() {
  d(this, S0).call(this, d(this, T0).call(this));
}, S0 = new WeakMap(), T0 = new WeakMap(), I2 = function() {
  const { bufferedEnd: n, duration: o } = d(this, $a).$state;
  return Na(Math.min(n() / Math.max(o(), 1), 1), 3) * 100;
}, UC = function(n) {
  var v;
  const { seekableEnd: o } = d(this, $a).$state, h = o();
  return Number.isFinite(h) ? h : ((v = n[n.length - 1]) == null ? void 0 : v.endTime) || 0;
}, zC = function(n, o, h, v) {
  if (!n || d(this, aa).call(this).length === 0) return 0;
  const C = v - h, D = Math.max(0, n.startTime - h), $ = Math.min(v, n.endTime) - h, _ = D / C, A = _ * 100, B = Math.min(1, _ + ($ - D) / C) * 100;
  return Math.max(
    0,
    Na(
      o >= B ? 100 : (o - A) / (B - A) * 100,
      3
    )
  );
}, q2 = function(n) {
  let o = [], { seekableStart: h, seekableEnd: v, duration: y } = d(this, $a).$state, C = h(), D = v();
  n = n.filter((A) => A.startTime <= D && A.endTime >= C);
  const $ = n[0];
  $ && $.startTime > C && o.push(new window.VTTCue(C, $.startTime, ""));
  for (let A = 0; A < n.length - 1; A++) {
    const B = n[A], W = n[A + 1];
    if (o.push(B), W) {
      const ne = W.startTime - B.endTime;
      ne > 0 && o.push(new window.VTTCue(B.endTime, B.endTime + ne, ""));
    }
  }
  const _ = n[n.length - 1];
  if (_) {
    o.push(_);
    const A = y();
    A >= 0 && A - _.endTime > 1 && o.push(new window.VTTCue(_.endTime, y(), ""));
  }
  return o;
}, j2 = function() {
  const { source: n } = d(this, $a).$state;
  n(), S(this, qe, B2).call(this);
}, B2 = function() {
  if (!this.scope) return;
  const { disabled: n } = this.$props;
  if (n()) {
    d(this, aa).set([]), d(this, ju).set(0), L(this, Cd, 0);
    return;
  }
  const o = d(this, Ih).call(this);
  if (o) {
    const h = d(this, XT).bind(this);
    h(), new gn(o).add("add-cue", h).add("remove-cue", h), J(S(this, qe, Q2).bind(this));
  }
  return L(this, po, S(this, qe, W2).call(this)), d(this, po) && J(S(this, qe, Y2).bind(this)), () => {
    d(this, po) && (d(this, po).textContent = "", L(this, po, null));
  };
}, Q2 = function() {
  d(this, $a).$state.duration(), d(this, XT).call(this);
}, XT = new WeakMap(), Y2 = function() {
  const n = this.activePointerCue || this.activeCue;
  d(this, po) && (d(this, po).textContent = (n == null ? void 0 : n.text) || "");
}, G2 = function() {
  let n = this.el;
  for (; n && n.getAttribute("role") !== "slider"; )
    n = n.parentElement;
  return n;
}, W2 = function() {
  const n = S(this, qe, G2).call(this);
  return n ? n.querySelector('[data-part="chapter-title"]') : null;
}, Z(Ry, "props", {
  disabled: !1
});
_0([
  rn
], Ry.prototype, "cues");
_0([
  rn
], Ry.prototype, "activeCue");
_0([
  rn
], Ry.prototype, "activePointerCue");
_0([
  Zi
], Ry.prototype, "setRefs");
const Pd = by(), iP = (f) => typeof f == "object" && f != null && f.nodeType === 1, rP = (f, s) => (!s || f !== "hidden") && f !== "visible" && f !== "clip", yC = (f, s) => {
  if (f.clientHeight < f.scrollHeight || f.clientWidth < f.scrollWidth) {
    const n = getComputedStyle(f, null);
    return rP(n.overflowY, s) || rP(n.overflowX, s) || ((o) => {
      const h = ((v) => {
        if (!v.ownerDocument || !v.ownerDocument.defaultView) return null;
        try {
          return v.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!h && (h.clientHeight < o.scrollHeight || h.clientWidth < o.scrollWidth);
    })(f);
  }
  return !1;
}, gC = (f, s, n, o, h, v, y, C) => v < f && y > s || v > f && y < s ? 0 : v <= f && C <= n || y >= s && C >= n ? v - f - o : y > s && C < n || v < f && C > n ? y - s + h : 0, L8 = (f) => {
  const s = f.parentElement;
  return s ?? (f.getRootNode().host || null);
}, $8 = (f, s) => {
  var n, o, h, v;
  if (typeof document > "u") return [];
  const { scrollMode: y, block: C, inline: D, boundary: $, skipOverflowHiddenElements: _ } = s, A = typeof $ == "function" ? $ : (Je) => Je !== $;
  if (!iP(f)) throw new TypeError("Invalid target");
  const B = document.scrollingElement || document.documentElement, W = [];
  let ne = f;
  for (; iP(ne) && A(ne); ) {
    if (ne = L8(ne), ne === B) {
      W.push(ne);
      break;
    }
    ne != null && ne === document.body && yC(ne) && !yC(document.documentElement) || ne != null && yC(ne, _) && W.push(ne);
  }
  const ce = (o = (n = window.visualViewport) == null ? void 0 : n.width) != null ? o : innerWidth, Re = (v = (h = window.visualViewport) == null ? void 0 : h.height) != null ? v : innerHeight, { scrollX: Lt, scrollY: $t } = window, { height: Ve, width: ct, top: Ye, right: wt, bottom: He, left: de } = f.getBoundingClientRect(), { top: Ge, right: ft, bottom: Kt, left: Mt } = ((Je) => {
    const ot = window.getComputedStyle(Je);
    return { top: parseFloat(ot.scrollMarginTop) || 0, right: parseFloat(ot.scrollMarginRight) || 0, bottom: parseFloat(ot.scrollMarginBottom) || 0, left: parseFloat(ot.scrollMarginLeft) || 0 };
  })(f);
  let Ae = C === "start" || C === "nearest" ? Ye - Ge : C === "end" ? He + Kt : Ye + Ve / 2 - Ge + Kt, Et = D === "center" ? de + ct / 2 - Mt + ft : D === "end" ? wt + ft : de - Mt;
  const Sn = [];
  for (let Je = 0; Je < W.length; Je++) {
    const ot = W[Je], { height: oe, width: Le, top: he, right: gt, bottom: Nt, left: Ii } = ot.getBoundingClientRect();
    if (y === "if-needed" && Ye >= 0 && de >= 0 && He <= Re && wt <= ce && (ot === B && !yC(ot) || Ye >= he && He <= Nt && de >= Ii && wt <= gt)) return Sn;
    const Bn = getComputedStyle(ot), oa = parseInt(Bn.borderLeftWidth, 10), ai = parseInt(Bn.borderTopWidth, 10), si = parseInt(Bn.borderRightWidth, 10), Ci = parseInt(Bn.borderBottomWidth, 10);
    let li = 0, ki = 0;
    const Nn = "offsetWidth" in ot ? ot.offsetWidth - ot.clientWidth - oa - si : 0, er = "offsetHeight" in ot ? ot.offsetHeight - ot.clientHeight - ai - Ci : 0, gi = "offsetWidth" in ot ? ot.offsetWidth === 0 ? 0 : Le / ot.offsetWidth : 0, xi = "offsetHeight" in ot ? ot.offsetHeight === 0 ? 0 : oe / ot.offsetHeight : 0;
    if (B === ot) li = C === "start" ? Ae : C === "end" ? Ae - Re : C === "nearest" ? gC($t, $t + Re, Re, ai, Ci, $t + Ae, $t + Ae + Ve, Ve) : Ae - Re / 2, ki = D === "start" ? Et : D === "center" ? Et - ce / 2 : D === "end" ? Et - ce : gC(Lt, Lt + ce, ce, oa, si, Lt + Et, Lt + Et + ct, ct), li = Math.max(0, li + $t), ki = Math.max(0, ki + Lt);
    else {
      li = C === "start" ? Ae - he - ai : C === "end" ? Ae - Nt + Ci + er : C === "nearest" ? gC(he, Nt, oe, ai, Ci + er, Ae, Ae + Ve, Ve) : Ae - (he + oe / 2) + er / 2, ki = D === "start" ? Et - Ii - oa : D === "center" ? Et - (Ii + Le / 2) + Nn / 2 : D === "end" ? Et - gt + si + Nn : gC(Ii, gt, Le, oa, si + Nn, Et, Et + ct, ct);
      const { scrollLeft: tr, scrollTop: Ir } = ot;
      li = xi === 0 ? 0 : Math.max(0, Math.min(Ir + li / xi, ot.scrollHeight - oe / xi + er)), ki = gi === 0 ? 0 : Math.max(0, Math.min(tr + ki / gi, ot.scrollWidth - Le / gi + Nn)), Ae += Ir - li, Et += tr - ki;
    }
    Sn.push({ el: ot, top: li, left: ki });
  }
  return Sn;
};
function O8(f, s) {
  const n = $8(f, s);
  for (const { el: o, top: h, left: v } of n)
    o.scroll({ top: h, left: v, behavior: s.behavior });
}
function A8(f, s = {}) {
  O8(f, {
    scrollMode: "if-needed",
    block: "center",
    inline: "center",
    ...s
  });
}
const P8 = /* @__PURE__ */ [
  "a[href]",
  "[tabindex]",
  "input",
  "select",
  "button"
].map((f) => `${f}:not([aria-hidden='true'])`).join(","), _8 = /* @__PURE__ */ new Set([
  "Escape",
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "PageUp",
  "End",
  "PageDown",
  "Enter",
  " "
]);
var kd, Tl, Oa, ZT, vn, hh, rM, K2, aM, X2, Z2, FC, J2;
class N8 {
  constructor(s) {
    R(this, vn);
    R(this, kd, -1);
    R(this, Tl, null);
    R(this, Oa, []);
    R(this, ZT);
    L(this, ZT, s);
  }
  get items() {
    return d(this, Oa);
  }
  attachMenu(s) {
    En(s, "focus", S(this, vn, K2).bind(this)), L(this, Tl, s), Wt(() => {
      L(this, Tl, null);
    });
  }
  listen() {
    d(this, Tl) && (this.update(), new gn(d(this, Tl)).add("keyup", S(this, vn, X2).bind(this)).add("keydown", S(this, vn, Z2).bind(this)), Wt(() => {
      L(this, kd, -1), L(this, Oa, []);
    }));
  }
  update() {
    L(this, kd, 0), L(this, Oa, S(this, vn, J2).call(this));
  }
  scroll(s = S(this, vn, rM).call(this)) {
    const n = d(this, Oa)[s];
    n && requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        A8(n, {
          behavior: "smooth",
          boundary: (o) => !o.hasAttribute("data-root")
        });
      });
    });
  }
  focusActive(s = !0) {
    const n = S(this, vn, rM).call(this);
    S(this, vn, hh).call(this, n >= 0 ? n : 0, s);
  }
}
kd = new WeakMap(), Tl = new WeakMap(), Oa = new WeakMap(), ZT = new WeakMap(), vn = new WeakSet(), hh = function(s, n = !0) {
  var o;
  L(this, kd, s), d(this, Oa)[s] ? (d(this, Oa)[s].focus({ preventScroll: !0 }), n && this.scroll(s)) : (o = d(this, Tl)) == null || o.focus({ preventScroll: !0 });
}, rM = function() {
  return d(this, Oa).findIndex(
    (s) => document.activeElement === s || s.getAttribute("role") === "menuitemradio" && s.getAttribute("aria-checked") === "true"
  );
}, K2 = function() {
  d(this, kd) >= 0 || (this.update(), this.focusActive());
}, aM = function(s) {
  const n = s.target;
  if (Xj(s) && n instanceof Element) {
    const o = n.getAttribute("role");
    return !/a|input|select|button/.test(n.localName) && !o;
  }
  return _8.has(s.key);
}, X2 = function(s) {
  S(this, vn, aM).call(this, s) && (s.stopPropagation(), s.preventDefault());
}, Z2 = function(s) {
  if (S(this, vn, aM).call(this, s))
    switch (s.stopPropagation(), s.preventDefault(), s.key) {
      case "Escape":
        d(this, ZT).closeMenu(s);
        break;
      case "Tab":
        S(this, vn, hh).call(this, S(this, vn, FC).call(this, s.shiftKey ? -1 : 1));
        break;
      case "ArrowUp":
        S(this, vn, hh).call(this, S(this, vn, FC).call(this, -1));
        break;
      case "ArrowDown":
        S(this, vn, hh).call(this, S(this, vn, FC).call(this, 1));
        break;
      case "Home":
      case "PageUp":
        S(this, vn, hh).call(this, 0);
        break;
      case "End":
      case "PageDown":
        S(this, vn, hh).call(this, d(this, Oa).length - 1);
        break;
    }
}, FC = function(s) {
  var o;
  let n = d(this, kd);
  do
    n = (n + s + d(this, Oa).length) % d(this, Oa).length;
  while (((o = d(this, Oa)[n]) == null ? void 0 : o.offsetParent) === null);
  return n;
}, J2 = function() {
  if (!d(this, Tl)) return [];
  const s = d(this, Tl).querySelectorAll(P8), n = [], o = (h) => h.getAttribute("role") === "menu";
  for (const h of s)
    JC(h) && h.offsetParent !== null && // does not have display: none
    o_(d(this, Tl), h, o) && n.push(h);
  return n;
};
var U8 = Object.defineProperty, z8 = Object.getOwnPropertyDescriptor, fw = (f, s, n, o) => {
  for (var h = z8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && U8(s, n, h), h;
};
let F8 = 0;
var wl, iy, ry, sa, JT, mo, Gi, xd, Rd, jh, Bh, Bu, Qh, ew, Yh, Ke, eF, tF, nF, iF, rF, sM, aF, ay, sF, lM, lF, rT, oF, uF, cF, dF, fF, hF, w0, pF, sy, E0, mF, b0, vF, ly, oy, yF;
class Dy extends bi {
  constructor() {
    super();
    R(this, Ke);
    R(this, wl);
    R(this, iy);
    R(this, ry);
    R(this, sa, st(!1));
    R(this, JT, st(!1));
    R(this, mo, st(null));
    R(this, Gi, st(null));
    R(this, xd);
    R(this, Rd, /* @__PURE__ */ new Set());
    R(this, jh, null);
    R(this, Bh);
    R(this, Bu);
    R(this, Qh, !1);
    R(this, ew, st(!1));
    R(this, Yh, /* @__PURE__ */ new Set());
    R(this, ay, !1);
    R(this, w0, S(this, Ke, pF).bind(this));
    R(this, sy, !1);
    R(this, E0, S(this, Ke, mF).bind(this));
    R(this, b0, S(this, Ke, vF).bind(this));
    R(this, ly, Ey(() => {
      const n = ye(d(this, Gi));
      if (!n) return;
      let o = 0, h = getComputedStyle(n), v = [...n.children];
      for (const y of ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"])
        o += parseFloat(h[y]) || 0;
      for (const y of v)
        if (JC(y) && y.style.display === "contents")
          v.push(...y.children);
        else if (y.nodeType === 3)
          o += parseFloat(getComputedStyle(y).fontSize);
        else if (JC(y)) {
          if (!s_(y)) continue;
          const C = getComputedStyle(y);
          o += y.offsetHeight + (parseFloat(C.marginTop) || 0) + (parseFloat(C.marginBottom) || 0);
        }
      Nd(n, "--menu-height", o + "px");
    }));
    R(this, oy, !1);
    const { showDelay: n } = this.$props;
    L(this, Bh, new f8({
      trigger: d(this, mo),
      content: d(this, Gi),
      showDelay: n,
      listen: (o, h, v) => {
        vy(o, (C) => {
          d(this, sa).call(this) ? v(C) : h(C);
        });
        const y = S(this, Ke, dF).call(this);
        y && vy(y, (C) => {
          C.stopPropagation(), v(C);
        });
      },
      onChange: S(this, Ke, sF).bind(this)
    }));
  }
  get triggerElement() {
    return d(this, mo).call(this);
  }
  get contentElement() {
    return d(this, Gi).call(this);
  }
  get isSubmenu() {
    return !!d(this, xd);
  }
  onSetup() {
    L(this, wl, Ua());
    const n = ++F8;
    L(this, iy, `media-menu-${n}`), L(this, ry, `media-menu-button-${n}`), L(this, Bu, new N8({
      closeMenu: this.close.bind(this)
    })), ep(Pd) && L(this, xd, Us(Pd)), S(this, Ke, eF).call(this), this.setAttributes({
      "data-open": d(this, sa),
      "data-root": !this.isSubmenu,
      "data-submenu": this.isSubmenu,
      "data-disabled": S(this, Ke, rT).bind(this)
    }), Ju(Pd, {
      button: d(this, mo),
      content: d(this, Gi),
      expanded: d(this, sa),
      hint: st(""),
      submenu: !!d(this, xd),
      disable: S(this, Ke, oF).bind(this),
      attachMenuButton: S(this, Ke, nF).bind(this),
      attachMenuItems: S(this, Ke, iF).bind(this),
      attachObserver: S(this, Ke, rF).bind(this),
      disableMenuButton: S(this, Ke, aF).bind(this),
      addSubmenu: S(this, Ke, hF).bind(this),
      onTransitionEvent: (o) => {
        d(this, Yh).add(o), Wt(() => {
          d(this, Yh).delete(o);
        });
      }
    });
  }
  onAttach(n) {
    n.style.setProperty("display", "contents");
  }
  onConnect(n) {
    var o;
    J(S(this, Ke, tF).bind(this)), this.isSubmenu && ((o = d(this, xd)) == null || o.addSubmenu(this));
  }
  onDestroy() {
    d(this, mo).set(null), d(this, Gi).set(null), L(this, jh, null), d(this, Yh).clear();
  }
  open(n) {
    ye(d(this, sa)) || (d(this, Bh).show(n), Xu());
  }
  close(n) {
    ye(d(this, sa)) && (d(this, Bh).hide(n), Xu());
  }
}
wl = new WeakMap(), iy = new WeakMap(), ry = new WeakMap(), sa = new WeakMap(), JT = new WeakMap(), mo = new WeakMap(), Gi = new WeakMap(), xd = new WeakMap(), Rd = new WeakMap(), jh = new WeakMap(), Bh = new WeakMap(), Bu = new WeakMap(), Qh = new WeakMap(), ew = new WeakMap(), Yh = new WeakMap(), Ke = new WeakSet(), eF = function() {
  let n = -1, o = ep(oT) ? Us(oT) : null;
  Ju(oT, {
    onDragStart: () => {
      var h;
      (h = o == null ? void 0 : o.onDragStart) == null || h.call(o), window.clearTimeout(n), n = -1, L(this, Qh, !0);
    },
    onDragEnd: () => {
      var h;
      (h = o == null ? void 0 : o.onDragEnd) == null || h.call(o), n = window.setTimeout(() => {
        L(this, Qh, !1), n = -1;
      }, 300);
    }
  });
}, tF = function() {
  const n = S(this, Ke, lF).call(this);
  this.isSubmenu || d(this, ly).call(this), S(this, Ke, sM).call(this, n), n && (J(() => {
    const { height: o } = d(this, wl).$state, h = d(this, Gi).call(this);
    h && Nd(h, "--player-height", o() + "px");
  }), d(this, Bu).listen(), this.listen("pointerup", S(this, Ke, uF).bind(this)), En(window, "pointerup", S(this, Ke, cF).bind(this)));
}, nF = function(n) {
  const o = n.el, h = this.isSubmenu, v = sp(S(this, Ke, rT).bind(this));
  Wi(o, "tabindex", h ? "-1" : "0"), Wi(o, "role", h ? "menuitem" : "button"), ht(o, "id", d(this, ry)), ht(o, "aria-haspopup", "menu"), ht(o, "aria-expanded", "false"), ht(o, "data-root", !this.isSubmenu), ht(o, "data-submenu", this.isSubmenu), J(() => {
    ht(o, "data-open", d(this, sa).call(this)), ht(o, "aria-disabled", v());
  }), d(this, mo).set(o), Wt(() => {
    d(this, mo).set(null);
  });
}, iF = function(n) {
  var y;
  const o = n.el;
  o.style.setProperty("display", "none"), ht(o, "id", d(this, iy)), Wi(o, "role", "menu"), Wi(o, "tabindex", "-1"), ht(o, "data-root", !this.isSubmenu), ht(o, "data-submenu", this.isSubmenu), d(this, Gi).set(o), Wt(() => d(this, Gi).set(null)), J(() => ht(o, "data-open", d(this, sa).call(this))), d(this, Bu).attachMenu(o), S(this, Ke, sM).call(this, !1);
  const v = S(this, Ke, yF).bind(this);
  this.isSubmenu ? (y = d(this, xd)) == null || y.onTransitionEvent(v) : (n.listen("transitionstart", v), n.listen("transitionend", v), n.listen("animationend", d(this, ly)), n.listen("vds-menu-resize", d(this, ly)));
}, rF = function(n) {
  L(this, jh, n);
}, sM = function(n) {
  const o = ye(d(this, Gi));
  o && ht(o, "aria-hidden", XC(!n));
}, aF = function(n) {
  d(this, ew).set(n);
}, ay = new WeakMap(), sF = function(n, o) {
  var y, C, D, $, _, A;
  if (L(this, ay, D0(o)), o == null || o.stopPropagation(), d(this, sa).call(this) === n) return;
  if (S(this, Ke, rT).call(this)) {
    n && d(this, Bh).hide(o);
    return;
  }
  (y = this.el) == null || y.dispatchEvent(
    new Event("vds-menu-resize", {
      bubbles: !0,
      composed: !0
    })
  );
  const h = d(this, mo).call(this), v = d(this, Gi).call(this);
  if (h && (ht(h, "aria-controls", n && d(this, iy)), ht(h, "aria-expanded", XC(n))), v && ht(v, "aria-labelledby", n && d(this, ry)), d(this, sa).set(n), S(this, Ke, fF).call(this, o), Xu(), d(this, ay)) {
    n ? v == null || v.focus() : h == null || h.focus();
    for (const B of [this.el, v])
      B && B.setAttribute("data-keyboard", "");
  } else
    for (const B of [this.el, v])
      B && B.removeAttribute("data-keyboard");
  if (this.dispatch(n ? "open" : "close", { trigger: o }), n)
    !this.isSubmenu && d(this, wl).activeMenu !== this && ((C = d(this, wl).activeMenu) == null || C.close(o), d(this, wl).activeMenu = this), ($ = (D = d(this, jh)) == null ? void 0 : D.onOpen) == null || $.call(D, o);
  else {
    if (this.isSubmenu)
      for (const B of d(this, Rd)) B.close(o);
    else
      d(this, wl).activeMenu = null;
    (A = (_ = d(this, jh)) == null ? void 0 : _.onClose) == null || A.call(_, o);
  }
  n && requestAnimationFrame(S(this, Ke, lM).bind(this));
}, lM = function() {
  d(this, oy) || d(this, sy) || (d(this, Bu).update(), requestAnimationFrame(() => {
    d(this, ay) ? d(this, Bu).focusActive() : d(this, Bu).scroll();
  }));
}, lF = function() {
  return !S(this, Ke, rT).call(this) && d(this, sa).call(this);
}, rT = function() {
  return d(this, JT).call(this) || d(this, ew).call(this);
}, oF = function(n) {
  d(this, JT).set(n);
}, uF = function(n) {
  const o = d(this, Gi).call(this);
  d(this, Qh) || o && qA(o, n) || n.stopPropagation();
}, cF = function(n) {
  const o = d(this, Gi).call(this);
  d(this, Qh) || o && qA(o, n) || this.close(n);
}, dF = function() {
  var o;
  const n = (o = this.el) == null ? void 0 : o.querySelector('[data-part="close-target"]');
  return this.el && n && o_(this.el, n, (h) => h.getAttribute("role") === "menu") ? n : null;
}, fF = function(n) {
  this.isSubmenu || (d(this, sa).call(this) ? d(this, wl).remote.pauseControls(n) : d(this, wl).remote.resumeControls(n));
}, hF = function(n) {
  d(this, Rd).add(n), new gn(n).add("open", d(this, E0)).add("close", d(this, b0)), Wt(d(this, w0));
}, w0 = new WeakMap(), pF = function(n) {
  d(this, Rd).delete(n);
}, sy = new WeakMap(), E0 = new WeakMap(), mF = function(n) {
  var h;
  L(this, sy, !0);
  const o = d(this, Gi).call(this);
  this.isSubmenu && ((h = this.triggerElement) == null || h.setAttribute("aria-hidden", "true"));
  for (const v of d(this, Rd))
    if (v !== n.target)
      for (const y of [v.el, v.triggerElement])
        y == null || y.setAttribute("aria-hidden", "true");
  if (o) {
    const v = n.target.el;
    for (const y of o.children)
      y.contains(v) ? y.setAttribute("data-open", "") : y !== v && y.setAttribute("data-hidden", "");
  }
}, b0 = new WeakMap(), vF = function(n) {
  var h;
  L(this, sy, !1);
  const o = d(this, Gi).call(this);
  this.isSubmenu && ((h = this.triggerElement) == null || h.setAttribute("aria-hidden", "false"));
  for (const v of d(this, Rd))
    for (const y of [v.el, v.triggerElement])
      y == null || y.setAttribute("aria-hidden", "false");
  if (o)
    for (const v of o.children)
      v.removeAttribute("data-open"), v.removeAttribute("data-hidden");
}, ly = new WeakMap(), oy = new WeakMap(), yF = function(n) {
  const o = d(this, Gi).call(this);
  o && n.propertyName === "height" && (L(this, oy, n.type === "transitionstart"), ht(o, "data-transition", d(this, oy) ? "height" : null), d(this, sa).call(this) && S(this, Ke, lM).call(this));
  for (const h of d(this, Yh)) h(n);
}, Z(Dy, "props", {
  showDelay: 0
});
fw([
  rn
], Dy.prototype, "triggerElement");
fw([
  rn
], Dy.prototype, "contentElement");
fw([
  rn
], Dy.prototype, "isSubmenu");
fw([
  Zi
], Dy.prototype, "open");
fw([
  Zi
], Dy.prototype, "close");
var V8 = Object.defineProperty, H8 = Object.getOwnPropertyDescriptor, I8 = (f, s, n, o) => {
  for (var h = H8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && V8(s, n, h), h;
}, Dd, tw, tc, SF, TF, oM;
class gF extends bi {
  constructor() {
    super();
    R(this, tc);
    R(this, Dd);
    R(this, tw, st(null));
    new dw();
  }
  get expanded() {
    var n;
    return ((n = d(this, Dd)) == null ? void 0 : n.expanded()) ?? !1;
  }
  onSetup() {
    L(this, Dd, Us(Pd));
  }
  onAttach(n) {
    d(this, Dd).attachMenuButton(this), J(S(this, tc, SF).bind(this)), Wi(n, "type", "button");
  }
  onConnect(n) {
    J(S(this, tc, TF).bind(this)), S(this, tc, oM).call(this);
    const o = new MutationObserver(S(this, tc, oM).bind(this));
    o.observe(n, { attributeFilter: ["data-part"], childList: !0, subtree: !0 }), Wt(() => o.disconnect()), vy(n, (h) => {
      this.dispatch("select", { trigger: h });
    });
  }
}
Dd = new WeakMap(), tw = new WeakMap(), tc = new WeakSet(), SF = function() {
  d(this, Dd).disableMenuButton(this.$props.disabled());
}, TF = function() {
  const n = d(this, tw).call(this);
  n && J(() => {
    const o = d(this, Dd).hint();
    o && (n.textContent = o);
  });
}, oM = function() {
  var o;
  const n = (o = this.el) == null ? void 0 : o.querySelector('[data-part="hint"]');
  d(this, tw).set(n ?? null);
}, Z(gF, "props", {
  disabled: !1
});
I8([
  rn
], gF.prototype, "expanded");
const uM = by();
var Qu, Md, xM, Fs, EF, bF, C0, cM, dM;
class wF extends Hs {
  constructor() {
    super(...arguments);
    R(this, Fs);
    R(this, Qu, /* @__PURE__ */ new Set());
    R(this, Md, st(""));
    R(this, xM, null);
    Z(this, "onValueChange");
    R(this, C0, S(this, Fs, cM).bind(this));
  }
  get values() {
    return Array.from(d(this, Qu)).map((n) => n.value());
  }
  get value() {
    return d(this, Md).call(this);
  }
  set value(n) {
    S(this, Fs, cM).call(this, n);
  }
  onSetup() {
    Ju(uM, {
      add: S(this, Fs, EF).bind(this),
      remove: S(this, Fs, bF).bind(this)
    });
  }
  onAttach(n) {
    ep(Pd) || Wi(n, "role", "radiogroup"), this.setAttributes({ value: d(this, Md) });
  }
  onDestroy() {
    d(this, Qu).clear();
  }
}
Qu = new WeakMap(), Md = new WeakMap(), xM = new WeakMap(), Fs = new WeakSet(), EF = function(n) {
  d(this, Qu).has(n) || (d(this, Qu).add(n), n.onCheck = d(this, C0), n.check(n.value() === d(this, Md).call(this)));
}, bF = function(n) {
  n.onCheck = null, d(this, Qu).delete(n);
}, C0 = new WeakMap(), cM = function(n, o) {
  var C;
  const h = ye(d(this, Md));
  if (!n || n === h) return;
  const v = S(this, Fs, dM).call(this, h), y = S(this, Fs, dM).call(this, n);
  v == null || v.check(!1, o), y == null || y.check(!0, o), d(this, Md).set(n), (C = this.onValueChange) == null || C.call(this, n, o);
}, dM = function(n) {
  for (const o of d(this, Qu))
    if (n === ye(o.value)) return o;
  return null;
};
var q8 = Object.defineProperty, j8 = Object.getOwnPropertyDescriptor, CF = (f, s, n, o) => {
  for (var h = j8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && q8(s, n, h), h;
}, Yu, Sy, kF, xF;
class GM extends bi {
  constructor() {
    super();
    R(this, Sy);
    R(this, Yu);
    L(this, Yu, new wF()), d(this, Yu).onValueChange = S(this, Sy, xF).bind(this);
  }
  get values() {
    return d(this, Yu).values;
  }
  get value() {
    return d(this, Yu).value;
  }
  set value(n) {
    d(this, Yu).value = n;
  }
  onSetup() {
    J(S(this, Sy, kF).bind(this));
  }
}
Yu = new WeakMap(), Sy = new WeakSet(), kF = function() {
  d(this, Yu).value = this.$props.value();
}, xF = function(n, o) {
  const h = this.createEvent("change", { detail: n, trigger: o });
  this.dispatch(h);
}, Z(GM, "props", {
  value: ""
});
CF([
  rn
], GM.prototype, "values");
CF([
  rn
], GM.prototype, "value");
var B8 = Object.defineProperty, Q8 = Object.getOwnPropertyDescriptor, Y8 = (f, s, n, o) => {
  for (var h = Q8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && B8(s, n, h), h;
}, vo, Gh, Tr, DF, MF, LF, $F, OF, fM, AF;
class RF extends bi {
  constructor() {
    super();
    R(this, Tr);
    R(this, vo, st(!1));
    R(this, Gh, {
      value: this.$props.value,
      check: S(this, Tr, OF).bind(this),
      onCheck: null
    });
    new dw();
  }
  get checked() {
    return d(this, vo).call(this);
  }
  onSetup() {
    this.setAttributes({
      value: this.$props.value,
      "data-checked": d(this, vo),
      "aria-checked": sp(d(this, vo))
    });
  }
  onAttach(n) {
    const o = ep(Pd);
    Wi(n, "tabindex", o ? "-1" : "0"), Wi(n, "role", o ? "menuitemradio" : "radio"), J(S(this, Tr, LF).bind(this));
  }
  onConnect(n) {
    S(this, Tr, MF).call(this), vy(n, S(this, Tr, $F).bind(this)), Wt(S(this, Tr, DF).bind(this));
  }
}
vo = new WeakMap(), Gh = new WeakMap(), Tr = new WeakSet(), DF = function() {
  bl(() => {
    Us(uM).remove(d(this, Gh));
  }, this.connectScope);
}, MF = function() {
  Us(uM).add(d(this, Gh));
}, LF = function() {
  var h, v;
  const { value: n } = this.$props, o = n();
  ye(d(this, vo)) && ((v = (h = d(this, Gh)).onCheck) == null || v.call(h, o));
}, $F = function(n) {
  var o, h;
  ye(d(this, vo)) || (S(this, Tr, fM).call(this, !0, n), S(this, Tr, AF).call(this, n), (h = (o = d(this, Gh)).onCheck) == null || h.call(o, ye(this.$props.value), n));
}, OF = function(n, o) {
  ye(d(this, vo)) !== n && S(this, Tr, fM).call(this, n, o);
}, fM = function(n, o) {
  d(this, vo).set(n), this.dispatch("change", { detail: n, trigger: o });
}, AF = function(n) {
  this.dispatch("select", { trigger: n });
}, Z(RF, "props", {
  value: ""
});
Y8([
  rn
], RF.prototype, "checked");
var G8 = Object.defineProperty, W8 = Object.getOwnPropertyDescriptor, WM = (f, s, n, o) => {
  for (var h = W8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && G8(s, n, h), h;
};
const PF = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
var Ld, uy, Wh, Vs, _F, NF, UF, zF, FF;
class N0 extends bi {
  constructor() {
    super();
    R(this, Vs);
    R(this, Ld);
    R(this, uy);
    R(this, Wh);
    L(this, Wh, new wF()), d(this, Wh).onValueChange = S(this, Vs, FF).bind(this);
  }
  get value() {
    return d(this, Wh).value;
  }
  get disabled() {
    const { rates: n } = this.$props, { canSetPlaybackRate: o } = d(this, Ld).$state;
    return !o() || n().length === 0;
  }
  onSetup() {
    L(this, Ld, Ua()), ep(Pd) && L(this, uy, Us(Pd));
  }
  onConnect(n) {
    J(S(this, Vs, _F).bind(this)), J(S(this, Vs, NF).bind(this)), J(S(this, Vs, UF).bind(this));
  }
  getOptions() {
    const { rates: n, normalLabel: o } = this.$props;
    return n().map((h) => ({
      label: h === 1 ? o : h + "×",
      value: h.toString()
    }));
  }
}
Ld = new WeakMap(), uy = new WeakMap(), Wh = new WeakMap(), Vs = new WeakSet(), _F = function() {
  d(this, Wh).value = S(this, Vs, zF).call(this);
}, NF = function() {
  var v;
  const { normalLabel: n } = this.$props, { playbackRate: o } = d(this, Ld).$state, h = o();
  (v = d(this, uy)) == null || v.hint.set(h === 1 ? n() : h + "×");
}, UF = function() {
  var n;
  (n = d(this, uy)) == null || n.disable(this.disabled);
}, zF = function() {
  const { playbackRate: n } = d(this, Ld).$state;
  return n().toString();
}, FF = function(n, o) {
  if (this.disabled) return;
  const h = +n;
  d(this, Ld).remote.changePlaybackRate(h, o), this.dispatch("change", { detail: h, trigger: o });
}, Z(N0, "props", {
  normalLabel: "Normal",
  rates: PF
});
WM([
  rn
], N0.prototype, "value");
WM([
  rn
], N0.prototype, "disabled");
WM([
  Zi
], N0.prototype, "getOptions");
var cy, Gu, Wu, nw, hM;
class K8 {
  constructor(s) {
    R(this, nw);
    Z(this, "priority", 10);
    R(this, cy, null);
    R(this, Gu);
    R(this, Wu);
    L(this, Gu, s);
  }
  attach() {
  }
  canRender() {
    return !0;
  }
  detach() {
    var s;
    (s = d(this, Wu)) == null || s.abort(), L(this, Wu, void 0), d(this, Gu).reset(), L(this, cy, null);
  }
  changeTrack(s) {
    var n;
    !s || d(this, cy) === s || ((n = d(this, Wu)) == null || n.abort(), L(this, Wu, new gn(s)), s.readyState < 2 ? (d(this, Gu).reset(), d(this, Wu).add("load", () => S(this, nw, hM).call(this, s), { once: !0 })) : S(this, nw, hM).call(this, s), d(this, Wu).add("add-cue", (o) => {
      d(this, Gu).addCue(o.detail);
    }).add("remove-cue", (o) => {
      d(this, Gu).removeCue(o.detail);
    }), L(this, cy, s));
  }
}
cy = new WeakMap(), Gu = new WeakMap(), Wu = new WeakMap(), nw = new WeakSet(), hM = function(s) {
  d(this, Gu).changeTrack({
    cues: [...s.cues],
    regions: [...s.regions]
  });
};
var as, Aa, ut, VC, VF, HF, IF, pM, qF, jF, BF, QF, mM, YF, GF, Ku, vM, HC, yM, gM;
let X8 = (as = class extends bi {
  constructor() {
    super(...arguments);
    R(this, ut);
    R(this, Aa);
    R(this, Ku, -1);
  }
  onSetup() {
    L(this, Aa, Ua()), this.setAttributes({
      "aria-hidden": sp(S(this, ut, VC).bind(this))
    });
  }
  onAttach(n) {
    n.style.setProperty("pointer-events", "none");
  }
  onConnect(n) {
    as.lib() || import("./dev-D3SS6qhA.js").then((o) => o.d).then((o) => as.lib.set(o)), J(S(this, ut, VF).bind(this));
  }
}, Aa = new WeakMap(), ut = new WeakSet(), VC = function() {
  const { textTrack: n, remotePlaybackState: o, iOSControls: h } = d(this, Aa).$state, v = n();
  return h() || o() === "connected" || !v || !_a(v);
}, VF = function() {
  if (!as.lib()) return;
  const { viewType: n } = d(this, Aa).$state;
  return n() === "audio" ? S(this, ut, HF).call(this) : S(this, ut, jF).call(this);
}, HF = function() {
  return J(S(this, ut, IF).bind(this)), S(this, ut, mM).call(this, null), () => {
    this.el.textContent = "";
  };
}, IF = function() {
  if (S(this, ut, VC).call(this)) return;
  S(this, ut, pM).call(this);
  const { textTrack: n } = d(this, Aa).$state;
  En(n(), "cue-change", S(this, ut, pM).bind(this)), J(S(this, ut, qF).bind(this));
}, pM = function() {
  this.el.textContent = "", d(this, Ku) >= 0 && S(this, ut, HC).call(this);
  const { realCurrentTime: n, textTrack: o } = d(this, Aa).$state, { renderVTTCueString: h } = as.lib(), v = ye(n), y = ye(o).activeCues;
  for (const C of y) {
    const D = S(this, ut, yM).call(this), $ = S(this, ut, gM).call(this);
    $.innerHTML = h(C, v), D.append($), this.el.append($);
  }
}, qF = function() {
  const { realCurrentTime: n } = d(this, Aa).$state, { updateTimedVTTCueNodes: o } = as.lib();
  o(this.el, n());
}, jF = function() {
  const { CaptionsRenderer: n } = as.lib(), o = new n(this.el), h = new K8(o);
  return d(this, Aa).textRenderers.add(h), J(S(this, ut, BF).bind(this, o)), J(S(this, ut, QF).bind(this, o)), S(this, ut, mM).call(this, o), () => {
    this.el.textContent = "", d(this, Aa).textRenderers.remove(h), o.destroy();
  };
}, BF = function(n) {
  n.dir = this.$props.textDir();
}, QF = function(n) {
  var v;
  if (S(this, ut, VC).call(this)) return;
  const { realCurrentTime: o, textTrack: h } = d(this, Aa).$state;
  n.currentTime = o(), d(this, Ku) >= 0 && ((v = h()) != null && v.activeCues[0]) && S(this, ut, HC).call(this);
}, mM = function(n) {
  const o = d(this, Aa).player;
  if (!o) return;
  const h = S(this, ut, YF).bind(this, n);
  En(o, "vds-font-change", h);
}, YF = function(n) {
  var h;
  if (d(this, Ku) >= 0) {
    S(this, ut, vM).call(this);
    return;
  }
  const { textTrack: o } = d(this, Aa).$state;
  (h = o()) != null && h.activeCues[0] ? n == null || n.update(!0) : S(this, ut, GF).call(this);
}, GF = function() {
  var h, v;
  const n = S(this, ut, yM).call(this);
  ht(n, "data-example", "");
  const o = S(this, ut, gM).call(this);
  ht(o, "data-example", ""), o.textContent = this.$props.exampleText(), n == null || n.append(o), (h = this.el) == null || h.append(n), (v = this.el) == null || v.setAttribute("data-example", ""), S(this, ut, vM).call(this);
}, Ku = new WeakMap(), vM = function() {
  window.clearTimeout(d(this, Ku)), L(this, Ku, window.setTimeout(S(this, ut, HC).bind(this), 2500));
}, HC = function() {
  var n, o;
  (n = this.el) == null || n.removeAttribute("data-example"), (o = this.el) != null && o.querySelector("[data-example]") && (this.el.textContent = ""), L(this, Ku, -1);
}, yM = function() {
  const n = document.createElement("div");
  return ht(n, "data-part", "cue-display"), n;
}, gM = function() {
  const n = document.createElement("div");
  return ht(n, "data-part", "cue"), n;
}, Z(as, "props", {
  textDir: "ltr",
  exampleText: "Captions look like this."
}), Z(as, "lib", st(null)), as);
var EC, Kh, $d, iw, rw, _n, WF, KF, XF, SM, ZF, JF, TM, IC, eV;
let Z8 = (EC = class extends bi {
  constructor() {
    super(...arguments);
    R(this, _n);
    R(this, Kh);
    R(this, $d, st(null));
    R(this, iw, st(!0));
    R(this, rw, st(!0));
  }
  onSetup() {
    L(this, Kh, Ua()), S(this, _n, SM).call(this);
    const { type: n } = this.$props;
    this.setAttributes({
      "data-type": n,
      "data-remainder": S(this, _n, IC).bind(this)
    }), new yz({
      callback: S(this, _n, WF).bind(this)
    }).attach(this);
  }
  onAttach(n) {
    n.hasAttribute("role") || J(S(this, _n, ZF).bind(this)), J(S(this, _n, SM).bind(this)), J(S(this, _n, JF).bind(this));
  }
  onConnect(n) {
    Wt(l_(n, d(this, iw).set)), J(S(this, _n, KF).bind(this)), J(S(this, _n, XF).bind(this));
  }
}, Kh = new WeakMap(), $d = new WeakMap(), iw = new WeakMap(), rw = new WeakMap(), _n = new WeakSet(), WF = function(n) {
  d(this, rw).set(n[0].isIntersecting);
}, KF = function() {
  const { hidden: n } = this.$props;
  this.$state.hidden.set(n() || !d(this, iw).call(this) || !d(this, rw).call(this));
}, XF = function() {
  if (!this.$props.toggle()) {
    d(this, $d).set(null);
    return;
  }
  this.el && vy(this.el, S(this, _n, eV).bind(this));
}, SM = function() {
  const { hidden: n, timeText: o } = this.$state, { duration: h } = d(this, Kh).$state;
  if (n()) return;
  const { type: v, padHours: y, padMinutes: C, showHours: D } = this.$props, $ = S(this, _n, TM).call(this, v()), _ = h(), A = S(this, _n, IC).call(this);
  if (!Number.isFinite($ + _)) {
    o.set("LIVE");
    return;
  }
  const B = A ? Math.max(0, _ - $) : $, W = BM(B, {
    padHrs: y(),
    padMins: C(),
    showHrs: D()
  });
  o.set((A ? "-" : "") + W);
}, ZF = function() {
  if (!this.el) return;
  const { toggle: n } = this.$props;
  ht(this.el, "role", n() ? "timer" : null), ht(this.el, "tabindex", n() ? 0 : null);
}, JF = function() {
  if (!this.el) return;
  const { hidden: n } = this.$state, { duration: o } = d(this, Kh).$state;
  if (n()) {
    ht(this.el, "aria-label", null);
    return;
  }
  const { type: h } = this.$props, v = S(this, _n, TM).call(this, h()), y = S(this, _n, IC).call(this);
  if (!Number.isFinite(v + o())) {
    ht(this.el, "aria-label", "Live");
    return;
  }
  const C = y ? Math.max(0, o() - v) : v, D = (y ? "-" : "") + iD(C);
  ht(this.el, "aria-label", D);
}, TM = function(n) {
  const { bufferedEnd: o, duration: h, currentTime: v } = d(this, Kh).$state;
  switch (n) {
    case "buffered":
      return o();
    case "duration":
      return h();
    default:
      return v();
  }
}, IC = function() {
  return this.$props.remainder() && d(this, $d).call(this) !== !1;
}, eV = function(n) {
  if (n.preventDefault(), d(this, $d).call(this) === null) {
    d(this, $d).set(!this.$props.remainder());
    return;
  }
  d(this, $d).set((o) => !o);
}, Z(EC, "props", {
  type: "current",
  showHours: !1,
  padHours: null,
  padMinutes: null,
  remainder: !1,
  toggle: !1,
  hidden: !1
}), Z(EC, "state", new Cy({
  timeText: "",
  hidden: !1
})), EC);
class KM extends i8 {
}
class J8 extends lz {
}
class e6 extends v8 {
}
class tV extends np {
}
class t6 extends a0 {
}
class n6 extends KD {
}
class i6 extends T8 {
}
class r6 extends YM {
}
class a6 extends r0 {
}
class s6 extends u2 {
}
class l6 extends Ry {
}
class o6 extends X8 {
}
class u6 extends Z8 {
}
const U0 = ue.createContext({ current: null });
U0.displayName = "Scope";
function c6(f, ...s) {
  return ue.createElement(U0.Provider, { value: f }, ...s);
}
function d6() {
  return ue.useContext(U0).current;
}
function nV(f) {
  const s = d6();
  return ue.useMemo(() => MM(f.id, s), [s]);
}
function iV(f, s) {
  typeof f == "function" ? f(s) : f && (f.current = s);
}
function Hd(...f) {
  return (s) => f.forEach((n) => iV(n, s));
}
function f6(f, s) {
  const n = ue.forwardRef((o, h) => {
    var Re, Lt, $t, Ve, ct, Ye, wt, He;
    let v = ue.useContext(U0), y = ue.useRef(null), C = ue.useRef();
    if (!C.current) {
      const de = p6(), Ge = lP(f, de, o, v.current);
      de.component = Ge, C.current = de, y.current = Ge.scope;
    }
    function D() {
      let de = C.current, Ge = v.current;
      if (window.cancelAnimationFrame(de.destroyId), de.destroyId = -1, de.component.$$.destroyed) {
        const ft = lP(f, de, o, Ge);
        de.component = ft, de.attached = !1, de.forwardRef = !1, y.current = ft.scope;
      }
      return de.el && sP(de, de.el), de.forwardRef || (iV(h, de.component), de.forwardRef = !0), () => qC(de);
    }
    function $(de) {
      const Ge = C.current;
      if (!Ge.forwardRef) {
        Ge.el = de;
        return;
      }
      window.cancelAnimationFrame(Ge.refChangeId), Ge.refChangeId = window.requestAnimationFrame(() => {
        const ft = C.current;
        ft.refChangeId = -1, ft.el !== de && (qC(ft), de && sP(ft, de), ft.el = de);
      });
    }
    ue.useEffect(() => {
      const de = C.current;
      return window.cancelAnimationFrame(de.destroyId), de.destroyId = -1, function() {
        ls(o.children) && (window.cancelAnimationFrame(de.refChangeId), de.refChangeId = -1, window.cancelAnimationFrame(de.connectId), de.connectId = -1, window.cancelAnimationFrame(de.destroyId), de.destroyId = window.requestAnimationFrame(() => {
          de.destroyId = -1, qC(de), de.component.$$.destroy(), de.component.$$[L0] = null, de.callbacks = {}, de.domCallbacks = {}, y.current = null;
        }));
      };
    }, []), ue.useEffect(Xu);
    let _ = C.current, { children: A, ...B } = o, W = {}, ne = _.prevProps, ce = Object.keys(B);
    _.callbacks = {};
    for (const de of [...ne, ...ce])
      if (s.props.has(de))
        _.component.$props[de].set(
          // If the prop was removed we'll use the default value provided on Component creation.
          mi(B[de]) ? (Re = f.props) == null ? void 0 : Re[de] : B[de]
        );
      else if ((Lt = s.events) != null && Lt.has(de) || ($t = s.eventsRE) != null && $t.test(de))
        _.callbacks[de] = B[de];
      else if ((Ve = s.domEvents) != null && Ve.has(de) || (ct = s.domEventsRE) != null && ct.test(de)) {
        let Ge = M0(de.slice(2));
        _.domCallbacks[Ge] = B[de], ce.includes(de) ? _.el && !((He = _.listening) != null && He.has(Ge)) && (_.listening || (_.listening = /* @__PURE__ */ new Set()), _.listening.add(Ge), _.el.addEventListener(Ge, _.onDOMEvent)) : ((Ye = _.el) == null || Ye.removeEventListener(Ge, _.onDOMEvent), (wt = _.listening) == null || wt.delete(Ge));
      } else
        W[de] = B[de];
    return _.prevProps = ce, c6(
      y,
      ue.createElement(h6, {
        effect: D
      }),
      ls(A) ? A == null ? void 0 : A(
        {
          ...W,
          suppressHydrationWarning: !0,
          ref: $
        },
        _.component
      ) : A
    );
  });
  return n.displayName = f.name + "Bridge", n;
}
function h6({ effect: f }) {
  return ue.useEffect(f, []), null;
}
const aP = /* @__PURE__ */ new Map();
function p6() {
  const f = {
    el: null,
    prevProps: [],
    callbacks: {},
    domCallbacks: {},
    refChangeId: -1,
    connectId: -1,
    destroyId: -1,
    attached: !1,
    forwardRef: !1,
    listening: null,
    onDOMEvent(s) {
      var o, h;
      const n = mi(s.detail) ? [s] : [s.detail, s];
      (h = (o = f.domCallbacks)[s.type]) == null || h.call(o, ...n);
    }
  };
  return f;
}
function sP(f, s) {
  if (!(f.el === s && f.attached)) {
    if (f.attached && qC(f), f.domCallbacks) {
      f.listening || (f.listening = /* @__PURE__ */ new Set());
      for (const n of Object.keys(f.domCallbacks))
        f.listening.has(n) || (s.addEventListener(n, f.onDOMEvent), f.listening.add(n));
    }
    f.component.$$.attach(s), f.connectId = window.requestAnimationFrame(() => {
      f.component.$$.connect(), f.connectId = -1;
    }), f.attached = !0;
  }
}
function qC(f) {
  if (f.attached && (window.cancelAnimationFrame(f.connectId), f.connectId = -1, f.component.$$.detach(), f.attached = !1, f.el && f.listening)) {
    for (const s of f.listening)
      f.el.removeEventListener(s, f.onDOMEvent);
    f.listening.clear();
  }
}
function m6(f) {
  var o, h;
  let s = aP.get(f.type), n = mi(f.detail) ? [f] : [f.detail, f];
  s || aP.set(f.type, s = `on${Jj(f.type)}`), (h = (o = this.callbacks)[s]) == null || h.call(o, ...n);
}
function lP(f, s, n, o) {
  const h = oB(f, { props: n, scope: o });
  return h.$$[L0] = m6.bind(s), h.$$.setup(), h;
}
function hw(f) {
  return nV(f);
}
function Dn(f, s) {
  const [, n] = ue.useState();
  return ue.useEffect(() => VP(() => {
    f(), n({});
  }), [s ?? f]), f();
}
function v6(f) {
  const [, s] = ue.useState(), n = ue.useRef(null);
  return n.current == null && (n.current = {
    state: {},
    $update: st({}),
    props: /* @__PURE__ */ new Set()
  }), ue.useEffect(() => {
    let { state: o, $update: h, props: v } = n.current;
    return J(() => {
      for (const y of v) {
        const C = f[y]();
        o[y] = Vr(C) ? [...C] : C;
      }
      h(), s({});
    });
  }, [f]), ue.useMemo(() => {
    let { state: o, $update: h, props: v } = n.current, y = !1;
    return v.clear(), new Proxy(o, {
      get(C, D) {
        if (!v.has(D) && D in f) {
          v.add(D);
          const $ = f[D]();
          o[D] = Vr($) ? [...$] : $, y || (h.set({}), y = !0, queueMicrotask(() => y = !1));
        }
        return o[D];
      },
      set(C, D, $) {
        return D in f || (o[D] = $), !0;
      }
    });
  }, [f]);
}
function cs(f, s) {
  return f6(f, {
    props: new Set(Object.keys(f.props || {})),
    events: new Set(s == null ? void 0 : s.events),
    eventsRE: s == null ? void 0 : s.eventsRegex,
    domEvents: s == null ? void 0 : s.domEvents,
    domEventsRE: s == null ? void 0 : s.domEventsRegex
  });
}
const y6 = [
  "onAbort",
  "onAudioTrackChange",
  "onAudioTracksChange",
  "onAutoPlay",
  "onAutoPlayChange",
  "onAutoPlayFail",
  "onCanLoad",
  "onCanPlay",
  "onCanPlayThrough",
  "onControlsChange",
  "onDestroy",
  "onDurationChange",
  "onEmptied",
  "onEnd",
  "onEnded",
  "onError",
  "onFindMediaPlayer",
  "onFullscreenChange",
  "onFullscreenError",
  "onLiveChange",
  "onLiveEdgeChange",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onLoopChange",
  "onOrientationChange",
  "onPause",
  "onPictureInPictureChange",
  "onPictureInPictureError",
  "onPlay",
  "onPlayFail",
  "onPlaying",
  "onPlaysInlineChange",
  "onPosterChange",
  "onProgress",
  "onProviderChange",
  "onProviderLoaderChange",
  "onProviderSetup",
  "onQualitiesChange",
  "onQualityChange",
  "onRateChange",
  "onReplay",
  "onSeeked",
  "onSeeking",
  "onSourceChange",
  "onSourceChange",
  "onStalled",
  "onStarted",
  "onStreamTypeChange",
  "onSuspend",
  "onTextTrackChange",
  "onTextTracksChange",
  "onTimeUpdate",
  "onTitleChange",
  "onVdsLog",
  "onVideoPresentationChange",
  "onVolumeChange",
  "onWaiting"
], rV = ue.forwardRef((f, s) => {
  const { children: n, ...o } = f, h = ue.Children.toArray(n), v = h.find(S6);
  if (v) {
    const y = v.props.children, C = h.map((D) => D === v ? ue.Children.count(y) > 1 ? ue.Children.only(null) : ue.isValidElement(y) ? y.props.children : null : D);
    return /* @__PURE__ */ lt(wM, { ...o, ref: s, children: ue.isValidElement(y) ? ue.cloneElement(y, void 0, C) : null });
  }
  return /* @__PURE__ */ lt(wM, { ...o, ref: s, children: n });
});
rV.displayName = "Slot";
const wM = ue.forwardRef((f, s) => {
  const { children: n, ...o } = f;
  return ue.isValidElement(n) ? ue.cloneElement(n, {
    ...T6(o, n.props),
    ref: s ? Hd(s, n.ref) : n.ref
  }) : ue.Children.count(n) > 1 ? ue.Children.only(null) : null;
});
wM.displayName = "SlotClone";
const g6 = ({ children: f }) => /* @__PURE__ */ lt(Rj, { children: f });
function S6(f) {
  return ue.isValidElement(f) && f.type === g6;
}
function T6(f, s) {
  const n = { ...s };
  for (const o in s) {
    const h = f[o], v = s[o];
    /^on[A-Z]/.test(o) ? h && v ? n[o] = (...C) => {
      v(...C), h(...C);
    } : h && (n[o] = h) : o === "style" ? n[o] = { ...h, ...v } : o === "className" && (n[o] = [h, v].filter(Boolean).join(" "));
  }
  return { ...f, ...n };
}
const w6 = ["button", "div", "span", "img", "video", "audio"], Ji = w6.reduce((f, s) => {
  const n = ue.forwardRef((o, h) => {
    const { asChild: v, ...y } = o;
    return /* @__PURE__ */ lt(v ? rV : s, { ...y, ref: h });
  });
  return n.displayName = `Primitive.${s}`, { ...f, [s]: n };
}, {}), E6 = cs(KM, {
  events: y6,
  eventsRegex: /^onHls/,
  domEventsRegex: /^onMedia/
}), b6 = ue.forwardRef(
  ({ aspectRatio: f, children: s, ...n }, o) => /* @__PURE__ */ lt(
    E6,
    {
      ...n,
      src: n.src,
      ref: o,
      style: {
        aspectRatio: f,
        ...n.style
      },
      children: (h) => /* @__PURE__ */ lt(Ji.div, { ...h, children: s })
    }
  )
);
b6.displayName = "MediaPlayer";
function lp() {
  return nV(FM);
}
const aV = /* @__PURE__ */ ue.forwardRef((f, s) => {
  const { width: n, height: o, size: h = null, paths: v, ...y } = f;
  return ue.createElement("svg", {
    viewBox: "0 0 32 32",
    ...y,
    width: n ?? h,
    height: o ?? h,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: s,
    dangerouslySetInnerHTML: { __html: v }
  });
});
aV.displayName = "VidstackIcon";
function C6(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "REMOTION";
}
const k6 = cs(J8), x6 = ue.forwardRef(
  ({ loaders: f = [], children: s, iframeProps: n, mediaProps: o, ...h }, v) => {
    const y = ue.useMemo(() => f.map((C) => new C()), f);
    return /* @__PURE__ */ lt(k6, { ...h, loaders: y, ref: v, children: (C, D) => /* @__PURE__ */ hy("div", { ...C, children: [
      /* @__PURE__ */ lt(sV, { provider: D, mediaProps: o, iframeProps: n }),
      s
    ] }) });
  }
);
x6.displayName = "MediaProvider";
function sV({ provider: f, mediaProps: s, iframeProps: n }) {
  const { sources: o, crossOrigin: h, poster: v, remotePlaybackInfo: y, nativeControls: C, viewType: D } = hw(xy), { loader: $ } = f.$state, { $provider: _, $providerSetup: A } = lp(), B = Dn(o), W = Dn(C), ne = Dn(h), ce = Dn(v), Re = Dn($), Lt = Dn(_), $t = Dn(A), Ve = Dn(y), ct = Re == null ? void 0 : Re.mediaType(), Ye = Dn(D), wt = Ye === "audio", He = (Re == null ? void 0 : Re.name) === "youtube", de = (Re == null ? void 0 : Re.name) === "vimeo", Ge = He || de, ft = (Re == null ? void 0 : Re.name) === "remotion", Kt = (Re == null ? void 0 : Re.name) === "google-cast", [Mt, Ae] = ue.useState(""), [Et, Sn] = ue.useState(!1);
  return ue.useEffect(() => {
    !Kt || Mt || import("./chromecast-fcYiHsj5.js").then((Je) => {
      Ae(Je.default);
    });
  }, [Kt]), ue.useEffect(() => {
    Sn(!0);
  }, []), Kt ? /* @__PURE__ */ hy(
    "div",
    {
      className: "vds-google-cast",
      ref: (Je) => {
        f.load(Je);
      },
      children: [
        /* @__PURE__ */ lt(aV, { paths: Mt }),
        Ve != null && Ve.deviceName ? /* @__PURE__ */ hy("span", { className: "vds-google-cast-info", children: [
          "Google Cast on",
          " ",
          /* @__PURE__ */ lt("span", { className: "vds-google-cast-device-name", children: Ve.deviceName })
        ] }) : null
      ]
    }
  ) : ft ? /* @__PURE__ */ lt("div", { "data-remotion-canvas": !0, children: /* @__PURE__ */ lt(
    "div",
    {
      "data-remotion-container": !0,
      ref: (Je) => {
        f.load(Je);
      },
      children: C6(Lt) && $t ? ue.createElement(Lt.render) : null
    }
  ) }) : Ge ? ue.createElement(
    ue.Fragment,
    null,
    ue.createElement("iframe", {
      ...n,
      className: (n != null && n.className ? `${n.className} ` : "") + He ? "vds-youtube" : "vds-vimeo",
      suppressHydrationWarning: !0,
      tabIndex: W ? void 0 : -1,
      "aria-hidden": "true",
      "data-no-controls": W ? void 0 : "",
      ref(Je) {
        f.load(Je);
      }
    }),
    !W && !wt ? ue.createElement("div", { className: "vds-blocker" }) : null
  ) : ct ? ue.createElement(ct === "audio" ? "audio" : "video", {
    ...s,
    controls: W ? !0 : null,
    crossOrigin: typeof ne == "boolean" ? "" : ne,
    poster: ct === "video" && W && ce ? ce : null,
    suppressHydrationWarning: !0,
    children: Et ? null : B.map(
      ({ src: Je, type: ot }) => Ze(Je) ? /* @__PURE__ */ lt("source", { src: Je, type: ot !== "?" ? ot : void 0 }, Je) : null
    ),
    ref(Je) {
      f.load(Je);
    }
  }) : null;
}
sV.displayName = "MediaOutlet";
function R6(f) {
  const s = lp(), n = ue.useMemo(() => new Ud(f), Object.values(f));
  return ue.useEffect(() => (s.textTracks.add(n), () => void s.textTracks.remove(n)), [n]), n;
}
function D6({ lang: f, ...s }) {
  return R6({ language: f, ...s }), null;
}
D6.displayName = "Track";
const M6 = cs(e6, {
  domEventsRegex: /^onMedia/
}), L6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(M6, { ...s, children: (o) => /* @__PURE__ */ lt(
    Ji.button,
    {
      ...o,
      ref: Hd(o.ref, n),
      children: f
    }
  ) })
);
L6.displayName = "FullscreenButton";
const oP = tV.state.record, $6 = Object.keys(oP).reduce(
  (f, s) => ({
    ...f,
    [s]() {
      return oP[s];
    }
  }),
  {}
);
function bR(f, s) {
  const n = hw(P0);
  return Dn((n || $6)[f]);
}
const XM = [
  "onDragStart",
  "onDragEnd",
  "onDragValueChange",
  "onValueChange",
  "onPointerValueChange"
], O6 = cs(r6), A6 = cs(tV, {
  events: XM
}), P6 = ue.forwardRef(({ children: f, ...s }, n) => /* @__PURE__ */ lt(A6, { ...s, ref: n, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, children: f }) }));
P6.displayName = "Slider";
const _6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
_6.displayName = "SliderThumb";
const N6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
N6.displayName = "SliderTrack";
const U6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
U6.displayName = "SliderTrackFill";
const z6 = cs(s6), F6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(z6, { ...s, children: (o) => /* @__PURE__ */ lt(
    Ji.div,
    {
      ...o,
      ref: Hd(o.ref, n),
      children: f
    }
  ) })
);
F6.displayName = "SliderPreview";
const V6 = ue.forwardRef(({ children: f, ...s }, n) => /* @__PURE__ */ lt(O6, { ...s, children: (o, h) => {
  const v = Dn(() => h.getValueText(), h);
  return /* @__PURE__ */ hy(Ji.div, { ...o, ref: n, children: [
    v,
    f
  ] });
} }));
V6.displayName = "SliderValue";
const H6 = ue.forwardRef(({ children: f, ...s }, n) => {
  const o = bR("min"), h = bR("max"), v = bR("step"), y = (h - o) / v;
  return /* @__PURE__ */ lt(Ji.div, { ...s, ref: n, children: Array.from({ length: Math.floor(y) + 1 }).map((C, D) => f(D)) });
});
H6.displayName = "SliderSteps";
const I6 = cs(n6, {
  events: XM,
  domEventsRegex: /^onMedia/
}), q6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(I6, { ...s, ref: n, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, children: f }) })
);
q6.displayName = "VolumeSlider";
function j6(f = 0, s = 0, n = "") {
  return new window.VTTCue(f, s, n);
}
const z0 = ue.createContext({
  $chapters: st(null)
});
z0.displayName = "TimeSliderContext";
const B6 = cs(t6, {
  events: XM,
  domEventsRegex: /^onMedia/
}), Q6 = ue.forwardRef(
  ({ children: f, ...s }, n) => {
    const o = ue.useMemo(() => st(null), []);
    return /* @__PURE__ */ lt(z0.Provider, { value: { $chapters: o }, children: /* @__PURE__ */ lt(B6, { ...s, ref: n, children: (h) => /* @__PURE__ */ lt(Ji.div, { ...h, children: f }) }) });
  }
);
Q6.displayName = "TimeSlider";
const Y6 = cs(l6), G6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(Y6, { ...s, children: (o, h) => /* @__PURE__ */ lt(
    Ji.div,
    {
      ...o,
      ref: Hd(o.ref, n),
      children: /* @__PURE__ */ lt(lV, { instance: h, children: f })
    }
  ) })
);
G6.displayName = "SliderChapters";
function lV({ instance: f, children: s }) {
  const n = Dn(() => f.cues, f), o = ue.useRef([]), h = ue.useRef(null), { $chapters: v } = ue.useContext(z0);
  return h.current || (h.current = j6()), ue.useEffect(() => (v.set(f), () => void v.set(null)), [f]), ue.useEffect(() => {
    f.setRefs(o.current);
  }, [n]), s(n.length ? n : [h.current], (y) => {
    if (!y) {
      o.current.length = 0;
      return;
    }
    o.current.push(y);
  });
}
lV.displayName = "SliderChapterTracks";
const W6 = ue.forwardRef(
  ({ children: f, ...s }, n) => {
    const { $chapters: o } = ue.useContext(z0), [h, v] = ue.useState();
    return ue.useEffect(() => J(() => {
      const y = o(), C = (y == null ? void 0 : y.activePointerCue) || (y == null ? void 0 : y.activeCue);
      v((C == null ? void 0 : C.text) || "");
    }), []), /* @__PURE__ */ hy(Ji.div, { ...s, ref: n, children: [
      h,
      f
    ] });
  }
);
W6.displayName = "SliderChapterTitle";
const K6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
K6.displayName = "SliderProgress";
const X6 = cs(i6), Z6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(X6, { ...s, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, ref: Hd(o.ref, n), children: f }) })
);
Z6.displayName = "SliderThumbnail";
const J6 = cs(a6, {
  events: ["onCanPlay", "onError"]
}), eQ = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(J6, { ...s, children: (o, h) => /* @__PURE__ */ lt(
    oV,
    {
      ...o,
      instance: h,
      ref: Hd(o.ref, n),
      children: f
    }
  ) })
);
eQ.displayName = "SliderVideo";
const oV = ue.forwardRef(
  ({ instance: f, children: s, ...n }, o) => {
    const { canLoad: h } = hw(xy), { src: v, video: y, crossOrigin: C } = f.$state, D = Dn(v), $ = Dn(h), _ = Dn(C);
    return /* @__PURE__ */ lt(
      Ji.video,
      {
        style: { maxWidth: "unset" },
        ...n,
        src: D || void 0,
        muted: !0,
        playsInline: !0,
        preload: $ ? "auto" : "none",
        crossOrigin: _ || void 0,
        ref: Hd(y.set, o),
        children: s
      }
    );
  }
);
oV.displayName = "SliderVideoProvider";
var SC = { exports: {} }, Da = {}, TC = { exports: {} }, CR = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uP;
function tQ() {
  return uP || (uP = 1, function(f) {
    function s(oe, Le) {
      var he = oe.length;
      oe.push(Le);
      e: for (; 0 < he; ) {
        var gt = he - 1 >>> 1, Nt = oe[gt];
        if (0 < h(Nt, Le)) oe[gt] = Le, oe[he] = Nt, he = gt;
        else break e;
      }
    }
    function n(oe) {
      return oe.length === 0 ? null : oe[0];
    }
    function o(oe) {
      if (oe.length === 0) return null;
      var Le = oe[0], he = oe.pop();
      if (he !== Le) {
        oe[0] = he;
        e: for (var gt = 0, Nt = oe.length, Ii = Nt >>> 1; gt < Ii; ) {
          var Bn = 2 * (gt + 1) - 1, oa = oe[Bn], ai = Bn + 1, si = oe[ai];
          if (0 > h(oa, he)) ai < Nt && 0 > h(si, oa) ? (oe[gt] = si, oe[ai] = he, gt = ai) : (oe[gt] = oa, oe[Bn] = he, gt = Bn);
          else if (ai < Nt && 0 > h(si, he)) oe[gt] = si, oe[ai] = he, gt = ai;
          else break e;
        }
      }
      return Le;
    }
    function h(oe, Le) {
      var he = oe.sortIndex - Le.sortIndex;
      return he !== 0 ? he : oe.id - Le.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var v = performance;
      f.unstable_now = function() {
        return v.now();
      };
    } else {
      var y = Date, C = y.now();
      f.unstable_now = function() {
        return y.now() - C;
      };
    }
    var D = [], $ = [], _ = 1, A = null, B = 3, W = !1, ne = !1, ce = !1, Re = typeof setTimeout == "function" ? setTimeout : null, Lt = typeof clearTimeout == "function" ? clearTimeout : null, $t = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function Ve(oe) {
      for (var Le = n($); Le !== null; ) {
        if (Le.callback === null) o($);
        else if (Le.startTime <= oe) o($), Le.sortIndex = Le.expirationTime, s(D, Le);
        else break;
        Le = n($);
      }
    }
    function ct(oe) {
      if (ce = !1, Ve(oe), !ne) if (n(D) !== null) ne = !0, Je(Ye);
      else {
        var Le = n($);
        Le !== null && ot(ct, Le.startTime - oe);
      }
    }
    function Ye(oe, Le) {
      ne = !1, ce && (ce = !1, Lt(de), de = -1), W = !0;
      var he = B;
      try {
        for (Ve(Le), A = n(D); A !== null && (!(A.expirationTime > Le) || oe && !Kt()); ) {
          var gt = A.callback;
          if (typeof gt == "function") {
            A.callback = null, B = A.priorityLevel;
            var Nt = gt(A.expirationTime <= Le);
            Le = f.unstable_now(), typeof Nt == "function" ? A.callback = Nt : A === n(D) && o(D), Ve(Le);
          } else o(D);
          A = n(D);
        }
        if (A !== null) var Ii = !0;
        else {
          var Bn = n($);
          Bn !== null && ot(ct, Bn.startTime - Le), Ii = !1;
        }
        return Ii;
      } finally {
        A = null, B = he, W = !1;
      }
    }
    var wt = !1, He = null, de = -1, Ge = 5, ft = -1;
    function Kt() {
      return !(f.unstable_now() - ft < Ge);
    }
    function Mt() {
      if (He !== null) {
        var oe = f.unstable_now();
        ft = oe;
        var Le = !0;
        try {
          Le = He(!0, oe);
        } finally {
          Le ? Ae() : (wt = !1, He = null);
        }
      } else wt = !1;
    }
    var Ae;
    if (typeof $t == "function") Ae = function() {
      $t(Mt);
    };
    else if (typeof MessageChannel < "u") {
      var Et = new MessageChannel(), Sn = Et.port2;
      Et.port1.onmessage = Mt, Ae = function() {
        Sn.postMessage(null);
      };
    } else Ae = function() {
      Re(Mt, 0);
    };
    function Je(oe) {
      He = oe, wt || (wt = !0, Ae());
    }
    function ot(oe, Le) {
      de = Re(function() {
        oe(f.unstable_now());
      }, Le);
    }
    f.unstable_IdlePriority = 5, f.unstable_ImmediatePriority = 1, f.unstable_LowPriority = 4, f.unstable_NormalPriority = 3, f.unstable_Profiling = null, f.unstable_UserBlockingPriority = 2, f.unstable_cancelCallback = function(oe) {
      oe.callback = null;
    }, f.unstable_continueExecution = function() {
      ne || W || (ne = !0, Je(Ye));
    }, f.unstable_forceFrameRate = function(oe) {
      0 > oe || 125 < oe ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Ge = 0 < oe ? Math.floor(1e3 / oe) : 5;
    }, f.unstable_getCurrentPriorityLevel = function() {
      return B;
    }, f.unstable_getFirstCallbackNode = function() {
      return n(D);
    }, f.unstable_next = function(oe) {
      switch (B) {
        case 1:
        case 2:
        case 3:
          var Le = 3;
          break;
        default:
          Le = B;
      }
      var he = B;
      B = Le;
      try {
        return oe();
      } finally {
        B = he;
      }
    }, f.unstable_pauseExecution = function() {
    }, f.unstable_requestPaint = function() {
    }, f.unstable_runWithPriority = function(oe, Le) {
      switch (oe) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          oe = 3;
      }
      var he = B;
      B = oe;
      try {
        return Le();
      } finally {
        B = he;
      }
    }, f.unstable_scheduleCallback = function(oe, Le, he) {
      var gt = f.unstable_now();
      switch (typeof he == "object" && he !== null ? (he = he.delay, he = typeof he == "number" && 0 < he ? gt + he : gt) : he = gt, oe) {
        case 1:
          var Nt = -1;
          break;
        case 2:
          Nt = 250;
          break;
        case 5:
          Nt = 1073741823;
          break;
        case 4:
          Nt = 1e4;
          break;
        default:
          Nt = 5e3;
      }
      return Nt = he + Nt, oe = { id: _++, callback: Le, priorityLevel: oe, startTime: he, expirationTime: Nt, sortIndex: -1 }, he > gt ? (oe.sortIndex = he, s($, oe), n(D) === null && oe === n($) && (ce ? (Lt(de), de = -1) : ce = !0, ot(ct, he - gt))) : (oe.sortIndex = Nt, s(D, oe), ne || W || (ne = !0, Je(Ye))), oe;
    }, f.unstable_shouldYield = Kt, f.unstable_wrapCallback = function(oe) {
      var Le = B;
      return function() {
        var he = B;
        B = Le;
        try {
          return oe.apply(this, arguments);
        } finally {
          B = he;
        }
      };
    };
  }(CR)), CR;
}
var kR = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cP;
function nQ() {
  return cP || (cP = 1, function(f) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var s = !1, n = 5;
      function o(pe, ze) {
        var pt = pe.length;
        pe.push(ze), y(pe, ze, pt);
      }
      function h(pe) {
        return pe.length === 0 ? null : pe[0];
      }
      function v(pe) {
        if (pe.length === 0)
          return null;
        var ze = pe[0], pt = pe.pop();
        return pt !== ze && (pe[0] = pt, C(pe, pt, 0)), ze;
      }
      function y(pe, ze, pt) {
        for (var an = pt; an > 0; ) {
          var Ln = an - 1 >>> 1, wr = pe[Ln];
          if (D(wr, ze) > 0)
            pe[Ln] = ze, pe[an] = wr, an = Ln;
          else
            return;
        }
      }
      function C(pe, ze, pt) {
        for (var an = pt, Ln = pe.length, wr = Ln >>> 1; an < wr; ) {
          var Qn = (an + 1) * 2 - 1, Er = pe[Qn], Yn = Qn + 1, $n = pe[Yn];
          if (D(Er, ze) < 0)
            Yn < Ln && D($n, Er) < 0 ? (pe[an] = $n, pe[Yn] = ze, an = Yn) : (pe[an] = Er, pe[Qn] = ze, an = Qn);
          else if (Yn < Ln && D($n, ze) < 0)
            pe[an] = $n, pe[Yn] = ze, an = Yn;
          else
            return;
        }
      }
      function D(pe, ze) {
        var pt = pe.sortIndex - ze.sortIndex;
        return pt !== 0 ? pt : pe.id - ze.id;
      }
      var $ = 1, _ = 2, A = 3, B = 4, W = 5;
      function ne(pe, ze) {
      }
      var ce = typeof performance == "object" && typeof performance.now == "function";
      if (ce) {
        var Re = performance;
        f.unstable_now = function() {
          return Re.now();
        };
      } else {
        var Lt = Date, $t = Lt.now();
        f.unstable_now = function() {
          return Lt.now() - $t;
        };
      }
      var Ve = 1073741823, ct = -1, Ye = 250, wt = 5e3, He = 1e4, de = Ve, Ge = [], ft = [], Kt = 1, Mt = null, Ae = A, Et = !1, Sn = !1, Je = !1, ot = typeof setTimeout == "function" ? setTimeout : null, oe = typeof clearTimeout == "function" ? clearTimeout : null, Le = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function he(pe) {
        for (var ze = h(ft); ze !== null; ) {
          if (ze.callback === null)
            v(ft);
          else if (ze.startTime <= pe)
            v(ft), ze.sortIndex = ze.expirationTime, o(Ge, ze);
          else
            return;
          ze = h(ft);
        }
      }
      function gt(pe) {
        if (Je = !1, he(pe), !Sn)
          if (h(Ge) !== null)
            Sn = !0, jr(Nt);
          else {
            var ze = h(ft);
            ze !== null && ds(gt, ze.startTime - pe);
          }
      }
      function Nt(pe, ze) {
        Sn = !1, Je && (Je = !1, $o()), Et = !0;
        var pt = Ae;
        try {
          var an;
          if (!s) return Ii(pe, ze);
        } finally {
          Mt = null, Ae = pt, Et = !1;
        }
      }
      function Ii(pe, ze) {
        var pt = ze;
        for (he(pt), Mt = h(Ge); Mt !== null && !(Mt.expirationTime > pt && (!pe || Id())); ) {
          var an = Mt.callback;
          if (typeof an == "function") {
            Mt.callback = null, Ae = Mt.priorityLevel;
            var Ln = Mt.expirationTime <= pt, wr = an(Ln);
            pt = f.unstable_now(), typeof wr == "function" ? Mt.callback = wr : Mt === h(Ge) && v(Ge), he(pt);
          } else
            v(Ge);
          Mt = h(Ge);
        }
        if (Mt !== null)
          return !0;
        var Qn = h(ft);
        return Qn !== null && ds(gt, Qn.startTime - pt), !1;
      }
      function Bn(pe, ze) {
        switch (pe) {
          case $:
          case _:
          case A:
          case B:
          case W:
            break;
          default:
            pe = A;
        }
        var pt = Ae;
        Ae = pe;
        try {
          return ze();
        } finally {
          Ae = pt;
        }
      }
      function oa(pe) {
        var ze;
        switch (Ae) {
          case $:
          case _:
          case A:
            ze = A;
            break;
          default:
            ze = Ae;
            break;
        }
        var pt = Ae;
        Ae = ze;
        try {
          return pe();
        } finally {
          Ae = pt;
        }
      }
      function ai(pe) {
        var ze = Ae;
        return function() {
          var pt = Ae;
          Ae = ze;
          try {
            return pe.apply(this, arguments);
          } finally {
            Ae = pt;
          }
        };
      }
      function si(pe, ze, pt) {
        var an = f.unstable_now(), Ln;
        if (typeof pt == "object" && pt !== null) {
          var wr = pt.delay;
          typeof wr == "number" && wr > 0 ? Ln = an + wr : Ln = an;
        } else
          Ln = an;
        var Qn;
        switch (pe) {
          case $:
            Qn = ct;
            break;
          case _:
            Qn = Ye;
            break;
          case W:
            Qn = de;
            break;
          case B:
            Qn = He;
            break;
          case A:
          default:
            Qn = wt;
            break;
        }
        var Er = Ln + Qn, Yn = {
          id: Kt++,
          callback: ze,
          priorityLevel: pe,
          startTime: Ln,
          expirationTime: Er,
          sortIndex: -1
        };
        return Ln > an ? (Yn.sortIndex = Ln, o(ft, Yn), h(Ge) === null && Yn === h(ft) && (Je ? $o() : Je = !0, ds(gt, Ln - an))) : (Yn.sortIndex = Er, o(Ge, Yn), !Sn && !Et && (Sn = !0, jr(Nt))), Yn;
      }
      function Ci() {
      }
      function li() {
        !Sn && !Et && (Sn = !0, jr(Nt));
      }
      function ki() {
        return h(Ge);
      }
      function Nn(pe) {
        pe.callback = null;
      }
      function er() {
        return Ae;
      }
      var gi = !1, xi = null, tr = -1, Ir = n, nc = -1;
      function Id() {
        var pe = f.unstable_now() - nc;
        return !(pe < Ir);
      }
      function qd() {
      }
      function Lo(pe) {
        if (pe < 0 || pe > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        pe > 0 ? Ir = Math.floor(1e3 / pe) : Ir = n;
      }
      var qr = function() {
        if (xi !== null) {
          var pe = f.unstable_now();
          nc = pe;
          var ze = !0, pt = !0;
          try {
            pt = xi(ze, pe);
          } finally {
            pt ? ua() : (gi = !1, xi = null);
          }
        } else
          gi = !1;
      }, ua;
      if (typeof Le == "function")
        ua = function() {
          Le(qr);
        };
      else if (typeof MessageChannel < "u") {
        var za = new MessageChannel(), ic = za.port2;
        za.port1.onmessage = qr, ua = function() {
          ic.postMessage(null);
        };
      } else
        ua = function() {
          ot(qr, 0);
        };
      function jr(pe) {
        xi = pe, gi || (gi = !0, ua());
      }
      function ds(pe, ze) {
        tr = ot(function() {
          pe(f.unstable_now());
        }, ze);
      }
      function $o() {
        oe(tr), tr = -1;
      }
      var Oo = qd, jd = null;
      f.unstable_IdlePriority = W, f.unstable_ImmediatePriority = $, f.unstable_LowPriority = B, f.unstable_NormalPriority = A, f.unstable_Profiling = jd, f.unstable_UserBlockingPriority = _, f.unstable_cancelCallback = Nn, f.unstable_continueExecution = li, f.unstable_forceFrameRate = Lo, f.unstable_getCurrentPriorityLevel = er, f.unstable_getFirstCallbackNode = ki, f.unstable_next = oa, f.unstable_pauseExecution = Ci, f.unstable_requestPaint = Oo, f.unstable_runWithPriority = Bn, f.unstable_scheduleCallback = si, f.unstable_shouldYield = Id, f.unstable_wrapCallback = ai, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(kR)), kR;
}
var dP;
function uV() {
  return dP || (dP = 1, process.env.NODE_ENV === "production" ? TC.exports = tQ() : TC.exports = nQ()), TC.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fP;
function iQ() {
  if (fP) return Da;
  fP = 1;
  var f = DP, s = uV();
  function n(i) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, u = 1; u < arguments.length; u++) r += "&args[]=" + encodeURIComponent(arguments[u]);
    return "Minified React error #" + i + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var o = /* @__PURE__ */ new Set(), h = {};
  function v(i, r) {
    y(i, r), y(i + "Capture", r);
  }
  function y(i, r) {
    for (h[i] = r, i = 0; i < r.length; i++) o.add(r[i]);
  }
  var C = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), D = Object.prototype.hasOwnProperty, $ = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, _ = {}, A = {};
  function B(i) {
    return D.call(A, i) ? !0 : D.call(_, i) ? !1 : $.test(i) ? A[i] = !0 : (_[i] = !0, !1);
  }
  function W(i, r, u, p) {
    if (u !== null && u.type === 0) return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return p ? !1 : u !== null ? !u.acceptsBooleans : (i = i.toLowerCase().slice(0, 5), i !== "data-" && i !== "aria-");
      default:
        return !1;
    }
  }
  function ne(i, r, u, p) {
    if (r === null || typeof r > "u" || W(i, r, u, p)) return !0;
    if (p) return !1;
    if (u !== null) switch (u.type) {
      case 3:
        return !r;
      case 4:
        return r === !1;
      case 5:
        return isNaN(r);
      case 6:
        return isNaN(r) || 1 > r;
    }
    return !1;
  }
  function ce(i, r, u, p, g, w, k) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = p, this.attributeNamespace = g, this.mustUseProperty = u, this.propertyName = i, this.type = r, this.sanitizeURL = w, this.removeEmptyString = k;
  }
  var Re = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    Re[i] = new ce(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var r = i[0];
    Re[r] = new ce(r, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    Re[i] = new ce(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    Re[i] = new ce(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    Re[i] = new ce(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    Re[i] = new ce(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    Re[i] = new ce(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    Re[i] = new ce(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    Re[i] = new ce(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var Lt = /[\-:]([a-z])/g;
  function $t(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var r = i.replace(
      Lt,
      $t
    );
    Re[r] = new ce(r, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var r = i.replace(Lt, $t);
    Re[r] = new ce(r, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var r = i.replace(Lt, $t);
    Re[r] = new ce(r, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    Re[i] = new ce(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), Re.xlinkHref = new ce("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    Re[i] = new ce(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  function Ve(i, r, u, p) {
    var g = Re.hasOwnProperty(r) ? Re[r] : null;
    (g !== null ? g.type !== 0 : p || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (ne(r, u, g, p) && (u = null), p || g === null ? B(r) && (u === null ? i.removeAttribute(r) : i.setAttribute(r, "" + u)) : g.mustUseProperty ? i[g.propertyName] = u === null ? g.type === 3 ? !1 : "" : u : (r = g.attributeName, p = g.attributeNamespace, u === null ? i.removeAttribute(r) : (g = g.type, u = g === 3 || g === 4 && u === !0 ? "" : "" + u, p ? i.setAttributeNS(p, r, u) : i.setAttribute(r, u))));
  }
  var ct = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Ye = Symbol.for("react.element"), wt = Symbol.for("react.portal"), He = Symbol.for("react.fragment"), de = Symbol.for("react.strict_mode"), Ge = Symbol.for("react.profiler"), ft = Symbol.for("react.provider"), Kt = Symbol.for("react.context"), Mt = Symbol.for("react.forward_ref"), Ae = Symbol.for("react.suspense"), Et = Symbol.for("react.suspense_list"), Sn = Symbol.for("react.memo"), Je = Symbol.for("react.lazy"), ot = Symbol.for("react.offscreen"), oe = Symbol.iterator;
  function Le(i) {
    return i === null || typeof i != "object" ? null : (i = oe && i[oe] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var he = Object.assign, gt;
  function Nt(i) {
    if (gt === void 0) try {
      throw Error();
    } catch (u) {
      var r = u.stack.trim().match(/\n( *(at )?)/);
      gt = r && r[1] || "";
    }
    return `
` + gt + i;
  }
  var Ii = !1;
  function Bn(i, r) {
    if (!i || Ii) return "";
    Ii = !0;
    var u = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) if (r = function() {
        throw Error();
      }, Object.defineProperty(r.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(r, []);
        } catch (j) {
          var p = j;
        }
        Reflect.construct(i, [], r);
      } else {
        try {
          r.call();
        } catch (j) {
          p = j;
        }
        i.call(r.prototype);
      }
      else {
        try {
          throw Error();
        } catch (j) {
          p = j;
        }
        i();
      }
    } catch (j) {
      if (j && p && typeof j.stack == "string") {
        for (var g = j.stack.split(`
`), w = p.stack.split(`
`), k = g.length - 1, O = w.length - 1; 1 <= k && 0 <= O && g[k] !== w[O]; ) O--;
        for (; 1 <= k && 0 <= O; k--, O--) if (g[k] !== w[O]) {
          if (k !== 1 || O !== 1)
            do
              if (k--, O--, 0 > O || g[k] !== w[O]) {
                var P = `
` + g[k].replace(" at new ", " at ");
                return i.displayName && P.includes("<anonymous>") && (P = P.replace("<anonymous>", i.displayName)), P;
              }
            while (1 <= k && 0 <= O);
          break;
        }
      }
    } finally {
      Ii = !1, Error.prepareStackTrace = u;
    }
    return (i = i ? i.displayName || i.name : "") ? Nt(i) : "";
  }
  function oa(i) {
    switch (i.tag) {
      case 5:
        return Nt(i.type);
      case 16:
        return Nt("Lazy");
      case 13:
        return Nt("Suspense");
      case 19:
        return Nt("SuspenseList");
      case 0:
      case 2:
      case 15:
        return i = Bn(i.type, !1), i;
      case 11:
        return i = Bn(i.type.render, !1), i;
      case 1:
        return i = Bn(i.type, !0), i;
      default:
        return "";
    }
  }
  function ai(i) {
    if (i == null) return null;
    if (typeof i == "function") return i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case He:
        return "Fragment";
      case wt:
        return "Portal";
      case Ge:
        return "Profiler";
      case de:
        return "StrictMode";
      case Ae:
        return "Suspense";
      case Et:
        return "SuspenseList";
    }
    if (typeof i == "object") switch (i.$$typeof) {
      case Kt:
        return (i.displayName || "Context") + ".Consumer";
      case ft:
        return (i._context.displayName || "Context") + ".Provider";
      case Mt:
        var r = i.render;
        return i = i.displayName, i || (i = r.displayName || r.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
      case Sn:
        return r = i.displayName || null, r !== null ? r : ai(i.type) || "Memo";
      case Je:
        r = i._payload, i = i._init;
        try {
          return ai(i(r));
        } catch {
        }
    }
    return null;
  }
  function si(i) {
    var r = i.type;
    switch (i.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return i = r.render, i = i.displayName || i.name || "", r.displayName || (i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return ai(r);
      case 8:
        return r === de ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function") return r.displayName || r.name || null;
        if (typeof r == "string") return r;
    }
    return null;
  }
  function Ci(i) {
    switch (typeof i) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return i;
      case "object":
        return i;
      default:
        return "";
    }
  }
  function li(i) {
    var r = i.type;
    return (i = i.nodeName) && i.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function ki(i) {
    var r = li(i) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(i.constructor.prototype, r), p = "" + i[r];
    if (!i.hasOwnProperty(r) && typeof u < "u" && typeof u.get == "function" && typeof u.set == "function") {
      var g = u.get, w = u.set;
      return Object.defineProperty(i, r, { configurable: !0, get: function() {
        return g.call(this);
      }, set: function(k) {
        p = "" + k, w.call(this, k);
      } }), Object.defineProperty(i, r, { enumerable: u.enumerable }), { getValue: function() {
        return p;
      }, setValue: function(k) {
        p = "" + k;
      }, stopTracking: function() {
        i._valueTracker = null, delete i[r];
      } };
    }
  }
  function Nn(i) {
    i._valueTracker || (i._valueTracker = ki(i));
  }
  function er(i) {
    if (!i) return !1;
    var r = i._valueTracker;
    if (!r) return !0;
    var u = r.getValue(), p = "";
    return i && (p = li(i) ? i.checked ? "true" : "false" : i.value), i = p, i !== u ? (r.setValue(i), !0) : !1;
  }
  function gi(i) {
    if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u") return null;
    try {
      return i.activeElement || i.body;
    } catch {
      return i.body;
    }
  }
  function xi(i, r) {
    var u = r.checked;
    return he({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: u ?? i._wrapperState.initialChecked });
  }
  function tr(i, r) {
    var u = r.defaultValue == null ? "" : r.defaultValue, p = r.checked != null ? r.checked : r.defaultChecked;
    u = Ci(r.value != null ? r.value : u), i._wrapperState = { initialChecked: p, initialValue: u, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function Ir(i, r) {
    r = r.checked, r != null && Ve(i, "checked", r, !1);
  }
  function nc(i, r) {
    Ir(i, r);
    var u = Ci(r.value), p = r.type;
    if (u != null) p === "number" ? (u === 0 && i.value === "" || i.value != u) && (i.value = "" + u) : i.value !== "" + u && (i.value = "" + u);
    else if (p === "submit" || p === "reset") {
      i.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? qd(i, r.type, u) : r.hasOwnProperty("defaultValue") && qd(i, r.type, Ci(r.defaultValue)), r.checked == null && r.defaultChecked != null && (i.defaultChecked = !!r.defaultChecked);
  }
  function Id(i, r, u) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var p = r.type;
      if (!(p !== "submit" && p !== "reset" || r.value !== void 0 && r.value !== null)) return;
      r = "" + i._wrapperState.initialValue, u || r === i.value || (i.value = r), i.defaultValue = r;
    }
    u = i.name, u !== "" && (i.name = ""), i.defaultChecked = !!i._wrapperState.initialChecked, u !== "" && (i.name = u);
  }
  function qd(i, r, u) {
    (r !== "number" || gi(i.ownerDocument) !== i) && (u == null ? i.defaultValue = "" + i._wrapperState.initialValue : i.defaultValue !== "" + u && (i.defaultValue = "" + u));
  }
  var Lo = Array.isArray;
  function qr(i, r, u, p) {
    if (i = i.options, r) {
      r = {};
      for (var g = 0; g < u.length; g++) r["$" + u[g]] = !0;
      for (u = 0; u < i.length; u++) g = r.hasOwnProperty("$" + i[u].value), i[u].selected !== g && (i[u].selected = g), g && p && (i[u].defaultSelected = !0);
    } else {
      for (u = "" + Ci(u), r = null, g = 0; g < i.length; g++) {
        if (i[g].value === u) {
          i[g].selected = !0, p && (i[g].defaultSelected = !0);
          return;
        }
        r !== null || i[g].disabled || (r = i[g]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function ua(i, r) {
    if (r.dangerouslySetInnerHTML != null) throw Error(n(91));
    return he({}, r, { value: void 0, defaultValue: void 0, children: "" + i._wrapperState.initialValue });
  }
  function za(i, r) {
    var u = r.value;
    if (u == null) {
      if (u = r.children, r = r.defaultValue, u != null) {
        if (r != null) throw Error(n(92));
        if (Lo(u)) {
          if (1 < u.length) throw Error(n(93));
          u = u[0];
        }
        r = u;
      }
      r == null && (r = ""), u = r;
    }
    i._wrapperState = { initialValue: Ci(u) };
  }
  function ic(i, r) {
    var u = Ci(r.value), p = Ci(r.defaultValue);
    u != null && (u = "" + u, u !== i.value && (i.value = u), r.defaultValue == null && i.defaultValue !== u && (i.defaultValue = u)), p != null && (i.defaultValue = "" + p);
  }
  function jr(i) {
    var r = i.textContent;
    r === i._wrapperState.initialValue && r !== "" && r !== null && (i.value = r);
  }
  function ds(i) {
    switch (i) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function $o(i, r) {
    return i == null || i === "http://www.w3.org/1999/xhtml" ? ds(r) : i === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : i;
  }
  var Oo, jd = function(i) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, p, g) {
      MSApp.execUnsafeLocalFunction(function() {
        return i(r, u, p, g);
      });
    } : i;
  }(function(i, r) {
    if (i.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in i) i.innerHTML = r;
    else {
      for (Oo = Oo || document.createElement("div"), Oo.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Oo.firstChild; i.firstChild; ) i.removeChild(i.firstChild);
      for (; r.firstChild; ) i.appendChild(r.firstChild);
    }
  });
  function pe(i, r) {
    if (r) {
      var u = i.firstChild;
      if (u && u === i.lastChild && u.nodeType === 3) {
        u.nodeValue = r;
        return;
      }
    }
    i.textContent = r;
  }
  var ze = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, pt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ze).forEach(function(i) {
    pt.forEach(function(r) {
      r = r + i.charAt(0).toUpperCase() + i.substring(1), ze[r] = ze[i];
    });
  });
  function an(i, r, u) {
    return r == null || typeof r == "boolean" || r === "" ? "" : u || typeof r != "number" || r === 0 || ze.hasOwnProperty(i) && ze[i] ? ("" + r).trim() : r + "px";
  }
  function Ln(i, r) {
    i = i.style;
    for (var u in r) if (r.hasOwnProperty(u)) {
      var p = u.indexOf("--") === 0, g = an(u, r[u], p);
      u === "float" && (u = "cssFloat"), p ? i.setProperty(u, g) : i[u] = g;
    }
  }
  var wr = he({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Qn(i, r) {
    if (r) {
      if (wr[i] && (r.children != null || r.dangerouslySetInnerHTML != null)) throw Error(n(137, i));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null) throw Error(n(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML)) throw Error(n(61));
      }
      if (r.style != null && typeof r.style != "object") throw Error(n(62));
    }
  }
  function Er(i, r) {
    if (i.indexOf("-") === -1) return typeof r.is == "string";
    switch (i) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Yn = null;
  function $n(i) {
    return i = i.target || i.srcElement || window, i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === 3 ? i.parentNode : i;
  }
  var oi = null, rc = null, kl = null;
  function op(i) {
    if (i = Pe(i)) {
      if (typeof oi != "function") throw Error(n(280));
      var r = i.stateNode;
      r && (r = Un(r), oi(i.stateNode, i.type, r));
    }
  }
  function pw(i) {
    rc ? kl ? kl.push(i) : kl = [i] : rc = i;
  }
  function mw() {
    if (rc) {
      var i = rc, r = kl;
      if (kl = rc = null, op(i), r) for (i = 0; i < r.length; i++) op(r[i]);
    }
  }
  function My(i, r) {
    return i(r);
  }
  function Ly() {
  }
  var $y = !1;
  function Oy(i, r, u) {
    if ($y) return i(r, u);
    $y = !0;
    try {
      return My(i, r, u);
    } finally {
      $y = !1, (rc !== null || kl !== null) && (Ly(), mw());
    }
  }
  function Ao(i, r) {
    var u = i.stateNode;
    if (u === null) return null;
    var p = Un(u);
    if (p === null) return null;
    u = p[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (p = !p.disabled) || (i = i.type, p = !(i === "button" || i === "input" || i === "select" || i === "textarea")), i = !p;
        break e;
      default:
        i = !1;
    }
    if (i) return null;
    if (u && typeof u != "function") throw Error(n(231, r, typeof u));
    return u;
  }
  var xl = !1;
  if (C) try {
    var Fa = {};
    Object.defineProperty(Fa, "passive", { get: function() {
      xl = !0;
    } }), window.addEventListener("test", Fa, Fa), window.removeEventListener("test", Fa, Fa);
  } catch {
    xl = !1;
  }
  function ac(i, r, u, p, g, w, k, O, P) {
    var j = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(u, j);
    } catch (ie) {
      this.onError(ie);
    }
  }
  var Po = !1, sc = null, lc = !1, Bd = null, oc = { onError: function(i) {
    Po = !0, sc = i;
  } };
  function up(i, r, u, p, g, w, k, O, P) {
    Po = !1, sc = null, ac.apply(oc, arguments);
  }
  function cp(i, r, u, p, g, w, k, O, P) {
    if (up.apply(this, arguments), Po) {
      if (Po) {
        var j = sc;
        Po = !1, sc = null;
      } else throw Error(n(198));
      lc || (lc = !0, Bd = j);
    }
  }
  function Va(i) {
    var r = i, u = i;
    if (i.alternate) for (; r.return; ) r = r.return;
    else {
      i = r;
      do
        r = i, r.flags & 4098 && (u = r.return), i = r.return;
      while (i);
    }
    return r.tag === 3 ? u : null;
  }
  function qi(i) {
    if (i.tag === 13) {
      var r = i.memoizedState;
      if (r === null && (i = i.alternate, i !== null && (r = i.memoizedState)), r !== null) return r.dehydrated;
    }
    return null;
  }
  function vw(i) {
    if (Va(i) !== i) throw Error(n(188));
  }
  function F0(i) {
    var r = i.alternate;
    if (!r) {
      if (r = Va(i), r === null) throw Error(n(188));
      return r !== i ? null : i;
    }
    for (var u = i, p = r; ; ) {
      var g = u.return;
      if (g === null) break;
      var w = g.alternate;
      if (w === null) {
        if (p = g.return, p !== null) {
          u = p;
          continue;
        }
        break;
      }
      if (g.child === w.child) {
        for (w = g.child; w; ) {
          if (w === u) return vw(g), i;
          if (w === p) return vw(g), r;
          w = w.sibling;
        }
        throw Error(n(188));
      }
      if (u.return !== p.return) u = g, p = w;
      else {
        for (var k = !1, O = g.child; O; ) {
          if (O === u) {
            k = !0, u = g, p = w;
            break;
          }
          if (O === p) {
            k = !0, p = g, u = w;
            break;
          }
          O = O.sibling;
        }
        if (!k) {
          for (O = w.child; O; ) {
            if (O === u) {
              k = !0, u = w, p = g;
              break;
            }
            if (O === p) {
              k = !0, p = w, u = g;
              break;
            }
            O = O.sibling;
          }
          if (!k) throw Error(n(189));
        }
      }
      if (u.alternate !== p) throw Error(n(190));
    }
    if (u.tag !== 3) throw Error(n(188));
    return u.stateNode.current === u ? i : r;
  }
  function Ay(i) {
    return i = F0(i), i !== null ? yw(i) : null;
  }
  function yw(i) {
    if (i.tag === 5 || i.tag === 6) return i;
    for (i = i.child; i !== null; ) {
      var r = yw(i);
      if (r !== null) return r;
      i = i.sibling;
    }
    return null;
  }
  var gw = s.unstable_scheduleCallback, Sw = s.unstable_cancelCallback, Tw = s.unstable_shouldYield, V0 = s.unstable_requestPaint, sn = s.unstable_now, St = s.unstable_getCurrentPriorityLevel, _o = s.unstable_ImmediatePriority, Py = s.unstable_UserBlockingPriority, Qd = s.unstable_NormalPriority, ww = s.unstable_LowPriority, _y = s.unstable_IdlePriority, Yd = null, Ha = null;
  function Ew(i) {
    if (Ha && typeof Ha.onCommitFiberRoot == "function") try {
      Ha.onCommitFiberRoot(Yd, i, void 0, (i.current.flags & 128) === 128);
    } catch {
    }
  }
  var ca = Math.clz32 ? Math.clz32 : Ny, H0 = Math.log, I0 = Math.LN2;
  function Ny(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (H0(i) / I0 | 0) | 0;
  }
  var uc = 64, Ia = 4194304;
  function No(i) {
    switch (i & -i) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return i & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return i;
    }
  }
  function Uo(i, r) {
    var u = i.pendingLanes;
    if (u === 0) return 0;
    var p = 0, g = i.suspendedLanes, w = i.pingedLanes, k = u & 268435455;
    if (k !== 0) {
      var O = k & ~g;
      O !== 0 ? p = No(O) : (w &= k, w !== 0 && (p = No(w)));
    } else k = u & ~g, k !== 0 ? p = No(k) : w !== 0 && (p = No(w));
    if (p === 0) return 0;
    if (r !== 0 && r !== p && !(r & g) && (g = p & -p, w = r & -r, g >= w || g === 16 && (w & 4194240) !== 0)) return r;
    if (p & 4 && (p |= u & 16), r = i.entangledLanes, r !== 0) for (i = i.entanglements, r &= p; 0 < r; ) u = 31 - ca(r), g = 1 << u, p |= i[u], r &= ~g;
    return p;
  }
  function q0(i, r) {
    switch (i) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Uy(i, r) {
    for (var u = i.suspendedLanes, p = i.pingedLanes, g = i.expirationTimes, w = i.pendingLanes; 0 < w; ) {
      var k = 31 - ca(w), O = 1 << k, P = g[k];
      P === -1 ? (!(O & u) || O & p) && (g[k] = q0(O, r)) : P <= r && (i.expiredLanes |= O), w &= ~O;
    }
  }
  function zy(i) {
    return i = i.pendingLanes & -1073741825, i !== 0 ? i : i & 1073741824 ? 1073741824 : 0;
  }
  function dp() {
    var i = uc;
    return uc <<= 1, !(uc & 4194240) && (uc = 64), i;
  }
  function Fy(i) {
    for (var r = [], u = 0; 31 > u; u++) r.push(i);
    return r;
  }
  function zo(i, r, u) {
    i.pendingLanes |= r, r !== 536870912 && (i.suspendedLanes = 0, i.pingedLanes = 0), i = i.eventTimes, r = 31 - ca(r), i[r] = u;
  }
  function j0(i, r) {
    var u = i.pendingLanes & ~r;
    i.pendingLanes = r, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= r, i.mutableReadLanes &= r, i.entangledLanes &= r, r = i.entanglements;
    var p = i.eventTimes;
    for (i = i.expirationTimes; 0 < u; ) {
      var g = 31 - ca(u), w = 1 << g;
      r[g] = 0, p[g] = -1, i[g] = -1, u &= ~w;
    }
  }
  function fp(i, r) {
    var u = i.entangledLanes |= r;
    for (i = i.entanglements; u; ) {
      var p = 31 - ca(u), g = 1 << p;
      g & r | i[p] & r && (i[p] |= r), u &= ~g;
    }
  }
  var Xt = 0;
  function Vy(i) {
    return i &= -i, 1 < i ? 4 < i ? i & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Zt, Hy, Iy, nt, qy, nr = !1, Rl = [], da = null, Dl = null, On = null, pn = /* @__PURE__ */ new Map(), Gd = /* @__PURE__ */ new Map(), Ri = [], fa = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Is(i, r) {
    switch (i) {
      case "focusin":
      case "focusout":
        da = null;
        break;
      case "dragenter":
      case "dragleave":
        Dl = null;
        break;
      case "mouseover":
      case "mouseout":
        On = null;
        break;
      case "pointerover":
      case "pointerout":
        pn.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Gd.delete(r.pointerId);
    }
  }
  function Wd(i, r, u, p, g, w) {
    return i === null || i.nativeEvent !== w ? (i = { blockedOn: r, domEventName: u, eventSystemFlags: p, nativeEvent: w, targetContainers: [g] }, r !== null && (r = Pe(r), r !== null && Hy(r)), i) : (i.eventSystemFlags |= p, r = i.targetContainers, g !== null && r.indexOf(g) === -1 && r.push(g), i);
  }
  function jy(i, r, u, p, g) {
    switch (r) {
      case "focusin":
        return da = Wd(da, i, r, u, p, g), !0;
      case "dragenter":
        return Dl = Wd(Dl, i, r, u, p, g), !0;
      case "mouseover":
        return On = Wd(On, i, r, u, p, g), !0;
      case "pointerover":
        var w = g.pointerId;
        return pn.set(w, Wd(pn.get(w) || null, i, r, u, p, g)), !0;
      case "gotpointercapture":
        return w = g.pointerId, Gd.set(w, Wd(Gd.get(w) || null, i, r, u, p, g)), !0;
    }
    return !1;
  }
  function By(i) {
    var r = Go(i.target);
    if (r !== null) {
      var u = Va(r);
      if (u !== null) {
        if (r = u.tag, r === 13) {
          if (r = qi(u), r !== null) {
            i.blockedOn = r, qy(i.priority, function() {
              Iy(u);
            });
            return;
          }
        } else if (r === 3 && u.stateNode.current.memoizedState.isDehydrated) {
          i.blockedOn = u.tag === 3 ? u.stateNode.containerInfo : null;
          return;
        }
      }
    }
    i.blockedOn = null;
  }
  function Kd(i) {
    if (i.blockedOn !== null) return !1;
    for (var r = i.targetContainers; 0 < r.length; ) {
      var u = pp(i.domEventName, i.eventSystemFlags, r[0], i.nativeEvent);
      if (u === null) {
        u = i.nativeEvent;
        var p = new u.constructor(u.type, u);
        Yn = p, u.target.dispatchEvent(p), Yn = null;
      } else return r = Pe(u), r !== null && Hy(r), i.blockedOn = u, !1;
      r.shift();
    }
    return !0;
  }
  function bw(i, r, u) {
    Kd(i) && u.delete(r);
  }
  function B0() {
    nr = !1, da !== null && Kd(da) && (da = null), Dl !== null && Kd(Dl) && (Dl = null), On !== null && Kd(On) && (On = null), pn.forEach(bw), Gd.forEach(bw);
  }
  function Xd(i, r) {
    i.blockedOn === r && (i.blockedOn = null, nr || (nr = !0, s.unstable_scheduleCallback(s.unstable_NormalPriority, B0)));
  }
  function Ml(i) {
    function r(g) {
      return Xd(g, i);
    }
    if (0 < Rl.length) {
      Xd(Rl[0], i);
      for (var u = 1; u < Rl.length; u++) {
        var p = Rl[u];
        p.blockedOn === i && (p.blockedOn = null);
      }
    }
    for (da !== null && Xd(da, i), Dl !== null && Xd(Dl, i), On !== null && Xd(On, i), pn.forEach(r), Gd.forEach(r), u = 0; u < Ri.length; u++) p = Ri[u], p.blockedOn === i && (p.blockedOn = null);
    for (; 0 < Ri.length && (u = Ri[0], u.blockedOn === null); ) By(u), u.blockedOn === null && Ri.shift();
  }
  var Fo = ct.ReactCurrentBatchConfig, Vo = !0;
  function Cw(i, r, u, p) {
    var g = Xt, w = Fo.transition;
    Fo.transition = null;
    try {
      Xt = 1, hp(i, r, u, p);
    } finally {
      Xt = g, Fo.transition = w;
    }
  }
  function kw(i, r, u, p) {
    var g = Xt, w = Fo.transition;
    Fo.transition = null;
    try {
      Xt = 4, hp(i, r, u, p);
    } finally {
      Xt = g, Fo.transition = w;
    }
  }
  function hp(i, r, u, p) {
    if (Vo) {
      var g = pp(i, r, u, p);
      if (g === null) Op(i, r, p, Zd, u), Is(i, p);
      else if (jy(g, i, r, u, p)) p.stopPropagation();
      else if (Is(i, p), r & 4 && -1 < fa.indexOf(i)) {
        for (; g !== null; ) {
          var w = Pe(g);
          if (w !== null && Zt(w), w = pp(i, r, u, p), w === null && Op(i, r, p, Zd, u), w === g) break;
          g = w;
        }
        g !== null && p.stopPropagation();
      } else Op(i, r, p, null, u);
    }
  }
  var Zd = null;
  function pp(i, r, u, p) {
    if (Zd = null, i = $n(p), i = Go(i), i !== null) if (r = Va(i), r === null) i = null;
    else if (u = r.tag, u === 13) {
      if (i = qi(r), i !== null) return i;
      i = null;
    } else if (u === 3) {
      if (r.stateNode.current.memoizedState.isDehydrated) return r.tag === 3 ? r.stateNode.containerInfo : null;
      i = null;
    } else r !== i && (i = null);
    return Zd = i, null;
  }
  function mp(i) {
    switch (i) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (St()) {
          case _o:
            return 1;
          case Py:
            return 4;
          case Qd:
          case ww:
            return 16;
          case _y:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var qs = null, vp = null, cc = null;
  function Qy() {
    if (cc) return cc;
    var i, r = vp, u = r.length, p, g = "value" in qs ? qs.value : qs.textContent, w = g.length;
    for (i = 0; i < u && r[i] === g[i]; i++) ;
    var k = u - i;
    for (p = 1; p <= k && r[u - p] === g[w - p]; p++) ;
    return cc = g.slice(i, 1 < p ? 1 - p : void 0);
  }
  function yp(i) {
    var r = i.keyCode;
    return "charCode" in i ? (i = i.charCode, i === 0 && r === 13 && (i = 13)) : i = r, i === 10 && (i = 13), 32 <= i || i === 13 ? i : 0;
  }
  function gp() {
    return !0;
  }
  function Sp() {
    return !1;
  }
  function br(i) {
    function r(u, p, g, w, k) {
      this._reactName = u, this._targetInst = g, this.type = p, this.nativeEvent = w, this.target = k, this.currentTarget = null;
      for (var O in i) i.hasOwnProperty(O) && (u = i[O], this[O] = u ? u(w) : w[O]);
      return this.isDefaultPrevented = (w.defaultPrevented != null ? w.defaultPrevented : w.returnValue === !1) ? gp : Sp, this.isPropagationStopped = Sp, this;
    }
    return he(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var u = this.nativeEvent;
      u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = gp);
    }, stopPropagation: function() {
      var u = this.nativeEvent;
      u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = gp);
    }, persist: function() {
    }, isPersistent: gp }), r;
  }
  var Ho = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(i) {
    return i.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Tp = br(Ho), dc = he({}, Ho, { view: 0, detail: 0 }), Q0 = br(dc), Yy, Di, Io, Jd = he({}, dc, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Zy, button: 0, buttons: 0, relatedTarget: function(i) {
    return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
  }, movementX: function(i) {
    return "movementX" in i ? i.movementX : (i !== Io && (Io && i.type === "mousemove" ? (Yy = i.screenX - Io.screenX, Di = i.screenY - Io.screenY) : Di = Yy = 0, Io = i), Yy);
  }, movementY: function(i) {
    return "movementY" in i ? i.movementY : Di;
  } }), Gy = br(Jd), Y0 = he({}, Jd, { dataTransfer: 0 }), fc = br(Y0), Wy = he({}, dc, { relatedTarget: 0 }), wp = br(Wy), G0 = he({}, Ho, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), W0 = br(G0), K0 = he({}, Ho, { clipboardData: function(i) {
    return "clipboardData" in i ? i.clipboardData : window.clipboardData;
  } }), xw = br(K0), Ky = he({}, Ho, { data: 0 }), Xy = br(Ky), Rw = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Dw = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, X0 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function js(i) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(i) : (i = X0[i]) ? !!r[i] : !1;
  }
  function Zy() {
    return js;
  }
  var Jy = he({}, dc, { key: function(i) {
    if (i.key) {
      var r = Rw[i.key] || i.key;
      if (r !== "Unidentified") return r;
    }
    return i.type === "keypress" ? (i = yp(i), i === 13 ? "Enter" : String.fromCharCode(i)) : i.type === "keydown" || i.type === "keyup" ? Dw[i.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Zy, charCode: function(i) {
    return i.type === "keypress" ? yp(i) : 0;
  }, keyCode: function(i) {
    return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  }, which: function(i) {
    return i.type === "keypress" ? yp(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  } }), eg = br(Jy), tg = he({}, Jd, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Mw = br(tg), Ep = he({}, dc, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Zy }), Lw = br(Ep), Cr = he({}, Ho, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Bs = br(Cr), Gn = he({}, Jd, {
    deltaX: function(i) {
      return "deltaX" in i ? i.deltaX : "wheelDeltaX" in i ? -i.wheelDeltaX : 0;
    },
    deltaY: function(i) {
      return "deltaY" in i ? i.deltaY : "wheelDeltaY" in i ? -i.wheelDeltaY : "wheelDelta" in i ? -i.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Qs = br(Gn), ng = [9, 13, 27, 32], hc = C && "CompositionEvent" in window, ef = null;
  C && "documentMode" in document && (ef = document.documentMode);
  var tf = C && "TextEvent" in window && !ef, $w = C && (!hc || ef && 8 < ef && 11 >= ef), Ow = " ", bp = !1;
  function Aw(i, r) {
    switch (i) {
      case "keyup":
        return ng.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Pw(i) {
    return i = i.detail, typeof i == "object" && "data" in i ? i.data : null;
  }
  var pc = !1;
  function _w(i, r) {
    switch (i) {
      case "compositionend":
        return Pw(r);
      case "keypress":
        return r.which !== 32 ? null : (bp = !0, Ow);
      case "textInput":
        return i = r.data, i === Ow && bp ? null : i;
      default:
        return null;
    }
  }
  function Z0(i, r) {
    if (pc) return i === "compositionend" || !hc && Aw(i, r) ? (i = Qy(), cc = vp = qs = null, pc = !1, i) : null;
    switch (i) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length) return r.char;
          if (r.which) return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return $w && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var J0 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Nw(i) {
    var r = i && i.nodeName && i.nodeName.toLowerCase();
    return r === "input" ? !!J0[i.type] : r === "textarea";
  }
  function ig(i, r, u, p) {
    pw(p), r = of(r, "onChange"), 0 < r.length && (u = new Tp("onChange", "change", null, u, p), i.push({ event: u, listeners: r }));
  }
  var fs = null, qo = null;
  function Uw(i) {
    Qo(i, 0);
  }
  function nf(i) {
    var r = ja(i);
    if (er(r)) return i;
  }
  function ek(i, r) {
    if (i === "change") return r;
  }
  var zw = !1;
  if (C) {
    var rg;
    if (C) {
      var ag = "oninput" in document;
      if (!ag) {
        var Fw = document.createElement("div");
        Fw.setAttribute("oninput", "return;"), ag = typeof Fw.oninput == "function";
      }
      rg = ag;
    } else rg = !1;
    zw = rg && (!document.documentMode || 9 < document.documentMode);
  }
  function Vw() {
    fs && (fs.detachEvent("onpropertychange", Hw), qo = fs = null);
  }
  function Hw(i) {
    if (i.propertyName === "value" && nf(qo)) {
      var r = [];
      ig(r, qo, i, $n(i)), Oy(Uw, r);
    }
  }
  function tk(i, r, u) {
    i === "focusin" ? (Vw(), fs = r, qo = u, fs.attachEvent("onpropertychange", Hw)) : i === "focusout" && Vw();
  }
  function Iw(i) {
    if (i === "selectionchange" || i === "keyup" || i === "keydown") return nf(qo);
  }
  function nk(i, r) {
    if (i === "click") return nf(r);
  }
  function qw(i, r) {
    if (i === "input" || i === "change") return nf(r);
  }
  function ik(i, r) {
    return i === r && (i !== 0 || 1 / i === 1 / r) || i !== i && r !== r;
  }
  var qa = typeof Object.is == "function" ? Object.is : ik;
  function rf(i, r) {
    if (qa(i, r)) return !0;
    if (typeof i != "object" || i === null || typeof r != "object" || r === null) return !1;
    var u = Object.keys(i), p = Object.keys(r);
    if (u.length !== p.length) return !1;
    for (p = 0; p < u.length; p++) {
      var g = u[p];
      if (!D.call(r, g) || !qa(i[g], r[g])) return !1;
    }
    return !0;
  }
  function jw(i) {
    for (; i && i.firstChild; ) i = i.firstChild;
    return i;
  }
  function Cp(i, r) {
    var u = jw(i);
    i = 0;
    for (var p; u; ) {
      if (u.nodeType === 3) {
        if (p = i + u.textContent.length, i <= r && p >= r) return { node: u, offset: r - i };
        i = p;
      }
      e: {
        for (; u; ) {
          if (u.nextSibling) {
            u = u.nextSibling;
            break e;
          }
          u = u.parentNode;
        }
        u = void 0;
      }
      u = jw(u);
    }
  }
  function Ll(i, r) {
    return i && r ? i === r ? !0 : i && i.nodeType === 3 ? !1 : r && r.nodeType === 3 ? Ll(i, r.parentNode) : "contains" in i ? i.contains(r) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function af() {
    for (var i = window, r = gi(); r instanceof i.HTMLIFrameElement; ) {
      try {
        var u = typeof r.contentWindow.location.href == "string";
      } catch {
        u = !1;
      }
      if (u) i = r.contentWindow;
      else break;
      r = gi(i.document);
    }
    return r;
  }
  function kp(i) {
    var r = i && i.nodeName && i.nodeName.toLowerCase();
    return r && (r === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || r === "textarea" || i.contentEditable === "true");
  }
  function mc(i) {
    var r = af(), u = i.focusedElem, p = i.selectionRange;
    if (r !== u && u && u.ownerDocument && Ll(u.ownerDocument.documentElement, u)) {
      if (p !== null && kp(u)) {
        if (r = p.start, i = p.end, i === void 0 && (i = r), "selectionStart" in u) u.selectionStart = r, u.selectionEnd = Math.min(i, u.value.length);
        else if (i = (r = u.ownerDocument || document) && r.defaultView || window, i.getSelection) {
          i = i.getSelection();
          var g = u.textContent.length, w = Math.min(p.start, g);
          p = p.end === void 0 ? w : Math.min(p.end, g), !i.extend && w > p && (g = p, p = w, w = g), g = Cp(u, w);
          var k = Cp(
            u,
            p
          );
          g && k && (i.rangeCount !== 1 || i.anchorNode !== g.node || i.anchorOffset !== g.offset || i.focusNode !== k.node || i.focusOffset !== k.offset) && (r = r.createRange(), r.setStart(g.node, g.offset), i.removeAllRanges(), w > p ? (i.addRange(r), i.extend(k.node, k.offset)) : (r.setEnd(k.node, k.offset), i.addRange(r)));
        }
      }
      for (r = [], i = u; i = i.parentNode; ) i.nodeType === 1 && r.push({ element: i, left: i.scrollLeft, top: i.scrollTop });
      for (typeof u.focus == "function" && u.focus(), u = 0; u < r.length; u++) i = r[u], i.element.scrollLeft = i.left, i.element.scrollTop = i.top;
    }
  }
  var rk = C && "documentMode" in document && 11 >= document.documentMode, vc = null, sg = null, sf = null, lg = !1;
  function og(i, r, u) {
    var p = u.window === u ? u.document : u.nodeType === 9 ? u : u.ownerDocument;
    lg || vc == null || vc !== gi(p) || (p = vc, "selectionStart" in p && kp(p) ? p = { start: p.selectionStart, end: p.selectionEnd } : (p = (p.ownerDocument && p.ownerDocument.defaultView || window).getSelection(), p = { anchorNode: p.anchorNode, anchorOffset: p.anchorOffset, focusNode: p.focusNode, focusOffset: p.focusOffset }), sf && rf(sf, p) || (sf = p, p = of(sg, "onSelect"), 0 < p.length && (r = new Tp("onSelect", "select", null, r, u), i.push({ event: r, listeners: p }), r.target = vc)));
  }
  function xp(i, r) {
    var u = {};
    return u[i.toLowerCase()] = r.toLowerCase(), u["Webkit" + i] = "webkit" + r, u["Moz" + i] = "moz" + r, u;
  }
  var jo = { animationend: xp("Animation", "AnimationEnd"), animationiteration: xp("Animation", "AnimationIteration"), animationstart: xp("Animation", "AnimationStart"), transitionend: xp("Transition", "TransitionEnd") }, Mi = {}, ug = {};
  C && (ug = document.createElement("div").style, "AnimationEvent" in window || (delete jo.animationend.animation, delete jo.animationiteration.animation, delete jo.animationstart.animation), "TransitionEvent" in window || delete jo.transitionend.transition);
  function Rp(i) {
    if (Mi[i]) return Mi[i];
    if (!jo[i]) return i;
    var r = jo[i], u;
    for (u in r) if (r.hasOwnProperty(u) && u in ug) return Mi[i] = r[u];
    return i;
  }
  var Bw = Rp("animationend"), Qw = Rp("animationiteration"), Yw = Rp("animationstart"), Gw = Rp("transitionend"), cg = /* @__PURE__ */ new Map(), Dp = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ha(i, r) {
    cg.set(i, r), v(r, [i]);
  }
  for (var dg = 0; dg < Dp.length; dg++) {
    var Bo = Dp[dg], ak = Bo.toLowerCase(), sk = Bo[0].toUpperCase() + Bo.slice(1);
    ha(ak, "on" + sk);
  }
  ha(Bw, "onAnimationEnd"), ha(Qw, "onAnimationIteration"), ha(Yw, "onAnimationStart"), ha("dblclick", "onDoubleClick"), ha("focusin", "onFocus"), ha("focusout", "onBlur"), ha(Gw, "onTransitionEnd"), y("onMouseEnter", ["mouseout", "mouseover"]), y("onMouseLeave", ["mouseout", "mouseover"]), y("onPointerEnter", ["pointerout", "pointerover"]), y("onPointerLeave", ["pointerout", "pointerover"]), v("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), v("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), v("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), v("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), fg = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
  function Mp(i, r, u) {
    var p = i.type || "unknown-event";
    i.currentTarget = u, cp(p, r, void 0, i), i.currentTarget = null;
  }
  function Qo(i, r) {
    r = (r & 4) !== 0;
    for (var u = 0; u < i.length; u++) {
      var p = i[u], g = p.event;
      p = p.listeners;
      e: {
        var w = void 0;
        if (r) for (var k = p.length - 1; 0 <= k; k--) {
          var O = p[k], P = O.instance, j = O.currentTarget;
          if (O = O.listener, P !== w && g.isPropagationStopped()) break e;
          Mp(g, O, j), w = P;
        }
        else for (k = 0; k < p.length; k++) {
          if (O = p[k], P = O.instance, j = O.currentTarget, O = O.listener, P !== w && g.isPropagationStopped()) break e;
          Mp(g, O, j), w = P;
        }
      }
    }
    if (lc) throw i = Bd, lc = !1, Bd = null, i;
  }
  function Yt(i, r) {
    var u = r[df];
    u === void 0 && (u = r[df] = /* @__PURE__ */ new Set());
    var p = i + "__bubble";
    u.has(p) || (Ww(r, i, 2, !1), u.add(p));
  }
  function Lp(i, r, u) {
    var p = 0;
    r && (p |= 4), Ww(u, i, p, r);
  }
  var $p = "_reactListening" + Math.random().toString(36).slice(2);
  function yc(i) {
    if (!i[$p]) {
      i[$p] = !0, o.forEach(function(u) {
        u !== "selectionchange" && (fg.has(u) || Lp(u, !1, i), Lp(u, !0, i));
      });
      var r = i.nodeType === 9 ? i : i.ownerDocument;
      r === null || r[$p] || (r[$p] = !0, Lp("selectionchange", !1, r));
    }
  }
  function Ww(i, r, u, p) {
    switch (mp(r)) {
      case 1:
        var g = Cw;
        break;
      case 4:
        g = kw;
        break;
      default:
        g = hp;
    }
    u = g.bind(null, r, u, i), g = void 0, !xl || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (g = !0), p ? g !== void 0 ? i.addEventListener(r, u, { capture: !0, passive: g }) : i.addEventListener(r, u, !0) : g !== void 0 ? i.addEventListener(r, u, { passive: g }) : i.addEventListener(r, u, !1);
  }
  function Op(i, r, u, p, g) {
    var w = p;
    if (!(r & 1) && !(r & 2) && p !== null) e: for (; ; ) {
      if (p === null) return;
      var k = p.tag;
      if (k === 3 || k === 4) {
        var O = p.stateNode.containerInfo;
        if (O === g || O.nodeType === 8 && O.parentNode === g) break;
        if (k === 4) for (k = p.return; k !== null; ) {
          var P = k.tag;
          if ((P === 3 || P === 4) && (P = k.stateNode.containerInfo, P === g || P.nodeType === 8 && P.parentNode === g)) return;
          k = k.return;
        }
        for (; O !== null; ) {
          if (k = Go(O), k === null) return;
          if (P = k.tag, P === 5 || P === 6) {
            p = w = k;
            continue e;
          }
          O = O.parentNode;
        }
      }
      p = p.return;
    }
    Oy(function() {
      var j = w, ie = $n(u), re = [];
      e: {
        var te = cg.get(i);
        if (te !== void 0) {
          var Te = Tp, ke = i;
          switch (i) {
            case "keypress":
              if (yp(u) === 0) break e;
            case "keydown":
            case "keyup":
              Te = eg;
              break;
            case "focusin":
              ke = "focus", Te = wp;
              break;
            case "focusout":
              ke = "blur", Te = wp;
              break;
            case "beforeblur":
            case "afterblur":
              Te = wp;
              break;
            case "click":
              if (u.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Te = Gy;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Te = fc;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Te = Lw;
              break;
            case Bw:
            case Qw:
            case Yw:
              Te = W0;
              break;
            case Gw:
              Te = Bs;
              break;
            case "scroll":
              Te = Q0;
              break;
            case "wheel":
              Te = Qs;
              break;
            case "copy":
            case "cut":
            case "paste":
              Te = xw;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Te = Mw;
          }
          var De = (r & 4) !== 0, In = !De && i === "scroll", F = De ? te !== null ? te + "Capture" : null : te;
          De = [];
          for (var U = j, I; U !== null; ) {
            I = U;
            var le = I.stateNode;
            if (I.tag === 5 && le !== null && (I = le, F !== null && (le = Ao(U, F), le != null && De.push(gc(U, le, I)))), In) break;
            U = U.return;
          }
          0 < De.length && (te = new Te(te, ke, null, u, ie), re.push({ event: te, listeners: De }));
        }
      }
      if (!(r & 7)) {
        e: {
          if (te = i === "mouseover" || i === "pointerover", Te = i === "mouseout" || i === "pointerout", te && u !== Yn && (ke = u.relatedTarget || u.fromElement) && (Go(ke) || ke[Ys])) break e;
          if ((Te || te) && (te = ie.window === ie ? ie : (te = ie.ownerDocument) ? te.defaultView || te.parentWindow : window, Te ? (ke = u.relatedTarget || u.toElement, Te = j, ke = ke ? Go(ke) : null, ke !== null && (In = Va(ke), ke !== In || ke.tag !== 5 && ke.tag !== 6) && (ke = null)) : (Te = null, ke = j), Te !== ke)) {
            if (De = Gy, le = "onMouseLeave", F = "onMouseEnter", U = "mouse", (i === "pointerout" || i === "pointerover") && (De = Mw, le = "onPointerLeave", F = "onPointerEnter", U = "pointer"), In = Te == null ? te : ja(Te), I = ke == null ? te : ja(ke), te = new De(le, U + "leave", Te, u, ie), te.target = In, te.relatedTarget = I, le = null, Go(ie) === j && (De = new De(F, U + "enter", ke, u, ie), De.target = I, De.relatedTarget = In, le = De), In = le, Te && ke) t: {
              for (De = Te, F = ke, U = 0, I = De; I; I = $l(I)) U++;
              for (I = 0, le = F; le; le = $l(le)) I++;
              for (; 0 < U - I; ) De = $l(De), U--;
              for (; 0 < I - U; ) F = $l(F), I--;
              for (; U--; ) {
                if (De === F || F !== null && De === F.alternate) break t;
                De = $l(De), F = $l(F);
              }
              De = null;
            }
            else De = null;
            Te !== null && Kw(re, te, Te, De, !1), ke !== null && In !== null && Kw(re, In, ke, De, !0);
          }
        }
        e: {
          if (te = j ? ja(j) : window, Te = te.nodeName && te.nodeName.toLowerCase(), Te === "select" || Te === "input" && te.type === "file") var ge = ek;
          else if (Nw(te)) if (zw) ge = qw;
          else {
            ge = Iw;
            var Ne = tk;
          }
          else (Te = te.nodeName) && Te.toLowerCase() === "input" && (te.type === "checkbox" || te.type === "radio") && (ge = nk);
          if (ge && (ge = ge(i, j))) {
            ig(re, ge, u, ie);
            break e;
          }
          Ne && Ne(i, te, j), i === "focusout" && (Ne = te._wrapperState) && Ne.controlled && te.type === "number" && qd(te, "number", te.value);
        }
        switch (Ne = j ? ja(j) : window, i) {
          case "focusin":
            (Nw(Ne) || Ne.contentEditable === "true") && (vc = Ne, sg = j, sf = null);
            break;
          case "focusout":
            sf = sg = vc = null;
            break;
          case "mousedown":
            lg = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            lg = !1, og(re, u, ie);
            break;
          case "selectionchange":
            if (rk) break;
          case "keydown":
          case "keyup":
            og(re, u, ie);
        }
        var Fe;
        if (hc) e: {
          switch (i) {
            case "compositionstart":
              var We = "onCompositionStart";
              break e;
            case "compositionend":
              We = "onCompositionEnd";
              break e;
            case "compositionupdate":
              We = "onCompositionUpdate";
              break e;
          }
          We = void 0;
        }
        else pc ? Aw(i, u) && (We = "onCompositionEnd") : i === "keydown" && u.keyCode === 229 && (We = "onCompositionStart");
        We && ($w && u.locale !== "ko" && (pc || We !== "onCompositionStart" ? We === "onCompositionEnd" && pc && (Fe = Qy()) : (qs = ie, vp = "value" in qs ? qs.value : qs.textContent, pc = !0)), Ne = of(j, We), 0 < Ne.length && (We = new Xy(We, i, null, u, ie), re.push({ event: We, listeners: Ne }), Fe ? We.data = Fe : (Fe = Pw(u), Fe !== null && (We.data = Fe)))), (Fe = tf ? _w(i, u) : Z0(i, u)) && (j = of(j, "onBeforeInput"), 0 < j.length && (ie = new Xy("onBeforeInput", "beforeinput", null, u, ie), re.push({ event: ie, listeners: j }), ie.data = Fe));
      }
      Qo(re, r);
    });
  }
  function gc(i, r, u) {
    return { instance: i, listener: r, currentTarget: u };
  }
  function of(i, r) {
    for (var u = r + "Capture", p = []; i !== null; ) {
      var g = i, w = g.stateNode;
      g.tag === 5 && w !== null && (g = w, w = Ao(i, u), w != null && p.unshift(gc(i, w, g)), w = Ao(i, r), w != null && p.push(gc(i, w, g))), i = i.return;
    }
    return p;
  }
  function $l(i) {
    if (i === null) return null;
    do
      i = i.return;
    while (i && i.tag !== 5);
    return i || null;
  }
  function Kw(i, r, u, p, g) {
    for (var w = r._reactName, k = []; u !== null && u !== p; ) {
      var O = u, P = O.alternate, j = O.stateNode;
      if (P !== null && P === p) break;
      O.tag === 5 && j !== null && (O = j, g ? (P = Ao(u, w), P != null && k.unshift(gc(u, P, O))) : g || (P = Ao(u, w), P != null && k.push(gc(u, P, O)))), u = u.return;
    }
    k.length !== 0 && i.push({ event: r, listeners: k });
  }
  var Xw = /\r\n?/g, lk = /\u0000|\uFFFD/g;
  function Zw(i) {
    return (typeof i == "string" ? i : "" + i).replace(Xw, `
`).replace(lk, "");
  }
  function Ap(i, r, u) {
    if (r = Zw(r), Zw(i) !== r && u) throw Error(n(425));
  }
  function Ol() {
  }
  var uf = null, Yo = null;
  function Pp(i, r) {
    return i === "textarea" || i === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var _p = typeof setTimeout == "function" ? setTimeout : void 0, hg = typeof clearTimeout == "function" ? clearTimeout : void 0, Jw = typeof Promise == "function" ? Promise : void 0, Sc = typeof queueMicrotask == "function" ? queueMicrotask : typeof Jw < "u" ? function(i) {
    return Jw.resolve(null).then(i).catch(Np);
  } : _p;
  function Np(i) {
    setTimeout(function() {
      throw i;
    });
  }
  function Tc(i, r) {
    var u = r, p = 0;
    do {
      var g = u.nextSibling;
      if (i.removeChild(u), g && g.nodeType === 8) if (u = g.data, u === "/$") {
        if (p === 0) {
          i.removeChild(g), Ml(r);
          return;
        }
        p--;
      } else u !== "$" && u !== "$?" && u !== "$!" || p++;
      u = g;
    } while (u);
    Ml(r);
  }
  function hs(i) {
    for (; i != null; i = i.nextSibling) {
      var r = i.nodeType;
      if (r === 1 || r === 3) break;
      if (r === 8) {
        if (r = i.data, r === "$" || r === "$!" || r === "$?") break;
        if (r === "/$") return null;
      }
    }
    return i;
  }
  function eE(i) {
    i = i.previousSibling;
    for (var r = 0; i; ) {
      if (i.nodeType === 8) {
        var u = i.data;
        if (u === "$" || u === "$!" || u === "$?") {
          if (r === 0) return i;
          r--;
        } else u === "/$" && r++;
      }
      i = i.previousSibling;
    }
    return null;
  }
  var Al = Math.random().toString(36).slice(2), ps = "__reactFiber$" + Al, cf = "__reactProps$" + Al, Ys = "__reactContainer$" + Al, df = "__reactEvents$" + Al, wc = "__reactListeners$" + Al, ok = "__reactHandles$" + Al;
  function Go(i) {
    var r = i[ps];
    if (r) return r;
    for (var u = i.parentNode; u; ) {
      if (r = u[Ys] || u[ps]) {
        if (u = r.alternate, r.child !== null || u !== null && u.child !== null) for (i = eE(i); i !== null; ) {
          if (u = i[ps]) return u;
          i = eE(i);
        }
        return r;
      }
      i = u, u = i.parentNode;
    }
    return null;
  }
  function Pe(i) {
    return i = i[ps] || i[Ys], !i || i.tag !== 5 && i.tag !== 6 && i.tag !== 13 && i.tag !== 3 ? null : i;
  }
  function ja(i) {
    if (i.tag === 5 || i.tag === 6) return i.stateNode;
    throw Error(n(33));
  }
  function Un(i) {
    return i[cf] || null;
  }
  var bt = [], pa = -1;
  function Ba(i) {
    return { current: i };
  }
  function un(i) {
    0 > pa || (i.current = bt[pa], bt[pa] = null, pa--);
  }
  function Oe(i, r) {
    pa++, bt[pa] = i.current, i.current = r;
  }
  var kr = {}, An = Ba(kr), ui = Ba(!1), xr = kr;
  function ma(i, r) {
    var u = i.type.contextTypes;
    if (!u) return kr;
    var p = i.stateNode;
    if (p && p.__reactInternalMemoizedUnmaskedChildContext === r) return p.__reactInternalMemoizedMaskedChildContext;
    var g = {}, w;
    for (w in u) g[w] = r[w];
    return p && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = r, i.__reactInternalMemoizedMaskedChildContext = g), g;
  }
  function Wn(i) {
    return i = i.childContextTypes, i != null;
  }
  function Ec() {
    un(ui), un(An);
  }
  function tE(i, r, u) {
    if (An.current !== kr) throw Error(n(168));
    Oe(An, r), Oe(ui, u);
  }
  function ff(i, r, u) {
    var p = i.stateNode;
    if (r = r.childContextTypes, typeof p.getChildContext != "function") return u;
    p = p.getChildContext();
    for (var g in p) if (!(g in r)) throw Error(n(108, si(i) || "Unknown", g));
    return he({}, u, p);
  }
  function Rr(i) {
    return i = (i = i.stateNode) && i.__reactInternalMemoizedMergedChildContext || kr, xr = An.current, Oe(An, i), Oe(ui, ui.current), !0;
  }
  function Up(i, r, u) {
    var p = i.stateNode;
    if (!p) throw Error(n(169));
    u ? (i = ff(i, r, xr), p.__reactInternalMemoizedMergedChildContext = i, un(ui), un(An), Oe(An, i)) : un(ui), Oe(ui, u);
  }
  var ms = null, bc = !1, Gs = !1;
  function zp(i) {
    ms === null ? ms = [i] : ms.push(i);
  }
  function Pl(i) {
    bc = !0, zp(i);
  }
  function vs() {
    if (!Gs && ms !== null) {
      Gs = !0;
      var i = 0, r = Xt;
      try {
        var u = ms;
        for (Xt = 1; i < u.length; i++) {
          var p = u[i];
          do
            p = p(!0);
          while (p !== null);
        }
        ms = null, bc = !1;
      } catch (g) {
        throw ms !== null && (ms = ms.slice(i + 1)), gw(_o, vs), g;
      } finally {
        Xt = r, Gs = !1;
      }
    }
    return null;
  }
  var _l = [], Nl = 0, Ul = null, Ws = 0, Kn = [], va = 0, Br = null, ys = 1, gs = "";
  function Wo(i, r) {
    _l[Nl++] = Ws, _l[Nl++] = Ul, Ul = i, Ws = r;
  }
  function nE(i, r, u) {
    Kn[va++] = ys, Kn[va++] = gs, Kn[va++] = Br, Br = i;
    var p = ys;
    i = gs;
    var g = 32 - ca(p) - 1;
    p &= ~(1 << g), u += 1;
    var w = 32 - ca(r) + g;
    if (30 < w) {
      var k = g - g % 5;
      w = (p & (1 << k) - 1).toString(32), p >>= k, g -= k, ys = 1 << 32 - ca(r) + g | u << g | p, gs = w + i;
    } else ys = 1 << w | u << g | p, gs = i;
  }
  function Fp(i) {
    i.return !== null && (Wo(i, 1), nE(i, 1, 0));
  }
  function Vp(i) {
    for (; i === Ul; ) Ul = _l[--Nl], _l[Nl] = null, Ws = _l[--Nl], _l[Nl] = null;
    for (; i === Br; ) Br = Kn[--va], Kn[va] = null, gs = Kn[--va], Kn[va] = null, ys = Kn[--va], Kn[va] = null;
  }
  var Dr = null, Mr = null, Tn = !1, ya = null;
  function pg(i, r) {
    var u = Ea(5, null, null, 0);
    u.elementType = "DELETED", u.stateNode = r, u.return = i, r = i.deletions, r === null ? (i.deletions = [u], i.flags |= 16) : r.push(u);
  }
  function iE(i, r) {
    switch (i.tag) {
      case 5:
        var u = i.type;
        return r = r.nodeType !== 1 || u.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (i.stateNode = r, Dr = i, Mr = hs(r.firstChild), !0) : !1;
      case 6:
        return r = i.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (i.stateNode = r, Dr = i, Mr = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (u = Br !== null ? { id: ys, overflow: gs } : null, i.memoizedState = { dehydrated: r, treeContext: u, retryLane: 1073741824 }, u = Ea(18, null, null, 0), u.stateNode = r, u.return = i, i.child = u, Dr = i, Mr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function mg(i) {
    return (i.mode & 1) !== 0 && (i.flags & 128) === 0;
  }
  function vg(i) {
    if (Tn) {
      var r = Mr;
      if (r) {
        var u = r;
        if (!iE(i, r)) {
          if (mg(i)) throw Error(n(418));
          r = hs(u.nextSibling);
          var p = Dr;
          r && iE(i, r) ? pg(p, u) : (i.flags = i.flags & -4097 | 2, Tn = !1, Dr = i);
        }
      } else {
        if (mg(i)) throw Error(n(418));
        i.flags = i.flags & -4097 | 2, Tn = !1, Dr = i;
      }
    }
  }
  function ci(i) {
    for (i = i.return; i !== null && i.tag !== 5 && i.tag !== 3 && i.tag !== 13; ) i = i.return;
    Dr = i;
  }
  function Hp(i) {
    if (i !== Dr) return !1;
    if (!Tn) return ci(i), Tn = !0, !1;
    var r;
    if ((r = i.tag !== 3) && !(r = i.tag !== 5) && (r = i.type, r = r !== "head" && r !== "body" && !Pp(i.type, i.memoizedProps)), r && (r = Mr)) {
      if (mg(i)) throw hf(), Error(n(418));
      for (; r; ) pg(i, r), r = hs(r.nextSibling);
    }
    if (ci(i), i.tag === 13) {
      if (i = i.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(n(317));
      e: {
        for (i = i.nextSibling, r = 0; i; ) {
          if (i.nodeType === 8) {
            var u = i.data;
            if (u === "/$") {
              if (r === 0) {
                Mr = hs(i.nextSibling);
                break e;
              }
              r--;
            } else u !== "$" && u !== "$!" && u !== "$?" || r++;
          }
          i = i.nextSibling;
        }
        Mr = null;
      }
    } else Mr = Dr ? hs(i.stateNode.nextSibling) : null;
    return !0;
  }
  function hf() {
    for (var i = Mr; i; ) i = hs(i.nextSibling);
  }
  function zl() {
    Mr = Dr = null, Tn = !1;
  }
  function Ks(i) {
    ya === null ? ya = [i] : ya.push(i);
  }
  var uk = ct.ReactCurrentBatchConfig;
  function Ko(i, r, u) {
    if (i = u.ref, i !== null && typeof i != "function" && typeof i != "object") {
      if (u._owner) {
        if (u = u._owner, u) {
          if (u.tag !== 1) throw Error(n(309));
          var p = u.stateNode;
        }
        if (!p) throw Error(n(147, i));
        var g = p, w = "" + i;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === w ? r.ref : (r = function(k) {
          var O = g.refs;
          k === null ? delete O[w] : O[w] = k;
        }, r._stringRef = w, r);
      }
      if (typeof i != "string") throw Error(n(284));
      if (!u._owner) throw Error(n(290, i));
    }
    return i;
  }
  function Ip(i, r) {
    throw i = Object.prototype.toString.call(r), Error(n(31, i === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : i));
  }
  function rE(i) {
    var r = i._init;
    return r(i._payload);
  }
  function Xo(i) {
    function r(F, U) {
      if (i) {
        var I = F.deletions;
        I === null ? (F.deletions = [U], F.flags |= 16) : I.push(U);
      }
    }
    function u(F, U) {
      if (!i) return null;
      for (; U !== null; ) r(F, U), U = U.sibling;
      return null;
    }
    function p(F, U) {
      for (F = /* @__PURE__ */ new Map(); U !== null; ) U.key !== null ? F.set(U.key, U) : F.set(U.index, U), U = U.sibling;
      return F;
    }
    function g(F, U) {
      return F = Ql(F, U), F.index = 0, F.sibling = null, F;
    }
    function w(F, U, I) {
      return F.index = I, i ? (I = F.alternate, I !== null ? (I = I.index, I < U ? (F.flags |= 2, U) : I) : (F.flags |= 2, U)) : (F.flags |= 1048576, U);
    }
    function k(F) {
      return i && F.alternate === null && (F.flags |= 2), F;
    }
    function O(F, U, I, le) {
      return U === null || U.tag !== 6 ? (U = Yg(I, F.mode, le), U.return = F, U) : (U = g(U, I), U.return = F, U);
    }
    function P(F, U, I, le) {
      var ge = I.type;
      return ge === He ? ie(F, U, I.props.children, le, I.key) : U !== null && (U.elementType === ge || typeof ge == "object" && ge !== null && ge.$$typeof === Je && rE(ge) === U.type) ? (le = g(U, I.props), le.ref = Ko(F, U, I), le.return = F, le) : (le = qf(I.type, I.key, I.props, null, F.mode, le), le.ref = Ko(F, U, I), le.return = F, le);
    }
    function j(F, U, I, le) {
      return U === null || U.tag !== 4 || U.stateNode.containerInfo !== I.containerInfo || U.stateNode.implementation !== I.implementation ? (U = wm(I, F.mode, le), U.return = F, U) : (U = g(U, I.children || []), U.return = F, U);
    }
    function ie(F, U, I, le, ge) {
      return U === null || U.tag !== 7 ? (U = nl(I, F.mode, le, ge), U.return = F, U) : (U = g(U, I), U.return = F, U);
    }
    function re(F, U, I) {
      if (typeof U == "string" && U !== "" || typeof U == "number") return U = Yg("" + U, F.mode, I), U.return = F, U;
      if (typeof U == "object" && U !== null) {
        switch (U.$$typeof) {
          case Ye:
            return I = qf(U.type, U.key, U.props, null, F.mode, I), I.ref = Ko(F, null, U), I.return = F, I;
          case wt:
            return U = wm(U, F.mode, I), U.return = F, U;
          case Je:
            var le = U._init;
            return re(F, le(U._payload), I);
        }
        if (Lo(U) || Le(U)) return U = nl(U, F.mode, I, null), U.return = F, U;
        Ip(F, U);
      }
      return null;
    }
    function te(F, U, I, le) {
      var ge = U !== null ? U.key : null;
      if (typeof I == "string" && I !== "" || typeof I == "number") return ge !== null ? null : O(F, U, "" + I, le);
      if (typeof I == "object" && I !== null) {
        switch (I.$$typeof) {
          case Ye:
            return I.key === ge ? P(F, U, I, le) : null;
          case wt:
            return I.key === ge ? j(F, U, I, le) : null;
          case Je:
            return ge = I._init, te(
              F,
              U,
              ge(I._payload),
              le
            );
        }
        if (Lo(I) || Le(I)) return ge !== null ? null : ie(F, U, I, le, null);
        Ip(F, I);
      }
      return null;
    }
    function Te(F, U, I, le, ge) {
      if (typeof le == "string" && le !== "" || typeof le == "number") return F = F.get(I) || null, O(U, F, "" + le, ge);
      if (typeof le == "object" && le !== null) {
        switch (le.$$typeof) {
          case Ye:
            return F = F.get(le.key === null ? I : le.key) || null, P(U, F, le, ge);
          case wt:
            return F = F.get(le.key === null ? I : le.key) || null, j(U, F, le, ge);
          case Je:
            var Ne = le._init;
            return Te(F, U, I, Ne(le._payload), ge);
        }
        if (Lo(le) || Le(le)) return F = F.get(I) || null, ie(U, F, le, ge, null);
        Ip(U, le);
      }
      return null;
    }
    function ke(F, U, I, le) {
      for (var ge = null, Ne = null, Fe = U, We = U = 0, fi = null; Fe !== null && We < I.length; We++) {
        Fe.index > We ? (fi = Fe, Fe = null) : fi = Fe.sibling;
        var Ft = te(F, Fe, I[We], le);
        if (Ft === null) {
          Fe === null && (Fe = fi);
          break;
        }
        i && Fe && Ft.alternate === null && r(F, Fe), U = w(Ft, U, We), Ne === null ? ge = Ft : Ne.sibling = Ft, Ne = Ft, Fe = fi;
      }
      if (We === I.length) return u(F, Fe), Tn && Wo(F, We), ge;
      if (Fe === null) {
        for (; We < I.length; We++) Fe = re(F, I[We], le), Fe !== null && (U = w(Fe, U, We), Ne === null ? ge = Fe : Ne.sibling = Fe, Ne = Fe);
        return Tn && Wo(F, We), ge;
      }
      for (Fe = p(F, Fe); We < I.length; We++) fi = Te(Fe, F, We, I[We], le), fi !== null && (i && fi.alternate !== null && Fe.delete(fi.key === null ? We : fi.key), U = w(fi, U, We), Ne === null ? ge = fi : Ne.sibling = fi, Ne = fi);
      return i && Fe.forEach(function(Wl) {
        return r(F, Wl);
      }), Tn && Wo(F, We), ge;
    }
    function De(F, U, I, le) {
      var ge = Le(I);
      if (typeof ge != "function") throw Error(n(150));
      if (I = ge.call(I), I == null) throw Error(n(151));
      for (var Ne = ge = null, Fe = U, We = U = 0, fi = null, Ft = I.next(); Fe !== null && !Ft.done; We++, Ft = I.next()) {
        Fe.index > We ? (fi = Fe, Fe = null) : fi = Fe.sibling;
        var Wl = te(F, Fe, Ft.value, le);
        if (Wl === null) {
          Fe === null && (Fe = fi);
          break;
        }
        i && Fe && Wl.alternate === null && r(F, Fe), U = w(Wl, U, We), Ne === null ? ge = Wl : Ne.sibling = Wl, Ne = Wl, Fe = fi;
      }
      if (Ft.done) return u(
        F,
        Fe
      ), Tn && Wo(F, We), ge;
      if (Fe === null) {
        for (; !Ft.done; We++, Ft = I.next()) Ft = re(F, Ft.value, le), Ft !== null && (U = w(Ft, U, We), Ne === null ? ge = Ft : Ne.sibling = Ft, Ne = Ft);
        return Tn && Wo(F, We), ge;
      }
      for (Fe = p(F, Fe); !Ft.done; We++, Ft = I.next()) Ft = Te(Fe, F, We, Ft.value, le), Ft !== null && (i && Ft.alternate !== null && Fe.delete(Ft.key === null ? We : Ft.key), U = w(Ft, U, We), Ne === null ? ge = Ft : Ne.sibling = Ft, Ne = Ft);
      return i && Fe.forEach(function(bk) {
        return r(F, bk);
      }), Tn && Wo(F, We), ge;
    }
    function In(F, U, I, le) {
      if (typeof I == "object" && I !== null && I.type === He && I.key === null && (I = I.props.children), typeof I == "object" && I !== null) {
        switch (I.$$typeof) {
          case Ye:
            e: {
              for (var ge = I.key, Ne = U; Ne !== null; ) {
                if (Ne.key === ge) {
                  if (ge = I.type, ge === He) {
                    if (Ne.tag === 7) {
                      u(F, Ne.sibling), U = g(Ne, I.props.children), U.return = F, F = U;
                      break e;
                    }
                  } else if (Ne.elementType === ge || typeof ge == "object" && ge !== null && ge.$$typeof === Je && rE(ge) === Ne.type) {
                    u(F, Ne.sibling), U = g(Ne, I.props), U.ref = Ko(F, Ne, I), U.return = F, F = U;
                    break e;
                  }
                  u(F, Ne);
                  break;
                } else r(F, Ne);
                Ne = Ne.sibling;
              }
              I.type === He ? (U = nl(I.props.children, F.mode, le, I.key), U.return = F, F = U) : (le = qf(I.type, I.key, I.props, null, F.mode, le), le.ref = Ko(F, U, I), le.return = F, F = le);
            }
            return k(F);
          case wt:
            e: {
              for (Ne = I.key; U !== null; ) {
                if (U.key === Ne) if (U.tag === 4 && U.stateNode.containerInfo === I.containerInfo && U.stateNode.implementation === I.implementation) {
                  u(F, U.sibling), U = g(U, I.children || []), U.return = F, F = U;
                  break e;
                } else {
                  u(F, U);
                  break;
                }
                else r(F, U);
                U = U.sibling;
              }
              U = wm(I, F.mode, le), U.return = F, F = U;
            }
            return k(F);
          case Je:
            return Ne = I._init, In(F, U, Ne(I._payload), le);
        }
        if (Lo(I)) return ke(F, U, I, le);
        if (Le(I)) return De(F, U, I, le);
        Ip(F, I);
      }
      return typeof I == "string" && I !== "" || typeof I == "number" ? (I = "" + I, U !== null && U.tag === 6 ? (u(F, U.sibling), U = g(U, I), U.return = F, F = U) : (u(F, U), U = Yg(I, F.mode, le), U.return = F, F = U), k(F)) : u(F, U);
    }
    return In;
  }
  var zn = Xo(!0), me = Xo(!1), Qr = Ba(null), Lr = null, Cc = null, yg = null;
  function gg() {
    yg = Cc = Lr = null;
  }
  function Sg(i) {
    var r = Qr.current;
    un(Qr), i._currentValue = r;
  }
  function Tg(i, r, u) {
    for (; i !== null; ) {
      var p = i.alternate;
      if ((i.childLanes & r) !== r ? (i.childLanes |= r, p !== null && (p.childLanes |= r)) : p !== null && (p.childLanes & r) !== r && (p.childLanes |= r), i === u) break;
      i = i.return;
    }
  }
  function bn(i, r) {
    Lr = i, yg = Cc = null, i = i.dependencies, i !== null && i.firstContext !== null && (i.lanes & r && (Zn = !0), i.firstContext = null);
  }
  function ga(i) {
    var r = i._currentValue;
    if (yg !== i) if (i = { context: i, memoizedValue: r, next: null }, Cc === null) {
      if (Lr === null) throw Error(n(308));
      Cc = i, Lr.dependencies = { lanes: 0, firstContext: i };
    } else Cc = Cc.next = i;
    return r;
  }
  var Zo = null;
  function wg(i) {
    Zo === null ? Zo = [i] : Zo.push(i);
  }
  function Eg(i, r, u, p) {
    var g = r.interleaved;
    return g === null ? (u.next = u, wg(r)) : (u.next = g.next, g.next = u), r.interleaved = u, Yr(i, p);
  }
  function Yr(i, r) {
    i.lanes |= r;
    var u = i.alternate;
    for (u !== null && (u.lanes |= r), u = i, i = i.return; i !== null; ) i.childLanes |= r, u = i.alternate, u !== null && (u.childLanes |= r), u = i, i = i.return;
    return u.tag === 3 ? u.stateNode : null;
  }
  var Gr = !1;
  function bg(i) {
    i.updateQueue = { baseState: i.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function aE(i, r) {
    i = i.updateQueue, r.updateQueue === i && (r.updateQueue = { baseState: i.baseState, firstBaseUpdate: i.firstBaseUpdate, lastBaseUpdate: i.lastBaseUpdate, shared: i.shared, effects: i.effects });
  }
  function Xs(i, r) {
    return { eventTime: i, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function Fl(i, r, u) {
    var p = i.updateQueue;
    if (p === null) return null;
    if (p = p.shared, Ct & 2) {
      var g = p.pending;
      return g === null ? r.next = r : (r.next = g.next, g.next = r), p.pending = r, Yr(i, u);
    }
    return g = p.interleaved, g === null ? (r.next = r, wg(p)) : (r.next = g.next, g.next = r), p.interleaved = r, Yr(i, u);
  }
  function qp(i, r, u) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (u & 4194240) !== 0)) {
      var p = r.lanes;
      p &= i.pendingLanes, u |= p, r.lanes = u, fp(i, u);
    }
  }
  function sE(i, r) {
    var u = i.updateQueue, p = i.alternate;
    if (p !== null && (p = p.updateQueue, u === p)) {
      var g = null, w = null;
      if (u = u.firstBaseUpdate, u !== null) {
        do {
          var k = { eventTime: u.eventTime, lane: u.lane, tag: u.tag, payload: u.payload, callback: u.callback, next: null };
          w === null ? g = w = k : w = w.next = k, u = u.next;
        } while (u !== null);
        w === null ? g = w = r : w = w.next = r;
      } else g = w = r;
      u = { baseState: p.baseState, firstBaseUpdate: g, lastBaseUpdate: w, shared: p.shared, effects: p.effects }, i.updateQueue = u;
      return;
    }
    i = u.lastBaseUpdate, i === null ? u.firstBaseUpdate = r : i.next = r, u.lastBaseUpdate = r;
  }
  function pf(i, r, u, p) {
    var g = i.updateQueue;
    Gr = !1;
    var w = g.firstBaseUpdate, k = g.lastBaseUpdate, O = g.shared.pending;
    if (O !== null) {
      g.shared.pending = null;
      var P = O, j = P.next;
      P.next = null, k === null ? w = j : k.next = j, k = P;
      var ie = i.alternate;
      ie !== null && (ie = ie.updateQueue, O = ie.lastBaseUpdate, O !== k && (O === null ? ie.firstBaseUpdate = j : O.next = j, ie.lastBaseUpdate = P));
    }
    if (w !== null) {
      var re = g.baseState;
      k = 0, ie = j = P = null, O = w;
      do {
        var te = O.lane, Te = O.eventTime;
        if ((p & te) === te) {
          ie !== null && (ie = ie.next = {
            eventTime: Te,
            lane: 0,
            tag: O.tag,
            payload: O.payload,
            callback: O.callback,
            next: null
          });
          e: {
            var ke = i, De = O;
            switch (te = r, Te = u, De.tag) {
              case 1:
                if (ke = De.payload, typeof ke == "function") {
                  re = ke.call(Te, re, te);
                  break e;
                }
                re = ke;
                break e;
              case 3:
                ke.flags = ke.flags & -65537 | 128;
              case 0:
                if (ke = De.payload, te = typeof ke == "function" ? ke.call(Te, re, te) : ke, te == null) break e;
                re = he({}, re, te);
                break e;
              case 2:
                Gr = !0;
            }
          }
          O.callback !== null && O.lane !== 0 && (i.flags |= 64, te = g.effects, te === null ? g.effects = [O] : te.push(O));
        } else Te = { eventTime: Te, lane: te, tag: O.tag, payload: O.payload, callback: O.callback, next: null }, ie === null ? (j = ie = Te, P = re) : ie = ie.next = Te, k |= te;
        if (O = O.next, O === null) {
          if (O = g.shared.pending, O === null) break;
          te = O, O = te.next, te.next = null, g.lastBaseUpdate = te, g.shared.pending = null;
        }
      } while (!0);
      if (ie === null && (P = re), g.baseState = P, g.firstBaseUpdate = j, g.lastBaseUpdate = ie, r = g.shared.interleaved, r !== null) {
        g = r;
        do
          k |= g.lane, g = g.next;
        while (g !== r);
      } else w === null && (g.shared.lanes = 0);
      bs |= k, i.lanes = k, i.memoizedState = re;
    }
  }
  function Cg(i, r, u) {
    if (i = r.effects, r.effects = null, i !== null) for (r = 0; r < i.length; r++) {
      var p = i[r], g = p.callback;
      if (g !== null) {
        if (p.callback = null, p = u, typeof g != "function") throw Error(n(191, g));
        g.call(p);
      }
    }
  }
  var mf = {}, Ss = Ba(mf), vf = Ba(mf), yf = Ba(mf);
  function Jo(i) {
    if (i === mf) throw Error(n(174));
    return i;
  }
  function kg(i, r) {
    switch (Oe(yf, r), Oe(vf, i), Oe(Ss, mf), i = r.nodeType, i) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : $o(null, "");
        break;
      default:
        i = i === 8 ? r.parentNode : r, r = i.namespaceURI || null, i = i.tagName, r = $o(r, i);
    }
    un(Ss), Oe(Ss, r);
  }
  function eu() {
    un(Ss), un(vf), un(yf);
  }
  function lE(i) {
    Jo(yf.current);
    var r = Jo(Ss.current), u = $o(r, i.type);
    r !== u && (Oe(vf, i), Oe(Ss, u));
  }
  function jp(i) {
    vf.current === i && (un(Ss), un(vf));
  }
  var Cn = Ba(0);
  function Bp(i) {
    for (var r = i; r !== null; ) {
      if (r.tag === 13) {
        var u = r.memoizedState;
        if (u !== null && (u = u.dehydrated, u === null || u.data === "$?" || u.data === "$!")) return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if (r.flags & 128) return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === i) break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === i) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var gf = [];
  function _e() {
    for (var i = 0; i < gf.length; i++) gf[i]._workInProgressVersionPrimary = null;
    gf.length = 0;
  }
  var dt = ct.ReactCurrentDispatcher, Ut = ct.ReactCurrentBatchConfig, Jt = 0, zt = null, Xn = null, Si = null, Qp = !1, Sf = !1, tu = 0, ee = 0;
  function Ot() {
    throw Error(n(321));
  }
  function je(i, r) {
    if (r === null) return !1;
    for (var u = 0; u < r.length && u < i.length; u++) if (!qa(i[u], r[u])) return !1;
    return !0;
  }
  function Vl(i, r, u, p, g, w) {
    if (Jt = w, zt = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, dt.current = i === null || i.memoizedState === null ? lm : kf, i = u(p, g), Sf) {
      w = 0;
      do {
        if (Sf = !1, tu = 0, 25 <= w) throw Error(n(301));
        w += 1, Si = Xn = null, r.updateQueue = null, dt.current = om, i = u(p, g);
      } while (Sf);
    }
    if (dt.current = su, r = Xn !== null && Xn.next !== null, Jt = 0, Si = Xn = zt = null, Qp = !1, r) throw Error(n(300));
    return i;
  }
  function Qa() {
    var i = tu !== 0;
    return tu = 0, i;
  }
  function ji() {
    var i = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Si === null ? zt.memoizedState = Si = i : Si = Si.next = i, Si;
  }
  function Fn() {
    if (Xn === null) {
      var i = zt.alternate;
      i = i !== null ? i.memoizedState : null;
    } else i = Xn.next;
    var r = Si === null ? zt.memoizedState : Si.next;
    if (r !== null) Si = r, Xn = i;
    else {
      if (i === null) throw Error(n(310));
      Xn = i, i = { memoizedState: Xn.memoizedState, baseState: Xn.baseState, baseQueue: Xn.baseQueue, queue: Xn.queue, next: null }, Si === null ? zt.memoizedState = Si = i : Si = Si.next = i;
    }
    return Si;
  }
  function Zs(i, r) {
    return typeof r == "function" ? r(i) : r;
  }
  function Hl(i) {
    var r = Fn(), u = r.queue;
    if (u === null) throw Error(n(311));
    u.lastRenderedReducer = i;
    var p = Xn, g = p.baseQueue, w = u.pending;
    if (w !== null) {
      if (g !== null) {
        var k = g.next;
        g.next = w.next, w.next = k;
      }
      p.baseQueue = g = w, u.pending = null;
    }
    if (g !== null) {
      w = g.next, p = p.baseState;
      var O = k = null, P = null, j = w;
      do {
        var ie = j.lane;
        if ((Jt & ie) === ie) P !== null && (P = P.next = { lane: 0, action: j.action, hasEagerState: j.hasEagerState, eagerState: j.eagerState, next: null }), p = j.hasEagerState ? j.eagerState : i(p, j.action);
        else {
          var re = {
            lane: ie,
            action: j.action,
            hasEagerState: j.hasEagerState,
            eagerState: j.eagerState,
            next: null
          };
          P === null ? (O = P = re, k = p) : P = P.next = re, zt.lanes |= ie, bs |= ie;
        }
        j = j.next;
      } while (j !== null && j !== w);
      P === null ? k = p : P.next = O, qa(p, r.memoizedState) || (Zn = !0), r.memoizedState = p, r.baseState = k, r.baseQueue = P, u.lastRenderedState = p;
    }
    if (i = u.interleaved, i !== null) {
      g = i;
      do
        w = g.lane, zt.lanes |= w, bs |= w, g = g.next;
      while (g !== i);
    } else g === null && (u.lanes = 0);
    return [r.memoizedState, u.dispatch];
  }
  function nu(i) {
    var r = Fn(), u = r.queue;
    if (u === null) throw Error(n(311));
    u.lastRenderedReducer = i;
    var p = u.dispatch, g = u.pending, w = r.memoizedState;
    if (g !== null) {
      u.pending = null;
      var k = g = g.next;
      do
        w = i(w, k.action), k = k.next;
      while (k !== g);
      qa(w, r.memoizedState) || (Zn = !0), r.memoizedState = w, r.baseQueue === null && (r.baseState = w), u.lastRenderedState = w;
    }
    return [w, p];
  }
  function Yp() {
  }
  function Gp(i, r) {
    var u = zt, p = Fn(), g = r(), w = !qa(p.memoizedState, g);
    if (w && (p.memoizedState = g, Zn = !0), p = p.queue, Tf(Xp.bind(null, u, p, i), [i]), p.getSnapshot !== r || w || Si !== null && Si.memoizedState.tag & 1) {
      if (u.flags |= 2048, iu(9, Kp.bind(null, u, p, g, r), void 0, null), di === null) throw Error(n(349));
      Jt & 30 || Wp(u, r, g);
    }
    return g;
  }
  function Wp(i, r, u) {
    i.flags |= 16384, i = { getSnapshot: r, value: u }, r = zt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, zt.updateQueue = r, r.stores = [i]) : (u = r.stores, u === null ? r.stores = [i] : u.push(i));
  }
  function Kp(i, r, u, p) {
    r.value = u, r.getSnapshot = p, Zp(r) && Jp(i);
  }
  function Xp(i, r, u) {
    return u(function() {
      Zp(r) && Jp(i);
    });
  }
  function Zp(i) {
    var r = i.getSnapshot;
    i = i.value;
    try {
      var u = r();
      return !qa(i, u);
    } catch {
      return !0;
    }
  }
  function Jp(i) {
    var r = Yr(i, 1);
    r !== null && sr(r, i, 1, -1);
  }
  function em(i) {
    var r = ji();
    return typeof i == "function" && (i = i()), r.memoizedState = r.baseState = i, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Zs, lastRenderedState: i }, r.queue = i, i = i.dispatch = au.bind(null, zt, i), [r.memoizedState, i];
  }
  function iu(i, r, u, p) {
    return i = { tag: i, create: r, destroy: u, deps: p, next: null }, r = zt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, zt.updateQueue = r, r.lastEffect = i.next = i) : (u = r.lastEffect, u === null ? r.lastEffect = i.next = i : (p = u.next, u.next = i, i.next = p, r.lastEffect = i)), i;
  }
  function tm() {
    return Fn().memoizedState;
  }
  function kc(i, r, u, p) {
    var g = ji();
    zt.flags |= i, g.memoizedState = iu(1 | r, u, void 0, p === void 0 ? null : p);
  }
  function xc(i, r, u, p) {
    var g = Fn();
    p = p === void 0 ? null : p;
    var w = void 0;
    if (Xn !== null) {
      var k = Xn.memoizedState;
      if (w = k.destroy, p !== null && je(p, k.deps)) {
        g.memoizedState = iu(r, u, w, p);
        return;
      }
    }
    zt.flags |= i, g.memoizedState = iu(1 | r, u, w, p);
  }
  function nm(i, r) {
    return kc(8390656, 8, i, r);
  }
  function Tf(i, r) {
    return xc(2048, 8, i, r);
  }
  function im(i, r) {
    return xc(4, 2, i, r);
  }
  function wf(i, r) {
    return xc(4, 4, i, r);
  }
  function ru(i, r) {
    if (typeof r == "function") return i = i(), r(i), function() {
      r(null);
    };
    if (r != null) return i = i(), r.current = i, function() {
      r.current = null;
    };
  }
  function rm(i, r, u) {
    return u = u != null ? u.concat([i]) : null, xc(4, 4, ru.bind(null, r, i), u);
  }
  function Ef() {
  }
  function am(i, r) {
    var u = Fn();
    r = r === void 0 ? null : r;
    var p = u.memoizedState;
    return p !== null && r !== null && je(r, p[1]) ? p[0] : (u.memoizedState = [i, r], i);
  }
  function sm(i, r) {
    var u = Fn();
    r = r === void 0 ? null : r;
    var p = u.memoizedState;
    return p !== null && r !== null && je(r, p[1]) ? p[0] : (i = i(), u.memoizedState = [i, r], i);
  }
  function xg(i, r, u) {
    return Jt & 21 ? (qa(u, r) || (u = dp(), zt.lanes |= u, bs |= u, i.baseState = !0), r) : (i.baseState && (i.baseState = !1, Zn = !0), i.memoizedState = u);
  }
  function bf(i, r) {
    var u = Xt;
    Xt = u !== 0 && 4 > u ? u : 4, i(!0);
    var p = Ut.transition;
    Ut.transition = {};
    try {
      i(!1), r();
    } finally {
      Xt = u, Ut.transition = p;
    }
  }
  function Rg() {
    return Fn().memoizedState;
  }
  function Cf(i, r, u) {
    var p = Cs(i);
    if (u = { lane: p, action: u, hasEagerState: !1, eagerState: null, next: null }, Wr(i)) oE(r, u);
    else if (u = Eg(i, r, u, p), u !== null) {
      var g = ti();
      sr(u, i, p, g), ln(u, r, p);
    }
  }
  function au(i, r, u) {
    var p = Cs(i), g = { lane: p, action: u, hasEagerState: !1, eagerState: null, next: null };
    if (Wr(i)) oE(r, g);
    else {
      var w = i.alternate;
      if (i.lanes === 0 && (w === null || w.lanes === 0) && (w = r.lastRenderedReducer, w !== null)) try {
        var k = r.lastRenderedState, O = w(k, u);
        if (g.hasEagerState = !0, g.eagerState = O, qa(O, k)) {
          var P = r.interleaved;
          P === null ? (g.next = g, wg(r)) : (g.next = P.next, P.next = g), r.interleaved = g;
          return;
        }
      } catch {
      } finally {
      }
      u = Eg(i, r, g, p), u !== null && (g = ti(), sr(u, i, p, g), ln(u, r, p));
    }
  }
  function Wr(i) {
    var r = i.alternate;
    return i === zt || r !== null && r === zt;
  }
  function oE(i, r) {
    Sf = Qp = !0;
    var u = i.pending;
    u === null ? r.next = r : (r.next = u.next, u.next = r), i.pending = r;
  }
  function ln(i, r, u) {
    if (u & 4194240) {
      var p = r.lanes;
      p &= i.pendingLanes, u |= p, r.lanes = u, fp(i, u);
    }
  }
  var su = { readContext: ga, useCallback: Ot, useContext: Ot, useEffect: Ot, useImperativeHandle: Ot, useInsertionEffect: Ot, useLayoutEffect: Ot, useMemo: Ot, useReducer: Ot, useRef: Ot, useState: Ot, useDebugValue: Ot, useDeferredValue: Ot, useTransition: Ot, useMutableSource: Ot, useSyncExternalStore: Ot, useId: Ot, unstable_isNewReconciler: !1 }, lm = { readContext: ga, useCallback: function(i, r) {
    return ji().memoizedState = [i, r === void 0 ? null : r], i;
  }, useContext: ga, useEffect: nm, useImperativeHandle: function(i, r, u) {
    return u = u != null ? u.concat([i]) : null, kc(
      4194308,
      4,
      ru.bind(null, r, i),
      u
    );
  }, useLayoutEffect: function(i, r) {
    return kc(4194308, 4, i, r);
  }, useInsertionEffect: function(i, r) {
    return kc(4, 2, i, r);
  }, useMemo: function(i, r) {
    var u = ji();
    return r = r === void 0 ? null : r, i = i(), u.memoizedState = [i, r], i;
  }, useReducer: function(i, r, u) {
    var p = ji();
    return r = u !== void 0 ? u(r) : r, p.memoizedState = p.baseState = r, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: i, lastRenderedState: r }, p.queue = i, i = i.dispatch = Cf.bind(null, zt, i), [p.memoizedState, i];
  }, useRef: function(i) {
    var r = ji();
    return i = { current: i }, r.memoizedState = i;
  }, useState: em, useDebugValue: Ef, useDeferredValue: function(i) {
    return ji().memoizedState = i;
  }, useTransition: function() {
    var i = em(!1), r = i[0];
    return i = bf.bind(null, i[1]), ji().memoizedState = i, [r, i];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(i, r, u) {
    var p = zt, g = ji();
    if (Tn) {
      if (u === void 0) throw Error(n(407));
      u = u();
    } else {
      if (u = r(), di === null) throw Error(n(349));
      Jt & 30 || Wp(p, r, u);
    }
    g.memoizedState = u;
    var w = { value: u, getSnapshot: r };
    return g.queue = w, nm(Xp.bind(
      null,
      p,
      w,
      i
    ), [i]), p.flags |= 2048, iu(9, Kp.bind(null, p, w, u, r), void 0, null), u;
  }, useId: function() {
    var i = ji(), r = di.identifierPrefix;
    if (Tn) {
      var u = gs, p = ys;
      u = (p & ~(1 << 32 - ca(p) - 1)).toString(32) + u, r = ":" + r + "R" + u, u = tu++, 0 < u && (r += "H" + u.toString(32)), r += ":";
    } else u = ee++, r = ":" + r + "r" + u.toString(32) + ":";
    return i.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, kf = {
    readContext: ga,
    useCallback: am,
    useContext: ga,
    useEffect: Tf,
    useImperativeHandle: rm,
    useInsertionEffect: im,
    useLayoutEffect: wf,
    useMemo: sm,
    useReducer: Hl,
    useRef: tm,
    useState: function() {
      return Hl(Zs);
    },
    useDebugValue: Ef,
    useDeferredValue: function(i) {
      var r = Fn();
      return xg(r, Xn.memoizedState, i);
    },
    useTransition: function() {
      var i = Hl(Zs)[0], r = Fn().memoizedState;
      return [i, r];
    },
    useMutableSource: Yp,
    useSyncExternalStore: Gp,
    useId: Rg,
    unstable_isNewReconciler: !1
  }, om = { readContext: ga, useCallback: am, useContext: ga, useEffect: Tf, useImperativeHandle: rm, useInsertionEffect: im, useLayoutEffect: wf, useMemo: sm, useReducer: nu, useRef: tm, useState: function() {
    return nu(Zs);
  }, useDebugValue: Ef, useDeferredValue: function(i) {
    var r = Fn();
    return Xn === null ? r.memoizedState = i : xg(r, Xn.memoizedState, i);
  }, useTransition: function() {
    var i = nu(Zs)[0], r = Fn().memoizedState;
    return [i, r];
  }, useMutableSource: Yp, useSyncExternalStore: Gp, useId: Rg, unstable_isNewReconciler: !1 };
  function Ya(i, r) {
    if (i && i.defaultProps) {
      r = he({}, r), i = i.defaultProps;
      for (var u in i) r[u] === void 0 && (r[u] = i[u]);
      return r;
    }
    return r;
  }
  function Dg(i, r, u, p) {
    r = i.memoizedState, u = u(p, r), u = u == null ? r : he({}, r, u), i.memoizedState = u, i.lanes === 0 && (i.updateQueue.baseState = u);
  }
  var um = { isMounted: function(i) {
    return (i = i._reactInternals) ? Va(i) === i : !1;
  }, enqueueSetState: function(i, r, u) {
    i = i._reactInternals;
    var p = ti(), g = Cs(i), w = Xs(p, g);
    w.payload = r, u != null && (w.callback = u), r = Fl(i, w, g), r !== null && (sr(r, i, g, p), qp(r, i, g));
  }, enqueueReplaceState: function(i, r, u) {
    i = i._reactInternals;
    var p = ti(), g = Cs(i), w = Xs(p, g);
    w.tag = 1, w.payload = r, u != null && (w.callback = u), r = Fl(i, w, g), r !== null && (sr(r, i, g, p), qp(r, i, g));
  }, enqueueForceUpdate: function(i, r) {
    i = i._reactInternals;
    var u = ti(), p = Cs(i), g = Xs(u, p);
    g.tag = 2, r != null && (g.callback = r), r = Fl(i, g, p), r !== null && (sr(r, i, p, u), qp(r, i, p));
  } };
  function uE(i, r, u, p, g, w, k) {
    return i = i.stateNode, typeof i.shouldComponentUpdate == "function" ? i.shouldComponentUpdate(p, w, k) : r.prototype && r.prototype.isPureReactComponent ? !rf(u, p) || !rf(g, w) : !0;
  }
  function cm(i, r, u) {
    var p = !1, g = kr, w = r.contextType;
    return typeof w == "object" && w !== null ? w = ga(w) : (g = Wn(r) ? xr : An.current, p = r.contextTypes, w = (p = p != null) ? ma(i, g) : kr), r = new r(u, w), i.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = um, i.stateNode = r, r._reactInternals = i, p && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = g, i.__reactInternalMemoizedMaskedChildContext = w), r;
  }
  function cE(i, r, u, p) {
    i = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, p), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, p), r.state !== i && um.enqueueReplaceState(r, r.state, null);
  }
  function xf(i, r, u, p) {
    var g = i.stateNode;
    g.props = u, g.state = i.memoizedState, g.refs = {}, bg(i);
    var w = r.contextType;
    typeof w == "object" && w !== null ? g.context = ga(w) : (w = Wn(r) ? xr : An.current, g.context = ma(i, w)), g.state = i.memoizedState, w = r.getDerivedStateFromProps, typeof w == "function" && (Dg(i, r, w, u), g.state = i.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof g.getSnapshotBeforeUpdate == "function" || typeof g.UNSAFE_componentWillMount != "function" && typeof g.componentWillMount != "function" || (r = g.state, typeof g.componentWillMount == "function" && g.componentWillMount(), typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount(), r !== g.state && um.enqueueReplaceState(g, g.state, null), pf(i, u, g, p), g.state = i.memoizedState), typeof g.componentDidMount == "function" && (i.flags |= 4194308);
  }
  function lu(i, r) {
    try {
      var u = "", p = r;
      do
        u += oa(p), p = p.return;
      while (p);
      var g = u;
    } catch (w) {
      g = `
Error generating stack: ` + w.message + `
` + w.stack;
    }
    return { value: i, source: r, stack: g, digest: null };
  }
  function Mg(i, r, u) {
    return { value: i, source: null, stack: u ?? null, digest: r ?? null };
  }
  function Lg(i, r) {
    try {
      console.error(r.value);
    } catch (u) {
      setTimeout(function() {
        throw u;
      });
    }
  }
  var dm = typeof WeakMap == "function" ? WeakMap : Map;
  function dE(i, r, u) {
    u = Xs(-1, u), u.tag = 3, u.payload = { element: null };
    var p = r.value;
    return u.callback = function() {
      Oc || (Oc = !0, cu = p), Lg(i, r);
    }, u;
  }
  function $g(i, r, u) {
    u = Xs(-1, u), u.tag = 3;
    var p = i.type.getDerivedStateFromError;
    if (typeof p == "function") {
      var g = r.value;
      u.payload = function() {
        return p(g);
      }, u.callback = function() {
        Lg(i, r);
      };
    }
    var w = i.stateNode;
    return w !== null && typeof w.componentDidCatch == "function" && (u.callback = function() {
      Lg(i, r), typeof p != "function" && (jl === null ? jl = /* @__PURE__ */ new Set([this]) : jl.add(this));
      var k = r.stack;
      this.componentDidCatch(r.value, { componentStack: k !== null ? k : "" });
    }), u;
  }
  function Og(i, r, u) {
    var p = i.pingCache;
    if (p === null) {
      p = i.pingCache = new dm();
      var g = /* @__PURE__ */ new Set();
      p.set(r, g);
    } else g = p.get(r), g === void 0 && (g = /* @__PURE__ */ new Set(), p.set(r, g));
    g.has(u) || (g.add(u), i = vk.bind(null, i, r, u), r.then(i, i));
  }
  function fE(i) {
    do {
      var r;
      if ((r = i.tag === 13) && (r = i.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r) return i;
      i = i.return;
    } while (i !== null);
    return null;
  }
  function Il(i, r, u, p, g) {
    return i.mode & 1 ? (i.flags |= 65536, i.lanes = g, i) : (i === r ? i.flags |= 65536 : (i.flags |= 128, u.flags |= 131072, u.flags &= -52805, u.tag === 1 && (u.alternate === null ? u.tag = 17 : (r = Xs(-1, 1), r.tag = 2, Fl(u, r, 1))), u.lanes |= 1), i);
  }
  var Rf = ct.ReactCurrentOwner, Zn = !1;
  function Li(i, r, u, p) {
    r.child = i === null ? me(r, null, u, p) : zn(r, i.child, u, p);
  }
  function $r(i, r, u, p, g) {
    u = u.render;
    var w = r.ref;
    return bn(r, g), p = Vl(i, r, u, p, w, g), u = Qa(), i !== null && !Zn ? (r.updateQueue = i.updateQueue, r.flags &= -2053, i.lanes &= ~g, Ta(i, r, g)) : (Tn && u && Fp(r), r.flags |= 1, Li(i, r, p, g), r.child);
  }
  function ou(i, r, u, p, g) {
    if (i === null) {
      var w = u.type;
      return typeof w == "function" && !Qg(w) && w.defaultProps === void 0 && u.compare === null && u.defaultProps === void 0 ? (r.tag = 15, r.type = w, it(i, r, w, p, g)) : (i = qf(u.type, null, p, r, r.mode, g), i.ref = r.ref, i.return = r, r.child = i);
    }
    if (w = i.child, !(i.lanes & g)) {
      var k = w.memoizedProps;
      if (u = u.compare, u = u !== null ? u : rf, u(k, p) && i.ref === r.ref) return Ta(i, r, g);
    }
    return r.flags |= 1, i = Ql(w, p), i.ref = r.ref, i.return = r, r.child = i;
  }
  function it(i, r, u, p, g) {
    if (i !== null) {
      var w = i.memoizedProps;
      if (rf(w, p) && i.ref === r.ref) if (Zn = !1, r.pendingProps = p = w, (i.lanes & g) !== 0) i.flags & 131072 && (Zn = !0);
      else return r.lanes = i.lanes, Ta(i, r, g);
    }
    return hE(i, r, u, p, g);
  }
  function Df(i, r, u) {
    var p = r.pendingProps, g = p.children, w = i !== null ? i.memoizedState : null;
    if (p.mode === "hidden") if (!(r.mode & 1)) r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Oe(Mc, Kr), Kr |= u;
    else {
      if (!(u & 1073741824)) return i = w !== null ? w.baseLanes | u : u, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: i, cachePool: null, transitions: null }, r.updateQueue = null, Oe(Mc, Kr), Kr |= i, null;
      r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, p = w !== null ? w.baseLanes : u, Oe(Mc, Kr), Kr |= p;
    }
    else w !== null ? (p = w.baseLanes | u, r.memoizedState = null) : p = u, Oe(Mc, Kr), Kr |= p;
    return Li(i, r, g, u), r.child;
  }
  function Ag(i, r) {
    var u = r.ref;
    (i === null && u !== null || i !== null && i.ref !== u) && (r.flags |= 512, r.flags |= 2097152);
  }
  function hE(i, r, u, p, g) {
    var w = Wn(u) ? xr : An.current;
    return w = ma(r, w), bn(r, g), u = Vl(i, r, u, p, w, g), p = Qa(), i !== null && !Zn ? (r.updateQueue = i.updateQueue, r.flags &= -2053, i.lanes &= ~g, Ta(i, r, g)) : (Tn && p && Fp(r), r.flags |= 1, Li(i, r, u, g), r.child);
  }
  function pE(i, r, u, p, g) {
    if (Wn(u)) {
      var w = !0;
      Rr(r);
    } else w = !1;
    if (bn(r, g), r.stateNode === null) Sa(i, r), cm(r, u, p), xf(r, u, p, g), p = !0;
    else if (i === null) {
      var k = r.stateNode, O = r.memoizedProps;
      k.props = O;
      var P = k.context, j = u.contextType;
      typeof j == "object" && j !== null ? j = ga(j) : (j = Wn(u) ? xr : An.current, j = ma(r, j));
      var ie = u.getDerivedStateFromProps, re = typeof ie == "function" || typeof k.getSnapshotBeforeUpdate == "function";
      re || typeof k.UNSAFE_componentWillReceiveProps != "function" && typeof k.componentWillReceiveProps != "function" || (O !== p || P !== j) && cE(r, k, p, j), Gr = !1;
      var te = r.memoizedState;
      k.state = te, pf(r, p, k, g), P = r.memoizedState, O !== p || te !== P || ui.current || Gr ? (typeof ie == "function" && (Dg(r, u, ie, p), P = r.memoizedState), (O = Gr || uE(r, u, O, p, te, P, j)) ? (re || typeof k.UNSAFE_componentWillMount != "function" && typeof k.componentWillMount != "function" || (typeof k.componentWillMount == "function" && k.componentWillMount(), typeof k.UNSAFE_componentWillMount == "function" && k.UNSAFE_componentWillMount()), typeof k.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof k.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = p, r.memoizedState = P), k.props = p, k.state = P, k.context = j, p = O) : (typeof k.componentDidMount == "function" && (r.flags |= 4194308), p = !1);
    } else {
      k = r.stateNode, aE(i, r), O = r.memoizedProps, j = r.type === r.elementType ? O : Ya(r.type, O), k.props = j, re = r.pendingProps, te = k.context, P = u.contextType, typeof P == "object" && P !== null ? P = ga(P) : (P = Wn(u) ? xr : An.current, P = ma(r, P));
      var Te = u.getDerivedStateFromProps;
      (ie = typeof Te == "function" || typeof k.getSnapshotBeforeUpdate == "function") || typeof k.UNSAFE_componentWillReceiveProps != "function" && typeof k.componentWillReceiveProps != "function" || (O !== re || te !== P) && cE(r, k, p, P), Gr = !1, te = r.memoizedState, k.state = te, pf(r, p, k, g);
      var ke = r.memoizedState;
      O !== re || te !== ke || ui.current || Gr ? (typeof Te == "function" && (Dg(r, u, Te, p), ke = r.memoizedState), (j = Gr || uE(r, u, j, p, te, ke, P) || !1) ? (ie || typeof k.UNSAFE_componentWillUpdate != "function" && typeof k.componentWillUpdate != "function" || (typeof k.componentWillUpdate == "function" && k.componentWillUpdate(p, ke, P), typeof k.UNSAFE_componentWillUpdate == "function" && k.UNSAFE_componentWillUpdate(p, ke, P)), typeof k.componentDidUpdate == "function" && (r.flags |= 4), typeof k.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof k.componentDidUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 4), typeof k.getSnapshotBeforeUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 1024), r.memoizedProps = p, r.memoizedState = ke), k.props = p, k.state = ke, k.context = P, p = j) : (typeof k.componentDidUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 4), typeof k.getSnapshotBeforeUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 1024), p = !1);
    }
    return Mf(i, r, u, p, w, g);
  }
  function Mf(i, r, u, p, g, w) {
    Ag(i, r);
    var k = (r.flags & 128) !== 0;
    if (!p && !k) return g && Up(r, u, !1), Ta(i, r, w);
    p = r.stateNode, Rf.current = r;
    var O = k && typeof u.getDerivedStateFromError != "function" ? null : p.render();
    return r.flags |= 1, i !== null && k ? (r.child = zn(r, i.child, null, w), r.child = zn(r, null, O, w)) : Li(i, r, O, w), r.memoizedState = p.state, g && Up(r, u, !0), r.child;
  }
  function Rc(i) {
    var r = i.stateNode;
    r.pendingContext ? tE(i, r.pendingContext, r.pendingContext !== r.context) : r.context && tE(i, r.context, !1), kg(i, r.containerInfo);
  }
  function mE(i, r, u, p, g) {
    return zl(), Ks(g), r.flags |= 256, Li(i, r, u, p), r.child;
  }
  var fm = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Pg(i) {
    return { baseLanes: i, cachePool: null, transitions: null };
  }
  function hm(i, r, u) {
    var p = r.pendingProps, g = Cn.current, w = !1, k = (r.flags & 128) !== 0, O;
    if ((O = k) || (O = i !== null && i.memoizedState === null ? !1 : (g & 2) !== 0), O ? (w = !0, r.flags &= -129) : (i === null || i.memoizedState !== null) && (g |= 1), Oe(Cn, g & 1), i === null)
      return vg(r), i = r.memoizedState, i !== null && (i = i.dehydrated, i !== null) ? (r.mode & 1 ? i.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824 : r.lanes = 1, null) : (k = p.children, i = p.fallback, w ? (p = r.mode, w = r.child, k = { mode: "hidden", children: k }, !(p & 1) && w !== null ? (w.childLanes = 0, w.pendingProps = k) : w = Yl(k, p, 0, null), i = nl(i, p, u, null), w.return = r, i.return = r, w.sibling = i, r.child = w, r.child.memoizedState = Pg(u), r.memoizedState = fm, i) : _g(r, k));
    if (g = i.memoizedState, g !== null && (O = g.dehydrated, O !== null)) return vE(i, r, k, p, O, g, u);
    if (w) {
      w = p.fallback, k = r.mode, g = i.child, O = g.sibling;
      var P = { mode: "hidden", children: p.children };
      return !(k & 1) && r.child !== g ? (p = r.child, p.childLanes = 0, p.pendingProps = P, r.deletions = null) : (p = Ql(g, P), p.subtreeFlags = g.subtreeFlags & 14680064), O !== null ? w = Ql(O, w) : (w = nl(w, k, u, null), w.flags |= 2), w.return = r, p.return = r, p.sibling = w, r.child = p, p = w, w = r.child, k = i.child.memoizedState, k = k === null ? Pg(u) : { baseLanes: k.baseLanes | u, cachePool: null, transitions: k.transitions }, w.memoizedState = k, w.childLanes = i.childLanes & ~u, r.memoizedState = fm, p;
    }
    return w = i.child, i = w.sibling, p = Ql(w, { mode: "visible", children: p.children }), !(r.mode & 1) && (p.lanes = u), p.return = r, p.sibling = null, i !== null && (u = r.deletions, u === null ? (r.deletions = [i], r.flags |= 16) : u.push(i)), r.child = p, r.memoizedState = null, p;
  }
  function _g(i, r) {
    return r = Yl({ mode: "visible", children: r }, i.mode, 0, null), r.return = i, i.child = r;
  }
  function Lf(i, r, u, p) {
    return p !== null && Ks(p), zn(r, i.child, null, u), i = _g(r, r.pendingProps.children), i.flags |= 2, r.memoizedState = null, i;
  }
  function vE(i, r, u, p, g, w, k) {
    if (u)
      return r.flags & 256 ? (r.flags &= -257, p = Mg(Error(n(422))), Lf(i, r, k, p)) : r.memoizedState !== null ? (r.child = i.child, r.flags |= 128, null) : (w = p.fallback, g = r.mode, p = Yl({ mode: "visible", children: p.children }, g, 0, null), w = nl(w, g, k, null), w.flags |= 2, p.return = r, w.return = r, p.sibling = w, r.child = p, r.mode & 1 && zn(r, i.child, null, k), r.child.memoizedState = Pg(k), r.memoizedState = fm, w);
    if (!(r.mode & 1)) return Lf(i, r, k, null);
    if (g.data === "$!") {
      if (p = g.nextSibling && g.nextSibling.dataset, p) var O = p.dgst;
      return p = O, w = Error(n(419)), p = Mg(w, p, void 0), Lf(i, r, k, p);
    }
    if (O = (k & i.childLanes) !== 0, Zn || O) {
      if (p = di, p !== null) {
        switch (k & -k) {
          case 4:
            g = 2;
            break;
          case 16:
            g = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            g = 32;
            break;
          case 536870912:
            g = 268435456;
            break;
          default:
            g = 0;
        }
        g = g & (p.suspendedLanes | k) ? 0 : g, g !== 0 && g !== w.retryLane && (w.retryLane = g, Yr(i, g), sr(p, i, g, -1));
      }
      return Bg(), p = Mg(Error(n(421))), Lf(i, r, k, p);
    }
    return g.data === "$?" ? (r.flags |= 128, r.child = i.child, r = yk.bind(null, i), g._reactRetry = r, null) : (i = w.treeContext, Mr = hs(g.nextSibling), Dr = r, Tn = !0, ya = null, i !== null && (Kn[va++] = ys, Kn[va++] = gs, Kn[va++] = Br, ys = i.id, gs = i.overflow, Br = r), r = _g(r, p.children), r.flags |= 4096, r);
  }
  function Ng(i, r, u) {
    i.lanes |= r;
    var p = i.alternate;
    p !== null && (p.lanes |= r), Tg(i.return, r, u);
  }
  function ir(i, r, u, p, g) {
    var w = i.memoizedState;
    w === null ? i.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: p, tail: u, tailMode: g } : (w.isBackwards = r, w.rendering = null, w.renderingStartTime = 0, w.last = p, w.tail = u, w.tailMode = g);
  }
  function Ts(i, r, u) {
    var p = r.pendingProps, g = p.revealOrder, w = p.tail;
    if (Li(i, r, p.children, u), p = Cn.current, p & 2) p = p & 1 | 2, r.flags |= 128;
    else {
      if (i !== null && i.flags & 128) e: for (i = r.child; i !== null; ) {
        if (i.tag === 13) i.memoizedState !== null && Ng(i, u, r);
        else if (i.tag === 19) Ng(i, u, r);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === r) break e;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === r) break e;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      p &= 1;
    }
    if (Oe(Cn, p), !(r.mode & 1)) r.memoizedState = null;
    else switch (g) {
      case "forwards":
        for (u = r.child, g = null; u !== null; ) i = u.alternate, i !== null && Bp(i) === null && (g = u), u = u.sibling;
        u = g, u === null ? (g = r.child, r.child = null) : (g = u.sibling, u.sibling = null), ir(r, !1, g, u, w);
        break;
      case "backwards":
        for (u = null, g = r.child, r.child = null; g !== null; ) {
          if (i = g.alternate, i !== null && Bp(i) === null) {
            r.child = g;
            break;
          }
          i = g.sibling, g.sibling = u, u = g, g = i;
        }
        ir(r, !0, u, null, w);
        break;
      case "together":
        ir(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function Sa(i, r) {
    !(r.mode & 1) && i !== null && (i.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function Ta(i, r, u) {
    if (i !== null && (r.dependencies = i.dependencies), bs |= r.lanes, !(u & r.childLanes)) return null;
    if (i !== null && r.child !== i.child) throw Error(n(153));
    if (r.child !== null) {
      for (i = r.child, u = Ql(i, i.pendingProps), r.child = u, u.return = r; i.sibling !== null; ) i = i.sibling, u = u.sibling = Ql(i, i.pendingProps), u.return = r;
      u.sibling = null;
    }
    return r.child;
  }
  function $f(i, r, u) {
    switch (r.tag) {
      case 3:
        Rc(r), zl();
        break;
      case 5:
        lE(r);
        break;
      case 1:
        Wn(r.type) && Rr(r);
        break;
      case 4:
        kg(r, r.stateNode.containerInfo);
        break;
      case 10:
        var p = r.type._context, g = r.memoizedProps.value;
        Oe(Qr, p._currentValue), p._currentValue = g;
        break;
      case 13:
        if (p = r.memoizedState, p !== null)
          return p.dehydrated !== null ? (Oe(Cn, Cn.current & 1), r.flags |= 128, null) : u & r.child.childLanes ? hm(i, r, u) : (Oe(Cn, Cn.current & 1), i = Ta(i, r, u), i !== null ? i.sibling : null);
        Oe(Cn, Cn.current & 1);
        break;
      case 19:
        if (p = (u & r.childLanes) !== 0, i.flags & 128) {
          if (p) return Ts(i, r, u);
          r.flags |= 128;
        }
        if (g = r.memoizedState, g !== null && (g.rendering = null, g.tail = null, g.lastEffect = null), Oe(Cn, Cn.current), p) break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, Df(i, r, u);
    }
    return Ta(i, r, u);
  }
  var wa, Jn, yE, gE;
  wa = function(i, r) {
    for (var u = r.child; u !== null; ) {
      if (u.tag === 5 || u.tag === 6) i.appendChild(u.stateNode);
      else if (u.tag !== 4 && u.child !== null) {
        u.child.return = u, u = u.child;
        continue;
      }
      if (u === r) break;
      for (; u.sibling === null; ) {
        if (u.return === null || u.return === r) return;
        u = u.return;
      }
      u.sibling.return = u.return, u = u.sibling;
    }
  }, Jn = function() {
  }, yE = function(i, r, u, p) {
    var g = i.memoizedProps;
    if (g !== p) {
      i = r.stateNode, Jo(Ss.current);
      var w = null;
      switch (u) {
        case "input":
          g = xi(i, g), p = xi(i, p), w = [];
          break;
        case "select":
          g = he({}, g, { value: void 0 }), p = he({}, p, { value: void 0 }), w = [];
          break;
        case "textarea":
          g = ua(i, g), p = ua(i, p), w = [];
          break;
        default:
          typeof g.onClick != "function" && typeof p.onClick == "function" && (i.onclick = Ol);
      }
      Qn(u, p);
      var k;
      u = null;
      for (j in g) if (!p.hasOwnProperty(j) && g.hasOwnProperty(j) && g[j] != null) if (j === "style") {
        var O = g[j];
        for (k in O) O.hasOwnProperty(k) && (u || (u = {}), u[k] = "");
      } else j !== "dangerouslySetInnerHTML" && j !== "children" && j !== "suppressContentEditableWarning" && j !== "suppressHydrationWarning" && j !== "autoFocus" && (h.hasOwnProperty(j) ? w || (w = []) : (w = w || []).push(j, null));
      for (j in p) {
        var P = p[j];
        if (O = g != null ? g[j] : void 0, p.hasOwnProperty(j) && P !== O && (P != null || O != null)) if (j === "style") if (O) {
          for (k in O) !O.hasOwnProperty(k) || P && P.hasOwnProperty(k) || (u || (u = {}), u[k] = "");
          for (k in P) P.hasOwnProperty(k) && O[k] !== P[k] && (u || (u = {}), u[k] = P[k]);
        } else u || (w || (w = []), w.push(
          j,
          u
        )), u = P;
        else j === "dangerouslySetInnerHTML" ? (P = P ? P.__html : void 0, O = O ? O.__html : void 0, P != null && O !== P && (w = w || []).push(j, P)) : j === "children" ? typeof P != "string" && typeof P != "number" || (w = w || []).push(j, "" + P) : j !== "suppressContentEditableWarning" && j !== "suppressHydrationWarning" && (h.hasOwnProperty(j) ? (P != null && j === "onScroll" && Yt("scroll", i), w || O === P || (w = [])) : (w = w || []).push(j, P));
      }
      u && (w = w || []).push("style", u);
      var j = w;
      (r.updateQueue = j) && (r.flags |= 4);
    }
  }, gE = function(i, r, u, p) {
    u !== p && (r.flags |= 4);
  };
  function Of(i, r) {
    if (!Tn) switch (i.tailMode) {
      case "hidden":
        r = i.tail;
        for (var u = null; r !== null; ) r.alternate !== null && (u = r), r = r.sibling;
        u === null ? i.tail = null : u.sibling = null;
        break;
      case "collapsed":
        u = i.tail;
        for (var p = null; u !== null; ) u.alternate !== null && (p = u), u = u.sibling;
        p === null ? r || i.tail === null ? i.tail = null : i.tail.sibling = null : p.sibling = null;
    }
  }
  function Ti(i) {
    var r = i.alternate !== null && i.alternate.child === i.child, u = 0, p = 0;
    if (r) for (var g = i.child; g !== null; ) u |= g.lanes | g.childLanes, p |= g.subtreeFlags & 14680064, p |= g.flags & 14680064, g.return = i, g = g.sibling;
    else for (g = i.child; g !== null; ) u |= g.lanes | g.childLanes, p |= g.subtreeFlags, p |= g.flags, g.return = i, g = g.sibling;
    return i.subtreeFlags |= p, i.childLanes = u, r;
  }
  function SE(i, r, u) {
    var p = r.pendingProps;
    switch (Vp(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ti(r), null;
      case 1:
        return Wn(r.type) && Ec(), Ti(r), null;
      case 3:
        return p = r.stateNode, eu(), un(ui), un(An), _e(), p.pendingContext && (p.context = p.pendingContext, p.pendingContext = null), (i === null || i.child === null) && (Hp(r) ? r.flags |= 4 : i === null || i.memoizedState.isDehydrated && !(r.flags & 256) || (r.flags |= 1024, ya !== null && (du(ya), ya = null))), Jn(i, r), Ti(r), null;
      case 5:
        jp(r);
        var g = Jo(yf.current);
        if (u = r.type, i !== null && r.stateNode != null) yE(i, r, u, p, g), i.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!p) {
            if (r.stateNode === null) throw Error(n(166));
            return Ti(r), null;
          }
          if (i = Jo(Ss.current), Hp(r)) {
            p = r.stateNode, u = r.type;
            var w = r.memoizedProps;
            switch (p[ps] = r, p[cf] = w, i = (r.mode & 1) !== 0, u) {
              case "dialog":
                Yt("cancel", p), Yt("close", p);
                break;
              case "iframe":
              case "object":
              case "embed":
                Yt("load", p);
                break;
              case "video":
              case "audio":
                for (g = 0; g < lf.length; g++) Yt(lf[g], p);
                break;
              case "source":
                Yt("error", p);
                break;
              case "img":
              case "image":
              case "link":
                Yt(
                  "error",
                  p
                ), Yt("load", p);
                break;
              case "details":
                Yt("toggle", p);
                break;
              case "input":
                tr(p, w), Yt("invalid", p);
                break;
              case "select":
                p._wrapperState = { wasMultiple: !!w.multiple }, Yt("invalid", p);
                break;
              case "textarea":
                za(p, w), Yt("invalid", p);
            }
            Qn(u, w), g = null;
            for (var k in w) if (w.hasOwnProperty(k)) {
              var O = w[k];
              k === "children" ? typeof O == "string" ? p.textContent !== O && (w.suppressHydrationWarning !== !0 && Ap(p.textContent, O, i), g = ["children", O]) : typeof O == "number" && p.textContent !== "" + O && (w.suppressHydrationWarning !== !0 && Ap(
                p.textContent,
                O,
                i
              ), g = ["children", "" + O]) : h.hasOwnProperty(k) && O != null && k === "onScroll" && Yt("scroll", p);
            }
            switch (u) {
              case "input":
                Nn(p), Id(p, w, !0);
                break;
              case "textarea":
                Nn(p), jr(p);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof w.onClick == "function" && (p.onclick = Ol);
            }
            p = g, r.updateQueue = p, p !== null && (r.flags |= 4);
          } else {
            k = g.nodeType === 9 ? g : g.ownerDocument, i === "http://www.w3.org/1999/xhtml" && (i = ds(u)), i === "http://www.w3.org/1999/xhtml" ? u === "script" ? (i = k.createElement("div"), i.innerHTML = "<script><\/script>", i = i.removeChild(i.firstChild)) : typeof p.is == "string" ? i = k.createElement(u, { is: p.is }) : (i = k.createElement(u), u === "select" && (k = i, p.multiple ? k.multiple = !0 : p.size && (k.size = p.size))) : i = k.createElementNS(i, u), i[ps] = r, i[cf] = p, wa(i, r, !1, !1), r.stateNode = i;
            e: {
              switch (k = Er(u, p), u) {
                case "dialog":
                  Yt("cancel", i), Yt("close", i), g = p;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Yt("load", i), g = p;
                  break;
                case "video":
                case "audio":
                  for (g = 0; g < lf.length; g++) Yt(lf[g], i);
                  g = p;
                  break;
                case "source":
                  Yt("error", i), g = p;
                  break;
                case "img":
                case "image":
                case "link":
                  Yt(
                    "error",
                    i
                  ), Yt("load", i), g = p;
                  break;
                case "details":
                  Yt("toggle", i), g = p;
                  break;
                case "input":
                  tr(i, p), g = xi(i, p), Yt("invalid", i);
                  break;
                case "option":
                  g = p;
                  break;
                case "select":
                  i._wrapperState = { wasMultiple: !!p.multiple }, g = he({}, p, { value: void 0 }), Yt("invalid", i);
                  break;
                case "textarea":
                  za(i, p), g = ua(i, p), Yt("invalid", i);
                  break;
                default:
                  g = p;
              }
              Qn(u, g), O = g;
              for (w in O) if (O.hasOwnProperty(w)) {
                var P = O[w];
                w === "style" ? Ln(i, P) : w === "dangerouslySetInnerHTML" ? (P = P ? P.__html : void 0, P != null && jd(i, P)) : w === "children" ? typeof P == "string" ? (u !== "textarea" || P !== "") && pe(i, P) : typeof P == "number" && pe(i, "" + P) : w !== "suppressContentEditableWarning" && w !== "suppressHydrationWarning" && w !== "autoFocus" && (h.hasOwnProperty(w) ? P != null && w === "onScroll" && Yt("scroll", i) : P != null && Ve(i, w, P, k));
              }
              switch (u) {
                case "input":
                  Nn(i), Id(i, p, !1);
                  break;
                case "textarea":
                  Nn(i), jr(i);
                  break;
                case "option":
                  p.value != null && i.setAttribute("value", "" + Ci(p.value));
                  break;
                case "select":
                  i.multiple = !!p.multiple, w = p.value, w != null ? qr(i, !!p.multiple, w, !1) : p.defaultValue != null && qr(
                    i,
                    !!p.multiple,
                    p.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof g.onClick == "function" && (i.onclick = Ol);
              }
              switch (u) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  p = !!p.autoFocus;
                  break e;
                case "img":
                  p = !0;
                  break e;
                default:
                  p = !1;
              }
            }
            p && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return Ti(r), null;
      case 6:
        if (i && r.stateNode != null) gE(i, r, i.memoizedProps, p);
        else {
          if (typeof p != "string" && r.stateNode === null) throw Error(n(166));
          if (u = Jo(yf.current), Jo(Ss.current), Hp(r)) {
            if (p = r.stateNode, u = r.memoizedProps, p[ps] = r, (w = p.nodeValue !== u) && (i = Dr, i !== null)) switch (i.tag) {
              case 3:
                Ap(p.nodeValue, u, (i.mode & 1) !== 0);
                break;
              case 5:
                i.memoizedProps.suppressHydrationWarning !== !0 && Ap(p.nodeValue, u, (i.mode & 1) !== 0);
            }
            w && (r.flags |= 4);
          } else p = (u.nodeType === 9 ? u : u.ownerDocument).createTextNode(p), p[ps] = r, r.stateNode = p;
        }
        return Ti(r), null;
      case 13:
        if (un(Cn), p = r.memoizedState, i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
          if (Tn && Mr !== null && r.mode & 1 && !(r.flags & 128)) hf(), zl(), r.flags |= 98560, w = !1;
          else if (w = Hp(r), p !== null && p.dehydrated !== null) {
            if (i === null) {
              if (!w) throw Error(n(318));
              if (w = r.memoizedState, w = w !== null ? w.dehydrated : null, !w) throw Error(n(317));
              w[ps] = r;
            } else zl(), !(r.flags & 128) && (r.memoizedState = null), r.flags |= 4;
            Ti(r), w = !1;
          } else ya !== null && (du(ya), ya = null), w = !0;
          if (!w) return r.flags & 65536 ? r : null;
        }
        return r.flags & 128 ? (r.lanes = u, r) : (p = p !== null, p !== (i !== null && i.memoizedState !== null) && p && (r.child.flags |= 8192, r.mode & 1 && (i === null || Cn.current & 1 ? Hn === 0 && (Hn = 3) : Bg())), r.updateQueue !== null && (r.flags |= 4), Ti(r), null);
      case 4:
        return eu(), Jn(i, r), i === null && yc(r.stateNode.containerInfo), Ti(r), null;
      case 10:
        return Sg(r.type._context), Ti(r), null;
      case 17:
        return Wn(r.type) && Ec(), Ti(r), null;
      case 19:
        if (un(Cn), w = r.memoizedState, w === null) return Ti(r), null;
        if (p = (r.flags & 128) !== 0, k = w.rendering, k === null) if (p) Of(w, !1);
        else {
          if (Hn !== 0 || i !== null && i.flags & 128) for (i = r.child; i !== null; ) {
            if (k = Bp(i), k !== null) {
              for (r.flags |= 128, Of(w, !1), p = k.updateQueue, p !== null && (r.updateQueue = p, r.flags |= 4), r.subtreeFlags = 0, p = u, u = r.child; u !== null; ) w = u, i = p, w.flags &= 14680066, k = w.alternate, k === null ? (w.childLanes = 0, w.lanes = i, w.child = null, w.subtreeFlags = 0, w.memoizedProps = null, w.memoizedState = null, w.updateQueue = null, w.dependencies = null, w.stateNode = null) : (w.childLanes = k.childLanes, w.lanes = k.lanes, w.child = k.child, w.subtreeFlags = 0, w.deletions = null, w.memoizedProps = k.memoizedProps, w.memoizedState = k.memoizedState, w.updateQueue = k.updateQueue, w.type = k.type, i = k.dependencies, w.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }), u = u.sibling;
              return Oe(Cn, Cn.current & 1 | 2), r.child;
            }
            i = i.sibling;
          }
          w.tail !== null && sn() > $c && (r.flags |= 128, p = !0, Of(w, !1), r.lanes = 4194304);
        }
        else {
          if (!p) if (i = Bp(k), i !== null) {
            if (r.flags |= 128, p = !0, u = i.updateQueue, u !== null && (r.updateQueue = u, r.flags |= 4), Of(w, !0), w.tail === null && w.tailMode === "hidden" && !k.alternate && !Tn) return Ti(r), null;
          } else 2 * sn() - w.renderingStartTime > $c && u !== 1073741824 && (r.flags |= 128, p = !0, Of(w, !1), r.lanes = 4194304);
          w.isBackwards ? (k.sibling = r.child, r.child = k) : (u = w.last, u !== null ? u.sibling = k : r.child = k, w.last = k);
        }
        return w.tail !== null ? (r = w.tail, w.rendering = r, w.tail = r.sibling, w.renderingStartTime = sn(), r.sibling = null, u = Cn.current, Oe(Cn, p ? u & 1 | 2 : u & 1), r) : (Ti(r), null);
      case 22:
      case 23:
        return jg(), p = r.memoizedState !== null, i !== null && i.memoizedState !== null !== p && (r.flags |= 8192), p && r.mode & 1 ? Kr & 1073741824 && (Ti(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : Ti(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, r.tag));
  }
  function pm(i, r) {
    switch (Vp(r), r.tag) {
      case 1:
        return Wn(r.type) && Ec(), i = r.flags, i & 65536 ? (r.flags = i & -65537 | 128, r) : null;
      case 3:
        return eu(), un(ui), un(An), _e(), i = r.flags, i & 65536 && !(i & 128) ? (r.flags = i & -65537 | 128, r) : null;
      case 5:
        return jp(r), null;
      case 13:
        if (un(Cn), i = r.memoizedState, i !== null && i.dehydrated !== null) {
          if (r.alternate === null) throw Error(n(340));
          zl();
        }
        return i = r.flags, i & 65536 ? (r.flags = i & -65537 | 128, r) : null;
      case 19:
        return un(Cn), null;
      case 4:
        return eu(), null;
      case 10:
        return Sg(r.type._context), null;
      case 22:
      case 23:
        return jg(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Af = !1, Bi = !1, ck = typeof WeakSet == "function" ? WeakSet : Set, be = null;
  function Dc(i, r) {
    var u = i.ref;
    if (u !== null) if (typeof u == "function") try {
      u(null);
    } catch (p) {
      wn(i, r, p);
    }
    else u.current = null;
  }
  function mm(i, r, u) {
    try {
      u();
    } catch (p) {
      wn(i, r, p);
    }
  }
  var TE = !1;
  function wE(i, r) {
    if (uf = Vo, i = af(), kp(i)) {
      if ("selectionStart" in i) var u = { start: i.selectionStart, end: i.selectionEnd };
      else e: {
        u = (u = i.ownerDocument) && u.defaultView || window;
        var p = u.getSelection && u.getSelection();
        if (p && p.rangeCount !== 0) {
          u = p.anchorNode;
          var g = p.anchorOffset, w = p.focusNode;
          p = p.focusOffset;
          try {
            u.nodeType, w.nodeType;
          } catch {
            u = null;
            break e;
          }
          var k = 0, O = -1, P = -1, j = 0, ie = 0, re = i, te = null;
          t: for (; ; ) {
            for (var Te; re !== u || g !== 0 && re.nodeType !== 3 || (O = k + g), re !== w || p !== 0 && re.nodeType !== 3 || (P = k + p), re.nodeType === 3 && (k += re.nodeValue.length), (Te = re.firstChild) !== null; )
              te = re, re = Te;
            for (; ; ) {
              if (re === i) break t;
              if (te === u && ++j === g && (O = k), te === w && ++ie === p && (P = k), (Te = re.nextSibling) !== null) break;
              re = te, te = re.parentNode;
            }
            re = Te;
          }
          u = O === -1 || P === -1 ? null : { start: O, end: P };
        } else u = null;
      }
      u = u || { start: 0, end: 0 };
    } else u = null;
    for (Yo = { focusedElem: i, selectionRange: u }, Vo = !1, be = r; be !== null; ) if (r = be, i = r.child, (r.subtreeFlags & 1028) !== 0 && i !== null) i.return = r, be = i;
    else for (; be !== null; ) {
      r = be;
      try {
        var ke = r.alternate;
        if (r.flags & 1024) switch (r.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (ke !== null) {
              var De = ke.memoizedProps, In = ke.memoizedState, F = r.stateNode, U = F.getSnapshotBeforeUpdate(r.elementType === r.type ? De : Ya(r.type, De), In);
              F.__reactInternalSnapshotBeforeUpdate = U;
            }
            break;
          case 3:
            var I = r.stateNode.containerInfo;
            I.nodeType === 1 ? I.textContent = "" : I.nodeType === 9 && I.documentElement && I.removeChild(I.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(n(163));
        }
      } catch (le) {
        wn(r, r.return, le);
      }
      if (i = r.sibling, i !== null) {
        i.return = r.return, be = i;
        break;
      }
      be = r.return;
    }
    return ke = TE, TE = !1, ke;
  }
  function Pf(i, r, u) {
    var p = r.updateQueue;
    if (p = p !== null ? p.lastEffect : null, p !== null) {
      var g = p = p.next;
      do {
        if ((g.tag & i) === i) {
          var w = g.destroy;
          g.destroy = void 0, w !== void 0 && mm(r, u, w);
        }
        g = g.next;
      } while (g !== p);
    }
  }
  function _f(i, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var u = r = r.next;
      do {
        if ((u.tag & i) === i) {
          var p = u.create;
          u.destroy = p();
        }
        u = u.next;
      } while (u !== r);
    }
  }
  function Ug(i) {
    var r = i.ref;
    if (r !== null) {
      var u = i.stateNode;
      switch (i.tag) {
        case 5:
          i = u;
          break;
        default:
          i = u;
      }
      typeof r == "function" ? r(i) : r.current = i;
    }
  }
  function vm(i) {
    var r = i.alternate;
    r !== null && (i.alternate = null, vm(r)), i.child = null, i.deletions = null, i.sibling = null, i.tag === 5 && (r = i.stateNode, r !== null && (delete r[ps], delete r[cf], delete r[df], delete r[wc], delete r[ok])), i.stateNode = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
  }
  function Nf(i) {
    return i.tag === 5 || i.tag === 3 || i.tag === 4;
  }
  function Js(i) {
    e: for (; ; ) {
      for (; i.sibling === null; ) {
        if (i.return === null || Nf(i.return)) return null;
        i = i.return;
      }
      for (i.sibling.return = i.return, i = i.sibling; i.tag !== 5 && i.tag !== 6 && i.tag !== 18; ) {
        if (i.flags & 2 || i.child === null || i.tag === 4) continue e;
        i.child.return = i, i = i.child;
      }
      if (!(i.flags & 2)) return i.stateNode;
    }
  }
  function ws(i, r, u) {
    var p = i.tag;
    if (p === 5 || p === 6) i = i.stateNode, r ? u.nodeType === 8 ? u.parentNode.insertBefore(i, r) : u.insertBefore(i, r) : (u.nodeType === 8 ? (r = u.parentNode, r.insertBefore(i, u)) : (r = u, r.appendChild(i)), u = u._reactRootContainer, u != null || r.onclick !== null || (r.onclick = Ol));
    else if (p !== 4 && (i = i.child, i !== null)) for (ws(i, r, u), i = i.sibling; i !== null; ) ws(i, r, u), i = i.sibling;
  }
  function Es(i, r, u) {
    var p = i.tag;
    if (p === 5 || p === 6) i = i.stateNode, r ? u.insertBefore(i, r) : u.appendChild(i);
    else if (p !== 4 && (i = i.child, i !== null)) for (Es(i, r, u), i = i.sibling; i !== null; ) Es(i, r, u), i = i.sibling;
  }
  var Vn = null, rr = !1;
  function ar(i, r, u) {
    for (u = u.child; u !== null; ) EE(i, r, u), u = u.sibling;
  }
  function EE(i, r, u) {
    if (Ha && typeof Ha.onCommitFiberUnmount == "function") try {
      Ha.onCommitFiberUnmount(Yd, u);
    } catch {
    }
    switch (u.tag) {
      case 5:
        Bi || Dc(u, r);
      case 6:
        var p = Vn, g = rr;
        Vn = null, ar(i, r, u), Vn = p, rr = g, Vn !== null && (rr ? (i = Vn, u = u.stateNode, i.nodeType === 8 ? i.parentNode.removeChild(u) : i.removeChild(u)) : Vn.removeChild(u.stateNode));
        break;
      case 18:
        Vn !== null && (rr ? (i = Vn, u = u.stateNode, i.nodeType === 8 ? Tc(i.parentNode, u) : i.nodeType === 1 && Tc(i, u), Ml(i)) : Tc(Vn, u.stateNode));
        break;
      case 4:
        p = Vn, g = rr, Vn = u.stateNode.containerInfo, rr = !0, ar(i, r, u), Vn = p, rr = g;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Bi && (p = u.updateQueue, p !== null && (p = p.lastEffect, p !== null))) {
          g = p = p.next;
          do {
            var w = g, k = w.destroy;
            w = w.tag, k !== void 0 && (w & 2 || w & 4) && mm(u, r, k), g = g.next;
          } while (g !== p);
        }
        ar(i, r, u);
        break;
      case 1:
        if (!Bi && (Dc(u, r), p = u.stateNode, typeof p.componentWillUnmount == "function")) try {
          p.props = u.memoizedProps, p.state = u.memoizedState, p.componentWillUnmount();
        } catch (O) {
          wn(u, r, O);
        }
        ar(i, r, u);
        break;
      case 21:
        ar(i, r, u);
        break;
      case 22:
        u.mode & 1 ? (Bi = (p = Bi) || u.memoizedState !== null, ar(i, r, u), Bi = p) : ar(i, r, u);
        break;
      default:
        ar(i, r, u);
    }
  }
  function bE(i) {
    var r = i.updateQueue;
    if (r !== null) {
      i.updateQueue = null;
      var u = i.stateNode;
      u === null && (u = i.stateNode = new ck()), r.forEach(function(p) {
        var g = OE.bind(null, i, p);
        u.has(p) || (u.add(p), p.then(g, g));
      });
    }
  }
  function Ga(i, r) {
    var u = r.deletions;
    if (u !== null) for (var p = 0; p < u.length; p++) {
      var g = u[p];
      try {
        var w = i, k = r, O = k;
        e: for (; O !== null; ) {
          switch (O.tag) {
            case 5:
              Vn = O.stateNode, rr = !1;
              break e;
            case 3:
              Vn = O.stateNode.containerInfo, rr = !0;
              break e;
            case 4:
              Vn = O.stateNode.containerInfo, rr = !0;
              break e;
          }
          O = O.return;
        }
        if (Vn === null) throw Error(n(160));
        EE(w, k, g), Vn = null, rr = !1;
        var P = g.alternate;
        P !== null && (P.return = null), g.return = null;
      } catch (j) {
        wn(g, r, j);
      }
    }
    if (r.subtreeFlags & 12854) for (r = r.child; r !== null; ) zg(r, i), r = r.sibling;
  }
  function zg(i, r) {
    var u = i.alternate, p = i.flags;
    switch (i.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Ga(r, i), Or(i), p & 4) {
          try {
            Pf(3, i, i.return), _f(3, i);
          } catch (De) {
            wn(i, i.return, De);
          }
          try {
            Pf(5, i, i.return);
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        break;
      case 1:
        Ga(r, i), Or(i), p & 512 && u !== null && Dc(u, u.return);
        break;
      case 5:
        if (Ga(r, i), Or(i), p & 512 && u !== null && Dc(u, u.return), i.flags & 32) {
          var g = i.stateNode;
          try {
            pe(g, "");
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        if (p & 4 && (g = i.stateNode, g != null)) {
          var w = i.memoizedProps, k = u !== null ? u.memoizedProps : w, O = i.type, P = i.updateQueue;
          if (i.updateQueue = null, P !== null) try {
            O === "input" && w.type === "radio" && w.name != null && Ir(g, w), Er(O, k);
            var j = Er(O, w);
            for (k = 0; k < P.length; k += 2) {
              var ie = P[k], re = P[k + 1];
              ie === "style" ? Ln(g, re) : ie === "dangerouslySetInnerHTML" ? jd(g, re) : ie === "children" ? pe(g, re) : Ve(g, ie, re, j);
            }
            switch (O) {
              case "input":
                nc(g, w);
                break;
              case "textarea":
                ic(g, w);
                break;
              case "select":
                var te = g._wrapperState.wasMultiple;
                g._wrapperState.wasMultiple = !!w.multiple;
                var Te = w.value;
                Te != null ? qr(g, !!w.multiple, Te, !1) : te !== !!w.multiple && (w.defaultValue != null ? qr(
                  g,
                  !!w.multiple,
                  w.defaultValue,
                  !0
                ) : qr(g, !!w.multiple, w.multiple ? [] : "", !1));
            }
            g[cf] = w;
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        break;
      case 6:
        if (Ga(r, i), Or(i), p & 4) {
          if (i.stateNode === null) throw Error(n(162));
          g = i.stateNode, w = i.memoizedProps;
          try {
            g.nodeValue = w;
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        break;
      case 3:
        if (Ga(r, i), Or(i), p & 4 && u !== null && u.memoizedState.isDehydrated) try {
          Ml(r.containerInfo);
        } catch (De) {
          wn(i, i.return, De);
        }
        break;
      case 4:
        Ga(r, i), Or(i);
        break;
      case 13:
        Ga(r, i), Or(i), g = i.child, g.flags & 8192 && (w = g.memoizedState !== null, g.stateNode.isHidden = w, !w || g.alternate !== null && g.alternate.memoizedState !== null || (Hg = sn())), p & 4 && bE(i);
        break;
      case 22:
        if (ie = u !== null && u.memoizedState !== null, i.mode & 1 ? (Bi = (j = Bi) || ie, Ga(r, i), Bi = j) : Ga(r, i), Or(i), p & 8192) {
          if (j = i.memoizedState !== null, (i.stateNode.isHidden = j) && !ie && i.mode & 1) for (be = i, ie = i.child; ie !== null; ) {
            for (re = be = ie; be !== null; ) {
              switch (te = be, Te = te.child, te.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Pf(4, te, te.return);
                  break;
                case 1:
                  Dc(te, te.return);
                  var ke = te.stateNode;
                  if (typeof ke.componentWillUnmount == "function") {
                    p = te, u = te.return;
                    try {
                      r = p, ke.props = r.memoizedProps, ke.state = r.memoizedState, ke.componentWillUnmount();
                    } catch (De) {
                      wn(p, u, De);
                    }
                  }
                  break;
                case 5:
                  Dc(te, te.return);
                  break;
                case 22:
                  if (te.memoizedState !== null) {
                    Uf(re);
                    continue;
                  }
              }
              Te !== null ? (Te.return = te, be = Te) : Uf(re);
            }
            ie = ie.sibling;
          }
          e: for (ie = null, re = i; ; ) {
            if (re.tag === 5) {
              if (ie === null) {
                ie = re;
                try {
                  g = re.stateNode, j ? (w = g.style, typeof w.setProperty == "function" ? w.setProperty("display", "none", "important") : w.display = "none") : (O = re.stateNode, P = re.memoizedProps.style, k = P != null && P.hasOwnProperty("display") ? P.display : null, O.style.display = an("display", k));
                } catch (De) {
                  wn(i, i.return, De);
                }
              }
            } else if (re.tag === 6) {
              if (ie === null) try {
                re.stateNode.nodeValue = j ? "" : re.memoizedProps;
              } catch (De) {
                wn(i, i.return, De);
              }
            } else if ((re.tag !== 22 && re.tag !== 23 || re.memoizedState === null || re === i) && re.child !== null) {
              re.child.return = re, re = re.child;
              continue;
            }
            if (re === i) break e;
            for (; re.sibling === null; ) {
              if (re.return === null || re.return === i) break e;
              ie === re && (ie = null), re = re.return;
            }
            ie === re && (ie = null), re.sibling.return = re.return, re = re.sibling;
          }
        }
        break;
      case 19:
        Ga(r, i), Or(i), p & 4 && bE(i);
        break;
      case 21:
        break;
      default:
        Ga(
          r,
          i
        ), Or(i);
    }
  }
  function Or(i) {
    var r = i.flags;
    if (r & 2) {
      try {
        e: {
          for (var u = i.return; u !== null; ) {
            if (Nf(u)) {
              var p = u;
              break e;
            }
            u = u.return;
          }
          throw Error(n(160));
        }
        switch (p.tag) {
          case 5:
            var g = p.stateNode;
            p.flags & 32 && (pe(g, ""), p.flags &= -33);
            var w = Js(i);
            Es(i, w, g);
            break;
          case 3:
          case 4:
            var k = p.stateNode.containerInfo, O = Js(i);
            ws(i, O, k);
            break;
          default:
            throw Error(n(161));
        }
      } catch (P) {
        wn(i, i.return, P);
      }
      i.flags &= -3;
    }
    r & 4096 && (i.flags &= -4097);
  }
  function dk(i, r, u) {
    be = i, Fg(i);
  }
  function Fg(i, r, u) {
    for (var p = (i.mode & 1) !== 0; be !== null; ) {
      var g = be, w = g.child;
      if (g.tag === 22 && p) {
        var k = g.memoizedState !== null || Af;
        if (!k) {
          var O = g.alternate, P = O !== null && O.memoizedState !== null || Bi;
          O = Af;
          var j = Bi;
          if (Af = k, (Bi = P) && !j) for (be = g; be !== null; ) k = be, P = k.child, k.tag === 22 && k.memoizedState !== null ? Vg(g) : P !== null ? (P.return = k, be = P) : Vg(g);
          for (; w !== null; ) be = w, Fg(w), w = w.sibling;
          be = g, Af = O, Bi = j;
        }
        CE(i);
      } else g.subtreeFlags & 8772 && w !== null ? (w.return = g, be = w) : CE(i);
    }
  }
  function CE(i) {
    for (; be !== null; ) {
      var r = be;
      if (r.flags & 8772) {
        var u = r.alternate;
        try {
          if (r.flags & 8772) switch (r.tag) {
            case 0:
            case 11:
            case 15:
              Bi || _f(5, r);
              break;
            case 1:
              var p = r.stateNode;
              if (r.flags & 4 && !Bi) if (u === null) p.componentDidMount();
              else {
                var g = r.elementType === r.type ? u.memoizedProps : Ya(r.type, u.memoizedProps);
                p.componentDidUpdate(g, u.memoizedState, p.__reactInternalSnapshotBeforeUpdate);
              }
              var w = r.updateQueue;
              w !== null && Cg(r, w, p);
              break;
            case 3:
              var k = r.updateQueue;
              if (k !== null) {
                if (u = null, r.child !== null) switch (r.child.tag) {
                  case 5:
                    u = r.child.stateNode;
                    break;
                  case 1:
                    u = r.child.stateNode;
                }
                Cg(r, k, u);
              }
              break;
            case 5:
              var O = r.stateNode;
              if (u === null && r.flags & 4) {
                u = O;
                var P = r.memoizedProps;
                switch (r.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    P.autoFocus && u.focus();
                    break;
                  case "img":
                    P.src && (u.src = P.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (r.memoizedState === null) {
                var j = r.alternate;
                if (j !== null) {
                  var ie = j.memoizedState;
                  if (ie !== null) {
                    var re = ie.dehydrated;
                    re !== null && Ml(re);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(n(163));
          }
          Bi || r.flags & 512 && Ug(r);
        } catch (te) {
          wn(r, r.return, te);
        }
      }
      if (r === i) {
        be = null;
        break;
      }
      if (u = r.sibling, u !== null) {
        u.return = r.return, be = u;
        break;
      }
      be = r.return;
    }
  }
  function Uf(i) {
    for (; be !== null; ) {
      var r = be;
      if (r === i) {
        be = null;
        break;
      }
      var u = r.sibling;
      if (u !== null) {
        u.return = r.return, be = u;
        break;
      }
      be = r.return;
    }
  }
  function Vg(i) {
    for (; be !== null; ) {
      var r = be;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var u = r.return;
            try {
              _f(4, r);
            } catch (P) {
              wn(r, u, P);
            }
            break;
          case 1:
            var p = r.stateNode;
            if (typeof p.componentDidMount == "function") {
              var g = r.return;
              try {
                p.componentDidMount();
              } catch (P) {
                wn(r, g, P);
              }
            }
            var w = r.return;
            try {
              Ug(r);
            } catch (P) {
              wn(r, w, P);
            }
            break;
          case 5:
            var k = r.return;
            try {
              Ug(r);
            } catch (P) {
              wn(r, k, P);
            }
        }
      } catch (P) {
        wn(r, r.return, P);
      }
      if (r === i) {
        be = null;
        break;
      }
      var O = r.sibling;
      if (O !== null) {
        O.return = r.return, be = O;
        break;
      }
      be = r.return;
    }
  }
  var fk = Math.ceil, ql = ct.ReactCurrentDispatcher, uu = ct.ReactCurrentOwner, $i = ct.ReactCurrentBatchConfig, Ct = 0, di = null, ei = null, Oi = 0, Kr = 0, Mc = Ba(0), Hn = 0, zf = null, bs = 0, Lc = 0, ym = 0, Ff = null, Ar = null, Hg = 0, $c = 1 / 0, Xr = null, Oc = !1, cu = null, jl = null, gm = !1, el = null, Vf = 0, Bl = 0, Ac = null, Hf = -1, Qi = 0;
  function ti() {
    return Ct & 6 ? sn() : Hf !== -1 ? Hf : Hf = sn();
  }
  function Cs(i) {
    return i.mode & 1 ? Ct & 2 && Oi !== 0 ? Oi & -Oi : uk.transition !== null ? (Qi === 0 && (Qi = dp()), Qi) : (i = Xt, i !== 0 || (i = window.event, i = i === void 0 ? 16 : mp(i.type)), i) : 1;
  }
  function sr(i, r, u, p) {
    if (50 < Bl) throw Bl = 0, Ac = null, Error(n(185));
    zo(i, u, p), (!(Ct & 2) || i !== di) && (i === di && (!(Ct & 2) && (Lc |= u), Hn === 4 && Wa(i, Oi)), Pr(i, p), u === 1 && Ct === 0 && !(r.mode & 1) && ($c = sn() + 500, bc && vs()));
  }
  function Pr(i, r) {
    var u = i.callbackNode;
    Uy(i, r);
    var p = Uo(i, i === di ? Oi : 0);
    if (p === 0) u !== null && Sw(u), i.callbackNode = null, i.callbackPriority = 0;
    else if (r = p & -p, i.callbackPriority !== r) {
      if (u != null && Sw(u), r === 1) i.tag === 0 ? Pl(Ig.bind(null, i)) : zp(Ig.bind(null, i)), Sc(function() {
        !(Ct & 6) && vs();
      }), u = null;
      else {
        switch (Vy(p)) {
          case 1:
            u = _o;
            break;
          case 4:
            u = Py;
            break;
          case 16:
            u = Qd;
            break;
          case 536870912:
            u = _y;
            break;
          default:
            u = Qd;
        }
        u = PE(u, Sm.bind(null, i));
      }
      i.callbackPriority = r, i.callbackNode = u;
    }
  }
  function Sm(i, r) {
    if (Hf = -1, Qi = 0, Ct & 6) throw Error(n(327));
    var u = i.callbackNode;
    if (Pc() && i.callbackNode !== u) return null;
    var p = Uo(i, i === di ? Oi : 0);
    if (p === 0) return null;
    if (p & 30 || p & i.expiredLanes || r) r = Tm(i, p);
    else {
      r = p;
      var g = Ct;
      Ct |= 2;
      var w = xE();
      (di !== i || Oi !== r) && (Xr = null, $c = sn() + 500, tl(i, r));
      do
        try {
          RE();
          break;
        } catch (O) {
          kE(i, O);
        }
      while (!0);
      gg(), ql.current = w, Ct = g, ei !== null ? r = 0 : (di = null, Oi = 0, r = Hn);
    }
    if (r !== 0) {
      if (r === 2 && (g = zy(i), g !== 0 && (p = g, r = If(i, g))), r === 1) throw u = zf, tl(i, 0), Wa(i, p), Pr(i, sn()), u;
      if (r === 6) Wa(i, p);
      else {
        if (g = i.current.alternate, !(p & 30) && !hk(g) && (r = Tm(i, p), r === 2 && (w = zy(i), w !== 0 && (p = w, r = If(i, w))), r === 1)) throw u = zf, tl(i, 0), Wa(i, p), Pr(i, sn()), u;
        switch (i.finishedWork = g, i.finishedLanes = p, r) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            hu(i, Ar, Xr);
            break;
          case 3:
            if (Wa(i, p), (p & 130023424) === p && (r = Hg + 500 - sn(), 10 < r)) {
              if (Uo(i, 0) !== 0) break;
              if (g = i.suspendedLanes, (g & p) !== p) {
                ti(), i.pingedLanes |= i.suspendedLanes & g;
                break;
              }
              i.timeoutHandle = _p(hu.bind(null, i, Ar, Xr), r);
              break;
            }
            hu(i, Ar, Xr);
            break;
          case 4:
            if (Wa(i, p), (p & 4194240) === p) break;
            for (r = i.eventTimes, g = -1; 0 < p; ) {
              var k = 31 - ca(p);
              w = 1 << k, k = r[k], k > g && (g = k), p &= ~w;
            }
            if (p = g, p = sn() - p, p = (120 > p ? 120 : 480 > p ? 480 : 1080 > p ? 1080 : 1920 > p ? 1920 : 3e3 > p ? 3e3 : 4320 > p ? 4320 : 1960 * fk(p / 1960)) - p, 10 < p) {
              i.timeoutHandle = _p(hu.bind(null, i, Ar, Xr), p);
              break;
            }
            hu(i, Ar, Xr);
            break;
          case 5:
            hu(i, Ar, Xr);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return Pr(i, sn()), i.callbackNode === u ? Sm.bind(null, i) : null;
  }
  function If(i, r) {
    var u = Ff;
    return i.current.memoizedState.isDehydrated && (tl(i, r).flags |= 256), i = Tm(i, r), i !== 2 && (r = Ar, Ar = u, r !== null && du(r)), i;
  }
  function du(i) {
    Ar === null ? Ar = i : Ar.push.apply(Ar, i);
  }
  function hk(i) {
    for (var r = i; ; ) {
      if (r.flags & 16384) {
        var u = r.updateQueue;
        if (u !== null && (u = u.stores, u !== null)) for (var p = 0; p < u.length; p++) {
          var g = u[p], w = g.getSnapshot;
          g = g.value;
          try {
            if (!qa(w(), g)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (u = r.child, r.subtreeFlags & 16384 && u !== null) u.return = r, r = u;
      else {
        if (r === i) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === i) return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function Wa(i, r) {
    for (r &= ~ym, r &= ~Lc, i.suspendedLanes |= r, i.pingedLanes &= ~r, i = i.expirationTimes; 0 < r; ) {
      var u = 31 - ca(r), p = 1 << u;
      i[u] = -1, r &= ~p;
    }
  }
  function Ig(i) {
    if (Ct & 6) throw Error(n(327));
    Pc();
    var r = Uo(i, 0);
    if (!(r & 1)) return Pr(i, sn()), null;
    var u = Tm(i, r);
    if (i.tag !== 0 && u === 2) {
      var p = zy(i);
      p !== 0 && (r = p, u = If(i, p));
    }
    if (u === 1) throw u = zf, tl(i, 0), Wa(i, r), Pr(i, sn()), u;
    if (u === 6) throw Error(n(345));
    return i.finishedWork = i.current.alternate, i.finishedLanes = r, hu(i, Ar, Xr), Pr(i, sn()), null;
  }
  function qg(i, r) {
    var u = Ct;
    Ct |= 1;
    try {
      return i(r);
    } finally {
      Ct = u, Ct === 0 && ($c = sn() + 500, bc && vs());
    }
  }
  function fu(i) {
    el !== null && el.tag === 0 && !(Ct & 6) && Pc();
    var r = Ct;
    Ct |= 1;
    var u = $i.transition, p = Xt;
    try {
      if ($i.transition = null, Xt = 1, i) return i();
    } finally {
      Xt = p, $i.transition = u, Ct = r, !(Ct & 6) && vs();
    }
  }
  function jg() {
    Kr = Mc.current, un(Mc);
  }
  function tl(i, r) {
    i.finishedWork = null, i.finishedLanes = 0;
    var u = i.timeoutHandle;
    if (u !== -1 && (i.timeoutHandle = -1, hg(u)), ei !== null) for (u = ei.return; u !== null; ) {
      var p = u;
      switch (Vp(p), p.tag) {
        case 1:
          p = p.type.childContextTypes, p != null && Ec();
          break;
        case 3:
          eu(), un(ui), un(An), _e();
          break;
        case 5:
          jp(p);
          break;
        case 4:
          eu();
          break;
        case 13:
          un(Cn);
          break;
        case 19:
          un(Cn);
          break;
        case 10:
          Sg(p.type._context);
          break;
        case 22:
        case 23:
          jg();
      }
      u = u.return;
    }
    if (di = i, ei = i = Ql(i.current, null), Oi = Kr = r, Hn = 0, zf = null, ym = Lc = bs = 0, Ar = Ff = null, Zo !== null) {
      for (r = 0; r < Zo.length; r++) if (u = Zo[r], p = u.interleaved, p !== null) {
        u.interleaved = null;
        var g = p.next, w = u.pending;
        if (w !== null) {
          var k = w.next;
          w.next = g, p.next = k;
        }
        u.pending = p;
      }
      Zo = null;
    }
    return i;
  }
  function kE(i, r) {
    do {
      var u = ei;
      try {
        if (gg(), dt.current = su, Qp) {
          for (var p = zt.memoizedState; p !== null; ) {
            var g = p.queue;
            g !== null && (g.pending = null), p = p.next;
          }
          Qp = !1;
        }
        if (Jt = 0, Si = Xn = zt = null, Sf = !1, tu = 0, uu.current = null, u === null || u.return === null) {
          Hn = 1, zf = r, ei = null;
          break;
        }
        e: {
          var w = i, k = u.return, O = u, P = r;
          if (r = Oi, O.flags |= 32768, P !== null && typeof P == "object" && typeof P.then == "function") {
            var j = P, ie = O, re = ie.tag;
            if (!(ie.mode & 1) && (re === 0 || re === 11 || re === 15)) {
              var te = ie.alternate;
              te ? (ie.updateQueue = te.updateQueue, ie.memoizedState = te.memoizedState, ie.lanes = te.lanes) : (ie.updateQueue = null, ie.memoizedState = null);
            }
            var Te = fE(k);
            if (Te !== null) {
              Te.flags &= -257, Il(Te, k, O, w, r), Te.mode & 1 && Og(w, j, r), r = Te, P = j;
              var ke = r.updateQueue;
              if (ke === null) {
                var De = /* @__PURE__ */ new Set();
                De.add(P), r.updateQueue = De;
              } else ke.add(P);
              break e;
            } else {
              if (!(r & 1)) {
                Og(w, j, r), Bg();
                break e;
              }
              P = Error(n(426));
            }
          } else if (Tn && O.mode & 1) {
            var In = fE(k);
            if (In !== null) {
              !(In.flags & 65536) && (In.flags |= 256), Il(In, k, O, w, r), Ks(lu(P, O));
              break e;
            }
          }
          w = P = lu(P, O), Hn !== 4 && (Hn = 2), Ff === null ? Ff = [w] : Ff.push(w), w = k;
          do {
            switch (w.tag) {
              case 3:
                w.flags |= 65536, r &= -r, w.lanes |= r;
                var F = dE(w, P, r);
                sE(w, F);
                break e;
              case 1:
                O = P;
                var U = w.type, I = w.stateNode;
                if (!(w.flags & 128) && (typeof U.getDerivedStateFromError == "function" || I !== null && typeof I.componentDidCatch == "function" && (jl === null || !jl.has(I)))) {
                  w.flags |= 65536, r &= -r, w.lanes |= r;
                  var le = $g(w, O, r);
                  sE(w, le);
                  break e;
                }
            }
            w = w.return;
          } while (w !== null);
        }
        ME(u);
      } catch (ge) {
        r = ge, ei === u && u !== null && (ei = u = u.return);
        continue;
      }
      break;
    } while (!0);
  }
  function xE() {
    var i = ql.current;
    return ql.current = su, i === null ? su : i;
  }
  function Bg() {
    (Hn === 0 || Hn === 3 || Hn === 2) && (Hn = 4), di === null || !(bs & 268435455) && !(Lc & 268435455) || Wa(di, Oi);
  }
  function Tm(i, r) {
    var u = Ct;
    Ct |= 2;
    var p = xE();
    (di !== i || Oi !== r) && (Xr = null, tl(i, r));
    do
      try {
        pk();
        break;
      } catch (g) {
        kE(i, g);
      }
    while (!0);
    if (gg(), Ct = u, ql.current = p, ei !== null) throw Error(n(261));
    return di = null, Oi = 0, Hn;
  }
  function pk() {
    for (; ei !== null; ) DE(ei);
  }
  function RE() {
    for (; ei !== null && !Tw(); ) DE(ei);
  }
  function DE(i) {
    var r = AE(i.alternate, i, Kr);
    i.memoizedProps = i.pendingProps, r === null ? ME(i) : ei = r, uu.current = null;
  }
  function ME(i) {
    var r = i;
    do {
      var u = r.alternate;
      if (i = r.return, r.flags & 32768) {
        if (u = pm(u, r), u !== null) {
          u.flags &= 32767, ei = u;
          return;
        }
        if (i !== null) i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null;
        else {
          Hn = 6, ei = null;
          return;
        }
      } else if (u = SE(u, r, Kr), u !== null) {
        ei = u;
        return;
      }
      if (r = r.sibling, r !== null) {
        ei = r;
        return;
      }
      ei = r = i;
    } while (r !== null);
    Hn === 0 && (Hn = 5);
  }
  function hu(i, r, u) {
    var p = Xt, g = $i.transition;
    try {
      $i.transition = null, Xt = 1, mk(i, r, u, p);
    } finally {
      $i.transition = g, Xt = p;
    }
    return null;
  }
  function mk(i, r, u, p) {
    do
      Pc();
    while (el !== null);
    if (Ct & 6) throw Error(n(327));
    u = i.finishedWork;
    var g = i.finishedLanes;
    if (u === null) return null;
    if (i.finishedWork = null, i.finishedLanes = 0, u === i.current) throw Error(n(177));
    i.callbackNode = null, i.callbackPriority = 0;
    var w = u.lanes | u.childLanes;
    if (j0(i, w), i === di && (ei = di = null, Oi = 0), !(u.subtreeFlags & 2064) && !(u.flags & 2064) || gm || (gm = !0, PE(Qd, function() {
      return Pc(), null;
    })), w = (u.flags & 15990) !== 0, u.subtreeFlags & 15990 || w) {
      w = $i.transition, $i.transition = null;
      var k = Xt;
      Xt = 1;
      var O = Ct;
      Ct |= 4, uu.current = null, wE(i, u), zg(u, i), mc(Yo), Vo = !!uf, Yo = uf = null, i.current = u, dk(u), V0(), Ct = O, Xt = k, $i.transition = w;
    } else i.current = u;
    if (gm && (gm = !1, el = i, Vf = g), w = i.pendingLanes, w === 0 && (jl = null), Ew(u.stateNode), Pr(i, sn()), r !== null) for (p = i.onRecoverableError, u = 0; u < r.length; u++) g = r[u], p(g.value, { componentStack: g.stack, digest: g.digest });
    if (Oc) throw Oc = !1, i = cu, cu = null, i;
    return Vf & 1 && i.tag !== 0 && Pc(), w = i.pendingLanes, w & 1 ? i === Ac ? Bl++ : (Bl = 0, Ac = i) : Bl = 0, vs(), null;
  }
  function Pc() {
    if (el !== null) {
      var i = Vy(Vf), r = $i.transition, u = Xt;
      try {
        if ($i.transition = null, Xt = 16 > i ? 16 : i, el === null) var p = !1;
        else {
          if (i = el, el = null, Vf = 0, Ct & 6) throw Error(n(331));
          var g = Ct;
          for (Ct |= 4, be = i.current; be !== null; ) {
            var w = be, k = w.child;
            if (be.flags & 16) {
              var O = w.deletions;
              if (O !== null) {
                for (var P = 0; P < O.length; P++) {
                  var j = O[P];
                  for (be = j; be !== null; ) {
                    var ie = be;
                    switch (ie.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Pf(8, ie, w);
                    }
                    var re = ie.child;
                    if (re !== null) re.return = ie, be = re;
                    else for (; be !== null; ) {
                      ie = be;
                      var te = ie.sibling, Te = ie.return;
                      if (vm(ie), ie === j) {
                        be = null;
                        break;
                      }
                      if (te !== null) {
                        te.return = Te, be = te;
                        break;
                      }
                      be = Te;
                    }
                  }
                }
                var ke = w.alternate;
                if (ke !== null) {
                  var De = ke.child;
                  if (De !== null) {
                    ke.child = null;
                    do {
                      var In = De.sibling;
                      De.sibling = null, De = In;
                    } while (De !== null);
                  }
                }
                be = w;
              }
            }
            if (w.subtreeFlags & 2064 && k !== null) k.return = w, be = k;
            else e: for (; be !== null; ) {
              if (w = be, w.flags & 2048) switch (w.tag) {
                case 0:
                case 11:
                case 15:
                  Pf(9, w, w.return);
              }
              var F = w.sibling;
              if (F !== null) {
                F.return = w.return, be = F;
                break e;
              }
              be = w.return;
            }
          }
          var U = i.current;
          for (be = U; be !== null; ) {
            k = be;
            var I = k.child;
            if (k.subtreeFlags & 2064 && I !== null) I.return = k, be = I;
            else e: for (k = U; be !== null; ) {
              if (O = be, O.flags & 2048) try {
                switch (O.tag) {
                  case 0:
                  case 11:
                  case 15:
                    _f(9, O);
                }
              } catch (ge) {
                wn(O, O.return, ge);
              }
              if (O === k) {
                be = null;
                break e;
              }
              var le = O.sibling;
              if (le !== null) {
                le.return = O.return, be = le;
                break e;
              }
              be = O.return;
            }
          }
          if (Ct = g, vs(), Ha && typeof Ha.onPostCommitFiberRoot == "function") try {
            Ha.onPostCommitFiberRoot(Yd, i);
          } catch {
          }
          p = !0;
        }
        return p;
      } finally {
        Xt = u, $i.transition = r;
      }
    }
    return !1;
  }
  function LE(i, r, u) {
    r = lu(u, r), r = dE(i, r, 1), i = Fl(i, r, 1), r = ti(), i !== null && (zo(i, 1, r), Pr(i, r));
  }
  function wn(i, r, u) {
    if (i.tag === 3) LE(i, i, u);
    else for (; r !== null; ) {
      if (r.tag === 3) {
        LE(r, i, u);
        break;
      } else if (r.tag === 1) {
        var p = r.stateNode;
        if (typeof r.type.getDerivedStateFromError == "function" || typeof p.componentDidCatch == "function" && (jl === null || !jl.has(p))) {
          i = lu(u, i), i = $g(r, i, 1), r = Fl(r, i, 1), i = ti(), r !== null && (zo(r, 1, i), Pr(r, i));
          break;
        }
      }
      r = r.return;
    }
  }
  function vk(i, r, u) {
    var p = i.pingCache;
    p !== null && p.delete(r), r = ti(), i.pingedLanes |= i.suspendedLanes & u, di === i && (Oi & u) === u && (Hn === 4 || Hn === 3 && (Oi & 130023424) === Oi && 500 > sn() - Hg ? tl(i, 0) : ym |= u), Pr(i, r);
  }
  function $E(i, r) {
    r === 0 && (i.mode & 1 ? (r = Ia, Ia <<= 1, !(Ia & 130023424) && (Ia = 4194304)) : r = 1);
    var u = ti();
    i = Yr(i, r), i !== null && (zo(i, r, u), Pr(i, u));
  }
  function yk(i) {
    var r = i.memoizedState, u = 0;
    r !== null && (u = r.retryLane), $E(i, u);
  }
  function OE(i, r) {
    var u = 0;
    switch (i.tag) {
      case 13:
        var p = i.stateNode, g = i.memoizedState;
        g !== null && (u = g.retryLane);
        break;
      case 19:
        p = i.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    p !== null && p.delete(r), $E(i, u);
  }
  var AE;
  AE = function(i, r, u) {
    if (i !== null) if (i.memoizedProps !== r.pendingProps || ui.current) Zn = !0;
    else {
      if (!(i.lanes & u) && !(r.flags & 128)) return Zn = !1, $f(i, r, u);
      Zn = !!(i.flags & 131072);
    }
    else Zn = !1, Tn && r.flags & 1048576 && nE(r, Ws, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var p = r.type;
        Sa(i, r), i = r.pendingProps;
        var g = ma(r, An.current);
        bn(r, u), g = Vl(null, r, p, i, g, u);
        var w = Qa();
        return r.flags |= 1, typeof g == "object" && g !== null && typeof g.render == "function" && g.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, Wn(p) ? (w = !0, Rr(r)) : w = !1, r.memoizedState = g.state !== null && g.state !== void 0 ? g.state : null, bg(r), g.updater = um, r.stateNode = g, g._reactInternals = r, xf(r, p, i, u), r = Mf(null, r, p, !0, w, u)) : (r.tag = 0, Tn && w && Fp(r), Li(null, r, g, u), r = r.child), r;
      case 16:
        p = r.elementType;
        e: {
          switch (Sa(i, r), i = r.pendingProps, g = p._init, p = g(p._payload), r.type = p, g = r.tag = Sk(p), i = Ya(p, i), g) {
            case 0:
              r = hE(null, r, p, i, u);
              break e;
            case 1:
              r = pE(null, r, p, i, u);
              break e;
            case 11:
              r = $r(null, r, p, i, u);
              break e;
            case 14:
              r = ou(null, r, p, Ya(p.type, i), u);
              break e;
          }
          throw Error(n(
            306,
            p,
            ""
          ));
        }
        return r;
      case 0:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), hE(i, r, p, g, u);
      case 1:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), pE(i, r, p, g, u);
      case 3:
        e: {
          if (Rc(r), i === null) throw Error(n(387));
          p = r.pendingProps, w = r.memoizedState, g = w.element, aE(i, r), pf(r, p, null, u);
          var k = r.memoizedState;
          if (p = k.element, w.isDehydrated) if (w = { element: p, isDehydrated: !1, cache: k.cache, pendingSuspenseBoundaries: k.pendingSuspenseBoundaries, transitions: k.transitions }, r.updateQueue.baseState = w, r.memoizedState = w, r.flags & 256) {
            g = lu(Error(n(423)), r), r = mE(i, r, p, u, g);
            break e;
          } else if (p !== g) {
            g = lu(Error(n(424)), r), r = mE(i, r, p, u, g);
            break e;
          } else for (Mr = hs(r.stateNode.containerInfo.firstChild), Dr = r, Tn = !0, ya = null, u = me(r, null, p, u), r.child = u; u; ) u.flags = u.flags & -3 | 4096, u = u.sibling;
          else {
            if (zl(), p === g) {
              r = Ta(i, r, u);
              break e;
            }
            Li(i, r, p, u);
          }
          r = r.child;
        }
        return r;
      case 5:
        return lE(r), i === null && vg(r), p = r.type, g = r.pendingProps, w = i !== null ? i.memoizedProps : null, k = g.children, Pp(p, g) ? k = null : w !== null && Pp(p, w) && (r.flags |= 32), Ag(i, r), Li(i, r, k, u), r.child;
      case 6:
        return i === null && vg(r), null;
      case 13:
        return hm(i, r, u);
      case 4:
        return kg(r, r.stateNode.containerInfo), p = r.pendingProps, i === null ? r.child = zn(r, null, p, u) : Li(i, r, p, u), r.child;
      case 11:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), $r(i, r, p, g, u);
      case 7:
        return Li(i, r, r.pendingProps, u), r.child;
      case 8:
        return Li(i, r, r.pendingProps.children, u), r.child;
      case 12:
        return Li(i, r, r.pendingProps.children, u), r.child;
      case 10:
        e: {
          if (p = r.type._context, g = r.pendingProps, w = r.memoizedProps, k = g.value, Oe(Qr, p._currentValue), p._currentValue = k, w !== null) if (qa(w.value, k)) {
            if (w.children === g.children && !ui.current) {
              r = Ta(i, r, u);
              break e;
            }
          } else for (w = r.child, w !== null && (w.return = r); w !== null; ) {
            var O = w.dependencies;
            if (O !== null) {
              k = w.child;
              for (var P = O.firstContext; P !== null; ) {
                if (P.context === p) {
                  if (w.tag === 1) {
                    P = Xs(-1, u & -u), P.tag = 2;
                    var j = w.updateQueue;
                    if (j !== null) {
                      j = j.shared;
                      var ie = j.pending;
                      ie === null ? P.next = P : (P.next = ie.next, ie.next = P), j.pending = P;
                    }
                  }
                  w.lanes |= u, P = w.alternate, P !== null && (P.lanes |= u), Tg(
                    w.return,
                    u,
                    r
                  ), O.lanes |= u;
                  break;
                }
                P = P.next;
              }
            } else if (w.tag === 10) k = w.type === r.type ? null : w.child;
            else if (w.tag === 18) {
              if (k = w.return, k === null) throw Error(n(341));
              k.lanes |= u, O = k.alternate, O !== null && (O.lanes |= u), Tg(k, u, r), k = w.sibling;
            } else k = w.child;
            if (k !== null) k.return = w;
            else for (k = w; k !== null; ) {
              if (k === r) {
                k = null;
                break;
              }
              if (w = k.sibling, w !== null) {
                w.return = k.return, k = w;
                break;
              }
              k = k.return;
            }
            w = k;
          }
          Li(i, r, g.children, u), r = r.child;
        }
        return r;
      case 9:
        return g = r.type, p = r.pendingProps.children, bn(r, u), g = ga(g), p = p(g), r.flags |= 1, Li(i, r, p, u), r.child;
      case 14:
        return p = r.type, g = Ya(p, r.pendingProps), g = Ya(p.type, g), ou(i, r, p, g, u);
      case 15:
        return it(i, r, r.type, r.pendingProps, u);
      case 17:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), Sa(i, r), r.tag = 1, Wn(p) ? (i = !0, Rr(r)) : i = !1, bn(r, u), cm(r, p, g), xf(r, p, g, u), Mf(null, r, p, !0, i, u);
      case 19:
        return Ts(i, r, u);
      case 22:
        return Df(i, r, u);
    }
    throw Error(n(156, r.tag));
  };
  function PE(i, r) {
    return gw(i, r);
  }
  function gk(i, r, u, p) {
    this.tag = i, this.key = u, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = p, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ea(i, r, u, p) {
    return new gk(i, r, u, p);
  }
  function Qg(i) {
    return i = i.prototype, !(!i || !i.isReactComponent);
  }
  function Sk(i) {
    if (typeof i == "function") return Qg(i) ? 1 : 0;
    if (i != null) {
      if (i = i.$$typeof, i === Mt) return 11;
      if (i === Sn) return 14;
    }
    return 2;
  }
  function Ql(i, r) {
    var u = i.alternate;
    return u === null ? (u = Ea(i.tag, r, i.key, i.mode), u.elementType = i.elementType, u.type = i.type, u.stateNode = i.stateNode, u.alternate = i, i.alternate = u) : (u.pendingProps = r, u.type = i.type, u.flags = 0, u.subtreeFlags = 0, u.deletions = null), u.flags = i.flags & 14680064, u.childLanes = i.childLanes, u.lanes = i.lanes, u.child = i.child, u.memoizedProps = i.memoizedProps, u.memoizedState = i.memoizedState, u.updateQueue = i.updateQueue, r = i.dependencies, u.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, u.sibling = i.sibling, u.index = i.index, u.ref = i.ref, u;
  }
  function qf(i, r, u, p, g, w) {
    var k = 2;
    if (p = i, typeof i == "function") Qg(i) && (k = 1);
    else if (typeof i == "string") k = 5;
    else e: switch (i) {
      case He:
        return nl(u.children, g, w, r);
      case de:
        k = 8, g |= 8;
        break;
      case Ge:
        return i = Ea(12, u, r, g | 2), i.elementType = Ge, i.lanes = w, i;
      case Ae:
        return i = Ea(13, u, r, g), i.elementType = Ae, i.lanes = w, i;
      case Et:
        return i = Ea(19, u, r, g), i.elementType = Et, i.lanes = w, i;
      case ot:
        return Yl(u, g, w, r);
      default:
        if (typeof i == "object" && i !== null) switch (i.$$typeof) {
          case ft:
            k = 10;
            break e;
          case Kt:
            k = 9;
            break e;
          case Mt:
            k = 11;
            break e;
          case Sn:
            k = 14;
            break e;
          case Je:
            k = 16, p = null;
            break e;
        }
        throw Error(n(130, i == null ? i : typeof i, ""));
    }
    return r = Ea(k, u, r, g), r.elementType = i, r.type = p, r.lanes = w, r;
  }
  function nl(i, r, u, p) {
    return i = Ea(7, i, p, r), i.lanes = u, i;
  }
  function Yl(i, r, u, p) {
    return i = Ea(22, i, p, r), i.elementType = ot, i.lanes = u, i.stateNode = { isHidden: !1 }, i;
  }
  function Yg(i, r, u) {
    return i = Ea(6, i, null, r), i.lanes = u, i;
  }
  function wm(i, r, u) {
    return r = Ea(4, i.children !== null ? i.children : [], i.key, r), r.lanes = u, r.stateNode = { containerInfo: i.containerInfo, pendingChildren: null, implementation: i.implementation }, r;
  }
  function _E(i, r, u, p, g) {
    this.tag = r, this.containerInfo = i, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Fy(0), this.expirationTimes = Fy(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fy(0), this.identifierPrefix = p, this.onRecoverableError = g, this.mutableSourceEagerHydrationData = null;
  }
  function Em(i, r, u, p, g, w, k, O, P) {
    return i = new _E(i, r, u, O, P), r === 1 ? (r = 1, w === !0 && (r |= 8)) : r = 0, w = Ea(3, null, null, r), i.current = w, w.stateNode = i, w.memoizedState = { element: p, isDehydrated: u, cache: null, transitions: null, pendingSuspenseBoundaries: null }, bg(w), i;
  }
  function Tk(i, r, u) {
    var p = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: wt, key: p == null ? null : "" + p, children: i, containerInfo: r, implementation: u };
  }
  function Gg(i) {
    if (!i) return kr;
    i = i._reactInternals;
    e: {
      if (Va(i) !== i || i.tag !== 1) throw Error(n(170));
      var r = i;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (Wn(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(n(171));
    }
    if (i.tag === 1) {
      var u = i.type;
      if (Wn(u)) return ff(i, u, r);
    }
    return r;
  }
  function NE(i, r, u, p, g, w, k, O, P) {
    return i = Em(u, p, !0, i, g, w, k, O, P), i.context = Gg(null), u = i.current, p = ti(), g = Cs(u), w = Xs(p, g), w.callback = r ?? null, Fl(u, w, g), i.current.lanes = g, zo(i, g, p), Pr(i, p), i;
  }
  function bm(i, r, u, p) {
    var g = r.current, w = ti(), k = Cs(g);
    return u = Gg(u), r.context === null ? r.context = u : r.pendingContext = u, r = Xs(w, k), r.payload = { element: i }, p = p === void 0 ? null : p, p !== null && (r.callback = p), i = Fl(g, r, k), i !== null && (sr(i, g, k, w), qp(i, g, k)), k;
  }
  function Cm(i) {
    if (i = i.current, !i.child) return null;
    switch (i.child.tag) {
      case 5:
        return i.child.stateNode;
      default:
        return i.child.stateNode;
    }
  }
  function Wg(i, r) {
    if (i = i.memoizedState, i !== null && i.dehydrated !== null) {
      var u = i.retryLane;
      i.retryLane = u !== 0 && u < r ? u : r;
    }
  }
  function km(i, r) {
    Wg(i, r), (i = i.alternate) && Wg(i, r);
  }
  var Kg = typeof reportError == "function" ? reportError : function(i) {
    console.error(i);
  };
  function Gl(i) {
    this._internalRoot = i;
  }
  xm.prototype.render = Gl.prototype.render = function(i) {
    var r = this._internalRoot;
    if (r === null) throw Error(n(409));
    bm(i, r, null, null);
  }, xm.prototype.unmount = Gl.prototype.unmount = function() {
    var i = this._internalRoot;
    if (i !== null) {
      this._internalRoot = null;
      var r = i.containerInfo;
      fu(function() {
        bm(null, i, null, null);
      }), r[Ys] = null;
    }
  };
  function xm(i) {
    this._internalRoot = i;
  }
  xm.prototype.unstable_scheduleHydration = function(i) {
    if (i) {
      var r = nt();
      i = { blockedOn: null, target: i, priority: r };
      for (var u = 0; u < Ri.length && r !== 0 && r < Ri[u].priority; u++) ;
      Ri.splice(u, 0, i), u === 0 && By(i);
    }
  };
  function Xg(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11);
  }
  function Rm(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11 && (i.nodeType !== 8 || i.nodeValue !== " react-mount-point-unstable "));
  }
  function UE() {
  }
  function wk(i, r, u, p, g) {
    if (g) {
      if (typeof p == "function") {
        var w = p;
        p = function() {
          var j = Cm(k);
          w.call(j);
        };
      }
      var k = NE(r, p, i, 0, null, !1, !1, "", UE);
      return i._reactRootContainer = k, i[Ys] = k.current, yc(i.nodeType === 8 ? i.parentNode : i), fu(), k;
    }
    for (; g = i.lastChild; ) i.removeChild(g);
    if (typeof p == "function") {
      var O = p;
      p = function() {
        var j = Cm(P);
        O.call(j);
      };
    }
    var P = Em(i, 0, !1, null, null, !1, !1, "", UE);
    return i._reactRootContainer = P, i[Ys] = P.current, yc(i.nodeType === 8 ? i.parentNode : i), fu(function() {
      bm(r, P, u, p);
    }), P;
  }
  function Dm(i, r, u, p, g) {
    var w = u._reactRootContainer;
    if (w) {
      var k = w;
      if (typeof g == "function") {
        var O = g;
        g = function() {
          var P = Cm(k);
          O.call(P);
        };
      }
      bm(r, k, i, g);
    } else k = wk(u, r, i, g, p);
    return Cm(k);
  }
  Zt = function(i) {
    switch (i.tag) {
      case 3:
        var r = i.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var u = No(r.pendingLanes);
          u !== 0 && (fp(r, u | 1), Pr(r, sn()), !(Ct & 6) && ($c = sn() + 500, vs()));
        }
        break;
      case 13:
        fu(function() {
          var p = Yr(i, 1);
          if (p !== null) {
            var g = ti();
            sr(p, i, 1, g);
          }
        }), km(i, 1);
    }
  }, Hy = function(i) {
    if (i.tag === 13) {
      var r = Yr(i, 134217728);
      if (r !== null) {
        var u = ti();
        sr(r, i, 134217728, u);
      }
      km(i, 134217728);
    }
  }, Iy = function(i) {
    if (i.tag === 13) {
      var r = Cs(i), u = Yr(i, r);
      if (u !== null) {
        var p = ti();
        sr(u, i, r, p);
      }
      km(i, r);
    }
  }, nt = function() {
    return Xt;
  }, qy = function(i, r) {
    var u = Xt;
    try {
      return Xt = i, r();
    } finally {
      Xt = u;
    }
  }, oi = function(i, r, u) {
    switch (r) {
      case "input":
        if (nc(i, u), r = u.name, u.type === "radio" && r != null) {
          for (u = i; u.parentNode; ) u = u.parentNode;
          for (u = u.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < u.length; r++) {
            var p = u[r];
            if (p !== i && p.form === i.form) {
              var g = Un(p);
              if (!g) throw Error(n(90));
              er(p), nc(p, g);
            }
          }
        }
        break;
      case "textarea":
        ic(i, u);
        break;
      case "select":
        r = u.value, r != null && qr(i, !!u.multiple, r, !1);
    }
  }, My = qg, Ly = fu;
  var zE = { usingClientEntryPoint: !1, Events: [Pe, ja, Un, pw, mw, qg] }, jf = { findFiberByHostInstance: Go, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Ek = { bundleType: jf.bundleType, version: jf.version, rendererPackageName: jf.rendererPackageName, rendererConfig: jf.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ct.ReactCurrentDispatcher, findHostInstanceByFiber: function(i) {
    return i = Ay(i), i === null ? null : i.stateNode;
  }, findFiberByHostInstance: jf.findFiberByHostInstance, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Bf = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Bf.isDisabled && Bf.supportsFiber) try {
      Yd = Bf.inject(Ek), Ha = Bf;
    } catch {
    }
  }
  return Da.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = zE, Da.createPortal = function(i, r) {
    var u = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Xg(r)) throw Error(n(200));
    return Tk(i, r, null, u);
  }, Da.createRoot = function(i, r) {
    if (!Xg(i)) throw Error(n(299));
    var u = !1, p = "", g = Kg;
    return r != null && (r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (p = r.identifierPrefix), r.onRecoverableError !== void 0 && (g = r.onRecoverableError)), r = Em(i, 1, !1, null, null, u, !1, p, g), i[Ys] = r.current, yc(i.nodeType === 8 ? i.parentNode : i), new Gl(r);
  }, Da.findDOMNode = function(i) {
    if (i == null) return null;
    if (i.nodeType === 1) return i;
    var r = i._reactInternals;
    if (r === void 0)
      throw typeof i.render == "function" ? Error(n(188)) : (i = Object.keys(i).join(","), Error(n(268, i)));
    return i = Ay(r), i = i === null ? null : i.stateNode, i;
  }, Da.flushSync = function(i) {
    return fu(i);
  }, Da.hydrate = function(i, r, u) {
    if (!Rm(r)) throw Error(n(200));
    return Dm(null, i, r, !0, u);
  }, Da.hydrateRoot = function(i, r, u) {
    if (!Xg(i)) throw Error(n(405));
    var p = u != null && u.hydratedSources || null, g = !1, w = "", k = Kg;
    if (u != null && (u.unstable_strictMode === !0 && (g = !0), u.identifierPrefix !== void 0 && (w = u.identifierPrefix), u.onRecoverableError !== void 0 && (k = u.onRecoverableError)), r = NE(r, null, i, 1, u ?? null, g, !1, w, k), i[Ys] = r.current, yc(i), p) for (i = 0; i < p.length; i++) u = p[i], g = u._getVersion, g = g(u._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [u, g] : r.mutableSourceEagerHydrationData.push(
      u,
      g
    );
    return new xm(r);
  }, Da.render = function(i, r, u) {
    if (!Rm(r)) throw Error(n(200));
    return Dm(null, i, r, !1, u);
  }, Da.unmountComponentAtNode = function(i) {
    if (!Rm(i)) throw Error(n(40));
    return i._reactRootContainer ? (fu(function() {
      Dm(null, null, i, !1, function() {
        i._reactRootContainer = null, i[Ys] = null;
      });
    }), !0) : !1;
  }, Da.unstable_batchedUpdates = qg, Da.unstable_renderSubtreeIntoContainer = function(i, r, u, p) {
    if (!Rm(u)) throw Error(n(200));
    if (i == null || i._reactInternals === void 0) throw Error(n(38));
    return Dm(i, r, u, !1, p);
  }, Da.version = "18.3.1-next-f1338f8080-20240426", Da;
}
var Ma = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hP;
function rQ() {
  return hP || (hP = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var f = DP, s = uV(), n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = !1;
    function h(e) {
      o = e;
    }
    function v(e) {
      if (!o) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++)
          a[l - 1] = arguments[l];
        C("warn", e, a);
      }
    }
    function y(e) {
      if (!o) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++)
          a[l - 1] = arguments[l];
        C("error", e, a);
      }
    }
    function C(e, t, a) {
      {
        var l = n.ReactDebugCurrentFrame, c = l.getStackAddendum();
        c !== "" && (t += "%s", a = a.concat([c]));
        var m = a.map(function(T) {
          return String(T);
        });
        m.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, m);
      }
    }
    var D = 0, $ = 1, _ = 2, A = 3, B = 4, W = 5, ne = 6, ce = 7, Re = 8, Lt = 9, $t = 10, Ve = 11, ct = 12, Ye = 13, wt = 14, He = 15, de = 16, Ge = 17, ft = 18, Kt = 19, Mt = 21, Ae = 22, Et = 23, Sn = 24, Je = 25, ot = !0, oe = !1, Le = !1, he = !1, gt = !1, Nt = !0, Ii = !0, Bn = !0, oa = !0, ai = /* @__PURE__ */ new Set(), si = {}, Ci = {};
    function li(e, t) {
      ki(e, t), ki(e + "Capture", t);
    }
    function ki(e, t) {
      si[e] && y("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), si[e] = t;
      {
        var a = e.toLowerCase();
        Ci[a] = e, e === "onDoubleClick" && (Ci.ondblclick = e);
      }
      for (var l = 0; l < t.length; l++)
        ai.add(t[l]);
    }
    var Nn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", er = Object.prototype.hasOwnProperty;
    function gi(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, a = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function xi(e) {
      try {
        return tr(e), !1;
      } catch {
        return !0;
      }
    }
    function tr(e) {
      return "" + e;
    }
    function Ir(e, t) {
      if (xi(e))
        return y("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, gi(e)), tr(e);
    }
    function nc(e) {
      if (xi(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gi(e)), tr(e);
    }
    function Id(e, t) {
      if (xi(e))
        return y("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, gi(e)), tr(e);
    }
    function qd(e, t) {
      if (xi(e))
        return y("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, gi(e)), tr(e);
    }
    function Lo(e) {
      if (xi(e))
        return y("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", gi(e)), tr(e);
    }
    function qr(e) {
      if (xi(e))
        return y("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", gi(e)), tr(e);
    }
    var ua = 0, za = 1, ic = 2, jr = 3, ds = 4, $o = 5, Oo = 6, jd = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", pe = jd + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ze = new RegExp("^[" + jd + "][" + pe + "]*$"), pt = {}, an = {};
    function Ln(e) {
      return er.call(an, e) ? !0 : er.call(pt, e) ? !1 : ze.test(e) ? (an[e] = !0, !0) : (pt[e] = !0, y("Invalid attribute name: `%s`", e), !1);
    }
    function wr(e, t, a) {
      return t !== null ? t.type === ua : a ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function Qn(e, t, a, l) {
      if (a !== null && a.type === ua)
        return !1;
      switch (typeof t) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (l)
            return !1;
          if (a !== null)
            return !a.acceptsBooleans;
          var c = e.toLowerCase().slice(0, 5);
          return c !== "data-" && c !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Er(e, t, a, l) {
      if (t === null || typeof t > "u" || Qn(e, t, a, l))
        return !0;
      if (l)
        return !1;
      if (a !== null)
        switch (a.type) {
          case jr:
            return !t;
          case ds:
            return t === !1;
          case $o:
            return isNaN(t);
          case Oo:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function Yn(e) {
      return oi.hasOwnProperty(e) ? oi[e] : null;
    }
    function $n(e, t, a, l, c, m, T) {
      this.acceptsBooleans = t === ic || t === jr || t === ds, this.attributeName = l, this.attributeNamespace = c, this.mustUseProperty = a, this.propertyName = e, this.type = t, this.sanitizeURL = m, this.removeEmptyString = T;
    }
    var oi = {}, rc = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    rc.forEach(function(e) {
      oi[e] = new $n(
        e,
        ua,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], a = e[1];
      oi[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      oi[e] = new $n(
        e,
        ic,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      oi[e] = new $n(
        e,
        ic,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      oi[e] = new $n(
        e,
        jr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      oi[e] = new $n(
        e,
        jr,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      oi[e] = new $n(
        e,
        ds,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      oi[e] = new $n(
        e,
        Oo,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      oi[e] = new $n(
        e,
        $o,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var kl = /[\-\:]([a-z])/g, op = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(kl, op);
      oi[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(kl, op);
      oi[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(kl, op);
      oi[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      oi[e] = new $n(
        e,
        za,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var pw = "xlinkHref";
    oi[pw] = new $n(
      "xlinkHref",
      za,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      oi[e] = new $n(
        e,
        za,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var mw = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, My = !1;
    function Ly(e) {
      !My && mw.test(e) && (My = !0, y("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function $y(e, t, a, l) {
      if (l.mustUseProperty) {
        var c = l.propertyName;
        return e[c];
      } else {
        Ir(a, t), l.sanitizeURL && Ly("" + a);
        var m = l.attributeName, T = null;
        if (l.type === ds) {
          if (e.hasAttribute(m)) {
            var E = e.getAttribute(m);
            return E === "" ? !0 : Er(t, a, l, !1) ? E : E === "" + a ? a : E;
          }
        } else if (e.hasAttribute(m)) {
          if (Er(t, a, l, !1))
            return e.getAttribute(m);
          if (l.type === jr)
            return a;
          T = e.getAttribute(m);
        }
        return Er(t, a, l, !1) ? T === null ? a : T : T === "" + a ? a : T;
      }
    }
    function Oy(e, t, a, l) {
      {
        if (!Ln(t))
          return;
        if (!e.hasAttribute(t))
          return a === void 0 ? void 0 : null;
        var c = e.getAttribute(t);
        return Ir(a, t), c === "" + a ? a : c;
      }
    }
    function Ao(e, t, a, l) {
      var c = Yn(t);
      if (!wr(t, c, l)) {
        if (Er(t, a, c, l) && (a = null), l || c === null) {
          if (Ln(t)) {
            var m = t;
            a === null ? e.removeAttribute(m) : (Ir(a, t), e.setAttribute(m, "" + a));
          }
          return;
        }
        var T = c.mustUseProperty;
        if (T) {
          var E = c.propertyName;
          if (a === null) {
            var b = c.type;
            e[E] = b === jr ? !1 : "";
          } else
            e[E] = a;
          return;
        }
        var x = c.attributeName, M = c.attributeNamespace;
        if (a === null)
          e.removeAttribute(x);
        else {
          var z = c.type, N;
          z === jr || z === ds && a === !0 ? N = "" : (Ir(a, x), N = "" + a, c.sanitizeURL && Ly(N.toString())), M ? e.setAttributeNS(M, x, N) : e.setAttribute(x, N);
        }
      }
    }
    var xl = Symbol.for("react.element"), Fa = Symbol.for("react.portal"), ac = Symbol.for("react.fragment"), Po = Symbol.for("react.strict_mode"), sc = Symbol.for("react.profiler"), lc = Symbol.for("react.provider"), Bd = Symbol.for("react.context"), oc = Symbol.for("react.forward_ref"), up = Symbol.for("react.suspense"), cp = Symbol.for("react.suspense_list"), Va = Symbol.for("react.memo"), qi = Symbol.for("react.lazy"), vw = Symbol.for("react.scope"), F0 = Symbol.for("react.debug_trace_mode"), Ay = Symbol.for("react.offscreen"), yw = Symbol.for("react.legacy_hidden"), gw = Symbol.for("react.cache"), Sw = Symbol.for("react.tracing_marker"), Tw = Symbol.iterator, V0 = "@@iterator";
    function sn(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Tw && e[Tw] || e[V0];
      return typeof t == "function" ? t : null;
    }
    var St = Object.assign, _o = 0, Py, Qd, ww, _y, Yd, Ha, Ew;
    function ca() {
    }
    ca.__reactDisabledLog = !0;
    function H0() {
      {
        if (_o === 0) {
          Py = console.log, Qd = console.info, ww = console.warn, _y = console.error, Yd = console.group, Ha = console.groupCollapsed, Ew = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ca,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        _o++;
      }
    }
    function I0() {
      {
        if (_o--, _o === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: St({}, e, {
              value: Py
            }),
            info: St({}, e, {
              value: Qd
            }),
            warn: St({}, e, {
              value: ww
            }),
            error: St({}, e, {
              value: _y
            }),
            group: St({}, e, {
              value: Yd
            }),
            groupCollapsed: St({}, e, {
              value: Ha
            }),
            groupEnd: St({}, e, {
              value: Ew
            })
          });
        }
        _o < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ny = n.ReactCurrentDispatcher, uc;
    function Ia(e, t, a) {
      {
        if (uc === void 0)
          try {
            throw Error();
          } catch (c) {
            var l = c.stack.trim().match(/\n( *(at )?)/);
            uc = l && l[1] || "";
          }
        return `
` + uc + e;
      }
    }
    var No = !1, Uo;
    {
      var q0 = typeof WeakMap == "function" ? WeakMap : Map;
      Uo = new q0();
    }
    function Uy(e, t) {
      if (!e || No)
        return "";
      {
        var a = Uo.get(e);
        if (a !== void 0)
          return a;
      }
      var l;
      No = !0;
      var c = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = Ny.current, Ny.current = null, H0();
      try {
        if (t) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (Q) {
              l = Q;
            }
            Reflect.construct(e, [], T);
          } else {
            try {
              T.call();
            } catch (Q) {
              l = Q;
            }
            e.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            l = Q;
          }
          e();
        }
      } catch (Q) {
        if (Q && l && typeof Q.stack == "string") {
          for (var E = Q.stack.split(`
`), b = l.stack.split(`
`), x = E.length - 1, M = b.length - 1; x >= 1 && M >= 0 && E[x] !== b[M]; )
            M--;
          for (; x >= 1 && M >= 0; x--, M--)
            if (E[x] !== b[M]) {
              if (x !== 1 || M !== 1)
                do
                  if (x--, M--, M < 0 || E[x] !== b[M]) {
                    var z = `
` + E[x].replace(" at new ", " at ");
                    return e.displayName && z.includes("<anonymous>") && (z = z.replace("<anonymous>", e.displayName)), typeof e == "function" && Uo.set(e, z), z;
                  }
                while (x >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        No = !1, Ny.current = m, I0(), Error.prepareStackTrace = c;
      }
      var N = e ? e.displayName || e.name : "", q = N ? Ia(N) : "";
      return typeof e == "function" && Uo.set(e, q), q;
    }
    function zy(e, t, a) {
      return Uy(e, !0);
    }
    function dp(e, t, a) {
      return Uy(e, !1);
    }
    function Fy(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function zo(e, t, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Uy(e, Fy(e));
      if (typeof e == "string")
        return Ia(e);
      switch (e) {
        case up:
          return Ia("Suspense");
        case cp:
          return Ia("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case oc:
            return dp(e.render);
          case Va:
            return zo(e.type, t, a);
          case qi: {
            var l = e, c = l._payload, m = l._init;
            try {
              return zo(m(c), t, a);
            } catch {
            }
          }
        }
      return "";
    }
    function j0(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case W:
          return Ia(e.type);
        case de:
          return Ia("Lazy");
        case Ye:
          return Ia("Suspense");
        case Kt:
          return Ia("SuspenseList");
        case D:
        case _:
        case He:
          return dp(e.type);
        case Ve:
          return dp(e.type.render);
        case $:
          return zy(e.type);
        default:
          return "";
      }
    }
    function fp(e) {
      try {
        var t = "", a = e;
        do
          t += j0(a), a = a.return;
        while (a);
        return t;
      } catch (l) {
        return `
Error generating stack: ` + l.message + `
` + l.stack;
      }
    }
    function Xt(e, t, a) {
      var l = e.displayName;
      if (l)
        return l;
      var c = t.displayName || t.name || "";
      return c !== "" ? a + "(" + c + ")" : a;
    }
    function Vy(e) {
      return e.displayName || "Context";
    }
    function Zt(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case ac:
          return "Fragment";
        case Fa:
          return "Portal";
        case sc:
          return "Profiler";
        case Po:
          return "StrictMode";
        case up:
          return "Suspense";
        case cp:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Bd:
            var t = e;
            return Vy(t) + ".Consumer";
          case lc:
            var a = e;
            return Vy(a._context) + ".Provider";
          case oc:
            return Xt(e, e.render, "ForwardRef");
          case Va:
            var l = e.displayName || null;
            return l !== null ? l : Zt(e.type) || "Memo";
          case qi: {
            var c = e, m = c._payload, T = c._init;
            try {
              return Zt(T(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Hy(e, t, a) {
      var l = t.displayName || t.name || "";
      return e.displayName || (l !== "" ? a + "(" + l + ")" : a);
    }
    function Iy(e) {
      return e.displayName || "Context";
    }
    function nt(e) {
      var t = e.tag, a = e.type;
      switch (t) {
        case Sn:
          return "Cache";
        case Lt:
          var l = a;
          return Iy(l) + ".Consumer";
        case $t:
          var c = a;
          return Iy(c._context) + ".Provider";
        case ft:
          return "DehydratedFragment";
        case Ve:
          return Hy(a, a.render, "ForwardRef");
        case ce:
          return "Fragment";
        case W:
          return a;
        case B:
          return "Portal";
        case A:
          return "Root";
        case ne:
          return "Text";
        case de:
          return Zt(a);
        case Re:
          return a === Po ? "StrictMode" : "Mode";
        case Ae:
          return "Offscreen";
        case ct:
          return "Profiler";
        case Mt:
          return "Scope";
        case Ye:
          return "Suspense";
        case Kt:
          return "SuspenseList";
        case Je:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case $:
        case D:
        case Ge:
        case _:
        case wt:
        case He:
          if (typeof a == "function")
            return a.displayName || a.name || null;
          if (typeof a == "string")
            return a;
          break;
      }
      return null;
    }
    var qy = n.ReactDebugCurrentFrame, nr = null, Rl = !1;
    function da() {
      {
        if (nr === null)
          return null;
        var e = nr._debugOwner;
        if (e !== null && typeof e < "u")
          return nt(e);
      }
      return null;
    }
    function Dl() {
      return nr === null ? "" : fp(nr);
    }
    function On() {
      qy.getCurrentStack = null, nr = null, Rl = !1;
    }
    function pn(e) {
      qy.getCurrentStack = e === null ? null : Dl, nr = e, Rl = !1;
    }
    function Gd() {
      return nr;
    }
    function Ri(e) {
      Rl = e;
    }
    function fa(e) {
      return "" + e;
    }
    function Is(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return qr(e), e;
        default:
          return "";
      }
    }
    var Wd = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function jy(e, t) {
      Wd[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || y("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || y("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function By(e) {
      var t = e.type, a = e.nodeName;
      return a && a.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function Kd(e) {
      return e._valueTracker;
    }
    function bw(e) {
      e._valueTracker = null;
    }
    function B0(e) {
      var t = "";
      return e && (By(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function Xd(e) {
      var t = By(e) ? "checked" : "value", a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      qr(e[t]);
      var l = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof a > "u" || typeof a.get != "function" || typeof a.set != "function")) {
        var c = a.get, m = a.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return c.call(this);
          },
          set: function(E) {
            qr(E), l = "" + E, m.call(this, E);
          }
        }), Object.defineProperty(e, t, {
          enumerable: a.enumerable
        });
        var T = {
          getValue: function() {
            return l;
          },
          setValue: function(E) {
            qr(E), l = "" + E;
          },
          stopTracking: function() {
            bw(e), delete e[t];
          }
        };
        return T;
      }
    }
    function Ml(e) {
      Kd(e) || (e._valueTracker = Xd(e));
    }
    function Fo(e) {
      if (!e)
        return !1;
      var t = Kd(e);
      if (!t)
        return !0;
      var a = t.getValue(), l = B0(e);
      return l !== a ? (t.setValue(l), !0) : !1;
    }
    function Vo(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var Cw = !1, kw = !1, hp = !1, Zd = !1;
    function pp(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function mp(e, t) {
      var a = e, l = t.checked, c = St({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: l ?? a._wrapperState.initialChecked
      });
      return c;
    }
    function qs(e, t) {
      jy("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !kw && (y("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", da() || "A component", t.type), kw = !0), t.value !== void 0 && t.defaultValue !== void 0 && !Cw && (y("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", da() || "A component", t.type), Cw = !0);
      var a = e, l = t.defaultValue == null ? "" : t.defaultValue;
      a._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: Is(t.value != null ? t.value : l),
        controlled: pp(t)
      };
    }
    function vp(e, t) {
      var a = e, l = t.checked;
      l != null && Ao(a, "checked", l, !1);
    }
    function cc(e, t) {
      var a = e;
      {
        var l = pp(t);
        !a._wrapperState.controlled && l && !Zd && (y("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Zd = !0), a._wrapperState.controlled && !l && !hp && (y("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), hp = !0);
      }
      vp(e, t);
      var c = Is(t.value), m = t.type;
      if (c != null)
        m === "number" ? (c === 0 && a.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        a.value != c) && (a.value = fa(c)) : a.value !== fa(c) && (a.value = fa(c));
      else if (m === "submit" || m === "reset") {
        a.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? Sp(a, t.type, c) : t.hasOwnProperty("defaultValue") && Sp(a, t.type, Is(t.defaultValue)), t.checked == null && t.defaultChecked != null && (a.defaultChecked = !!t.defaultChecked);
    }
    function Qy(e, t, a) {
      var l = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var c = t.type, m = c === "submit" || c === "reset";
        if (m && (t.value === void 0 || t.value === null))
          return;
        var T = fa(l._wrapperState.initialValue);
        a || T !== l.value && (l.value = T), l.defaultValue = T;
      }
      var E = l.name;
      E !== "" && (l.name = ""), l.defaultChecked = !l.defaultChecked, l.defaultChecked = !!l._wrapperState.initialChecked, E !== "" && (l.name = E);
    }
    function yp(e, t) {
      var a = e;
      cc(a, t), gp(a, t);
    }
    function gp(e, t) {
      var a = t.name;
      if (t.type === "radio" && a != null) {
        for (var l = e; l.parentNode; )
          l = l.parentNode;
        Ir(a, "name");
        for (var c = l.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), m = 0; m < c.length; m++) {
          var T = c[m];
          if (!(T === e || T.form !== e.form)) {
            var E = tb(T);
            if (!E)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Fo(T), cc(T, E);
          }
        }
      }
    }
    function Sp(e, t, a) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (t !== "number" || Vo(e.ownerDocument) !== e) && (a == null ? e.defaultValue = fa(e._wrapperState.initialValue) : e.defaultValue !== fa(a) && (e.defaultValue = fa(a)));
    }
    var br = !1, Ho = !1, Tp = !1;
    function dc(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? f.Children.forEach(t.children, function(a) {
        a != null && (typeof a == "string" || typeof a == "number" || Ho || (Ho = !0, y("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (Tp || (Tp = !0, y("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !br && (y("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), br = !0);
    }
    function Q0(e, t) {
      t.value != null && e.setAttribute("value", fa(Is(t.value)));
    }
    var Yy = Array.isArray;
    function Di(e) {
      return Yy(e);
    }
    var Io;
    Io = !1;
    function Jd() {
      var e = da();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var Gy = ["value", "defaultValue"];
    function Y0(e) {
      {
        jy("select", e);
        for (var t = 0; t < Gy.length; t++) {
          var a = Gy[t];
          if (e[a] != null) {
            var l = Di(e[a]);
            e.multiple && !l ? y("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", a, Jd()) : !e.multiple && l && y("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", a, Jd());
          }
        }
      }
    }
    function fc(e, t, a, l) {
      var c = e.options;
      if (t) {
        for (var m = a, T = {}, E = 0; E < m.length; E++)
          T["$" + m[E]] = !0;
        for (var b = 0; b < c.length; b++) {
          var x = T.hasOwnProperty("$" + c[b].value);
          c[b].selected !== x && (c[b].selected = x), x && l && (c[b].defaultSelected = !0);
        }
      } else {
        for (var M = fa(Is(a)), z = null, N = 0; N < c.length; N++) {
          if (c[N].value === M) {
            c[N].selected = !0, l && (c[N].defaultSelected = !0);
            return;
          }
          z === null && !c[N].disabled && (z = c[N]);
        }
        z !== null && (z.selected = !0);
      }
    }
    function Wy(e, t) {
      return St({}, t, {
        value: void 0
      });
    }
    function wp(e, t) {
      var a = e;
      Y0(t), a._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !Io && (y("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Io = !0);
    }
    function G0(e, t) {
      var a = e;
      a.multiple = !!t.multiple;
      var l = t.value;
      l != null ? fc(a, !!t.multiple, l, !1) : t.defaultValue != null && fc(a, !!t.multiple, t.defaultValue, !0);
    }
    function W0(e, t) {
      var a = e, l = a._wrapperState.wasMultiple;
      a._wrapperState.wasMultiple = !!t.multiple;
      var c = t.value;
      c != null ? fc(a, !!t.multiple, c, !1) : l !== !!t.multiple && (t.defaultValue != null ? fc(a, !!t.multiple, t.defaultValue, !0) : fc(a, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function K0(e, t) {
      var a = e, l = t.value;
      l != null && fc(a, !!t.multiple, l, !1);
    }
    var xw = !1;
    function Ky(e, t) {
      var a = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var l = St({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: fa(a._wrapperState.initialValue)
      });
      return l;
    }
    function Xy(e, t) {
      var a = e;
      jy("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !xw && (y("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", da() || "A component"), xw = !0);
      var l = t.value;
      if (l == null) {
        var c = t.children, m = t.defaultValue;
        if (c != null) {
          y("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (m != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Di(c)) {
              if (c.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              c = c[0];
            }
            m = c;
          }
        }
        m == null && (m = ""), l = m;
      }
      a._wrapperState = {
        initialValue: Is(l)
      };
    }
    function Rw(e, t) {
      var a = e, l = Is(t.value), c = Is(t.defaultValue);
      if (l != null) {
        var m = fa(l);
        m !== a.value && (a.value = m), t.defaultValue == null && a.defaultValue !== m && (a.defaultValue = m);
      }
      c != null && (a.defaultValue = fa(c));
    }
    function Dw(e, t) {
      var a = e, l = a.textContent;
      l === a._wrapperState.initialValue && l !== "" && l !== null && (a.value = l);
    }
    function X0(e, t) {
      Rw(e, t);
    }
    var js = "http://www.w3.org/1999/xhtml", Zy = "http://www.w3.org/1998/Math/MathML", Jy = "http://www.w3.org/2000/svg";
    function eg(e) {
      switch (e) {
        case "svg":
          return Jy;
        case "math":
          return Zy;
        default:
          return js;
      }
    }
    function tg(e, t) {
      return e == null || e === js ? eg(t) : e === Jy && t === "foreignObject" ? js : e;
    }
    var Mw = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, a, l, c) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, a, l, c);
        });
      } : e;
    }, Ep, Lw = Mw(function(e, t) {
      if (e.namespaceURI === Jy && !("innerHTML" in e)) {
        Ep = Ep || document.createElement("div"), Ep.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var a = Ep.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; a.firstChild; )
          e.appendChild(a.firstChild);
        return;
      }
      e.innerHTML = t;
    }), Cr = 1, Bs = 3, Gn = 8, Qs = 9, ng = 11, hc = function(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === Bs) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, ef = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, tf = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function $w(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var Ow = ["Webkit", "ms", "Moz", "O"];
    Object.keys(tf).forEach(function(e) {
      Ow.forEach(function(t) {
        tf[$w(t, e)] = tf[e];
      });
    });
    function bp(e, t, a) {
      var l = t == null || typeof t == "boolean" || t === "";
      return l ? "" : !a && typeof t == "number" && t !== 0 && !(tf.hasOwnProperty(e) && tf[e]) ? t + "px" : (qd(t, e), ("" + t).trim());
    }
    var Aw = /([A-Z])/g, Pw = /^ms-/;
    function pc(e) {
      return e.replace(Aw, "-$1").toLowerCase().replace(Pw, "-ms-");
    }
    var _w = function() {
    };
    {
      var Z0 = /^(?:webkit|moz|o)[A-Z]/, J0 = /^-ms-/, Nw = /-(.)/g, ig = /;\s*$/, fs = {}, qo = {}, Uw = !1, nf = !1, ek = function(e) {
        return e.replace(Nw, function(t, a) {
          return a.toUpperCase();
        });
      }, zw = function(e) {
        fs.hasOwnProperty(e) && fs[e] || (fs[e] = !0, y(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          ek(e.replace(J0, "ms-"))
        ));
      }, rg = function(e) {
        fs.hasOwnProperty(e) && fs[e] || (fs[e] = !0, y("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, ag = function(e, t) {
        qo.hasOwnProperty(t) && qo[t] || (qo[t] = !0, y(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(ig, "")));
      }, Fw = function(e, t) {
        Uw || (Uw = !0, y("`NaN` is an invalid value for the `%s` css style property.", e));
      }, Vw = function(e, t) {
        nf || (nf = !0, y("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      _w = function(e, t) {
        e.indexOf("-") > -1 ? zw(e) : Z0.test(e) ? rg(e) : ig.test(t) && ag(e, t), typeof t == "number" && (isNaN(t) ? Fw(e, t) : isFinite(t) || Vw(e, t));
      };
    }
    var Hw = _w;
    function tk(e) {
      {
        var t = "", a = "";
        for (var l in e)
          if (e.hasOwnProperty(l)) {
            var c = e[l];
            if (c != null) {
              var m = l.indexOf("--") === 0;
              t += a + (m ? l : pc(l)) + ":", t += bp(l, c, m), a = ";";
            }
          }
        return t || null;
      }
    }
    function Iw(e, t) {
      var a = e.style;
      for (var l in t)
        if (t.hasOwnProperty(l)) {
          var c = l.indexOf("--") === 0;
          c || Hw(l, t[l]);
          var m = bp(l, t[l], c);
          l === "float" && (l = "cssFloat"), c ? a.setProperty(l, m) : a[l] = m;
        }
    }
    function nk(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function qw(e) {
      var t = {};
      for (var a in e)
        for (var l = ef[a] || [a], c = 0; c < l.length; c++)
          t[l[c]] = a;
      return t;
    }
    function ik(e, t) {
      {
        if (!t)
          return;
        var a = qw(e), l = qw(t), c = {};
        for (var m in a) {
          var T = a[m], E = l[m];
          if (E && T !== E) {
            var b = T + "," + E;
            if (c[b])
              continue;
            c[b] = !0, y("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", nk(e[T]) ? "Removing" : "Updating", T, E);
          }
        }
      }
    }
    var qa = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, rf = St({
      menuitem: !0
    }, qa), jw = "__html";
    function Cp(e, t) {
      if (t) {
        if (rf[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(jw in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && y("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Ll(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var af = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, kp = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, mc = {}, rk = new RegExp("^(aria)-[" + pe + "]*$"), vc = new RegExp("^(aria)[A-Z][" + pe + "]*$");
    function sg(e, t) {
      {
        if (er.call(mc, t) && mc[t])
          return !0;
        if (vc.test(t)) {
          var a = "aria-" + t.slice(4).toLowerCase(), l = kp.hasOwnProperty(a) ? a : null;
          if (l == null)
            return y("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), mc[t] = !0, !0;
          if (t !== l)
            return y("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, l), mc[t] = !0, !0;
        }
        if (rk.test(t)) {
          var c = t.toLowerCase(), m = kp.hasOwnProperty(c) ? c : null;
          if (m == null)
            return mc[t] = !0, !1;
          if (t !== m)
            return y("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, m), mc[t] = !0, !0;
        }
      }
      return !0;
    }
    function sf(e, t) {
      {
        var a = [];
        for (var l in t) {
          var c = sg(e, l);
          c || a.push(l);
        }
        var m = a.map(function(T) {
          return "`" + T + "`";
        }).join(", ");
        a.length === 1 ? y("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", m, e) : a.length > 1 && y("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", m, e);
      }
    }
    function lg(e, t) {
      Ll(e, t) || sf(e, t);
    }
    var og = !1;
    function xp(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !og && (og = !0, e === "select" && t.multiple ? y("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : y("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var jo = function() {
    };
    {
      var Mi = {}, ug = /^on./, Rp = /^on[^A-Z]/, Bw = new RegExp("^(aria)-[" + pe + "]*$"), Qw = new RegExp("^(aria)[A-Z][" + pe + "]*$");
      jo = function(e, t, a, l) {
        if (er.call(Mi, t) && Mi[t])
          return !0;
        var c = t.toLowerCase();
        if (c === "onfocusin" || c === "onfocusout")
          return y("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Mi[t] = !0, !0;
        if (l != null) {
          var m = l.registrationNameDependencies, T = l.possibleRegistrationNames;
          if (m.hasOwnProperty(t))
            return !0;
          var E = T.hasOwnProperty(c) ? T[c] : null;
          if (E != null)
            return y("Invalid event handler property `%s`. Did you mean `%s`?", t, E), Mi[t] = !0, !0;
          if (ug.test(t))
            return y("Unknown event handler property `%s`. It will be ignored.", t), Mi[t] = !0, !0;
        } else if (ug.test(t))
          return Rp.test(t) && y("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), Mi[t] = !0, !0;
        if (Bw.test(t) || Qw.test(t))
          return !0;
        if (c === "innerhtml")
          return y("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Mi[t] = !0, !0;
        if (c === "aria")
          return y("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Mi[t] = !0, !0;
        if (c === "is" && a !== null && a !== void 0 && typeof a != "string")
          return y("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof a), Mi[t] = !0, !0;
        if (typeof a == "number" && isNaN(a))
          return y("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), Mi[t] = !0, !0;
        var b = Yn(t), x = b !== null && b.type === ua;
        if (af.hasOwnProperty(c)) {
          var M = af[c];
          if (M !== t)
            return y("Invalid DOM property `%s`. Did you mean `%s`?", t, M), Mi[t] = !0, !0;
        } else if (!x && t !== c)
          return y("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, c), Mi[t] = !0, !0;
        return typeof a == "boolean" && Qn(t, a, b, !1) ? (a ? y('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', a, t, t, a, t) : y('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', a, t, t, a, t, t, t), Mi[t] = !0, !0) : x ? !0 : Qn(t, a, b, !1) ? (Mi[t] = !0, !1) : ((a === "false" || a === "true") && b !== null && b.type === jr && (y("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", a, t, a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, a), Mi[t] = !0), !0);
      };
    }
    var Yw = function(e, t, a) {
      {
        var l = [];
        for (var c in t) {
          var m = jo(e, c, t[c], a);
          m || l.push(c);
        }
        var T = l.map(function(E) {
          return "`" + E + "`";
        }).join(", ");
        l.length === 1 ? y("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", T, e) : l.length > 1 && y("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", T, e);
      }
    };
    function Gw(e, t, a) {
      Ll(e, t) || Yw(e, t, a);
    }
    var cg = 1, Dp = 2, ha = 4, dg = cg | Dp | ha, Bo = null;
    function ak(e) {
      Bo !== null && y("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Bo = e;
    }
    function sk() {
      Bo === null && y("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Bo = null;
    }
    function lf(e) {
      return e === Bo;
    }
    function fg(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === Bs ? t.parentNode : t;
    }
    var Mp = null, Qo = null, Yt = null;
    function Lp(e) {
      var t = Uc(e);
      if (t) {
        if (typeof Mp != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var a = t.stateNode;
        if (a) {
          var l = tb(a);
          Mp(t.stateNode, t.type, l);
        }
      }
    }
    function $p(e) {
      Mp = e;
    }
    function yc(e) {
      Qo ? Yt ? Yt.push(e) : Yt = [e] : Qo = e;
    }
    function Ww() {
      return Qo !== null || Yt !== null;
    }
    function Op() {
      if (Qo) {
        var e = Qo, t = Yt;
        if (Qo = null, Yt = null, Lp(e), t)
          for (var a = 0; a < t.length; a++)
            Lp(t[a]);
      }
    }
    var gc = function(e, t) {
      return e(t);
    }, of = function() {
    }, $l = !1;
    function Kw() {
      var e = Ww();
      e && (of(), Op());
    }
    function Xw(e, t, a) {
      if ($l)
        return e(t, a);
      $l = !0;
      try {
        return gc(e, t, a);
      } finally {
        $l = !1, Kw();
      }
    }
    function lk(e, t, a) {
      gc = e, of = a;
    }
    function Zw(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function Ap(e, t, a) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(a.disabled && Zw(t));
        default:
          return !1;
      }
    }
    function Ol(e, t) {
      var a = e.stateNode;
      if (a === null)
        return null;
      var l = tb(a);
      if (l === null)
        return null;
      var c = l[t];
      if (Ap(t, e.type, l))
        return null;
      if (c && typeof c != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof c + "` type.");
      return c;
    }
    var uf = !1;
    if (Nn)
      try {
        var Yo = {};
        Object.defineProperty(Yo, "passive", {
          get: function() {
            uf = !0;
          }
        }), window.addEventListener("test", Yo, Yo), window.removeEventListener("test", Yo, Yo);
      } catch {
        uf = !1;
      }
    function Pp(e, t, a, l, c, m, T, E, b) {
      var x = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(a, x);
      } catch (M) {
        this.onError(M);
      }
    }
    var _p = Pp;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var hg = document.createElement("react");
      _p = function(t, a, l, c, m, T, E, b, x) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var M = document.createEvent("Event"), z = !1, N = !0, q = window.event, Q = Object.getOwnPropertyDescriptor(window, "event");
        function Y() {
          hg.removeEventListener(G, Ue, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = q);
        }
        var ve = Array.prototype.slice.call(arguments, 3);
        function Ue() {
          z = !0, Y(), a.apply(l, ve), N = !1;
        }
        var Me, xt = !1, mt = !1;
        function V(H) {
          if (Me = H.error, xt = !0, Me === null && H.colno === 0 && H.lineno === 0 && (mt = !0), H.defaultPrevented && Me != null && typeof Me == "object")
            try {
              Me._suppressLogging = !0;
            } catch {
            }
        }
        var G = "react-" + (t || "invokeguardedcallback");
        if (window.addEventListener("error", V), hg.addEventListener(G, Ue, !1), M.initEvent(G, !1, !1), hg.dispatchEvent(M), Q && Object.defineProperty(window, "event", Q), z && N && (xt ? mt && (Me = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Me = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Me)), window.removeEventListener("error", V), !z)
          return Y(), Pp.apply(this, arguments);
      };
    }
    var Jw = _p, Sc = !1, Np = null, Tc = !1, hs = null, eE = {
      onError: function(e) {
        Sc = !0, Np = e;
      }
    };
    function Al(e, t, a, l, c, m, T, E, b) {
      Sc = !1, Np = null, Jw.apply(eE, arguments);
    }
    function ps(e, t, a, l, c, m, T, E, b) {
      if (Al.apply(this, arguments), Sc) {
        var x = df();
        Tc || (Tc = !0, hs = x);
      }
    }
    function cf() {
      if (Tc) {
        var e = hs;
        throw Tc = !1, hs = null, e;
      }
    }
    function Ys() {
      return Sc;
    }
    function df() {
      if (Sc) {
        var e = Np;
        return Sc = !1, Np = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function wc(e) {
      return e._reactInternals;
    }
    function ok(e) {
      return e._reactInternals !== void 0;
    }
    function Go(e, t) {
      e._reactInternals = t;
    }
    var Pe = (
      /*                      */
      0
    ), ja = (
      /*                */
      1
    ), Un = (
      /*                    */
      2
    ), bt = (
      /*                       */
      4
    ), pa = (
      /*                */
      16
    ), Ba = (
      /*                 */
      32
    ), un = (
      /*                     */
      64
    ), Oe = (
      /*                   */
      128
    ), kr = (
      /*            */
      256
    ), An = (
      /*                          */
      512
    ), ui = (
      /*                     */
      1024
    ), xr = (
      /*                      */
      2048
    ), ma = (
      /*                    */
      4096
    ), Wn = (
      /*                   */
      8192
    ), Ec = (
      /*             */
      16384
    ), tE = (
      /*               */
      32767
    ), ff = (
      /*                   */
      32768
    ), Rr = (
      /*                */
      65536
    ), Up = (
      /* */
      131072
    ), ms = (
      /*                       */
      1048576
    ), bc = (
      /*                    */
      2097152
    ), Gs = (
      /*                 */
      4194304
    ), zp = (
      /*                */
      8388608
    ), Pl = (
      /*               */
      16777216
    ), vs = (
      /*              */
      33554432
    ), _l = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      bt | ui | 0
    ), Nl = Un | bt | pa | Ba | An | ma | Wn, Ul = bt | un | An | Wn, Ws = xr | pa, Kn = Gs | zp | bc, va = n.ReactCurrentOwner;
    function Br(e) {
      var t = e, a = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var l = t;
        do
          t = l, (t.flags & (Un | ma)) !== Pe && (a = t.return), l = t.return;
        while (l);
      }
      return t.tag === A ? a : null;
    }
    function ys(e) {
      if (e.tag === Ye) {
        var t = e.memoizedState;
        if (t === null) {
          var a = e.alternate;
          a !== null && (t = a.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function gs(e) {
      return e.tag === A ? e.stateNode.containerInfo : null;
    }
    function Wo(e) {
      return Br(e) === e;
    }
    function nE(e) {
      {
        var t = va.current;
        if (t !== null && t.tag === $) {
          var a = t, l = a.stateNode;
          l._warnedAboutRefsInRender || y("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", nt(a) || "A component"), l._warnedAboutRefsInRender = !0;
        }
      }
      var c = wc(e);
      return c ? Br(c) === c : !1;
    }
    function Fp(e) {
      if (Br(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Vp(e) {
      var t = e.alternate;
      if (!t) {
        var a = Br(e);
        if (a === null)
          throw new Error("Unable to find node on an unmounted component.");
        return a !== e ? null : e;
      }
      for (var l = e, c = t; ; ) {
        var m = l.return;
        if (m === null)
          break;
        var T = m.alternate;
        if (T === null) {
          var E = m.return;
          if (E !== null) {
            l = c = E;
            continue;
          }
          break;
        }
        if (m.child === T.child) {
          for (var b = m.child; b; ) {
            if (b === l)
              return Fp(m), e;
            if (b === c)
              return Fp(m), t;
            b = b.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (l.return !== c.return)
          l = m, c = T;
        else {
          for (var x = !1, M = m.child; M; ) {
            if (M === l) {
              x = !0, l = m, c = T;
              break;
            }
            if (M === c) {
              x = !0, c = m, l = T;
              break;
            }
            M = M.sibling;
          }
          if (!x) {
            for (M = T.child; M; ) {
              if (M === l) {
                x = !0, l = T, c = m;
                break;
              }
              if (M === c) {
                x = !0, c = T, l = m;
                break;
              }
              M = M.sibling;
            }
            if (!x)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (l.alternate !== c)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (l.tag !== A)
        throw new Error("Unable to find node on an unmounted component.");
      return l.stateNode.current === l ? e : t;
    }
    function Dr(e) {
      var t = Vp(e);
      return t !== null ? Mr(t) : null;
    }
    function Mr(e) {
      if (e.tag === W || e.tag === ne)
        return e;
      for (var t = e.child; t !== null; ) {
        var a = Mr(t);
        if (a !== null)
          return a;
        t = t.sibling;
      }
      return null;
    }
    function Tn(e) {
      var t = Vp(e);
      return t !== null ? ya(t) : null;
    }
    function ya(e) {
      if (e.tag === W || e.tag === ne)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== B) {
          var a = ya(t);
          if (a !== null)
            return a;
        }
        t = t.sibling;
      }
      return null;
    }
    var pg = s.unstable_scheduleCallback, iE = s.unstable_cancelCallback, mg = s.unstable_shouldYield, vg = s.unstable_requestPaint, ci = s.unstable_now, Hp = s.unstable_getCurrentPriorityLevel, hf = s.unstable_ImmediatePriority, zl = s.unstable_UserBlockingPriority, Ks = s.unstable_NormalPriority, uk = s.unstable_LowPriority, Ko = s.unstable_IdlePriority, Ip = s.unstable_yieldValue, rE = s.unstable_setDisableYieldValue, Xo = null, zn = null, me = null, Qr = !1, Lr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Cc(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled)
        return !0;
      if (!t.supportsFiber)
        return y("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ii && (e = St({}, e, {
          getLaneLabelMap: Zo,
          injectProfilingHooks: ga
        })), Xo = t.inject(e), zn = t;
      } catch (a) {
        y("React instrumentation encountered an error: %s.", a);
      }
      return !!t.checkDCE;
    }
    function yg(e, t) {
      if (zn && typeof zn.onScheduleFiberRoot == "function")
        try {
          zn.onScheduleFiberRoot(Xo, e, t);
        } catch (a) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", a));
        }
    }
    function gg(e, t) {
      if (zn && typeof zn.onCommitFiberRoot == "function")
        try {
          var a = (e.current.flags & Oe) === Oe;
          if (Bn) {
            var l;
            switch (t) {
              case ir:
                l = hf;
                break;
              case Ts:
                l = zl;
                break;
              case Sa:
                l = Ks;
                break;
              case Ta:
                l = Ko;
                break;
              default:
                l = Ks;
                break;
            }
            zn.onCommitFiberRoot(Xo, e, l, a);
          }
        } catch (c) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", c));
        }
    }
    function Sg(e) {
      if (zn && typeof zn.onPostCommitFiberRoot == "function")
        try {
          zn.onPostCommitFiberRoot(Xo, e);
        } catch (t) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", t));
        }
    }
    function Tg(e) {
      if (zn && typeof zn.onCommitFiberUnmount == "function")
        try {
          zn.onCommitFiberUnmount(Xo, e);
        } catch (t) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", t));
        }
    }
    function bn(e) {
      if (typeof Ip == "function" && (rE(e), h(e)), zn && typeof zn.setStrictMode == "function")
        try {
          zn.setStrictMode(Xo, e);
        } catch (t) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", t));
        }
    }
    function ga(e) {
      me = e;
    }
    function Zo() {
      {
        for (var e = /* @__PURE__ */ new Map(), t = 1, a = 0; a < tu; a++) {
          var l = oE(t);
          e.set(t, l), t *= 2;
        }
        return e;
      }
    }
    function wg(e) {
      me !== null && typeof me.markCommitStarted == "function" && me.markCommitStarted(e);
    }
    function Eg() {
      me !== null && typeof me.markCommitStopped == "function" && me.markCommitStopped();
    }
    function Yr(e) {
      me !== null && typeof me.markComponentRenderStarted == "function" && me.markComponentRenderStarted(e);
    }
    function Gr() {
      me !== null && typeof me.markComponentRenderStopped == "function" && me.markComponentRenderStopped();
    }
    function bg(e) {
      me !== null && typeof me.markComponentPassiveEffectMountStarted == "function" && me.markComponentPassiveEffectMountStarted(e);
    }
    function aE() {
      me !== null && typeof me.markComponentPassiveEffectMountStopped == "function" && me.markComponentPassiveEffectMountStopped();
    }
    function Xs(e) {
      me !== null && typeof me.markComponentPassiveEffectUnmountStarted == "function" && me.markComponentPassiveEffectUnmountStarted(e);
    }
    function Fl() {
      me !== null && typeof me.markComponentPassiveEffectUnmountStopped == "function" && me.markComponentPassiveEffectUnmountStopped();
    }
    function qp(e) {
      me !== null && typeof me.markComponentLayoutEffectMountStarted == "function" && me.markComponentLayoutEffectMountStarted(e);
    }
    function sE() {
      me !== null && typeof me.markComponentLayoutEffectMountStopped == "function" && me.markComponentLayoutEffectMountStopped();
    }
    function pf(e) {
      me !== null && typeof me.markComponentLayoutEffectUnmountStarted == "function" && me.markComponentLayoutEffectUnmountStarted(e);
    }
    function Cg() {
      me !== null && typeof me.markComponentLayoutEffectUnmountStopped == "function" && me.markComponentLayoutEffectUnmountStopped();
    }
    function mf(e, t, a) {
      me !== null && typeof me.markComponentErrored == "function" && me.markComponentErrored(e, t, a);
    }
    function Ss(e, t, a) {
      me !== null && typeof me.markComponentSuspended == "function" && me.markComponentSuspended(e, t, a);
    }
    function vf(e) {
      me !== null && typeof me.markLayoutEffectsStarted == "function" && me.markLayoutEffectsStarted(e);
    }
    function yf() {
      me !== null && typeof me.markLayoutEffectsStopped == "function" && me.markLayoutEffectsStopped();
    }
    function Jo(e) {
      me !== null && typeof me.markPassiveEffectsStarted == "function" && me.markPassiveEffectsStarted(e);
    }
    function kg() {
      me !== null && typeof me.markPassiveEffectsStopped == "function" && me.markPassiveEffectsStopped();
    }
    function eu(e) {
      me !== null && typeof me.markRenderStarted == "function" && me.markRenderStarted(e);
    }
    function lE() {
      me !== null && typeof me.markRenderYielded == "function" && me.markRenderYielded();
    }
    function jp() {
      me !== null && typeof me.markRenderStopped == "function" && me.markRenderStopped();
    }
    function Cn(e) {
      me !== null && typeof me.markRenderScheduled == "function" && me.markRenderScheduled(e);
    }
    function Bp(e, t) {
      me !== null && typeof me.markForceUpdateScheduled == "function" && me.markForceUpdateScheduled(e, t);
    }
    function gf(e, t) {
      me !== null && typeof me.markStateUpdateScheduled == "function" && me.markStateUpdateScheduled(e, t);
    }
    var _e = (
      /*                         */
      0
    ), dt = (
      /*                 */
      1
    ), Ut = (
      /*                    */
      2
    ), Jt = (
      /*               */
      8
    ), zt = (
      /*              */
      16
    ), Xn = Math.clz32 ? Math.clz32 : Sf, Si = Math.log, Qp = Math.LN2;
    function Sf(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (Si(t) / Qp | 0) | 0;
    }
    var tu = 31, ee = (
      /*                        */
      0
    ), Ot = (
      /*                          */
      0
    ), je = (
      /*                        */
      1
    ), Vl = (
      /*    */
      2
    ), Qa = (
      /*             */
      4
    ), ji = (
      /*            */
      8
    ), Fn = (
      /*                     */
      16
    ), Zs = (
      /*                */
      32
    ), Hl = (
      /*                       */
      4194240
    ), nu = (
      /*                        */
      64
    ), Yp = (
      /*                        */
      128
    ), Gp = (
      /*                        */
      256
    ), Wp = (
      /*                        */
      512
    ), Kp = (
      /*                        */
      1024
    ), Xp = (
      /*                        */
      2048
    ), Zp = (
      /*                        */
      4096
    ), Jp = (
      /*                        */
      8192
    ), em = (
      /*                        */
      16384
    ), iu = (
      /*                       */
      32768
    ), tm = (
      /*                       */
      65536
    ), kc = (
      /*                       */
      131072
    ), xc = (
      /*                       */
      262144
    ), nm = (
      /*                       */
      524288
    ), Tf = (
      /*                       */
      1048576
    ), im = (
      /*                       */
      2097152
    ), wf = (
      /*                            */
      130023424
    ), ru = (
      /*                             */
      4194304
    ), rm = (
      /*                             */
      8388608
    ), Ef = (
      /*                             */
      16777216
    ), am = (
      /*                             */
      33554432
    ), sm = (
      /*                             */
      67108864
    ), xg = ru, bf = (
      /*          */
      134217728
    ), Rg = (
      /*                          */
      268435455
    ), Cf = (
      /*               */
      268435456
    ), au = (
      /*                        */
      536870912
    ), Wr = (
      /*                   */
      1073741824
    );
    function oE(e) {
      {
        if (e & je)
          return "Sync";
        if (e & Vl)
          return "InputContinuousHydration";
        if (e & Qa)
          return "InputContinuous";
        if (e & ji)
          return "DefaultHydration";
        if (e & Fn)
          return "Default";
        if (e & Zs)
          return "TransitionHydration";
        if (e & Hl)
          return "Transition";
        if (e & wf)
          return "Retry";
        if (e & bf)
          return "SelectiveHydration";
        if (e & Cf)
          return "IdleHydration";
        if (e & au)
          return "Idle";
        if (e & Wr)
          return "Offscreen";
      }
    }
    var ln = -1, su = nu, lm = ru;
    function kf(e) {
      switch (Il(e)) {
        case je:
          return je;
        case Vl:
          return Vl;
        case Qa:
          return Qa;
        case ji:
          return ji;
        case Fn:
          return Fn;
        case Zs:
          return Zs;
        case nu:
        case Yp:
        case Gp:
        case Wp:
        case Kp:
        case Xp:
        case Zp:
        case Jp:
        case em:
        case iu:
        case tm:
        case kc:
        case xc:
        case nm:
        case Tf:
        case im:
          return e & Hl;
        case ru:
        case rm:
        case Ef:
        case am:
        case sm:
          return e & wf;
        case bf:
          return bf;
        case Cf:
          return Cf;
        case au:
          return au;
        case Wr:
          return Wr;
        default:
          return y("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function om(e, t) {
      var a = e.pendingLanes;
      if (a === ee)
        return ee;
      var l = ee, c = e.suspendedLanes, m = e.pingedLanes, T = a & Rg;
      if (T !== ee) {
        var E = T & ~c;
        if (E !== ee)
          l = kf(E);
        else {
          var b = T & m;
          b !== ee && (l = kf(b));
        }
      } else {
        var x = a & ~c;
        x !== ee ? l = kf(x) : m !== ee && (l = kf(m));
      }
      if (l === ee)
        return ee;
      if (t !== ee && t !== l && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & c) === ee) {
        var M = Il(l), z = Il(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          M >= z || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          M === Fn && (z & Hl) !== ee
        )
          return t;
      }
      (l & Qa) !== ee && (l |= a & Fn);
      var N = e.entangledLanes;
      if (N !== ee)
        for (var q = e.entanglements, Q = l & N; Q > 0; ) {
          var Y = Zn(Q), ve = 1 << Y;
          l |= q[Y], Q &= ~ve;
        }
      return l;
    }
    function Ya(e, t) {
      for (var a = e.eventTimes, l = ln; t > 0; ) {
        var c = Zn(t), m = 1 << c, T = a[c];
        T > l && (l = T), t &= ~m;
      }
      return l;
    }
    function Dg(e, t) {
      switch (e) {
        case je:
        case Vl:
        case Qa:
          return t + 250;
        case ji:
        case Fn:
        case Zs:
        case nu:
        case Yp:
        case Gp:
        case Wp:
        case Kp:
        case Xp:
        case Zp:
        case Jp:
        case em:
        case iu:
        case tm:
        case kc:
        case xc:
        case nm:
        case Tf:
        case im:
          return t + 5e3;
        case ru:
        case rm:
        case Ef:
        case am:
        case sm:
          return ln;
        case bf:
        case Cf:
        case au:
        case Wr:
          return ln;
        default:
          return y("Should have found matching lanes. This is a bug in React."), ln;
      }
    }
    function um(e, t) {
      for (var a = e.pendingLanes, l = e.suspendedLanes, c = e.pingedLanes, m = e.expirationTimes, T = a; T > 0; ) {
        var E = Zn(T), b = 1 << E, x = m[E];
        x === ln ? ((b & l) === ee || (b & c) !== ee) && (m[E] = Dg(b, t)) : x <= t && (e.expiredLanes |= b), T &= ~b;
      }
    }
    function uE(e) {
      return kf(e.pendingLanes);
    }
    function cm(e) {
      var t = e.pendingLanes & -1073741825;
      return t !== ee ? t : t & Wr ? Wr : ee;
    }
    function cE(e) {
      return (e & je) !== ee;
    }
    function xf(e) {
      return (e & Rg) !== ee;
    }
    function lu(e) {
      return (e & wf) === e;
    }
    function Mg(e) {
      var t = je | Qa | Fn;
      return (e & t) === ee;
    }
    function Lg(e) {
      return (e & Hl) === e;
    }
    function dm(e, t) {
      var a = Vl | Qa | ji | Fn;
      return (t & a) !== ee;
    }
    function dE(e, t) {
      return (t & e.expiredLanes) !== ee;
    }
    function $g(e) {
      return (e & Hl) !== ee;
    }
    function Og() {
      var e = su;
      return su <<= 1, (su & Hl) === ee && (su = nu), e;
    }
    function fE() {
      var e = lm;
      return lm <<= 1, (lm & wf) === ee && (lm = ru), e;
    }
    function Il(e) {
      return e & -e;
    }
    function Rf(e) {
      return Il(e);
    }
    function Zn(e) {
      return 31 - Xn(e);
    }
    function Li(e) {
      return Zn(e);
    }
    function $r(e, t) {
      return (e & t) !== ee;
    }
    function ou(e, t) {
      return (e & t) === t;
    }
    function it(e, t) {
      return e | t;
    }
    function Df(e, t) {
      return e & ~t;
    }
    function Ag(e, t) {
      return e & t;
    }
    function hE(e) {
      return e;
    }
    function pE(e, t) {
      return e !== Ot && e < t ? e : t;
    }
    function Mf(e) {
      for (var t = [], a = 0; a < tu; a++)
        t.push(e);
      return t;
    }
    function Rc(e, t, a) {
      e.pendingLanes |= t, t !== au && (e.suspendedLanes = ee, e.pingedLanes = ee);
      var l = e.eventTimes, c = Li(t);
      l[c] = a;
    }
    function mE(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var a = e.expirationTimes, l = t; l > 0; ) {
        var c = Zn(l), m = 1 << c;
        a[c] = ln, l &= ~m;
      }
    }
    function fm(e, t, a) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function Pg(e, t) {
      var a = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = ee, e.pingedLanes = ee, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var l = e.entanglements, c = e.eventTimes, m = e.expirationTimes, T = a; T > 0; ) {
        var E = Zn(T), b = 1 << E;
        l[E] = ee, c[E] = ln, m[E] = ln, T &= ~b;
      }
    }
    function hm(e, t) {
      for (var a = e.entangledLanes |= t, l = e.entanglements, c = a; c; ) {
        var m = Zn(c), T = 1 << m;
        // Is this one of the newly entangled lanes?
        T & t | // Is this lane transitively entangled with the newly entangled lanes?
        l[m] & t && (l[m] |= t), c &= ~T;
      }
    }
    function _g(e, t) {
      var a = Il(t), l;
      switch (a) {
        case Qa:
          l = Vl;
          break;
        case Fn:
          l = ji;
          break;
        case nu:
        case Yp:
        case Gp:
        case Wp:
        case Kp:
        case Xp:
        case Zp:
        case Jp:
        case em:
        case iu:
        case tm:
        case kc:
        case xc:
        case nm:
        case Tf:
        case im:
        case ru:
        case rm:
        case Ef:
        case am:
        case sm:
          l = Zs;
          break;
        case au:
          l = Cf;
          break;
        default:
          l = Ot;
          break;
      }
      return (l & (e.suspendedLanes | t)) !== Ot ? Ot : l;
    }
    function Lf(e, t, a) {
      if (Lr)
        for (var l = e.pendingUpdatersLaneMap; a > 0; ) {
          var c = Li(a), m = 1 << c, T = l[c];
          T.add(t), a &= ~m;
        }
    }
    function vE(e, t) {
      if (Lr)
        for (var a = e.pendingUpdatersLaneMap, l = e.memoizedUpdaters; t > 0; ) {
          var c = Li(t), m = 1 << c, T = a[c];
          T.size > 0 && (T.forEach(function(E) {
            var b = E.alternate;
            (b === null || !l.has(b)) && l.add(E);
          }), T.clear()), t &= ~m;
        }
    }
    function Ng(e, t) {
      return null;
    }
    var ir = je, Ts = Qa, Sa = Fn, Ta = au, $f = Ot;
    function wa() {
      return $f;
    }
    function Jn(e) {
      $f = e;
    }
    function yE(e, t) {
      var a = $f;
      try {
        return $f = e, t();
      } finally {
        $f = a;
      }
    }
    function gE(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function Of(e, t) {
      return e > t ? e : t;
    }
    function Ti(e, t) {
      return e !== 0 && e < t;
    }
    function SE(e) {
      var t = Il(e);
      return Ti(ir, t) ? Ti(Ts, t) ? xf(t) ? Sa : Ta : Ts : ir;
    }
    function pm(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var Af;
    function Bi(e) {
      Af = e;
    }
    function ck(e) {
      Af(e);
    }
    var be;
    function Dc(e) {
      be = e;
    }
    var mm;
    function TE(e) {
      mm = e;
    }
    var wE;
    function Pf(e) {
      wE = e;
    }
    var _f;
    function Ug(e) {
      _f = e;
    }
    var vm = !1, Nf = [], Js = null, ws = null, Es = null, Vn = /* @__PURE__ */ new Map(), rr = /* @__PURE__ */ new Map(), ar = [], EE = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function bE(e) {
      return EE.indexOf(e) > -1;
    }
    function Ga(e, t, a, l, c) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: a,
        nativeEvent: c,
        targetContainers: [l]
      };
    }
    function zg(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Js = null;
          break;
        case "dragenter":
        case "dragleave":
          ws = null;
          break;
        case "mouseover":
        case "mouseout":
          Es = null;
          break;
        case "pointerover":
        case "pointerout": {
          var a = t.pointerId;
          Vn.delete(a);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var l = t.pointerId;
          rr.delete(l);
          break;
        }
      }
    }
    function Or(e, t, a, l, c, m) {
      if (e === null || e.nativeEvent !== m) {
        var T = Ga(t, a, l, c, m);
        if (t !== null) {
          var E = Uc(t);
          E !== null && be(E);
        }
        return T;
      }
      e.eventSystemFlags |= l;
      var b = e.targetContainers;
      return c !== null && b.indexOf(c) === -1 && b.push(c), e;
    }
    function dk(e, t, a, l, c) {
      switch (t) {
        case "focusin": {
          var m = c;
          return Js = Or(Js, e, t, a, l, m), !0;
        }
        case "dragenter": {
          var T = c;
          return ws = Or(ws, e, t, a, l, T), !0;
        }
        case "mouseover": {
          var E = c;
          return Es = Or(Es, e, t, a, l, E), !0;
        }
        case "pointerover": {
          var b = c, x = b.pointerId;
          return Vn.set(x, Or(Vn.get(x) || null, e, t, a, l, b)), !0;
        }
        case "gotpointercapture": {
          var M = c, z = M.pointerId;
          return rr.set(z, Or(rr.get(z) || null, e, t, a, l, M)), !0;
        }
      }
      return !1;
    }
    function Fg(e) {
      var t = Gf(e.target);
      if (t !== null) {
        var a = Br(t);
        if (a !== null) {
          var l = a.tag;
          if (l === Ye) {
            var c = ys(a);
            if (c !== null) {
              e.blockedOn = c, _f(e.priority, function() {
                mm(a);
              });
              return;
            }
          } else if (l === A) {
            var m = a.stateNode;
            if (pm(m)) {
              e.blockedOn = gs(a);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function CE(e) {
      for (var t = wE(), a = {
        blockedOn: null,
        target: e,
        priority: t
      }, l = 0; l < ar.length && Ti(t, ar[l].priority); l++)
        ;
      ar.splice(l, 0, a), l === 0 && Fg(a);
    }
    function Uf(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var a = t[0], l = Lc(e.domEventName, e.eventSystemFlags, a, e.nativeEvent);
        if (l === null) {
          var c = e.nativeEvent, m = new c.constructor(c.type, c);
          ak(m), c.target.dispatchEvent(m), sk();
        } else {
          var T = Uc(l);
          return T !== null && be(T), e.blockedOn = l, !1;
        }
        t.shift();
      }
      return !0;
    }
    function Vg(e, t, a) {
      Uf(e) && a.delete(t);
    }
    function fk() {
      vm = !1, Js !== null && Uf(Js) && (Js = null), ws !== null && Uf(ws) && (ws = null), Es !== null && Uf(Es) && (Es = null), Vn.forEach(Vg), rr.forEach(Vg);
    }
    function ql(e, t) {
      e.blockedOn === t && (e.blockedOn = null, vm || (vm = !0, s.unstable_scheduleCallback(s.unstable_NormalPriority, fk)));
    }
    function uu(e) {
      if (Nf.length > 0) {
        ql(Nf[0], e);
        for (var t = 1; t < Nf.length; t++) {
          var a = Nf[t];
          a.blockedOn === e && (a.blockedOn = null);
        }
      }
      Js !== null && ql(Js, e), ws !== null && ql(ws, e), Es !== null && ql(Es, e);
      var l = function(E) {
        return ql(E, e);
      };
      Vn.forEach(l), rr.forEach(l);
      for (var c = 0; c < ar.length; c++) {
        var m = ar[c];
        m.blockedOn === e && (m.blockedOn = null);
      }
      for (; ar.length > 0; ) {
        var T = ar[0];
        if (T.blockedOn !== null)
          break;
        Fg(T), T.blockedOn === null && ar.shift();
      }
    }
    var $i = n.ReactCurrentBatchConfig, Ct = !0;
    function di(e) {
      Ct = !!e;
    }
    function ei() {
      return Ct;
    }
    function Oi(e, t, a) {
      var l = ym(t), c;
      switch (l) {
        case ir:
          c = Kr;
          break;
        case Ts:
          c = Mc;
          break;
        case Sa:
        default:
          c = Hn;
          break;
      }
      return c.bind(null, t, a, e);
    }
    function Kr(e, t, a, l) {
      var c = wa(), m = $i.transition;
      $i.transition = null;
      try {
        Jn(ir), Hn(e, t, a, l);
      } finally {
        Jn(c), $i.transition = m;
      }
    }
    function Mc(e, t, a, l) {
      var c = wa(), m = $i.transition;
      $i.transition = null;
      try {
        Jn(Ts), Hn(e, t, a, l);
      } finally {
        Jn(c), $i.transition = m;
      }
    }
    function Hn(e, t, a, l) {
      Ct && zf(e, t, a, l);
    }
    function zf(e, t, a, l) {
      var c = Lc(e, t, a, l);
      if (c === null) {
        Lk(e, t, l, bs, a), zg(e, l);
        return;
      }
      if (dk(c, e, t, a, l)) {
        l.stopPropagation();
        return;
      }
      if (zg(e, l), t & ha && bE(e)) {
        for (; c !== null; ) {
          var m = Uc(c);
          m !== null && ck(m);
          var T = Lc(e, t, a, l);
          if (T === null && Lk(e, t, l, bs, a), T === c)
            break;
          c = T;
        }
        c !== null && l.stopPropagation();
        return;
      }
      Lk(e, t, l, null, a);
    }
    var bs = null;
    function Lc(e, t, a, l) {
      bs = null;
      var c = fg(l), m = Gf(c);
      if (m !== null) {
        var T = Br(m);
        if (T === null)
          m = null;
        else {
          var E = T.tag;
          if (E === Ye) {
            var b = ys(T);
            if (b !== null)
              return b;
            m = null;
          } else if (E === A) {
            var x = T.stateNode;
            if (pm(x))
              return gs(T);
            m = null;
          } else T !== m && (m = null);
        }
      }
      return bs = m, null;
    }
    function ym(e) {
      switch (e) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return ir;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ts;
        case "message": {
          var t = Hp();
          switch (t) {
            case hf:
              return ir;
            case zl:
              return Ts;
            case Ks:
            case uk:
              return Sa;
            case Ko:
              return Ta;
            default:
              return Sa;
          }
        }
        default:
          return Sa;
      }
    }
    function Ff(e, t, a) {
      return e.addEventListener(t, a, !1), a;
    }
    function Ar(e, t, a) {
      return e.addEventListener(t, a, !0), a;
    }
    function Hg(e, t, a, l) {
      return e.addEventListener(t, a, {
        capture: !0,
        passive: l
      }), a;
    }
    function $c(e, t, a, l) {
      return e.addEventListener(t, a, {
        passive: l
      }), a;
    }
    var Xr = null, Oc = null, cu = null;
    function jl(e) {
      return Xr = e, Oc = Vf(), !0;
    }
    function gm() {
      Xr = null, Oc = null, cu = null;
    }
    function el() {
      if (cu)
        return cu;
      var e, t = Oc, a = t.length, l, c = Vf(), m = c.length;
      for (e = 0; e < a && t[e] === c[e]; e++)
        ;
      var T = a - e;
      for (l = 1; l <= T && t[a - l] === c[m - l]; l++)
        ;
      var E = l > 1 ? 1 - l : void 0;
      return cu = c.slice(e, E), cu;
    }
    function Vf() {
      return "value" in Xr ? Xr.value : Xr.textContent;
    }
    function Bl(e) {
      var t, a = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && a === 13 && (t = 13)) : t = a, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function Ac() {
      return !0;
    }
    function Hf() {
      return !1;
    }
    function Qi(e) {
      function t(a, l, c, m, T) {
        this._reactName = a, this._targetInst = c, this.type = l, this.nativeEvent = m, this.target = T, this.currentTarget = null;
        for (var E in e)
          if (e.hasOwnProperty(E)) {
            var b = e[E];
            b ? this[E] = b(m) : this[E] = m[E];
          }
        var x = m.defaultPrevented != null ? m.defaultPrevented : m.returnValue === !1;
        return x ? this.isDefaultPrevented = Ac : this.isDefaultPrevented = Hf, this.isPropagationStopped = Hf, this;
      }
      return St(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = Ac);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = Ac);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Ac
      }), t;
    }
    var ti = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Cs = Qi(ti), sr = St({}, ti, {
      view: 0,
      detail: 0
    }), Pr = Qi(sr), Sm, If, du;
    function hk(e) {
      e !== du && (du && e.type === "mousemove" ? (Sm = e.screenX - du.screenX, If = e.screenY - du.screenY) : (Sm = 0, If = 0), du = e);
    }
    var Wa = St({}, sr, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: wn,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (hk(e), Sm);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : If;
      }
    }), Ig = Qi(Wa), qg = St({}, Wa, {
      dataTransfer: 0
    }), fu = Qi(qg), jg = St({}, sr, {
      relatedTarget: 0
    }), tl = Qi(jg), kE = St({}, ti, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), xE = Qi(kE), Bg = St({}, ti, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), Tm = Qi(Bg), pk = St({}, ti, {
      data: 0
    }), RE = Qi(pk), DE = RE, ME = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, hu = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function mk(e) {
      if (e.key) {
        var t = ME[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var a = Bl(e);
        return a === 13 ? "Enter" : String.fromCharCode(a);
      }
      return e.type === "keydown" || e.type === "keyup" ? hu[e.keyCode] || "Unidentified" : "";
    }
    var Pc = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function LE(e) {
      var t = this, a = t.nativeEvent;
      if (a.getModifierState)
        return a.getModifierState(e);
      var l = Pc[e];
      return l ? !!a[l] : !1;
    }
    function wn(e) {
      return LE;
    }
    var vk = St({}, sr, {
      key: mk,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: wn,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Bl(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Bl(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), $E = Qi(vk), yk = St({}, Wa, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), OE = Qi(yk), AE = St({}, sr, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: wn
    }), PE = Qi(AE), gk = St({}, ti, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ea = Qi(gk), Qg = St({}, Wa, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Sk = Qi(Qg), Ql = [9, 13, 27, 32], qf = 229, nl = Nn && "CompositionEvent" in window, Yl = null;
    Nn && "documentMode" in document && (Yl = document.documentMode);
    var Yg = Nn && "TextEvent" in window && !Yl, wm = Nn && (!nl || Yl && Yl > 8 && Yl <= 11), _E = 32, Em = String.fromCharCode(_E);
    function Tk() {
      li("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), li("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), li("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), li("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Gg = !1;
    function NE(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function bm(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Cm(e, t) {
      return e === "keydown" && t.keyCode === qf;
    }
    function Wg(e, t) {
      switch (e) {
        case "keyup":
          return Ql.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== qf;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function km(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function Kg(e) {
      return e.locale === "ko";
    }
    var Gl = !1;
    function xm(e, t, a, l, c) {
      var m, T;
      if (nl ? m = bm(t) : Gl ? Wg(t, l) && (m = "onCompositionEnd") : Cm(t, l) && (m = "onCompositionStart"), !m)
        return null;
      wm && !Kg(l) && (!Gl && m === "onCompositionStart" ? Gl = jl(c) : m === "onCompositionEnd" && Gl && (T = el()));
      var E = IE(a, m);
      if (E.length > 0) {
        var b = new RE(m, t, null, l, c);
        if (e.push({
          event: b,
          listeners: E
        }), T)
          b.data = T;
        else {
          var x = km(l);
          x !== null && (b.data = x);
        }
      }
    }
    function Xg(e, t) {
      switch (e) {
        case "compositionend":
          return km(t);
        case "keypress":
          var a = t.which;
          return a !== _E ? null : (Gg = !0, Em);
        case "textInput":
          var l = t.data;
          return l === Em && Gg ? null : l;
        default:
          return null;
      }
    }
    function Rm(e, t) {
      if (Gl) {
        if (e === "compositionend" || !nl && Wg(e, t)) {
          var a = el();
          return gm(), Gl = !1, a;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!NE(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return wm && !Kg(t) ? null : t.data;
        default:
          return null;
      }
    }
    function UE(e, t, a, l, c) {
      var m;
      if (Yg ? m = Xg(t, l) : m = Rm(t, l), !m)
        return null;
      var T = IE(a, "onBeforeInput");
      if (T.length > 0) {
        var E = new DE("onBeforeInput", "beforeinput", null, l, c);
        e.push({
          event: E,
          listeners: T
        }), E.data = m;
      }
    }
    function wk(e, t, a, l, c, m, T) {
      xm(e, t, a, l, c), UE(e, t, a, l, c);
    }
    var Dm = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function zE(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!Dm[e.type] : t === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function jf(e) {
      if (!Nn)
        return !1;
      var t = "on" + e, a = t in document;
      if (!a) {
        var l = document.createElement("div");
        l.setAttribute(t, "return;"), a = typeof l[t] == "function";
      }
      return a;
    }
    function Ek() {
      li("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Bf(e, t, a, l) {
      yc(l);
      var c = IE(t, "onChange");
      if (c.length > 0) {
        var m = new Cs("onChange", "change", null, a, l);
        e.push({
          event: m,
          listeners: c
        });
      }
    }
    var i = null, r = null;
    function u(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function p(e) {
      var t = [];
      Bf(t, r, e, fg(e)), Xw(g, t);
    }
    function g(e) {
      dL(e, 0);
    }
    function w(e) {
      var t = Pm(e);
      if (Fo(t))
        return e;
    }
    function k(e, t) {
      if (e === "change")
        return t;
    }
    var O = !1;
    Nn && (O = jf("input") && (!document.documentMode || document.documentMode > 9));
    function P(e, t) {
      i = e, r = t, i.attachEvent("onpropertychange", ie);
    }
    function j() {
      i && (i.detachEvent("onpropertychange", ie), i = null, r = null);
    }
    function ie(e) {
      e.propertyName === "value" && w(r) && p(e);
    }
    function re(e, t, a) {
      e === "focusin" ? (j(), P(t, a)) : e === "focusout" && j();
    }
    function te(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return w(r);
    }
    function Te(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function ke(e, t) {
      if (e === "click")
        return w(t);
    }
    function De(e, t) {
      if (e === "input" || e === "change")
        return w(t);
    }
    function In(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || Sp(e, "number", e.value);
    }
    function F(e, t, a, l, c, m, T) {
      var E = a ? Pm(a) : window, b, x;
      if (u(E) ? b = k : zE(E) ? O ? b = De : (b = te, x = re) : Te(E) && (b = ke), b) {
        var M = b(t, a);
        if (M) {
          Bf(e, M, l, c);
          return;
        }
      }
      x && x(t, E, a), t === "focusout" && In(E);
    }
    function U() {
      ki("onMouseEnter", ["mouseout", "mouseover"]), ki("onMouseLeave", ["mouseout", "mouseover"]), ki("onPointerEnter", ["pointerout", "pointerover"]), ki("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function I(e, t, a, l, c, m, T) {
      var E = t === "mouseover" || t === "pointerover", b = t === "mouseout" || t === "pointerout";
      if (E && !lf(l)) {
        var x = l.relatedTarget || l.fromElement;
        if (x && (Gf(x) || dS(x)))
          return;
      }
      if (!(!b && !E)) {
        var M;
        if (c.window === c)
          M = c;
        else {
          var z = c.ownerDocument;
          z ? M = z.defaultView || z.parentWindow : M = window;
        }
        var N, q;
        if (b) {
          var Q = l.relatedTarget || l.toElement;
          if (N = a, q = Q ? Gf(Q) : null, q !== null) {
            var Y = Br(q);
            (q !== Y || q.tag !== W && q.tag !== ne) && (q = null);
          }
        } else
          N = null, q = a;
        if (N !== q) {
          var ve = Ig, Ue = "onMouseLeave", Me = "onMouseEnter", xt = "mouse";
          (t === "pointerout" || t === "pointerover") && (ve = OE, Ue = "onPointerLeave", Me = "onPointerEnter", xt = "pointer");
          var mt = N == null ? M : Pm(N), V = q == null ? M : Pm(q), G = new ve(Ue, xt + "leave", N, l, c);
          G.target = mt, G.relatedTarget = V;
          var H = null, ae = Gf(c);
          if (ae === a) {
            var Ee = new ve(Me, xt + "enter", q, l, c);
            Ee.target = V, Ee.relatedTarget = mt, H = Ee;
          }
          iH(e, G, H, N, q);
        }
      }
    }
    function le(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var ge = typeof Object.is == "function" ? Object.is : le;
    function Ne(e, t) {
      if (ge(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), l = Object.keys(t);
      if (a.length !== l.length)
        return !1;
      for (var c = 0; c < a.length; c++) {
        var m = a[c];
        if (!er.call(t, m) || !ge(e[m], t[m]))
          return !1;
      }
      return !0;
    }
    function Fe(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function We(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function fi(e, t) {
      for (var a = Fe(e), l = 0, c = 0; a; ) {
        if (a.nodeType === Bs) {
          if (c = l + a.textContent.length, l <= t && c >= t)
            return {
              node: a,
              offset: t - l
            };
          l = c;
        }
        a = Fe(We(a));
      }
    }
    function Ft(e) {
      var t = e.ownerDocument, a = t && t.defaultView || window, l = a.getSelection && a.getSelection();
      if (!l || l.rangeCount === 0)
        return null;
      var c = l.anchorNode, m = l.anchorOffset, T = l.focusNode, E = l.focusOffset;
      try {
        c.nodeType, T.nodeType;
      } catch {
        return null;
      }
      return Wl(e, c, m, T, E);
    }
    function Wl(e, t, a, l, c) {
      var m = 0, T = -1, E = -1, b = 0, x = 0, M = e, z = null;
      e: for (; ; ) {
        for (var N = null; M === t && (a === 0 || M.nodeType === Bs) && (T = m + a), M === l && (c === 0 || M.nodeType === Bs) && (E = m + c), M.nodeType === Bs && (m += M.nodeValue.length), (N = M.firstChild) !== null; )
          z = M, M = N;
        for (; ; ) {
          if (M === e)
            break e;
          if (z === t && ++b === a && (T = m), z === l && ++x === c && (E = m), (N = M.nextSibling) !== null)
            break;
          M = z, z = M.parentNode;
        }
        M = N;
      }
      return T === -1 || E === -1 ? null : {
        start: T,
        end: E
      };
    }
    function bk(e, t) {
      var a = e.ownerDocument || document, l = a && a.defaultView || window;
      if (l.getSelection) {
        var c = l.getSelection(), m = e.textContent.length, T = Math.min(t.start, m), E = t.end === void 0 ? T : Math.min(t.end, m);
        if (!c.extend && T > E) {
          var b = E;
          E = T, T = b;
        }
        var x = fi(e, T), M = fi(e, E);
        if (x && M) {
          if (c.rangeCount === 1 && c.anchorNode === x.node && c.anchorOffset === x.offset && c.focusNode === M.node && c.focusOffset === M.offset)
            return;
          var z = a.createRange();
          z.setStart(x.node, x.offset), c.removeAllRanges(), T > E ? (c.addRange(z), c.extend(M.node, M.offset)) : (z.setEnd(M.node, M.offset), c.addRange(z));
        }
      }
    }
    function JM(e) {
      return e && e.nodeType === Bs;
    }
    function eL(e, t) {
      return !e || !t ? !1 : e === t ? !0 : JM(e) ? !1 : JM(t) ? eL(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function FV(e) {
      return e && e.ownerDocument && eL(e.ownerDocument.documentElement, e);
    }
    function VV(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function tL() {
      for (var e = window, t = Vo(); t instanceof e.HTMLIFrameElement; ) {
        if (VV(t))
          e = t.contentWindow;
        else
          return t;
        t = Vo(e.document);
      }
      return t;
    }
    function Ck(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function HV() {
      var e = tL();
      return {
        focusedElem: e,
        selectionRange: Ck(e) ? qV(e) : null
      };
    }
    function IV(e) {
      var t = tL(), a = e.focusedElem, l = e.selectionRange;
      if (t !== a && FV(a)) {
        l !== null && Ck(a) && jV(a, l);
        for (var c = [], m = a; m = m.parentNode; )
          m.nodeType === Cr && c.push({
            element: m,
            left: m.scrollLeft,
            top: m.scrollTop
          });
        typeof a.focus == "function" && a.focus();
        for (var T = 0; T < c.length; T++) {
          var E = c[T];
          E.element.scrollLeft = E.left, E.element.scrollTop = E.top;
        }
      }
    }
    function qV(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = Ft(e), t || {
        start: 0,
        end: 0
      };
    }
    function jV(e, t) {
      var a = t.start, l = t.end;
      l === void 0 && (l = a), "selectionStart" in e ? (e.selectionStart = a, e.selectionEnd = Math.min(l, e.value.length)) : bk(e, t);
    }
    var BV = Nn && "documentMode" in document && document.documentMode <= 11;
    function QV() {
      li("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Mm = null, kk = null, Zg = null, xk = !1;
    function YV(e) {
      if ("selectionStart" in e && Ck(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, a = t.getSelection();
      return {
        anchorNode: a.anchorNode,
        anchorOffset: a.anchorOffset,
        focusNode: a.focusNode,
        focusOffset: a.focusOffset
      };
    }
    function GV(e) {
      return e.window === e ? e.document : e.nodeType === Qs ? e : e.ownerDocument;
    }
    function nL(e, t, a) {
      var l = GV(a);
      if (!(xk || Mm == null || Mm !== Vo(l))) {
        var c = YV(Mm);
        if (!Zg || !Ne(Zg, c)) {
          Zg = c;
          var m = IE(kk, "onSelect");
          if (m.length > 0) {
            var T = new Cs("onSelect", "select", null, t, a);
            e.push({
              event: T,
              listeners: m
            }), T.target = Mm;
          }
        }
      }
    }
    function WV(e, t, a, l, c, m, T) {
      var E = a ? Pm(a) : window;
      switch (t) {
        // Track the input node that has focus.
        case "focusin":
          (zE(E) || E.contentEditable === "true") && (Mm = E, kk = a, Zg = null);
          break;
        case "focusout":
          Mm = null, kk = null, Zg = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          xk = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          xk = !1, nL(e, l, c);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (BV)
            break;
        // falls through
        case "keydown":
        case "keyup":
          nL(e, l, c);
      }
    }
    function FE(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    var Lm = {
      animationend: FE("Animation", "AnimationEnd"),
      animationiteration: FE("Animation", "AnimationIteration"),
      animationstart: FE("Animation", "AnimationStart"),
      transitionend: FE("Transition", "TransitionEnd")
    }, Rk = {}, iL = {};
    Nn && (iL = document.createElement("div").style, "AnimationEvent" in window || (delete Lm.animationend.animation, delete Lm.animationiteration.animation, delete Lm.animationstart.animation), "TransitionEvent" in window || delete Lm.transitionend.transition);
    function VE(e) {
      if (Rk[e])
        return Rk[e];
      if (!Lm[e])
        return e;
      var t = Lm[e];
      for (var a in t)
        if (t.hasOwnProperty(a) && a in iL)
          return Rk[e] = t[a];
      return e;
    }
    var rL = VE("animationend"), aL = VE("animationiteration"), sL = VE("animationstart"), lL = VE("transitionend"), oL = /* @__PURE__ */ new Map(), uL = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function _c(e, t) {
      oL.set(e, t), li(t, [e]);
    }
    function KV() {
      for (var e = 0; e < uL.length; e++) {
        var t = uL[e], a = t.toLowerCase(), l = t[0].toUpperCase() + t.slice(1);
        _c(a, "on" + l);
      }
      _c(rL, "onAnimationEnd"), _c(aL, "onAnimationIteration"), _c(sL, "onAnimationStart"), _c("dblclick", "onDoubleClick"), _c("focusin", "onFocus"), _c("focusout", "onBlur"), _c(lL, "onTransitionEnd");
    }
    function XV(e, t, a, l, c, m, T) {
      var E = oL.get(t);
      if (E !== void 0) {
        var b = Cs, x = t;
        switch (t) {
          case "keypress":
            if (Bl(l) === 0)
              return;
          /* falls through */
          case "keydown":
          case "keyup":
            b = $E;
            break;
          case "focusin":
            x = "focus", b = tl;
            break;
          case "focusout":
            x = "blur", b = tl;
            break;
          case "beforeblur":
          case "afterblur":
            b = tl;
            break;
          case "click":
            if (l.button === 2)
              return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            b = Ig;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            b = fu;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            b = PE;
            break;
          case rL:
          case aL:
          case sL:
            b = xE;
            break;
          case lL:
            b = Ea;
            break;
          case "scroll":
            b = Pr;
            break;
          case "wheel":
            b = Sk;
            break;
          case "copy":
          case "cut":
          case "paste":
            b = Tm;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            b = OE;
            break;
        }
        var M = (m & ha) !== 0;
        {
          var z = !M && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", N = tH(a, E, l.type, M, z);
          if (N.length > 0) {
            var q = new b(E, x, null, l, c);
            e.push({
              event: q,
              listeners: N
            });
          }
        }
      }
    }
    KV(), U(), Ek(), QV(), Tk();
    function ZV(e, t, a, l, c, m, T) {
      XV(e, t, a, l, c, m);
      var E = (m & dg) === 0;
      E && (I(e, t, a, l, c), F(e, t, a, l, c), WV(e, t, a, l, c), wk(e, t, a, l, c));
    }
    var Jg = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], Dk = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Jg));
    function cL(e, t, a) {
      var l = e.type || "unknown-event";
      e.currentTarget = a, ps(l, t, void 0, e), e.currentTarget = null;
    }
    function JV(e, t, a) {
      var l;
      if (a)
        for (var c = t.length - 1; c >= 0; c--) {
          var m = t[c], T = m.instance, E = m.currentTarget, b = m.listener;
          if (T !== l && e.isPropagationStopped())
            return;
          cL(e, b, E), l = T;
        }
      else
        for (var x = 0; x < t.length; x++) {
          var M = t[x], z = M.instance, N = M.currentTarget, q = M.listener;
          if (z !== l && e.isPropagationStopped())
            return;
          cL(e, q, N), l = z;
        }
    }
    function dL(e, t) {
      for (var a = (t & ha) !== 0, l = 0; l < e.length; l++) {
        var c = e[l], m = c.event, T = c.listeners;
        JV(m, T, a);
      }
      cf();
    }
    function eH(e, t, a, l, c) {
      var m = fg(a), T = [];
      ZV(T, e, l, a, m, t), dL(T, t);
    }
    function kn(e, t) {
      Dk.has(e) || y('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var a = !1, l = L3(t), c = rH(e);
      l.has(c) || (fL(t, e, Dp, a), l.add(c));
    }
    function Mk(e, t, a) {
      Dk.has(e) && !t && y('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var l = 0;
      t && (l |= ha), fL(a, e, l, t);
    }
    var HE = "_reactListening" + Math.random().toString(36).slice(2);
    function eS(e) {
      if (!e[HE]) {
        e[HE] = !0, ai.forEach(function(a) {
          a !== "selectionchange" && (Dk.has(a) || Mk(a, !1, e), Mk(a, !0, e));
        });
        var t = e.nodeType === Qs ? e : e.ownerDocument;
        t !== null && (t[HE] || (t[HE] = !0, Mk("selectionchange", !1, t)));
      }
    }
    function fL(e, t, a, l, c) {
      var m = Oi(e, t, a), T = void 0;
      uf && (t === "touchstart" || t === "touchmove" || t === "wheel") && (T = !0), e = e, l ? T !== void 0 ? Hg(e, t, m, T) : Ar(e, t, m) : T !== void 0 ? $c(e, t, m, T) : Ff(e, t, m);
    }
    function hL(e, t) {
      return e === t || e.nodeType === Gn && e.parentNode === t;
    }
    function Lk(e, t, a, l, c) {
      var m = l;
      if (!(t & cg) && !(t & Dp)) {
        var T = c;
        if (l !== null) {
          var E = l;
          e: for (; ; ) {
            if (E === null)
              return;
            var b = E.tag;
            if (b === A || b === B) {
              var x = E.stateNode.containerInfo;
              if (hL(x, T))
                break;
              if (b === B)
                for (var M = E.return; M !== null; ) {
                  var z = M.tag;
                  if (z === A || z === B) {
                    var N = M.stateNode.containerInfo;
                    if (hL(N, T))
                      return;
                  }
                  M = M.return;
                }
              for (; x !== null; ) {
                var q = Gf(x);
                if (q === null)
                  return;
                var Q = q.tag;
                if (Q === W || Q === ne) {
                  E = m = q;
                  continue e;
                }
                x = x.parentNode;
              }
            }
            E = E.return;
          }
        }
      }
      Xw(function() {
        return eH(e, t, a, m);
      });
    }
    function tS(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function tH(e, t, a, l, c, m) {
      for (var T = t !== null ? t + "Capture" : null, E = l ? T : t, b = [], x = e, M = null; x !== null; ) {
        var z = x, N = z.stateNode, q = z.tag;
        if (q === W && N !== null && (M = N, E !== null)) {
          var Q = Ol(x, E);
          Q != null && b.push(tS(x, Q, M));
        }
        if (c)
          break;
        x = x.return;
      }
      return b;
    }
    function IE(e, t) {
      for (var a = t + "Capture", l = [], c = e; c !== null; ) {
        var m = c, T = m.stateNode, E = m.tag;
        if (E === W && T !== null) {
          var b = T, x = Ol(c, a);
          x != null && l.unshift(tS(c, x, b));
          var M = Ol(c, t);
          M != null && l.push(tS(c, M, b));
        }
        c = c.return;
      }
      return l;
    }
    function $m(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== W);
      return e || null;
    }
    function nH(e, t) {
      for (var a = e, l = t, c = 0, m = a; m; m = $m(m))
        c++;
      for (var T = 0, E = l; E; E = $m(E))
        T++;
      for (; c - T > 0; )
        a = $m(a), c--;
      for (; T - c > 0; )
        l = $m(l), T--;
      for (var b = c; b--; ) {
        if (a === l || l !== null && a === l.alternate)
          return a;
        a = $m(a), l = $m(l);
      }
      return null;
    }
    function pL(e, t, a, l, c) {
      for (var m = t._reactName, T = [], E = a; E !== null && E !== l; ) {
        var b = E, x = b.alternate, M = b.stateNode, z = b.tag;
        if (x !== null && x === l)
          break;
        if (z === W && M !== null) {
          var N = M;
          if (c) {
            var q = Ol(E, m);
            q != null && T.unshift(tS(E, q, N));
          } else if (!c) {
            var Q = Ol(E, m);
            Q != null && T.push(tS(E, Q, N));
          }
        }
        E = E.return;
      }
      T.length !== 0 && e.push({
        event: t,
        listeners: T
      });
    }
    function iH(e, t, a, l, c) {
      var m = l && c ? nH(l, c) : null;
      l !== null && pL(e, t, l, m, !1), c !== null && a !== null && pL(e, a, c, m, !0);
    }
    function rH(e, t) {
      return e + "__bubble";
    }
    var ba = !1, nS = "dangerouslySetInnerHTML", qE = "suppressContentEditableWarning", Nc = "suppressHydrationWarning", mL = "autoFocus", Qf = "children", Yf = "style", jE = "__html", $k, BE, iS, vL, QE, yL, gL;
    $k = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, BE = function(e, t) {
      lg(e, t), xp(e, t), Gw(e, t, {
        registrationNameDependencies: si,
        possibleRegistrationNames: Ci
      });
    }, yL = Nn && !document.documentMode, iS = function(e, t, a) {
      if (!ba) {
        var l = YE(a), c = YE(t);
        c !== l && (ba = !0, y("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(c), JSON.stringify(l)));
      }
    }, vL = function(e) {
      if (!ba) {
        ba = !0;
        var t = [];
        e.forEach(function(a) {
          t.push(a);
        }), y("Extra attributes from the server: %s", t);
      }
    }, QE = function(e, t) {
      t === !1 ? y("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : y("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, gL = function(e, t) {
      var a = e.namespaceURI === js ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return a.innerHTML = t, a.innerHTML;
    };
    var aH = /\r\n?/g, sH = /\u0000|\uFFFD/g;
    function YE(e) {
      Lo(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(aH, `
`).replace(sH, "");
    }
    function GE(e, t, a, l) {
      var c = YE(t), m = YE(e);
      if (m !== c && (l && (ba || (ba = !0, y('Text content did not match. Server: "%s" Client: "%s"', m, c))), a && ot))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function SL(e) {
      return e.nodeType === Qs ? e : e.ownerDocument;
    }
    function lH() {
    }
    function WE(e) {
      e.onclick = lH;
    }
    function oH(e, t, a, l, c) {
      for (var m in l)
        if (l.hasOwnProperty(m)) {
          var T = l[m];
          if (m === Yf)
            T && Object.freeze(T), Iw(t, T);
          else if (m === nS) {
            var E = T ? T[jE] : void 0;
            E != null && Lw(t, E);
          } else if (m === Qf)
            if (typeof T == "string") {
              var b = e !== "textarea" || T !== "";
              b && hc(t, T);
            } else typeof T == "number" && hc(t, "" + T);
          else m === qE || m === Nc || m === mL || (si.hasOwnProperty(m) ? T != null && (typeof T != "function" && QE(m, T), m === "onScroll" && kn("scroll", t)) : T != null && Ao(t, m, T, c));
        }
    }
    function uH(e, t, a, l) {
      for (var c = 0; c < t.length; c += 2) {
        var m = t[c], T = t[c + 1];
        m === Yf ? Iw(e, T) : m === nS ? Lw(e, T) : m === Qf ? hc(e, T) : Ao(e, m, T, l);
      }
    }
    function cH(e, t, a, l) {
      var c, m = SL(a), T, E = l;
      if (E === js && (E = eg(e)), E === js) {
        if (c = Ll(e, t), !c && e !== e.toLowerCase() && y("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var b = m.createElement("div");
          b.innerHTML = "<script><\/script>";
          var x = b.firstChild;
          T = b.removeChild(x);
        } else if (typeof t.is == "string")
          T = m.createElement(e, {
            is: t.is
          });
        else if (T = m.createElement(e), e === "select") {
          var M = T;
          t.multiple ? M.multiple = !0 : t.size && (M.size = t.size);
        }
      } else
        T = m.createElementNS(E, e);
      return E === js && !c && Object.prototype.toString.call(T) === "[object HTMLUnknownElement]" && !er.call($k, e) && ($k[e] = !0, y("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), T;
    }
    function dH(e, t) {
      return SL(t).createTextNode(e);
    }
    function fH(e, t, a, l) {
      var c = Ll(t, a);
      BE(t, a);
      var m;
      switch (t) {
        case "dialog":
          kn("cancel", e), kn("close", e), m = a;
          break;
        case "iframe":
        case "object":
        case "embed":
          kn("load", e), m = a;
          break;
        case "video":
        case "audio":
          for (var T = 0; T < Jg.length; T++)
            kn(Jg[T], e);
          m = a;
          break;
        case "source":
          kn("error", e), m = a;
          break;
        case "img":
        case "image":
        case "link":
          kn("error", e), kn("load", e), m = a;
          break;
        case "details":
          kn("toggle", e), m = a;
          break;
        case "input":
          qs(e, a), m = mp(e, a), kn("invalid", e);
          break;
        case "option":
          dc(e, a), m = a;
          break;
        case "select":
          wp(e, a), m = Wy(e, a), kn("invalid", e);
          break;
        case "textarea":
          Xy(e, a), m = Ky(e, a), kn("invalid", e);
          break;
        default:
          m = a;
      }
      switch (Cp(t, m), oH(t, e, l, m, c), t) {
        case "input":
          Ml(e), Qy(e, a, !1);
          break;
        case "textarea":
          Ml(e), Dw(e);
          break;
        case "option":
          Q0(e, a);
          break;
        case "select":
          G0(e, a);
          break;
        default:
          typeof m.onClick == "function" && WE(e);
          break;
      }
    }
    function hH(e, t, a, l, c) {
      BE(t, l);
      var m = null, T, E;
      switch (t) {
        case "input":
          T = mp(e, a), E = mp(e, l), m = [];
          break;
        case "select":
          T = Wy(e, a), E = Wy(e, l), m = [];
          break;
        case "textarea":
          T = Ky(e, a), E = Ky(e, l), m = [];
          break;
        default:
          T = a, E = l, typeof T.onClick != "function" && typeof E.onClick == "function" && WE(e);
          break;
      }
      Cp(t, E);
      var b, x, M = null;
      for (b in T)
        if (!(E.hasOwnProperty(b) || !T.hasOwnProperty(b) || T[b] == null))
          if (b === Yf) {
            var z = T[b];
            for (x in z)
              z.hasOwnProperty(x) && (M || (M = {}), M[x] = "");
          } else b === nS || b === Qf || b === qE || b === Nc || b === mL || (si.hasOwnProperty(b) ? m || (m = []) : (m = m || []).push(b, null));
      for (b in E) {
        var N = E[b], q = T != null ? T[b] : void 0;
        if (!(!E.hasOwnProperty(b) || N === q || N == null && q == null))
          if (b === Yf)
            if (N && Object.freeze(N), q) {
              for (x in q)
                q.hasOwnProperty(x) && (!N || !N.hasOwnProperty(x)) && (M || (M = {}), M[x] = "");
              for (x in N)
                N.hasOwnProperty(x) && q[x] !== N[x] && (M || (M = {}), M[x] = N[x]);
            } else
              M || (m || (m = []), m.push(b, M)), M = N;
          else if (b === nS) {
            var Q = N ? N[jE] : void 0, Y = q ? q[jE] : void 0;
            Q != null && Y !== Q && (m = m || []).push(b, Q);
          } else b === Qf ? (typeof N == "string" || typeof N == "number") && (m = m || []).push(b, "" + N) : b === qE || b === Nc || (si.hasOwnProperty(b) ? (N != null && (typeof N != "function" && QE(b, N), b === "onScroll" && kn("scroll", e)), !m && q !== N && (m = [])) : (m = m || []).push(b, N));
      }
      return M && (ik(M, E[Yf]), (m = m || []).push(Yf, M)), m;
    }
    function pH(e, t, a, l, c) {
      a === "input" && c.type === "radio" && c.name != null && vp(e, c);
      var m = Ll(a, l), T = Ll(a, c);
      switch (uH(e, t, m, T), a) {
        case "input":
          cc(e, c);
          break;
        case "textarea":
          Rw(e, c);
          break;
        case "select":
          W0(e, c);
          break;
      }
    }
    function mH(e) {
      {
        var t = e.toLowerCase();
        return af.hasOwnProperty(t) && af[t] || null;
      }
    }
    function vH(e, t, a, l, c, m, T) {
      var E, b;
      switch (E = Ll(t, a), BE(t, a), t) {
        case "dialog":
          kn("cancel", e), kn("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          kn("load", e);
          break;
        case "video":
        case "audio":
          for (var x = 0; x < Jg.length; x++)
            kn(Jg[x], e);
          break;
        case "source":
          kn("error", e);
          break;
        case "img":
        case "image":
        case "link":
          kn("error", e), kn("load", e);
          break;
        case "details":
          kn("toggle", e);
          break;
        case "input":
          qs(e, a), kn("invalid", e);
          break;
        case "option":
          dc(e, a);
          break;
        case "select":
          wp(e, a), kn("invalid", e);
          break;
        case "textarea":
          Xy(e, a), kn("invalid", e);
          break;
      }
      Cp(t, a);
      {
        b = /* @__PURE__ */ new Set();
        for (var M = e.attributes, z = 0; z < M.length; z++) {
          var N = M[z].name.toLowerCase();
          switch (N) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              b.add(M[z].name);
          }
        }
      }
      var q = null;
      for (var Q in a)
        if (a.hasOwnProperty(Q)) {
          var Y = a[Q];
          if (Q === Qf)
            typeof Y == "string" ? e.textContent !== Y && (a[Nc] !== !0 && GE(e.textContent, Y, m, T), q = [Qf, Y]) : typeof Y == "number" && e.textContent !== "" + Y && (a[Nc] !== !0 && GE(e.textContent, Y, m, T), q = [Qf, "" + Y]);
          else if (si.hasOwnProperty(Q))
            Y != null && (typeof Y != "function" && QE(Q, Y), Q === "onScroll" && kn("scroll", e));
          else if (T && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof E == "boolean") {
            var ve = void 0, Ue = Yn(Q);
            if (a[Nc] !== !0) {
              if (!(Q === qE || Q === Nc || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Q === "value" || Q === "checked" || Q === "selected")) {
                if (Q === nS) {
                  var Me = e.innerHTML, xt = Y ? Y[jE] : void 0;
                  if (xt != null) {
                    var mt = gL(e, xt);
                    mt !== Me && iS(Q, Me, mt);
                  }
                } else if (Q === Yf) {
                  if (b.delete(Q), yL) {
                    var V = tk(Y);
                    ve = e.getAttribute("style"), V !== ve && iS(Q, ve, V);
                  }
                } else if (E)
                  b.delete(Q.toLowerCase()), ve = Oy(e, Q, Y), Y !== ve && iS(Q, ve, Y);
                else if (!wr(Q, Ue, E) && !Er(Q, Y, Ue, E)) {
                  var G = !1;
                  if (Ue !== null)
                    b.delete(Ue.attributeName), ve = $y(e, Q, Y, Ue);
                  else {
                    var H = l;
                    if (H === js && (H = eg(t)), H === js)
                      b.delete(Q.toLowerCase());
                    else {
                      var ae = mH(Q);
                      ae !== null && ae !== Q && (G = !0, b.delete(ae)), b.delete(Q);
                    }
                    ve = Oy(e, Q, Y);
                  }
                  var Ee = gt;
                  !Ee && Y !== ve && !G && iS(Q, ve, Y);
                }
              }
            }
          }
        }
      switch (T && // $FlowFixMe - Should be inferred as not undefined.
      b.size > 0 && a[Nc] !== !0 && vL(b), t) {
        case "input":
          Ml(e), Qy(e, a, !0);
          break;
        case "textarea":
          Ml(e), Dw(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof a.onClick == "function" && WE(e);
          break;
      }
      return q;
    }
    function yH(e, t, a) {
      var l = e.nodeValue !== t;
      return l;
    }
    function Ok(e, t) {
      {
        if (ba)
          return;
        ba = !0, y("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function Ak(e, t) {
      {
        if (ba)
          return;
        ba = !0, y('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function Pk(e, t, a) {
      {
        if (ba)
          return;
        ba = !0, y("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function _k(e, t) {
      {
        if (t === "" || ba)
          return;
        ba = !0, y('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function gH(e, t, a) {
      switch (t) {
        case "input":
          yp(e, a);
          return;
        case "textarea":
          X0(e, a);
          return;
        case "select":
          K0(e, a);
          return;
      }
    }
    var rS = function() {
    }, aS = function() {
    };
    {
      var SH = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], TL = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], TH = TL.concat(["button"]), wH = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], wL = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      aS = function(e, t) {
        var a = St({}, e || wL), l = {
          tag: t
        };
        return TL.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), TH.indexOf(t) !== -1 && (a.pTagInButtonScope = null), SH.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = l, t === "form" && (a.formTag = l), t === "a" && (a.aTagInScope = l), t === "button" && (a.buttonTagInScope = l), t === "nobr" && (a.nobrTagInScope = l), t === "p" && (a.pTagInButtonScope = l), t === "li" && (a.listItemTagAutoclosing = l), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = l), a;
      };
      var EH = function(e, t) {
        switch (t) {
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
          // but
          case "option":
            return e === "#text";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
          // No special behavior since these rules fall back to "in body" mode for
          // all except special table nodes which cause bad parsing behavior anyway.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
          case "colgroup":
            return e === "col" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return wH.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, bH = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, EL = {};
      rS = function(e, t, a) {
        a = a || wL;
        var l = a.current, c = l && l.tag;
        t != null && (e != null && y("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var m = EH(e, c) ? null : l, T = m ? null : bH(e, a), E = m || T;
        if (E) {
          var b = E.tag, x = !!m + "|" + e + "|" + b;
          if (!EL[x]) {
            EL[x] = !0;
            var M = e, z = "";
            if (e === "#text" ? /\S/.test(t) ? M = "Text nodes" : (M = "Whitespace text nodes", z = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : M = "<" + e + ">", m) {
              var N = "";
              b === "table" && e === "tr" && (N += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), y("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", M, b, z, N);
            } else
              y("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", M, b);
          }
        }
      };
    }
    var KE = "suppressHydrationWarning", XE = "$", ZE = "/$", sS = "$?", lS = "$!", CH = "style", Nk = null, Uk = null;
    function kH(e) {
      var t, a, l = e.nodeType;
      switch (l) {
        case Qs:
        case ng: {
          t = l === Qs ? "#document" : "#fragment";
          var c = e.documentElement;
          a = c ? c.namespaceURI : tg(null, "");
          break;
        }
        default: {
          var m = l === Gn ? e.parentNode : e, T = m.namespaceURI || null;
          t = m.tagName, a = tg(T, t);
          break;
        }
      }
      {
        var E = t.toLowerCase(), b = aS(null, E);
        return {
          namespace: a,
          ancestorInfo: b
        };
      }
    }
    function xH(e, t, a) {
      {
        var l = e, c = tg(l.namespace, t), m = aS(l.ancestorInfo, t);
        return {
          namespace: c,
          ancestorInfo: m
        };
      }
    }
    function mQ(e) {
      return e;
    }
    function RH(e) {
      Nk = ei(), Uk = HV();
      var t = null;
      return di(!1), t;
    }
    function DH(e) {
      IV(Uk), di(Nk), Nk = null, Uk = null;
    }
    function MH(e, t, a, l, c) {
      var m;
      {
        var T = l;
        if (rS(e, null, T.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var E = "" + t.children, b = aS(T.ancestorInfo, e);
          rS(null, E, b);
        }
        m = T.namespace;
      }
      var x = cH(e, t, a, m);
      return cS(c, x), Bk(x, t), x;
    }
    function LH(e, t) {
      e.appendChild(t);
    }
    function $H(e, t, a, l, c) {
      switch (fH(e, t, a, l), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!a.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function OH(e, t, a, l, c, m) {
      {
        var T = m;
        if (typeof l.children != typeof a.children && (typeof l.children == "string" || typeof l.children == "number")) {
          var E = "" + l.children, b = aS(T.ancestorInfo, t);
          rS(null, E, b);
        }
      }
      return hH(e, t, a, l);
    }
    function zk(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function AH(e, t, a, l) {
      {
        var c = a;
        rS(null, e, c.ancestorInfo);
      }
      var m = dH(e, t);
      return cS(l, m), m;
    }
    function PH() {
      var e = window.event;
      return e === void 0 ? Sa : ym(e.type);
    }
    var Fk = typeof setTimeout == "function" ? setTimeout : void 0, _H = typeof clearTimeout == "function" ? clearTimeout : void 0, Vk = -1, bL = typeof Promise == "function" ? Promise : void 0, NH = typeof queueMicrotask == "function" ? queueMicrotask : typeof bL < "u" ? function(e) {
      return bL.resolve(null).then(e).catch(UH);
    } : Fk;
    function UH(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function zH(e, t, a, l) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          return;
        case "img": {
          a.src && (e.src = a.src);
          return;
        }
      }
    }
    function FH(e, t, a, l, c, m) {
      pH(e, t, a, l, c), Bk(e, c);
    }
    function CL(e) {
      hc(e, "");
    }
    function VH(e, t, a) {
      e.nodeValue = a;
    }
    function HH(e, t) {
      e.appendChild(t);
    }
    function IH(e, t) {
      var a;
      e.nodeType === Gn ? (a = e.parentNode, a.insertBefore(t, e)) : (a = e, a.appendChild(t));
      var l = e._reactRootContainer;
      l == null && a.onclick === null && WE(a);
    }
    function qH(e, t, a) {
      e.insertBefore(t, a);
    }
    function jH(e, t, a) {
      e.nodeType === Gn ? e.parentNode.insertBefore(t, a) : e.insertBefore(t, a);
    }
    function BH(e, t) {
      e.removeChild(t);
    }
    function QH(e, t) {
      e.nodeType === Gn ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function Hk(e, t) {
      var a = t, l = 0;
      do {
        var c = a.nextSibling;
        if (e.removeChild(a), c && c.nodeType === Gn) {
          var m = c.data;
          if (m === ZE)
            if (l === 0) {
              e.removeChild(c), uu(t);
              return;
            } else
              l--;
          else (m === XE || m === sS || m === lS) && l++;
        }
        a = c;
      } while (a);
      uu(t);
    }
    function YH(e, t) {
      e.nodeType === Gn ? Hk(e.parentNode, t) : e.nodeType === Cr && Hk(e, t), uu(e);
    }
    function GH(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function WH(e) {
      e.nodeValue = "";
    }
    function KH(e, t) {
      e = e;
      var a = t[CH], l = a != null && a.hasOwnProperty("display") ? a.display : null;
      e.style.display = bp("display", l);
    }
    function XH(e, t) {
      e.nodeValue = t;
    }
    function ZH(e) {
      e.nodeType === Cr ? e.textContent = "" : e.nodeType === Qs && e.documentElement && e.removeChild(e.documentElement);
    }
    function JH(e, t, a) {
      return e.nodeType !== Cr || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function e3(e, t) {
      return t === "" || e.nodeType !== Bs ? null : e;
    }
    function t3(e) {
      return e.nodeType !== Gn ? null : e;
    }
    function kL(e) {
      return e.data === sS;
    }
    function Ik(e) {
      return e.data === lS;
    }
    function n3(e) {
      var t = e.nextSibling && e.nextSibling.dataset, a, l, c;
      return t && (a = t.dgst, l = t.msg, c = t.stck), {
        message: l,
        digest: a,
        stack: c
      };
    }
    function i3(e, t) {
      e._reactRetry = t;
    }
    function JE(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === Cr || t === Bs)
          break;
        if (t === Gn) {
          var a = e.data;
          if (a === XE || a === lS || a === sS)
            break;
          if (a === ZE)
            return null;
        }
      }
      return e;
    }
    function oS(e) {
      return JE(e.nextSibling);
    }
    function r3(e) {
      return JE(e.firstChild);
    }
    function a3(e) {
      return JE(e.firstChild);
    }
    function s3(e) {
      return JE(e.nextSibling);
    }
    function l3(e, t, a, l, c, m, T) {
      cS(m, e), Bk(e, a);
      var E;
      {
        var b = c;
        E = b.namespace;
      }
      var x = (m.mode & dt) !== _e;
      return vH(e, t, a, E, l, x, T);
    }
    function o3(e, t, a, l) {
      return cS(a, e), a.mode & dt, yH(e, t);
    }
    function u3(e, t) {
      cS(t, e);
    }
    function c3(e) {
      for (var t = e.nextSibling, a = 0; t; ) {
        if (t.nodeType === Gn) {
          var l = t.data;
          if (l === ZE) {
            if (a === 0)
              return oS(t);
            a--;
          } else (l === XE || l === lS || l === sS) && a++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function xL(e) {
      for (var t = e.previousSibling, a = 0; t; ) {
        if (t.nodeType === Gn) {
          var l = t.data;
          if (l === XE || l === lS || l === sS) {
            if (a === 0)
              return t;
            a--;
          } else l === ZE && a++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function d3(e) {
      uu(e);
    }
    function f3(e) {
      uu(e);
    }
    function h3(e) {
      return e !== "head" && e !== "body";
    }
    function p3(e, t, a, l) {
      var c = !0;
      GE(t.nodeValue, a, l, c);
    }
    function m3(e, t, a, l, c, m) {
      if (t[KE] !== !0) {
        var T = !0;
        GE(l.nodeValue, c, m, T);
      }
    }
    function v3(e, t) {
      t.nodeType === Cr ? Ok(e, t) : t.nodeType === Gn || Ak(e, t);
    }
    function y3(e, t) {
      {
        var a = e.parentNode;
        a !== null && (t.nodeType === Cr ? Ok(a, t) : t.nodeType === Gn || Ak(a, t));
      }
    }
    function g3(e, t, a, l, c) {
      (c || t[KE] !== !0) && (l.nodeType === Cr ? Ok(a, l) : l.nodeType === Gn || Ak(a, l));
    }
    function S3(e, t, a) {
      Pk(e, t);
    }
    function T3(e, t) {
      _k(e, t);
    }
    function w3(e, t, a) {
      {
        var l = e.parentNode;
        l !== null && Pk(l, t);
      }
    }
    function E3(e, t) {
      {
        var a = e.parentNode;
        a !== null && _k(a, t);
      }
    }
    function b3(e, t, a, l, c, m) {
      (m || t[KE] !== !0) && Pk(a, l);
    }
    function C3(e, t, a, l, c) {
      (c || t[KE] !== !0) && _k(a, l);
    }
    function k3(e) {
      y("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function x3(e) {
      eS(e);
    }
    var Om = Math.random().toString(36).slice(2), Am = "__reactFiber$" + Om, qk = "__reactProps$" + Om, uS = "__reactContainer$" + Om, jk = "__reactEvents$" + Om, R3 = "__reactListeners$" + Om, D3 = "__reactHandles$" + Om;
    function M3(e) {
      delete e[Am], delete e[qk], delete e[jk], delete e[R3], delete e[D3];
    }
    function cS(e, t) {
      t[Am] = e;
    }
    function eb(e, t) {
      t[uS] = e;
    }
    function RL(e) {
      e[uS] = null;
    }
    function dS(e) {
      return !!e[uS];
    }
    function Gf(e) {
      var t = e[Am];
      if (t)
        return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[uS] || a[Am], t) {
          var l = t.alternate;
          if (t.child !== null || l !== null && l.child !== null)
            for (var c = xL(e); c !== null; ) {
              var m = c[Am];
              if (m)
                return m;
              c = xL(c);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function Uc(e) {
      var t = e[Am] || e[uS];
      return t && (t.tag === W || t.tag === ne || t.tag === Ye || t.tag === A) ? t : null;
    }
    function Pm(e) {
      if (e.tag === W || e.tag === ne)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function tb(e) {
      return e[qk] || null;
    }
    function Bk(e, t) {
      e[qk] = t;
    }
    function L3(e) {
      var t = e[jk];
      return t === void 0 && (t = e[jk] = /* @__PURE__ */ new Set()), t;
    }
    var DL = {}, ML = n.ReactDebugCurrentFrame;
    function nb(e) {
      if (e) {
        var t = e._owner, a = zo(e.type, e._source, t ? t.type : null);
        ML.setExtraStackFrame(a);
      } else
        ML.setExtraStackFrame(null);
    }
    function il(e, t, a, l, c) {
      {
        var m = Function.call.bind(er);
        for (var T in e)
          if (m(e, T)) {
            var E = void 0;
            try {
              if (typeof e[T] != "function") {
                var b = Error((l || "React class") + ": " + a + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw b.name = "Invariant Violation", b;
              }
              E = e[T](t, T, l, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              E = x;
            }
            E && !(E instanceof Error) && (nb(c), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", a, T, typeof E), nb(null)), E instanceof Error && !(E.message in DL) && (DL[E.message] = !0, nb(c), y("Failed %s type: %s", a, E.message), nb(null));
          }
      }
    }
    var Qk = [], ib;
    ib = [];
    var pu = -1;
    function zc(e) {
      return {
        current: e
      };
    }
    function _r(e, t) {
      if (pu < 0) {
        y("Unexpected pop.");
        return;
      }
      t !== ib[pu] && y("Unexpected Fiber popped."), e.current = Qk[pu], Qk[pu] = null, ib[pu] = null, pu--;
    }
    function Nr(e, t, a) {
      pu++, Qk[pu] = e.current, ib[pu] = a, e.current = t;
    }
    var Yk;
    Yk = {};
    var Ka = {};
    Object.freeze(Ka);
    var mu = zc(Ka), Kl = zc(!1), Gk = Ka;
    function _m(e, t, a) {
      return a && Xl(t) ? Gk : mu.current;
    }
    function LL(e, t, a) {
      {
        var l = e.stateNode;
        l.__reactInternalMemoizedUnmaskedChildContext = t, l.__reactInternalMemoizedMaskedChildContext = a;
      }
    }
    function Nm(e, t) {
      {
        var a = e.type, l = a.contextTypes;
        if (!l)
          return Ka;
        var c = e.stateNode;
        if (c && c.__reactInternalMemoizedUnmaskedChildContext === t)
          return c.__reactInternalMemoizedMaskedChildContext;
        var m = {};
        for (var T in l)
          m[T] = t[T];
        {
          var E = nt(e) || "Unknown";
          il(l, m, "context", E);
        }
        return c && LL(e, t, m), m;
      }
    }
    function rb() {
      return Kl.current;
    }
    function Xl(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function ab(e) {
      _r(Kl, e), _r(mu, e);
    }
    function Wk(e) {
      _r(Kl, e), _r(mu, e);
    }
    function $L(e, t, a) {
      {
        if (mu.current !== Ka)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Nr(mu, t, e), Nr(Kl, a, e);
      }
    }
    function OL(e, t, a) {
      {
        var l = e.stateNode, c = t.childContextTypes;
        if (typeof l.getChildContext != "function") {
          {
            var m = nt(e) || "Unknown";
            Yk[m] || (Yk[m] = !0, y("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", m, m));
          }
          return a;
        }
        var T = l.getChildContext();
        for (var E in T)
          if (!(E in c))
            throw new Error((nt(e) || "Unknown") + '.getChildContext(): key "' + E + '" is not defined in childContextTypes.');
        {
          var b = nt(e) || "Unknown";
          il(c, T, "child context", b);
        }
        return St({}, a, T);
      }
    }
    function sb(e) {
      {
        var t = e.stateNode, a = t && t.__reactInternalMemoizedMergedChildContext || Ka;
        return Gk = mu.current, Nr(mu, a, e), Nr(Kl, Kl.current, e), !0;
      }
    }
    function AL(e, t, a) {
      {
        var l = e.stateNode;
        if (!l)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (a) {
          var c = OL(e, t, Gk);
          l.__reactInternalMemoizedMergedChildContext = c, _r(Kl, e), _r(mu, e), Nr(mu, c, e), Nr(Kl, a, e);
        } else
          _r(Kl, e), Nr(Kl, a, e);
      }
    }
    function $3(e) {
      {
        if (!Wo(e) || e.tag !== $)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case A:
              return t.stateNode.context;
            case $: {
              var a = t.type;
              if (Xl(a))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Fc = 0, lb = 1, vu = null, Kk = !1, Xk = !1;
    function PL(e) {
      vu === null ? vu = [e] : vu.push(e);
    }
    function O3(e) {
      Kk = !0, PL(e);
    }
    function _L() {
      Kk && Vc();
    }
    function Vc() {
      if (!Xk && vu !== null) {
        Xk = !0;
        var e = 0, t = wa();
        try {
          var a = !0, l = vu;
          for (Jn(ir); e < l.length; e++) {
            var c = l[e];
            do
              c = c(a);
            while (c !== null);
          }
          vu = null, Kk = !1;
        } catch (m) {
          throw vu !== null && (vu = vu.slice(e + 1)), pg(hf, Vc), m;
        } finally {
          Jn(t), Xk = !1;
        }
      }
      return null;
    }
    var Um = [], zm = 0, ob = null, ub = 0, ks = [], xs = 0, Wf = null, yu = 1, gu = "";
    function A3(e) {
      return Xf(), (e.flags & ms) !== Pe;
    }
    function P3(e) {
      return Xf(), ub;
    }
    function _3() {
      var e = gu, t = yu, a = t & ~N3(t);
      return a.toString(32) + e;
    }
    function Kf(e, t) {
      Xf(), Um[zm++] = ub, Um[zm++] = ob, ob = e, ub = t;
    }
    function NL(e, t, a) {
      Xf(), ks[xs++] = yu, ks[xs++] = gu, ks[xs++] = Wf, Wf = e;
      var l = yu, c = gu, m = cb(l) - 1, T = l & ~(1 << m), E = a + 1, b = cb(t) + m;
      if (b > 30) {
        var x = m - m % 5, M = (1 << x) - 1, z = (T & M).toString(32), N = T >> x, q = m - x, Q = cb(t) + q, Y = E << q, ve = Y | N, Ue = z + c;
        yu = 1 << Q | ve, gu = Ue;
      } else {
        var Me = E << m, xt = Me | T, mt = c;
        yu = 1 << b | xt, gu = mt;
      }
    }
    function Zk(e) {
      Xf();
      var t = e.return;
      if (t !== null) {
        var a = 1, l = 0;
        Kf(e, a), NL(e, a, l);
      }
    }
    function cb(e) {
      return 32 - Xn(e);
    }
    function N3(e) {
      return 1 << cb(e) - 1;
    }
    function Jk(e) {
      for (; e === ob; )
        ob = Um[--zm], Um[zm] = null, ub = Um[--zm], Um[zm] = null;
      for (; e === Wf; )
        Wf = ks[--xs], ks[xs] = null, gu = ks[--xs], ks[xs] = null, yu = ks[--xs], ks[xs] = null;
    }
    function U3() {
      return Xf(), Wf !== null ? {
        id: yu,
        overflow: gu
      } : null;
    }
    function z3(e, t) {
      Xf(), ks[xs++] = yu, ks[xs++] = gu, ks[xs++] = Wf, yu = t.id, gu = t.overflow, Wf = e;
    }
    function Xf() {
      or() || y("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var lr = null, Rs = null, rl = !1, Zf = !1, Hc = null;
    function F3() {
      rl && y("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function UL() {
      Zf = !0;
    }
    function V3() {
      return Zf;
    }
    function H3(e) {
      var t = e.stateNode.containerInfo;
      return Rs = a3(t), lr = e, rl = !0, Hc = null, Zf = !1, !0;
    }
    function I3(e, t, a) {
      return Rs = s3(t), lr = e, rl = !0, Hc = null, Zf = !1, a !== null && z3(e, a), !0;
    }
    function zL(e, t) {
      switch (e.tag) {
        case A: {
          v3(e.stateNode.containerInfo, t);
          break;
        }
        case W: {
          var a = (e.mode & dt) !== _e;
          g3(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            a
          );
          break;
        }
        case Ye: {
          var l = e.memoizedState;
          l.dehydrated !== null && y3(l.dehydrated, t);
          break;
        }
      }
    }
    function FL(e, t) {
      zL(e, t);
      var a = Qq();
      a.stateNode = t, a.return = e;
      var l = e.deletions;
      l === null ? (e.deletions = [a], e.flags |= pa) : l.push(a);
    }
    function ex(e, t) {
      {
        if (Zf)
          return;
        switch (e.tag) {
          case A: {
            var a = e.stateNode.containerInfo;
            switch (t.tag) {
              case W:
                var l = t.type;
                t.pendingProps, S3(a, l);
                break;
              case ne:
                var c = t.pendingProps;
                T3(a, c);
                break;
            }
            break;
          }
          case W: {
            var m = e.type, T = e.memoizedProps, E = e.stateNode;
            switch (t.tag) {
              case W: {
                var b = t.type, x = t.pendingProps, M = (e.mode & dt) !== _e;
                b3(
                  m,
                  T,
                  E,
                  b,
                  x,
                  // TODO: Delete this argument when we remove the legacy root API.
                  M
                );
                break;
              }
              case ne: {
                var z = t.pendingProps, N = (e.mode & dt) !== _e;
                C3(
                  m,
                  T,
                  E,
                  z,
                  // TODO: Delete this argument when we remove the legacy root API.
                  N
                );
                break;
              }
            }
            break;
          }
          case Ye: {
            var q = e.memoizedState, Q = q.dehydrated;
            if (Q !== null) switch (t.tag) {
              case W:
                var Y = t.type;
                t.pendingProps, w3(Q, Y);
                break;
              case ne:
                var ve = t.pendingProps;
                E3(Q, ve);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function VL(e, t) {
      t.flags = t.flags & -4097 | Un, ex(e, t);
    }
    function HL(e, t) {
      switch (e.tag) {
        case W: {
          var a = e.type;
          e.pendingProps;
          var l = JH(t, a);
          return l !== null ? (e.stateNode = l, lr = e, Rs = r3(l), !0) : !1;
        }
        case ne: {
          var c = e.pendingProps, m = e3(t, c);
          return m !== null ? (e.stateNode = m, lr = e, Rs = null, !0) : !1;
        }
        case Ye: {
          var T = t3(t);
          if (T !== null) {
            var E = {
              dehydrated: T,
              treeContext: U3(),
              retryLane: Wr
            };
            e.memoizedState = E;
            var b = Yq(T);
            return b.return = e, e.child = b, lr = e, Rs = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function tx(e) {
      return (e.mode & dt) !== _e && (e.flags & Oe) === Pe;
    }
    function nx(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function ix(e) {
      if (rl) {
        var t = Rs;
        if (!t) {
          tx(e) && (ex(lr, e), nx()), VL(lr, e), rl = !1, lr = e;
          return;
        }
        var a = t;
        if (!HL(e, t)) {
          tx(e) && (ex(lr, e), nx()), t = oS(a);
          var l = lr;
          if (!t || !HL(e, t)) {
            VL(lr, e), rl = !1, lr = e;
            return;
          }
          FL(l, a);
        }
      }
    }
    function q3(e, t, a) {
      var l = e.stateNode, c = !Zf, m = l3(l, e.type, e.memoizedProps, t, a, e, c);
      return e.updateQueue = m, m !== null;
    }
    function j3(e) {
      var t = e.stateNode, a = e.memoizedProps, l = o3(t, a, e);
      if (l) {
        var c = lr;
        if (c !== null)
          switch (c.tag) {
            case A: {
              var m = c.stateNode.containerInfo, T = (c.mode & dt) !== _e;
              p3(
                m,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                T
              );
              break;
            }
            case W: {
              var E = c.type, b = c.memoizedProps, x = c.stateNode, M = (c.mode & dt) !== _e;
              m3(
                E,
                b,
                x,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                M
              );
              break;
            }
          }
      }
      return l;
    }
    function B3(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      u3(a, e);
    }
    function Q3(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return c3(a);
    }
    function IL(e) {
      for (var t = e.return; t !== null && t.tag !== W && t.tag !== A && t.tag !== Ye; )
        t = t.return;
      lr = t;
    }
    function db(e) {
      if (e !== lr)
        return !1;
      if (!rl)
        return IL(e), rl = !0, !1;
      if (e.tag !== A && (e.tag !== W || h3(e.type) && !zk(e.type, e.memoizedProps))) {
        var t = Rs;
        if (t)
          if (tx(e))
            qL(e), nx();
          else
            for (; t; )
              FL(e, t), t = oS(t);
      }
      return IL(e), e.tag === Ye ? Rs = Q3(e) : Rs = lr ? oS(e.stateNode) : null, !0;
    }
    function Y3() {
      return rl && Rs !== null;
    }
    function qL(e) {
      for (var t = Rs; t; )
        zL(e, t), t = oS(t);
    }
    function Fm() {
      lr = null, Rs = null, rl = !1, Zf = !1;
    }
    function jL() {
      Hc !== null && (UO(Hc), Hc = null);
    }
    function or() {
      return rl;
    }
    function rx(e) {
      Hc === null ? Hc = [e] : Hc.push(e);
    }
    var G3 = n.ReactCurrentBatchConfig, W3 = null;
    function K3() {
      return G3.transition;
    }
    var al = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var X3 = function(e) {
        for (var t = null, a = e; a !== null; )
          a.mode & Jt && (t = a), a = a.return;
        return t;
      }, Jf = function(e) {
        var t = [];
        return e.forEach(function(a) {
          t.push(a);
        }), t.sort().join(", ");
      }, fS = [], hS = [], pS = [], mS = [], vS = [], yS = [], eh = /* @__PURE__ */ new Set();
      al.recordUnsafeLifecycleWarnings = function(e, t) {
        eh.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && fS.push(e), e.mode & Jt && typeof t.UNSAFE_componentWillMount == "function" && hS.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && pS.push(e), e.mode & Jt && typeof t.UNSAFE_componentWillReceiveProps == "function" && mS.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && vS.push(e), e.mode & Jt && typeof t.UNSAFE_componentWillUpdate == "function" && yS.push(e));
      }, al.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        fS.length > 0 && (fS.forEach(function(N) {
          e.add(nt(N) || "Component"), eh.add(N.type);
        }), fS = []);
        var t = /* @__PURE__ */ new Set();
        hS.length > 0 && (hS.forEach(function(N) {
          t.add(nt(N) || "Component"), eh.add(N.type);
        }), hS = []);
        var a = /* @__PURE__ */ new Set();
        pS.length > 0 && (pS.forEach(function(N) {
          a.add(nt(N) || "Component"), eh.add(N.type);
        }), pS = []);
        var l = /* @__PURE__ */ new Set();
        mS.length > 0 && (mS.forEach(function(N) {
          l.add(nt(N) || "Component"), eh.add(N.type);
        }), mS = []);
        var c = /* @__PURE__ */ new Set();
        vS.length > 0 && (vS.forEach(function(N) {
          c.add(nt(N) || "Component"), eh.add(N.type);
        }), vS = []);
        var m = /* @__PURE__ */ new Set();
        if (yS.length > 0 && (yS.forEach(function(N) {
          m.add(nt(N) || "Component"), eh.add(N.type);
        }), yS = []), t.size > 0) {
          var T = Jf(t);
          y(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, T);
        }
        if (l.size > 0) {
          var E = Jf(l);
          y(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, E);
        }
        if (m.size > 0) {
          var b = Jf(m);
          y(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, b);
        }
        if (e.size > 0) {
          var x = Jf(e);
          v(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, x);
        }
        if (a.size > 0) {
          var M = Jf(a);
          v(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (c.size > 0) {
          var z = Jf(c);
          v(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, z);
        }
      };
      var fb = /* @__PURE__ */ new Map(), BL = /* @__PURE__ */ new Set();
      al.recordLegacyContextWarning = function(e, t) {
        var a = X3(e);
        if (a === null) {
          y("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!BL.has(e.type)) {
          var l = fb.get(a);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (l === void 0 && (l = [], fb.set(a, l)), l.push(e));
        }
      }, al.flushLegacyContextWarning = function() {
        fb.forEach(function(e, t) {
          if (e.length !== 0) {
            var a = e[0], l = /* @__PURE__ */ new Set();
            e.forEach(function(m) {
              l.add(nt(m) || "Component"), BL.add(m.type);
            });
            var c = Jf(l);
            try {
              pn(a), y(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c);
            } finally {
              On();
            }
          }
        });
      }, al.discardPendingWarnings = function() {
        fS = [], hS = [], pS = [], mS = [], vS = [], yS = [], fb = /* @__PURE__ */ new Map();
      };
    }
    var ax, sx, lx, ox, ux, QL = function(e, t) {
    };
    ax = !1, sx = !1, lx = {}, ox = {}, ux = {}, QL = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var a = nt(t) || "Component";
        ox[a] || (ox[a] = !0, y('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function Z3(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function gS(e, t, a) {
      var l = a.ref;
      if (l !== null && typeof l != "function" && typeof l != "object") {
        if ((e.mode & Jt || Nt) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(a._owner && a._self && a._owner.stateNode !== a._self) && // Will already throw with "Function components cannot have string refs"
        !(a._owner && a._owner.tag !== $) && // Will already warn with "Function components cannot be given refs"
        !(typeof a.type == "function" && !Z3(a.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        a._owner) {
          var c = nt(e) || "Component";
          lx[c] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', c, l), lx[c] = !0);
        }
        if (a._owner) {
          var m = a._owner, T;
          if (m) {
            var E = m;
            if (E.tag !== $)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            T = E.stateNode;
          }
          if (!T)
            throw new Error("Missing owner for string ref " + l + ". This error is likely caused by a bug in React. Please file an issue.");
          var b = T;
          Id(l, "ref");
          var x = "" + l;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === x)
            return t.ref;
          var M = function(z) {
            var N = b.refs;
            z === null ? delete N[x] : N[x] = z;
          };
          return M._stringRef = x, M;
        } else {
          if (typeof l != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!a._owner)
            throw new Error("Element ref was specified as a string (" + l + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return l;
    }
    function hb(e, t) {
      var a = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead.");
    }
    function pb(e) {
      {
        var t = nt(e) || "Component";
        if (ux[t])
          return;
        ux[t] = !0, y("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function YL(e) {
      var t = e._payload, a = e._init;
      return a(t);
    }
    function GL(e) {
      function t(V, G) {
        if (e) {
          var H = V.deletions;
          H === null ? (V.deletions = [G], V.flags |= pa) : H.push(G);
        }
      }
      function a(V, G) {
        if (!e)
          return null;
        for (var H = G; H !== null; )
          t(V, H), H = H.sibling;
        return null;
      }
      function l(V, G) {
        for (var H = /* @__PURE__ */ new Map(), ae = G; ae !== null; )
          ae.key !== null ? H.set(ae.key, ae) : H.set(ae.index, ae), ae = ae.sibling;
        return H;
      }
      function c(V, G) {
        var H = uh(V, G);
        return H.index = 0, H.sibling = null, H;
      }
      function m(V, G, H) {
        if (V.index = H, !e)
          return V.flags |= ms, G;
        var ae = V.alternate;
        if (ae !== null) {
          var Ee = ae.index;
          return Ee < G ? (V.flags |= Un, G) : Ee;
        } else
          return V.flags |= Un, G;
      }
      function T(V) {
        return e && V.alternate === null && (V.flags |= Un), V;
      }
      function E(V, G, H, ae) {
        if (G === null || G.tag !== ne) {
          var Ee = rR(H, V.mode, ae);
          return Ee.return = V, Ee;
        } else {
          var Se = c(G, H);
          return Se.return = V, Se;
        }
      }
      function b(V, G, H, ae) {
        var Ee = H.type;
        if (Ee === ac)
          return M(V, G, H.props.children, ae, H.key);
        if (G !== null && (G.elementType === Ee || // Keep this check inline so it only runs on the false path:
        JO(G, H) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Ee == "object" && Ee !== null && Ee.$$typeof === qi && YL(Ee) === G.type)) {
          var Se = c(G, H.props);
          return Se.ref = gS(V, G, H), Se.return = V, Se._debugSource = H._source, Se._debugOwner = H._owner, Se;
        }
        var Qe = iR(H, V.mode, ae);
        return Qe.ref = gS(V, G, H), Qe.return = V, Qe;
      }
      function x(V, G, H, ae) {
        if (G === null || G.tag !== B || G.stateNode.containerInfo !== H.containerInfo || G.stateNode.implementation !== H.implementation) {
          var Ee = aR(H, V.mode, ae);
          return Ee.return = V, Ee;
        } else {
          var Se = c(G, H.children || []);
          return Se.return = V, Se;
        }
      }
      function M(V, G, H, ae, Ee) {
        if (G === null || G.tag !== ce) {
          var Se = Zc(H, V.mode, ae, Ee);
          return Se.return = V, Se;
        } else {
          var Qe = c(G, H);
          return Qe.return = V, Qe;
        }
      }
      function z(V, G, H) {
        if (typeof G == "string" && G !== "" || typeof G == "number") {
          var ae = rR("" + G, V.mode, H);
          return ae.return = V, ae;
        }
        if (typeof G == "object" && G !== null) {
          switch (G.$$typeof) {
            case xl: {
              var Ee = iR(G, V.mode, H);
              return Ee.ref = gS(V, null, G), Ee.return = V, Ee;
            }
            case Fa: {
              var Se = aR(G, V.mode, H);
              return Se.return = V, Se;
            }
            case qi: {
              var Qe = G._payload, et = G._init;
              return z(V, et(Qe), H);
            }
          }
          if (Di(G) || sn(G)) {
            var tn = Zc(G, V.mode, H, null);
            return tn.return = V, tn;
          }
          hb(V, G);
        }
        return typeof G == "function" && pb(V), null;
      }
      function N(V, G, H, ae) {
        var Ee = G !== null ? G.key : null;
        if (typeof H == "string" && H !== "" || typeof H == "number")
          return Ee !== null ? null : E(V, G, "" + H, ae);
        if (typeof H == "object" && H !== null) {
          switch (H.$$typeof) {
            case xl:
              return H.key === Ee ? b(V, G, H, ae) : null;
            case Fa:
              return H.key === Ee ? x(V, G, H, ae) : null;
            case qi: {
              var Se = H._payload, Qe = H._init;
              return N(V, G, Qe(Se), ae);
            }
          }
          if (Di(H) || sn(H))
            return Ee !== null ? null : M(V, G, H, ae, null);
          hb(V, H);
        }
        return typeof H == "function" && pb(V), null;
      }
      function q(V, G, H, ae, Ee) {
        if (typeof ae == "string" && ae !== "" || typeof ae == "number") {
          var Se = V.get(H) || null;
          return E(G, Se, "" + ae, Ee);
        }
        if (typeof ae == "object" && ae !== null) {
          switch (ae.$$typeof) {
            case xl: {
              var Qe = V.get(ae.key === null ? H : ae.key) || null;
              return b(G, Qe, ae, Ee);
            }
            case Fa: {
              var et = V.get(ae.key === null ? H : ae.key) || null;
              return x(G, et, ae, Ee);
            }
            case qi:
              var tn = ae._payload, Vt = ae._init;
              return q(V, G, H, Vt(tn), Ee);
          }
          if (Di(ae) || sn(ae)) {
            var hi = V.get(H) || null;
            return M(G, hi, ae, Ee, null);
          }
          hb(G, ae);
        }
        return typeof ae == "function" && pb(G), null;
      }
      function Q(V, G, H) {
        {
          if (typeof V != "object" || V === null)
            return G;
          switch (V.$$typeof) {
            case xl:
            case Fa:
              QL(V, H);
              var ae = V.key;
              if (typeof ae != "string")
                break;
              if (G === null) {
                G = /* @__PURE__ */ new Set(), G.add(ae);
                break;
              }
              if (!G.has(ae)) {
                G.add(ae);
                break;
              }
              y("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", ae);
              break;
            case qi:
              var Ee = V._payload, Se = V._init;
              Q(Se(Ee), G, H);
              break;
          }
        }
        return G;
      }
      function Y(V, G, H, ae) {
        for (var Ee = null, Se = 0; Se < H.length; Se++) {
          var Qe = H[Se];
          Ee = Q(Qe, Ee, V);
        }
        for (var et = null, tn = null, Vt = G, hi = 0, Ht = 0, ni = null; Vt !== null && Ht < H.length; Ht++) {
          Vt.index > Ht ? (ni = Vt, Vt = null) : ni = Vt.sibling;
          var zr = N(V, Vt, H[Ht], ae);
          if (zr === null) {
            Vt === null && (Vt = ni);
            break;
          }
          e && Vt && zr.alternate === null && t(V, Vt), hi = m(zr, hi, Ht), tn === null ? et = zr : tn.sibling = zr, tn = zr, Vt = ni;
        }
        if (Ht === H.length) {
          if (a(V, Vt), or()) {
            var mr = Ht;
            Kf(V, mr);
          }
          return et;
        }
        if (Vt === null) {
          for (; Ht < H.length; Ht++) {
            var Za = z(V, H[Ht], ae);
            Za !== null && (hi = m(Za, hi, Ht), tn === null ? et = Za : tn.sibling = Za, tn = Za);
          }
          if (or()) {
            var ta = Ht;
            Kf(V, ta);
          }
          return et;
        }
        for (var na = l(V, Vt); Ht < H.length; Ht++) {
          var Fr = q(na, V, Ht, H[Ht], ae);
          Fr !== null && (e && Fr.alternate !== null && na.delete(Fr.key === null ? Ht : Fr.key), hi = m(Fr, hi, Ht), tn === null ? et = Fr : tn.sibling = Fr, tn = Fr);
        }
        if (e && na.forEach(function(rv) {
          return t(V, rv);
        }), or()) {
          var ku = Ht;
          Kf(V, ku);
        }
        return et;
      }
      function ve(V, G, H, ae) {
        var Ee = sn(H);
        if (typeof Ee != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          H[Symbol.toStringTag] === "Generator" && (sx || y("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), sx = !0), H.entries === Ee && (ax || y("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), ax = !0);
          var Se = Ee.call(H);
          if (Se)
            for (var Qe = null, et = Se.next(); !et.done; et = Se.next()) {
              var tn = et.value;
              Qe = Q(tn, Qe, V);
            }
        }
        var Vt = Ee.call(H);
        if (Vt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var hi = null, Ht = null, ni = G, zr = 0, mr = 0, Za = null, ta = Vt.next(); ni !== null && !ta.done; mr++, ta = Vt.next()) {
          ni.index > mr ? (Za = ni, ni = null) : Za = ni.sibling;
          var na = N(V, ni, ta.value, ae);
          if (na === null) {
            ni === null && (ni = Za);
            break;
          }
          e && ni && na.alternate === null && t(V, ni), zr = m(na, zr, mr), Ht === null ? hi = na : Ht.sibling = na, Ht = na, ni = Za;
        }
        if (ta.done) {
          if (a(V, ni), or()) {
            var Fr = mr;
            Kf(V, Fr);
          }
          return hi;
        }
        if (ni === null) {
          for (; !ta.done; mr++, ta = Vt.next()) {
            var ku = z(V, ta.value, ae);
            ku !== null && (zr = m(ku, zr, mr), Ht === null ? hi = ku : Ht.sibling = ku, Ht = ku);
          }
          if (or()) {
            var rv = mr;
            Kf(V, rv);
          }
          return hi;
        }
        for (var KS = l(V, ni); !ta.done; mr++, ta = Vt.next()) {
          var ao = q(KS, V, mr, ta.value, ae);
          ao !== null && (e && ao.alternate !== null && KS.delete(ao.key === null ? mr : ao.key), zr = m(ao, zr, mr), Ht === null ? hi = ao : Ht.sibling = ao, Ht = ao);
        }
        if (e && KS.forEach(function(Cj) {
          return t(V, Cj);
        }), or()) {
          var bj = mr;
          Kf(V, bj);
        }
        return hi;
      }
      function Ue(V, G, H, ae) {
        if (G !== null && G.tag === ne) {
          a(V, G.sibling);
          var Ee = c(G, H);
          return Ee.return = V, Ee;
        }
        a(V, G);
        var Se = rR(H, V.mode, ae);
        return Se.return = V, Se;
      }
      function Me(V, G, H, ae) {
        for (var Ee = H.key, Se = G; Se !== null; ) {
          if (Se.key === Ee) {
            var Qe = H.type;
            if (Qe === ac) {
              if (Se.tag === ce) {
                a(V, Se.sibling);
                var et = c(Se, H.props.children);
                return et.return = V, et._debugSource = H._source, et._debugOwner = H._owner, et;
              }
            } else if (Se.elementType === Qe || // Keep this check inline so it only runs on the false path:
            JO(Se, H) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Qe == "object" && Qe !== null && Qe.$$typeof === qi && YL(Qe) === Se.type) {
              a(V, Se.sibling);
              var tn = c(Se, H.props);
              return tn.ref = gS(V, Se, H), tn.return = V, tn._debugSource = H._source, tn._debugOwner = H._owner, tn;
            }
            a(V, Se);
            break;
          } else
            t(V, Se);
          Se = Se.sibling;
        }
        if (H.type === ac) {
          var Vt = Zc(H.props.children, V.mode, ae, H.key);
          return Vt.return = V, Vt;
        } else {
          var hi = iR(H, V.mode, ae);
          return hi.ref = gS(V, G, H), hi.return = V, hi;
        }
      }
      function xt(V, G, H, ae) {
        for (var Ee = H.key, Se = G; Se !== null; ) {
          if (Se.key === Ee)
            if (Se.tag === B && Se.stateNode.containerInfo === H.containerInfo && Se.stateNode.implementation === H.implementation) {
              a(V, Se.sibling);
              var Qe = c(Se, H.children || []);
              return Qe.return = V, Qe;
            } else {
              a(V, Se);
              break;
            }
          else
            t(V, Se);
          Se = Se.sibling;
        }
        var et = aR(H, V.mode, ae);
        return et.return = V, et;
      }
      function mt(V, G, H, ae) {
        var Ee = typeof H == "object" && H !== null && H.type === ac && H.key === null;
        if (Ee && (H = H.props.children), typeof H == "object" && H !== null) {
          switch (H.$$typeof) {
            case xl:
              return T(Me(V, G, H, ae));
            case Fa:
              return T(xt(V, G, H, ae));
            case qi:
              var Se = H._payload, Qe = H._init;
              return mt(V, G, Qe(Se), ae);
          }
          if (Di(H))
            return Y(V, G, H, ae);
          if (sn(H))
            return ve(V, G, H, ae);
          hb(V, H);
        }
        return typeof H == "string" && H !== "" || typeof H == "number" ? T(Ue(V, G, "" + H, ae)) : (typeof H == "function" && pb(V), a(V, G));
      }
      return mt;
    }
    var Vm = GL(!0), WL = GL(!1);
    function J3(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var a = t.child, l = uh(a, a.pendingProps);
        for (t.child = l, l.return = t; a.sibling !== null; )
          a = a.sibling, l = l.sibling = uh(a, a.pendingProps), l.return = t;
        l.sibling = null;
      }
    }
    function eI(e, t) {
      for (var a = e.child; a !== null; )
        Hq(a, t), a = a.sibling;
    }
    var cx = zc(null), dx;
    dx = {};
    var mb = null, Hm = null, fx = null, vb = !1;
    function yb() {
      mb = null, Hm = null, fx = null, vb = !1;
    }
    function KL() {
      vb = !0;
    }
    function XL() {
      vb = !1;
    }
    function ZL(e, t, a) {
      Nr(cx, t._currentValue, e), t._currentValue = a, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== dx && y("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = dx;
    }
    function hx(e, t) {
      var a = cx.current;
      _r(cx, t), e._currentValue = a;
    }
    function px(e, t, a) {
      for (var l = e; l !== null; ) {
        var c = l.alternate;
        if (ou(l.childLanes, t) ? c !== null && !ou(c.childLanes, t) && (c.childLanes = it(c.childLanes, t)) : (l.childLanes = it(l.childLanes, t), c !== null && (c.childLanes = it(c.childLanes, t))), l === a)
          break;
        l = l.return;
      }
      l !== a && y("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function tI(e, t, a) {
      nI(e, t, a);
    }
    function nI(e, t, a) {
      var l = e.child;
      for (l !== null && (l.return = e); l !== null; ) {
        var c = void 0, m = l.dependencies;
        if (m !== null) {
          c = l.child;
          for (var T = m.firstContext; T !== null; ) {
            if (T.context === t) {
              if (l.tag === $) {
                var E = Rf(a), b = Su(ln, E);
                b.tag = Sb;
                var x = l.updateQueue;
                if (x !== null) {
                  var M = x.shared, z = M.pending;
                  z === null ? b.next = b : (b.next = z.next, z.next = b), M.pending = b;
                }
              }
              l.lanes = it(l.lanes, a);
              var N = l.alternate;
              N !== null && (N.lanes = it(N.lanes, a)), px(l.return, a, e), m.lanes = it(m.lanes, a);
              break;
            }
            T = T.next;
          }
        } else if (l.tag === $t)
          c = l.type === e.type ? null : l.child;
        else if (l.tag === ft) {
          var q = l.return;
          if (q === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          q.lanes = it(q.lanes, a);
          var Q = q.alternate;
          Q !== null && (Q.lanes = it(Q.lanes, a)), px(q, a, e), c = l.sibling;
        } else
          c = l.child;
        if (c !== null)
          c.return = l;
        else
          for (c = l; c !== null; ) {
            if (c === e) {
              c = null;
              break;
            }
            var Y = c.sibling;
            if (Y !== null) {
              Y.return = c.return, c = Y;
              break;
            }
            c = c.return;
          }
        l = c;
      }
    }
    function Im(e, t) {
      mb = e, Hm = null, fx = null;
      var a = e.dependencies;
      if (a !== null) {
        var l = a.firstContext;
        l !== null && ($r(a.lanes, t) && AS(), a.firstContext = null);
      }
    }
    function wi(e) {
      vb && y("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (fx !== e) {
        var a = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (Hm === null) {
          if (mb === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Hm = a, mb.dependencies = {
            lanes: ee,
            firstContext: a
          };
        } else
          Hm = Hm.next = a;
      }
      return t;
    }
    var th = null;
    function mx(e) {
      th === null ? th = [e] : th.push(e);
    }
    function iI() {
      if (th !== null) {
        for (var e = 0; e < th.length; e++) {
          var t = th[e], a = t.interleaved;
          if (a !== null) {
            t.interleaved = null;
            var l = a.next, c = t.pending;
            if (c !== null) {
              var m = c.next;
              c.next = l, a.next = m;
            }
            t.pending = a;
          }
        }
        th = null;
      }
    }
    function JL(e, t, a, l) {
      var c = t.interleaved;
      return c === null ? (a.next = a, mx(t)) : (a.next = c.next, c.next = a), t.interleaved = a, gb(e, l);
    }
    function rI(e, t, a, l) {
      var c = t.interleaved;
      c === null ? (a.next = a, mx(t)) : (a.next = c.next, c.next = a), t.interleaved = a;
    }
    function aI(e, t, a, l) {
      var c = t.interleaved;
      return c === null ? (a.next = a, mx(t)) : (a.next = c.next, c.next = a), t.interleaved = a, gb(e, l);
    }
    function Ca(e, t) {
      return gb(e, t);
    }
    var sI = gb;
    function gb(e, t) {
      e.lanes = it(e.lanes, t);
      var a = e.alternate;
      a !== null && (a.lanes = it(a.lanes, t)), a === null && (e.flags & (Un | ma)) !== Pe && WO(e);
      for (var l = e, c = e.return; c !== null; )
        c.childLanes = it(c.childLanes, t), a = c.alternate, a !== null ? a.childLanes = it(a.childLanes, t) : (c.flags & (Un | ma)) !== Pe && WO(e), l = c, c = c.return;
      if (l.tag === A) {
        var m = l.stateNode;
        return m;
      } else
        return null;
    }
    var e$ = 0, t$ = 1, Sb = 2, vx = 3, Tb = !1, yx, wb;
    yx = !1, wb = null;
    function gx(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: ee
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function n$(e, t) {
      var a = t.updateQueue, l = e.updateQueue;
      if (a === l) {
        var c = {
          baseState: l.baseState,
          firstBaseUpdate: l.firstBaseUpdate,
          lastBaseUpdate: l.lastBaseUpdate,
          shared: l.shared,
          effects: l.effects
        };
        t.updateQueue = c;
      }
    }
    function Su(e, t) {
      var a = {
        eventTime: e,
        lane: t,
        tag: e$,
        payload: null,
        callback: null,
        next: null
      };
      return a;
    }
    function Ic(e, t, a) {
      var l = e.updateQueue;
      if (l === null)
        return null;
      var c = l.shared;
      if (wb === c && !yx && (y("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), yx = !0), rq()) {
        var m = c.pending;
        return m === null ? t.next = t : (t.next = m.next, m.next = t), c.pending = t, sI(e, a);
      } else
        return aI(e, c, t, a);
    }
    function Eb(e, t, a) {
      var l = t.updateQueue;
      if (l !== null) {
        var c = l.shared;
        if ($g(a)) {
          var m = c.lanes;
          m = Ag(m, e.pendingLanes);
          var T = it(m, a);
          c.lanes = T, hm(e, T);
        }
      }
    }
    function Sx(e, t) {
      var a = e.updateQueue, l = e.alternate;
      if (l !== null) {
        var c = l.updateQueue;
        if (a === c) {
          var m = null, T = null, E = a.firstBaseUpdate;
          if (E !== null) {
            var b = E;
            do {
              var x = {
                eventTime: b.eventTime,
                lane: b.lane,
                tag: b.tag,
                payload: b.payload,
                callback: b.callback,
                next: null
              };
              T === null ? m = T = x : (T.next = x, T = x), b = b.next;
            } while (b !== null);
            T === null ? m = T = t : (T.next = t, T = t);
          } else
            m = T = t;
          a = {
            baseState: c.baseState,
            firstBaseUpdate: m,
            lastBaseUpdate: T,
            shared: c.shared,
            effects: c.effects
          }, e.updateQueue = a;
          return;
        }
      }
      var M = a.lastBaseUpdate;
      M === null ? a.firstBaseUpdate = t : M.next = t, a.lastBaseUpdate = t;
    }
    function lI(e, t, a, l, c, m) {
      switch (a.tag) {
        case t$: {
          var T = a.payload;
          if (typeof T == "function") {
            KL();
            var E = T.call(m, l, c);
            {
              if (e.mode & Jt) {
                bn(!0);
                try {
                  T.call(m, l, c);
                } finally {
                  bn(!1);
                }
              }
              XL();
            }
            return E;
          }
          return T;
        }
        case vx:
          e.flags = e.flags & -65537 | Oe;
        // Intentional fallthrough
        case e$: {
          var b = a.payload, x;
          if (typeof b == "function") {
            KL(), x = b.call(m, l, c);
            {
              if (e.mode & Jt) {
                bn(!0);
                try {
                  b.call(m, l, c);
                } finally {
                  bn(!1);
                }
              }
              XL();
            }
          } else
            x = b;
          return x == null ? l : St({}, l, x);
        }
        case Sb:
          return Tb = !0, l;
      }
      return l;
    }
    function bb(e, t, a, l) {
      var c = e.updateQueue;
      Tb = !1, wb = c.shared;
      var m = c.firstBaseUpdate, T = c.lastBaseUpdate, E = c.shared.pending;
      if (E !== null) {
        c.shared.pending = null;
        var b = E, x = b.next;
        b.next = null, T === null ? m = x : T.next = x, T = b;
        var M = e.alternate;
        if (M !== null) {
          var z = M.updateQueue, N = z.lastBaseUpdate;
          N !== T && (N === null ? z.firstBaseUpdate = x : N.next = x, z.lastBaseUpdate = b);
        }
      }
      if (m !== null) {
        var q = c.baseState, Q = ee, Y = null, ve = null, Ue = null, Me = m;
        do {
          var xt = Me.lane, mt = Me.eventTime;
          if (ou(l, xt)) {
            if (Ue !== null) {
              var G = {
                eventTime: mt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ot,
                tag: Me.tag,
                payload: Me.payload,
                callback: Me.callback,
                next: null
              };
              Ue = Ue.next = G;
            }
            q = lI(e, c, Me, q, t, a);
            var H = Me.callback;
            if (H !== null && // If the update was already committed, we should not queue its
            // callback again.
            Me.lane !== Ot) {
              e.flags |= un;
              var ae = c.effects;
              ae === null ? c.effects = [Me] : ae.push(Me);
            }
          } else {
            var V = {
              eventTime: mt,
              lane: xt,
              tag: Me.tag,
              payload: Me.payload,
              callback: Me.callback,
              next: null
            };
            Ue === null ? (ve = Ue = V, Y = q) : Ue = Ue.next = V, Q = it(Q, xt);
          }
          if (Me = Me.next, Me === null) {
            if (E = c.shared.pending, E === null)
              break;
            var Ee = E, Se = Ee.next;
            Ee.next = null, Me = Se, c.lastBaseUpdate = Ee, c.shared.pending = null;
          }
        } while (!0);
        Ue === null && (Y = q), c.baseState = Y, c.firstBaseUpdate = ve, c.lastBaseUpdate = Ue;
        var Qe = c.shared.interleaved;
        if (Qe !== null) {
          var et = Qe;
          do
            Q = it(Q, et.lane), et = et.next;
          while (et !== Qe);
        } else m === null && (c.shared.lanes = ee);
        BS(Q), e.lanes = Q, e.memoizedState = q;
      }
      wb = null;
    }
    function oI(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function i$() {
      Tb = !1;
    }
    function Cb() {
      return Tb;
    }
    function r$(e, t, a) {
      var l = t.effects;
      if (t.effects = null, l !== null)
        for (var c = 0; c < l.length; c++) {
          var m = l[c], T = m.callback;
          T !== null && (m.callback = null, oI(T, a));
        }
    }
    var SS = {}, qc = zc(SS), TS = zc(SS), kb = zc(SS);
    function xb(e) {
      if (e === SS)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function a$() {
      var e = xb(kb.current);
      return e;
    }
    function Tx(e, t) {
      Nr(kb, t, e), Nr(TS, e, e), Nr(qc, SS, e);
      var a = kH(t);
      _r(qc, e), Nr(qc, a, e);
    }
    function qm(e) {
      _r(qc, e), _r(TS, e), _r(kb, e);
    }
    function wx() {
      var e = xb(qc.current);
      return e;
    }
    function s$(e) {
      xb(kb.current);
      var t = xb(qc.current), a = xH(t, e.type);
      t !== a && (Nr(TS, e, e), Nr(qc, a, e));
    }
    function Ex(e) {
      TS.current === e && (_r(qc, e), _r(TS, e));
    }
    var uI = 0, l$ = 1, o$ = 1, wS = 2, sl = zc(uI);
    function bx(e, t) {
      return (e & t) !== 0;
    }
    function jm(e) {
      return e & l$;
    }
    function Cx(e, t) {
      return e & l$ | t;
    }
    function cI(e, t) {
      return e | t;
    }
    function jc(e, t) {
      Nr(sl, t, e);
    }
    function Bm(e) {
      _r(sl, e);
    }
    function dI(e, t) {
      var a = e.memoizedState;
      return a !== null ? a.dehydrated !== null : (e.memoizedProps, !0);
    }
    function Rb(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === Ye) {
          var a = t.memoizedState;
          if (a !== null) {
            var l = a.dehydrated;
            if (l === null || kL(l) || Ik(l))
              return t;
          }
        } else if (t.tag === Kt && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var c = (t.flags & Oe) !== Pe;
          if (c)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var ka = (
      /*   */
      0
    ), Ai = (
      /* */
      1
    ), Zl = (
      /*  */
      2
    ), Pi = (
      /*    */
      4
    ), ur = (
      /*   */
      8
    ), kx = [];
    function xx() {
      for (var e = 0; e < kx.length; e++) {
        var t = kx[e];
        t._workInProgressVersionPrimary = null;
      }
      kx.length = 0;
    }
    function fI(e, t) {
      var a = t._getVersion, l = a(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, l] : e.mutableSourceEagerHydrationData.push(t, l);
    }
    var we = n.ReactCurrentDispatcher, ES = n.ReactCurrentBatchConfig, Rx, Qm;
    Rx = /* @__PURE__ */ new Set();
    var nh = ee, en = null, _i = null, Ni = null, Db = !1, bS = !1, CS = 0, hI = 0, pI = 25, X = null, Ds = null, Bc = -1, Dx = !1;
    function Gt() {
      {
        var e = X;
        Ds === null ? Ds = [e] : Ds.push(e);
      }
    }
    function fe() {
      {
        var e = X;
        Ds !== null && (Bc++, Ds[Bc] !== e && mI(e));
      }
    }
    function Ym(e) {
      e != null && !Di(e) && y("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", X, typeof e);
    }
    function mI(e) {
      {
        var t = nt(en);
        if (!Rx.has(t) && (Rx.add(t), Ds !== null)) {
          for (var a = "", l = 30, c = 0; c <= Bc; c++) {
            for (var m = Ds[c], T = c === Bc ? e : m, E = c + 1 + ". " + m; E.length < l; )
              E += " ";
            E += T + `
`, a += E;
          }
          y(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, a);
        }
      }
    }
    function Ur() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Mx(e, t) {
      if (Dx)
        return !1;
      if (t === null)
        return y("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", X), !1;
      e.length !== t.length && y(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, X, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!ge(e[a], t[a]))
          return !1;
      return !0;
    }
    function Gm(e, t, a, l, c, m) {
      nh = m, en = t, Ds = e !== null ? e._debugHookTypes : null, Bc = -1, Dx = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = ee, e !== null && e.memoizedState !== null ? we.current = L$ : Ds !== null ? we.current = M$ : we.current = D$;
      var T = a(l, c);
      if (bS) {
        var E = 0;
        do {
          if (bS = !1, CS = 0, E >= pI)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          E += 1, Dx = !1, _i = null, Ni = null, t.updateQueue = null, Bc = -1, we.current = $$, T = a(l, c);
        } while (bS);
      }
      we.current = Hb, t._debugHookTypes = Ds;
      var b = _i !== null && _i.next !== null;
      if (nh = ee, en = null, _i = null, Ni = null, X = null, Ds = null, Bc = -1, e !== null && (e.flags & Kn) !== (t.flags & Kn) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & dt) !== _e && y("Internal React error: Expected static flag was missing. Please notify the React team."), Db = !1, b)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return T;
    }
    function Wm() {
      var e = CS !== 0;
      return CS = 0, e;
    }
    function u$(e, t, a) {
      t.updateQueue = e.updateQueue, (t.mode & zt) !== _e ? t.flags &= -50333701 : t.flags &= -2053, e.lanes = Df(e.lanes, a);
    }
    function c$() {
      if (we.current = Hb, Db) {
        for (var e = en.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        Db = !1;
      }
      nh = ee, en = null, _i = null, Ni = null, Ds = null, Bc = -1, X = null, b$ = !1, bS = !1, CS = 0;
    }
    function Jl() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ni === null ? en.memoizedState = Ni = e : Ni = Ni.next = e, Ni;
    }
    function Ms() {
      var e;
      if (_i === null) {
        var t = en.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = _i.next;
      var a;
      if (Ni === null ? a = en.memoizedState : a = Ni.next, a !== null)
        Ni = a, a = Ni.next, _i = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        _i = e;
        var l = {
          memoizedState: _i.memoizedState,
          baseState: _i.baseState,
          baseQueue: _i.baseQueue,
          queue: _i.queue,
          next: null
        };
        Ni === null ? en.memoizedState = Ni = l : Ni = Ni.next = l;
      }
      return Ni;
    }
    function d$() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Lx(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function $x(e, t, a) {
      var l = Jl(), c;
      a !== void 0 ? c = a(t) : c = t, l.memoizedState = l.baseState = c;
      var m = {
        pending: null,
        interleaved: null,
        lanes: ee,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      };
      l.queue = m;
      var T = m.dispatch = SI.bind(null, en, m);
      return [l.memoizedState, T];
    }
    function Ox(e, t, a) {
      var l = Ms(), c = l.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var m = _i, T = m.baseQueue, E = c.pending;
      if (E !== null) {
        if (T !== null) {
          var b = T.next, x = E.next;
          T.next = x, E.next = b;
        }
        m.baseQueue !== T && y("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), m.baseQueue = T = E, c.pending = null;
      }
      if (T !== null) {
        var M = T.next, z = m.baseState, N = null, q = null, Q = null, Y = M;
        do {
          var ve = Y.lane;
          if (ou(nh, ve)) {
            if (Q !== null) {
              var Me = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ot,
                action: Y.action,
                hasEagerState: Y.hasEagerState,
                eagerState: Y.eagerState,
                next: null
              };
              Q = Q.next = Me;
            }
            if (Y.hasEagerState)
              z = Y.eagerState;
            else {
              var xt = Y.action;
              z = e(z, xt);
            }
          } else {
            var Ue = {
              lane: ve,
              action: Y.action,
              hasEagerState: Y.hasEagerState,
              eagerState: Y.eagerState,
              next: null
            };
            Q === null ? (q = Q = Ue, N = z) : Q = Q.next = Ue, en.lanes = it(en.lanes, ve), BS(ve);
          }
          Y = Y.next;
        } while (Y !== null && Y !== M);
        Q === null ? N = z : Q.next = q, ge(z, l.memoizedState) || AS(), l.memoizedState = z, l.baseState = N, l.baseQueue = Q, c.lastRenderedState = z;
      }
      var mt = c.interleaved;
      if (mt !== null) {
        var V = mt;
        do {
          var G = V.lane;
          en.lanes = it(en.lanes, G), BS(G), V = V.next;
        } while (V !== mt);
      } else T === null && (c.lanes = ee);
      var H = c.dispatch;
      return [l.memoizedState, H];
    }
    function Ax(e, t, a) {
      var l = Ms(), c = l.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var m = c.dispatch, T = c.pending, E = l.memoizedState;
      if (T !== null) {
        c.pending = null;
        var b = T.next, x = b;
        do {
          var M = x.action;
          E = e(E, M), x = x.next;
        } while (x !== b);
        ge(E, l.memoizedState) || AS(), l.memoizedState = E, l.baseQueue === null && (l.baseState = E), c.lastRenderedState = E;
      }
      return [E, m];
    }
    function vQ(e, t, a) {
    }
    function yQ(e, t, a) {
    }
    function Px(e, t, a) {
      var l = en, c = Jl(), m, T = or();
      if (T) {
        if (a === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        m = a(), Qm || m !== a() && (y("The result of getServerSnapshot should be cached to avoid an infinite loop"), Qm = !0);
      } else {
        if (m = t(), !Qm) {
          var E = t();
          ge(m, E) || (y("The result of getSnapshot should be cached to avoid an infinite loop"), Qm = !0);
        }
        var b = sC();
        if (b === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        dm(b, nh) || f$(l, t, m);
      }
      c.memoizedState = m;
      var x = {
        value: m,
        getSnapshot: t
      };
      return c.queue = x, Ab(p$.bind(null, l, x, e), [e]), l.flags |= xr, kS(Ai | ur, h$.bind(null, l, x, m, t), void 0, null), m;
    }
    function Mb(e, t, a) {
      var l = en, c = Ms(), m = t();
      if (!Qm) {
        var T = t();
        ge(m, T) || (y("The result of getSnapshot should be cached to avoid an infinite loop"), Qm = !0);
      }
      var E = c.memoizedState, b = !ge(E, m);
      b && (c.memoizedState = m, AS());
      var x = c.queue;
      if (RS(p$.bind(null, l, x, e), [e]), x.getSnapshot !== t || b || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ni !== null && Ni.memoizedState.tag & Ai) {
        l.flags |= xr, kS(Ai | ur, h$.bind(null, l, x, m, t), void 0, null);
        var M = sC();
        if (M === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        dm(M, nh) || f$(l, t, m);
      }
      return m;
    }
    function f$(e, t, a) {
      e.flags |= Ec;
      var l = {
        getSnapshot: t,
        value: a
      }, c = en.updateQueue;
      if (c === null)
        c = d$(), en.updateQueue = c, c.stores = [l];
      else {
        var m = c.stores;
        m === null ? c.stores = [l] : m.push(l);
      }
    }
    function h$(e, t, a, l) {
      t.value = a, t.getSnapshot = l, m$(t) && v$(e);
    }
    function p$(e, t, a) {
      var l = function() {
        m$(t) && v$(e);
      };
      return a(l);
    }
    function m$(e) {
      var t = e.getSnapshot, a = e.value;
      try {
        var l = t();
        return !ge(a, l);
      } catch {
        return !0;
      }
    }
    function v$(e) {
      var t = Ca(e, je);
      t !== null && Vi(t, e, je, ln);
    }
    function Lb(e) {
      var t = Jl();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        interleaved: null,
        lanes: ee,
        dispatch: null,
        lastRenderedReducer: Lx,
        lastRenderedState: e
      };
      t.queue = a;
      var l = a.dispatch = TI.bind(null, en, a);
      return [t.memoizedState, l];
    }
    function _x(e) {
      return Ox(Lx);
    }
    function Nx(e) {
      return Ax(Lx);
    }
    function kS(e, t, a, l) {
      var c = {
        tag: e,
        create: t,
        destroy: a,
        deps: l,
        // Circular
        next: null
      }, m = en.updateQueue;
      if (m === null)
        m = d$(), en.updateQueue = m, m.lastEffect = c.next = c;
      else {
        var T = m.lastEffect;
        if (T === null)
          m.lastEffect = c.next = c;
        else {
          var E = T.next;
          T.next = c, c.next = E, m.lastEffect = c;
        }
      }
      return c;
    }
    function Ux(e) {
      var t = Jl();
      {
        var a = {
          current: e
        };
        return t.memoizedState = a, a;
      }
    }
    function $b(e) {
      var t = Ms();
      return t.memoizedState;
    }
    function xS(e, t, a, l) {
      var c = Jl(), m = l === void 0 ? null : l;
      en.flags |= e, c.memoizedState = kS(Ai | t, a, void 0, m);
    }
    function Ob(e, t, a, l) {
      var c = Ms(), m = l === void 0 ? null : l, T = void 0;
      if (_i !== null) {
        var E = _i.memoizedState;
        if (T = E.destroy, m !== null) {
          var b = E.deps;
          if (Mx(m, b)) {
            c.memoizedState = kS(t, a, T, m);
            return;
          }
        }
      }
      en.flags |= e, c.memoizedState = kS(Ai | t, a, T, m);
    }
    function Ab(e, t) {
      return (en.mode & zt) !== _e ? xS(vs | xr | zp, ur, e, t) : xS(xr | zp, ur, e, t);
    }
    function RS(e, t) {
      return Ob(xr, ur, e, t);
    }
    function zx(e, t) {
      return xS(bt, Zl, e, t);
    }
    function Pb(e, t) {
      return Ob(bt, Zl, e, t);
    }
    function Fx(e, t) {
      var a = bt;
      return a |= Gs, (en.mode & zt) !== _e && (a |= Pl), xS(a, Pi, e, t);
    }
    function _b(e, t) {
      return Ob(bt, Pi, e, t);
    }
    function y$(e, t) {
      if (typeof t == "function") {
        var a = t, l = e();
        return a(l), function() {
          a(null);
        };
      } else if (t != null) {
        var c = t;
        c.hasOwnProperty("current") || y("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(c).join(", ") + "}");
        var m = e();
        return c.current = m, function() {
          c.current = null;
        };
      }
    }
    function Vx(e, t, a) {
      typeof t != "function" && y("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var l = a != null ? a.concat([e]) : null, c = bt;
      return c |= Gs, (en.mode & zt) !== _e && (c |= Pl), xS(c, Pi, y$.bind(null, t, e), l);
    }
    function Nb(e, t, a) {
      typeof t != "function" && y("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var l = a != null ? a.concat([e]) : null;
      return Ob(bt, Pi, y$.bind(null, t, e), l);
    }
    function vI(e, t) {
    }
    var Ub = vI;
    function Hx(e, t) {
      var a = Jl(), l = t === void 0 ? null : t;
      return a.memoizedState = [e, l], e;
    }
    function zb(e, t) {
      var a = Ms(), l = t === void 0 ? null : t, c = a.memoizedState;
      if (c !== null && l !== null) {
        var m = c[1];
        if (Mx(l, m))
          return c[0];
      }
      return a.memoizedState = [e, l], e;
    }
    function Ix(e, t) {
      var a = Jl(), l = t === void 0 ? null : t, c = e();
      return a.memoizedState = [c, l], c;
    }
    function Fb(e, t) {
      var a = Ms(), l = t === void 0 ? null : t, c = a.memoizedState;
      if (c !== null && l !== null) {
        var m = c[1];
        if (Mx(l, m))
          return c[0];
      }
      var T = e();
      return a.memoizedState = [T, l], T;
    }
    function qx(e) {
      var t = Jl();
      return t.memoizedState = e, e;
    }
    function g$(e) {
      var t = Ms(), a = _i, l = a.memoizedState;
      return T$(t, l, e);
    }
    function S$(e) {
      var t = Ms();
      if (_i === null)
        return t.memoizedState = e, e;
      var a = _i.memoizedState;
      return T$(t, a, e);
    }
    function T$(e, t, a) {
      var l = !Mg(nh);
      if (l) {
        if (!ge(a, t)) {
          var c = Og();
          en.lanes = it(en.lanes, c), BS(c), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, AS()), e.memoizedState = a, a;
    }
    function yI(e, t, a) {
      var l = wa();
      Jn(gE(l, Ts)), e(!0);
      var c = ES.transition;
      ES.transition = {};
      var m = ES.transition;
      ES.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if (Jn(l), ES.transition = c, c === null && m._updatedFibers) {
          var T = m._updatedFibers.size;
          T > 10 && v("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), m._updatedFibers.clear();
        }
      }
    }
    function jx() {
      var e = Lb(!1), t = e[0], a = e[1], l = yI.bind(null, a), c = Jl();
      return c.memoizedState = l, [t, l];
    }
    function w$() {
      var e = _x(), t = e[0], a = Ms(), l = a.memoizedState;
      return [t, l];
    }
    function E$() {
      var e = Nx(), t = e[0], a = Ms(), l = a.memoizedState;
      return [t, l];
    }
    var b$ = !1;
    function gI() {
      return b$;
    }
    function Bx() {
      var e = Jl(), t = sC(), a = t.identifierPrefix, l;
      if (or()) {
        var c = _3();
        l = ":" + a + "R" + c;
        var m = CS++;
        m > 0 && (l += "H" + m.toString(32)), l += ":";
      } else {
        var T = hI++;
        l = ":" + a + "r" + T.toString(32) + ":";
      }
      return e.memoizedState = l, l;
    }
    function Vb() {
      var e = Ms(), t = e.memoizedState;
      return t;
    }
    function SI(e, t, a) {
      typeof arguments[3] == "function" && y("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var l = Kc(e), c = {
        lane: l,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (C$(e))
        k$(t, c);
      else {
        var m = JL(e, t, c, l);
        if (m !== null) {
          var T = ea();
          Vi(m, e, l, T), x$(m, t, l);
        }
      }
      R$(e, l);
    }
    function TI(e, t, a) {
      typeof arguments[3] == "function" && y("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var l = Kc(e), c = {
        lane: l,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (C$(e))
        k$(t, c);
      else {
        var m = e.alternate;
        if (e.lanes === ee && (m === null || m.lanes === ee)) {
          var T = t.lastRenderedReducer;
          if (T !== null) {
            var E;
            E = we.current, we.current = ll;
            try {
              var b = t.lastRenderedState, x = T(b, a);
              if (c.hasEagerState = !0, c.eagerState = x, ge(x, b)) {
                rI(e, t, c, l);
                return;
              }
            } catch {
            } finally {
              we.current = E;
            }
          }
        }
        var M = JL(e, t, c, l);
        if (M !== null) {
          var z = ea();
          Vi(M, e, l, z), x$(M, t, l);
        }
      }
      R$(e, l);
    }
    function C$(e) {
      var t = e.alternate;
      return e === en || t !== null && t === en;
    }
    function k$(e, t) {
      bS = Db = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function x$(e, t, a) {
      if ($g(a)) {
        var l = t.lanes;
        l = Ag(l, e.pendingLanes);
        var c = it(l, a);
        t.lanes = c, hm(e, c);
      }
    }
    function R$(e, t, a) {
      gf(e, t);
    }
    var Hb = {
      readContext: wi,
      useCallback: Ur,
      useContext: Ur,
      useEffect: Ur,
      useImperativeHandle: Ur,
      useInsertionEffect: Ur,
      useLayoutEffect: Ur,
      useMemo: Ur,
      useReducer: Ur,
      useRef: Ur,
      useState: Ur,
      useDebugValue: Ur,
      useDeferredValue: Ur,
      useTransition: Ur,
      useMutableSource: Ur,
      useSyncExternalStore: Ur,
      useId: Ur,
      unstable_isNewReconciler: oe
    }, D$ = null, M$ = null, L$ = null, $$ = null, eo = null, ll = null, Ib = null;
    {
      var Qx = function() {
        y("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Xe = function() {
        y("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      D$ = {
        readContext: function(e) {
          return wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Gt(), Ym(t), Hx(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Gt(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Gt(), Ym(t), Ab(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Gt(), Ym(a), Vx(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Gt(), Ym(t), zx(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Gt(), Ym(t), Fx(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Gt(), Ym(t);
          var a = we.current;
          we.current = eo;
          try {
            return Ix(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Gt();
          var l = we.current;
          we.current = eo;
          try {
            return $x(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Gt(), Ux(e);
        },
        useState: function(e) {
          X = "useState", Gt();
          var t = we.current;
          we.current = eo;
          try {
            return Lb(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Gt(), void 0;
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Gt(), qx(e);
        },
        useTransition: function() {
          return X = "useTransition", Gt(), jx();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Gt(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Gt(), Px(e, t, a);
        },
        useId: function() {
          return X = "useId", Gt(), Bx();
        },
        unstable_isNewReconciler: oe
      }, M$ = {
        readContext: function(e) {
          return wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", fe(), Hx(e, t);
        },
        useContext: function(e) {
          return X = "useContext", fe(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", fe(), Ab(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", fe(), Vx(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", fe(), zx(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", fe(), Fx(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", fe();
          var a = we.current;
          we.current = eo;
          try {
            return Ix(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", fe();
          var l = we.current;
          we.current = eo;
          try {
            return $x(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", fe(), Ux(e);
        },
        useState: function(e) {
          X = "useState", fe();
          var t = we.current;
          we.current = eo;
          try {
            return Lb(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", fe(), void 0;
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", fe(), qx(e);
        },
        useTransition: function() {
          return X = "useTransition", fe(), jx();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", fe(), Px(e, t, a);
        },
        useId: function() {
          return X = "useId", fe(), Bx();
        },
        unstable_isNewReconciler: oe
      }, L$ = {
        readContext: function(e) {
          return wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", fe(), zb(e, t);
        },
        useContext: function(e) {
          return X = "useContext", fe(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", fe(), Nb(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", fe(), Pb(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", fe(), _b(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", fe();
          var a = we.current;
          we.current = ll;
          try {
            return Fb(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", fe();
          var l = we.current;
          we.current = ll;
          try {
            return Ox(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", fe(), $b();
        },
        useState: function(e) {
          X = "useState", fe();
          var t = we.current;
          we.current = ll;
          try {
            return _x(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", fe(), Ub();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", fe(), g$(e);
        },
        useTransition: function() {
          return X = "useTransition", fe(), w$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", fe(), Mb(e, t);
        },
        useId: function() {
          return X = "useId", fe(), Vb();
        },
        unstable_isNewReconciler: oe
      }, $$ = {
        readContext: function(e) {
          return wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", fe(), zb(e, t);
        },
        useContext: function(e) {
          return X = "useContext", fe(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", fe(), Nb(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", fe(), Pb(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", fe(), _b(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", fe();
          var a = we.current;
          we.current = Ib;
          try {
            return Fb(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", fe();
          var l = we.current;
          we.current = Ib;
          try {
            return Ax(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", fe(), $b();
        },
        useState: function(e) {
          X = "useState", fe();
          var t = we.current;
          we.current = Ib;
          try {
            return Nx(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", fe(), Ub();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", fe(), S$(e);
        },
        useTransition: function() {
          return X = "useTransition", fe(), E$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", fe(), Mb(e, t);
        },
        useId: function() {
          return X = "useId", fe(), Vb();
        },
        unstable_isNewReconciler: oe
      }, eo = {
        readContext: function(e) {
          return Qx(), wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Xe(), Gt(), Hx(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Xe(), Gt(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Xe(), Gt(), Ab(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Xe(), Gt(), Vx(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Xe(), Gt(), zx(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Xe(), Gt(), Fx(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Xe(), Gt();
          var a = we.current;
          we.current = eo;
          try {
            return Ix(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Xe(), Gt();
          var l = we.current;
          we.current = eo;
          try {
            return $x(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Xe(), Gt(), Ux(e);
        },
        useState: function(e) {
          X = "useState", Xe(), Gt();
          var t = we.current;
          we.current = eo;
          try {
            return Lb(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Xe(), Gt(), void 0;
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Xe(), Gt(), qx(e);
        },
        useTransition: function() {
          return X = "useTransition", Xe(), Gt(), jx();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Xe(), Gt(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Xe(), Gt(), Px(e, t, a);
        },
        useId: function() {
          return X = "useId", Xe(), Gt(), Bx();
        },
        unstable_isNewReconciler: oe
      }, ll = {
        readContext: function(e) {
          return Qx(), wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Xe(), fe(), zb(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Xe(), fe(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Xe(), fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Xe(), fe(), Nb(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Xe(), fe(), Pb(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Xe(), fe(), _b(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Xe(), fe();
          var a = we.current;
          we.current = ll;
          try {
            return Fb(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Xe(), fe();
          var l = we.current;
          we.current = ll;
          try {
            return Ox(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Xe(), fe(), $b();
        },
        useState: function(e) {
          X = "useState", Xe(), fe();
          var t = we.current;
          we.current = ll;
          try {
            return _x(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Xe(), fe(), Ub();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Xe(), fe(), g$(e);
        },
        useTransition: function() {
          return X = "useTransition", Xe(), fe(), w$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Xe(), fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Xe(), fe(), Mb(e, t);
        },
        useId: function() {
          return X = "useId", Xe(), fe(), Vb();
        },
        unstable_isNewReconciler: oe
      }, Ib = {
        readContext: function(e) {
          return Qx(), wi(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Xe(), fe(), zb(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Xe(), fe(), wi(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Xe(), fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Xe(), fe(), Nb(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Xe(), fe(), Pb(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Xe(), fe(), _b(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Xe(), fe();
          var a = we.current;
          we.current = ll;
          try {
            return Fb(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Xe(), fe();
          var l = we.current;
          we.current = ll;
          try {
            return Ax(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Xe(), fe(), $b();
        },
        useState: function(e) {
          X = "useState", Xe(), fe();
          var t = we.current;
          we.current = ll;
          try {
            return Nx(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Xe(), fe(), Ub();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Xe(), fe(), S$(e);
        },
        useTransition: function() {
          return X = "useTransition", Xe(), fe(), E$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Xe(), fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Xe(), fe(), Mb(e, t);
        },
        useId: function() {
          return X = "useId", Xe(), fe(), Vb();
        },
        unstable_isNewReconciler: oe
      };
    }
    var Qc = s.unstable_now, O$ = 0, qb = -1, DS = -1, jb = -1, Yx = !1, Bb = !1;
    function A$() {
      return Yx;
    }
    function wI() {
      Bb = !0;
    }
    function EI() {
      Yx = !1, Bb = !1;
    }
    function bI() {
      Yx = Bb, Bb = !1;
    }
    function P$() {
      return O$;
    }
    function _$() {
      O$ = Qc();
    }
    function Gx(e) {
      DS = Qc(), e.actualStartTime < 0 && (e.actualStartTime = Qc());
    }
    function N$(e) {
      DS = -1;
    }
    function Qb(e, t) {
      if (DS >= 0) {
        var a = Qc() - DS;
        e.actualDuration += a, t && (e.selfBaseDuration = a), DS = -1;
      }
    }
    function to(e) {
      if (qb >= 0) {
        var t = Qc() - qb;
        qb = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case A:
              var l = a.stateNode;
              l.effectDuration += t;
              return;
            case ct:
              var c = a.stateNode;
              c.effectDuration += t;
              return;
          }
          a = a.return;
        }
      }
    }
    function Wx(e) {
      if (jb >= 0) {
        var t = Qc() - jb;
        jb = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case A:
              var l = a.stateNode;
              l !== null && (l.passiveEffectDuration += t);
              return;
            case ct:
              var c = a.stateNode;
              c !== null && (c.passiveEffectDuration += t);
              return;
          }
          a = a.return;
        }
      }
    }
    function no() {
      qb = Qc();
    }
    function Kx() {
      jb = Qc();
    }
    function Xx(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function ol(e, t) {
      if (e && e.defaultProps) {
        var a = St({}, t), l = e.defaultProps;
        for (var c in l)
          a[c] === void 0 && (a[c] = l[c]);
        return a;
      }
      return t;
    }
    var Zx = {}, Jx, e1, t1, n1, i1, U$, Yb, r1, a1, s1, MS;
    {
      Jx = /* @__PURE__ */ new Set(), e1 = /* @__PURE__ */ new Set(), t1 = /* @__PURE__ */ new Set(), n1 = /* @__PURE__ */ new Set(), r1 = /* @__PURE__ */ new Set(), i1 = /* @__PURE__ */ new Set(), a1 = /* @__PURE__ */ new Set(), s1 = /* @__PURE__ */ new Set(), MS = /* @__PURE__ */ new Set();
      var z$ = /* @__PURE__ */ new Set();
      Yb = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var a = t + "_" + e;
          z$.has(a) || (z$.add(a), y("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, U$ = function(e, t) {
        if (t === void 0) {
          var a = Zt(e) || "Component";
          i1.has(a) || (i1.add(a), y("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", a));
        }
      }, Object.defineProperty(Zx, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Zx);
    }
    function l1(e, t, a, l) {
      var c = e.memoizedState, m = a(l, c);
      {
        if (e.mode & Jt) {
          bn(!0);
          try {
            m = a(l, c);
          } finally {
            bn(!1);
          }
        }
        U$(t, m);
      }
      var T = m == null ? c : St({}, c, m);
      if (e.memoizedState = T, e.lanes === ee) {
        var E = e.updateQueue;
        E.baseState = T;
      }
    }
    var o1 = {
      isMounted: nE,
      enqueueSetState: function(e, t, a) {
        var l = wc(e), c = ea(), m = Kc(l), T = Su(c, m);
        T.payload = t, a != null && (Yb(a, "setState"), T.callback = a);
        var E = Ic(l, T, m);
        E !== null && (Vi(E, l, m, c), Eb(E, l, m)), gf(l, m);
      },
      enqueueReplaceState: function(e, t, a) {
        var l = wc(e), c = ea(), m = Kc(l), T = Su(c, m);
        T.tag = t$, T.payload = t, a != null && (Yb(a, "replaceState"), T.callback = a);
        var E = Ic(l, T, m);
        E !== null && (Vi(E, l, m, c), Eb(E, l, m)), gf(l, m);
      },
      enqueueForceUpdate: function(e, t) {
        var a = wc(e), l = ea(), c = Kc(a), m = Su(l, c);
        m.tag = Sb, t != null && (Yb(t, "forceUpdate"), m.callback = t);
        var T = Ic(a, m, c);
        T !== null && (Vi(T, a, c, l), Eb(T, a, c)), Bp(a, c);
      }
    };
    function F$(e, t, a, l, c, m, T) {
      var E = e.stateNode;
      if (typeof E.shouldComponentUpdate == "function") {
        var b = E.shouldComponentUpdate(l, m, T);
        {
          if (e.mode & Jt) {
            bn(!0);
            try {
              b = E.shouldComponentUpdate(l, m, T);
            } finally {
              bn(!1);
            }
          }
          b === void 0 && y("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Zt(t) || "Component");
        }
        return b;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !Ne(a, l) || !Ne(c, m) : !0;
    }
    function CI(e, t, a) {
      var l = e.stateNode;
      {
        var c = Zt(t) || "Component", m = l.render;
        m || (t.prototype && typeof t.prototype.render == "function" ? y("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", c) : y("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", c)), l.getInitialState && !l.getInitialState.isReactClassApproved && !l.state && y("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", c), l.getDefaultProps && !l.getDefaultProps.isReactClassApproved && y("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", c), l.propTypes && y("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", c), l.contextType && y("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", c), t.childContextTypes && !MS.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Jt) === _e && (MS.add(t), y(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), t.contextTypes && !MS.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Jt) === _e && (MS.add(t), y(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), l.contextTypes && y("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", c), t.contextType && t.contextTypes && !a1.has(t) && (a1.add(t), y("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", c)), typeof l.componentShouldUpdate == "function" && y("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", c), t.prototype && t.prototype.isPureReactComponent && typeof l.shouldComponentUpdate < "u" && y("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Zt(t) || "A pure component"), typeof l.componentDidUnmount == "function" && y("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", c), typeof l.componentDidReceiveProps == "function" && y("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", c), typeof l.componentWillRecieveProps == "function" && y("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", c), typeof l.UNSAFE_componentWillRecieveProps == "function" && y("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", c);
        var T = l.props !== a;
        l.props !== void 0 && T && y("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", c, c), l.defaultProps && y("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", c, c), typeof l.getSnapshotBeforeUpdate == "function" && typeof l.componentDidUpdate != "function" && !t1.has(t) && (t1.add(t), y("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Zt(t))), typeof l.getDerivedStateFromProps == "function" && y("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof l.getDerivedStateFromError == "function" && y("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof t.getSnapshotBeforeUpdate == "function" && y("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", c);
        var E = l.state;
        E && (typeof E != "object" || Di(E)) && y("%s.state: must be set to an object or null", c), typeof l.getChildContext == "function" && typeof t.childContextTypes != "object" && y("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", c);
      }
    }
    function V$(e, t) {
      t.updater = o1, e.stateNode = t, Go(t, e), t._reactInternalInstance = Zx;
    }
    function H$(e, t, a) {
      var l = !1, c = Ka, m = Ka, T = t.contextType;
      if ("contextType" in t) {
        var E = (
          // Allow null for conditional declaration
          T === null || T !== void 0 && T.$$typeof === Bd && T._context === void 0
        );
        if (!E && !s1.has(t)) {
          s1.add(t);
          var b = "";
          T === void 0 ? b = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof T != "object" ? b = " However, it is set to a " + typeof T + "." : T.$$typeof === lc ? b = " Did you accidentally pass the Context.Provider instead?" : T._context !== void 0 ? b = " Did you accidentally pass the Context.Consumer instead?" : b = " However, it is set to an object with keys {" + Object.keys(T).join(", ") + "}.", y("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Zt(t) || "Component", b);
        }
      }
      if (typeof T == "object" && T !== null)
        m = wi(T);
      else {
        c = _m(e, t, !0);
        var x = t.contextTypes;
        l = x != null, m = l ? Nm(e, c) : Ka;
      }
      var M = new t(a, m);
      if (e.mode & Jt) {
        bn(!0);
        try {
          M = new t(a, m);
        } finally {
          bn(!1);
        }
      }
      var z = e.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null;
      V$(e, M);
      {
        if (typeof t.getDerivedStateFromProps == "function" && z === null) {
          var N = Zt(t) || "Component";
          e1.has(N) || (e1.add(N), y("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", N, M.state === null ? "null" : "undefined", N));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function") {
          var q = null, Q = null, Y = null;
          if (typeof M.componentWillMount == "function" && M.componentWillMount.__suppressDeprecationWarning !== !0 ? q = "componentWillMount" : typeof M.UNSAFE_componentWillMount == "function" && (q = "UNSAFE_componentWillMount"), typeof M.componentWillReceiveProps == "function" && M.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Q = "componentWillReceiveProps" : typeof M.UNSAFE_componentWillReceiveProps == "function" && (Q = "UNSAFE_componentWillReceiveProps"), typeof M.componentWillUpdate == "function" && M.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Y = "componentWillUpdate" : typeof M.UNSAFE_componentWillUpdate == "function" && (Y = "UNSAFE_componentWillUpdate"), q !== null || Q !== null || Y !== null) {
            var ve = Zt(t) || "Component", Ue = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            n1.has(ve) || (n1.add(ve), y(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, ve, Ue, q !== null ? `
  ` + q : "", Q !== null ? `
  ` + Q : "", Y !== null ? `
  ` + Y : ""));
          }
        }
      }
      return l && LL(e, c, m), M;
    }
    function kI(e, t) {
      var a = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), a !== t.state && (y("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", nt(e) || "Component"), o1.enqueueReplaceState(t, t.state, null));
    }
    function I$(e, t, a, l) {
      var c = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, l), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, l), t.state !== c) {
        {
          var m = nt(e) || "Component";
          Jx.has(m) || (Jx.add(m), y("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", m));
        }
        o1.enqueueReplaceState(t, t.state, null);
      }
    }
    function u1(e, t, a, l) {
      CI(e, t, a);
      var c = e.stateNode;
      c.props = a, c.state = e.memoizedState, c.refs = {}, gx(e);
      var m = t.contextType;
      if (typeof m == "object" && m !== null)
        c.context = wi(m);
      else {
        var T = _m(e, t, !0);
        c.context = Nm(e, T);
      }
      {
        if (c.state === a) {
          var E = Zt(t) || "Component";
          r1.has(E) || (r1.add(E), y("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", E));
        }
        e.mode & Jt && al.recordLegacyContextWarning(e, c), al.recordUnsafeLifecycleWarnings(e, c);
      }
      c.state = e.memoizedState;
      var b = t.getDerivedStateFromProps;
      if (typeof b == "function" && (l1(e, t, b, a), c.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof c.getSnapshotBeforeUpdate != "function" && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (kI(e, c), bb(e, a, c, l), c.state = e.memoizedState), typeof c.componentDidMount == "function") {
        var x = bt;
        x |= Gs, (e.mode & zt) !== _e && (x |= Pl), e.flags |= x;
      }
    }
    function xI(e, t, a, l) {
      var c = e.stateNode, m = e.memoizedProps;
      c.props = m;
      var T = c.context, E = t.contextType, b = Ka;
      if (typeof E == "object" && E !== null)
        b = wi(E);
      else {
        var x = _m(e, t, !0);
        b = Nm(e, x);
      }
      var M = t.getDerivedStateFromProps, z = typeof M == "function" || typeof c.getSnapshotBeforeUpdate == "function";
      !z && (typeof c.UNSAFE_componentWillReceiveProps == "function" || typeof c.componentWillReceiveProps == "function") && (m !== a || T !== b) && I$(e, c, a, b), i$();
      var N = e.memoizedState, q = c.state = N;
      if (bb(e, a, c, l), q = e.memoizedState, m === a && N === q && !rb() && !Cb()) {
        if (typeof c.componentDidMount == "function") {
          var Q = bt;
          Q |= Gs, (e.mode & zt) !== _e && (Q |= Pl), e.flags |= Q;
        }
        return !1;
      }
      typeof M == "function" && (l1(e, t, M, a), q = e.memoizedState);
      var Y = Cb() || F$(e, t, m, a, N, q, b);
      if (Y) {
        if (!z && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount()), typeof c.componentDidMount == "function") {
          var ve = bt;
          ve |= Gs, (e.mode & zt) !== _e && (ve |= Pl), e.flags |= ve;
        }
      } else {
        if (typeof c.componentDidMount == "function") {
          var Ue = bt;
          Ue |= Gs, (e.mode & zt) !== _e && (Ue |= Pl), e.flags |= Ue;
        }
        e.memoizedProps = a, e.memoizedState = q;
      }
      return c.props = a, c.state = q, c.context = b, Y;
    }
    function RI(e, t, a, l, c) {
      var m = t.stateNode;
      n$(e, t);
      var T = t.memoizedProps, E = t.type === t.elementType ? T : ol(t.type, T);
      m.props = E;
      var b = t.pendingProps, x = m.context, M = a.contextType, z = Ka;
      if (typeof M == "object" && M !== null)
        z = wi(M);
      else {
        var N = _m(t, a, !0);
        z = Nm(t, N);
      }
      var q = a.getDerivedStateFromProps, Q = typeof q == "function" || typeof m.getSnapshotBeforeUpdate == "function";
      !Q && (typeof m.UNSAFE_componentWillReceiveProps == "function" || typeof m.componentWillReceiveProps == "function") && (T !== b || x !== z) && I$(t, m, l, z), i$();
      var Y = t.memoizedState, ve = m.state = Y;
      if (bb(t, l, m, c), ve = t.memoizedState, T === b && Y === ve && !rb() && !Cb())
        return typeof m.componentDidUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= bt), typeof m.getSnapshotBeforeUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= ui), !1;
      typeof q == "function" && (l1(t, a, q, l), ve = t.memoizedState);
      var Ue = Cb() || F$(t, a, E, l, Y, ve, z) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Le;
      return Ue ? (!Q && (typeof m.UNSAFE_componentWillUpdate == "function" || typeof m.componentWillUpdate == "function") && (typeof m.componentWillUpdate == "function" && m.componentWillUpdate(l, ve, z), typeof m.UNSAFE_componentWillUpdate == "function" && m.UNSAFE_componentWillUpdate(l, ve, z)), typeof m.componentDidUpdate == "function" && (t.flags |= bt), typeof m.getSnapshotBeforeUpdate == "function" && (t.flags |= ui)) : (typeof m.componentDidUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= bt), typeof m.getSnapshotBeforeUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= ui), t.memoizedProps = l, t.memoizedState = ve), m.props = l, m.state = ve, m.context = z, Ue;
    }
    function ih(e, t) {
      return {
        value: e,
        source: t,
        stack: fp(t),
        digest: null
      };
    }
    function c1(e, t, a) {
      return {
        value: e,
        source: null,
        stack: a ?? null,
        digest: t ?? null
      };
    }
    function DI(e, t) {
      return !0;
    }
    function d1(e, t) {
      try {
        var a = DI(e, t);
        if (a === !1)
          return;
        var l = t.value, c = t.source, m = t.stack, T = m !== null ? m : "";
        if (l != null && l._suppressLogging) {
          if (e.tag === $)
            return;
          console.error(l);
        }
        var E = c ? nt(c) : null, b = E ? "The above error occurred in the <" + E + "> component:" : "The above error occurred in one of your React components:", x;
        if (e.tag === A)
          x = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var M = nt(e) || "Anonymous";
          x = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + M + ".");
        }
        var z = b + `
` + T + `

` + ("" + x);
        console.error(z);
      } catch (N) {
        setTimeout(function() {
          throw N;
        });
      }
    }
    var MI = typeof WeakMap == "function" ? WeakMap : Map;
    function q$(e, t, a) {
      var l = Su(ln, a);
      l.tag = vx, l.payload = {
        element: null
      };
      var c = t.value;
      return l.callback = function() {
        wq(c), d1(e, t);
      }, l;
    }
    function f1(e, t, a) {
      var l = Su(ln, a);
      l.tag = vx;
      var c = e.type.getDerivedStateFromError;
      if (typeof c == "function") {
        var m = t.value;
        l.payload = function() {
          return c(m);
        }, l.callback = function() {
          eA(e), d1(e, t);
        };
      }
      var T = e.stateNode;
      return T !== null && typeof T.componentDidCatch == "function" && (l.callback = function() {
        eA(e), d1(e, t), typeof c != "function" && Sq(this);
        var b = t.value, x = t.stack;
        this.componentDidCatch(b, {
          componentStack: x !== null ? x : ""
        }), typeof c != "function" && ($r(e.lanes, je) || y("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", nt(e) || "Unknown"));
      }), l;
    }
    function j$(e, t, a) {
      var l = e.pingCache, c;
      if (l === null ? (l = e.pingCache = new MI(), c = /* @__PURE__ */ new Set(), l.set(t, c)) : (c = l.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), l.set(t, c))), !c.has(a)) {
        c.add(a);
        var m = Eq.bind(null, e, t, a);
        Lr && QS(e, a), t.then(m, m);
      }
    }
    function LI(e, t, a, l) {
      var c = e.updateQueue;
      if (c === null) {
        var m = /* @__PURE__ */ new Set();
        m.add(a), e.updateQueue = m;
      } else
        c.add(a);
    }
    function $I(e, t) {
      var a = e.tag;
      if ((e.mode & dt) === _e && (a === D || a === Ve || a === He)) {
        var l = e.alternate;
        l ? (e.updateQueue = l.updateQueue, e.memoizedState = l.memoizedState, e.lanes = l.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function B$(e) {
      var t = e;
      do {
        if (t.tag === Ye && dI(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function Q$(e, t, a, l, c) {
      if ((e.mode & dt) === _e) {
        if (e === t)
          e.flags |= Rr;
        else {
          if (e.flags |= Oe, a.flags |= Up, a.flags &= -52805, a.tag === $) {
            var m = a.alternate;
            if (m === null)
              a.tag = Ge;
            else {
              var T = Su(ln, je);
              T.tag = Sb, Ic(a, T, je);
            }
          }
          a.lanes = it(a.lanes, je);
        }
        return e;
      }
      return e.flags |= Rr, e.lanes = c, e;
    }
    function OI(e, t, a, l, c) {
      if (a.flags |= ff, Lr && QS(e, c), l !== null && typeof l == "object" && typeof l.then == "function") {
        var m = l;
        $I(a), or() && a.mode & dt && UL();
        var T = B$(t);
        if (T !== null) {
          T.flags &= -257, Q$(T, t, a, e, c), T.mode & dt && j$(e, m, c), LI(T, e, m);
          return;
        } else {
          if (!cE(c)) {
            j$(e, m, c), B1();
            return;
          }
          var E = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          l = E;
        }
      } else if (or() && a.mode & dt) {
        UL();
        var b = B$(t);
        if (b !== null) {
          (b.flags & Rr) === Pe && (b.flags |= kr), Q$(b, t, a, e, c), rx(ih(l, a));
          return;
        }
      }
      l = ih(l, a), dq(l);
      var x = t;
      do {
        switch (x.tag) {
          case A: {
            var M = l;
            x.flags |= Rr;
            var z = Rf(c);
            x.lanes = it(x.lanes, z);
            var N = q$(x, M, z);
            Sx(x, N);
            return;
          }
          case $:
            var q = l, Q = x.type, Y = x.stateNode;
            if ((x.flags & Oe) === Pe && (typeof Q.getDerivedStateFromError == "function" || Y !== null && typeof Y.componentDidCatch == "function" && !BO(Y))) {
              x.flags |= Rr;
              var ve = Rf(c);
              x.lanes = it(x.lanes, ve);
              var Ue = f1(x, q, ve);
              Sx(x, Ue);
              return;
            }
            break;
        }
        x = x.return;
      } while (x !== null);
    }
    function AI() {
      return null;
    }
    var LS = n.ReactCurrentOwner, ul = !1, h1, $S, p1, m1, v1, rh, y1, Gb, OS;
    h1 = {}, $S = {}, p1 = {}, m1 = {}, v1 = {}, rh = !1, y1 = {}, Gb = {}, OS = {};
    function Zr(e, t, a, l) {
      e === null ? t.child = WL(t, null, a, l) : t.child = Vm(t, e.child, a, l);
    }
    function PI(e, t, a, l) {
      t.child = Vm(t, e.child, null, l), t.child = Vm(t, null, a, l);
    }
    function Y$(e, t, a, l, c) {
      if (t.type !== t.elementType) {
        var m = a.propTypes;
        m && il(
          m,
          l,
          // Resolved props
          "prop",
          Zt(a)
        );
      }
      var T = a.render, E = t.ref, b, x;
      Im(t, c), Yr(t);
      {
        if (LS.current = t, Ri(!0), b = Gm(e, t, T, l, E, c), x = Wm(), t.mode & Jt) {
          bn(!0);
          try {
            b = Gm(e, t, T, l, E, c), x = Wm();
          } finally {
            bn(!1);
          }
        }
        Ri(!1);
      }
      return Gr(), e !== null && !ul ? (u$(e, t, c), Tu(e, t, c)) : (or() && x && Zk(t), t.flags |= ja, Zr(e, t, b, c), t.child);
    }
    function G$(e, t, a, l, c) {
      if (e === null) {
        var m = a.type;
        if (Fq(m) && a.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        a.defaultProps === void 0) {
          var T = m;
          return T = iv(m), t.tag = He, t.type = T, T1(t, m), W$(e, t, T, l, c);
        }
        {
          var E = m.propTypes;
          if (E && il(
            E,
            l,
            // Resolved props
            "prop",
            Zt(m)
          ), a.defaultProps !== void 0) {
            var b = Zt(m) || "Unknown";
            OS[b] || (y("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", b), OS[b] = !0);
          }
        }
        var x = nR(a.type, null, l, t, t.mode, c);
        return x.ref = t.ref, x.return = t, t.child = x, x;
      }
      {
        var M = a.type, z = M.propTypes;
        z && il(
          z,
          l,
          // Resolved props
          "prop",
          Zt(M)
        );
      }
      var N = e.child, q = x1(e, c);
      if (!q) {
        var Q = N.memoizedProps, Y = a.compare;
        if (Y = Y !== null ? Y : Ne, Y(Q, l) && e.ref === t.ref)
          return Tu(e, t, c);
      }
      t.flags |= ja;
      var ve = uh(N, l);
      return ve.ref = t.ref, ve.return = t, t.child = ve, ve;
    }
    function W$(e, t, a, l, c) {
      if (t.type !== t.elementType) {
        var m = t.elementType;
        if (m.$$typeof === qi) {
          var T = m, E = T._payload, b = T._init;
          try {
            m = b(E);
          } catch {
            m = null;
          }
          var x = m && m.propTypes;
          x && il(
            x,
            l,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Zt(m)
          );
        }
      }
      if (e !== null) {
        var M = e.memoizedProps;
        if (Ne(M, l) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (ul = !1, t.pendingProps = l = M, x1(e, c))
            (e.flags & Up) !== Pe && (ul = !0);
          else return t.lanes = e.lanes, Tu(e, t, c);
      }
      return g1(e, t, a, l, c);
    }
    function K$(e, t, a) {
      var l = t.pendingProps, c = l.children, m = e !== null ? e.memoizedState : null;
      if (l.mode === "hidden" || he)
        if ((t.mode & dt) === _e) {
          var T = {
            baseLanes: ee,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = T, lC(t, a);
        } else if ($r(a, Wr)) {
          var z = {
            baseLanes: ee,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = z;
          var N = m !== null ? m.baseLanes : a;
          lC(t, N);
        } else {
          var E = null, b;
          if (m !== null) {
            var x = m.baseLanes;
            b = it(x, a);
          } else
            b = a;
          t.lanes = t.childLanes = Wr;
          var M = {
            baseLanes: b,
            cachePool: E,
            transitions: null
          };
          return t.memoizedState = M, t.updateQueue = null, lC(t, b), null;
        }
      else {
        var q;
        m !== null ? (q = it(m.baseLanes, a), t.memoizedState = null) : q = a, lC(t, q);
      }
      return Zr(e, t, c, a), t.child;
    }
    function _I(e, t, a) {
      var l = t.pendingProps;
      return Zr(e, t, l, a), t.child;
    }
    function NI(e, t, a) {
      var l = t.pendingProps.children;
      return Zr(e, t, l, a), t.child;
    }
    function UI(e, t, a) {
      {
        t.flags |= bt;
        {
          var l = t.stateNode;
          l.effectDuration = 0, l.passiveEffectDuration = 0;
        }
      }
      var c = t.pendingProps, m = c.children;
      return Zr(e, t, m, a), t.child;
    }
    function X$(e, t) {
      var a = t.ref;
      (e === null && a !== null || e !== null && e.ref !== a) && (t.flags |= An, t.flags |= bc);
    }
    function g1(e, t, a, l, c) {
      if (t.type !== t.elementType) {
        var m = a.propTypes;
        m && il(
          m,
          l,
          // Resolved props
          "prop",
          Zt(a)
        );
      }
      var T;
      {
        var E = _m(t, a, !0);
        T = Nm(t, E);
      }
      var b, x;
      Im(t, c), Yr(t);
      {
        if (LS.current = t, Ri(!0), b = Gm(e, t, a, l, T, c), x = Wm(), t.mode & Jt) {
          bn(!0);
          try {
            b = Gm(e, t, a, l, T, c), x = Wm();
          } finally {
            bn(!1);
          }
        }
        Ri(!1);
      }
      return Gr(), e !== null && !ul ? (u$(e, t, c), Tu(e, t, c)) : (or() && x && Zk(t), t.flags |= ja, Zr(e, t, b, c), t.child);
    }
    function Z$(e, t, a, l, c) {
      {
        switch (ej(t)) {
          case !1: {
            var m = t.stateNode, T = t.type, E = new T(t.memoizedProps, m.context), b = E.state;
            m.updater.enqueueSetState(m, b, null);
            break;
          }
          case !0: {
            t.flags |= Oe, t.flags |= Rr;
            var x = new Error("Simulated error coming from DevTools"), M = Rf(c);
            t.lanes = it(t.lanes, M);
            var z = f1(t, ih(x, t), M);
            Sx(t, z);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var N = a.propTypes;
          N && il(
            N,
            l,
            // Resolved props
            "prop",
            Zt(a)
          );
        }
      }
      var q;
      Xl(a) ? (q = !0, sb(t)) : q = !1, Im(t, c);
      var Q = t.stateNode, Y;
      Q === null ? (Kb(e, t), H$(t, a, l), u1(t, a, l, c), Y = !0) : e === null ? Y = xI(t, a, l, c) : Y = RI(e, t, a, l, c);
      var ve = S1(e, t, a, Y, q, c);
      {
        var Ue = t.stateNode;
        Y && Ue.props !== l && (rh || y("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", nt(t) || "a component"), rh = !0);
      }
      return ve;
    }
    function S1(e, t, a, l, c, m) {
      X$(e, t);
      var T = (t.flags & Oe) !== Pe;
      if (!l && !T)
        return c && AL(t, a, !1), Tu(e, t, m);
      var E = t.stateNode;
      LS.current = t;
      var b;
      if (T && typeof a.getDerivedStateFromError != "function")
        b = null, N$();
      else {
        Yr(t);
        {
          if (Ri(!0), b = E.render(), t.mode & Jt) {
            bn(!0);
            try {
              E.render();
            } finally {
              bn(!1);
            }
          }
          Ri(!1);
        }
        Gr();
      }
      return t.flags |= ja, e !== null && T ? PI(e, t, b, m) : Zr(e, t, b, m), t.memoizedState = E.state, c && AL(t, a, !0), t.child;
    }
    function J$(e) {
      var t = e.stateNode;
      t.pendingContext ? $L(e, t.pendingContext, t.pendingContext !== t.context) : t.context && $L(e, t.context, !1), Tx(e, t.containerInfo);
    }
    function zI(e, t, a) {
      if (J$(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var l = t.pendingProps, c = t.memoizedState, m = c.element;
      n$(e, t), bb(t, l, null, a);
      var T = t.memoizedState;
      t.stateNode;
      var E = T.element;
      if (c.isDehydrated) {
        var b = {
          element: E,
          isDehydrated: !1,
          cache: T.cache,
          pendingSuspenseBoundaries: T.pendingSuspenseBoundaries,
          transitions: T.transitions
        }, x = t.updateQueue;
        if (x.baseState = b, t.memoizedState = b, t.flags & kr) {
          var M = ih(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return eO(e, t, E, a, M);
        } else if (E !== m) {
          var z = ih(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return eO(e, t, E, a, z);
        } else {
          H3(t);
          var N = WL(t, null, E, a);
          t.child = N;
          for (var q = N; q; )
            q.flags = q.flags & -3 | ma, q = q.sibling;
        }
      } else {
        if (Fm(), E === m)
          return Tu(e, t, a);
        Zr(e, t, E, a);
      }
      return t.child;
    }
    function eO(e, t, a, l, c) {
      return Fm(), rx(c), t.flags |= kr, Zr(e, t, a, l), t.child;
    }
    function FI(e, t, a) {
      s$(t), e === null && ix(t);
      var l = t.type, c = t.pendingProps, m = e !== null ? e.memoizedProps : null, T = c.children, E = zk(l, c);
      return E ? T = null : m !== null && zk(l, m) && (t.flags |= Ba), X$(e, t), Zr(e, t, T, a), t.child;
    }
    function VI(e, t) {
      return e === null && ix(t), null;
    }
    function HI(e, t, a, l) {
      Kb(e, t);
      var c = t.pendingProps, m = a, T = m._payload, E = m._init, b = E(T);
      t.type = b;
      var x = t.tag = Vq(b), M = ol(b, c), z;
      switch (x) {
        case D:
          return T1(t, b), t.type = b = iv(b), z = g1(null, t, b, M, l), z;
        case $:
          return t.type = b = K1(b), z = Z$(null, t, b, M, l), z;
        case Ve:
          return t.type = b = X1(b), z = Y$(null, t, b, M, l), z;
        case wt: {
          if (t.type !== t.elementType) {
            var N = b.propTypes;
            N && il(
              N,
              M,
              // Resolved for outer only
              "prop",
              Zt(b)
            );
          }
          return z = G$(
            null,
            t,
            b,
            ol(b.type, M),
            // The inner type can have defaults too
            l
          ), z;
        }
      }
      var q = "";
      throw b !== null && typeof b == "object" && b.$$typeof === qi && (q = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + b + ". " + ("Lazy element type must resolve to a class or function." + q));
    }
    function II(e, t, a, l, c) {
      Kb(e, t), t.tag = $;
      var m;
      return Xl(a) ? (m = !0, sb(t)) : m = !1, Im(t, c), H$(t, a, l), u1(t, a, l, c), S1(null, t, a, !0, m, c);
    }
    function qI(e, t, a, l) {
      Kb(e, t);
      var c = t.pendingProps, m;
      {
        var T = _m(t, a, !1);
        m = Nm(t, T);
      }
      Im(t, l);
      var E, b;
      Yr(t);
      {
        if (a.prototype && typeof a.prototype.render == "function") {
          var x = Zt(a) || "Unknown";
          h1[x] || (y("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", x, x), h1[x] = !0);
        }
        t.mode & Jt && al.recordLegacyContextWarning(t, null), Ri(!0), LS.current = t, E = Gm(null, t, a, c, m, l), b = Wm(), Ri(!1);
      }
      if (Gr(), t.flags |= ja, typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0) {
        var M = Zt(a) || "Unknown";
        $S[M] || (y("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", M, M, M), $S[M] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0
      ) {
        {
          var z = Zt(a) || "Unknown";
          $S[z] || (y("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", z, z, z), $S[z] = !0);
        }
        t.tag = $, t.memoizedState = null, t.updateQueue = null;
        var N = !1;
        return Xl(a) ? (N = !0, sb(t)) : N = !1, t.memoizedState = E.state !== null && E.state !== void 0 ? E.state : null, gx(t), V$(t, E), u1(t, a, c, l), S1(null, t, a, !0, N, l);
      } else {
        if (t.tag = D, t.mode & Jt) {
          bn(!0);
          try {
            E = Gm(null, t, a, c, m, l), b = Wm();
          } finally {
            bn(!1);
          }
        }
        return or() && b && Zk(t), Zr(null, t, E, l), T1(t, a), t.child;
      }
    }
    function T1(e, t) {
      {
        if (t && t.childContextTypes && y("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var a = "", l = da();
          l && (a += `

Check the render method of \`` + l + "`.");
          var c = l || "", m = e._debugSource;
          m && (c = m.fileName + ":" + m.lineNumber), v1[c] || (v1[c] = !0, y("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", a));
        }
        if (t.defaultProps !== void 0) {
          var T = Zt(t) || "Unknown";
          OS[T] || (y("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", T), OS[T] = !0);
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var E = Zt(t) || "Unknown";
          m1[E] || (y("%s: Function components do not support getDerivedStateFromProps.", E), m1[E] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var b = Zt(t) || "Unknown";
          p1[b] || (y("%s: Function components do not support contextType.", b), p1[b] = !0);
        }
      }
    }
    var w1 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Ot
    };
    function E1(e) {
      return {
        baseLanes: e,
        cachePool: AI(),
        transitions: null
      };
    }
    function jI(e, t) {
      var a = null;
      return {
        baseLanes: it(e.baseLanes, t),
        cachePool: a,
        transitions: e.transitions
      };
    }
    function BI(e, t, a, l) {
      if (t !== null) {
        var c = t.memoizedState;
        if (c === null)
          return !1;
      }
      return bx(e, wS);
    }
    function QI(e, t) {
      return Df(e.childLanes, t);
    }
    function tO(e, t, a) {
      var l = t.pendingProps;
      tj(t) && (t.flags |= Oe);
      var c = sl.current, m = !1, T = (t.flags & Oe) !== Pe;
      if (T || BI(c, e) ? (m = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (c = cI(c, o$)), c = jm(c), jc(t, c), e === null) {
        ix(t);
        var E = t.memoizedState;
        if (E !== null) {
          var b = E.dehydrated;
          if (b !== null)
            return XI(t, b);
        }
        var x = l.children, M = l.fallback;
        if (m) {
          var z = YI(t, x, M, a), N = t.child;
          return N.memoizedState = E1(a), t.memoizedState = w1, z;
        } else
          return b1(t, x);
      } else {
        var q = e.memoizedState;
        if (q !== null) {
          var Q = q.dehydrated;
          if (Q !== null)
            return ZI(e, t, T, l, Q, q, a);
        }
        if (m) {
          var Y = l.fallback, ve = l.children, Ue = WI(e, t, ve, Y, a), Me = t.child, xt = e.child.memoizedState;
          return Me.memoizedState = xt === null ? E1(a) : jI(xt, a), Me.childLanes = QI(e, a), t.memoizedState = w1, Ue;
        } else {
          var mt = l.children, V = GI(e, t, mt, a);
          return t.memoizedState = null, V;
        }
      }
    }
    function b1(e, t, a) {
      var l = e.mode, c = {
        mode: "visible",
        children: t
      }, m = C1(c, l);
      return m.return = e, e.child = m, m;
    }
    function YI(e, t, a, l) {
      var c = e.mode, m = e.child, T = {
        mode: "hidden",
        children: t
      }, E, b;
      return (c & dt) === _e && m !== null ? (E = m, E.childLanes = ee, E.pendingProps = T, e.mode & Ut && (E.actualDuration = 0, E.actualStartTime = -1, E.selfBaseDuration = 0, E.treeBaseDuration = 0), b = Zc(a, c, l, null)) : (E = C1(T, c), b = Zc(a, c, l, null)), E.return = e, b.return = e, E.sibling = b, e.child = E, b;
    }
    function C1(e, t, a) {
      return nA(e, t, ee, null);
    }
    function nO(e, t) {
      return uh(e, t);
    }
    function GI(e, t, a, l) {
      var c = e.child, m = c.sibling, T = nO(c, {
        mode: "visible",
        children: a
      });
      if ((t.mode & dt) === _e && (T.lanes = l), T.return = t, T.sibling = null, m !== null) {
        var E = t.deletions;
        E === null ? (t.deletions = [m], t.flags |= pa) : E.push(m);
      }
      return t.child = T, T;
    }
    function WI(e, t, a, l, c) {
      var m = t.mode, T = e.child, E = T.sibling, b = {
        mode: "hidden",
        children: a
      }, x;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (m & dt) === _e && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== T
      ) {
        var M = t.child;
        x = M, x.childLanes = ee, x.pendingProps = b, t.mode & Ut && (x.actualDuration = 0, x.actualStartTime = -1, x.selfBaseDuration = T.selfBaseDuration, x.treeBaseDuration = T.treeBaseDuration), t.deletions = null;
      } else
        x = nO(T, b), x.subtreeFlags = T.subtreeFlags & Kn;
      var z;
      return E !== null ? z = uh(E, l) : (z = Zc(l, m, c, null), z.flags |= Un), z.return = t, x.return = t, x.sibling = z, t.child = x, z;
    }
    function Wb(e, t, a, l) {
      l !== null && rx(l), Vm(t, e.child, null, a);
      var c = t.pendingProps, m = c.children, T = b1(t, m);
      return T.flags |= Un, t.memoizedState = null, T;
    }
    function KI(e, t, a, l, c) {
      var m = t.mode, T = {
        mode: "visible",
        children: a
      }, E = C1(T, m), b = Zc(l, m, c, null);
      return b.flags |= Un, E.return = t, b.return = t, E.sibling = b, t.child = E, (t.mode & dt) !== _e && Vm(t, e.child, null, c), b;
    }
    function XI(e, t, a) {
      return (e.mode & dt) === _e ? (y("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = je) : Ik(t) ? e.lanes = ji : e.lanes = Wr, null;
    }
    function ZI(e, t, a, l, c, m, T) {
      if (a)
        if (t.flags & kr) {
          t.flags &= -257;
          var V = c1(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Wb(e, t, T, V);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= Oe, null;
          var G = l.children, H = l.fallback, ae = KI(e, t, G, H, T), Ee = t.child;
          return Ee.memoizedState = E1(T), t.memoizedState = w1, ae;
        }
      else {
        if (F3(), (t.mode & dt) === _e)
          return Wb(
            e,
            t,
            T,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Ik(c)) {
          var E, b, x;
          {
            var M = n3(c);
            E = M.digest, b = M.message, x = M.stack;
          }
          var z;
          b ? z = new Error(b) : z = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var N = c1(z, E, x);
          return Wb(e, t, T, N);
        }
        var q = $r(T, e.childLanes);
        if (ul || q) {
          var Q = sC();
          if (Q !== null) {
            var Y = _g(Q, T);
            if (Y !== Ot && Y !== m.retryLane) {
              m.retryLane = Y;
              var ve = ln;
              Ca(e, Y), Vi(Q, e, Y, ve);
            }
          }
          B1();
          var Ue = c1(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Wb(e, t, T, Ue);
        } else if (kL(c)) {
          t.flags |= Oe, t.child = e.child;
          var Me = bq.bind(null, e);
          return i3(c, Me), null;
        } else {
          I3(t, c, m.treeContext);
          var xt = l.children, mt = b1(t, xt);
          return mt.flags |= ma, mt;
        }
      }
    }
    function iO(e, t, a) {
      e.lanes = it(e.lanes, t);
      var l = e.alternate;
      l !== null && (l.lanes = it(l.lanes, t)), px(e.return, t, a);
    }
    function JI(e, t, a) {
      for (var l = t; l !== null; ) {
        if (l.tag === Ye) {
          var c = l.memoizedState;
          c !== null && iO(l, a, e);
        } else if (l.tag === Kt)
          iO(l, a, e);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === e)
          return;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === e)
            return;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    function e4(e) {
      for (var t = e, a = null; t !== null; ) {
        var l = t.alternate;
        l !== null && Rb(l) === null && (a = t), t = t.sibling;
      }
      return a;
    }
    function t4(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !y1[e])
        if (y1[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              y('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              y('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              y('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          y('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function n4(e, t) {
      e !== void 0 && !Gb[e] && (e !== "collapsed" && e !== "hidden" ? (Gb[e] = !0, y('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (Gb[e] = !0, y('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function rO(e, t) {
      {
        var a = Di(e), l = !a && typeof sn(e) == "function";
        if (a || l) {
          var c = a ? "array" : "iterable";
          return y("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", c, t, c), !1;
        }
      }
      return !0;
    }
    function i4(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (Di(e)) {
          for (var a = 0; a < e.length; a++)
            if (!rO(e[a], a))
              return;
        } else {
          var l = sn(e);
          if (typeof l == "function") {
            var c = l.call(e);
            if (c)
              for (var m = c.next(), T = 0; !m.done; m = c.next()) {
                if (!rO(m.value, T))
                  return;
                T++;
              }
          } else
            y('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function k1(e, t, a, l, c) {
      var m = e.memoizedState;
      m === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: l,
        tail: a,
        tailMode: c
      } : (m.isBackwards = t, m.rendering = null, m.renderingStartTime = 0, m.last = l, m.tail = a, m.tailMode = c);
    }
    function aO(e, t, a) {
      var l = t.pendingProps, c = l.revealOrder, m = l.tail, T = l.children;
      t4(c), n4(m, c), i4(T, c), Zr(e, t, T, a);
      var E = sl.current, b = bx(E, wS);
      if (b)
        E = Cx(E, wS), t.flags |= Oe;
      else {
        var x = e !== null && (e.flags & Oe) !== Pe;
        x && JI(t, t.child, a), E = jm(E);
      }
      if (jc(t, E), (t.mode & dt) === _e)
        t.memoizedState = null;
      else
        switch (c) {
          case "forwards": {
            var M = e4(t.child), z;
            M === null ? (z = t.child, t.child = null) : (z = M.sibling, M.sibling = null), k1(
              t,
              !1,
              // isBackwards
              z,
              M,
              m
            );
            break;
          }
          case "backwards": {
            var N = null, q = t.child;
            for (t.child = null; q !== null; ) {
              var Q = q.alternate;
              if (Q !== null && Rb(Q) === null) {
                t.child = q;
                break;
              }
              var Y = q.sibling;
              q.sibling = N, N = q, q = Y;
            }
            k1(
              t,
              !0,
              // isBackwards
              N,
              null,
              // last
              m
            );
            break;
          }
          case "together": {
            k1(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function r4(e, t, a) {
      Tx(t, t.stateNode.containerInfo);
      var l = t.pendingProps;
      return e === null ? t.child = Vm(t, null, l, a) : Zr(e, t, l, a), t.child;
    }
    var sO = !1;
    function a4(e, t, a) {
      var l = t.type, c = l._context, m = t.pendingProps, T = t.memoizedProps, E = m.value;
      {
        "value" in m || sO || (sO = !0, y("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var b = t.type.propTypes;
        b && il(b, m, "prop", "Context.Provider");
      }
      if (ZL(t, c, E), T !== null) {
        var x = T.value;
        if (ge(x, E)) {
          if (T.children === m.children && !rb())
            return Tu(e, t, a);
        } else
          tI(t, c, a);
      }
      var M = m.children;
      return Zr(e, t, M, a), t.child;
    }
    var lO = !1;
    function s4(e, t, a) {
      var l = t.type;
      l._context === void 0 ? l !== l.Consumer && (lO || (lO = !0, y("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : l = l._context;
      var c = t.pendingProps, m = c.children;
      typeof m != "function" && y("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Im(t, a);
      var T = wi(l);
      Yr(t);
      var E;
      return LS.current = t, Ri(!0), E = m(T), Ri(!1), Gr(), t.flags |= ja, Zr(e, t, E, a), t.child;
    }
    function AS() {
      ul = !0;
    }
    function Kb(e, t) {
      (t.mode & dt) === _e && e !== null && (e.alternate = null, t.alternate = null, t.flags |= Un);
    }
    function Tu(e, t, a) {
      return e !== null && (t.dependencies = e.dependencies), N$(), BS(t.lanes), $r(a, t.childLanes) ? (J3(e, t), t.child) : null;
    }
    function l4(e, t, a) {
      {
        var l = t.return;
        if (l === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, t === l.child)
          l.child = a;
        else {
          var c = l.child;
          if (c === null)
            throw new Error("Expected parent to have a child.");
          for (; c.sibling !== t; )
            if (c = c.sibling, c === null)
              throw new Error("Expected to find the previous sibling.");
          c.sibling = a;
        }
        var m = l.deletions;
        return m === null ? (l.deletions = [e], l.flags |= pa) : m.push(e), a.flags |= Un, a;
      }
    }
    function x1(e, t) {
      var a = e.lanes;
      return !!$r(a, t);
    }
    function o4(e, t, a) {
      switch (t.tag) {
        case A:
          J$(t), t.stateNode, Fm();
          break;
        case W:
          s$(t);
          break;
        case $: {
          var l = t.type;
          Xl(l) && sb(t);
          break;
        }
        case B:
          Tx(t, t.stateNode.containerInfo);
          break;
        case $t: {
          var c = t.memoizedProps.value, m = t.type._context;
          ZL(t, m, c);
          break;
        }
        case ct:
          {
            var T = $r(a, t.childLanes);
            T && (t.flags |= bt);
            {
              var E = t.stateNode;
              E.effectDuration = 0, E.passiveEffectDuration = 0;
            }
          }
          break;
        case Ye: {
          var b = t.memoizedState;
          if (b !== null) {
            if (b.dehydrated !== null)
              return jc(t, jm(sl.current)), t.flags |= Oe, null;
            var x = t.child, M = x.childLanes;
            if ($r(a, M))
              return tO(e, t, a);
            jc(t, jm(sl.current));
            var z = Tu(e, t, a);
            return z !== null ? z.sibling : null;
          } else
            jc(t, jm(sl.current));
          break;
        }
        case Kt: {
          var N = (e.flags & Oe) !== Pe, q = $r(a, t.childLanes);
          if (N) {
            if (q)
              return aO(e, t, a);
            t.flags |= Oe;
          }
          var Q = t.memoizedState;
          if (Q !== null && (Q.rendering = null, Q.tail = null, Q.lastEffect = null), jc(t, sl.current), q)
            break;
          return null;
        }
        case Ae:
        case Et:
          return t.lanes = ee, K$(e, t, a);
      }
      return Tu(e, t, a);
    }
    function oO(e, t, a) {
      if (t._debugNeedsRemount && e !== null)
        return l4(e, t, nR(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var l = e.memoizedProps, c = t.pendingProps;
        if (l !== c || rb() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          ul = !0;
        else {
          var m = x1(e, a);
          if (!m && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & Oe) === Pe)
            return ul = !1, o4(e, t, a);
          (e.flags & Up) !== Pe ? ul = !0 : ul = !1;
        }
      } else if (ul = !1, or() && A3(t)) {
        var T = t.index, E = P3();
        NL(t, E, T);
      }
      switch (t.lanes = ee, t.tag) {
        case _:
          return qI(e, t, t.type, a);
        case de: {
          var b = t.elementType;
          return HI(e, t, b, a);
        }
        case D: {
          var x = t.type, M = t.pendingProps, z = t.elementType === x ? M : ol(x, M);
          return g1(e, t, x, z, a);
        }
        case $: {
          var N = t.type, q = t.pendingProps, Q = t.elementType === N ? q : ol(N, q);
          return Z$(e, t, N, Q, a);
        }
        case A:
          return zI(e, t, a);
        case W:
          return FI(e, t, a);
        case ne:
          return VI(e, t);
        case Ye:
          return tO(e, t, a);
        case B:
          return r4(e, t, a);
        case Ve: {
          var Y = t.type, ve = t.pendingProps, Ue = t.elementType === Y ? ve : ol(Y, ve);
          return Y$(e, t, Y, Ue, a);
        }
        case ce:
          return _I(e, t, a);
        case Re:
          return NI(e, t, a);
        case ct:
          return UI(e, t, a);
        case $t:
          return a4(e, t, a);
        case Lt:
          return s4(e, t, a);
        case wt: {
          var Me = t.type, xt = t.pendingProps, mt = ol(Me, xt);
          if (t.type !== t.elementType) {
            var V = Me.propTypes;
            V && il(
              V,
              mt,
              // Resolved for outer only
              "prop",
              Zt(Me)
            );
          }
          return mt = ol(Me.type, mt), G$(e, t, Me, mt, a);
        }
        case He:
          return W$(e, t, t.type, t.pendingProps, a);
        case Ge: {
          var G = t.type, H = t.pendingProps, ae = t.elementType === G ? H : ol(G, H);
          return II(e, t, G, ae, a);
        }
        case Kt:
          return aO(e, t, a);
        case Mt:
          break;
        case Ae:
          return K$(e, t, a);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Km(e) {
      e.flags |= bt;
    }
    function uO(e) {
      e.flags |= An, e.flags |= bc;
    }
    var cO, R1, dO, fO;
    cO = function(e, t, a, l) {
      for (var c = t.child; c !== null; ) {
        if (c.tag === W || c.tag === ne)
          LH(e, c.stateNode);
        else if (c.tag !== B) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === t)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === t)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }, R1 = function(e, t) {
    }, dO = function(e, t, a, l, c) {
      var m = e.memoizedProps;
      if (m !== l) {
        var T = t.stateNode, E = wx(), b = OH(T, a, m, l, c, E);
        t.updateQueue = b, b && Km(t);
      }
    }, fO = function(e, t, a, l) {
      a !== l && Km(t);
    };
    function PS(e, t) {
      if (!or())
        switch (e.tailMode) {
          case "hidden": {
            for (var a = e.tail, l = null; a !== null; )
              a.alternate !== null && (l = a), a = a.sibling;
            l === null ? e.tail = null : l.sibling = null;
            break;
          }
          case "collapsed": {
            for (var c = e.tail, m = null; c !== null; )
              c.alternate !== null && (m = c), c = c.sibling;
            m === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : m.sibling = null;
            break;
          }
        }
    }
    function cr(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = ee, l = Pe;
      if (t) {
        if ((e.mode & Ut) !== _e) {
          for (var b = e.selfBaseDuration, x = e.child; x !== null; )
            a = it(a, it(x.lanes, x.childLanes)), l |= x.subtreeFlags & Kn, l |= x.flags & Kn, b += x.treeBaseDuration, x = x.sibling;
          e.treeBaseDuration = b;
        } else
          for (var M = e.child; M !== null; )
            a = it(a, it(M.lanes, M.childLanes)), l |= M.subtreeFlags & Kn, l |= M.flags & Kn, M.return = e, M = M.sibling;
        e.subtreeFlags |= l;
      } else {
        if ((e.mode & Ut) !== _e) {
          for (var c = e.actualDuration, m = e.selfBaseDuration, T = e.child; T !== null; )
            a = it(a, it(T.lanes, T.childLanes)), l |= T.subtreeFlags, l |= T.flags, c += T.actualDuration, m += T.treeBaseDuration, T = T.sibling;
          e.actualDuration = c, e.treeBaseDuration = m;
        } else
          for (var E = e.child; E !== null; )
            a = it(a, it(E.lanes, E.childLanes)), l |= E.subtreeFlags, l |= E.flags, E.return = e, E = E.sibling;
        e.subtreeFlags |= l;
      }
      return e.childLanes = a, t;
    }
    function u4(e, t, a) {
      if (Y3() && (t.mode & dt) !== _e && (t.flags & Oe) === Pe)
        return qL(t), Fm(), t.flags |= kr | ff | Rr, !1;
      var l = db(t);
      if (a !== null && a.dehydrated !== null)
        if (e === null) {
          if (!l)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (B3(t), cr(t), (t.mode & Ut) !== _e) {
            var c = a !== null;
            if (c) {
              var m = t.child;
              m !== null && (t.treeBaseDuration -= m.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Fm(), (t.flags & Oe) === Pe && (t.memoizedState = null), t.flags |= bt, cr(t), (t.mode & Ut) !== _e) {
            var T = a !== null;
            if (T) {
              var E = t.child;
              E !== null && (t.treeBaseDuration -= E.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return jL(), !0;
    }
    function hO(e, t, a) {
      var l = t.pendingProps;
      switch (Jk(t), t.tag) {
        case _:
        case de:
        case He:
        case D:
        case Ve:
        case ce:
        case Re:
        case ct:
        case Lt:
        case wt:
          return cr(t), null;
        case $: {
          var c = t.type;
          return Xl(c) && ab(t), cr(t), null;
        }
        case A: {
          var m = t.stateNode;
          if (qm(t), Wk(t), xx(), m.pendingContext && (m.context = m.pendingContext, m.pendingContext = null), e === null || e.child === null) {
            var T = db(t);
            if (T)
              Km(t);
            else if (e !== null) {
              var E = e.memoizedState;
              // Check if this is a client root
              (!E.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & kr) !== Pe) && (t.flags |= ui, jL());
            }
          }
          return R1(e, t), cr(t), null;
        }
        case W: {
          Ex(t);
          var b = a$(), x = t.type;
          if (e !== null && t.stateNode != null)
            dO(e, t, x, l, b), e.ref !== t.ref && uO(t);
          else {
            if (!l) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return cr(t), null;
            }
            var M = wx(), z = db(t);
            if (z)
              q3(t, b, M) && Km(t);
            else {
              var N = MH(x, l, b, M, t);
              cO(N, t, !1, !1), t.stateNode = N, $H(N, x, l, b) && Km(t);
            }
            t.ref !== null && uO(t);
          }
          return cr(t), null;
        }
        case ne: {
          var q = l;
          if (e && t.stateNode != null) {
            var Q = e.memoizedProps;
            fO(e, t, Q, q);
          } else {
            if (typeof q != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Y = a$(), ve = wx(), Ue = db(t);
            Ue ? j3(t) && Km(t) : t.stateNode = AH(q, Y, ve, t);
          }
          return cr(t), null;
        }
        case Ye: {
          Bm(t);
          var Me = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var xt = u4(e, t, Me);
            if (!xt)
              return t.flags & Rr ? t : null;
          }
          if ((t.flags & Oe) !== Pe)
            return t.lanes = a, (t.mode & Ut) !== _e && Xx(t), t;
          var mt = Me !== null, V = e !== null && e.memoizedState !== null;
          if (mt !== V && mt) {
            var G = t.child;
            if (G.flags |= Wn, (t.mode & dt) !== _e) {
              var H = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              H || bx(sl.current, o$) ? cq() : B1();
            }
          }
          var ae = t.updateQueue;
          if (ae !== null && (t.flags |= bt), cr(t), (t.mode & Ut) !== _e && mt) {
            var Ee = t.child;
            Ee !== null && (t.treeBaseDuration -= Ee.treeBaseDuration);
          }
          return null;
        }
        case B:
          return qm(t), R1(e, t), e === null && x3(t.stateNode.containerInfo), cr(t), null;
        case $t:
          var Se = t.type._context;
          return hx(Se, t), cr(t), null;
        case Ge: {
          var Qe = t.type;
          return Xl(Qe) && ab(t), cr(t), null;
        }
        case Kt: {
          Bm(t);
          var et = t.memoizedState;
          if (et === null)
            return cr(t), null;
          var tn = (t.flags & Oe) !== Pe, Vt = et.rendering;
          if (Vt === null)
            if (tn)
              PS(et, !1);
            else {
              var hi = fq() && (e === null || (e.flags & Oe) === Pe);
              if (!hi)
                for (var Ht = t.child; Ht !== null; ) {
                  var ni = Rb(Ht);
                  if (ni !== null) {
                    tn = !0, t.flags |= Oe, PS(et, !1);
                    var zr = ni.updateQueue;
                    return zr !== null && (t.updateQueue = zr, t.flags |= bt), t.subtreeFlags = Pe, eI(t, a), jc(t, Cx(sl.current, wS)), t.child;
                  }
                  Ht = Ht.sibling;
                }
              et.tail !== null && ci() > PO() && (t.flags |= Oe, tn = !0, PS(et, !1), t.lanes = xg);
            }
          else {
            if (!tn) {
              var mr = Rb(Vt);
              if (mr !== null) {
                t.flags |= Oe, tn = !0;
                var Za = mr.updateQueue;
                if (Za !== null && (t.updateQueue = Za, t.flags |= bt), PS(et, !0), et.tail === null && et.tailMode === "hidden" && !Vt.alternate && !or())
                  return cr(t), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              ci() * 2 - et.renderingStartTime > PO() && a !== Wr && (t.flags |= Oe, tn = !0, PS(et, !1), t.lanes = xg);
            }
            if (et.isBackwards)
              Vt.sibling = t.child, t.child = Vt;
            else {
              var ta = et.last;
              ta !== null ? ta.sibling = Vt : t.child = Vt, et.last = Vt;
            }
          }
          if (et.tail !== null) {
            var na = et.tail;
            et.rendering = na, et.tail = na.sibling, et.renderingStartTime = ci(), na.sibling = null;
            var Fr = sl.current;
            return tn ? Fr = Cx(Fr, wS) : Fr = jm(Fr), jc(t, Fr), na;
          }
          return cr(t), null;
        }
        case Mt:
          break;
        case Ae:
        case Et: {
          j1(t);
          var ku = t.memoizedState, rv = ku !== null;
          if (e !== null) {
            var KS = e.memoizedState, ao = KS !== null;
            ao !== rv && (t.flags |= Wn);
          }
          return !rv || (t.mode & dt) === _e ? cr(t) : $r(ro, Wr) && (cr(t), t.subtreeFlags & (Un | bt) && (t.flags |= Wn)), null;
        }
        case Sn:
          return null;
        case Je:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function c4(e, t, a) {
      switch (Jk(t), t.tag) {
        case $: {
          var l = t.type;
          Xl(l) && ab(t);
          var c = t.flags;
          return c & Rr ? (t.flags = c & -65537 | Oe, (t.mode & Ut) !== _e && Xx(t), t) : null;
        }
        case A: {
          t.stateNode, qm(t), Wk(t), xx();
          var m = t.flags;
          return (m & Rr) !== Pe && (m & Oe) === Pe ? (t.flags = m & -65537 | Oe, t) : null;
        }
        case W:
          return Ex(t), null;
        case Ye: {
          Bm(t);
          var T = t.memoizedState;
          if (T !== null && T.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Fm();
          }
          var E = t.flags;
          return E & Rr ? (t.flags = E & -65537 | Oe, (t.mode & Ut) !== _e && Xx(t), t) : null;
        }
        case Kt:
          return Bm(t), null;
        case B:
          return qm(t), null;
        case $t:
          var b = t.type._context;
          return hx(b, t), null;
        case Ae:
        case Et:
          return j1(t), null;
        case Sn:
          return null;
        default:
          return null;
      }
    }
    function pO(e, t, a) {
      switch (Jk(t), t.tag) {
        case $: {
          var l = t.type.childContextTypes;
          l != null && ab(t);
          break;
        }
        case A: {
          t.stateNode, qm(t), Wk(t), xx();
          break;
        }
        case W: {
          Ex(t);
          break;
        }
        case B:
          qm(t);
          break;
        case Ye:
          Bm(t);
          break;
        case Kt:
          Bm(t);
          break;
        case $t:
          var c = t.type._context;
          hx(c, t);
          break;
        case Ae:
        case Et:
          j1(t);
          break;
      }
    }
    var mO = null;
    mO = /* @__PURE__ */ new Set();
    var Xb = !1, dr = !1, d4 = typeof WeakSet == "function" ? WeakSet : Set, xe = null, Xm = null, Zm = null;
    function f4(e) {
      Al(null, function() {
        throw e;
      }), df();
    }
    var h4 = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Ut)
        try {
          no(), t.componentWillUnmount();
        } finally {
          to(e);
        }
      else
        t.componentWillUnmount();
    };
    function vO(e, t) {
      try {
        Yc(Pi, e);
      } catch (a) {
        mn(e, t, a);
      }
    }
    function D1(e, t, a) {
      try {
        h4(e, a);
      } catch (l) {
        mn(e, t, l);
      }
    }
    function p4(e, t, a) {
      try {
        a.componentDidMount();
      } catch (l) {
        mn(e, t, l);
      }
    }
    function yO(e, t) {
      try {
        SO(e);
      } catch (a) {
        mn(e, t, a);
      }
    }
    function Jm(e, t) {
      var a = e.ref;
      if (a !== null)
        if (typeof a == "function") {
          var l;
          try {
            if (Bn && oa && e.mode & Ut)
              try {
                no(), l = a(null);
              } finally {
                to(e);
              }
            else
              l = a(null);
          } catch (c) {
            mn(e, t, c);
          }
          typeof l == "function" && y("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", nt(e));
        } else
          a.current = null;
    }
    function Zb(e, t, a) {
      try {
        a();
      } catch (l) {
        mn(e, t, l);
      }
    }
    var gO = !1;
    function m4(e, t) {
      RH(e.containerInfo), xe = t, v4();
      var a = gO;
      return gO = !1, a;
    }
    function v4() {
      for (; xe !== null; ) {
        var e = xe, t = e.child;
        (e.subtreeFlags & _l) !== Pe && t !== null ? (t.return = e, xe = t) : y4();
      }
    }
    function y4() {
      for (; xe !== null; ) {
        var e = xe;
        pn(e);
        try {
          g4(e);
        } catch (a) {
          mn(e, e.return, a);
        }
        On();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, xe = t;
          return;
        }
        xe = e.return;
      }
    }
    function g4(e) {
      var t = e.alternate, a = e.flags;
      if ((a & ui) !== Pe) {
        switch (pn(e), e.tag) {
          case D:
          case Ve:
          case He:
            break;
          case $: {
            if (t !== null) {
              var l = t.memoizedProps, c = t.memoizedState, m = e.stateNode;
              e.type === e.elementType && !rh && (m.props !== e.memoizedProps && y("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(e) || "instance"), m.state !== e.memoizedState && y("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(e) || "instance"));
              var T = m.getSnapshotBeforeUpdate(e.elementType === e.type ? l : ol(e.type, l), c);
              {
                var E = mO;
                T === void 0 && !E.has(e.type) && (E.add(e.type), y("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", nt(e)));
              }
              m.__reactInternalSnapshotBeforeUpdate = T;
            }
            break;
          }
          case A: {
            {
              var b = e.stateNode;
              ZH(b.containerInfo);
            }
            break;
          }
          case W:
          case ne:
          case B:
          case Ge:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        On();
      }
    }
    function cl(e, t, a) {
      var l = t.updateQueue, c = l !== null ? l.lastEffect : null;
      if (c !== null) {
        var m = c.next, T = m;
        do {
          if ((T.tag & e) === e) {
            var E = T.destroy;
            T.destroy = void 0, E !== void 0 && ((e & ur) !== ka ? Xs(t) : (e & Pi) !== ka && pf(t), (e & Zl) !== ka && YS(!0), Zb(t, a, E), (e & Zl) !== ka && YS(!1), (e & ur) !== ka ? Fl() : (e & Pi) !== ka && Cg());
          }
          T = T.next;
        } while (T !== m);
      }
    }
    function Yc(e, t) {
      var a = t.updateQueue, l = a !== null ? a.lastEffect : null;
      if (l !== null) {
        var c = l.next, m = c;
        do {
          if ((m.tag & e) === e) {
            (e & ur) !== ka ? bg(t) : (e & Pi) !== ka && qp(t);
            var T = m.create;
            (e & Zl) !== ka && YS(!0), m.destroy = T(), (e & Zl) !== ka && YS(!1), (e & ur) !== ka ? aE() : (e & Pi) !== ka && sE();
            {
              var E = m.destroy;
              if (E !== void 0 && typeof E != "function") {
                var b = void 0;
                (m.tag & Pi) !== Pe ? b = "useLayoutEffect" : (m.tag & Zl) !== Pe ? b = "useInsertionEffect" : b = "useEffect";
                var x = void 0;
                E === null ? x = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof E.then == "function" ? x = `

It looks like you wrote ` + b + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + b + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : x = " You returned: " + E, y("%s must not return anything besides a function, which is used for clean-up.%s", b, x);
              }
            }
          }
          m = m.next;
        } while (m !== c);
      }
    }
    function S4(e, t) {
      if ((t.flags & bt) !== Pe)
        switch (t.tag) {
          case ct: {
            var a = t.stateNode.passiveEffectDuration, l = t.memoizedProps, c = l.id, m = l.onPostCommit, T = P$(), E = t.alternate === null ? "mount" : "update";
            A$() && (E = "nested-update"), typeof m == "function" && m(c, E, a, T);
            var b = t.return;
            e: for (; b !== null; ) {
              switch (b.tag) {
                case A:
                  var x = b.stateNode;
                  x.passiveEffectDuration += a;
                  break e;
                case ct:
                  var M = b.stateNode;
                  M.passiveEffectDuration += a;
                  break e;
              }
              b = b.return;
            }
            break;
          }
        }
    }
    function T4(e, t, a, l) {
      if ((a.flags & Ul) !== Pe)
        switch (a.tag) {
          case D:
          case Ve:
          case He: {
            if (!dr)
              if (a.mode & Ut)
                try {
                  no(), Yc(Pi | Ai, a);
                } finally {
                  to(a);
                }
              else
                Yc(Pi | Ai, a);
            break;
          }
          case $: {
            var c = a.stateNode;
            if (a.flags & bt && !dr)
              if (t === null)
                if (a.type === a.elementType && !rh && (c.props !== a.memoizedProps && y("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(a) || "instance"), c.state !== a.memoizedState && y("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(a) || "instance")), a.mode & Ut)
                  try {
                    no(), c.componentDidMount();
                  } finally {
                    to(a);
                  }
                else
                  c.componentDidMount();
              else {
                var m = a.elementType === a.type ? t.memoizedProps : ol(a.type, t.memoizedProps), T = t.memoizedState;
                if (a.type === a.elementType && !rh && (c.props !== a.memoizedProps && y("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(a) || "instance"), c.state !== a.memoizedState && y("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(a) || "instance")), a.mode & Ut)
                  try {
                    no(), c.componentDidUpdate(m, T, c.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    to(a);
                  }
                else
                  c.componentDidUpdate(m, T, c.__reactInternalSnapshotBeforeUpdate);
              }
            var E = a.updateQueue;
            E !== null && (a.type === a.elementType && !rh && (c.props !== a.memoizedProps && y("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(a) || "instance"), c.state !== a.memoizedState && y("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(a) || "instance")), r$(a, E, c));
            break;
          }
          case A: {
            var b = a.updateQueue;
            if (b !== null) {
              var x = null;
              if (a.child !== null)
                switch (a.child.tag) {
                  case W:
                    x = a.child.stateNode;
                    break;
                  case $:
                    x = a.child.stateNode;
                    break;
                }
              r$(a, b, x);
            }
            break;
          }
          case W: {
            var M = a.stateNode;
            if (t === null && a.flags & bt) {
              var z = a.type, N = a.memoizedProps;
              zH(M, z, N);
            }
            break;
          }
          case ne:
            break;
          case B:
            break;
          case ct: {
            {
              var q = a.memoizedProps, Q = q.onCommit, Y = q.onRender, ve = a.stateNode.effectDuration, Ue = P$(), Me = t === null ? "mount" : "update";
              A$() && (Me = "nested-update"), typeof Y == "function" && Y(a.memoizedProps.id, Me, a.actualDuration, a.treeBaseDuration, a.actualStartTime, Ue);
              {
                typeof Q == "function" && Q(a.memoizedProps.id, Me, ve, Ue), yq(a);
                var xt = a.return;
                e: for (; xt !== null; ) {
                  switch (xt.tag) {
                    case A:
                      var mt = xt.stateNode;
                      mt.effectDuration += ve;
                      break e;
                    case ct:
                      var V = xt.stateNode;
                      V.effectDuration += ve;
                      break e;
                  }
                  xt = xt.return;
                }
              }
            }
            break;
          }
          case Ye: {
            D4(e, a);
            break;
          }
          case Kt:
          case Ge:
          case Mt:
          case Ae:
          case Et:
          case Je:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      dr || a.flags & An && SO(a);
    }
    function w4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          if (e.mode & Ut)
            try {
              no(), vO(e, e.return);
            } finally {
              to(e);
            }
          else
            vO(e, e.return);
          break;
        }
        case $: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && p4(e, e.return, t), yO(e, e.return);
          break;
        }
        case W: {
          yO(e, e.return);
          break;
        }
      }
    }
    function E4(e, t) {
      for (var a = null, l = e; ; ) {
        if (l.tag === W) {
          if (a === null) {
            a = l;
            try {
              var c = l.stateNode;
              t ? GH(c) : KH(l.stateNode, l.memoizedProps);
            } catch (T) {
              mn(e, e.return, T);
            }
          }
        } else if (l.tag === ne) {
          if (a === null)
            try {
              var m = l.stateNode;
              t ? WH(m) : XH(m, l.memoizedProps);
            } catch (T) {
              mn(e, e.return, T);
            }
        } else if (!((l.tag === Ae || l.tag === Et) && l.memoizedState !== null && l !== e)) {
          if (l.child !== null) {
            l.child.return = l, l = l.child;
            continue;
          }
        }
        if (l === e)
          return;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === e)
            return;
          a === l && (a = null), l = l.return;
        }
        a === l && (a = null), l.sibling.return = l.return, l = l.sibling;
      }
    }
    function SO(e) {
      var t = e.ref;
      if (t !== null) {
        var a = e.stateNode, l;
        switch (e.tag) {
          case W:
            l = a;
            break;
          default:
            l = a;
        }
        if (typeof t == "function") {
          var c;
          if (e.mode & Ut)
            try {
              no(), c = t(l);
            } finally {
              to(e);
            }
          else
            c = t(l);
          typeof c == "function" && y("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", nt(e));
        } else
          t.hasOwnProperty("current") || y("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", nt(e)), t.current = l;
      }
    }
    function b4(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function TO(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, TO(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === W) {
          var a = e.stateNode;
          a !== null && M3(a);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function C4(e) {
      for (var t = e.return; t !== null; ) {
        if (wO(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function wO(e) {
      return e.tag === W || e.tag === A || e.tag === B;
    }
    function EO(e) {
      var t = e;
      e: for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || wO(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== W && t.tag !== ne && t.tag !== ft; ) {
          if (t.flags & Un || t.child === null || t.tag === B)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & Un))
          return t.stateNode;
      }
    }
    function k4(e) {
      var t = C4(e);
      switch (t.tag) {
        case W: {
          var a = t.stateNode;
          t.flags & Ba && (CL(a), t.flags &= -33);
          var l = EO(e);
          L1(e, l, a);
          break;
        }
        case A:
        case B: {
          var c = t.stateNode.containerInfo, m = EO(e);
          M1(e, m, c);
          break;
        }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function M1(e, t, a) {
      var l = e.tag, c = l === W || l === ne;
      if (c) {
        var m = e.stateNode;
        t ? jH(a, m, t) : IH(a, m);
      } else if (l !== B) {
        var T = e.child;
        if (T !== null) {
          M1(T, t, a);
          for (var E = T.sibling; E !== null; )
            M1(E, t, a), E = E.sibling;
        }
      }
    }
    function L1(e, t, a) {
      var l = e.tag, c = l === W || l === ne;
      if (c) {
        var m = e.stateNode;
        t ? qH(a, m, t) : HH(a, m);
      } else if (l !== B) {
        var T = e.child;
        if (T !== null) {
          L1(T, t, a);
          for (var E = T.sibling; E !== null; )
            L1(E, t, a), E = E.sibling;
        }
      }
    }
    var fr = null, dl = !1;
    function x4(e, t, a) {
      {
        var l = t;
        e: for (; l !== null; ) {
          switch (l.tag) {
            case W: {
              fr = l.stateNode, dl = !1;
              break e;
            }
            case A: {
              fr = l.stateNode.containerInfo, dl = !0;
              break e;
            }
            case B: {
              fr = l.stateNode.containerInfo, dl = !0;
              break e;
            }
          }
          l = l.return;
        }
        if (fr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        bO(e, t, a), fr = null, dl = !1;
      }
      b4(a);
    }
    function Gc(e, t, a) {
      for (var l = a.child; l !== null; )
        bO(e, t, l), l = l.sibling;
    }
    function bO(e, t, a) {
      switch (Tg(a), a.tag) {
        case W:
          dr || Jm(a, t);
        // eslint-disable-next-line-no-fallthrough
        case ne: {
          {
            var l = fr, c = dl;
            fr = null, Gc(e, t, a), fr = l, dl = c, fr !== null && (dl ? QH(fr, a.stateNode) : BH(fr, a.stateNode));
          }
          return;
        }
        case ft: {
          fr !== null && (dl ? YH(fr, a.stateNode) : Hk(fr, a.stateNode));
          return;
        }
        case B: {
          {
            var m = fr, T = dl;
            fr = a.stateNode.containerInfo, dl = !0, Gc(e, t, a), fr = m, dl = T;
          }
          return;
        }
        case D:
        case Ve:
        case wt:
        case He: {
          if (!dr) {
            var E = a.updateQueue;
            if (E !== null) {
              var b = E.lastEffect;
              if (b !== null) {
                var x = b.next, M = x;
                do {
                  var z = M, N = z.destroy, q = z.tag;
                  N !== void 0 && ((q & Zl) !== ka ? Zb(a, t, N) : (q & Pi) !== ka && (pf(a), a.mode & Ut ? (no(), Zb(a, t, N), to(a)) : Zb(a, t, N), Cg())), M = M.next;
                } while (M !== x);
              }
            }
          }
          Gc(e, t, a);
          return;
        }
        case $: {
          if (!dr) {
            Jm(a, t);
            var Q = a.stateNode;
            typeof Q.componentWillUnmount == "function" && D1(a, t, Q);
          }
          Gc(e, t, a);
          return;
        }
        case Mt: {
          Gc(e, t, a);
          return;
        }
        case Ae: {
          if (
            // TODO: Remove this dead flag
            a.mode & dt
          ) {
            var Y = dr;
            dr = Y || a.memoizedState !== null, Gc(e, t, a), dr = Y;
          } else
            Gc(e, t, a);
          break;
        }
        default: {
          Gc(e, t, a);
          return;
        }
      }
    }
    function R4(e) {
      e.memoizedState;
    }
    function D4(e, t) {
      var a = t.memoizedState;
      if (a === null) {
        var l = t.alternate;
        if (l !== null) {
          var c = l.memoizedState;
          if (c !== null) {
            var m = c.dehydrated;
            m !== null && f3(m);
          }
        }
      }
    }
    function CO(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var a = e.stateNode;
        a === null && (a = e.stateNode = new d4()), t.forEach(function(l) {
          var c = Cq.bind(null, e, l);
          if (!a.has(l)) {
            if (a.add(l), Lr)
              if (Xm !== null && Zm !== null)
                QS(Zm, Xm);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            l.then(c, c);
          }
        });
      }
    }
    function M4(e, t, a) {
      Xm = a, Zm = e, pn(t), kO(t, e), pn(t), Xm = null, Zm = null;
    }
    function fl(e, t, a) {
      var l = t.deletions;
      if (l !== null)
        for (var c = 0; c < l.length; c++) {
          var m = l[c];
          try {
            x4(e, t, m);
          } catch (b) {
            mn(m, t, b);
          }
        }
      var T = Gd();
      if (t.subtreeFlags & Nl)
        for (var E = t.child; E !== null; )
          pn(E), kO(E, e), E = E.sibling;
      pn(T);
    }
    function kO(e, t, a) {
      var l = e.alternate, c = e.flags;
      switch (e.tag) {
        case D:
        case Ve:
        case wt:
        case He: {
          if (fl(t, e), io(e), c & bt) {
            try {
              cl(Zl | Ai, e, e.return), Yc(Zl | Ai, e);
            } catch (Qe) {
              mn(e, e.return, Qe);
            }
            if (e.mode & Ut) {
              try {
                no(), cl(Pi | Ai, e, e.return);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
              to(e);
            } else
              try {
                cl(Pi | Ai, e, e.return);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
          }
          return;
        }
        case $: {
          fl(t, e), io(e), c & An && l !== null && Jm(l, l.return);
          return;
        }
        case W: {
          fl(t, e), io(e), c & An && l !== null && Jm(l, l.return);
          {
            if (e.flags & Ba) {
              var m = e.stateNode;
              try {
                CL(m);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
            }
            if (c & bt) {
              var T = e.stateNode;
              if (T != null) {
                var E = e.memoizedProps, b = l !== null ? l.memoizedProps : E, x = e.type, M = e.updateQueue;
                if (e.updateQueue = null, M !== null)
                  try {
                    FH(T, M, x, b, E, e);
                  } catch (Qe) {
                    mn(e, e.return, Qe);
                  }
              }
            }
          }
          return;
        }
        case ne: {
          if (fl(t, e), io(e), c & bt) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var z = e.stateNode, N = e.memoizedProps, q = l !== null ? l.memoizedProps : N;
            try {
              VH(z, q, N);
            } catch (Qe) {
              mn(e, e.return, Qe);
            }
          }
          return;
        }
        case A: {
          if (fl(t, e), io(e), c & bt && l !== null) {
            var Q = l.memoizedState;
            if (Q.isDehydrated)
              try {
                d3(t.containerInfo);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
          }
          return;
        }
        case B: {
          fl(t, e), io(e);
          return;
        }
        case Ye: {
          fl(t, e), io(e);
          var Y = e.child;
          if (Y.flags & Wn) {
            var ve = Y.stateNode, Ue = Y.memoizedState, Me = Ue !== null;
            if (ve.isHidden = Me, Me) {
              var xt = Y.alternate !== null && Y.alternate.memoizedState !== null;
              xt || uq();
            }
          }
          if (c & bt) {
            try {
              R4(e);
            } catch (Qe) {
              mn(e, e.return, Qe);
            }
            CO(e);
          }
          return;
        }
        case Ae: {
          var mt = l !== null && l.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & dt
          ) {
            var V = dr;
            dr = V || mt, fl(t, e), dr = V;
          } else
            fl(t, e);
          if (io(e), c & Wn) {
            var G = e.stateNode, H = e.memoizedState, ae = H !== null, Ee = e;
            if (G.isHidden = ae, ae && !mt && (Ee.mode & dt) !== _e) {
              xe = Ee;
              for (var Se = Ee.child; Se !== null; )
                xe = Se, $4(Se), Se = Se.sibling;
            }
            E4(Ee, ae);
          }
          return;
        }
        case Kt: {
          fl(t, e), io(e), c & bt && CO(e);
          return;
        }
        case Mt:
          return;
        default: {
          fl(t, e), io(e);
          return;
        }
      }
    }
    function io(e) {
      var t = e.flags;
      if (t & Un) {
        try {
          k4(e);
        } catch (a) {
          mn(e, e.return, a);
        }
        e.flags &= -3;
      }
      t & ma && (e.flags &= -4097);
    }
    function L4(e, t, a) {
      Xm = a, Zm = t, xe = e, xO(e, t, a), Xm = null, Zm = null;
    }
    function xO(e, t, a) {
      for (var l = (e.mode & dt) !== _e; xe !== null; ) {
        var c = xe, m = c.child;
        if (c.tag === Ae && l) {
          var T = c.memoizedState !== null, E = T || Xb;
          if (E) {
            $1(e, t, a);
            continue;
          } else {
            var b = c.alternate, x = b !== null && b.memoizedState !== null, M = x || dr, z = Xb, N = dr;
            Xb = E, dr = M, dr && !N && (xe = c, O4(c));
            for (var q = m; q !== null; )
              xe = q, xO(
                q,
                // New root; bubble back up to here and stop.
                t,
                a
              ), q = q.sibling;
            xe = c, Xb = z, dr = N, $1(e, t, a);
            continue;
          }
        }
        (c.subtreeFlags & Ul) !== Pe && m !== null ? (m.return = c, xe = m) : $1(e, t, a);
      }
    }
    function $1(e, t, a) {
      for (; xe !== null; ) {
        var l = xe;
        if ((l.flags & Ul) !== Pe) {
          var c = l.alternate;
          pn(l);
          try {
            T4(t, c, l, a);
          } catch (T) {
            mn(l, l.return, T);
          }
          On();
        }
        if (l === e) {
          xe = null;
          return;
        }
        var m = l.sibling;
        if (m !== null) {
          m.return = l.return, xe = m;
          return;
        }
        xe = l.return;
      }
    }
    function $4(e) {
      for (; xe !== null; ) {
        var t = xe, a = t.child;
        switch (t.tag) {
          case D:
          case Ve:
          case wt:
          case He: {
            if (t.mode & Ut)
              try {
                no(), cl(Pi, t, t.return);
              } finally {
                to(t);
              }
            else
              cl(Pi, t, t.return);
            break;
          }
          case $: {
            Jm(t, t.return);
            var l = t.stateNode;
            typeof l.componentWillUnmount == "function" && D1(t, t.return, l);
            break;
          }
          case W: {
            Jm(t, t.return);
            break;
          }
          case Ae: {
            var c = t.memoizedState !== null;
            if (c) {
              RO(e);
              continue;
            }
            break;
          }
        }
        a !== null ? (a.return = t, xe = a) : RO(e);
      }
    }
    function RO(e) {
      for (; xe !== null; ) {
        var t = xe;
        if (t === e) {
          xe = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, xe = a;
          return;
        }
        xe = t.return;
      }
    }
    function O4(e) {
      for (; xe !== null; ) {
        var t = xe, a = t.child;
        if (t.tag === Ae) {
          var l = t.memoizedState !== null;
          if (l) {
            DO(e);
            continue;
          }
        }
        a !== null ? (a.return = t, xe = a) : DO(e);
      }
    }
    function DO(e) {
      for (; xe !== null; ) {
        var t = xe;
        pn(t);
        try {
          w4(t);
        } catch (l) {
          mn(t, t.return, l);
        }
        if (On(), t === e) {
          xe = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, xe = a;
          return;
        }
        xe = t.return;
      }
    }
    function A4(e, t, a, l) {
      xe = t, P4(t, e, a, l);
    }
    function P4(e, t, a, l) {
      for (; xe !== null; ) {
        var c = xe, m = c.child;
        (c.subtreeFlags & Ws) !== Pe && m !== null ? (m.return = c, xe = m) : _4(e, t, a, l);
      }
    }
    function _4(e, t, a, l) {
      for (; xe !== null; ) {
        var c = xe;
        if ((c.flags & xr) !== Pe) {
          pn(c);
          try {
            N4(t, c, a, l);
          } catch (T) {
            mn(c, c.return, T);
          }
          On();
        }
        if (c === e) {
          xe = null;
          return;
        }
        var m = c.sibling;
        if (m !== null) {
          m.return = c.return, xe = m;
          return;
        }
        xe = c.return;
      }
    }
    function N4(e, t, a, l) {
      switch (t.tag) {
        case D:
        case Ve:
        case He: {
          if (t.mode & Ut) {
            Kx();
            try {
              Yc(ur | Ai, t);
            } finally {
              Wx(t);
            }
          } else
            Yc(ur | Ai, t);
          break;
        }
      }
    }
    function U4(e) {
      xe = e, z4();
    }
    function z4() {
      for (; xe !== null; ) {
        var e = xe, t = e.child;
        if ((xe.flags & pa) !== Pe) {
          var a = e.deletions;
          if (a !== null) {
            for (var l = 0; l < a.length; l++) {
              var c = a[l];
              xe = c, H4(c, e);
            }
            {
              var m = e.alternate;
              if (m !== null) {
                var T = m.child;
                if (T !== null) {
                  m.child = null;
                  do {
                    var E = T.sibling;
                    T.sibling = null, T = E;
                  } while (T !== null);
                }
              }
            }
            xe = e;
          }
        }
        (e.subtreeFlags & Ws) !== Pe && t !== null ? (t.return = e, xe = t) : F4();
      }
    }
    function F4() {
      for (; xe !== null; ) {
        var e = xe;
        (e.flags & xr) !== Pe && (pn(e), V4(e), On());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, xe = t;
          return;
        }
        xe = e.return;
      }
    }
    function V4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          e.mode & Ut ? (Kx(), cl(ur | Ai, e, e.return), Wx(e)) : cl(ur | Ai, e, e.return);
          break;
        }
      }
    }
    function H4(e, t) {
      for (; xe !== null; ) {
        var a = xe;
        pn(a), q4(a, t), On();
        var l = a.child;
        l !== null ? (l.return = a, xe = l) : I4(e);
      }
    }
    function I4(e) {
      for (; xe !== null; ) {
        var t = xe, a = t.sibling, l = t.return;
        if (TO(t), t === e) {
          xe = null;
          return;
        }
        if (a !== null) {
          a.return = l, xe = a;
          return;
        }
        xe = l;
      }
    }
    function q4(e, t) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          e.mode & Ut ? (Kx(), cl(ur, e, t), Wx(e)) : cl(ur, e, t);
          break;
        }
      }
    }
    function j4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          try {
            Yc(Pi | Ai, e);
          } catch (a) {
            mn(e, e.return, a);
          }
          break;
        }
        case $: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (a) {
            mn(e, e.return, a);
          }
          break;
        }
      }
    }
    function B4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          try {
            Yc(ur | Ai, e);
          } catch (t) {
            mn(e, e.return, t);
          }
          break;
        }
      }
    }
    function Q4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          try {
            cl(Pi | Ai, e, e.return);
          } catch (a) {
            mn(e, e.return, a);
          }
          break;
        }
        case $: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && D1(e, e.return, t);
          break;
        }
      }
    }
    function Y4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He:
          try {
            cl(ur | Ai, e, e.return);
          } catch (t) {
            mn(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var _S = Symbol.for;
      _S("selector.component"), _S("selector.has_pseudo_class"), _S("selector.role"), _S("selector.test_id"), _S("selector.text");
    }
    var G4 = [];
    function W4() {
      G4.forEach(function(e) {
        return e();
      });
    }
    var K4 = n.ReactCurrentActQueue;
    function X4(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), a = typeof jest < "u";
        return a && t !== !1;
      }
    }
    function MO() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && K4.current !== null && y("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var Z4 = Math.ceil, O1 = n.ReactCurrentDispatcher, A1 = n.ReactCurrentOwner, hr = n.ReactCurrentBatchConfig, hl = n.ReactCurrentActQueue, Ui = (
      /*             */
      0
    ), LO = (
      /*               */
      1
    ), pr = (
      /*                */
      2
    ), Ls = (
      /*                */
      4
    ), wu = 0, NS = 1, ah = 2, Jb = 3, US = 4, $O = 5, P1 = 6, kt = Ui, Jr = null, qn = null, zi = ee, ro = ee, _1 = zc(ee), Fi = wu, zS = null, eC = ee, FS = ee, tC = ee, VS = null, xa = null, N1 = 0, OO = 500, AO = 1 / 0, J4 = 500, Eu = null;
    function HS() {
      AO = ci() + J4;
    }
    function PO() {
      return AO;
    }
    var nC = !1, U1 = null, ev = null, sh = !1, Wc = null, IS = ee, z1 = [], F1 = null, eq = 50, qS = 0, V1 = null, H1 = !1, iC = !1, tq = 50, tv = 0, rC = null, jS = ln, aC = ee, _O = !1;
    function sC() {
      return Jr;
    }
    function ea() {
      return (kt & (pr | Ls)) !== Ui ? ci() : (jS !== ln || (jS = ci()), jS);
    }
    function Kc(e) {
      var t = e.mode;
      if ((t & dt) === _e)
        return je;
      if ((kt & pr) !== Ui && zi !== ee)
        return Rf(zi);
      var a = K3() !== W3;
      if (a) {
        if (hr.transition !== null) {
          var l = hr.transition;
          l._updatedFibers || (l._updatedFibers = /* @__PURE__ */ new Set()), l._updatedFibers.add(e);
        }
        return aC === Ot && (aC = Og()), aC;
      }
      var c = wa();
      if (c !== Ot)
        return c;
      var m = PH();
      return m;
    }
    function nq(e) {
      var t = e.mode;
      return (t & dt) === _e ? je : fE();
    }
    function Vi(e, t, a, l) {
      xq(), _O && y("useInsertionEffect must not schedule updates."), H1 && (iC = !0), Rc(e, a, l), (kt & pr) !== ee && e === Jr ? Mq(t) : (Lr && Lf(e, t, a), Lq(t), e === Jr && ((kt & pr) === Ui && (FS = it(FS, a)), Fi === US && Xc(e, zi)), Ra(e, l), a === je && kt === Ui && (t.mode & dt) === _e && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !hl.isBatchingLegacy && (HS(), _L()));
    }
    function iq(e, t, a) {
      var l = e.current;
      l.lanes = t, Rc(e, t, a), Ra(e, a);
    }
    function rq(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (kt & pr) !== Ui
      );
    }
    function Ra(e, t) {
      var a = e.callbackNode;
      um(e, t);
      var l = om(e, e === Jr ? zi : ee);
      if (l === ee) {
        a !== null && XO(a), e.callbackNode = null, e.callbackPriority = Ot;
        return;
      }
      var c = Il(l), m = e.callbackPriority;
      if (m === c && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(hl.current !== null && a !== G1)) {
        a == null && m !== je && y("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      a != null && XO(a);
      var T;
      if (c === je)
        e.tag === Fc ? (hl.isBatchingLegacy !== null && (hl.didScheduleLegacyUpdate = !0), O3(zO.bind(null, e))) : PL(zO.bind(null, e)), hl.current !== null ? hl.current.push(Vc) : NH(function() {
          (kt & (pr | Ls)) === Ui && Vc();
        }), T = null;
      else {
        var E;
        switch (SE(l)) {
          case ir:
            E = hf;
            break;
          case Ts:
            E = zl;
            break;
          case Sa:
            E = Ks;
            break;
          case Ta:
            E = Ko;
            break;
          default:
            E = Ks;
            break;
        }
        T = W1(E, NO.bind(null, e));
      }
      e.callbackPriority = c, e.callbackNode = T;
    }
    function NO(e, t) {
      if (EI(), jS = ln, aC = ee, (kt & (pr | Ls)) !== Ui)
        throw new Error("Should not already be working.");
      var a = e.callbackNode, l = Cu();
      if (l && e.callbackNode !== a)
        return null;
      var c = om(e, e === Jr ? zi : ee);
      if (c === ee)
        return null;
      var m = !dm(e, c) && !dE(e, c) && !t, T = m ? pq(e, c) : oC(e, c);
      if (T !== wu) {
        if (T === ah) {
          var E = cm(e);
          E !== ee && (c = E, T = I1(e, E));
        }
        if (T === NS) {
          var b = zS;
          throw lh(e, ee), Xc(e, c), Ra(e, ci()), b;
        }
        if (T === P1)
          Xc(e, c);
        else {
          var x = !dm(e, c), M = e.current.alternate;
          if (x && !sq(M)) {
            if (T = oC(e, c), T === ah) {
              var z = cm(e);
              z !== ee && (c = z, T = I1(e, z));
            }
            if (T === NS) {
              var N = zS;
              throw lh(e, ee), Xc(e, c), Ra(e, ci()), N;
            }
          }
          e.finishedWork = M, e.finishedLanes = c, aq(e, T, c);
        }
      }
      return Ra(e, ci()), e.callbackNode === a ? NO.bind(null, e) : null;
    }
    function I1(e, t) {
      var a = VS;
      if (pm(e)) {
        var l = lh(e, t);
        l.flags |= kr, k3(e.containerInfo);
      }
      var c = oC(e, t);
      if (c !== ah) {
        var m = xa;
        xa = a, m !== null && UO(m);
      }
      return c;
    }
    function UO(e) {
      xa === null ? xa = e : xa.push.apply(xa, e);
    }
    function aq(e, t, a) {
      switch (t) {
        case wu:
        case NS:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case ah: {
          oh(e, xa, Eu);
          break;
        }
        case Jb: {
          if (Xc(e, a), lu(a) && // do not delay if we're inside an act() scope
          !ZO()) {
            var l = N1 + OO - ci();
            if (l > 10) {
              var c = om(e, ee);
              if (c !== ee)
                break;
              var m = e.suspendedLanes;
              if (!ou(m, a)) {
                ea(), fm(e, m);
                break;
              }
              e.timeoutHandle = Fk(oh.bind(null, e, xa, Eu), l);
              break;
            }
          }
          oh(e, xa, Eu);
          break;
        }
        case US: {
          if (Xc(e, a), Lg(a))
            break;
          if (!ZO()) {
            var T = Ya(e, a), E = T, b = ci() - E, x = kq(b) - b;
            if (x > 10) {
              e.timeoutHandle = Fk(oh.bind(null, e, xa, Eu), x);
              break;
            }
          }
          oh(e, xa, Eu);
          break;
        }
        case $O: {
          oh(e, xa, Eu);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function sq(e) {
      for (var t = e; ; ) {
        if (t.flags & Ec) {
          var a = t.updateQueue;
          if (a !== null) {
            var l = a.stores;
            if (l !== null)
              for (var c = 0; c < l.length; c++) {
                var m = l[c], T = m.getSnapshot, E = m.value;
                try {
                  if (!ge(T(), E))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var b = t.child;
        if (t.subtreeFlags & Ec && b !== null) {
          b.return = t, t = b;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function Xc(e, t) {
      t = Df(t, tC), t = Df(t, FS), mE(e, t);
    }
    function zO(e) {
      if (bI(), (kt & (pr | Ls)) !== Ui)
        throw new Error("Should not already be working.");
      Cu();
      var t = om(e, ee);
      if (!$r(t, je))
        return Ra(e, ci()), null;
      var a = oC(e, t);
      if (e.tag !== Fc && a === ah) {
        var l = cm(e);
        l !== ee && (t = l, a = I1(e, l));
      }
      if (a === NS) {
        var c = zS;
        throw lh(e, ee), Xc(e, t), Ra(e, ci()), c;
      }
      if (a === P1)
        throw new Error("Root did not complete. This is a bug in React.");
      var m = e.current.alternate;
      return e.finishedWork = m, e.finishedLanes = t, oh(e, xa, Eu), Ra(e, ci()), null;
    }
    function lq(e, t) {
      t !== ee && (hm(e, it(t, je)), Ra(e, ci()), (kt & (pr | Ls)) === Ui && (HS(), Vc()));
    }
    function q1(e, t) {
      var a = kt;
      kt |= LO;
      try {
        return e(t);
      } finally {
        kt = a, kt === Ui && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !hl.isBatchingLegacy && (HS(), _L());
      }
    }
    function oq(e, t, a, l, c) {
      var m = wa(), T = hr.transition;
      try {
        return hr.transition = null, Jn(ir), e(t, a, l, c);
      } finally {
        Jn(m), hr.transition = T, kt === Ui && HS();
      }
    }
    function bu(e) {
      Wc !== null && Wc.tag === Fc && (kt & (pr | Ls)) === Ui && Cu();
      var t = kt;
      kt |= LO;
      var a = hr.transition, l = wa();
      try {
        return hr.transition = null, Jn(ir), e ? e() : void 0;
      } finally {
        Jn(l), hr.transition = a, kt = t, (kt & (pr | Ls)) === Ui && Vc();
      }
    }
    function FO() {
      return (kt & (pr | Ls)) !== Ui;
    }
    function lC(e, t) {
      Nr(_1, ro, e), ro = it(ro, t);
    }
    function j1(e) {
      ro = _1.current, _r(_1, e);
    }
    function lh(e, t) {
      e.finishedWork = null, e.finishedLanes = ee;
      var a = e.timeoutHandle;
      if (a !== Vk && (e.timeoutHandle = Vk, _H(a)), qn !== null)
        for (var l = qn.return; l !== null; ) {
          var c = l.alternate;
          pO(c, l), l = l.return;
        }
      Jr = e;
      var m = uh(e.current, null);
      return qn = m, zi = ro = t, Fi = wu, zS = null, eC = ee, FS = ee, tC = ee, VS = null, xa = null, iI(), al.discardPendingWarnings(), m;
    }
    function VO(e, t) {
      do {
        var a = qn;
        try {
          if (yb(), c$(), On(), A1.current = null, a === null || a.return === null) {
            Fi = NS, zS = t, qn = null;
            return;
          }
          if (Bn && a.mode & Ut && Qb(a, !0), Ii)
            if (Gr(), t !== null && typeof t == "object" && typeof t.then == "function") {
              var l = t;
              Ss(a, l, zi);
            } else
              mf(a, t, zi);
          OI(e, a.return, a, t, zi), jO(a);
        } catch (c) {
          t = c, qn === a && a !== null ? (a = a.return, qn = a) : a = qn;
          continue;
        }
        return;
      } while (!0);
    }
    function HO() {
      var e = O1.current;
      return O1.current = Hb, e === null ? Hb : e;
    }
    function IO(e) {
      O1.current = e;
    }
    function uq() {
      N1 = ci();
    }
    function BS(e) {
      eC = it(e, eC);
    }
    function cq() {
      Fi === wu && (Fi = Jb);
    }
    function B1() {
      (Fi === wu || Fi === Jb || Fi === ah) && (Fi = US), Jr !== null && (xf(eC) || xf(FS)) && Xc(Jr, zi);
    }
    function dq(e) {
      Fi !== US && (Fi = ah), VS === null ? VS = [e] : VS.push(e);
    }
    function fq() {
      return Fi === wu;
    }
    function oC(e, t) {
      var a = kt;
      kt |= pr;
      var l = HO();
      if (Jr !== e || zi !== t) {
        if (Lr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (QS(e, zi), c.clear()), vE(e, t);
        }
        Eu = Ng(), lh(e, t);
      }
      eu(t);
      do
        try {
          hq();
          break;
        } catch (m) {
          VO(e, m);
        }
      while (!0);
      if (yb(), kt = a, IO(l), qn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return jp(), Jr = null, zi = ee, Fi;
    }
    function hq() {
      for (; qn !== null; )
        qO(qn);
    }
    function pq(e, t) {
      var a = kt;
      kt |= pr;
      var l = HO();
      if (Jr !== e || zi !== t) {
        if (Lr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (QS(e, zi), c.clear()), vE(e, t);
        }
        Eu = Ng(), HS(), lh(e, t);
      }
      eu(t);
      do
        try {
          mq();
          break;
        } catch (m) {
          VO(e, m);
        }
      while (!0);
      return yb(), IO(l), kt = a, qn !== null ? (lE(), wu) : (jp(), Jr = null, zi = ee, Fi);
    }
    function mq() {
      for (; qn !== null && !mg(); )
        qO(qn);
    }
    function qO(e) {
      var t = e.alternate;
      pn(e);
      var a;
      (e.mode & Ut) !== _e ? (Gx(e), a = Q1(t, e, ro), Qb(e, !0)) : a = Q1(t, e, ro), On(), e.memoizedProps = e.pendingProps, a === null ? jO(e) : qn = a, A1.current = null;
    }
    function jO(e) {
      var t = e;
      do {
        var a = t.alternate, l = t.return;
        if ((t.flags & ff) === Pe) {
          pn(t);
          var c = void 0;
          if ((t.mode & Ut) === _e ? c = hO(a, t, ro) : (Gx(t), c = hO(a, t, ro), Qb(t, !1)), On(), c !== null) {
            qn = c;
            return;
          }
        } else {
          var m = c4(a, t);
          if (m !== null) {
            m.flags &= tE, qn = m;
            return;
          }
          if ((t.mode & Ut) !== _e) {
            Qb(t, !1);
            for (var T = t.actualDuration, E = t.child; E !== null; )
              T += E.actualDuration, E = E.sibling;
            t.actualDuration = T;
          }
          if (l !== null)
            l.flags |= ff, l.subtreeFlags = Pe, l.deletions = null;
          else {
            Fi = P1, qn = null;
            return;
          }
        }
        var b = t.sibling;
        if (b !== null) {
          qn = b;
          return;
        }
        t = l, qn = t;
      } while (t !== null);
      Fi === wu && (Fi = $O);
    }
    function oh(e, t, a) {
      var l = wa(), c = hr.transition;
      try {
        hr.transition = null, Jn(ir), vq(e, t, a, l);
      } finally {
        hr.transition = c, Jn(l);
      }
      return null;
    }
    function vq(e, t, a, l) {
      do
        Cu();
      while (Wc !== null);
      if (Rq(), (kt & (pr | Ls)) !== Ui)
        throw new Error("Should not already be working.");
      var c = e.finishedWork, m = e.finishedLanes;
      if (wg(m), c === null)
        return Eg(), null;
      if (m === ee && y("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = ee, c === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Ot;
      var T = it(c.lanes, c.childLanes);
      Pg(e, T), e === Jr && (Jr = null, qn = null, zi = ee), ((c.subtreeFlags & Ws) !== Pe || (c.flags & Ws) !== Pe) && (sh || (sh = !0, F1 = a, W1(Ks, function() {
        return Cu(), null;
      })));
      var E = (c.subtreeFlags & (_l | Nl | Ul | Ws)) !== Pe, b = (c.flags & (_l | Nl | Ul | Ws)) !== Pe;
      if (E || b) {
        var x = hr.transition;
        hr.transition = null;
        var M = wa();
        Jn(ir);
        var z = kt;
        kt |= Ls, A1.current = null, m4(e, c), _$(), M4(e, c, m), DH(e.containerInfo), e.current = c, vf(m), L4(c, e, m), yf(), vg(), kt = z, Jn(M), hr.transition = x;
      } else
        e.current = c, _$();
      var N = sh;
      if (sh ? (sh = !1, Wc = e, IS = m) : (tv = 0, rC = null), T = e.pendingLanes, T === ee && (ev = null), N || GO(e.current, !1), gg(c.stateNode, l), Lr && e.memoizedUpdaters.clear(), W4(), Ra(e, ci()), t !== null)
        for (var q = e.onRecoverableError, Q = 0; Q < t.length; Q++) {
          var Y = t[Q], ve = Y.stack, Ue = Y.digest;
          q(Y.value, {
            componentStack: ve,
            digest: Ue
          });
        }
      if (nC) {
        nC = !1;
        var Me = U1;
        throw U1 = null, Me;
      }
      return $r(IS, je) && e.tag !== Fc && Cu(), T = e.pendingLanes, $r(T, je) ? (wI(), e === V1 ? qS++ : (qS = 0, V1 = e)) : qS = 0, Vc(), Eg(), null;
    }
    function Cu() {
      if (Wc !== null) {
        var e = SE(IS), t = Of(Sa, e), a = hr.transition, l = wa();
        try {
          return hr.transition = null, Jn(t), gq();
        } finally {
          Jn(l), hr.transition = a;
        }
      }
      return !1;
    }
    function yq(e) {
      z1.push(e), sh || (sh = !0, W1(Ks, function() {
        return Cu(), null;
      }));
    }
    function gq() {
      if (Wc === null)
        return !1;
      var e = F1;
      F1 = null;
      var t = Wc, a = IS;
      if (Wc = null, IS = ee, (kt & (pr | Ls)) !== Ui)
        throw new Error("Cannot flush passive effects while already rendering.");
      H1 = !0, iC = !1, Jo(a);
      var l = kt;
      kt |= Ls, U4(t.current), A4(t, t.current, a, e);
      {
        var c = z1;
        z1 = [];
        for (var m = 0; m < c.length; m++) {
          var T = c[m];
          S4(t, T);
        }
      }
      kg(), GO(t.current, !0), kt = l, Vc(), iC ? t === rC ? tv++ : (tv = 0, rC = t) : tv = 0, H1 = !1, iC = !1, Sg(t);
      {
        var E = t.current.stateNode;
        E.effectDuration = 0, E.passiveEffectDuration = 0;
      }
      return !0;
    }
    function BO(e) {
      return ev !== null && ev.has(e);
    }
    function Sq(e) {
      ev === null ? ev = /* @__PURE__ */ new Set([e]) : ev.add(e);
    }
    function Tq(e) {
      nC || (nC = !0, U1 = e);
    }
    var wq = Tq;
    function QO(e, t, a) {
      var l = ih(a, t), c = q$(e, l, je), m = Ic(e, c, je), T = ea();
      m !== null && (Rc(m, je, T), Ra(m, T));
    }
    function mn(e, t, a) {
      if (f4(a), YS(!1), e.tag === A) {
        QO(e, e, a);
        return;
      }
      var l = null;
      for (l = t; l !== null; ) {
        if (l.tag === A) {
          QO(l, e, a);
          return;
        } else if (l.tag === $) {
          var c = l.type, m = l.stateNode;
          if (typeof c.getDerivedStateFromError == "function" || typeof m.componentDidCatch == "function" && !BO(m)) {
            var T = ih(a, e), E = f1(l, T, je), b = Ic(l, E, je), x = ea();
            b !== null && (Rc(b, je, x), Ra(b, x));
            return;
          }
        }
        l = l.return;
      }
      y(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, a);
    }
    function Eq(e, t, a) {
      var l = e.pingCache;
      l !== null && l.delete(t);
      var c = ea();
      fm(e, a), $q(e), Jr === e && ou(zi, a) && (Fi === US || Fi === Jb && lu(zi) && ci() - N1 < OO ? lh(e, ee) : tC = it(tC, a)), Ra(e, c);
    }
    function YO(e, t) {
      t === Ot && (t = nq(e));
      var a = ea(), l = Ca(e, t);
      l !== null && (Rc(l, t, a), Ra(l, a));
    }
    function bq(e) {
      var t = e.memoizedState, a = Ot;
      t !== null && (a = t.retryLane), YO(e, a);
    }
    function Cq(e, t) {
      var a = Ot, l;
      switch (e.tag) {
        case Ye:
          l = e.stateNode;
          var c = e.memoizedState;
          c !== null && (a = c.retryLane);
          break;
        case Kt:
          l = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      l !== null && l.delete(t), YO(e, a);
    }
    function kq(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : Z4(e / 1960) * 1960;
    }
    function xq() {
      if (qS > eq)
        throw qS = 0, V1 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      tv > tq && (tv = 0, rC = null, y("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function Rq() {
      al.flushLegacyContextWarning(), al.flushPendingUnsafeLifecycleWarnings();
    }
    function GO(e, t) {
      pn(e), uC(e, Pl, Q4), t && uC(e, vs, Y4), uC(e, Pl, j4), t && uC(e, vs, B4), On();
    }
    function uC(e, t, a) {
      for (var l = e, c = null; l !== null; ) {
        var m = l.subtreeFlags & t;
        l !== c && l.child !== null && m !== Pe ? l = l.child : ((l.flags & t) !== Pe && a(l), l.sibling !== null ? l = l.sibling : l = c = l.return);
      }
    }
    var cC = null;
    function WO(e) {
      {
        if ((kt & pr) !== Ui || !(e.mode & dt))
          return;
        var t = e.tag;
        if (t !== _ && t !== A && t !== $ && t !== D && t !== Ve && t !== wt && t !== He)
          return;
        var a = nt(e) || "ReactComponent";
        if (cC !== null) {
          if (cC.has(a))
            return;
          cC.add(a);
        } else
          cC = /* @__PURE__ */ new Set([a]);
        var l = nr;
        try {
          pn(e), y("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          l ? pn(e) : On();
        }
      }
    }
    var Q1;
    {
      var Dq = null;
      Q1 = function(e, t, a) {
        var l = iA(Dq, t);
        try {
          return oO(e, t, a);
        } catch (m) {
          if (V3() || m !== null && typeof m == "object" && typeof m.then == "function")
            throw m;
          if (yb(), c$(), pO(e, t), iA(t, l), t.mode & Ut && Gx(t), Al(null, oO, null, e, t, a), Ys()) {
            var c = df();
            typeof c == "object" && c !== null && c._suppressLogging && typeof m == "object" && m !== null && !m._suppressLogging && (m._suppressLogging = !0);
          }
          throw m;
        }
      };
    }
    var KO = !1, Y1;
    Y1 = /* @__PURE__ */ new Set();
    function Mq(e) {
      if (Rl && !gI())
        switch (e.tag) {
          case D:
          case Ve:
          case He: {
            var t = qn && nt(qn) || "Unknown", a = t;
            if (!Y1.has(a)) {
              Y1.add(a);
              var l = nt(e) || "Unknown";
              y("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", l, t, t);
            }
            break;
          }
          case $: {
            KO || (y("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), KO = !0);
            break;
          }
        }
    }
    function QS(e, t) {
      if (Lr) {
        var a = e.memoizedUpdaters;
        a.forEach(function(l) {
          Lf(e, l, t);
        });
      }
    }
    var G1 = {};
    function W1(e, t) {
      {
        var a = hl.current;
        return a !== null ? (a.push(t), G1) : pg(e, t);
      }
    }
    function XO(e) {
      if (e !== G1)
        return iE(e);
    }
    function ZO() {
      return hl.current !== null;
    }
    function Lq(e) {
      {
        if (e.mode & dt) {
          if (!MO())
            return;
        } else if (!X4() || kt !== Ui || e.tag !== D && e.tag !== Ve && e.tag !== He)
          return;
        if (hl.current === null) {
          var t = nr;
          try {
            pn(e), y(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, nt(e));
          } finally {
            t ? pn(e) : On();
          }
        }
      }
    }
    function $q(e) {
      e.tag !== Fc && MO() && hl.current === null && y(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function YS(e) {
      _O = e;
    }
    var $s = null, nv = null, Oq = function(e) {
      $s = e;
    };
    function iv(e) {
      {
        if ($s === null)
          return e;
        var t = $s(e);
        return t === void 0 ? e : t.current;
      }
    }
    function K1(e) {
      return iv(e);
    }
    function X1(e) {
      {
        if ($s === null)
          return e;
        var t = $s(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var a = iv(e.render);
            if (e.render !== a) {
              var l = {
                $$typeof: oc,
                render: a
              };
              return e.displayName !== void 0 && (l.displayName = e.displayName), l;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function JO(e, t) {
      {
        if ($s === null)
          return !1;
        var a = e.elementType, l = t.type, c = !1, m = typeof l == "object" && l !== null ? l.$$typeof : null;
        switch (e.tag) {
          case $: {
            typeof l == "function" && (c = !0);
            break;
          }
          case D: {
            (typeof l == "function" || m === qi) && (c = !0);
            break;
          }
          case Ve: {
            (m === oc || m === qi) && (c = !0);
            break;
          }
          case wt:
          case He: {
            (m === Va || m === qi) && (c = !0);
            break;
          }
          default:
            return !1;
        }
        if (c) {
          var T = $s(a);
          if (T !== void 0 && T === $s(l))
            return !0;
        }
        return !1;
      }
    }
    function eA(e) {
      {
        if ($s === null || typeof WeakSet != "function")
          return;
        nv === null && (nv = /* @__PURE__ */ new WeakSet()), nv.add(e);
      }
    }
    var Aq = function(e, t) {
      {
        if ($s === null)
          return;
        var a = t.staleFamilies, l = t.updatedFamilies;
        Cu(), bu(function() {
          Z1(e.current, l, a);
        });
      }
    }, Pq = function(e, t) {
      {
        if (e.context !== Ka)
          return;
        Cu(), bu(function() {
          GS(t, e, null, null);
        });
      }
    };
    function Z1(e, t, a) {
      {
        var l = e.alternate, c = e.child, m = e.sibling, T = e.tag, E = e.type, b = null;
        switch (T) {
          case D:
          case He:
          case $:
            b = E;
            break;
          case Ve:
            b = E.render;
            break;
        }
        if ($s === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var x = !1, M = !1;
        if (b !== null) {
          var z = $s(b);
          z !== void 0 && (a.has(z) ? M = !0 : t.has(z) && (T === $ ? M = !0 : x = !0));
        }
        if (nv !== null && (nv.has(e) || l !== null && nv.has(l)) && (M = !0), M && (e._debugNeedsRemount = !0), M || x) {
          var N = Ca(e, je);
          N !== null && Vi(N, e, je, ln);
        }
        c !== null && !M && Z1(c, t, a), m !== null && Z1(m, t, a);
      }
    }
    var _q = function(e, t) {
      {
        var a = /* @__PURE__ */ new Set(), l = new Set(t.map(function(c) {
          return c.current;
        }));
        return J1(e.current, l, a), a;
      }
    };
    function J1(e, t, a) {
      {
        var l = e.child, c = e.sibling, m = e.tag, T = e.type, E = null;
        switch (m) {
          case D:
          case He:
          case $:
            E = T;
            break;
          case Ve:
            E = T.render;
            break;
        }
        var b = !1;
        E !== null && t.has(E) && (b = !0), b ? Nq(e, a) : l !== null && J1(l, t, a), c !== null && J1(c, t, a);
      }
    }
    function Nq(e, t) {
      {
        var a = Uq(e, t);
        if (a)
          return;
        for (var l = e; ; ) {
          switch (l.tag) {
            case W:
              t.add(l.stateNode);
              return;
            case B:
              t.add(l.stateNode.containerInfo);
              return;
            case A:
              t.add(l.stateNode.containerInfo);
              return;
          }
          if (l.return === null)
            throw new Error("Expected to reach root first.");
          l = l.return;
        }
      }
    }
    function Uq(e, t) {
      for (var a = e, l = !1; ; ) {
        if (a.tag === W)
          l = !0, t.add(a.stateNode);
        else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === e)
          return l;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e)
            return l;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !1;
    }
    var eR;
    {
      eR = !1;
      try {
        var tA = Object.preventExtensions({});
      } catch {
        eR = !0;
      }
    }
    function zq(e, t, a, l) {
      this.tag = e, this.key = a, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = l, this.flags = Pe, this.subtreeFlags = Pe, this.deletions = null, this.lanes = ee, this.childLanes = ee, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !eR && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Xa = function(e, t, a, l) {
      return new zq(e, t, a, l);
    };
    function tR(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function Fq(e) {
      return typeof e == "function" && !tR(e) && e.defaultProps === void 0;
    }
    function Vq(e) {
      if (typeof e == "function")
        return tR(e) ? $ : D;
      if (e != null) {
        var t = e.$$typeof;
        if (t === oc)
          return Ve;
        if (t === Va)
          return wt;
      }
      return _;
    }
    function uh(e, t) {
      var a = e.alternate;
      a === null ? (a = Xa(e.tag, t, e.key, e.mode), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugSource = e._debugSource, a._debugOwner = e._debugOwner, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = Pe, a.subtreeFlags = Pe, a.deletions = null, a.actualDuration = 0, a.actualStartTime = -1), a.flags = e.flags & Kn, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue;
      var l = e.dependencies;
      switch (a.dependencies = l === null ? null : {
        lanes: l.lanes,
        firstContext: l.firstContext
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case _:
        case D:
        case He:
          a.type = iv(e.type);
          break;
        case $:
          a.type = K1(e.type);
          break;
        case Ve:
          a.type = X1(e.type);
          break;
      }
      return a;
    }
    function Hq(e, t) {
      e.flags &= Kn | Un;
      var a = e.alternate;
      if (a === null)
        e.childLanes = ee, e.lanes = t, e.child = null, e.subtreeFlags = Pe, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = Pe, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type;
        var l = a.dependencies;
        e.dependencies = l === null ? null : {
          lanes: l.lanes,
          firstContext: l.firstContext
        }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration;
      }
      return e;
    }
    function Iq(e, t, a) {
      var l;
      return e === lb ? (l = dt, t === !0 && (l |= Jt, l |= zt)) : l = _e, Lr && (l |= Ut), Xa(A, null, null, l);
    }
    function nR(e, t, a, l, c, m) {
      var T = _, E = e;
      if (typeof e == "function")
        tR(e) ? (T = $, E = K1(E)) : E = iv(E);
      else if (typeof e == "string")
        T = W;
      else
        e: switch (e) {
          case ac:
            return Zc(a.children, c, m, t);
          case Po:
            T = Re, c |= Jt, (c & dt) !== _e && (c |= zt);
            break;
          case sc:
            return qq(a, c, m, t);
          case up:
            return jq(a, c, m, t);
          case cp:
            return Bq(a, c, m, t);
          case Ay:
            return nA(a, c, m, t);
          case yw:
          // eslint-disable-next-line no-fallthrough
          case vw:
          // eslint-disable-next-line no-fallthrough
          case gw:
          // eslint-disable-next-line no-fallthrough
          case Sw:
          // eslint-disable-next-line no-fallthrough
          case F0:
          // eslint-disable-next-line no-fallthrough
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case lc:
                  T = $t;
                  break e;
                case Bd:
                  T = Lt;
                  break e;
                case oc:
                  T = Ve, E = X1(E);
                  break e;
                case Va:
                  T = wt;
                  break e;
                case qi:
                  T = de, E = null;
                  break e;
              }
            var b = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var x = l ? nt(l) : null;
              x && (b += `

Check the render method of \`` + x + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + b));
          }
        }
      var M = Xa(T, a, t, c);
      return M.elementType = e, M.type = E, M.lanes = m, M._debugOwner = l, M;
    }
    function iR(e, t, a) {
      var l = null;
      l = e._owner;
      var c = e.type, m = e.key, T = e.props, E = nR(c, m, T, l, t, a);
      return E._debugSource = e._source, E._debugOwner = e._owner, E;
    }
    function Zc(e, t, a, l) {
      var c = Xa(ce, e, l, t);
      return c.lanes = a, c;
    }
    function qq(e, t, a, l) {
      typeof e.id != "string" && y('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var c = Xa(ct, e, l, t | Ut);
      return c.elementType = sc, c.lanes = a, c.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, c;
    }
    function jq(e, t, a, l) {
      var c = Xa(Ye, e, l, t);
      return c.elementType = up, c.lanes = a, c;
    }
    function Bq(e, t, a, l) {
      var c = Xa(Kt, e, l, t);
      return c.elementType = cp, c.lanes = a, c;
    }
    function nA(e, t, a, l) {
      var c = Xa(Ae, e, l, t);
      c.elementType = Ay, c.lanes = a;
      var m = {
        isHidden: !1
      };
      return c.stateNode = m, c;
    }
    function rR(e, t, a) {
      var l = Xa(ne, e, null, t);
      return l.lanes = a, l;
    }
    function Qq() {
      var e = Xa(W, null, null, _e);
      return e.elementType = "DELETED", e;
    }
    function Yq(e) {
      var t = Xa(ft, null, null, _e);
      return t.stateNode = e, t;
    }
    function aR(e, t, a) {
      var l = e.children !== null ? e.children : [], c = Xa(B, l, e.key, t);
      return c.lanes = a, c.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, c;
    }
    function iA(e, t) {
      return e === null && (e = Xa(_, null, null, _e)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function Gq(e, t, a, l, c) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Vk, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ot, this.eventTimes = Mf(ee), this.expirationTimes = Mf(ln), this.pendingLanes = ee, this.suspendedLanes = ee, this.pingedLanes = ee, this.expiredLanes = ee, this.mutableReadLanes = ee, this.finishedLanes = ee, this.entangledLanes = ee, this.entanglements = Mf(ee), this.identifierPrefix = l, this.onRecoverableError = c, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var m = this.pendingUpdatersLaneMap = [], T = 0; T < tu; T++)
          m.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case lb:
          this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
          break;
        case Fc:
          this._debugRootType = a ? "hydrate()" : "render()";
          break;
      }
    }
    function rA(e, t, a, l, c, m, T, E, b, x) {
      var M = new Gq(e, t, a, E, b), z = Iq(t, m);
      M.current = z, z.stateNode = M;
      {
        var N = {
          element: l,
          isDehydrated: a,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        z.memoizedState = N;
      }
      return gx(z), M;
    }
    var sR = "18.3.1";
    function Wq(e, t, a) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return nc(l), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Fa,
        key: l == null ? null : "" + l,
        children: e,
        containerInfo: t,
        implementation: a
      };
    }
    var lR, oR;
    lR = !1, oR = {};
    function aA(e) {
      if (!e)
        return Ka;
      var t = wc(e), a = $3(t);
      if (t.tag === $) {
        var l = t.type;
        if (Xl(l))
          return OL(t, l, a);
      }
      return a;
    }
    function Kq(e, t) {
      {
        var a = wc(e);
        if (a === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var l = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + l);
        }
        var c = Dr(a);
        if (c === null)
          return null;
        if (c.mode & Jt) {
          var m = nt(a) || "Component";
          if (!oR[m]) {
            oR[m] = !0;
            var T = nr;
            try {
              pn(c), a.mode & Jt ? y("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, m) : y("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, m);
            } finally {
              T ? pn(T) : On();
            }
          }
        }
        return c.stateNode;
      }
    }
    function sA(e, t, a, l, c, m, T, E) {
      var b = !1, x = null;
      return rA(e, t, b, x, a, l, c, m, T);
    }
    function lA(e, t, a, l, c, m, T, E, b, x) {
      var M = !0, z = rA(a, l, M, e, c, m, T, E, b);
      z.context = aA(null);
      var N = z.current, q = ea(), Q = Kc(N), Y = Su(q, Q);
      return Y.callback = t ?? null, Ic(N, Y, Q), iq(z, Q, q), z;
    }
    function GS(e, t, a, l) {
      yg(t, e);
      var c = t.current, m = ea(), T = Kc(c);
      Cn(T);
      var E = aA(a);
      t.context === null ? t.context = E : t.pendingContext = E, Rl && nr !== null && !lR && (lR = !0, y(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, nt(nr) || "Unknown"));
      var b = Su(m, T);
      b.payload = {
        element: e
      }, l = l === void 0 ? null : l, l !== null && (typeof l != "function" && y("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l), b.callback = l);
      var x = Ic(c, b, T);
      return x !== null && (Vi(x, c, T, m), Eb(x, c, T)), T;
    }
    function dC(e) {
      var t = e.current;
      if (!t.child)
        return null;
      switch (t.child.tag) {
        case W:
          return t.child.stateNode;
        default:
          return t.child.stateNode;
      }
    }
    function Xq(e) {
      switch (e.tag) {
        case A: {
          var t = e.stateNode;
          if (pm(t)) {
            var a = uE(t);
            lq(t, a);
          }
          break;
        }
        case Ye: {
          bu(function() {
            var c = Ca(e, je);
            if (c !== null) {
              var m = ea();
              Vi(c, e, je, m);
            }
          });
          var l = je;
          uR(e, l);
          break;
        }
      }
    }
    function oA(e, t) {
      var a = e.memoizedState;
      a !== null && a.dehydrated !== null && (a.retryLane = pE(a.retryLane, t));
    }
    function uR(e, t) {
      oA(e, t);
      var a = e.alternate;
      a && oA(a, t);
    }
    function Zq(e) {
      if (e.tag === Ye) {
        var t = bf, a = Ca(e, t);
        if (a !== null) {
          var l = ea();
          Vi(a, e, t, l);
        }
        uR(e, t);
      }
    }
    function Jq(e) {
      if (e.tag === Ye) {
        var t = Kc(e), a = Ca(e, t);
        if (a !== null) {
          var l = ea();
          Vi(a, e, t, l);
        }
        uR(e, t);
      }
    }
    function uA(e) {
      var t = Tn(e);
      return t === null ? null : t.stateNode;
    }
    var cA = function(e) {
      return null;
    };
    function ej(e) {
      return cA(e);
    }
    var dA = function(e) {
      return !1;
    };
    function tj(e) {
      return dA(e);
    }
    var fA = null, hA = null, pA = null, mA = null, vA = null, yA = null, gA = null, SA = null, TA = null;
    {
      var wA = function(e, t, a) {
        var l = t[a], c = Di(e) ? e.slice() : St({}, e);
        return a + 1 === t.length ? (Di(c) ? c.splice(l, 1) : delete c[l], c) : (c[l] = wA(e[l], t, a + 1), c);
      }, EA = function(e, t) {
        return wA(e, t, 0);
      }, bA = function(e, t, a, l) {
        var c = t[l], m = Di(e) ? e.slice() : St({}, e);
        if (l + 1 === t.length) {
          var T = a[l];
          m[T] = m[c], Di(m) ? m.splice(c, 1) : delete m[c];
        } else
          m[c] = bA(
            // $FlowFixMe number or string is fine here
            e[c],
            t,
            a,
            l + 1
          );
        return m;
      }, CA = function(e, t, a) {
        if (t.length !== a.length) {
          v("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var l = 0; l < a.length - 1; l++)
            if (t[l] !== a[l]) {
              v("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return bA(e, t, a, 0);
      }, kA = function(e, t, a, l) {
        if (a >= t.length)
          return l;
        var c = t[a], m = Di(e) ? e.slice() : St({}, e);
        return m[c] = kA(e[c], t, a + 1, l), m;
      }, xA = function(e, t, a) {
        return kA(e, t, 0, a);
      }, cR = function(e, t) {
        for (var a = e.memoizedState; a !== null && t > 0; )
          a = a.next, t--;
        return a;
      };
      fA = function(e, t, a, l) {
        var c = cR(e, t);
        if (c !== null) {
          var m = xA(c.memoizedState, a, l);
          c.memoizedState = m, c.baseState = m, e.memoizedProps = St({}, e.memoizedProps);
          var T = Ca(e, je);
          T !== null && Vi(T, e, je, ln);
        }
      }, hA = function(e, t, a) {
        var l = cR(e, t);
        if (l !== null) {
          var c = EA(l.memoizedState, a);
          l.memoizedState = c, l.baseState = c, e.memoizedProps = St({}, e.memoizedProps);
          var m = Ca(e, je);
          m !== null && Vi(m, e, je, ln);
        }
      }, pA = function(e, t, a, l) {
        var c = cR(e, t);
        if (c !== null) {
          var m = CA(c.memoizedState, a, l);
          c.memoizedState = m, c.baseState = m, e.memoizedProps = St({}, e.memoizedProps);
          var T = Ca(e, je);
          T !== null && Vi(T, e, je, ln);
        }
      }, mA = function(e, t, a) {
        e.pendingProps = xA(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var l = Ca(e, je);
        l !== null && Vi(l, e, je, ln);
      }, vA = function(e, t) {
        e.pendingProps = EA(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var a = Ca(e, je);
        a !== null && Vi(a, e, je, ln);
      }, yA = function(e, t, a) {
        e.pendingProps = CA(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var l = Ca(e, je);
        l !== null && Vi(l, e, je, ln);
      }, gA = function(e) {
        var t = Ca(e, je);
        t !== null && Vi(t, e, je, ln);
      }, SA = function(e) {
        cA = e;
      }, TA = function(e) {
        dA = e;
      };
    }
    function nj(e) {
      var t = Dr(e);
      return t === null ? null : t.stateNode;
    }
    function ij(e) {
      return null;
    }
    function rj() {
      return nr;
    }
    function aj(e) {
      var t = e.findFiberByHostInstance, a = n.ReactCurrentDispatcher;
      return Cc({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: fA,
        overrideHookStateDeletePath: hA,
        overrideHookStateRenamePath: pA,
        overrideProps: mA,
        overridePropsDeletePath: vA,
        overridePropsRenamePath: yA,
        setErrorHandler: SA,
        setSuspenseHandler: TA,
        scheduleUpdate: gA,
        currentDispatcherRef: a,
        findHostInstanceByFiber: nj,
        findFiberByHostInstance: t || ij,
        // React Refresh
        findHostInstancesForRefresh: _q,
        scheduleRefresh: Aq,
        scheduleRoot: Pq,
        setRefreshHandler: Oq,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: rj,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: sR
      });
    }
    var RA = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function dR(e) {
      this._internalRoot = e;
    }
    fC.prototype.render = dR.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? y("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : hC(arguments[1]) ? y("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && y("You passed a second argument to root.render(...) but it only accepts one argument.");
        var a = t.containerInfo;
        if (a.nodeType !== Gn) {
          var l = uA(t.current);
          l && l.parentNode !== a && y("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      GS(e, t, null, null);
    }, fC.prototype.unmount = dR.prototype.unmount = function() {
      typeof arguments[0] == "function" && y("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        FO() && y("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), bu(function() {
          GS(null, e, null, null);
        }), RL(t);
      }
    };
    function sj(e, t) {
      if (!hC(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      DA(e);
      var a = !1, l = !1, c = "", m = RA;
      t != null && (t.hydrate ? v("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === xl && y(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (c = t.identifierPrefix), t.onRecoverableError !== void 0 && (m = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var T = sA(e, lb, null, a, l, c, m);
      eb(T.current, e);
      var E = e.nodeType === Gn ? e.parentNode : e;
      return eS(E), new dR(T);
    }
    function fC(e) {
      this._internalRoot = e;
    }
    function lj(e) {
      e && CE(e);
    }
    fC.prototype.unstable_scheduleHydration = lj;
    function oj(e, t, a) {
      if (!hC(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      DA(e), t === void 0 && y("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var l = a ?? null, c = a != null && a.hydratedSources || null, m = !1, T = !1, E = "", b = RA;
      a != null && (a.unstable_strictMode === !0 && (m = !0), a.identifierPrefix !== void 0 && (E = a.identifierPrefix), a.onRecoverableError !== void 0 && (b = a.onRecoverableError));
      var x = lA(t, null, e, lb, l, m, T, E, b);
      if (eb(x.current, e), eS(e), c)
        for (var M = 0; M < c.length; M++) {
          var z = c[M];
          fI(x, z);
        }
      return new fC(x);
    }
    function hC(e) {
      return !!(e && (e.nodeType === Cr || e.nodeType === Qs || e.nodeType === ng));
    }
    function WS(e) {
      return !!(e && (e.nodeType === Cr || e.nodeType === Qs || e.nodeType === ng || e.nodeType === Gn && e.nodeValue === " react-mount-point-unstable "));
    }
    function DA(e) {
      e.nodeType === Cr && e.tagName && e.tagName.toUpperCase() === "BODY" && y("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), dS(e) && (e._reactRootContainer ? y("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : y("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var uj = n.ReactCurrentOwner, MA;
    MA = function(e) {
      if (e._reactRootContainer && e.nodeType !== Gn) {
        var t = uA(e._reactRootContainer.current);
        t && t.parentNode !== e && y("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var a = !!e._reactRootContainer, l = fR(e), c = !!(l && Uc(l));
      c && !a && y("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === Cr && e.tagName && e.tagName.toUpperCase() === "BODY" && y("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function fR(e) {
      return e ? e.nodeType === Qs ? e.documentElement : e.firstChild : null;
    }
    function LA() {
    }
    function cj(e, t, a, l, c) {
      if (c) {
        if (typeof l == "function") {
          var m = l;
          l = function() {
            var N = dC(T);
            m.call(N);
          };
        }
        var T = lA(
          t,
          l,
          e,
          Fc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          LA
        );
        e._reactRootContainer = T, eb(T.current, e);
        var E = e.nodeType === Gn ? e.parentNode : e;
        return eS(E), bu(), T;
      } else {
        for (var b; b = e.lastChild; )
          e.removeChild(b);
        if (typeof l == "function") {
          var x = l;
          l = function() {
            var N = dC(M);
            x.call(N);
          };
        }
        var M = sA(
          e,
          Fc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          LA
        );
        e._reactRootContainer = M, eb(M.current, e);
        var z = e.nodeType === Gn ? e.parentNode : e;
        return eS(z), bu(function() {
          GS(t, M, a, l);
        }), M;
      }
    }
    function dj(e, t) {
      e !== null && typeof e != "function" && y("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function pC(e, t, a, l, c) {
      MA(a), dj(c === void 0 ? null : c, "render");
      var m = a._reactRootContainer, T;
      if (!m)
        T = cj(a, t, e, c, l);
      else {
        if (T = m, typeof c == "function") {
          var E = c;
          c = function() {
            var b = dC(T);
            E.call(b);
          };
        }
        GS(t, T, e, c);
      }
      return dC(T);
    }
    var $A = !1;
    function fj(e) {
      {
        $A || ($A = !0, y("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var t = uj.current;
        if (t !== null && t.stateNode !== null) {
          var a = t.stateNode._warnedAboutRefsInRender;
          a || y("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Zt(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === Cr ? e : Kq(e, "findDOMNode");
    }
    function hj(e, t, a) {
      if (y("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !WS(t))
        throw new Error("Target container is not a DOM element.");
      {
        var l = dS(t) && t._reactRootContainer === void 0;
        l && y("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return pC(null, e, t, !0, a);
    }
    function pj(e, t, a) {
      if (y("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !WS(t))
        throw new Error("Target container is not a DOM element.");
      {
        var l = dS(t) && t._reactRootContainer === void 0;
        l && y("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return pC(null, e, t, !1, a);
    }
    function mj(e, t, a, l) {
      if (y("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !WS(a))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !ok(e))
        throw new Error("parentComponent must be a valid React Component");
      return pC(e, t, a, !1, l);
    }
    var OA = !1;
    function vj(e) {
      if (OA || (OA = !0, y("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !WS(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = dS(e) && e._reactRootContainer === void 0;
        t && y("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var a = fR(e), l = a && !Uc(a);
          l && y("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return bu(function() {
          pC(null, null, e, !1, function() {
            e._reactRootContainer = null, RL(e);
          });
        }), !0;
      } else {
        {
          var c = fR(e), m = !!(c && Uc(c)), T = e.nodeType === Cr && WS(e.parentNode) && !!e.parentNode._reactRootContainer;
          m && y("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", T ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Bi(Xq), Dc(Zq), TE(Jq), Pf(wa), Ug(yE), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && y("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), $p(gH), lk(q1, oq, bu);
    function yj(e, t) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!hC(t))
        throw new Error("Target container is not a DOM element.");
      return Wq(e, t, null, a);
    }
    function gj(e, t, a, l) {
      return mj(e, t, a, l);
    }
    var hR = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Uc, Pm, tb, yc, Op, q1]
    };
    function Sj(e, t) {
      return hR.usingClientEntryPoint || y('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), sj(e, t);
    }
    function Tj(e, t, a) {
      return hR.usingClientEntryPoint || y('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), oj(e, t, a);
    }
    function wj(e) {
      return FO() && y("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), bu(e);
    }
    var Ej = aj({
      findFiberByHostInstance: Gf,
      bundleType: 1,
      version: sR,
      rendererPackageName: "react-dom"
    });
    if (!Ej && Nn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var AA = window.location.protocol;
      /^(https?|file):$/.test(AA) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (AA === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Ma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = hR, Ma.createPortal = yj, Ma.createRoot = Sj, Ma.findDOMNode = fj, Ma.flushSync = wj, Ma.hydrate = hj, Ma.hydrateRoot = Tj, Ma.render = pj, Ma.unmountComponentAtNode = vj, Ma.unstable_batchedUpdates = q1, Ma.unstable_renderSubtreeIntoContainer = gj, Ma.version = sR, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ma;
}
var pP;
function aQ() {
  if (pP) return SC.exports;
  pP = 1;
  function f() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(f);
      } catch (s) {
        console.error(s);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (f(), SC.exports = iQ()) : SC.exports = rQ(), SC.exports;
}
var jQ = aQ();
const mP = KM.state.record, cV = Object.keys(mP).reduce(
  (f, s) => ({
    ...f,
    [s]() {
      return mP[s];
    }
  }),
  {}
);
function BQ(f, s) {
  var o;
  const n = hw(xy);
  return Dn((((o = s == null ? void 0 : s.current) == null ? void 0 : o.$state) || n || cV)[f]);
}
function QQ(f) {
  const s = hw(xy);
  return v6(f != null && f.current ? f.current.$state : s || cV);
}
const sQ = cs(o6), lQ = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(sQ, { ...s, ref: n, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, children: f }) })
);
lQ.displayName = "Captions";
const oQ = cs(u6), uQ = ue.forwardRef(({ children: f, ...s }, n) => /* @__PURE__ */ lt(oQ, { ...s, children: (o, h) => /* @__PURE__ */ lt(
  dV,
  {
    ...o,
    instance: h,
    ref: Hd(o.ref, n),
    children: f
  }
) }));
uQ.displayName = "Time";
const dV = ue.forwardRef(
  ({ instance: f, children: s, ...n }, o) => {
    const { timeText: h } = f.$state, v = Dn(h);
    return /* @__PURE__ */ hy(Ji.div, { ...n, ref: o, children: [
      v,
      s
    ] });
  }
);
dV.displayName = "TimeText";
const YQ = ue.forwardRef(
  ({ size: f = 96, children: s, ...n }, o) => /* @__PURE__ */ lt(
    "svg",
    {
      width: f,
      height: f,
      fill: "none",
      viewBox: "0 0 120 120",
      "aria-hidden": "true",
      "data-part": "root",
      ...n,
      ref: o,
      children: s
    }
  )
), GQ = ue.forwardRef(
  ({ width: f = 8, children: s, ...n }, o) => /* @__PURE__ */ lt(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      strokeWidth: f,
      "data-part": "track",
      ...n,
      ref: o,
      children: s
    }
  )
), WQ = ue.forwardRef(
  ({ width: f = 8, fillPercent: s = 50, children: n, ...o }, h) => /* @__PURE__ */ lt(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      pathLength: "100",
      strokeWidth: f,
      strokeDasharray: 100,
      strokeDashoffset: 100 - s,
      "data-part": "track-fill",
      ...o,
      ref: h,
      children: n
    }
  )
);
function KQ() {
  const f = lp();
  return (f == null ? void 0 : f.player) || null;
}
function XQ(f) {
  const s = lp(), n = ue.useRef(null);
  return n.current || (n.current = new i_()), ue.useEffect(() => {
    const o = f, h = o instanceof KM, v = h ? o : s == null ? void 0 : s.player;
    n.current.setPlayer(v ?? null), n.current.setTarget(null);
  }, [s, f]), n.current;
}
function ZQ({ off: f = !0 } = {}) {
  const s = lp(), { textTracks: n, textTrack: o } = s.$state, h = Dn(n);
  return Dn(o), ue.useMemo(() => {
    const v = h.filter(_a), y = v.map((C) => ({
      track: C,
      label: C.label,
      value: vP(C),
      get selected() {
        return o() === C;
      },
      select(D) {
        const $ = n().indexOf(C);
        $ >= 0 && s.remote.changeTextTrackMode($, "showing", D);
      }
    }));
    return f && y.unshift({
      track: null,
      label: Ze(f) ? f : "Off",
      value: "off",
      get selected() {
        return !o();
      },
      select(C) {
        s.remote.toggleCaptions(C);
      }
    }), Object.defineProperty(y, "disabled", {
      get() {
        return !v.length;
      }
    }), Object.defineProperty(y, "selectedTrack", {
      get() {
        return o();
      }
    }), Object.defineProperty(y, "selectedValue", {
      get() {
        const C = o();
        return C ? vP(C) : "off";
      }
    }), y;
  }, [h]);
}
function vP(f) {
  return f.id + ":" + f.kind + "-" + f.label.toLowerCase();
}
function JQ({
  auto: f = !0,
  sort: s = "descending"
} = {}) {
  const n = lp(), { qualities: o, quality: h, autoQuality: v, canSetQuality: y } = n.$state, C = Dn(o);
  return Dn(h), Dn(v), Dn(y), ue.useMemo(() => {
    const D = u5(C, s === "descending"), $ = D.map((_) => ({
      quality: _,
      label: _.height + "p",
      value: yP(_),
      bitrateText: _.bitrate && _.bitrate > 0 ? `${(_.bitrate / 1e6).toFixed(2)} Mbps` : null,
      get selected() {
        return _ === h();
      },
      get autoSelected() {
        return v();
      },
      select(A) {
        const B = o().indexOf(_);
        B >= 0 && n.remote.changeQuality(B, A);
      }
    }));
    return f && $.unshift({
      quality: null,
      label: Ze(f) ? f : "Auto",
      value: "auto",
      bitrateText: null,
      get selected() {
        return v();
      },
      get autoSelected() {
        return v();
      },
      select(_) {
        n.remote.requestAutoQuality(_);
      }
    }), Object.defineProperty($, "disabled", {
      get() {
        return !y() || C.length <= 1;
      }
    }), Object.defineProperty($, "selectedQuality", {
      get() {
        return h();
      }
    }), Object.defineProperty($, "selectedValue", {
      get() {
        const _ = h();
        return !v() && _ ? yP(_) : "auto";
      }
    }), $;
  }, [C, s]);
}
function yP(f) {
  return f.height + "_" + f.bitrate;
}
function e7({
  rates: f = PF,
  normalLabel: s = "Normal"
} = {}) {
  const n = lp(), { playbackRate: o, canSetPlaybackRate: h } = n.$state;
  return Dn(o), Dn(h), ue.useMemo(() => {
    const v = f.map((y) => {
      const C = typeof y == "number" ? y === 1 && s ? s : y + "x" : y.label, D = typeof y == "number" ? y : y.rate;
      return {
        label: C,
        value: D.toString(),
        rate: D,
        get selected() {
          return o() === D;
        },
        select($) {
          n.remote.changePlaybackRate(D, $);
        }
      };
    });
    return Object.defineProperty(v, "disabled", {
      get() {
        return !h() || !v.length;
      }
    }), Object.defineProperty(v, "selectedValue", {
      get() {
        return o().toString();
      }
    }), v;
  }, [f]);
}
const cQ = (f) => M0(f);
var Xh, fn, At, dy, fy, Dt, ph, fV, hV, pV, mV, vV, yV, gV, SV, TV, wV, EV, bV, CV, kV;
class t7 {
  constructor(s, n) {
    R(this, Dt);
    R(this, Xh);
    R(this, fn);
    R(this, At, null);
    R(this, dy, null);
    Z(this, "config", {});
    R(this, fy, /* @__PURE__ */ new Set());
    L(this, Xh, s), L(this, fn, n);
  }
  get instance() {
    return d(this, At);
  }
  setup(s) {
    const { streamType: n } = d(this, fn).$state, o = ye(n).includes("live"), h = ye(n).includes("ll-");
    L(this, At, new s({
      lowLatencyMode: h,
      backBufferLength: h ? 4 : o ? 8 : void 0,
      renderTextTracksNatively: !1,
      ...this.config
    }));
    const v = S(this, Dt, pV).bind(this);
    for (const y of Object.values(s.Events)) d(this, At).on(y, v);
    d(this, At).on(s.Events.ERROR, S(this, Dt, wV).bind(this));
    for (const y of d(this, fy)) y(d(this, At));
    d(this, fn).player.dispatch("hls-instance", {
      detail: d(this, At)
    }), d(this, At).attachMedia(d(this, Xh)), d(this, At).on(s.Events.AUDIO_TRACK_SWITCHED, S(this, Dt, yV).bind(this)), d(this, At).on(s.Events.LEVEL_SWITCHED, S(this, Dt, gV).bind(this)), d(this, At).on(s.Events.LEVEL_LOADED, S(this, Dt, TV).bind(this)), d(this, At).on(s.Events.LEVEL_UPDATED, S(this, Dt, SV).bind(this)), d(this, At).on(s.Events.NON_NATIVE_TEXT_TRACKS_FOUND, S(this, Dt, mV).bind(this)), d(this, At).on(s.Events.CUES_PARSED, S(this, Dt, vV).bind(this)), d(this, fn).qualities[la.enableAuto] = S(this, Dt, bV).bind(this), En(d(this, fn).qualities, "change", S(this, Dt, CV).bind(this)), En(d(this, fn).audioTracks, "change", S(this, Dt, kV).bind(this)), L(this, dy, J(S(this, Dt, fV).bind(this)));
  }
  onInstance(s) {
    return d(this, fy).add(s), () => d(this, fy).delete(s);
  }
  loadSource(s) {
    var n;
    Ze(s.src) && ((n = d(this, At)) == null || n.loadSource(s.src));
  }
  destroy() {
    var s, n;
    (s = d(this, At)) == null || s.destroy(), L(this, At, null), (n = d(this, dy)) == null || n.call(this), L(this, dy, null);
  }
}
Xh = new WeakMap(), fn = new WeakMap(), At = new WeakMap(), dy = new WeakMap(), fy = new WeakMap(), Dt = new WeakSet(), ph = function(s, n) {
  return new yt(cQ(s), { detail: n });
}, fV = function() {
  if (!d(this, fn).$state.live()) return;
  const s = new jM(S(this, Dt, hV).bind(this));
  return s.start(), s.stop.bind(s);
}, hV = function() {
  var s;
  d(this, fn).$state.liveSyncPosition.set(((s = d(this, At)) == null ? void 0 : s.liveSyncPosition) ?? 1 / 0);
}, pV = function(s, n) {
  var o;
  (o = d(this, fn).player) == null || o.dispatch(S(this, Dt, ph).call(this, s, n));
}, mV = function(s, n) {
  const o = S(this, Dt, ph).call(this, s, n);
  let h = -1;
  for (let v = 0; v < n.tracks.length; v++) {
    const y = n.tracks[v], C = y.subtitleTrack ?? y.closedCaptions, D = new Ud({
      id: `hls-${y.kind}-${v}`,
      src: C == null ? void 0 : C.url,
      label: y.label,
      language: C == null ? void 0 : C.lang,
      kind: y.kind,
      default: y.default
    });
    D[tt.readyState] = 2, D[tt.onModeChange] = () => {
      D.mode === "showing" ? (d(this, At).subtitleTrack = v, h = v) : h === v && (d(this, At).subtitleTrack = -1, h = -1);
    }, d(this, fn).textTracks.add(D, o);
  }
}, vV = function(s, n) {
  var y;
  const o = (y = d(this, At)) == null ? void 0 : y.subtitleTrack, h = d(this, fn).textTracks.getById(`hls-${n.type}-${o}`);
  if (!h) return;
  const v = S(this, Dt, ph).call(this, s, n);
  for (const C of n.cues)
    C.positionAlign = "auto", h.addCue(C, v);
}, yV = function(s, n) {
  const o = d(this, fn).audioTracks[n.id];
  if (o) {
    const h = S(this, Dt, ph).call(this, s, n);
    d(this, fn).audioTracks[at.select](o, !0, h);
  }
}, gV = function(s, n) {
  const o = d(this, fn).qualities[n.level];
  if (o) {
    const h = S(this, Dt, ph).call(this, s, n);
    d(this, fn).qualities[at.select](o, !0, h);
  }
}, SV = function(s, n) {
  n.details.totalduration > 0 && d(this, fn).$state.inferredLiveDVRWindow.set(n.details.totalduration);
}, TV = function(s, n) {
  var $;
  if (d(this, fn).$state.canPlay()) return;
  const { type: o, live: h, totalduration: v, targetduration: y } = n.details, C = S(this, Dt, ph).call(this, s, n);
  d(this, fn).notify(
    "stream-type-change",
    h ? o === "EVENT" && Number.isFinite(v) && y >= 10 ? "live:dvr" : "live" : "on-demand",
    C
  ), d(this, fn).notify("duration-change", v, C);
  const D = d(this, At).media;
  d(this, At).currentLevel === -1 && d(this, fn).qualities[la.setAuto](!0, C);
  for (const _ of d(this, At).audioTracks) {
    const A = {
      id: _.id.toString(),
      label: _.name,
      language: _.lang || "",
      kind: "main"
    };
    d(this, fn).audioTracks[at.add](A, C);
  }
  for (const _ of d(this, At).levels) {
    const A = {
      id: (($ = _.id) == null ? void 0 : $.toString()) ?? _.height + "p",
      width: _.width,
      height: _.height,
      codec: _.codecSet,
      bitrate: _.bitrate
    };
    d(this, fn).qualities[at.add](A, C);
  }
  D.dispatchEvent(new yt("canplay", { trigger: C }));
}, wV = function(s, n) {
  var o;
  if (n.fatal)
    switch (n.type) {
      case "mediaError":
        (o = d(this, At)) == null || o.recoverMediaError();
        break;
      default:
        S(this, Dt, EV).call(this, n.error);
        break;
    }
}, EV = function(s) {
  d(this, fn).notify("error", {
    message: s.message,
    code: 1,
    error: s
  });
}, bV = function() {
  d(this, At) && (d(this, At).currentLevel = -1);
}, CV = function() {
  const { qualities: s } = d(this, fn);
  !d(this, At) || s.auto || (d(this, At)[s.switch + "Level"] = s.selectedIndex, O0 && (d(this, Xh).currentTime = d(this, Xh).currentTime));
}, kV = function() {
  const { audioTracks: s } = d(this, fn);
  d(this, At) && d(this, At).audioTrack !== s.selectedIndex && (d(this, At).audioTrack = s.selectedIndex);
};
var Zh, yo, aw, Mo, xV, RV, DV, MV;
class n7 {
  constructor(s, n, o) {
    R(this, Mo);
    R(this, Zh);
    R(this, yo);
    R(this, aw);
    L(this, Zh, s), L(this, yo, n), L(this, aw, o), S(this, Mo, xV).call(this);
  }
}
Zh = new WeakMap(), yo = new WeakMap(), aw = new WeakMap(), Mo = new WeakSet(), xV = async function() {
  const s = {
    onLoadStart: S(this, Mo, RV).bind(this),
    onLoaded: S(this, Mo, DV).bind(this),
    onLoadError: S(this, Mo, MV).bind(this)
  };
  let n = await fQ(d(this, Zh), s);
  if (mi(n) && !Ze(d(this, Zh)) && (n = await dQ(d(this, Zh), s)), !n) return null;
  if (!n.isSupported()) {
    const o = "[vidstack] `hls.js` is not supported in this environment";
    return d(this, yo).player.dispatch(new yt("hls-unsupported")), d(this, yo).notify("error", { message: o, code: 4 }), null;
  }
  return n;
}, RV = function() {
  d(this, yo).player.dispatch(new yt("hls-lib-load-start"));
}, DV = function(s) {
  d(this, yo).player.dispatch(
    new yt("hls-lib-loaded", {
      detail: s
    })
  ), d(this, aw).call(this, s);
}, MV = function(s) {
  const n = lT(s);
  d(this, yo).player.dispatch(
    new yt("hls-lib-load-error", {
      detail: n
    })
  ), d(this, yo).notify("error", {
    message: n.message,
    code: 4,
    error: n
  });
};
async function dQ(f, s = {}) {
  var n, o, h, v, y;
  if (!mi(f)) {
    if ((n = s.onLoadStart) == null || n.call(s), f.prototype && f.prototype !== Function)
      return (o = s.onLoaded) == null || o.call(s, f), f;
    try {
      const C = (h = await f()) == null ? void 0 : h.default;
      if (C && C.isSupported)
        (v = s.onLoaded) == null || v.call(s, C);
      else
        throw Error(
          ""
        );
      return C;
    } catch (C) {
      (y = s.onLoadError) == null || y.call(s, C);
    }
  }
}
async function fQ(f, s = {}) {
  var n, o, h;
  if (Ze(f)) {
    (n = s.onLoadStart) == null || n.call(s);
    try {
      if (await zM(f), !ls(window.Hls))
        throw Error(
          ""
        );
      const v = window.Hls;
      return (o = s.onLoaded) == null || o.call(s, v), v;
    } catch (v) {
      (h = s.onLoadError) == null || h.call(s, v);
    }
  }
}
var go, Ty, LV, $V;
class i7 {
  constructor(s) {
    R(this, Ty);
    R(this, go);
    Z(this, "src", st(""));
    /**
     * Defines which referrer is sent when fetching the resource.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy}
     */
    Z(this, "referrerPolicy", null);
    L(this, go, s), s.setAttribute("frameBorder", "0"), s.setAttribute("aria-hidden", "true"), s.setAttribute(
      "allow",
      "autoplay; fullscreen; encrypted-media; picture-in-picture; accelerometer; gyroscope"
    ), this.referrerPolicy !== null && s.setAttribute("referrerpolicy", this.referrerPolicy);
  }
  get iframe() {
    return d(this, go);
  }
  setup() {
    En(window, "message", S(this, Ty, $V).bind(this)), En(d(this, go), "load", this.onLoad.bind(this)), J(S(this, Ty, LV).bind(this));
  }
  postMessage(s, n) {
    var o;
    (o = d(this, go).contentWindow) == null || o.postMessage(JSON.stringify(s), n ?? "*");
  }
}
go = new WeakMap(), Ty = new WeakSet(), LV = function() {
  const s = this.src();
  if (!s.length) {
    d(this, go).setAttribute("src", "");
    return;
  }
  const n = ye(() => this.buildParams());
  d(this, go).setAttribute("src", DB(s, n));
}, $V = function(s) {
  var h;
  const n = this.getOrigin();
  if ((s.source === null || s.source === ((h = d(this, go)) == null ? void 0 : h.contentWindow)) && (!Ze(n) || n === s.origin)) {
    try {
      const v = JSON.parse(s.data);
      v && this.onMessage(v, s);
      return;
    } catch {
    }
    s.data && this.onMessage(s.data, s);
  }
};
const r7 = [
  "bufferend",
  "bufferstart",
  // 'cuechange',
  "durationchange",
  "ended",
  "enterpictureinpicture",
  "error",
  "fullscreenchange",
  "leavepictureinpicture",
  "loaded",
  // 'loadeddata',
  // 'loadedmetadata',
  // 'loadstart',
  "playProgress",
  "loadProgress",
  "pause",
  "play",
  "playbackratechange",
  // 'progress',
  "qualitychange",
  "seeked",
  "seeking",
  // 'texttrackchange',
  "timeupdate",
  "volumechange",
  "waiting"
  // 'adstarted',
  // 'adcompleted',
  // 'aderror',
  // 'adskipped',
  // 'adallcompleted',
  // 'adclicked',
  // 'chapterchange',
  // 'chromecastconnected',
  // 'remoteplaybackavailabilitychange',
  // 'remoteplaybackconnecting',
  // 'remoteplaybackconnect',
  // 'remoteplaybackdisconnect',
  // 'liveeventended',
  // 'liveeventstarted',
  // 'livestreamoffline',
  // 'livestreamonline',
], a7 = {
  Unstarted: -1,
  Ended: 0,
  Playing: 1,
  Paused: 2,
  Buffering: 3,
  Cued: 5
};
var Od, Hr, OV, AV, PV, jC, BC;
class hQ {
  constructor() {
    R(this, Hr);
    Z(this, "name", "google-cast");
    Z(this, "target");
    R(this, Od);
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return Dj();
  }
  mediaType() {
    return "video";
  }
  canPlay(s) {
    return O0 && !$0 && XP(s);
  }
  async prompt(s) {
    var v;
    let n, o, h;
    try {
      n = await S(this, Hr, OV).call(this, s), d(this, Od) || (L(this, Od, new cast.framework.RemotePlayer()), new cast.framework.RemotePlayerController(d(this, Od))), o = s.player.createEvent("google-cast-prompt-open", {
        trigger: n
      }), s.player.dispatchEvent(o), S(this, Hr, jC).call(this, s, "connecting", o), await S(this, Hr, AV).call(this, ye(s.$props.googleCast)), s.$state.remotePlaybackInfo.set({
        deviceName: (v = Mj()) == null ? void 0 : v.getCastDevice().friendlyName
      }), _A() && S(this, Hr, jC).call(this, s, "connected", o);
    } catch (y) {
      const C = y instanceof Error ? y : S(this, Hr, BC).call(this, (y + "").toUpperCase(), "Prompt failed.");
      throw h = s.player.createEvent("google-cast-prompt-error", {
        detail: C,
        trigger: o ?? n,
        cancelable: !0
      }), s.player.dispatch(h), S(this, Hr, jC).call(this, s, _A() ? "connected" : "disconnected", h), C;
    } finally {
      s.player.dispatch("google-cast-prompt-close", {
        trigger: h ?? o ?? n
      });
    }
  }
  async load(s) {
    if (!d(this, Od))
      throw Error("[vidstack] google cast player was not initialized");
    return new (await import("./vidstack-google-cast-BL3V-630.js").then((n) => n.p)).GoogleCastProvider(d(this, Od), s);
  }
}
Od = new WeakMap(), Hr = new WeakSet(), OV = async function(s) {
  if (Lj()) return;
  const n = s.player.createEvent("google-cast-load-start");
  s.player.dispatch(n), await zM(Pj()), await customElements.whenDefined("google-cast-launcher");
  const o = s.player.createEvent("google-cast-loaded", { trigger: n });
  if (s.player.dispatch(o), !$j())
    throw S(this, Hr, BC).call(this, "CAST_NOT_AVAILABLE", "Google Cast not available on this platform.");
  return o;
}, AV = async function(s) {
  S(this, Hr, PV).call(this, s);
  const n = await this.cast.requestSession();
  if (n)
    throw S(this, Hr, BC).call(this, n.toUpperCase(), Oj(n));
}, PV = function(s) {
  var n;
  (n = this.cast) == null || n.setOptions({
    ...Aj(),
    ...s
  });
}, jC = function(s, n, o) {
  const h = { type: "google-cast", state: n };
  s.notify("remote-playback-change", h, o);
}, BC = function(s, n) {
  const o = Error(n);
  return o.code = s, o;
};
const pQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleCastLoader: hQ
}, Symbol.toStringTag, { value: "Module" }));
var El, k0, _V;
class s7 {
  constructor(s) {
    R(this, k0);
    R(this, El);
    L(this, El, new chrome.cast.media.MediaInfo(s.src, s.type));
  }
  build() {
    return d(this, El);
  }
  setStreamType(s) {
    return s.includes("live") ? d(this, El).streamType = chrome.cast.media.StreamType.LIVE : d(this, El).streamType = chrome.cast.media.StreamType.BUFFERED, this;
  }
  setTracks(s) {
    return d(this, El).tracks = s.map(S(this, k0, _V)), this;
  }
  setMetadata(s, n) {
    return d(this, El).metadata = new chrome.cast.media.GenericMediaMetadata(), d(this, El).metadata.title = s, d(this, El).metadata.images = [{ url: n }], this;
  }
}
El = new WeakMap(), k0 = new WeakSet(), _V = function(s, n) {
  const o = new chrome.cast.media.Track(n, chrome.cast.media.TrackType.TEXT);
  return o.name = s.label, o.trackContentId = s.src, o.trackContentType = "text/vtt", o.language = s.language, o.subtype = s.kind.toUpperCase(), o;
};
var Ad, So, sw, yn, EM, ov, NV, UV, zV, bM, QC, CM;
class l7 {
  constructor(s, n, o) {
    R(this, yn);
    R(this, Ad);
    R(this, So);
    R(this, sw);
    L(this, Ad, s), L(this, So, n), L(this, sw, o);
  }
  setup() {
    const s = this.syncRemoteActiveIds.bind(this);
    En(d(this, So).audioTracks, "change", s), En(d(this, So).textTracks, "mode-change", s), J(S(this, yn, UV).bind(this));
  }
  getLocalTextTracks() {
    return d(this, So).$state.textTracks().filter((s) => s.src && s.type === "vtt");
  }
  syncRemoteTracks(s) {
    if (!d(this, Ad).isMediaLoaded) return;
    const n = S(this, yn, EM).call(this), o = this.getLocalTextTracks(), h = S(this, yn, ov).call(this, chrome.cast.media.TrackType.AUDIO), v = S(this, yn, ov).call(this, chrome.cast.media.TrackType.TEXT);
    for (const y of h) {
      if (S(this, yn, bM).call(this, n, y)) continue;
      const D = {
        id: y.trackId.toString(),
        label: y.name,
        language: y.language,
        kind: y.subtype ?? "main",
        selected: !1
      };
      d(this, So).audioTracks[at.add](D, s);
    }
    for (const y of v) {
      if (S(this, yn, bM).call(this, o, y)) continue;
      const D = {
        id: y.trackId.toString(),
        src: y.trackContentId,
        label: y.name,
        language: y.language,
        kind: y.subtype.toLowerCase()
      };
      d(this, So).textTracks.add(D, s);
    }
  }
  syncRemoteActiveIds(s) {
    if (!d(this, Ad).isMediaLoaded) return;
    const n = S(this, yn, NV).call(this), o = new chrome.cast.media.EditTracksInfoRequest(n);
    S(this, yn, zV).call(this, o).catch((h) => {
    });
  }
}
Ad = new WeakMap(), So = new WeakMap(), sw = new WeakMap(), yn = new WeakSet(), EM = function() {
  return d(this, So).$state.audioTracks();
}, ov = function(s) {
  var o;
  const n = ((o = d(this, Ad).mediaInfo) == null ? void 0 : o.tracks) ?? [];
  return s ? n.filter((h) => h.type === s) : n;
}, NV = function() {
  const s = [], n = S(this, yn, EM).call(this).find((h) => h.selected), o = this.getLocalTextTracks().filter((h) => h.mode === "showing");
  if (n) {
    const h = S(this, yn, ov).call(this, chrome.cast.media.TrackType.AUDIO), v = S(this, yn, QC).call(this, h, n);
    v && s.push(v.trackId);
  }
  if (o != null && o.length) {
    const h = S(this, yn, ov).call(this, chrome.cast.media.TrackType.TEXT);
    if (h.length)
      for (const v of o) {
        const y = S(this, yn, QC).call(this, h, v);
        y && s.push(y.trackId);
      }
  }
  return s;
}, UV = function() {
  const s = this.getLocalTextTracks();
  if (!d(this, Ad).isMediaLoaded) return;
  const n = S(this, yn, ov).call(this, chrome.cast.media.TrackType.TEXT);
  for (const o of s)
    if (!S(this, yn, QC).call(this, n, o)) {
      py(() => {
        var v;
        return (v = d(this, sw)) == null ? void 0 : v.call(this);
      });
      break;
    }
}, zV = function(s) {
  const n = _j();
  return new Promise((o, h) => n == null ? void 0 : n.editTracksInfo(s, o, h));
}, bM = function(s, n) {
  return s.find((o) => S(this, yn, CM).call(this, o, n));
}, QC = function(s, n) {
  return s.find((o) => S(this, yn, CM).call(this, n, o));
}, // Note: we can't rely on id matching because they will differ between local/remote. A local
// track id might not even exist.
CM = function(s, n) {
  return n.name === s.label && n.language === s.language && n.subtype.toLowerCase() === s.kind.toLowerCase();
};
export {
  _a as $,
  LQ as A,
  Vr as B,
  r7 as C,
  FQ as D,
  i7 as E,
  UQ as F,
  l7 as G,
  AQ as H,
  Ud as I,
  mi as J,
  Bj as K,
  at as L,
  ss as M,
  OQ as N,
  EQ as O,
  zQ as P,
  la as Q,
  jM as R,
  KQ as S,
  bC as T,
  YQ as U,
  NQ as V,
  GQ as W,
  WQ as X,
  a7 as Y,
  BQ as Z,
  XQ as _,
  Ze as a,
  D6 as a0,
  lQ as a1,
  ZQ as a2,
  JQ as a3,
  e7 as a4,
  BM as a5,
  jQ as a6,
  L6 as a7,
  uQ as a8,
  Q6 as a9,
  N6 as aa,
  K6 as ab,
  U6 as ac,
  _6 as ad,
  V6 as ae,
  q6 as af,
  kQ as ag,
  xQ as ah,
  DQ as ai,
  MQ as aj,
  RQ as ak,
  b6 as al,
  x6 as am,
  QQ as an,
  VQ as b,
  ye as c,
  WC as d,
  yt as e,
  s7 as f,
  t7 as g,
  NM as h,
  yB as i,
  n7 as j,
  bQ as k,
  En as l,
  $Q as m,
  ht as n,
  Wt as o,
  A0 as p,
  CQ as q,
  hB as r,
  bl as s,
  fB as t,
  _Q as u,
  dB as v,
  PQ as w,
  st as x,
  J as y,
  MR as z
};
